import "./style.css";
import { effectScope, ref, markRaw, toRaw, getCurrentInstance, inject, watch, unref, reactive, isRef, isReactive, toRef, nextTick as nextTick$1, computed, getCurrentScope, onScopeDispose, toRefs, defineComponent, h as h$1, shallowRef, withDirectives, onMounted, Teleport, openBlock, createElementBlock, createElementVNode, toDisplayString as toDisplayString$1, createBlock, withCtx, createTextVNode, createCommentVNode, Fragment, createVNode, withKeys, renderList, onUpdated, onBeforeMount, onUnmounted, Text } from "vue";
import "vue-router";
var isVue2 = !1;
function set$2(t, e, r) {
  return Array.isArray(t) ? (t.length = Math.max(t.length, e), t.splice(e, 1, r), r) : (t[e] = r, r);
}
function del(t, e) {
  if (Array.isArray(t)) {
    t.splice(e, 1);
    return;
  }
  delete t[e];
}
function getDevtoolsGlobalHook() {
  return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const isProxyAvailable = typeof Proxy == "function", HOOK_SETUP = "devtools-plugin:setup", HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported, perf;
function isPerformanceSupported() {
  var t;
  return supported !== void 0 || (typeof window < "u" && window.performance ? (supported = !0, perf = window.performance) : typeof global < "u" && (!((t = global.perf_hooks) === null || t === void 0) && t.performance) ? (supported = !0, perf = global.perf_hooks.performance) : supported = !1), supported;
}
function now$3() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
class ApiProxy {
  constructor(e, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = r;
    const o = {};
    if (e.settings)
      for (const u in e.settings) {
        const d = e.settings[u];
        o[u] = d.defaultValue;
      }
    const a = `__vue-devtools-plugin-settings__${e.id}`;
    let c = Object.assign({}, o);
    try {
      const u = localStorage.getItem(a), d = JSON.parse(u);
      Object.assign(c, d);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return c;
      },
      setSettings(u) {
        try {
          localStorage.setItem(a, JSON.stringify(u));
        } catch {
        }
        c = u;
      },
      now() {
        return now$3();
      }
    }, r && r.on(HOOK_PLUGIN_SETTINGS_SET, (u, d) => {
      u === this.plugin.id && this.fallbacks.setSettings(d);
    }), this.proxiedOn = new Proxy({}, {
      get: (u, d) => this.target ? this.target.on[d] : (...p) => {
        this.onQueue.push({
          method: d,
          args: p
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (u, d) => this.target ? this.target[d] : d === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(d) ? (...p) => (this.targetQueue.push({
        method: d,
        args: p,
        resolve: () => {
        }
      }), this.fallbacks[d](...p)) : (...p) => new Promise((g) => {
        this.targetQueue.push({
          method: d,
          args: p,
          resolve: g
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function setupDevtoolsPlugin(t, e) {
  const r = t, o = getTarget(), a = getDevtoolsGlobalHook(), c = isProxyAvailable && r.enableEarlyProxy;
  if (a && (o.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !c))
    a.emit(HOOK_SETUP, t, e);
  else {
    const u = c ? new ApiProxy(r, a) : null;
    (o.__VUE_DEVTOOLS_PLUGINS__ = o.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: e,
      proxy: u
    }), u && e(u.proxiedTarget);
  }
}
/*!
  * pinia v2.0.36
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
let activePinia;
const setActivePinia = (t) => activePinia = t, piniaSymbol = process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
function isPlainObject$2(t) {
  return t && typeof t == "object" && Object.prototype.toString.call(t) === "[object Object]" && typeof t.toJSON != "function";
}
var MutationType;
(function(t) {
  t.direct = "direct", t.patchObject = "patch object", t.patchFunction = "patch function";
})(MutationType || (MutationType = {}));
const IS_CLIENT = typeof window < "u", USE_DEVTOOLS = (process.env.NODE_ENV !== "production" || !1) && process.env.NODE_ENV !== "test" && IS_CLIENT, _global = /* @__PURE__ */ (() => typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof global == "object" && global.global === global ? global : typeof globalThis == "object" ? globalThis : { HTMLElement: null })();
function bom(t, { autoBom: e = !1 } = {}) {
  return e && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([String.fromCharCode(65279), t], { type: t.type }) : t;
}
function download(t, e, r) {
  const o = new XMLHttpRequest();
  o.open("GET", t), o.responseType = "blob", o.onload = function() {
    saveAs(o.response, e, r);
  }, o.onerror = function() {
    console.error("could not download file");
  }, o.send();
}
function corsEnabled(t) {
  const e = new XMLHttpRequest();
  e.open("HEAD", t, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function click(t) {
  try {
    t.dispatchEvent(new MouseEvent("click"));
  } catch {
    const r = document.createEvent("MouseEvents");
    r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(r);
  }
}
const _navigator = typeof navigator == "object" ? navigator : { userAgent: "" }, isMacOSWebView = /* @__PURE__ */ (() => /Macintosh/.test(_navigator.userAgent) && /AppleWebKit/.test(_navigator.userAgent) && !/Safari/.test(_navigator.userAgent))(), saveAs = IS_CLIENT ? (
  // Use download attribute first if possible (#193 Lumia mobile) unless this is a macOS WebView or mini program
  typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype && !isMacOSWebView ? downloadSaveAs : (
    // Use msSaveOrOpenBlob as a second approach
    "msSaveOrOpenBlob" in _navigator ? msSaveAs : (
      // Fallback to using FileReader and a popup
      fileSaverSaveAs
    )
  )
) : () => {
};
function downloadSaveAs(t, e = "download", r) {
  const o = document.createElement("a");
  o.download = e, o.rel = "noopener", typeof t == "string" ? (o.href = t, o.origin !== location.origin ? corsEnabled(o.href) ? download(t, e, r) : (o.target = "_blank", click(o)) : click(o)) : (o.href = URL.createObjectURL(t), setTimeout(function() {
    URL.revokeObjectURL(o.href);
  }, 4e4), setTimeout(function() {
    click(o);
  }, 0));
}
function msSaveAs(t, e = "download", r) {
  if (typeof t == "string")
    if (corsEnabled(t))
      download(t, e, r);
    else {
      const o = document.createElement("a");
      o.href = t, o.target = "_blank", setTimeout(function() {
        click(o);
      });
    }
  else
    navigator.msSaveOrOpenBlob(bom(t, r), e);
}
function fileSaverSaveAs(t, e, r, o) {
  if (o = o || open("", "_blank"), o && (o.document.title = o.document.body.innerText = "downloading..."), typeof t == "string")
    return download(t, e, r);
  const a = t.type === "application/octet-stream", c = /constructor/i.test(String(_global.HTMLElement)) || "safari" in _global, u = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((u || a && c || isMacOSWebView) && typeof FileReader < "u") {
    const d = new FileReader();
    d.onloadend = function() {
      let p = d.result;
      if (typeof p != "string")
        throw o = null, new Error("Wrong reader.result type");
      p = u ? p : p.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = p : location.assign(p), o = null;
    }, d.readAsDataURL(t);
  } else {
    const d = URL.createObjectURL(t);
    o ? o.location.assign(d) : location.href = d, o = null, setTimeout(function() {
      URL.revokeObjectURL(d);
    }, 4e4);
  }
}
function toastMessage(t, e) {
  const r = "🍍 " + t;
  typeof __VUE_DEVTOOLS_TOAST__ == "function" ? __VUE_DEVTOOLS_TOAST__(r, e) : e === "error" ? console.error(r) : e === "warn" ? console.warn(r) : console.log(r);
}
function isPinia(t) {
  return "_a" in t && "install" in t;
}
function checkClipboardAccess() {
  if (!("clipboard" in navigator))
    return toastMessage("Your browser doesn't support the Clipboard API", "error"), !0;
}
function checkNotFocusedError(t) {
  return t instanceof Error && t.message.toLowerCase().includes("document is not focused") ? (toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', "warn"), !0) : !1;
}
async function actionGlobalCopyState(t) {
  if (!checkClipboardAccess())
    try {
      await navigator.clipboard.writeText(JSON.stringify(t.state.value)), toastMessage("Global state copied to clipboard.");
    } catch (e) {
      if (checkNotFocusedError(e))
        return;
      toastMessage("Failed to serialize the state. Check the console for more details.", "error"), console.error(e);
    }
}
async function actionGlobalPasteState(t) {
  if (!checkClipboardAccess())
    try {
      t.state.value = JSON.parse(await navigator.clipboard.readText()), toastMessage("Global state pasted from clipboard.");
    } catch (e) {
      if (checkNotFocusedError(e))
        return;
      toastMessage("Failed to deserialize the state from clipboard. Check the console for more details.", "error"), console.error(e);
    }
}
async function actionGlobalSaveState(t) {
  try {
    saveAs(new Blob([JSON.stringify(t.state.value)], {
      type: "text/plain;charset=utf-8"
    }), "pinia-state.json");
  } catch (e) {
    toastMessage("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(e);
  }
}
let fileInput;
function getFileOpener() {
  fileInput || (fileInput = document.createElement("input"), fileInput.type = "file", fileInput.accept = ".json");
  function t() {
    return new Promise((e, r) => {
      fileInput.onchange = async () => {
        const o = fileInput.files;
        if (!o)
          return e(null);
        const a = o.item(0);
        return e(a ? { text: await a.text(), file: a } : null);
      }, fileInput.oncancel = () => e(null), fileInput.onerror = r, fileInput.click();
    });
  }
  return t;
}
async function actionGlobalOpenStateFile(t) {
  try {
    const r = await (await getFileOpener())();
    if (!r)
      return;
    const { text: o, file: a } = r;
    t.state.value = JSON.parse(o), toastMessage(`Global state imported from "${a.name}".`);
  } catch (e) {
    toastMessage("Failed to export the state as JSON. Check the console for more details.", "error"), console.error(e);
  }
}
function formatDisplay(t) {
  return {
    _custom: {
      display: t
    }
  };
}
const PINIA_ROOT_LABEL = "🍍 Pinia (root)", PINIA_ROOT_ID = "_root";
function formatStoreForInspectorTree(t) {
  return isPinia(t) ? {
    id: PINIA_ROOT_ID,
    label: PINIA_ROOT_LABEL
  } : {
    id: t.$id,
    label: t.$id
  };
}
function formatStoreForInspectorState(t) {
  if (isPinia(t)) {
    const r = Array.from(t._s.keys()), o = t._s;
    return {
      state: r.map((c) => ({
        editable: !0,
        key: c,
        value: t.state.value[c]
      })),
      getters: r.filter((c) => o.get(c)._getters).map((c) => {
        const u = o.get(c);
        return {
          editable: !1,
          key: c,
          value: u._getters.reduce((d, p) => (d[p] = u[p], d), {})
        };
      })
    };
  }
  const e = {
    state: Object.keys(t.$state).map((r) => ({
      editable: !0,
      key: r,
      value: t.$state[r]
    }))
  };
  return t._getters && t._getters.length && (e.getters = t._getters.map((r) => ({
    editable: !1,
    key: r,
    value: t[r]
  }))), t._customProperties.size && (e.customProperties = Array.from(t._customProperties).map((r) => ({
    editable: !0,
    key: r,
    value: t[r]
  }))), e;
}
function formatEventData(t) {
  return t ? Array.isArray(t) ? t.reduce((e, r) => (e.keys.push(r.key), e.operations.push(r.type), e.oldValue[r.key] = r.oldValue, e.newValue[r.key] = r.newValue, e), {
    oldValue: {},
    keys: [],
    operations: [],
    newValue: {}
  }) : {
    operation: formatDisplay(t.type),
    key: formatDisplay(t.key),
    oldValue: t.oldValue,
    newValue: t.newValue
  } : {};
}
function formatMutationType(t) {
  switch (t) {
    case MutationType.direct:
      return "mutation";
    case MutationType.patchFunction:
      return "$patch";
    case MutationType.patchObject:
      return "$patch";
    default:
      return "unknown";
  }
}
let isTimelineActive = !0;
const componentStateTypes = [], MUTATIONS_LAYER_ID = "pinia:mutations", INSPECTOR_ID = "pinia", { assign: assign$1$1 } = Object, getStoreType = (t) => "🍍 " + t;
function registerPiniaDevtools(t, e) {
  setupDevtoolsPlugin({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes,
    app: t
  }, (r) => {
    typeof r.now != "function" && toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html."), r.addTimelineLayer({
      id: MUTATIONS_LAYER_ID,
      label: "Pinia 🍍",
      color: 15064968
    }), r.addInspector({
      id: INSPECTOR_ID,
      label: "Pinia 🍍",
      icon: "storage",
      treeFilterPlaceholder: "Search stores",
      actions: [
        {
          icon: "content_copy",
          action: () => {
            actionGlobalCopyState(e);
          },
          tooltip: "Serialize and copy the state"
        },
        {
          icon: "content_paste",
          action: async () => {
            await actionGlobalPasteState(e), r.sendInspectorTree(INSPECTOR_ID), r.sendInspectorState(INSPECTOR_ID);
          },
          tooltip: "Replace the state with the content of your clipboard"
        },
        {
          icon: "save",
          action: () => {
            actionGlobalSaveState(e);
          },
          tooltip: "Save the state as a JSON file"
        },
        {
          icon: "folder_open",
          action: async () => {
            await actionGlobalOpenStateFile(e), r.sendInspectorTree(INSPECTOR_ID), r.sendInspectorState(INSPECTOR_ID);
          },
          tooltip: "Import the state from a JSON file"
        }
      ],
      nodeActions: [
        {
          icon: "restore",
          tooltip: "Reset the state (option store only)",
          action: (o) => {
            const a = e._s.get(o);
            a ? a._isOptionsAPI ? (a.$reset(), toastMessage(`Store "${o}" reset.`)) : toastMessage(`Cannot reset "${o}" store because it's a setup store.`, "warn") : toastMessage(`Cannot reset "${o}" store because it wasn't found.`, "warn");
          }
        }
      ]
    }), r.on.inspectComponent((o, a) => {
      const c = o.componentInstance && o.componentInstance.proxy;
      if (c && c._pStores) {
        const u = o.componentInstance.proxy._pStores;
        Object.values(u).forEach((d) => {
          o.instanceData.state.push({
            type: getStoreType(d.$id),
            key: "state",
            editable: !0,
            value: d._isOptionsAPI ? {
              _custom: {
                value: toRaw(d.$state),
                actions: [
                  {
                    icon: "restore",
                    tooltip: "Reset the state of this store",
                    action: () => d.$reset()
                  }
                ]
              }
            } : (
              // NOTE: workaround to unwrap transferred refs
              Object.keys(d.$state).reduce((p, g) => (p[g] = d.$state[g], p), {})
            )
          }), d._getters && d._getters.length && o.instanceData.state.push({
            type: getStoreType(d.$id),
            key: "getters",
            editable: !1,
            value: d._getters.reduce((p, g) => {
              try {
                p[g] = d[g];
              } catch (b) {
                p[g] = b;
              }
              return p;
            }, {})
          });
        });
      }
    }), r.on.getInspectorTree((o) => {
      if (o.app === t && o.inspectorId === INSPECTOR_ID) {
        let a = [e];
        a = a.concat(Array.from(e._s.values())), o.rootNodes = (o.filter ? a.filter((c) => "$id" in c ? c.$id.toLowerCase().includes(o.filter.toLowerCase()) : PINIA_ROOT_LABEL.toLowerCase().includes(o.filter.toLowerCase())) : a).map(formatStoreForInspectorTree);
      }
    }), r.on.getInspectorState((o) => {
      if (o.app === t && o.inspectorId === INSPECTOR_ID) {
        const a = o.nodeId === PINIA_ROOT_ID ? e : e._s.get(o.nodeId);
        if (!a)
          return;
        a && (o.state = formatStoreForInspectorState(a));
      }
    }), r.on.editInspectorState((o, a) => {
      if (o.app === t && o.inspectorId === INSPECTOR_ID) {
        const c = o.nodeId === PINIA_ROOT_ID ? e : e._s.get(o.nodeId);
        if (!c)
          return toastMessage(`store "${o.nodeId}" not found`, "error");
        const { path: u } = o;
        isPinia(c) ? u.unshift("state") : (u.length !== 1 || !c._customProperties.has(u[0]) || u[0] in c.$state) && u.unshift("$state"), isTimelineActive = !1, o.set(c, u, o.state.value), isTimelineActive = !0;
      }
    }), r.on.editComponentState((o) => {
      if (o.type.startsWith("🍍")) {
        const a = o.type.replace(/^🍍\s*/, ""), c = e._s.get(a);
        if (!c)
          return toastMessage(`store "${a}" not found`, "error");
        const { path: u } = o;
        if (u[0] !== "state")
          return toastMessage(`Invalid path for store "${a}":
${u}
Only state can be modified.`);
        u[0] = "$state", isTimelineActive = !1, o.set(c, u, o.state.value), isTimelineActive = !0;
      }
    });
  });
}
function addStoreToDevtools(t, e) {
  componentStateTypes.includes(getStoreType(e.$id)) || componentStateTypes.push(getStoreType(e.$id)), setupDevtoolsPlugin({
    id: "dev.esm.pinia",
    label: "Pinia 🍍",
    logo: "https://pinia.vuejs.org/logo.svg",
    packageName: "pinia",
    homepage: "https://pinia.vuejs.org",
    componentStateTypes,
    app: t,
    settings: {
      logStoreChanges: {
        label: "Notify about new/deleted stores",
        type: "boolean",
        defaultValue: !0
      }
      // useEmojis: {
      //   label: 'Use emojis in messages ⚡️',
      //   type: 'boolean',
      //   defaultValue: true,
      // },
    }
  }, (r) => {
    const o = typeof r.now == "function" ? r.now.bind(r) : Date.now;
    e.$onAction(({ after: u, onError: d, name: p, args: g }) => {
      const b = runningActionId++;
      r.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: o(),
          title: "🛫 " + p,
          subtitle: "start",
          data: {
            store: formatDisplay(e.$id),
            action: formatDisplay(p),
            args: g
          },
          groupId: b
        }
      }), u((x) => {
        activeAction = void 0, r.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: o(),
            title: "🛬 " + p,
            subtitle: "end",
            data: {
              store: formatDisplay(e.$id),
              action: formatDisplay(p),
              args: g,
              result: x
            },
            groupId: b
          }
        });
      }), d((x) => {
        activeAction = void 0, r.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: o(),
            logType: "error",
            title: "💥 " + p,
            subtitle: "end",
            data: {
              store: formatDisplay(e.$id),
              action: formatDisplay(p),
              args: g,
              error: x
            },
            groupId: b
          }
        });
      });
    }, !0), e._customProperties.forEach((u) => {
      watch(() => unref(e[u]), (d, p) => {
        r.notifyComponentUpdate(), r.sendInspectorState(INSPECTOR_ID), isTimelineActive && r.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: o(),
            title: "Change",
            subtitle: u,
            data: {
              newValue: d,
              oldValue: p
            },
            groupId: activeAction
          }
        });
      }, { deep: !0 });
    }), e.$subscribe(({ events: u, type: d }, p) => {
      if (r.notifyComponentUpdate(), r.sendInspectorState(INSPECTOR_ID), !isTimelineActive)
        return;
      const g = {
        time: o(),
        title: formatMutationType(d),
        data: assign$1$1({ store: formatDisplay(e.$id) }, formatEventData(u)),
        groupId: activeAction
      };
      activeAction = void 0, d === MutationType.patchFunction ? g.subtitle = "⤵️" : d === MutationType.patchObject ? g.subtitle = "🧩" : u && !Array.isArray(u) && (g.subtitle = u.type), u && (g.data["rawEvent(s)"] = {
        _custom: {
          display: "DebuggerEvent",
          type: "object",
          tooltip: "raw DebuggerEvent[]",
          value: u
        }
      }), r.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: g
      });
    }, { detached: !0, flush: "sync" });
    const a = e._hotUpdate;
    e._hotUpdate = markRaw((u) => {
      a(u), r.addTimelineEvent({
        layerId: MUTATIONS_LAYER_ID,
        event: {
          time: o(),
          title: "🔥 " + e.$id,
          subtitle: "HMR update",
          data: {
            store: formatDisplay(e.$id),
            info: formatDisplay("HMR update")
          }
        }
      }), r.notifyComponentUpdate(), r.sendInspectorTree(INSPECTOR_ID), r.sendInspectorState(INSPECTOR_ID);
    });
    const { $dispose: c } = e;
    e.$dispose = () => {
      c(), r.notifyComponentUpdate(), r.sendInspectorTree(INSPECTOR_ID), r.sendInspectorState(INSPECTOR_ID), r.getSettings().logStoreChanges && toastMessage(`Disposed "${e.$id}" store 🗑`);
    }, r.notifyComponentUpdate(), r.sendInspectorTree(INSPECTOR_ID), r.sendInspectorState(INSPECTOR_ID), r.getSettings().logStoreChanges && toastMessage(`"${e.$id}" store installed 🆕`);
  });
}
let runningActionId = 0, activeAction;
function patchActionForGrouping(t, e) {
  const r = e.reduce((o, a) => (o[a] = toRaw(t)[a], o), {});
  for (const o in r)
    t[o] = function() {
      const a = runningActionId, c = new Proxy(t, {
        get(...u) {
          return activeAction = a, Reflect.get(...u);
        },
        set(...u) {
          return activeAction = a, Reflect.set(...u);
        }
      });
      return r[o].apply(c, arguments);
    };
}
function devtoolsPlugin({ app: t, store: e, options: r }) {
  if (!e.$id.startsWith("__hot:")) {
    if (r.state && (e._isOptionsAPI = !0), typeof r.state == "function") {
      patchActionForGrouping(
        // @ts-expect-error: can cast the store...
        e,
        Object.keys(r.actions)
      );
      const o = e._hotUpdate;
      toRaw(e)._hotUpdate = function(a) {
        o.apply(this, arguments), patchActionForGrouping(e, Object.keys(a._hmrPayload.actions));
      };
    }
    addStoreToDevtools(
      t,
      // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
      e
    );
  }
}
function createPinia() {
  const t = effectScope(!0), e = t.run(() => ref({}));
  let r = [], o = [];
  const a = markRaw({
    install(c) {
      setActivePinia(a), a._a = c, c.provide(piniaSymbol, a), c.config.globalProperties.$pinia = a, USE_DEVTOOLS && registerPiniaDevtools(c, a), o.forEach((u) => r.push(u)), o = [];
    },
    use(c) {
      return !this._a && !isVue2 ? o.push(c) : r.push(c), this;
    },
    _p: r,
    // it's actually undefined here
    // @ts-expect-error
    _a: null,
    _e: t,
    _s: /* @__PURE__ */ new Map(),
    state: e
  });
  return USE_DEVTOOLS && typeof Proxy < "u" && a.use(devtoolsPlugin), a;
}
function patchObject(t, e) {
  for (const r in e) {
    const o = e[r];
    if (!(r in t))
      continue;
    const a = t[r];
    isPlainObject$2(a) && isPlainObject$2(o) && !isRef(o) && !isReactive(o) ? t[r] = patchObject(a, o) : t[r] = o;
  }
  return t;
}
const noop = () => {
};
function addSubscription(t, e, r, o = noop) {
  t.push(e);
  const a = () => {
    const c = t.indexOf(e);
    c > -1 && (t.splice(c, 1), o());
  };
  return !r && getCurrentScope() && onScopeDispose(a), a;
}
function triggerSubscriptions(t, ...e) {
  t.slice().forEach((r) => {
    r(...e);
  });
}
function mergeReactiveObjects(t, e) {
  t instanceof Map && e instanceof Map && e.forEach((r, o) => t.set(o, r)), t instanceof Set && e instanceof Set && e.forEach(t.add, t);
  for (const r in e) {
    if (!e.hasOwnProperty(r))
      continue;
    const o = e[r], a = t[r];
    isPlainObject$2(a) && isPlainObject$2(o) && t.hasOwnProperty(r) && !isRef(o) && !isReactive(o) ? t[r] = mergeReactiveObjects(a, o) : t[r] = o;
  }
  return t;
}
const skipHydrateSymbol = process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function shouldHydrate(t) {
  return !isPlainObject$2(t) || !t.hasOwnProperty(skipHydrateSymbol);
}
const { assign: assign$5 } = Object;
function isComputed(t) {
  return !!(isRef(t) && t.effect);
}
function createOptionsStore(t, e, r, o) {
  const { state: a, actions: c, getters: u } = e, d = r.state.value[t];
  let p;
  function g() {
    !d && (process.env.NODE_ENV === "production" || !o) && (r.state.value[t] = a ? a() : {});
    const b = process.env.NODE_ENV !== "production" && o ? (
      // use ref() to unwrap refs inside state TODO: check if this is still necessary
      toRefs(ref(a ? a() : {}).value)
    ) : toRefs(r.state.value[t]);
    return assign$5(b, c, Object.keys(u || {}).reduce((x, w) => (process.env.NODE_ENV !== "production" && w in b && console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${w}" in store "${t}".`), x[w] = markRaw(computed(() => {
      setActivePinia(r);
      const y = r._s.get(t);
      return u[w].call(y, y);
    })), x), {}));
  }
  return p = createSetupStore(t, g, e, r, o, !0), p;
}
function createSetupStore(t, e, r = {}, o, a, c) {
  let u;
  const d = assign$5({ actions: {} }, r);
  if (process.env.NODE_ENV !== "production" && !o._e.active)
    throw new Error("Pinia destroyed");
  const p = {
    deep: !0
    // flush: 'post',
  };
  process.env.NODE_ENV !== "production" && !isVue2 && (p.onTrigger = (W) => {
    g ? y = W : g == !1 && !P._hotUpdating && (Array.isArray(y) ? y.push(W) : console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug."));
  });
  let g, b, x = markRaw([]), w = markRaw([]), y;
  const I = o.state.value[t];
  !c && !I && (process.env.NODE_ENV === "production" || !a) && (o.state.value[t] = {});
  const E = ref({});
  let T;
  function C(W) {
    let A;
    g = b = !1, process.env.NODE_ENV !== "production" && (y = []), typeof W == "function" ? (W(o.state.value[t]), A = {
      type: MutationType.patchFunction,
      storeId: t,
      events: y
    }) : (mergeReactiveObjects(o.state.value[t], W), A = {
      type: MutationType.patchObject,
      payload: W,
      storeId: t,
      events: y
    });
    const S = T = Symbol();
    nextTick$1().then(() => {
      T === S && (g = !0);
    }), b = !0, triggerSubscriptions(x, A, o.state.value[t]);
  }
  const $ = c ? function() {
    const { state: A } = r, S = A ? A() : {};
    this.$patch((F) => {
      assign$5(F, S);
    });
  } : (
    /* istanbul ignore next */
    process.env.NODE_ENV !== "production" ? () => {
      throw new Error(`🍍: Store "${t}" is built using the setup syntax and does not implement $reset().`);
    } : noop
  );
  function D() {
    u.stop(), x = [], w = [], o._s.delete(t);
  }
  function L(W, A) {
    return function() {
      setActivePinia(o);
      const S = Array.from(arguments), F = [], U = [];
      function M(Q) {
        F.push(Q);
      }
      function V(Q) {
        U.push(Q);
      }
      triggerSubscriptions(w, {
        args: S,
        name: W,
        store: P,
        after: M,
        onError: V
      });
      let G;
      try {
        G = A.apply(this && this.$id === t ? this : P, S);
      } catch (Q) {
        throw triggerSubscriptions(U, Q), Q;
      }
      return G instanceof Promise ? G.then((Q) => (triggerSubscriptions(F, Q), Q)).catch((Q) => (triggerSubscriptions(U, Q), Promise.reject(Q))) : (triggerSubscriptions(F, G), G);
    };
  }
  const R = /* @__PURE__ */ markRaw({
    actions: {},
    getters: {},
    state: [],
    hotState: E
  }), O = {
    _p: o,
    // _s: scope,
    $id: t,
    $onAction: addSubscription.bind(null, w),
    $patch: C,
    $reset: $,
    $subscribe(W, A = {}) {
      const S = addSubscription(x, W, A.detached, () => F()), F = u.run(() => watch(() => o.state.value[t], (U) => {
        (A.flush === "sync" ? b : g) && W({
          storeId: t,
          type: MutationType.direct,
          events: y
        }, U);
      }, assign$5({}, p, A)));
      return S;
    },
    $dispose: D
  }, P = reactive(process.env.NODE_ENV !== "production" || USE_DEVTOOLS ? assign$5(
    {
      _hmrPayload: R,
      _customProperties: markRaw(/* @__PURE__ */ new Set())
      // devtools custom properties
    },
    O
    // must be added later
    // setupStore
  ) : O);
  o._s.set(t, P);
  const z = o._e.run(() => (u = effectScope(), u.run(() => e())));
  for (const W in z) {
    const A = z[W];
    if (isRef(A) && !isComputed(A) || isReactive(A))
      process.env.NODE_ENV !== "production" && a ? set$2(E.value, W, toRef(z, W)) : c || (I && shouldHydrate(A) && (isRef(A) ? A.value = I[W] : mergeReactiveObjects(A, I[W])), o.state.value[t][W] = A), process.env.NODE_ENV !== "production" && R.state.push(W);
    else if (typeof A == "function") {
      const S = process.env.NODE_ENV !== "production" && a ? A : L(W, A);
      z[W] = S, process.env.NODE_ENV !== "production" && (R.actions[W] = A), d.actions[W] = A;
    } else
      process.env.NODE_ENV !== "production" && isComputed(A) && (R.getters[W] = c ? (
        // @ts-expect-error
        r.getters[W]
      ) : A, IS_CLIENT && (z._getters || // @ts-expect-error: same
      (z._getters = markRaw([]))).push(W));
  }
  if (assign$5(P, z), assign$5(toRaw(P), z), Object.defineProperty(P, "$state", {
    get: () => process.env.NODE_ENV !== "production" && a ? E.value : o.state.value[t],
    set: (W) => {
      if (process.env.NODE_ENV !== "production" && a)
        throw new Error("cannot set hotState");
      C((A) => {
        assign$5(A, W);
      });
    }
  }), process.env.NODE_ENV !== "production" && (P._hotUpdate = markRaw((W) => {
    P._hotUpdating = !0, W._hmrPayload.state.forEach((A) => {
      if (A in P.$state) {
        const S = W.$state[A], F = P.$state[A];
        typeof S == "object" && isPlainObject$2(S) && isPlainObject$2(F) ? patchObject(S, F) : W.$state[A] = F;
      }
      set$2(P, A, toRef(W.$state, A));
    }), Object.keys(P.$state).forEach((A) => {
      A in W.$state || del(P, A);
    }), g = !1, b = !1, o.state.value[t] = toRef(W._hmrPayload, "hotState"), b = !0, nextTick$1().then(() => {
      g = !0;
    });
    for (const A in W._hmrPayload.actions) {
      const S = W[A];
      set$2(P, A, L(A, S));
    }
    for (const A in W._hmrPayload.getters) {
      const S = W._hmrPayload.getters[A], F = c ? (
        // special handling of options api
        computed(() => (setActivePinia(o), S.call(P, P)))
      ) : S;
      set$2(P, A, F);
    }
    Object.keys(P._hmrPayload.getters).forEach((A) => {
      A in W._hmrPayload.getters || del(P, A);
    }), Object.keys(P._hmrPayload.actions).forEach((A) => {
      A in W._hmrPayload.actions || del(P, A);
    }), P._hmrPayload = W._hmrPayload, P._getters = W._getters, P._hotUpdating = !1;
  })), USE_DEVTOOLS) {
    const W = {
      writable: !0,
      configurable: !0,
      // avoid warning on devtools trying to display this property
      enumerable: !1
    };
    ["_p", "_hmrPayload", "_getters", "_customProperties"].forEach((A) => {
      Object.defineProperty(P, A, assign$5({ value: P[A] }, W));
    });
  }
  return o._p.forEach((W) => {
    if (USE_DEVTOOLS) {
      const A = u.run(() => W({
        store: P,
        app: o._a,
        pinia: o,
        options: d
      }));
      Object.keys(A || {}).forEach((S) => P._customProperties.add(S)), assign$5(P, A);
    } else
      assign$5(P, u.run(() => W({
        store: P,
        app: o._a,
        pinia: o,
        options: d
      })));
  }), process.env.NODE_ENV !== "production" && P.$state && typeof P.$state == "object" && typeof P.$state.constructor == "function" && !P.$state.constructor.toString().includes("[native code]") && console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${P.$id}".`), I && c && r.hydrate && r.hydrate(P.$state, I), g = !0, b = !0, P;
}
function defineStore(t, e, r) {
  let o, a;
  const c = typeof e == "function";
  if (typeof t == "string")
    o = t, a = c ? r : e;
  else if (a = t, o = t.id, process.env.NODE_ENV !== "production" && typeof o != "string")
    throw new Error('[🍍]: "defineStore()" must be passed a store id as its first argument.');
  function u(d, p) {
    const g = getCurrentInstance();
    if (d = // in test mode, ignore the argument provided as we can always retrieve a
    // pinia instance with getActivePinia()
    (process.env.NODE_ENV === "test" && activePinia && activePinia._testing ? null : d) || g && inject(piniaSymbol, null), d && setActivePinia(d), process.env.NODE_ENV !== "production" && !activePinia)
      throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Did you forget to install pinia?
	const pinia = createPinia()
	app.use(pinia)
This will fail in production.`);
    d = activePinia, d._s.has(o) || (c ? createSetupStore(o, e, a, d) : createOptionsStore(o, a, d), process.env.NODE_ENV !== "production" && (u._pinia = d));
    const b = d._s.get(o);
    if (process.env.NODE_ENV !== "production" && p) {
      const x = "__hot:" + o, w = c ? createSetupStore(x, e, a, d, !0) : createOptionsStore(x, assign$5({}, a), d, !0);
      p._hotUpdate(w), delete d.state.value[x], d._s.delete(x);
    }
    if (process.env.NODE_ENV !== "production" && IS_CLIENT && g && g.proxy && // avoid adding stores that are just built for hot module replacement
    !p) {
      const x = g.proxy, w = "_pStores" in x ? x._pStores : x._pStores = {};
      w[o] = b;
    }
    return b;
  }
  return u.$id = o, u;
}
const useProductIdentificationStore = defineStore("productIdentification", {
  state: () => ({
    productIdentificationPref: {
      primaryId: "",
      secondaryId: ""
    },
    productIdentificationOptions: ["productId", "groupId", "groupName", "internalName", "parentProductName", "primaryProductCategoryName", "sku", "title", "SHOPIFY_PROD_SKU", "upc"]
  }),
  getters: {
    getProductIdentificationPref: (t) => t.productIdentificationPref,
    getProductIdentificationOptions: (t) => t.productIdentificationOptions
  },
  actions: {
    async setProductIdentificationPref(t, e, r) {
      const o = JSON.parse(JSON.stringify(this.getProductIdentificationPref));
      if (!r) {
        this.productIdentificationPref = o;
        return;
      }
      o[t] = e;
      try {
        this.productIdentificationPref = await productIdentificationContext.setProductIdentificationPref(r, o);
      } catch (a) {
        console.error("error", a);
      }
    },
    async getIdentificationPref(t) {
      if (!t)
        return this.productIdentificationPref = {
          primaryId: "productId",
          secondaryId: ""
        };
      this.productIdentificationPref = await productIdentificationContext.getProductIdentificationPref(t);
    }
  }
});
class LuxonError extends Error {
}
class InvalidDateTimeError extends LuxonError {
  constructor(e) {
    super(`Invalid DateTime: ${e.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(e) {
    super(`Invalid Interval: ${e.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(e) {
    super(`Invalid Duration: ${e.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {
}
class InvalidUnitError extends LuxonError {
  constructor(e) {
    super(`Invalid unit ${e}`);
  }
}
class InvalidArgumentError extends LuxonError {
}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}
const n = "numeric", s = "short", l = "long", DATE_SHORT = {
  year: n,
  month: n,
  day: n
}, DATE_MED = {
  year: n,
  month: s,
  day: n
}, DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
}, DATE_FULL = {
  year: n,
  month: l,
  day: n
}, DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
}, TIME_SIMPLE = {
  hour: n,
  minute: n
}, TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
}, TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
}, TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
}, TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
}, TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
}, TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
}, TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
}, DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
}, DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
}, DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
}, DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
}, DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
}, DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
}, DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
}, DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
}, DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(e, r) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(e, r) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(e) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(e) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}
let singleton$1 = null;
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return singleton$1 === null && (singleton$1 = new SystemZone()), singleton$1;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: r, locale: o }) {
    return parseZoneInfo(e, r, o);
  }
  /** @override **/
  formatOffset(e, r) {
    return formatOffset(this.offset(e), r);
  }
  /** @override **/
  offset(e) {
    return -new Date(e).getTimezoneOffset();
  }
  /** @override **/
  equals(e) {
    return e.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let dtfCache = {};
function makeDTF(t) {
  return dtfCache[t] || (dtfCache[t] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), dtfCache[t];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(t, e) {
  const r = t.format(e).replace(/\u200E/g, ""), o = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(r), [, a, c, u, d, p, g, b] = o;
  return [u, a, c, d, p, g, b];
}
function partsOffset(t, e) {
  const r = t.formatToParts(e), o = [];
  for (let a = 0; a < r.length; a++) {
    const { type: c, value: u } = r[a], d = typeToPos[c];
    c === "era" ? o[d] = u : isUndefined$1(d) || (o[d] = parseInt(u, 10));
  }
  return o;
}
let ianaZoneCache = {};
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(e) {
    return ianaZoneCache[e] || (ianaZoneCache[e] = new IANAZone(e)), ianaZoneCache[e];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {}, dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(e) {
    return this.isValidZone(e);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(e) {
    if (!e)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: e }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(e) {
    super(), this.zoneName = e, this.valid = IANAZone.isValidZone(e);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(e, { format: r, locale: o }) {
    return parseZoneInfo(e, r, o, this.name);
  }
  /** @override **/
  formatOffset(e, r) {
    return formatOffset(this.offset(e), r);
  }
  /** @override **/
  offset(e) {
    const r = new Date(e);
    if (isNaN(r))
      return NaN;
    const o = makeDTF(this.name);
    let [a, c, u, d, p, g, b] = o.formatToParts ? partsOffset(o, r) : hackyOffset(o, r);
    d === "BC" && (a = -Math.abs(a) + 1);
    const w = objToLocalTS({
      year: a,
      month: c,
      day: u,
      hour: p === 24 ? 0 : p,
      minute: g,
      second: b,
      millisecond: 0
    });
    let y = +r;
    const I = y % 1e3;
    return y -= I >= 0 ? I : 1e3 + I, (w - y) / (60 * 1e3);
  }
  /** @override **/
  equals(e) {
    return e.type === "iana" && e.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let intlLFCache = {};
function getCachedLF(t, e = {}) {
  const r = JSON.stringify([t, e]);
  let o = intlLFCache[r];
  return o || (o = new Intl.ListFormat(t, e), intlLFCache[r] = o), o;
}
let intlDTCache = {};
function getCachedDTF(t, e = {}) {
  const r = JSON.stringify([t, e]);
  let o = intlDTCache[r];
  return o || (o = new Intl.DateTimeFormat(t, e), intlDTCache[r] = o), o;
}
let intlNumCache = {};
function getCachedINF(t, e = {}) {
  const r = JSON.stringify([t, e]);
  let o = intlNumCache[r];
  return o || (o = new Intl.NumberFormat(t, e), intlNumCache[r] = o), o;
}
let intlRelCache = {};
function getCachedRTF(t, e = {}) {
  const { base: r, ...o } = e, a = JSON.stringify([t, o]);
  let c = intlRelCache[a];
  return c || (c = new Intl.RelativeTimeFormat(t, e), intlRelCache[a] = c), c;
}
let sysLocaleCache = null;
function systemLocale() {
  return sysLocaleCache || (sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale, sysLocaleCache);
}
function parseLocaleString(t) {
  const e = t.indexOf("-x-");
  e !== -1 && (t = t.substring(0, e));
  const r = t.indexOf("-u-");
  if (r === -1)
    return [t];
  {
    let o, a;
    try {
      o = getCachedDTF(t).resolvedOptions(), a = t;
    } catch {
      const p = t.substring(0, r);
      o = getCachedDTF(p).resolvedOptions(), a = p;
    }
    const { numberingSystem: c, calendar: u } = o;
    return [a, c, u];
  }
}
function intlConfigString(t, e, r) {
  return (r || e) && (t.includes("-u-") || (t += "-u"), r && (t += `-ca-${r}`), e && (t += `-nu-${e}`)), t;
}
function mapMonths(t) {
  const e = [];
  for (let r = 1; r <= 12; r++) {
    const o = DateTime.utc(2009, r, 1);
    e.push(t(o));
  }
  return e;
}
function mapWeekdays(t) {
  const e = [];
  for (let r = 1; r <= 7; r++) {
    const o = DateTime.utc(2016, 11, 13 + r);
    e.push(t(o));
  }
  return e;
}
function listStuff(t, e, r, o) {
  const a = t.listingMode();
  return a === "error" ? null : a === "en" ? r(e) : o(e);
}
function supportsFastNumbers(t) {
  return t.numberingSystem && t.numberingSystem !== "latn" ? !1 : t.numberingSystem === "latn" || !t.locale || t.locale.startsWith("en") || new Intl.DateTimeFormat(t.intl).resolvedOptions().numberingSystem === "latn";
}
class PolyNumberFormatter {
  constructor(e, r, o) {
    this.padTo = o.padTo || 0, this.floor = o.floor || !1;
    const { padTo: a, floor: c, ...u } = o;
    if (!r || Object.keys(u).length > 0) {
      const d = { useGrouping: !1, ...o };
      o.padTo > 0 && (d.minimumIntegerDigits = o.padTo), this.inf = getCachedINF(e, d);
    }
  }
  format(e) {
    if (this.inf) {
      const r = this.floor ? Math.floor(e) : e;
      return this.inf.format(r);
    } else {
      const r = this.floor ? Math.floor(e) : roundTo(e, 3);
      return padStart(r, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(e, r, o) {
    this.opts = o, this.originalZone = void 0;
    let a;
    if (this.opts.timeZone)
      this.dt = e;
    else if (e.zone.type === "fixed") {
      const u = -1 * (e.offset / 60), d = u >= 0 ? `Etc/GMT+${u}` : `Etc/GMT${u}`;
      e.offset !== 0 && IANAZone.create(d).valid ? (a = d, this.dt = e) : (a = "UTC", this.dt = e.offset === 0 ? e : e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    } else
      e.zone.type === "system" ? this.dt = e : e.zone.type === "iana" ? (this.dt = e, a = e.zone.name) : (a = "UTC", this.dt = e.setZone("UTC").plus({ minutes: e.offset }), this.originalZone = e.zone);
    const c = { ...this.opts };
    c.timeZone = c.timeZone || a, this.dtf = getCachedDTF(r, c);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: e }) => e).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const e = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? e.map((r) => {
      if (r.type === "timeZoneName") {
        const o = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...r,
          value: o
        };
      } else
        return r;
    }) : e;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(e, r, o) {
    this.opts = { style: "long", ...o }, !r && hasRelative() && (this.rtf = getCachedRTF(e, o));
  }
  format(e, r) {
    return this.rtf ? this.rtf.format(e, r) : formatRelativeTime(r, e, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(e, r) {
    return this.rtf ? this.rtf.formatToParts(e, r) : [];
  }
}
class Locale {
  static fromOpts(e) {
    return Locale.create(e.locale, e.numberingSystem, e.outputCalendar, e.defaultToEN);
  }
  static create(e, r, o, a = !1) {
    const c = e || Settings.defaultLocale, u = c || (a ? "en-US" : systemLocale()), d = r || Settings.defaultNumberingSystem, p = o || Settings.defaultOutputCalendar;
    return new Locale(u, d, p, c);
  }
  static resetCache() {
    sysLocaleCache = null, intlDTCache = {}, intlNumCache = {}, intlRelCache = {};
  }
  static fromObject({ locale: e, numberingSystem: r, outputCalendar: o } = {}) {
    return Locale.create(e, r, o);
  }
  constructor(e, r, o, a) {
    const [c, u, d] = parseLocaleString(e);
    this.locale = c, this.numberingSystem = r || u || null, this.outputCalendar = o || d || null, this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = a, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = supportsFastNumbers(this)), this.fastNumbersCached;
  }
  listingMode() {
    const e = this.isEnglish(), r = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return e && r ? "en" : "intl";
  }
  clone(e) {
    return !e || Object.getOwnPropertyNames(e).length === 0 ? this : Locale.create(
      e.locale || this.specifiedLocale,
      e.numberingSystem || this.numberingSystem,
      e.outputCalendar || this.outputCalendar,
      e.defaultToEN || !1
    );
  }
  redefaultToEN(e = {}) {
    return this.clone({ ...e, defaultToEN: !0 });
  }
  redefaultToSystem(e = {}) {
    return this.clone({ ...e, defaultToEN: !1 });
  }
  months(e, r = !1) {
    return listStuff(this, e, months, () => {
      const o = r ? { month: e, day: "numeric" } : { month: e }, a = r ? "format" : "standalone";
      return this.monthsCache[a][e] || (this.monthsCache[a][e] = mapMonths((c) => this.extract(c, o, "month"))), this.monthsCache[a][e];
    });
  }
  weekdays(e, r = !1) {
    return listStuff(this, e, weekdays, () => {
      const o = r ? { weekday: e, year: "numeric", month: "long", day: "numeric" } : { weekday: e }, a = r ? "format" : "standalone";
      return this.weekdaysCache[a][e] || (this.weekdaysCache[a][e] = mapWeekdays(
        (c) => this.extract(c, o, "weekday")
      )), this.weekdaysCache[a][e];
    });
  }
  meridiems() {
    return listStuff(
      this,
      void 0,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const e = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (r) => this.extract(r, e, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(e) {
    return listStuff(this, e, eras, () => {
      const r = { era: e };
      return this.eraCache[e] || (this.eraCache[e] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(
        (o) => this.extract(o, r, "era")
      )), this.eraCache[e];
    });
  }
  extract(e, r, o) {
    const a = this.dtFormatter(e, r), c = a.formatToParts(), u = c.find((d) => d.type.toLowerCase() === o);
    return u ? u.value : null;
  }
  numberFormatter(e = {}) {
    return new PolyNumberFormatter(this.intl, e.forceSimple || this.fastNumbers, e);
  }
  dtFormatter(e, r = {}) {
    return new PolyDateFormatter(e, this.intl, r);
  }
  relFormatter(e = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), e);
  }
  listFormatter(e = {}) {
    return getCachedLF(this.intl, e);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  equals(e) {
    return this.locale === e.locale && this.numberingSystem === e.numberingSystem && this.outputCalendar === e.outputCalendar;
  }
}
let singleton = null;
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return singleton === null && (singleton = new FixedOffsetZone(0)), singleton;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(e) {
    return e === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(e);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(e) {
    if (e) {
      const r = e.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r)
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
    }
    return null;
  }
  constructor(e) {
    super(), this.fixed = e;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(e, r) {
    return formatOffset(this.fixed, r);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(e) {
    return e.type === "fixed" && e.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class InvalidZone extends Zone {
  constructor(e) {
    super(), this.zoneName = e;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function normalizeZone(t, e) {
  if (isUndefined$1(t) || t === null)
    return e;
  if (t instanceof Zone)
    return t;
  if (isString$5(t)) {
    const r = t.toLowerCase();
    return r === "default" ? e : r === "local" || r === "system" ? SystemZone.instance : r === "utc" || r === "gmt" ? FixedOffsetZone.utcInstance : FixedOffsetZone.parseSpecifier(r) || IANAZone.create(t);
  } else
    return isNumber$3(t) ? FixedOffsetZone.instance(t) : typeof t == "object" && "offset" in t && typeof t.offset == "function" ? t : new InvalidZone(t);
}
let now$2 = () => Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid;
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now$2;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(e) {
    now$2 = e;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(e) {
    defaultZone = e;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(e) {
    defaultLocale = e;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(e) {
    defaultNumberingSystem = e;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(e) {
    defaultOutputCalendar = e;
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(e) {
    twoDigitCutoffYear = e % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(e) {
    throwOnInvalid = e;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache(), IANAZone.resetCache();
  }
}
function isUndefined$1(t) {
  return typeof t > "u";
}
function isNumber$3(t) {
  return typeof t == "number";
}
function isInteger(t) {
  return typeof t == "number" && t % 1 === 0;
}
function isString$5(t) {
  return typeof t == "string";
}
function isDate$3(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function maybeArray(t) {
  return Array.isArray(t) ? t : [t];
}
function bestBy(t, e, r) {
  if (t.length !== 0)
    return t.reduce((o, a) => {
      const c = [e(a), a];
      return o && r(o[0], c[0]) === o[0] ? o : c;
    }, null)[1];
}
function pick$1(t, e) {
  return e.reduce((r, o) => (r[o] = t[o], r), {});
}
function hasOwnProperty$1(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function integerBetween(t, e, r) {
  return isInteger(t) && t >= e && t <= r;
}
function floorMod(t, e) {
  return t - e * Math.floor(t / e);
}
function padStart(t, e = 2) {
  const r = t < 0;
  let o;
  return r ? o = "-" + ("" + -t).padStart(e, "0") : o = ("" + t).padStart(e, "0"), o;
}
function parseInteger(t) {
  if (!(isUndefined$1(t) || t === null || t === ""))
    return parseInt(t, 10);
}
function parseFloating(t) {
  if (!(isUndefined$1(t) || t === null || t === ""))
    return parseFloat(t);
}
function parseMillis(t) {
  if (!(isUndefined$1(t) || t === null || t === "")) {
    const e = parseFloat("0." + t) * 1e3;
    return Math.floor(e);
  }
}
function roundTo(t, e, r = !1) {
  const o = 10 ** e;
  return (r ? Math.trunc : Math.round)(t * o) / o;
}
function isLeapYear(t) {
  return t % 4 === 0 && (t % 100 !== 0 || t % 400 === 0);
}
function daysInYear(t) {
  return isLeapYear(t) ? 366 : 365;
}
function daysInMonth(t, e) {
  const r = floorMod(e - 1, 12) + 1, o = t + (e - r) / 12;
  return r === 2 ? isLeapYear(o) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][r - 1];
}
function objToLocalTS(t) {
  let e = Date.UTC(
    t.year,
    t.month - 1,
    t.day,
    t.hour,
    t.minute,
    t.second,
    t.millisecond
  );
  return t.year < 100 && t.year >= 0 && (e = new Date(e), e.setUTCFullYear(t.year, t.month - 1, t.day)), +e;
}
function weeksInWeekYear(t) {
  const e = (t + Math.floor(t / 4) - Math.floor(t / 100) + Math.floor(t / 400)) % 7, r = t - 1, o = (r + Math.floor(r / 4) - Math.floor(r / 100) + Math.floor(r / 400)) % 7;
  return e === 4 || o === 3 ? 53 : 52;
}
function untruncateYear(t) {
  return t > 99 ? t : t > Settings.twoDigitCutoffYear ? 1900 + t : 2e3 + t;
}
function parseZoneInfo(t, e, r, o = null) {
  const a = new Date(t), c = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  o && (c.timeZone = o);
  const u = { timeZoneName: e, ...c }, d = new Intl.DateTimeFormat(r, u).formatToParts(a).find((p) => p.type.toLowerCase() === "timezonename");
  return d ? d.value : null;
}
function signedOffset(t, e) {
  let r = parseInt(t, 10);
  Number.isNaN(r) && (r = 0);
  const o = parseInt(e, 10) || 0, a = r < 0 || Object.is(r, -0) ? -o : o;
  return r * 60 + a;
}
function asNumber(t) {
  const e = Number(t);
  if (typeof t == "boolean" || t === "" || Number.isNaN(e))
    throw new InvalidArgumentError(`Invalid unit value ${t}`);
  return e;
}
function normalizeObject(t, e) {
  const r = {};
  for (const o in t)
    if (hasOwnProperty$1(t, o)) {
      const a = t[o];
      if (a == null)
        continue;
      r[e(o)] = asNumber(a);
    }
  return r;
}
function formatOffset(t, e) {
  const r = Math.trunc(Math.abs(t / 60)), o = Math.trunc(Math.abs(t % 60)), a = t >= 0 ? "+" : "-";
  switch (e) {
    case "short":
      return `${a}${padStart(r, 2)}:${padStart(o, 2)}`;
    case "narrow":
      return `${a}${r}${o > 0 ? `:${o}` : ""}`;
    case "techie":
      return `${a}${padStart(r, 2)}${padStart(o, 2)}`;
    default:
      throw new RangeError(`Value format ${e} is out of range for property format`);
  }
}
function timeObject(t) {
  return pick$1(t, ["hour", "minute", "second", "millisecond"]);
}
const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(t) {
  switch (t) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(t) {
  switch (t) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"], erasLong = ["Before Christ", "Anno Domini"], erasShort = ["BC", "AD"], erasNarrow = ["B", "A"];
function eras(t) {
  switch (t) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(t) {
  return meridiems[t.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(t, e) {
  return weekdays(e)[t.weekday - 1];
}
function monthForDateTime(t, e) {
  return months(e)[t.month - 1];
}
function eraForDateTime(t, e) {
  return eras(e)[t.year < 0 ? 0 : 1];
}
function formatRelativeTime(t, e, r = "always", o = !1) {
  const a = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, c = ["hours", "minutes", "seconds"].indexOf(t) === -1;
  if (r === "auto" && c) {
    const x = t === "days";
    switch (e) {
      case 1:
        return x ? "tomorrow" : `next ${a[t][0]}`;
      case -1:
        return x ? "yesterday" : `last ${a[t][0]}`;
      case 0:
        return x ? "today" : `this ${a[t][0]}`;
    }
  }
  const u = Object.is(e, -0) || e < 0, d = Math.abs(e), p = d === 1, g = a[t], b = o ? p ? g[1] : g[2] || g[1] : p ? a[t][0] : t;
  return u ? `${d} ${b} ago` : `in ${d} ${b}`;
}
function stringifyTokens(t, e) {
  let r = "";
  for (const o of t)
    o.literal ? r += o.val : r += e(o.val);
  return r;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
class Formatter {
  static create(e, r = {}) {
    return new Formatter(e, r);
  }
  static parseFormat(e) {
    let r = null, o = "", a = !1;
    const c = [];
    for (let u = 0; u < e.length; u++) {
      const d = e.charAt(u);
      d === "'" ? (o.length > 0 && c.push({ literal: a || /^\s+$/.test(o), val: o }), r = null, o = "", a = !a) : a || d === r ? o += d : (o.length > 0 && c.push({ literal: /^\s+$/.test(o), val: o }), o = d, r = d);
    }
    return o.length > 0 && c.push({ literal: a || /^\s+$/.test(o), val: o }), c;
  }
  static macroTokenToFormatOpts(e) {
    return macroTokenToFormatOpts[e];
  }
  constructor(e, r) {
    this.opts = r, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, r) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...r }).format();
  }
  dtFormatter(e, r = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...r });
  }
  formatDateTime(e, r) {
    return this.dtFormatter(e, r).format();
  }
  formatDateTimeParts(e, r) {
    return this.dtFormatter(e, r).formatToParts();
  }
  formatInterval(e, r) {
    return this.dtFormatter(e.start, r).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, r) {
    return this.dtFormatter(e, r).resolvedOptions();
  }
  num(e, r = 0) {
    if (this.opts.forceSimple)
      return padStart(e, r);
    const o = { ...this.opts };
    return r > 0 && (o.padTo = r), this.loc.numberFormatter(o).format(e);
  }
  formatDateTimeFromString(e, r) {
    const o = this.loc.listingMode() === "en", a = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", c = (y, I) => this.loc.extract(e, y, I), u = (y) => e.isOffsetFixed && e.offset === 0 && y.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, y.format) : "", d = () => o ? meridiemForDateTime(e) : c({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), p = (y, I) => o ? monthForDateTime(e, y) : c(I ? { month: y } : { month: y, day: "numeric" }, "month"), g = (y, I) => o ? weekdayForDateTime(e, y) : c(
      I ? { weekday: y } : { weekday: y, month: "long", day: "numeric" },
      "weekday"
    ), b = (y) => {
      const I = Formatter.macroTokenToFormatOpts(y);
      return I ? this.formatWithSystemDefault(e, I) : y;
    }, x = (y) => o ? eraForDateTime(e, y) : c({ era: y }, "era"), w = (y) => {
      switch (y) {
        case "S":
          return this.num(e.millisecond);
        case "u":
        case "SSS":
          return this.num(e.millisecond, 3);
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        case "Z":
          return u({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return u({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return u({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return e.zoneName;
        case "a":
          return d();
        case "d":
          return a ? c({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return a ? c({ day: "2-digit" }, "day") : this.num(e.day, 2);
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return g("short", !0);
        case "cccc":
          return g("long", !0);
        case "ccccc":
          return g("narrow", !0);
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return g("short", !1);
        case "EEEE":
          return g("long", !1);
        case "EEEEE":
          return g("narrow", !1);
        case "L":
          return a ? c({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return a ? c({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return p("short", !0);
        case "LLLL":
          return p("long", !0);
        case "LLLLL":
          return p("narrow", !0);
        case "M":
          return a ? c({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return a ? c({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return p("short", !1);
        case "MMMM":
          return p("long", !1);
        case "MMMMM":
          return p("narrow", !1);
        case "y":
          return a ? c({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return a ? c({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return a ? c({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return a ? c({ year: "numeric" }, "year") : this.num(e.year, 6);
        case "G":
          return x("short");
        case "GG":
          return x("long");
        case "GGGGG":
          return x("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return b(y);
      }
    };
    return stringifyTokens(Formatter.parseFormat(r), w);
  }
  formatDurationFromString(e, r) {
    const o = (p) => {
      switch (p[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, a = (p) => (g) => {
      const b = o(g);
      return b ? this.num(p.get(b), g.length) : g;
    }, c = Formatter.parseFormat(r), u = c.reduce(
      (p, { literal: g, val: b }) => g ? p : p.concat(b),
      []
    ), d = e.shiftTo(...u.map(o).filter((p) => p));
    return stringifyTokens(c, a(d));
  }
}
class Invalid {
  constructor(e, r) {
    this.reason = e, this.explanation = r;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...t) {
  const e = t.reduce((r, o) => r + o.source, "");
  return RegExp(`^${e}$`);
}
function combineExtractors(...t) {
  return (e) => t.reduce(
    ([r, o, a], c) => {
      const [u, d, p] = c(e, a);
      return [{ ...r, ...u }, d || o, p];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function parse$4(t, ...e) {
  if (t == null)
    return [null, null];
  for (const [r, o] of e) {
    const a = r.exec(t);
    if (a)
      return o(a);
  }
  return [null, null];
}
function simpleParse(...t) {
  return (e, r) => {
    const o = {};
    let a;
    for (a = 0; a < t.length; a++)
      o[t[a]] = parseInteger(e[r + a]);
    return [o, null, r + a];
  };
}
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`, isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`), isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`), isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, isoOrdinalRegex = /(\d{4})-?(\d{3})/, extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"), extractISOOrdinalData = simpleParse("year", "ordinal"), sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
), sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int$1(t, e, r) {
  const o = t[e];
  return isUndefined$1(o) ? r : parseInteger(o);
}
function extractISOYmd(t, e) {
  return [{
    year: int$1(t, e),
    month: int$1(t, e + 1, 1),
    day: int$1(t, e + 2, 1)
  }, null, e + 3];
}
function extractISOTime(t, e) {
  return [{
    hours: int$1(t, e, 0),
    minutes: int$1(t, e + 1, 0),
    seconds: int$1(t, e + 2, 0),
    milliseconds: parseMillis(t[e + 3])
  }, null, e + 4];
}
function extractISOOffset(t, e) {
  const r = !t[e] && !t[e + 1], o = signedOffset(t[e + 1], t[e + 2]), a = r ? null : FixedOffsetZone.instance(o);
  return [{}, a, e + 3];
}
function extractIANAZone(t, e) {
  const r = t[e] ? IANAZone.create(t[e]) : null;
  return [{}, r, e + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`), isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(t) {
  const [e, r, o, a, c, u, d, p, g] = t, b = e[0] === "-", x = p && p[0] === "-", w = (y, I = !1) => y !== void 0 && (I || y && b) ? -y : y;
  return [
    {
      years: w(parseFloating(r)),
      months: w(parseFloating(o)),
      weeks: w(parseFloating(a)),
      days: w(parseFloating(c)),
      hours: w(parseFloating(u)),
      minutes: w(parseFloating(d)),
      seconds: w(parseFloating(p), p === "-0"),
      milliseconds: w(parseMillis(g), x)
    }
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(t, e, r, o, a, c, u) {
  const d = {
    year: e.length === 2 ? untruncateYear(parseInteger(e)) : parseInteger(e),
    month: monthsShort.indexOf(r) + 1,
    day: parseInteger(o),
    hour: parseInteger(a),
    minute: parseInteger(c)
  };
  return u && (d.second = parseInteger(u)), t && (d.weekday = t.length > 3 ? weekdaysLong.indexOf(t) + 1 : weekdaysShort.indexOf(t) + 1), d;
}
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(t) {
  const [
    ,
    e,
    r,
    o,
    a,
    c,
    u,
    d,
    p,
    g,
    b,
    x
  ] = t, w = fromStrings(e, a, o, r, c, u, d);
  let y;
  return p ? y = obsOffsets[p] : g ? y = 0 : y = signedOffset(b, x), [w, new FixedOffsetZone(y)];
}
function preprocessRFC2822(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(t) {
  const [, e, r, o, a, c, u, d] = t;
  return [fromStrings(e, a, o, r, c, u, d), FixedOffsetZone.utcInstance];
}
function extractASCII(t) {
  const [, e, r, o, a, c, u, d] = t;
  return [fromStrings(e, d, r, o, a, c, u), FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex), isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex), isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex), isoTimeCombinedRegex = combineRegexes(isoTimeRegex), extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
), extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
), extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
), extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(t) {
  return parse$4(
    t,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(t) {
  return parse$4(preprocessRFC2822(t), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(t) {
  return parse$4(
    t,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(t) {
  return parse$4(t, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(t) {
  return parse$4(t, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex), sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex), extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(t) {
  return parse$4(
    t,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}
const INVALID$2 = "Invalid Duration", lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, casualMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, daysInYearAccurate = 146097 / 400, daysInMonthAccurate = 146097 / 4800, accurateMatrix = {
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1e3
  },
  ...lowOrderMatrix
}, orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(t, e, r = !1) {
  const o = {
    values: r ? e.values : { ...t.values, ...e.values || {} },
    loc: t.loc.clone(e.loc),
    conversionAccuracy: e.conversionAccuracy || t.conversionAccuracy,
    matrix: e.matrix || t.matrix
  };
  return new Duration(o);
}
function durationToMillis(t, e) {
  let r = e.milliseconds ?? 0;
  for (const o of reverseUnits.slice(1))
    e[o] && (r += e[o] * t[o].milliseconds);
  return r;
}
function normalizeValues(t, e) {
  const r = durationToMillis(t, e) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((o, a) => {
    if (isUndefined$1(e[a]))
      return o;
    if (o) {
      const c = e[o] * r, u = t[a][o], d = Math.floor(c / u);
      e[a] += d * r, e[o] -= d * u * r;
    }
    return a;
  }, null), orderedUnits$1.reduce((o, a) => {
    if (isUndefined$1(e[a]))
      return o;
    if (o) {
      const c = e[o] % 1;
      e[o] -= c, e[a] += c * t[o][a];
    }
    return a;
  }, null);
}
function removeZeroes(t) {
  const e = {};
  for (const [r, o] of Object.entries(t))
    o !== 0 && (e[r] = o);
  return e;
}
class Duration {
  /**
   * @private
   */
  constructor(e) {
    const r = e.conversionAccuracy === "longterm" || !1;
    let o = r ? accurateMatrix : casualMatrix;
    e.matrix && (o = e.matrix), this.values = e.values, this.loc = e.loc || Locale.create(), this.conversionAccuracy = r ? "longterm" : "casual", this.invalid = e.invalid || null, this.matrix = o, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(e, r) {
    return Duration.fromObject({ milliseconds: e }, r);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(e, r = {}) {
    if (e == null || typeof e != "object")
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${e === null ? "null" : typeof e}`
      );
    return new Duration({
      values: normalizeObject(e, Duration.normalizeUnit),
      loc: Locale.fromObject(r),
      conversionAccuracy: r.conversionAccuracy,
      matrix: r.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(e) {
    if (isNumber$3(e))
      return Duration.fromMillis(e);
    if (Duration.isDuration(e))
      return e;
    if (typeof e == "object")
      return Duration.fromObject(e);
    throw new InvalidArgumentError(
      `Unknown duration argument ${e} of type ${typeof e}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(e, r) {
    const [o] = parseISODuration(e);
    return o ? Duration.fromObject(o, r) : Duration.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(e, r) {
    const [o] = parseISOTimeOnly(e);
    return o ? Duration.fromObject(o, r) : Duration.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(e, r = null) {
    if (!e)
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    const o = e instanceof Invalid ? e : new Invalid(e, r);
    if (Settings.throwOnInvalid)
      throw new InvalidDurationError(o);
    return new Duration({ invalid: o });
  }
  /**
   * @private
   */
  static normalizeUnit(e) {
    const r = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[e && e.toLowerCase()];
    if (!r)
      throw new InvalidUnitError(e);
    return r;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(e) {
    return e && e.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(e, r = {}) {
    const o = {
      ...r,
      floor: r.round !== !1 && r.floor !== !1
    };
    return this.isValid ? Formatter.create(this.loc, o).formatDurationFromString(this, e) : INVALID$2;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(e = {}) {
    if (!this.isValid)
      return INVALID$2;
    const r = orderedUnits$1.map((o) => {
      const a = this.values[o];
      return isUndefined$1(a) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...e, unit: o.slice(0, -1) }).format(a);
    }).filter((o) => o);
    return this.loc.listFormatter({ type: "conjunction", style: e.listStyle || "narrow", ...e }).format(r);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid)
      return null;
    let e = "P";
    return this.years !== 0 && (e += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (e += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (e += this.weeks + "W"), this.days !== 0 && (e += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (e += "T"), this.hours !== 0 && (e += this.hours + "H"), this.minutes !== 0 && (e += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (e += roundTo(this.seconds + this.milliseconds / 1e3, 3) + "S"), e === "P" && (e += "T0S"), e;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(e = {}) {
    if (!this.isValid)
      return null;
    const r = this.toMillis();
    return r < 0 || r >= 864e5 ? null : (e = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...e,
      includeOffset: !1
    }, DateTime.fromMillis(r, { zone: "UTC" }).toISOTime(e));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? durationToMillis(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(e) {
    if (!this.isValid)
      return this;
    const r = Duration.fromDurationLike(e), o = {};
    for (const a of orderedUnits$1)
      (hasOwnProperty$1(r.values, a) || hasOwnProperty$1(this.values, a)) && (o[a] = r.get(a) + this.get(a));
    return clone$1(this, { values: o }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(e) {
    if (!this.isValid)
      return this;
    const r = Duration.fromDurationLike(e);
    return this.plus(r.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(e) {
    if (!this.isValid)
      return this;
    const r = {};
    for (const o of Object.keys(this.values))
      r[o] = asNumber(e(this.values[o], o));
    return clone$1(this, { values: r }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(e) {
    return this[Duration.normalizeUnit(e)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(e) {
    if (!this.isValid)
      return this;
    const r = { ...this.values, ...normalizeObject(e, Duration.normalizeUnit) };
    return clone$1(this, { values: r });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: e, numberingSystem: r, conversionAccuracy: o, matrix: a } = {}) {
    const u = { loc: this.loc.clone({ locale: e, numberingSystem: r }), matrix: a, conversionAccuracy: o };
    return clone$1(this, u);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(e) {
    return this.isValid ? this.shiftTo(e).get(e) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see second example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid)
      return this;
    const e = this.toObject();
    return normalizeValues(this.matrix, e), clone$1(this, { values: e }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid)
      return this;
    const e = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: e }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...e) {
    if (!this.isValid)
      return this;
    if (e.length === 0)
      return this;
    e = e.map((u) => Duration.normalizeUnit(u));
    const r = {}, o = {}, a = this.toObject();
    let c;
    for (const u of orderedUnits$1)
      if (e.indexOf(u) >= 0) {
        c = u;
        let d = 0;
        for (const g in o)
          d += this.matrix[g][u] * o[g], o[g] = 0;
        isNumber$3(a[u]) && (d += a[u]);
        const p = Math.trunc(d);
        r[u] = p, o[u] = (d * 1e3 - p * 1e3) / 1e3;
      } else
        isNumber$3(a[u]) && (o[u] = a[u]);
    for (const u in o)
      o[u] !== 0 && (r[c] += u === c ? o[u] : o[u] / this.matrix[c][u]);
    return normalizeValues(this.matrix, r), clone$1(this, { values: r }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid)
      return this;
    const e = {};
    for (const r of Object.keys(this.values))
      e[r] = this.values[r] === 0 ? 0 : -this.values[r];
    return clone$1(this, { values: e }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(e) {
    if (!this.isValid || !e.isValid || !this.loc.equals(e.loc))
      return !1;
    function r(o, a) {
      return o === void 0 || o === 0 ? a === void 0 || a === 0 : o === a;
    }
    for (const o of orderedUnits$1)
      if (!r(this.values[o], e.values[o]))
        return !1;
    return !0;
  }
}
const INVALID$1 = "Invalid Interval";
function validateStartEnd(t, e) {
  return !t || !t.isValid ? Interval.invalid("missing or invalid start") : !e || !e.isValid ? Interval.invalid("missing or invalid end") : e < t ? Interval.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${t.toISO()} and end=${e.toISO()}`
  ) : null;
}
class Interval {
  /**
   * @private
   */
  constructor(e) {
    this.s = e.start, this.e = e.end, this.invalid = e.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(e, r = null) {
    if (!e)
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    const o = e instanceof Invalid ? e : new Invalid(e, r);
    if (Settings.throwOnInvalid)
      throw new InvalidIntervalError(o);
    return new Interval({ invalid: o });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(e, r) {
    const o = friendlyDateTime(e), a = friendlyDateTime(r), c = validateStartEnd(o, a);
    return c ?? new Interval({
      start: o,
      end: a
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(e, r) {
    const o = Duration.fromDurationLike(r), a = friendlyDateTime(e);
    return Interval.fromDateTimes(a, a.plus(o));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(e, r) {
    const o = Duration.fromDurationLike(r), a = friendlyDateTime(e);
    return Interval.fromDateTimes(a.minus(o), a);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(e, r) {
    const [o, a] = (e || "").split("/", 2);
    if (o && a) {
      let c, u;
      try {
        c = DateTime.fromISO(o, r), u = c.isValid;
      } catch {
        u = !1;
      }
      let d, p;
      try {
        d = DateTime.fromISO(a, r), p = d.isValid;
      } catch {
        p = !1;
      }
      if (u && p)
        return Interval.fromDateTimes(c, d);
      if (u) {
        const g = Duration.fromISO(a, r);
        if (g.isValid)
          return Interval.after(c, g);
      } else if (p) {
        const g = Duration.fromISO(o, r);
        if (g.isValid)
          return Interval.before(d, g);
      }
    }
    return Interval.invalid("unparsable", `the input "${e}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(e) {
    return e && e.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(e = "milliseconds") {
    return this.isValid ? this.toDuration(e).get(e) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  count(e = "milliseconds") {
    if (!this.isValid)
      return NaN;
    const r = this.start.startOf(e), o = this.end.startOf(e);
    return Math.floor(o.diff(r, e).get(e)) + (o.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(e) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, e) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(e) {
    return this.isValid ? this.s > e : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(e) {
    return this.isValid ? this.e <= e : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(e) {
    return this.isValid ? this.s <= e && this.e > e : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: e, end: r } = {}) {
    return this.isValid ? Interval.fromDateTimes(e || this.s, r || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...e) {
    if (!this.isValid)
      return [];
    const r = e.map(friendlyDateTime).filter((u) => this.contains(u)).sort(), o = [];
    let { s: a } = this, c = 0;
    for (; a < this.e; ) {
      const u = r[c] || this.e, d = +u > +this.e ? this.e : u;
      o.push(Interval.fromDateTimes(a, d)), a = d, c += 1;
    }
    return o;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(e) {
    const r = Duration.fromDurationLike(e);
    if (!this.isValid || !r.isValid || r.as("milliseconds") === 0)
      return [];
    let { s: o } = this, a = 1, c;
    const u = [];
    for (; o < this.e; ) {
      const d = this.start.plus(r.mapUnits((p) => p * a));
      c = +d > +this.e ? this.e : d, u.push(Interval.fromDateTimes(o, c)), o = c, a += 1;
    }
    return u;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(e) {
    return this.isValid ? this.splitBy(this.length() / e).slice(0, e) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(e) {
    return this.e > e.s && this.s < e.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(e) {
    return this.isValid ? +this.e == +e.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(e) {
    return this.isValid ? +e.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(e) {
    return this.isValid ? this.s <= e.s && this.e >= e.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(e) {
    return !this.isValid || !e.isValid ? !1 : this.s.equals(e.s) && this.e.equals(e.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(e) {
    if (!this.isValid)
      return this;
    const r = this.s > e.s ? this.s : e.s, o = this.e < e.e ? this.e : e.e;
    return r >= o ? null : Interval.fromDateTimes(r, o);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(e) {
    if (!this.isValid)
      return this;
    const r = this.s < e.s ? this.s : e.s, o = this.e > e.e ? this.e : e.e;
    return Interval.fromDateTimes(r, o);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(e) {
    const [r, o] = e.sort((a, c) => a.s - c.s).reduce(
      ([a, c], u) => c ? c.overlaps(u) || c.abutsStart(u) ? [a, c.union(u)] : [a.concat([c]), u] : [a, u],
      [[], null]
    );
    return o && r.push(o), r;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(e) {
    let r = null, o = 0;
    const a = [], c = e.map((p) => [
      { time: p.s, type: "s" },
      { time: p.e, type: "e" }
    ]), u = Array.prototype.concat(...c), d = u.sort((p, g) => p.time - g.time);
    for (const p of d)
      o += p.type === "s" ? 1 : -1, o === 1 ? r = p.time : (r && +r != +p.time && a.push(Interval.fromDateTimes(r, p.time)), r = null);
    return Interval.merge(a);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...e) {
    return Interval.xor([this].concat(e)).map((r) => this.intersection(r)).filter((r) => r && !r.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : INVALID$1;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(e = DATE_SHORT, r = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(r), e).formatInterval(this) : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(e) {
    return this.isValid ? `${this.s.toISO(e)}/${this.e.toISO(e)}` : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : INVALID$1;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(e) {
    return this.isValid ? `${this.s.toISOTime(e)}/${this.e.toISOTime(e)}` : INVALID$1;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(e, { separator: r = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(e)}${r}${this.e.toFormat(e)}` : INVALID$1;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(e, r) {
    return this.isValid ? this.e.diff(this.s, e, r) : Duration.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(e) {
    return Interval.fromDateTimes(e(this.s), e(this.e));
  }
}
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(e = Settings.defaultZone) {
    const r = DateTime.now().setZone(e).set({ month: 12 });
    return !e.isUniversal && r.offset !== r.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(e) {
    return IANAZone.isValidZone(e);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(e) {
    return normalizeZone(e, Settings.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(e = "long", { locale: r = null, numberingSystem: o = null, locObj: a = null, outputCalendar: c = "gregory" } = {}) {
    return (a || Locale.create(r, o, c)).months(e);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(e = "long", { locale: r = null, numberingSystem: o = null, locObj: a = null, outputCalendar: c = "gregory" } = {}) {
    return (a || Locale.create(r, o, c)).months(e, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(e = "long", { locale: r = null, numberingSystem: o = null, locObj: a = null } = {}) {
    return (a || Locale.create(r, o, null)).weekdays(e);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(e = "long", { locale: r = null, numberingSystem: o = null, locObj: a = null } = {}) {
    return (a || Locale.create(r, o, null)).weekdays(e, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: e = null } = {}) {
    return Locale.create(e).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(e = "short", { locale: r = null } = {}) {
    return Locale.create(r, null, "gregory").eras(e);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */
  static features() {
    return { relative: hasRelative() };
  }
}
function dayDiff(t, e) {
  const r = (a) => a.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), o = r(e) - r(t);
  return Math.floor(Duration.fromMillis(o).as("days"));
}
function highOrderDiffs(t, e, r) {
  const o = [
    ["years", (p, g) => g.year - p.year],
    ["quarters", (p, g) => g.quarter - p.quarter + (g.year - p.year) * 4],
    ["months", (p, g) => g.month - p.month + (g.year - p.year) * 12],
    [
      "weeks",
      (p, g) => {
        const b = dayDiff(p, g);
        return (b - b % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ], a = {}, c = t;
  let u, d;
  for (const [p, g] of o)
    r.indexOf(p) >= 0 && (u = p, a[p] = g(t, e), d = c.plus(a), d > e ? (a[p]--, t = c.plus(a), t > e && (d = t, a[p]--, t = c.plus(a))) : t = d);
  return [t, a, d, u];
}
function diff(t, e, r, o) {
  let [a, c, u, d] = highOrderDiffs(t, e, r);
  const p = e - a, g = r.filter(
    (x) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(x) >= 0
  );
  g.length === 0 && (u < e && (u = a.plus({ [d]: 1 })), u !== a && (c[d] = (c[d] || 0) + p / (u - a)));
  const b = Duration.fromObject(c, o);
  return g.length > 0 ? Duration.fromMillis(p, o).shiftTo(...g).plus(b) : b;
}
const numberingSystems = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(t) {
  let e = parseInt(t, 10);
  if (isNaN(e)) {
    e = "";
    for (let r = 0; r < t.length; r++) {
      const o = t.charCodeAt(r);
      if (t[r].search(numberingSystems.hanidec) !== -1)
        e += hanidecChars.indexOf(t[r]);
      else
        for (const a in numberingSystemsUTF16) {
          const [c, u] = numberingSystemsUTF16[a];
          o >= c && o <= u && (e += o - c);
        }
    }
    return parseInt(e, 10);
  } else
    return e;
}
function digitRegex({ numberingSystem: t }, e = "") {
  return new RegExp(`${numberingSystems[t || "latn"]}${e}`);
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(t, e = (r) => r) {
  return { regex: t, deser: ([r]) => e(parseDigits(r)) };
}
const NBSP = String.fromCharCode(160), spaceOrNBSP = `[ ${NBSP}]`, spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(t) {
  return t.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(t) {
  return t.replace(/\./g, "").replace(spaceOrNBSPRegExp, " ").toLowerCase();
}
function oneOf(t, e) {
  return t === null ? null : {
    regex: RegExp(t.map(fixListRegex).join("|")),
    deser: ([r]) => t.findIndex((o) => stripInsensitivities(r) === stripInsensitivities(o)) + e
  };
}
function offset(t, e) {
  return { regex: t, deser: ([, r, o]) => signedOffset(r, o), groups: e };
}
function simple(t) {
  return { regex: t, deser: ([e]) => e };
}
function escapeToken(t) {
  return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(t, e) {
  const r = digitRegex(e), o = digitRegex(e, "{2}"), a = digitRegex(e, "{3}"), c = digitRegex(e, "{4}"), u = digitRegex(e, "{6}"), d = digitRegex(e, "{1,2}"), p = digitRegex(e, "{1,3}"), g = digitRegex(e, "{1,6}"), b = digitRegex(e, "{1,9}"), x = digitRegex(e, "{2,4}"), w = digitRegex(e, "{4,6}"), y = (T) => ({ regex: RegExp(escapeToken(T.val)), deser: ([C]) => C, literal: !0 }), E = ((T) => {
    if (t.literal)
      return y(T);
    switch (T.val) {
      case "G":
        return oneOf(e.eras("short"), 0);
      case "GG":
        return oneOf(e.eras("long"), 0);
      case "y":
        return intUnit(g);
      case "yy":
        return intUnit(x, untruncateYear);
      case "yyyy":
        return intUnit(c);
      case "yyyyy":
        return intUnit(w);
      case "yyyyyy":
        return intUnit(u);
      case "M":
        return intUnit(d);
      case "MM":
        return intUnit(o);
      case "MMM":
        return oneOf(e.months("short", !0), 1);
      case "MMMM":
        return oneOf(e.months("long", !0), 1);
      case "L":
        return intUnit(d);
      case "LL":
        return intUnit(o);
      case "LLL":
        return oneOf(e.months("short", !1), 1);
      case "LLLL":
        return oneOf(e.months("long", !1), 1);
      case "d":
        return intUnit(d);
      case "dd":
        return intUnit(o);
      case "o":
        return intUnit(p);
      case "ooo":
        return intUnit(a);
      case "HH":
        return intUnit(o);
      case "H":
        return intUnit(d);
      case "hh":
        return intUnit(o);
      case "h":
        return intUnit(d);
      case "mm":
        return intUnit(o);
      case "m":
        return intUnit(d);
      case "q":
        return intUnit(d);
      case "qq":
        return intUnit(o);
      case "s":
        return intUnit(d);
      case "ss":
        return intUnit(o);
      case "S":
        return intUnit(p);
      case "SSS":
        return intUnit(a);
      case "u":
        return simple(b);
      case "uu":
        return simple(d);
      case "uuu":
        return intUnit(r);
      case "a":
        return oneOf(e.meridiems(), 0);
      case "kkkk":
        return intUnit(c);
      case "kk":
        return intUnit(x, untruncateYear);
      case "W":
        return intUnit(d);
      case "WW":
        return intUnit(o);
      case "E":
      case "c":
        return intUnit(r);
      case "EEE":
        return oneOf(e.weekdays("short", !1), 1);
      case "EEEE":
        return oneOf(e.weekdays("long", !1), 1);
      case "ccc":
        return oneOf(e.weekdays("short", !0), 1);
      case "cccc":
        return oneOf(e.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return offset(new RegExp(`([+-]${d.source})(?::(${o.source}))?`), 2);
      case "ZZZ":
        return offset(new RegExp(`([+-]${d.source})(${o.source})?`), 2);
      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);
      case " ":
        return simple(/[^\S\n\r]/);
      default:
        return y(T);
    }
  })(t) || {
    invalidReason: MISSING_FTP
  };
  return E.token = t, E;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(t, e, r) {
  const { type: o, value: a } = t;
  if (o === "literal") {
    const p = /^\s+$/.test(a);
    return {
      literal: !p,
      val: p ? " " : a
    };
  }
  const c = e[o];
  let u = o;
  o === "hour" && (e.hour12 != null ? u = e.hour12 ? "hour12" : "hour24" : e.hourCycle != null ? e.hourCycle === "h11" || e.hourCycle === "h12" ? u = "hour12" : u = "hour24" : u = r.hour12 ? "hour12" : "hour24");
  let d = partTypeStyleToTokenVal[u];
  if (typeof d == "object" && (d = d[c]), d)
    return {
      literal: !1,
      val: d
    };
}
function buildRegex(t) {
  return [`^${t.map((r) => r.regex).reduce((r, o) => `${r}(${o.source})`, "")}$`, t];
}
function match(t, e, r) {
  const o = t.match(e);
  if (o) {
    const a = {};
    let c = 1;
    for (const u in r)
      if (hasOwnProperty$1(r, u)) {
        const d = r[u], p = d.groups ? d.groups + 1 : 1;
        !d.literal && d.token && (a[d.token.val[0]] = d.deser(o.slice(c, c + p))), c += p;
      }
    return [o, a];
  } else
    return [o, {}];
}
function dateTimeFromMatches(t) {
  const e = (c) => {
    switch (c) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let r = null, o;
  return isUndefined$1(t.z) || (r = IANAZone.create(t.z)), isUndefined$1(t.Z) || (r || (r = new FixedOffsetZone(t.Z)), o = t.Z), isUndefined$1(t.q) || (t.M = (t.q - 1) * 3 + 1), isUndefined$1(t.h) || (t.h < 12 && t.a === 1 ? t.h += 12 : t.h === 12 && t.a === 0 && (t.h = 0)), t.G === 0 && t.y && (t.y = -t.y), isUndefined$1(t.u) || (t.S = parseMillis(t.u)), [Object.keys(t).reduce((c, u) => {
    const d = e(u);
    return d && (c[d] = t[u]), c;
  }, {}), r, o];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  return dummyDateTimeCache || (dummyDateTimeCache = DateTime.fromMillis(1555555555555)), dummyDateTimeCache;
}
function maybeExpandMacroToken(t, e) {
  if (t.literal)
    return t;
  const r = Formatter.macroTokenToFormatOpts(t.val), o = formatOptsToTokens(r, e);
  return o == null || o.includes(void 0) ? t : o;
}
function expandMacroTokens(t, e) {
  return Array.prototype.concat(...t.map((r) => maybeExpandMacroToken(r, e)));
}
function explainFromTokens(t, e, r) {
  const o = expandMacroTokens(Formatter.parseFormat(r), t), a = o.map((u) => unitForToken(u, t)), c = a.find((u) => u.invalidReason);
  if (c)
    return { input: e, tokens: o, invalidReason: c.invalidReason };
  {
    const [u, d] = buildRegex(a), p = RegExp(u, "i"), [g, b] = match(e, p, d), [x, w, y] = b ? dateTimeFromMatches(b) : [null, null, void 0];
    if (hasOwnProperty$1(b, "a") && hasOwnProperty$1(b, "H"))
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: e, tokens: o, regex: p, rawMatches: g, matches: b, result: x, zone: w, specificOffset: y };
  }
}
function parseFromTokens(t, e, r) {
  const { result: o, zone: a, specificOffset: c, invalidReason: u } = explainFromTokens(t, e, r);
  return [o, a, c, u];
}
function formatOptsToTokens(t, e) {
  if (!t)
    return null;
  const o = Formatter.create(e, t).dtFormatter(getDummyDateTime()), a = o.formatToParts(), c = o.resolvedOptions();
  return a.map((u) => tokenForPart(u, t, c));
}
const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(t, e) {
  return new Invalid(
    "unit out of range",
    `you specified ${e} (of type ${typeof e}) as a ${t}, which is invalid`
  );
}
function dayOfWeek(t, e, r) {
  const o = new Date(Date.UTC(t, e - 1, r));
  t < 100 && t >= 0 && o.setUTCFullYear(o.getUTCFullYear() - 1900);
  const a = o.getUTCDay();
  return a === 0 ? 7 : a;
}
function computeOrdinal(t, e, r) {
  return r + (isLeapYear(t) ? leapLadder : nonLeapLadder)[e - 1];
}
function uncomputeOrdinal(t, e) {
  const r = isLeapYear(t) ? leapLadder : nonLeapLadder, o = r.findIndex((c) => c < e), a = e - r[o];
  return { month: o + 1, day: a };
}
function gregorianToWeek(t) {
  const { year: e, month: r, day: o } = t, a = computeOrdinal(e, r, o), c = dayOfWeek(e, r, o);
  let u = Math.floor((a - c + 10) / 7), d;
  return u < 1 ? (d = e - 1, u = weeksInWeekYear(d)) : u > weeksInWeekYear(e) ? (d = e + 1, u = 1) : d = e, { weekYear: d, weekNumber: u, weekday: c, ...timeObject(t) };
}
function weekToGregorian(t) {
  const { weekYear: e, weekNumber: r, weekday: o } = t, a = dayOfWeek(e, 1, 4), c = daysInYear(e);
  let u = r * 7 + o - a - 3, d;
  u < 1 ? (d = e - 1, u += daysInYear(d)) : u > c ? (d = e + 1, u -= daysInYear(e)) : d = e;
  const { month: p, day: g } = uncomputeOrdinal(d, u);
  return { year: d, month: p, day: g, ...timeObject(t) };
}
function gregorianToOrdinal(t) {
  const { year: e, month: r, day: o } = t, a = computeOrdinal(e, r, o);
  return { year: e, ordinal: a, ...timeObject(t) };
}
function ordinalToGregorian(t) {
  const { year: e, ordinal: r } = t, { month: o, day: a } = uncomputeOrdinal(e, r);
  return { year: e, month: o, day: a, ...timeObject(t) };
}
function hasInvalidWeekData(t) {
  const e = isInteger(t.weekYear), r = integerBetween(t.weekNumber, 1, weeksInWeekYear(t.weekYear)), o = integerBetween(t.weekday, 1, 7);
  return e ? r ? o ? !1 : unitOutOfRange("weekday", t.weekday) : unitOutOfRange("week", t.week) : unitOutOfRange("weekYear", t.weekYear);
}
function hasInvalidOrdinalData(t) {
  const e = isInteger(t.year), r = integerBetween(t.ordinal, 1, daysInYear(t.year));
  return e ? r ? !1 : unitOutOfRange("ordinal", t.ordinal) : unitOutOfRange("year", t.year);
}
function hasInvalidGregorianData(t) {
  const e = isInteger(t.year), r = integerBetween(t.month, 1, 12), o = integerBetween(t.day, 1, daysInMonth(t.year, t.month));
  return e ? r ? o ? !1 : unitOutOfRange("day", t.day) : unitOutOfRange("month", t.month) : unitOutOfRange("year", t.year);
}
function hasInvalidTimeData(t) {
  const { hour: e, minute: r, second: o, millisecond: a } = t, c = integerBetween(e, 0, 23) || e === 24 && r === 0 && o === 0 && a === 0, u = integerBetween(r, 0, 59), d = integerBetween(o, 0, 59), p = integerBetween(a, 0, 999);
  return c ? u ? d ? p ? !1 : unitOutOfRange("millisecond", a) : unitOutOfRange("second", o) : unitOutOfRange("minute", r) : unitOutOfRange("hour", e);
}
const INVALID = "Invalid DateTime", MAX_DATE = 864e13;
function unsupportedZone(t) {
  return new Invalid("unsupported zone", `the zone "${t.name}" is not supported`);
}
function possiblyCachedWeekData(t) {
  return t.weekData === null && (t.weekData = gregorianToWeek(t.c)), t.weekData;
}
function clone(t, e) {
  const r = {
    ts: t.ts,
    zone: t.zone,
    c: t.c,
    o: t.o,
    loc: t.loc,
    invalid: t.invalid
  };
  return new DateTime({ ...r, ...e, old: r });
}
function fixOffset(t, e, r) {
  let o = t - e * 60 * 1e3;
  const a = r.offset(o);
  if (e === a)
    return [o, e];
  o -= (a - e) * 60 * 1e3;
  const c = r.offset(o);
  return a === c ? [o, a] : [t - Math.min(a, c) * 60 * 1e3, Math.max(a, c)];
}
function tsToObj(t, e) {
  t += e * 60 * 1e3;
  const r = new Date(t);
  return {
    year: r.getUTCFullYear(),
    month: r.getUTCMonth() + 1,
    day: r.getUTCDate(),
    hour: r.getUTCHours(),
    minute: r.getUTCMinutes(),
    second: r.getUTCSeconds(),
    millisecond: r.getUTCMilliseconds()
  };
}
function objToTS(t, e, r) {
  return fixOffset(objToLocalTS(t), e, r);
}
function adjustTime(t, e) {
  const r = t.o, o = t.c.year + Math.trunc(e.years), a = t.c.month + Math.trunc(e.months) + Math.trunc(e.quarters) * 3, c = {
    ...t.c,
    year: o,
    month: a,
    day: Math.min(t.c.day, daysInMonth(o, a)) + Math.trunc(e.days) + Math.trunc(e.weeks) * 7
  }, u = Duration.fromObject({
    years: e.years - Math.trunc(e.years),
    quarters: e.quarters - Math.trunc(e.quarters),
    months: e.months - Math.trunc(e.months),
    weeks: e.weeks - Math.trunc(e.weeks),
    days: e.days - Math.trunc(e.days),
    hours: e.hours,
    minutes: e.minutes,
    seconds: e.seconds,
    milliseconds: e.milliseconds
  }).as("milliseconds"), d = objToLocalTS(c);
  let [p, g] = fixOffset(d, r, t.zone);
  return u !== 0 && (p += u, g = t.zone.offset(p)), { ts: p, o: g };
}
function parseDataToDateTime(t, e, r, o, a, c) {
  const { setZone: u, zone: d } = r;
  if (t && Object.keys(t).length !== 0 || e) {
    const p = e || d, g = DateTime.fromObject(t, {
      ...r,
      zone: p,
      specificOffset: c
    });
    return u ? g : g.setZone(d);
  } else
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${a}" can't be parsed as ${o}`)
    );
}
function toTechFormat(t, e, r = !0) {
  return t.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: r,
    forceSimple: !0
  }).formatDateTimeFromString(t, e) : null;
}
function toISODate(t, e) {
  const r = t.c.year > 9999 || t.c.year < 0;
  let o = "";
  return r && t.c.year >= 0 && (o += "+"), o += padStart(t.c.year, r ? 6 : 4), e ? (o += "-", o += padStart(t.c.month), o += "-", o += padStart(t.c.day)) : (o += padStart(t.c.month), o += padStart(t.c.day)), o;
}
function toISOTime(t, e, r, o, a, c) {
  let u = padStart(t.c.hour);
  return e ? (u += ":", u += padStart(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !r) && (u += ":")) : u += padStart(t.c.minute), (t.c.millisecond !== 0 || t.c.second !== 0 || !r) && (u += padStart(t.c.second), (t.c.millisecond !== 0 || !o) && (u += ".", u += padStart(t.c.millisecond, 3))), a && (t.isOffsetFixed && t.offset === 0 && !c ? u += "Z" : t.o < 0 ? (u += "-", u += padStart(Math.trunc(-t.o / 60)), u += ":", u += padStart(Math.trunc(-t.o % 60))) : (u += "+", u += padStart(Math.trunc(t.o / 60)), u += ":", u += padStart(Math.trunc(t.o % 60)))), c && (u += "[" + t.zone.ianaName + "]"), u;
}
const defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"], orderedWeekUnits = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(t) {
  const e = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[t.toLowerCase()];
  if (!e)
    throw new InvalidUnitError(t);
  return e;
}
function quickDT(t, e) {
  const r = normalizeZone(e.zone, Settings.defaultZone), o = Locale.fromObject(e), a = Settings.now();
  let c, u;
  if (isUndefined$1(t.year))
    c = a;
  else {
    for (const g of orderedUnits)
      isUndefined$1(t[g]) && (t[g] = defaultUnitValues[g]);
    const d = hasInvalidGregorianData(t) || hasInvalidTimeData(t);
    if (d)
      return DateTime.invalid(d);
    const p = r.offset(a);
    [c, u] = objToTS(t, p, r);
  }
  return new DateTime({ ts: c, zone: r, loc: o, o: u });
}
function diffRelative(t, e, r) {
  const o = isUndefined$1(r.round) ? !0 : r.round, a = (u, d) => (u = roundTo(u, o || r.calendary ? 0 : 2, !0), e.loc.clone(r).relFormatter(r).format(u, d)), c = (u) => r.calendary ? e.hasSame(t, u) ? 0 : e.startOf(u).diff(t.startOf(u), u).get(u) : e.diff(t, u).get(u);
  if (r.unit)
    return a(c(r.unit), r.unit);
  for (const u of r.units) {
    const d = c(u);
    if (Math.abs(d) >= 1)
      return a(d, u);
  }
  return a(t > e ? -0 : 0, r.units[r.units.length - 1]);
}
function lastOpts(t) {
  let e = {}, r;
  return t.length > 0 && typeof t[t.length - 1] == "object" ? (e = t[t.length - 1], r = Array.from(t).slice(0, t.length - 1)) : r = Array.from(t), [e, r];
}
class DateTime {
  /**
   * @access private
   */
  constructor(e) {
    const r = e.zone || Settings.defaultZone;
    let o = e.invalid || (Number.isNaN(e.ts) ? new Invalid("invalid input") : null) || (r.isValid ? null : unsupportedZone(r));
    this.ts = isUndefined$1(e.ts) ? Settings.now() : e.ts;
    let a = null, c = null;
    if (!o)
      if (e.old && e.old.ts === this.ts && e.old.zone.equals(r))
        [a, c] = [e.old.c, e.old.o];
      else {
        const d = r.offset(this.ts);
        a = tsToObj(this.ts, d), o = Number.isNaN(a.year) ? new Invalid("invalid input") : null, a = o ? null : a, c = o ? null : d;
      }
    this._zone = r, this.loc = e.loc || Locale.create(), this.invalid = o, this.weekData = null, this.c = a, this.o = c, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [e, r] = lastOpts(arguments), [o, a, c, u, d, p, g] = r;
    return quickDT({ year: o, month: a, day: c, hour: u, minute: d, second: p, millisecond: g }, e);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [e, r] = lastOpts(arguments), [o, a, c, u, d, p, g] = r;
    return e.zone = FixedOffsetZone.utcInstance, quickDT({ year: o, month: a, day: c, hour: u, minute: d, second: p, millisecond: g }, e);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(e, r = {}) {
    const o = isDate$3(e) ? e.valueOf() : NaN;
    if (Number.isNaN(o))
      return DateTime.invalid("invalid input");
    const a = normalizeZone(r.zone, Settings.defaultZone);
    return a.isValid ? new DateTime({
      ts: o,
      zone: a,
      loc: Locale.fromObject(r)
    }) : DateTime.invalid(unsupportedZone(a));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(e, r = {}) {
    if (isNumber$3(e))
      return e < -MAX_DATE || e > MAX_DATE ? DateTime.invalid("Timestamp out of range") : new DateTime({
        ts: e,
        zone: normalizeZone(r.zone, Settings.defaultZone),
        loc: Locale.fromObject(r)
      });
    throw new InvalidArgumentError(
      `fromMillis requires a numerical input, but received a ${typeof e} with value ${e}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(e, r = {}) {
    if (isNumber$3(e))
      return new DateTime({
        ts: e * 1e3,
        zone: normalizeZone(r.zone, Settings.defaultZone),
        loc: Locale.fromObject(r)
      });
    throw new InvalidArgumentError("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  static fromObject(e, r = {}) {
    e = e || {};
    const o = normalizeZone(r.zone, Settings.defaultZone);
    if (!o.isValid)
      return DateTime.invalid(unsupportedZone(o));
    const a = Settings.now(), c = isUndefined$1(r.specificOffset) ? o.offset(a) : r.specificOffset, u = normalizeObject(e, normalizeUnit), d = !isUndefined$1(u.ordinal), p = !isUndefined$1(u.year), g = !isUndefined$1(u.month) || !isUndefined$1(u.day), b = p || g, x = u.weekYear || u.weekNumber, w = Locale.fromObject(r);
    if ((b || d) && x)
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (g && d)
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    const y = x || u.weekday && !b;
    let I, E, T = tsToObj(a, c);
    y ? (I = orderedWeekUnits, E = defaultWeekUnitValues, T = gregorianToWeek(T)) : d ? (I = orderedOrdinalUnits, E = defaultOrdinalUnitValues, T = gregorianToOrdinal(T)) : (I = orderedUnits, E = defaultUnitValues);
    let C = !1;
    for (const z of I) {
      const W = u[z];
      isUndefined$1(W) ? C ? u[z] = E[z] : u[z] = T[z] : C = !0;
    }
    const $ = y ? hasInvalidWeekData(u) : d ? hasInvalidOrdinalData(u) : hasInvalidGregorianData(u), D = $ || hasInvalidTimeData(u);
    if (D)
      return DateTime.invalid(D);
    const L = y ? weekToGregorian(u) : d ? ordinalToGregorian(u) : u, [R, O] = objToTS(L, c, o), P = new DateTime({
      ts: R,
      zone: o,
      o: O,
      loc: w
    });
    return u.weekday && b && e.weekday !== P.weekday ? DateTime.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${u.weekday} and a date of ${P.toISO()}`
    ) : P;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(e, r = {}) {
    const [o, a] = parseISODate(e);
    return parseDataToDateTime(o, a, r, "ISO 8601", e);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(e, r = {}) {
    const [o, a] = parseRFC2822Date(e);
    return parseDataToDateTime(o, a, r, "RFC 2822", e);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(e, r = {}) {
    const [o, a] = parseHTTPDate(e);
    return parseDataToDateTime(o, a, r, "HTTP", r);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(e, r, o = {}) {
    if (isUndefined$1(e) || isUndefined$1(r))
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    const { locale: a = null, numberingSystem: c = null } = o, u = Locale.fromOpts({
      locale: a,
      numberingSystem: c,
      defaultToEN: !0
    }), [d, p, g, b] = parseFromTokens(u, e, r);
    return b ? DateTime.invalid(b) : parseDataToDateTime(d, p, o, `format ${r}`, e, g);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(e, r, o = {}) {
    return DateTime.fromFormat(e, r, o);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(e, r = {}) {
    const [o, a] = parseSQL(e);
    return parseDataToDateTime(o, a, r, "SQL", e);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(e, r = null) {
    if (!e)
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    const o = e instanceof Invalid ? e : new Invalid(e, r);
    if (Settings.throwOnInvalid)
      throw new InvalidDateTimeError(o);
    return new DateTime({ invalid: o });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(e) {
    return e && e.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(e, r = {}) {
    const o = formatOptsToTokens(e, Locale.fromObject(r));
    return o ? o.map((a) => a ? a.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(e, r = {}) {
    return expandMacroTokens(Formatter.parseFormat(e), Locale.fromObject(r)).map((a) => a.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(e) {
    return this[e];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const e = 864e5, r = 6e4, o = objToLocalTS(this.c), a = this.zone.offset(o - e), c = this.zone.offset(o + e), u = this.zone.offset(o - a * r), d = this.zone.offset(o - c * r);
    if (u === d)
      return [this];
    const p = o - u * r, g = o - d * r, b = tsToObj(p, u), x = tsToObj(g, d);
    return b.hour === x.hour && b.minute === x.minute && b.second === x.second && b.millisecond === x.millisecond ? [clone(this, { ts: p }), clone(this, { ts: g })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(e = {}) {
    const { locale: r, numberingSystem: o, calendar: a } = Formatter.create(
      this.loc.clone(e),
      e
    ).resolvedOptions(this);
    return { locale: r, numberingSystem: o, outputCalendar: a };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(e = 0, r = {}) {
    return this.setZone(FixedOffsetZone.instance(e), r);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(e, { keepLocalTime: r = !1, keepCalendarTime: o = !1 } = {}) {
    if (e = normalizeZone(e, Settings.defaultZone), e.equals(this.zone))
      return this;
    if (e.isValid) {
      let a = this.ts;
      if (r || o) {
        const c = e.offset(this.ts), u = this.toObject();
        [a] = objToTS(u, c, e);
      }
      return clone(this, { ts: a, zone: e });
    } else
      return DateTime.invalid(unsupportedZone(e));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: e, numberingSystem: r, outputCalendar: o } = {}) {
    const a = this.loc.clone({ locale: e, numberingSystem: r, outputCalendar: o });
    return clone(this, { loc: a });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(e) {
    return this.reconfigure({ locale: e });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(e) {
    if (!this.isValid)
      return this;
    const r = normalizeObject(e, normalizeUnit), o = !isUndefined$1(r.weekYear) || !isUndefined$1(r.weekNumber) || !isUndefined$1(r.weekday), a = !isUndefined$1(r.ordinal), c = !isUndefined$1(r.year), u = !isUndefined$1(r.month) || !isUndefined$1(r.day), d = c || u, p = r.weekYear || r.weekNumber;
    if ((d || a) && p)
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (u && a)
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    let g;
    o ? g = weekToGregorian({ ...gregorianToWeek(this.c), ...r }) : isUndefined$1(r.ordinal) ? (g = { ...this.toObject(), ...r }, isUndefined$1(r.day) && (g.day = Math.min(daysInMonth(g.year, g.month), g.day))) : g = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...r });
    const [b, x] = objToTS(g, this.o, this.zone);
    return clone(this, { ts: b, o: x });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(e) {
    if (!this.isValid)
      return this;
    const r = Duration.fromDurationLike(e);
    return clone(this, adjustTime(this, r));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(e) {
    if (!this.isValid)
      return this;
    const r = Duration.fromDurationLike(e).negate();
    return clone(this, adjustTime(this, r));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(e) {
    if (!this.isValid)
      return this;
    const r = {}, o = Duration.normalizeUnit(e);
    switch (o) {
      case "years":
        r.month = 1;
      case "quarters":
      case "months":
        r.day = 1;
      case "weeks":
      case "days":
        r.hour = 0;
      case "hours":
        r.minute = 0;
      case "minutes":
        r.second = 0;
      case "seconds":
        r.millisecond = 0;
        break;
    }
    if (o === "weeks" && (r.weekday = 1), o === "quarters") {
      const a = Math.ceil(this.month / 3);
      r.month = (a - 1) * 3 + 1;
    }
    return this.set(r);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(e) {
    return this.isValid ? this.plus({ [e]: 1 }).startOf(e).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(e, r = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(r)).formatDateTimeFromString(this, e) : INVALID;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(e = DATE_SHORT, r = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(r), e).formatDateTime(this) : INVALID;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(e = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(e), e).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: e = "extended",
    suppressSeconds: r = !1,
    suppressMilliseconds: o = !1,
    includeOffset: a = !0,
    extendedZone: c = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const u = e === "extended";
    let d = toISODate(this, u);
    return d += "T", d += toISOTime(this, u, r, o, a, c), d;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: e = "extended" } = {}) {
    return this.isValid ? toISODate(this, e === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: e = !1,
    suppressSeconds: r = !1,
    includeOffset: o = !0,
    includePrefix: a = !1,
    extendedZone: c = !1,
    format: u = "extended"
  } = {}) {
    return this.isValid ? (a ? "T" : "") + toISOTime(
      this,
      u === "extended",
      r,
      e,
      o,
      c
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? toISODate(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: e = !0, includeZone: r = !1, includeOffsetSpace: o = !0 } = {}) {
    let a = "HH:mm:ss.SSS";
    return (r || e) && (o && (a += " "), r ? a += "z" : e && (a += "ZZ")), toTechFormat(this, a, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(e = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(e)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(e = {}) {
    if (!this.isValid)
      return {};
    const r = { ...this.c };
    return e.includeConfig && (r.outputCalendar = this.outputCalendar, r.numberingSystem = this.loc.numberingSystem, r.locale = this.loc.locale), r;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(e, r = "milliseconds", o = {}) {
    if (!this.isValid || !e.isValid)
      return Duration.invalid("created by diffing an invalid DateTime");
    const a = { locale: this.locale, numberingSystem: this.numberingSystem, ...o }, c = maybeArray(r).map(Duration.normalizeUnit), u = e.valueOf() > this.valueOf(), d = u ? this : e, p = u ? e : this, g = diff(d, p, c, a);
    return u ? g.negate() : g;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(e = "milliseconds", r = {}) {
    return this.diff(DateTime.now(), e, r);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(e) {
    return this.isValid ? Interval.fromDateTimes(this, e) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(e, r) {
    if (!this.isValid)
      return !1;
    const o = e.valueOf(), a = this.setZone(e.zone, { keepLocalTime: !0 });
    return a.startOf(r) <= o && o <= a.endOf(r);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(e) {
    return this.isValid && e.isValid && this.valueOf() === e.valueOf() && this.zone.equals(e.zone) && this.loc.equals(e.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(e = {}) {
    if (!this.isValid)
      return null;
    const r = e.base || DateTime.fromObject({}, { zone: this.zone }), o = e.padding ? this < r ? -e.padding : e.padding : 0;
    let a = ["years", "months", "days", "hours", "minutes", "seconds"], c = e.unit;
    return Array.isArray(e.unit) && (a = e.unit, c = void 0), diffRelative(r, this.plus(o), {
      ...e,
      numeric: "always",
      units: a,
      unit: c
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(e = {}) {
    return this.isValid ? diffRelative(e.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...e,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...e) {
    if (!e.every(DateTime.isDateTime))
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    return bestBy(e, (r) => r.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...e) {
    if (!e.every(DateTime.isDateTime))
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    return bestBy(e, (r) => r.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(e, r, o = {}) {
    const { locale: a = null, numberingSystem: c = null } = o, u = Locale.fromOpts({
      locale: a,
      numberingSystem: c,
      defaultToEN: !0
    });
    return explainFromTokens(u, e, r);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(e, r, o = {}) {
    return DateTime.fromFormatExplain(e, r, o);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(t) {
  if (DateTime.isDateTime(t))
    return t;
  if (t && t.valueOf && isNumber$3(t.valueOf()))
    return DateTime.fromJSDate(t);
  if (t && typeof t == "object")
    return DateTime.fromObject(t);
  throw new InvalidArgumentError(
    `Unknown datetime argument: ${t}, of type ${typeof t}`
  );
}
const useAuthStore = defineStore("userAuth", {
  state: () => ({
    token: {
      value: "",
      expiration: void 0
    },
    oms: ""
  }),
  getters: {
    getToken: (t) => t.token,
    getOms: (t) => t.oms,
    isAuthenticated: (t) => {
      let e = !1;
      if (t.token.expiration) {
        const r = DateTime.now().toMillis();
        e = t.token.expiration < r;
      }
      return t.token.value && !e;
    }
  },
  persist: !0
}), core = "", normalize$1 = "", structure = "", typography = "", padding = "", floatElements = "", textAlignment = "", textTransformation = "", flexUtils = "", display = "", BUILD = {
  allRenderFn: !1,
  cmpDidLoad: !0,
  cmpDidUnload: !1,
  cmpDidUpdate: !0,
  cmpDidRender: !0,
  cmpWillLoad: !0,
  cmpWillUpdate: !0,
  cmpWillRender: !0,
  connectedCallback: !0,
  disconnectedCallback: !0,
  element: !0,
  event: !0,
  hasRenderFn: !0,
  lifecycle: !0,
  hostListener: !0,
  hostListenerTargetWindow: !0,
  hostListenerTargetDocument: !0,
  hostListenerTargetBody: !0,
  hostListenerTargetParent: !1,
  hostListenerTarget: !0,
  member: !0,
  method: !0,
  mode: !0,
  observeAttribute: !0,
  prop: !0,
  propMutable: !0,
  reflect: !0,
  scoped: !0,
  shadowDom: !0,
  slot: !0,
  cssAnnotations: !0,
  state: !0,
  style: !0,
  formAssociated: !1,
  svg: !0,
  updatable: !0,
  vdomAttribute: !0,
  vdomXlink: !0,
  vdomClass: !0,
  vdomFunctional: !0,
  vdomKey: !0,
  vdomListener: !0,
  vdomRef: !0,
  vdomPropOrAttr: !0,
  vdomRender: !0,
  vdomStyle: !0,
  vdomText: !0,
  watchCallback: !0,
  taskQueue: !0,
  hotModuleReplacement: !1,
  isDebug: !1,
  isDev: !1,
  isTesting: !1,
  hydrateServerSide: !1,
  hydrateClientSide: !1,
  lifecycleDOMEvents: !1,
  lazyLoad: !1,
  profile: !1,
  slotRelocation: !0,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  appendChildSlotFix: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  cloneNodeFix: !1,
  hydratedAttribute: !1,
  hydratedClass: !0,
  scriptDataOpts: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  scopedSlotTextContentFix: !1,
  // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
  shadowDomShim: !1,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  slotChildNodesFix: !1,
  invisiblePrehydration: !0,
  propBoolean: !0,
  propNumber: !0,
  propString: !0,
  constructableCSS: !0,
  cmpShouldUpdate: !0,
  devTools: !1,
  shadowDelegatesFocus: !0,
  initializeNextTick: !1,
  asyncLoading: !1,
  asyncQueue: !1,
  transformTagName: !1,
  attachStyles: !0,
  // TODO(STENCIL-914): remove this option when `experimentalSlotFixes` is the default behavior
  experimentalSlotFixes: !1
};
let scopeId, contentRef, hostTagName, useNativeShadowDom = !1, checkSlotFallbackVisibility = !1, checkSlotRelocate = !1, isSvgMode = !1, renderingRef = null, queuePending = !1;
const Build = {
  isDev: !1,
  isBrowser: !0,
  isServer: !1,
  isTesting: !1
}, getAssetPath = (t) => {
  const e = new URL(t, plt.$resourcesUrl$);
  return e.origin !== win$2.location.origin ? e.href : e.pathname;
}, createTime = (t, e = "") => () => {
}, SLOT_FB_CSS = "slot-fb{display:contents}slot-fb[hidden]{display:none}", XLINK_NS = "http://www.w3.org/1999/xlink", EMPTY_OBJ = {}, SVG_NS = "http://www.w3.org/2000/svg", HTML_NS = "http://www.w3.org/1999/xhtml", isDef = (t) => t != null, isComplexType = (t) => (t = typeof t, t === "object" || t === "function");
function queryNonceMetaTagContent(t) {
  var e, r, o;
  return (o = (r = (e = t.head) === null || e === void 0 ? void 0 : e.querySelector('meta[name="csp-nonce"]')) === null || r === void 0 ? void 0 : r.getAttribute("content")) !== null && o !== void 0 ? o : void 0;
}
const h = (t, e, ...r) => {
  let o = null, a = null, c = null, u = !1, d = !1;
  const p = [], g = (x) => {
    for (let w = 0; w < x.length; w++)
      o = x[w], Array.isArray(o) ? g(o) : o != null && typeof o != "boolean" && ((u = typeof t != "function" && !isComplexType(o)) && (o = String(o)), u && d ? p[p.length - 1].$text$ += o : p.push(u ? newVNode(null, o) : o), d = u);
  };
  if (g(r), e) {
    e.key && (a = e.key), e.name && (c = e.name);
    {
      const x = e.className || e.class;
      x && (e.class = typeof x != "object" ? x : Object.keys(x).filter((w) => x[w]).join(" "));
    }
  }
  if (typeof t == "function")
    return t(e === null ? {} : e, p, vdomFnUtils);
  const b = newVNode(t, null);
  return b.$attrs$ = e, p.length > 0 && (b.$children$ = p), b.$key$ = a, b.$name$ = c, b;
}, newVNode = (t, e) => {
  const r = {
    $flags$: 0,
    $tag$: t,
    $text$: e,
    $elm$: null,
    $children$: null
  };
  return r.$attrs$ = null, r.$key$ = null, r.$name$ = null, r;
}, Host = {}, isHost = (t) => t && t.$tag$ === Host, vdomFnUtils = {
  forEach: (t, e) => t.map(convertToPublic).forEach(e),
  map: (t, e) => t.map(convertToPublic).map(e).map(convertToPrivate)
}, convertToPublic = (t) => ({
  vattrs: t.$attrs$,
  vchildren: t.$children$,
  vkey: t.$key$,
  vname: t.$name$,
  vtag: t.$tag$,
  vtext: t.$text$
}), convertToPrivate = (t) => {
  if (typeof t.vtag == "function") {
    const r = Object.assign({}, t.vattrs);
    return t.vkey && (r.key = t.vkey), t.vname && (r.name = t.vname), h(t.vtag, r, ...t.vchildren || []);
  }
  const e = newVNode(t.vtag, t.vtext);
  return e.$attrs$ = t.vattrs, e.$children$ = t.vchildren, e.$key$ = t.vkey, e.$name$ = t.vname, e;
}, computeMode = (t) => modeResolutionChain.map((e) => e(t)).find((e) => !!e), setMode = (t) => modeResolutionChain.push(t), getMode = (t) => getHostRef(t).$modeName$, parsePropertyValue = (t, e) => t != null && !isComplexType(t) ? e & 4 ? t === "false" ? !1 : t === "" || !!t : e & 2 ? parseFloat(t) : e & 1 ? String(t) : t : t, getElement = (t) => t, createEvent = (t, e, r) => {
  const o = getElement(t);
  return {
    emit: (a) => emitEvent(o, e, {
      bubbles: !!(r & 4),
      composed: !!(r & 2),
      cancelable: !!(r & 1),
      detail: a
    })
  };
}, emitEvent = (t, e, r) => {
  const o = plt.ce(e, r);
  return t.dispatchEvent(o), o;
}, rootAppliedStyles = /* @__PURE__ */ new WeakMap(), registerStyle = (t, e, r) => {
  let o = styles.get(t);
  supportsConstructableStylesheets && r ? (o = o || new CSSStyleSheet(), typeof o == "string" ? o = e : o.replaceSync(e)) : o = e, styles.set(t, o);
}, addStyle = (t, e, r) => {
  var o;
  const a = getScopeId(e, r), c = styles.get(a);
  if (t = t.nodeType === 11 ? t : doc$1, c)
    if (typeof c == "string") {
      t = t.head || t;
      let u = rootAppliedStyles.get(t), d;
      if (u || rootAppliedStyles.set(t, u = /* @__PURE__ */ new Set()), !u.has(a)) {
        {
          d = doc$1.createElement("style"), d.innerHTML = c;
          const p = (o = plt.$nonce$) !== null && o !== void 0 ? o : queryNonceMetaTagContent(doc$1);
          p != null && d.setAttribute("nonce", p), t.insertBefore(d, t.querySelector("link"));
        }
        e.$flags$ & 4 && (d.innerHTML += SLOT_FB_CSS), u && u.add(a);
      }
    } else
      t.adoptedStyleSheets.includes(c) || (t.adoptedStyleSheets = [...t.adoptedStyleSheets, c]);
  return a;
}, attachStyles = (t) => {
  const e = t.$cmpMeta$, r = t.$hostElement$, o = e.$flags$, a = createTime("attachStyles", e.$tagName$), c = addStyle(r.shadowRoot ? r.shadowRoot : r.getRootNode(), e, t.$modeName$);
  o & 10 && (r["s-sc"] = c, r.classList.add(c + "-h"), o & 2 && r.classList.add(c + "-s")), a();
}, getScopeId = (t, e) => "sc-" + (e && t.$flags$ & 32 ? t.$tagName$ + "-" + e : t.$tagName$), setAccessor = (t, e, r, o, a, c) => {
  if (r !== o) {
    let u = isMemberInElement(t, e), d = e.toLowerCase();
    if (e === "class") {
      const p = t.classList, g = parseClassList(r), b = parseClassList(o);
      p.remove(...g.filter((x) => x && !b.includes(x))), p.add(...b.filter((x) => x && !g.includes(x)));
    } else if (e === "style") {
      for (const p in r)
        (!o || o[p] == null) && (p.includes("-") ? t.style.removeProperty(p) : t.style[p] = "");
      for (const p in o)
        (!r || o[p] !== r[p]) && (p.includes("-") ? t.style.setProperty(p, o[p]) : t.style[p] = o[p]);
    } else if (e !== "key")
      if (e === "ref")
        o && o(t);
      else if (!t.__lookupSetter__(e) && e[0] === "o" && e[1] === "n") {
        if (e[2] === "-" ? e = e.slice(3) : isMemberInElement(win$2, d) ? e = d.slice(2) : e = d[2] + e.slice(3), r || o) {
          const p = e.endsWith(CAPTURE_EVENT_SUFFIX);
          e = e.replace(CAPTURE_EVENT_REGEX, ""), r && plt.rel(t, e, r, p), o && plt.ael(t, e, o, p);
        }
      } else {
        const p = isComplexType(o);
        if ((u || p && o !== null) && !a)
          try {
            if (t.tagName.includes("-"))
              t[e] = o;
            else {
              const b = o ?? "";
              e === "list" ? u = !1 : (r == null || t[e] != b) && (t[e] = b);
            }
          } catch {
          }
        let g = !1;
        d !== (d = d.replace(/^xlink\:?/, "")) && (e = d, g = !0), o == null || o === !1 ? (o !== !1 || t.getAttribute(e) === "") && (g ? t.removeAttributeNS(XLINK_NS, e) : t.removeAttribute(e)) : (!u || c & 4 || a) && !p && (o = o === !0 ? "" : o, g ? t.setAttributeNS(XLINK_NS, e, o) : t.setAttribute(e, o));
      }
  }
}, parseClassListRegex = /\s/, parseClassList = (t) => t ? t.split(parseClassListRegex) : [], CAPTURE_EVENT_SUFFIX = "Capture", CAPTURE_EVENT_REGEX = new RegExp(CAPTURE_EVENT_SUFFIX + "$"), updateElement = (t, e, r, o) => {
  const a = e.$elm$.nodeType === 11 && e.$elm$.host ? e.$elm$.host : e.$elm$, c = t && t.$attrs$ || EMPTY_OBJ, u = e.$attrs$ || EMPTY_OBJ;
  for (o in c)
    o in u || setAccessor(a, o, c[o], void 0, r, e.$flags$);
  for (o in u)
    setAccessor(a, o, c[o], u[o], r, e.$flags$);
}, createElm = (t, e, r, o) => {
  var a;
  const c = e.$children$[r];
  let u = 0, d, p, g;
  if (useNativeShadowDom || (checkSlotRelocate = !0, c.$tag$ === "slot" && (scopeId && o.classList.add(scopeId + "-s"), c.$flags$ |= c.$children$ ? (
    // slot element has fallback content
    2
  ) : (
    // slot element does not have fallback content
    1
  ))), c.$text$ !== null)
    d = c.$elm$ = doc$1.createTextNode(c.$text$);
  else if (c.$flags$ & 1)
    d = c.$elm$ = doc$1.createTextNode("");
  else {
    if (isSvgMode || (isSvgMode = c.$tag$ === "svg"), d = c.$elm$ = doc$1.createElementNS(isSvgMode ? SVG_NS : HTML_NS, c.$flags$ & 2 ? "slot-fb" : c.$tag$), isSvgMode && c.$tag$ === "foreignObject" && (isSvgMode = !1), updateElement(null, c, isSvgMode), isDef(scopeId) && d["s-si"] !== scopeId && d.classList.add(d["s-si"] = scopeId), c.$children$)
      for (u = 0; u < c.$children$.length; ++u)
        p = createElm(t, c, u, d), p && d.appendChild(p);
    c.$tag$ === "svg" ? isSvgMode = !1 : d.tagName === "foreignObject" && (isSvgMode = !0);
  }
  return d["s-hn"] = hostTagName, c.$flags$ & 3 && (d["s-sr"] = !0, d["s-fs"] = (a = c.$attrs$) === null || a === void 0 ? void 0 : a.slot, d["s-cr"] = contentRef, d["s-sn"] = c.$name$ || "", g = t && t.$children$ && t.$children$[r], g && g.$tag$ === c.$tag$ && t.$elm$ && putBackInOriginalLocation(t.$elm$, !1)), d;
}, putBackInOriginalLocation = (t, e) => {
  var r;
  plt.$flags$ |= 1;
  const o = t.childNodes;
  for (let a = o.length - 1; a >= 0; a--) {
    const c = o[a];
    c["s-hn"] !== hostTagName && c["s-ol"] && (parentReferenceNode(c).insertBefore(c, referenceNode(c)), c["s-ol"].remove(), c["s-ol"] = void 0, c["s-sh"] = void 0, c.nodeType === 1 && c.setAttribute("slot", (r = c["s-sn"]) !== null && r !== void 0 ? r : ""), checkSlotRelocate = !0), e && putBackInOriginalLocation(c, e);
  }
  plt.$flags$ &= -2;
}, addVnodes = (t, e, r, o, a, c) => {
  let u = t["s-cr"] && t["s-cr"].parentNode || t, d;
  for (u.shadowRoot && u.tagName === hostTagName && (u = u.shadowRoot); a <= c; ++a)
    o[a] && (d = createElm(null, r, a, t), d && (o[a].$elm$ = d, u.insertBefore(d, referenceNode(e))));
}, removeVnodes = (t, e, r) => {
  for (let o = e; o <= r; ++o) {
    const a = t[o];
    if (a) {
      const c = a.$elm$;
      nullifyVNodeRefs(a), c && (checkSlotFallbackVisibility = !0, c["s-ol"] ? c["s-ol"].remove() : putBackInOriginalLocation(c, !0), c.remove());
    }
  }
}, updateChildren = (t, e, r, o, a = !1) => {
  let c = 0, u = 0, d = 0, p = 0, g = e.length - 1, b = e[0], x = e[g], w = o.length - 1, y = o[0], I = o[w], E, T;
  for (; c <= g && u <= w; )
    if (b == null)
      b = e[++c];
    else if (x == null)
      x = e[--g];
    else if (y == null)
      y = o[++u];
    else if (I == null)
      I = o[--w];
    else if (isSameVnode(b, y, a))
      patch(b, y, a), b = e[++c], y = o[++u];
    else if (isSameVnode(x, I, a))
      patch(x, I, a), x = e[--g], I = o[--w];
    else if (isSameVnode(b, I, a))
      (b.$tag$ === "slot" || I.$tag$ === "slot") && putBackInOriginalLocation(b.$elm$.parentNode, !1), patch(b, I, a), t.insertBefore(b.$elm$, x.$elm$.nextSibling), b = e[++c], I = o[--w];
    else if (isSameVnode(x, y, a))
      (b.$tag$ === "slot" || I.$tag$ === "slot") && putBackInOriginalLocation(x.$elm$.parentNode, !1), patch(x, y, a), t.insertBefore(x.$elm$, b.$elm$), x = e[--g], y = o[++u];
    else {
      for (d = -1, p = c; p <= g; ++p)
        if (e[p] && e[p].$key$ !== null && e[p].$key$ === y.$key$) {
          d = p;
          break;
        }
      d >= 0 ? (T = e[d], T.$tag$ !== y.$tag$ ? E = createElm(e && e[u], r, d, t) : (patch(T, y, a), e[d] = void 0, E = T.$elm$), y = o[++u]) : (E = createElm(e && e[u], r, u, t), y = o[++u]), E && parentReferenceNode(b.$elm$).insertBefore(E, referenceNode(b.$elm$));
    }
  c > g ? addVnodes(t, o[w + 1] == null ? null : o[w + 1].$elm$, r, o, u, w) : u > w && removeVnodes(e, c, g);
}, isSameVnode = (t, e, r = !1) => t.$tag$ === e.$tag$ ? t.$tag$ === "slot" ? t.$name$ === e.$name$ : r ? !0 : t.$key$ === e.$key$ : !1, referenceNode = (t) => t && t["s-ol"] || t, parentReferenceNode = (t) => (t["s-ol"] ? t["s-ol"] : t).parentNode, patch = (t, e, r = !1) => {
  const o = e.$elm$ = t.$elm$, a = t.$children$, c = e.$children$, u = e.$tag$, d = e.$text$;
  let p;
  d === null ? (isSvgMode = u === "svg" ? !0 : u === "foreignObject" ? !1 : isSvgMode, u === "slot" || updateElement(t, e, isSvgMode), a !== null && c !== null ? updateChildren(o, a, e, c, r) : c !== null ? (t.$text$ !== null && (o.textContent = ""), addVnodes(o, null, e, c, 0, c.length - 1)) : a !== null && removeVnodes(a, 0, a.length - 1), isSvgMode && u === "svg" && (isSvgMode = !1)) : (p = o["s-cr"]) ? p.parentNode.textContent = d : t.$text$ !== d && (o.data = d);
}, updateFallbackSlotVisibility = (t) => {
  const e = t.childNodes;
  for (const r of e)
    if (r.nodeType === 1) {
      if (r["s-sr"]) {
        const o = r["s-sn"];
        r.hidden = !1;
        for (const a of e)
          if (a !== r) {
            if (a["s-hn"] !== r["s-hn"] || o !== "") {
              if (a.nodeType === 1 && (o === a.getAttribute("slot") || o === a["s-sn"])) {
                r.hidden = !0;
                break;
              }
            } else if (a.nodeType === 1 || a.nodeType === 3 && a.textContent.trim() !== "") {
              r.hidden = !0;
              break;
            }
          }
      }
      updateFallbackSlotVisibility(r);
    }
}, relocateNodes = [], markSlotContentForRelocation = (t) => {
  let e, r, o;
  for (const a of t.childNodes) {
    if (a["s-sr"] && (e = a["s-cr"]) && e.parentNode) {
      r = e.parentNode.childNodes;
      const c = a["s-sn"];
      for (o = r.length - 1; o >= 0; o--)
        if (e = r[o], !e["s-cn"] && !e["s-nr"] && e["s-hn"] !== a["s-hn"] && !BUILD.experimentalSlotFixes)
          if (isNodeLocatedInSlot(e, c)) {
            let u = relocateNodes.find((d) => d.$nodeToRelocate$ === e);
            checkSlotFallbackVisibility = !0, e["s-sn"] = e["s-sn"] || c, u ? (u.$nodeToRelocate$["s-sh"] = a["s-hn"], u.$slotRefNode$ = a) : (e["s-sh"] = a["s-hn"], relocateNodes.push({
              $slotRefNode$: a,
              $nodeToRelocate$: e
            })), e["s-sr"] && relocateNodes.map((d) => {
              isNodeLocatedInSlot(d.$nodeToRelocate$, e["s-sn"]) && (u = relocateNodes.find((p) => p.$nodeToRelocate$ === e), u && !d.$slotRefNode$ && (d.$slotRefNode$ = u.$slotRefNode$));
            });
          } else
            relocateNodes.some((u) => u.$nodeToRelocate$ === e) || relocateNodes.push({
              $nodeToRelocate$: e
            });
    }
    a.nodeType === 1 && markSlotContentForRelocation(a);
  }
}, isNodeLocatedInSlot = (t, e) => t.nodeType === 1 ? t.getAttribute("slot") === null && e === "" || t.getAttribute("slot") === e : t["s-sn"] === e ? !0 : e === "", nullifyVNodeRefs = (t) => {
  t.$attrs$ && t.$attrs$.ref && t.$attrs$.ref(null), t.$children$ && t.$children$.map(nullifyVNodeRefs);
}, renderVdom = (t, e, r = !1) => {
  var o, a, c, u;
  const d = t.$hostElement$, p = t.$cmpMeta$, g = t.$vnode$ || newVNode(null, null), b = isHost(e) ? e : h(null, null, e);
  if (hostTagName = d.tagName, p.$attrsToReflect$ && (b.$attrs$ = b.$attrs$ || {}, p.$attrsToReflect$.map(([x, w]) => b.$attrs$[w] = d[x])), r && b.$attrs$)
    for (const x of Object.keys(b.$attrs$))
      d.hasAttribute(x) && !["key", "ref", "style", "class"].includes(x) && (b.$attrs$[x] = d[x]);
  b.$tag$ = null, b.$flags$ |= 4, t.$vnode$ = b, b.$elm$ = g.$elm$ = d.shadowRoot || d, scopeId = d["s-sc"], contentRef = d["s-cr"], useNativeShadowDom = (p.$flags$ & 1) !== 0, checkSlotFallbackVisibility = !1, patch(g, b, r);
  {
    if (plt.$flags$ |= 1, checkSlotRelocate) {
      markSlotContentForRelocation(b.$elm$);
      for (const x of relocateNodes) {
        const w = x.$nodeToRelocate$;
        if (!w["s-ol"]) {
          const y = doc$1.createTextNode("");
          y["s-nr"] = w, w.parentNode.insertBefore(w["s-ol"] = y, w);
        }
      }
      for (const x of relocateNodes) {
        const w = x.$nodeToRelocate$, y = x.$slotRefNode$;
        if (y) {
          const I = y.parentNode;
          let E = y.nextSibling;
          {
            let T = (o = w["s-ol"]) === null || o === void 0 ? void 0 : o.previousSibling;
            for (; T; ) {
              let C = (a = T["s-nr"]) !== null && a !== void 0 ? a : null;
              if (C && C["s-sn"] === w["s-sn"] && I === C.parentNode && (C = C.nextSibling, !C || !C["s-nr"])) {
                E = C;
                break;
              }
              T = T.previousSibling;
            }
          }
          (!E && I !== w.parentNode || w.nextSibling !== E) && w !== E && (!w["s-hn"] && w["s-ol"] && (w["s-hn"] = w["s-ol"].parentNode.nodeName), I.insertBefore(w, E), w.nodeType === 1 && (w.hidden = (c = w["s-ih"]) !== null && c !== void 0 ? c : !1));
        } else
          w.nodeType === 1 && (r && (w["s-ih"] = (u = w.hidden) !== null && u !== void 0 ? u : !1), w.hidden = !0);
      }
    }
    checkSlotFallbackVisibility && updateFallbackSlotVisibility(b.$elm$), plt.$flags$ &= -2, relocateNodes.length = 0;
  }
}, attachToAncestor = (t, e) => {
}, scheduleUpdate = (t, e) => (t.$flags$ |= 16, attachToAncestor(t, t.$ancestorComponent$), writeTask(() => dispatchHooks(t, e))), dispatchHooks = (t, e) => {
  const r = t.$hostElement$, o = createTime("scheduleUpdate", t.$cmpMeta$.$tagName$), a = r;
  let c;
  return e ? c = safeCall$1(a, "componentWillLoad") : c = safeCall$1(a, "componentWillUpdate"), c = enqueue(c, () => safeCall$1(a, "componentWillRender")), o(), enqueue(c, () => updateComponent(t, a, e));
}, enqueue = (t, e) => isPromisey(t) ? t.then(e) : e(), isPromisey = (t) => t instanceof Promise || t && t.then && typeof t.then == "function", updateComponent = async (t, e, r) => {
  const o = t.$hostElement$, a = createTime("update", t.$cmpMeta$.$tagName$);
  o["s-rc"], r && attachStyles(t);
  const c = createTime("render", t.$cmpMeta$.$tagName$);
  callRender(t, e, o, r), c(), a(), postUpdateComponent(t);
}, callRender = (t, e, r, o) => {
  try {
    renderingRef = e, e = e.render && e.render(), t.$flags$ &= -17, t.$flags$ |= 2, (BUILD.hasRenderFn || BUILD.reflect) && (BUILD.vdomRender || BUILD.reflect) && (BUILD.hydrateServerSide || renderVdom(t, e, o));
  } catch (p) {
    consoleError(p, t.$hostElement$);
  }
  return renderingRef = null, null;
}, postUpdateComponent = (t) => {
  const e = t.$cmpMeta$.$tagName$, r = t.$hostElement$, o = createTime("postUpdate", e), a = r;
  t.$ancestorComponent$, safeCall$1(a, "componentDidRender"), t.$flags$ & 64 ? (safeCall$1(a, "componentDidUpdate"), o()) : (t.$flags$ |= 64, safeCall$1(a, "componentDidLoad"), o());
}, forceUpdate = (t) => {
  {
    const e = getHostRef(t), r = e.$hostElement$.isConnected;
    return r && (e.$flags$ & 18) === 2 && scheduleUpdate(e, !1), r;
  }
}, safeCall$1 = (t, e, r) => {
  if (t && t[e])
    try {
      return t[e](r);
    } catch (o) {
      consoleError(o);
    }
}, getValue = (t, e) => getHostRef(t).$instanceValues$.get(e), setValue = (t, e, r, o) => {
  const a = getHostRef(t), c = t, u = a.$instanceValues$.get(e), d = a.$flags$, p = c;
  r = parsePropertyValue(r, o.$members$[e][0]);
  const g = Number.isNaN(u) && Number.isNaN(r);
  if (r !== u && !g) {
    a.$instanceValues$.set(e, r);
    {
      if (o.$watchers$ && d & 128) {
        const x = o.$watchers$[e];
        x && x.map((w) => {
          try {
            p[w](r, u, e);
          } catch (y) {
            consoleError(y, c);
          }
        });
      }
      if ((d & 18) === 2) {
        if (p.componentShouldUpdate && p.componentShouldUpdate(r, u, e) === !1)
          return;
        scheduleUpdate(a, !1);
      }
    }
  }
}, proxyComponent = (t, e, r) => {
  var o;
  const a = t.prototype;
  if (e.$members$) {
    t.watchers && (e.$watchers$ = t.watchers);
    const c = Object.entries(e.$members$);
    c.map(([u, [d]]) => {
      (d & 31 || d & 32) && Object.defineProperty(a, u, {
        get() {
          return getValue(this, u);
        },
        set(p) {
          setValue(this, u, p, e);
        },
        configurable: !0,
        enumerable: !0
      });
    });
    {
      const u = /* @__PURE__ */ new Map();
      a.attributeChangedCallback = function(d, p, g) {
        plt.jmp(() => {
          var b;
          const x = u.get(d);
          if (this.hasOwnProperty(x))
            g = this[x], delete this[x];
          else {
            if (a.hasOwnProperty(x) && typeof this[x] == "number" && this[x] == g)
              return;
            if (x == null) {
              const w = getHostRef(this), y = w == null ? void 0 : w.$flags$;
              if (y && !(y & 8) && y & 128 && g !== p) {
                const E = this, T = (b = e.$watchers$) === null || b === void 0 ? void 0 : b[d];
                T == null || T.forEach((C) => {
                  E[C] != null && E[C].call(E, g, p, d);
                });
              }
              return;
            }
          }
          this[x] = g === null && typeof this[x] == "boolean" ? !1 : g;
        });
      }, t.observedAttributes = Array.from(/* @__PURE__ */ new Set([
        ...Object.keys((o = e.$watchers$) !== null && o !== void 0 ? o : {}),
        ...c.filter(
          ([d, p]) => p[0] & 15
          /* MEMBER_FLAGS.HasAttribute */
        ).map(([d, p]) => {
          var g;
          const b = p[1] || d;
          return u.set(b, d), p[0] & 512 && ((g = e.$attrsToReflect$) === null || g === void 0 || g.push([d, b])), b;
        })
      ]));
    }
  }
  return t;
}, initializeComponent = async (t, e, r, o) => {
  let a;
  if (!(e.$flags$ & 32) && (e.$flags$ |= 32, a = t.constructor, customElements.whenDefined(r.$tagName$).then(() => e.$flags$ |= 128), a.style)) {
    let u = a.style;
    typeof u != "string" && (u = u[e.$modeName$ = computeMode(t)]);
    const d = getScopeId(r, e.$modeName$);
    if (!styles.has(d)) {
      const p = createTime("registerStyles", r.$tagName$);
      registerStyle(d, u, !!(r.$flags$ & 1)), p();
    }
  }
  e.$ancestorComponent$, (() => scheduleUpdate(e, !0))();
}, fireConnectedCallback = (t) => {
}, connectedCallback = (t) => {
  if (!(plt.$flags$ & 1)) {
    const e = getHostRef(t), r = e.$cmpMeta$, o = createTime("connectedCallback", r.$tagName$);
    e.$flags$ & 1 ? (addHostEventListeners(t, e, r.$listeners$), e != null && e.$lazyInstance$ ? fireConnectedCallback(e.$lazyInstance$) : e != null && e.$onReadyPromise$ && e.$onReadyPromise$.then(() => fireConnectedCallback(e.$lazyInstance$))) : (e.$flags$ |= 1, // TODO(STENCIL-854): Remove code related to legacy shadowDomShim field
    r.$flags$ & 12 && setContentReference(t), r.$members$ && Object.entries(r.$members$).map(([a, [c]]) => {
      if (c & 31 && t.hasOwnProperty(a)) {
        const u = t[a];
        delete t[a], t[a] = u;
      }
    }), initializeComponent(t, e, r)), o();
  }
}, setContentReference = (t) => {
  const e = t["s-cr"] = doc$1.createComment("");
  e["s-cn"] = !0, t.insertBefore(e, t.firstChild);
}, disconnectedCallback = async (t) => {
  if (!(plt.$flags$ & 1)) {
    const e = getHostRef(t);
    e.$rmListeners$ && (e.$rmListeners$.map((r) => r()), e.$rmListeners$ = void 0);
  }
}, proxyCustomElement = (t, e) => {
  const r = {
    $flags$: e[0],
    $tagName$: e[1]
  };
  r.$members$ = e[2], r.$listeners$ = e[3], r.$watchers$ = t.$watchers$, r.$attrsToReflect$ = [];
  const o = t.prototype.connectedCallback, a = t.prototype.disconnectedCallback;
  return Object.assign(t.prototype, {
    __registerHost() {
      registerHost(this, r);
    },
    connectedCallback() {
      connectedCallback(this), o && o.call(this);
    },
    disconnectedCallback() {
      disconnectedCallback(this), a && a.call(this);
    },
    __attachShadow() {
      this.attachShadow({
        mode: "open",
        delegatesFocus: !!(r.$flags$ & 16)
      });
    }
  }), t.is = r.$tagName$, proxyComponent(t, r);
}, addHostEventListeners = (t, e, r, o) => {
  r && r.map(([a, c, u]) => {
    const d = getHostListenerTarget(t, a), p = hostListenerProxy(e, u), g = hostListenerOpts(a);
    plt.ael(d, c, p, g), (e.$rmListeners$ = e.$rmListeners$ || []).push(() => plt.rel(d, c, p, g));
  });
}, hostListenerProxy = (t, e) => (r) => {
  try {
    BUILD.lazyLoad || t.$hostElement$[e](r);
  } catch (o) {
    consoleError(o);
  }
}, getHostListenerTarget = (t, e) => e & 4 ? doc$1 : e & 8 ? win$2 : e & 16 ? doc$1.body : t, hostListenerOpts = (t) => supportsListenerOptions ? {
  passive: (t & 1) !== 0,
  capture: (t & 2) !== 0
} : (t & 2) !== 0, hostRefs = /* @__PURE__ */ new WeakMap(), getHostRef = (t) => hostRefs.get(t), registerHost = (t, e) => {
  const r = {
    $flags$: 0,
    $hostElement$: t,
    $cmpMeta$: e,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  return addHostEventListeners(t, r, e.$listeners$), hostRefs.set(t, r);
}, isMemberInElement = (t, e) => e in t, consoleError = (t, e) => (0, console.error)(t, e), styles = /* @__PURE__ */ new Map(), modeResolutionChain = [], win$2 = typeof window < "u" ? window : {}, doc$1 = win$2.document || { head: {} }, H = win$2.HTMLElement || class {
}, plt = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (t) => t(),
  raf: (t) => requestAnimationFrame(t),
  ael: (t, e, r, o) => t.addEventListener(e, r, o),
  rel: (t, e, r, o) => t.removeEventListener(e, r, o),
  ce: (t, e) => new CustomEvent(t, e)
}, setPlatformHelpers = (t) => {
  Object.assign(plt, t);
}, supportsListenerOptions = /* @__PURE__ */ (() => {
  let t = !1;
  try {
    doc$1.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        t = !0;
      }
    }));
  } catch {
  }
  return t;
})(), promiseResolve = (t) => Promise.resolve(t), supportsConstructableStylesheets = /* @__PURE__ */ (() => {
  try {
    return new CSSStyleSheet(), typeof new CSSStyleSheet().replaceSync == "function";
  } catch {
  }
  return !1;
})(), queueDomReads = [], queueDomWrites = [], queueTask = (t, e) => (r) => {
  t.push(r), queuePending || (queuePending = !0, e && plt.$flags$ & 4 ? nextTick(flush) : plt.raf(flush));
}, consume = (t) => {
  for (let e = 0; e < t.length; e++)
    try {
      t[e](performance.now());
    } catch (r) {
      consoleError(r);
    }
  t.length = 0;
}, flush = () => {
  consume(queueDomReads), consume(queueDomWrites), (queuePending = queueDomReads.length > 0) && plt.raf(flush);
}, nextTick = (t) => promiseResolve().then(t), readTask = /* @__PURE__ */ queueTask(queueDomReads, !1), writeTask = /* @__PURE__ */ queueTask(queueDomWrites, !0);
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const componentOnReady = (t, e) => {
  t.componentOnReady ? t.componentOnReady().then((r) => e(r)) : raf(() => e(t));
}, hasLazyBuild = (t) => t.componentOnReady !== void 0, inheritAttributes$2 = (t, e = []) => {
  const r = {};
  return e.forEach((o) => {
    t.hasAttribute(o) && (t.getAttribute(o) !== null && (r[o] = t.getAttribute(o)), t.removeAttribute(o));
  }), r;
}, ariaAttributes = [
  "role",
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-braillelabel",
  "aria-brailleroledescription",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colindextext",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-description",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowindextext",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext"
], inheritAriaAttributes = (t, e) => {
  let r = ariaAttributes;
  return e && e.length > 0 && (r = r.filter((o) => !e.includes(o))), inheritAttributes$2(t, r);
}, addEventListener$1 = (t, e, r, o) => {
  var a;
  if (typeof window < "u") {
    const c = window, u = (a = c == null ? void 0 : c.Ionic) === null || a === void 0 ? void 0 : a.config;
    if (u) {
      const d = u.get("_ael");
      if (d)
        return d(t, e, r, o);
      if (u._ael)
        return u._ael(t, e, r, o);
    }
  }
  return t.addEventListener(e, r, o);
}, removeEventListener = (t, e, r, o) => {
  var a;
  if (typeof window < "u") {
    const c = window, u = (a = c == null ? void 0 : c.Ionic) === null || a === void 0 ? void 0 : a.config;
    if (u) {
      const d = u.get("_rel");
      if (d)
        return d(t, e, r, o);
      if (u._rel)
        return u._rel(t, e, r, o);
    }
  }
  return t.removeEventListener(e, r, o);
}, getElementRoot = (t, e = t) => t.shadowRoot || e, raf = (t) => typeof __zone_symbol__requestAnimationFrame == "function" ? __zone_symbol__requestAnimationFrame(t) : typeof requestAnimationFrame == "function" ? requestAnimationFrame(t) : setTimeout(t), hasShadowDom = (t) => !!t.shadowRoot && !!t.attachShadow, findItemLabel = (t) => {
  const e = t.closest("ion-item");
  return e ? e.querySelector("ion-label") : null;
}, focusElement = (t) => {
  if (t.focus(), t.classList.contains("ion-focusable")) {
    const e = t.closest("ion-app");
    e && e.setFocus([t]);
  }
}, getAriaLabel = (t, e) => {
  let r;
  const o = t.getAttribute("aria-labelledby"), a = t.id;
  let c = o !== null && o.trim() !== "" ? o : e + "-lbl", u = o !== null && o.trim() !== "" ? document.getElementById(o) : findItemLabel(t);
  return u ? (o === null && (u.id = c), r = u.textContent, u.setAttribute("aria-hidden", "true")) : a.trim() !== "" && (u = document.querySelector(`label[for="${a}"]`), u && (u.id !== "" ? c = u.id : u.id = c = `${a}-lbl`, r = u.textContent)), { label: u, labelId: c, labelText: r };
}, renderHiddenInput = (t, e, r, o, a) => {
  if (t || hasShadowDom(e)) {
    let c = e.querySelector("input.aux-input");
    c || (c = e.ownerDocument.createElement("input"), c.type = "hidden", c.classList.add("aux-input"), e.appendChild(c)), c.disabled = a, c.name = r, c.value = o || "";
  }
}, clamp = (t, e, r) => Math.max(t, Math.min(e, r)), assert = (t, e) => {
  if (!t) {
    const r = "ASSERT: " + e;
    console.error(r);
    debugger;
    throw new Error(r);
  }
}, now$1 = (t) => t.timeStamp || Date.now(), pointerCoord = (t) => {
  if (t) {
    const e = t.changedTouches;
    if (e && e.length > 0) {
      const r = e[0];
      return { x: r.clientX, y: r.clientY };
    }
    if (t.pageX !== void 0)
      return { x: t.pageX, y: t.pageY };
  }
  return { x: 0, y: 0 };
}, debounceEvent = (t, e) => {
  const r = t._original || t;
  return {
    _original: t,
    emit: debounce(r.emit.bind(r), e)
  };
}, debounce = (t, e = 0) => {
  let r;
  return (...o) => {
    clearTimeout(r), r = setTimeout(t, e, ...o);
  };
}, shallowEqualStringMap = (t, e) => {
  if (t ?? (t = {}), e ?? (e = {}), t === e)
    return !0;
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !1;
  for (const o of r)
    if (!(o in e) || t[o] !== e[o])
      return !1;
  return !0;
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const arrowBackSharp = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='square' stroke-miterlimit='10' stroke-width='48' d='M244 400L100 256l144-144M120 256h292' class='ionicon-fill-none'/></svg>", caretDownSharp = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M64 144l192 224 192-224H64z'/></svg>", chevronBack = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M328 112L184 256l144 144' class='ionicon-fill-none'/></svg>", chevronExpand = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M136 208l120-104 120 104M136 304l120 104 120-104' stroke-width='48' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none'/></svg>", chevronForward = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M184 112l144 144-144 144' class='ionicon-fill-none'/></svg>", close$1 = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z'/></svg>", closeCircle = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z'/></svg>", closeSharp = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M400 145.49L366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z'/></svg>", searchOutline$1 = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z' stroke-miterlimit='10' class='ionicon-fill-none ionicon-stroke-width'/><path stroke-linecap='round' stroke-miterlimit='10' d='M338.29 338.29L448 448' class='ionicon-fill-none ionicon-stroke-width'/></svg>", searchSharp = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M464 428L339.92 303.9a160.48 160.48 0 0030.72-94.58C370.64 120.37 298.27 48 209.32 48S48 120.37 48 209.32s72.37 161.32 161.32 161.32a160.48 160.48 0 0094.58-30.72L428 464zM209.32 319.69a110.38 110.38 0 11110.37-110.37 110.5 110.5 0 01-110.37 110.37z'/></svg>";
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
class Config {
  constructor() {
    this.m = /* @__PURE__ */ new Map();
  }
  reset(e) {
    this.m = new Map(Object.entries(e));
  }
  get(e, r) {
    const o = this.m.get(e);
    return o !== void 0 ? o : r;
  }
  getBoolean(e, r = !1) {
    const o = this.m.get(e);
    return o === void 0 ? r : typeof o == "string" ? o === "true" : !!o;
  }
  getNumber(e, r) {
    const o = parseFloat(this.m.get(e));
    return isNaN(o) ? r !== void 0 ? r : NaN : o;
  }
  set(e, r) {
    this.m.set(e, r);
  }
}
const config$1 = /* @__PURE__ */ new Config(), configFromSession = (t) => {
  try {
    const e = t.sessionStorage.getItem(IONIC_SESSION_KEY);
    return e !== null ? JSON.parse(e) : {};
  } catch {
    return {};
  }
}, saveConfig = (t, e) => {
  try {
    t.sessionStorage.setItem(IONIC_SESSION_KEY, JSON.stringify(e));
  } catch {
    return;
  }
}, configFromURL = (t) => {
  const e = {};
  return t.location.search.slice(1).split("&").map((r) => r.split("=")).map(([r, o]) => [decodeURIComponent(r), decodeURIComponent(o)]).filter(([r]) => startsWith(r, IONIC_PREFIX)).map(([r, o]) => [r.slice(IONIC_PREFIX.length), o]).forEach(([r, o]) => {
    e[r] = o;
  }), e;
}, startsWith = (t, e) => t.substr(0, e.length) === e, IONIC_PREFIX = "ionic:", IONIC_SESSION_KEY = "ionic-persist-config", getPlatforms = (t) => setupPlatforms(t), isPlatform = (t, e) => (typeof t == "string" && (e = t, t = void 0), getPlatforms(t).includes(e)), setupPlatforms = (t = window) => {
  if (typeof t > "u")
    return [];
  t.Ionic = t.Ionic || {};
  let e = t.Ionic.platforms;
  return e == null && (e = t.Ionic.platforms = detectPlatforms(t), e.forEach((r) => t.document.documentElement.classList.add(`plt-${r}`))), e;
}, detectPlatforms = (t) => {
  const e = config$1.get("platform");
  return Object.keys(PLATFORMS_MAP).filter((r) => {
    const o = e == null ? void 0 : e[r];
    return typeof o == "function" ? o(t) : PLATFORMS_MAP[r](t);
  });
}, isMobileWeb = (t) => isMobile(t) && !isHybrid(t), isIpad = (t) => !!(testUserAgent(t, /iPad/i) || testUserAgent(t, /Macintosh/i) && isMobile(t)), isIphone = (t) => testUserAgent(t, /iPhone/i), isIOS = (t) => testUserAgent(t, /iPhone|iPod/i) || isIpad(t), isAndroid = (t) => testUserAgent(t, /android|sink/i), isAndroidTablet = (t) => isAndroid(t) && !testUserAgent(t, /mobile/i), isPhablet = (t) => {
  const e = t.innerWidth, r = t.innerHeight, o = Math.min(e, r), a = Math.max(e, r);
  return o > 390 && o < 520 && a > 620 && a < 800;
}, isTablet = (t) => {
  const e = t.innerWidth, r = t.innerHeight, o = Math.min(e, r), a = Math.max(e, r);
  return isIpad(t) || isAndroidTablet(t) || o > 460 && o < 820 && a > 780 && a < 1400;
}, isMobile = (t) => matchMedia(t, "(any-pointer:coarse)"), isDesktop = (t) => !isMobile(t), isHybrid = (t) => isCordova(t) || isCapacitorNative(t), isCordova = (t) => !!(t.cordova || t.phonegap || t.PhoneGap), isCapacitorNative = (t) => {
  const e = t.Capacitor;
  return !!(e != null && e.isNative);
}, isElectron = (t) => testUserAgent(t, /electron/i), isPWA = (t) => {
  var e;
  return !!(!((e = t.matchMedia) === null || e === void 0) && e.call(t, "(display-mode: standalone)").matches || t.navigator.standalone);
}, testUserAgent = (t, e) => e.test(t.navigator.userAgent), matchMedia = (t, e) => {
  var r;
  return (r = t.matchMedia) === null || r === void 0 ? void 0 : r.call(t, e).matches;
}, PLATFORMS_MAP = {
  ipad: isIpad,
  iphone: isIphone,
  ios: isIOS,
  android: isAndroid,
  phablet: isPhablet,
  tablet: isTablet,
  cordova: isCordova,
  capacitor: isCapacitorNative,
  electron: isElectron,
  pwa: isPWA,
  mobile: isMobile,
  mobileweb: isMobileWeb,
  desktop: isDesktop,
  hybrid: isHybrid
};
let defaultMode;
const getIonMode$2 = (t) => t && getMode(t) || defaultMode, initialize = (t = {}) => {
  if (typeof window > "u")
    return;
  const e = window.document, r = window, o = r.Ionic = r.Ionic || {}, a = {};
  t._ael && (a.ael = t._ael), t._rel && (a.rel = t._rel), t._ce && (a.ce = t._ce), setPlatformHelpers(a);
  const c = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, configFromSession(r)), { persistConfig: !1 }), o.config), configFromURL(r)), t);
  config$1.reset(c), config$1.getBoolean("persistConfig") && saveConfig(r, c), setupPlatforms(r), o.config = config$1, o.mode = defaultMode = config$1.get("mode", e.documentElement.getAttribute("mode") || (isPlatform(r, "ios") ? "ios" : "md")), config$1.set("mode", defaultMode), e.documentElement.setAttribute("mode", defaultMode), e.documentElement.classList.add(defaultMode), config$1.getBoolean("_testing") && config$1.set("animated", !1);
  const u = (p) => {
    var g;
    return (g = p.tagName) === null || g === void 0 ? void 0 : g.startsWith("ION-");
  }, d = (p) => ["ios", "md"].includes(p);
  setMode((p) => {
    for (; p; ) {
      const g = p.mode || p.getAttribute("mode");
      if (g) {
        if (d(g))
          return g;
        u(p) && console.warn('Invalid ionic mode: "' + g + '", expected: "ios" or "md"');
      }
      p = p.parentElement;
    }
    return defaultMode;
  });
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let CACHED_MAP$1;
const getIconMap$1 = () => {
  if (typeof window > "u")
    return /* @__PURE__ */ new Map();
  if (!CACHED_MAP$1) {
    const t = window;
    t.Ionicons = t.Ionicons || {}, CACHED_MAP$1 = t.Ionicons.map = t.Ionicons.map || /* @__PURE__ */ new Map();
  }
  return CACHED_MAP$1;
}, getUrl$1 = (t) => {
  let e = getSrc$1(t.src);
  return e || (e = getName$1(t.name, t.icon, t.mode, t.ios, t.md), e ? getNamedUrl$1(e, t) : t.icon && (e = getSrc$1(t.icon), e || (e = getSrc$1(t.icon[t.mode]), e)) ? e : null);
}, getNamedUrl$1 = (t, e) => {
  const r = getIconMap$1().get(t);
  if (r)
    return r;
  try {
    return getAssetPath(`svg/${t}.svg`);
  } catch {
    console.warn(`[Ionicons Warning]: Could not load icon with name "${t}". Ensure that the icon is registered using addIcons or that the icon SVG data is passed directly to the icon component.`, e);
  }
}, getName$1 = (t, e, r, o, a) => (r = (r && toLower$1(r)) === "ios" ? "ios" : "md", o && r === "ios" ? t = toLower$1(o) : a && r === "md" ? t = toLower$1(a) : (!t && e && !isSrc$1(e) && (t = e), isStr$1(t) && (t = toLower$1(t))), !isStr$1(t) || t.trim() === "" || t.replace(/[a-z]|-|\d/gi, "") !== "" ? null : t), getSrc$1 = (t) => isStr$1(t) && (t = t.trim(), isSrc$1(t)) ? t : null, isSrc$1 = (t) => t.length > 0 && /(\/|\.)/.test(t), isStr$1 = (t) => typeof t == "string", toLower$1 = (t) => t.toLowerCase(), inheritAttributes$1 = (t, e = []) => {
  const r = {};
  return e.forEach((o) => {
    t.hasAttribute(o) && (t.getAttribute(o) !== null && (r[o] = t.getAttribute(o)), t.removeAttribute(o));
  }), r;
}, isRTL$2 = (t) => t && t.dir !== "" ? t.dir.toLowerCase() === "rtl" : (document == null ? void 0 : document.dir.toLowerCase()) === "rtl", validateContent$1 = (t) => {
  const e = document.createElement("div");
  e.innerHTML = t;
  for (let o = e.childNodes.length - 1; o >= 0; o--)
    e.childNodes[o].nodeName.toLowerCase() !== "svg" && e.removeChild(e.childNodes[o]);
  const r = e.firstElementChild;
  if (r && r.nodeName.toLowerCase() === "svg") {
    const o = r.getAttribute("class") || "";
    if (r.setAttribute("class", (o + " s-ion-icon").trim()), isValid$1(r))
      return e.innerHTML;
  }
  return "";
}, isValid$1 = (t) => {
  if (t.nodeType === 1) {
    if (t.nodeName.toLowerCase() === "script")
      return !1;
    for (let e = 0; e < t.attributes.length; e++) {
      const r = t.attributes[e].name;
      if (isStr$1(r) && r.toLowerCase().indexOf("on") === 0)
        return !1;
    }
    for (let e = 0; e < t.childNodes.length; e++)
      if (!isValid$1(t.childNodes[e]))
        return !1;
  }
  return !0;
}, isSvgDataUrl$1 = (t) => t.startsWith("data:image/svg+xml"), isEncodedDataUrl$1 = (t) => t.indexOf(";utf8,") !== -1, ioniconContent$1 = /* @__PURE__ */ new Map(), requests$1 = /* @__PURE__ */ new Map();
let parser$1;
const getSvgContent$1 = (t, e) => {
  let r = requests$1.get(t);
  if (!r)
    if (typeof fetch < "u" && typeof document < "u")
      if (isSvgDataUrl$1(t) && isEncodedDataUrl$1(t)) {
        parser$1 || (parser$1 = new DOMParser());
        const a = parser$1.parseFromString(t, "text/html").querySelector("svg");
        return a && ioniconContent$1.set(t, a.outerHTML), Promise.resolve();
      } else
        r = fetch(t).then((o) => {
          if (o.ok)
            return o.text().then((a) => {
              a && e !== !1 && (a = validateContent$1(a)), ioniconContent$1.set(t, a || "");
            });
          ioniconContent$1.set(t, "");
        }), requests$1.set(t, r);
    else
      return ioniconContent$1.set(t, ""), Promise.resolve();
  return r;
}, iconCss$1 = ":host{display:inline-block;width:1em;height:1em;contain:strict;fill:currentColor;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host .ionicon{stroke:currentColor}.ionicon-fill-none{fill:none}.ionicon-stroke-width{stroke-width:32px;stroke-width:var(--ionicon-stroke-width, 32px)}.icon-inner,.ionicon,svg{display:block;height:100%;width:100%}@supports (background: -webkit-named-image(i)){:host(.icon-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}@supports not selector(:dir(rtl)) and selector(:host-context([dir='rtl'])){:host(.icon-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}:host(.flip-rtl):host-context([dir='rtl']) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}@supports selector(:dir(rtl)){:host(.flip-rtl:dir(rtl)) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(.flip-rtl:dir(ltr)) .icon-inner{-webkit-transform:scaleX(1);transform:scaleX(1)}}:host(.icon-small){font-size:1.125rem !important}:host(.icon-large){font-size:2rem !important}:host(.ion-color){color:var(--ion-color-base) !important}:host(.ion-color-primary){--ion-color-base:var(--ion-color-primary, #3880ff)}:host(.ion-color-secondary){--ion-color-base:var(--ion-color-secondary, #0cd1e8)}:host(.ion-color-tertiary){--ion-color-base:var(--ion-color-tertiary, #f4a942)}:host(.ion-color-success){--ion-color-base:var(--ion-color-success, #10dc60)}:host(.ion-color-warning){--ion-color-base:var(--ion-color-warning, #ffce00)}:host(.ion-color-danger){--ion-color-base:var(--ion-color-danger, #f14141)}:host(.ion-color-light){--ion-color-base:var(--ion-color-light, #f4f5f8)}:host(.ion-color-medium){--ion-color-base:var(--ion-color-medium, #989aa2)}:host(.ion-color-dark){--ion-color-base:var(--ion-color-dark, #222428)}", Icon$1 = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.iconName = null, this.inheritedAttributes = {}, this.didLoadIcon = !1, this.svgContent = void 0, this.isVisible = !1, this.mode = getIonMode$1(), this.color = void 0, this.ios = void 0, this.md = void 0, this.flipRtl = void 0, this.name = void 0, this.src = void 0, this.icon = void 0, this.size = void 0, this.lazy = !1, this.sanitize = !0;
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAttributes$1(this.el, ["aria-label"]);
  }
  connectedCallback() {
    this.waitUntilVisible(this.el, "50px", () => {
      this.isVisible = !0, this.loadIcon();
    });
  }
  componentDidLoad() {
    this.didLoadIcon || this.loadIcon();
  }
  disconnectedCallback() {
    this.io && (this.io.disconnect(), this.io = void 0);
  }
  waitUntilVisible(e, r, o) {
    if (this.lazy && typeof window < "u" && window.IntersectionObserver) {
      const a = this.io = new window.IntersectionObserver((c) => {
        c[0].isIntersecting && (a.disconnect(), this.io = void 0, o());
      }, { rootMargin: r });
      a.observe(e);
    } else
      o();
  }
  loadIcon() {
    if (this.isVisible) {
      const e = getUrl$1(this);
      e && (ioniconContent$1.has(e) ? this.svgContent = ioniconContent$1.get(e) : getSvgContent$1(e, this.sanitize).then(() => this.svgContent = ioniconContent$1.get(e)), this.didLoadIcon = !0);
    }
    this.iconName = getName$1(this.name, this.icon, this.mode, this.ios, this.md);
  }
  render() {
    const { flipRtl: e, iconName: r, inheritedAttributes: o, el: a } = this, c = this.mode || "md", u = r ? (r.includes("arrow") || r.includes("chevron")) && e !== !1 : !1, d = e || u;
    return h(Host, Object.assign({ role: "img", class: Object.assign(Object.assign({ [c]: !0 }, createColorClasses$2(this.color)), { [`icon-${this.size}`]: !!this.size, "flip-rtl": d, "icon-rtl": d && isRTL$2(a) }) }, o), this.svgContent ? h("div", { class: "icon-inner", innerHTML: this.svgContent }) : h("div", { class: "icon-inner" }));
  }
  static get assetsDirs() {
    return ["svg"];
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      name: ["loadIcon"],
      src: ["loadIcon"],
      icon: ["loadIcon"],
      ios: ["loadIcon"],
      md: ["loadIcon"]
    };
  }
  static get style() {
    return iconCss$1;
  }
}, [1, "ion-icon", {
  mode: [1025],
  color: [1],
  ios: [1],
  md: [1],
  flipRtl: [4, "flip-rtl"],
  name: [513],
  src: [1],
  icon: [8],
  size: [1],
  lazy: [4],
  sanitize: [4],
  svgContent: [32],
  isVisible: [32]
}, void 0, {
  name: ["loadIcon"],
  src: ["loadIcon"],
  icon: ["loadIcon"],
  ios: ["loadIcon"],
  md: ["loadIcon"]
}]), getIonMode$1 = () => typeof document < "u" && document.documentElement.getAttribute("mode") || "md", createColorClasses$2 = (t) => t ? {
  "ion-color": !0,
  [`ion-color-${t}`]: !0
} : null;
function defineCustomElement$T() {
  if (typeof customElements > "u")
    return;
  ["ion-icon"].forEach((e) => {
    switch (e) {
      case "ion-icon":
        customElements.get(e) || customElements.define(e, Icon$1);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const printIonWarning = (t, ...e) => console.warn(`[Ionic Warning]: ${t}`, ...e), printIonError = (t, ...e) => console.error(`[Ionic Error]: ${t}`, ...e), printRequiredElementError = (t, ...e) => console.error(`<${t.tagName.toLowerCase()}> must be used inside ${e.join(" or ")}.`);
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const avatarIosCss = ":host{border-radius:var(--border-radius);display:block}::slotted(ion-img),::slotted(img){border-radius:var(--border-radius);width:100%;height:100%;-o-object-fit:cover;object-fit:cover;overflow:hidden}:host{--border-radius:50%;width:48px;height:48px}", avatarMdCss = ":host{border-radius:var(--border-radius);display:block}::slotted(ion-img),::slotted(img){border-radius:var(--border-radius);width:100%;height:100%;-o-object-fit:cover;object-fit:cover;overflow:hidden}:host{--border-radius:50%;width:64px;height:64px}", Avatar = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow();
  }
  render() {
    return h(Host, { class: getIonMode$2(this) }, h("slot", null));
  }
  static get style() {
    return {
      ios: avatarIosCss,
      md: avatarMdCss
    };
  }
}, [33, "ion-avatar"]);
function defineCustomElement$1$q() {
  if (typeof customElements > "u")
    return;
  ["ion-avatar"].forEach((e) => {
    switch (e) {
      case "ion-avatar":
        customElements.get(e) || customElements.define(e, Avatar);
        break;
    }
  });
}
const defineCustomElement$S = defineCustomElement$1$q;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
class GestureController {
  constructor() {
    this.gestureId = 0, this.requestedStart = /* @__PURE__ */ new Map(), this.disabledGestures = /* @__PURE__ */ new Map(), this.disabledScroll = /* @__PURE__ */ new Set();
  }
  /**
   * Creates a gesture delegate based on the GestureConfig passed
   */
  createGesture(e) {
    var r;
    return new GestureDelegate(this, this.newID(), e.name, (r = e.priority) !== null && r !== void 0 ? r : 0, !!e.disableScroll);
  }
  /**
   * Creates a blocker that will block any other gesture events from firing. Set in the ion-gesture component.
   */
  createBlocker(e = {}) {
    return new BlockerDelegate(this, this.newID(), e.disable, !!e.disableScroll);
  }
  start(e, r, o) {
    return this.canStart(e) ? (this.requestedStart.set(r, o), !0) : (this.requestedStart.delete(r), !1);
  }
  capture(e, r, o) {
    if (!this.start(e, r, o))
      return !1;
    const a = this.requestedStart;
    let c = -1e4;
    if (a.forEach((u) => {
      c = Math.max(c, u);
    }), c === o) {
      this.capturedId = r, a.clear();
      const u = new CustomEvent("ionGestureCaptured", { detail: { gestureName: e } });
      return document.dispatchEvent(u), !0;
    }
    return a.delete(r), !1;
  }
  release(e) {
    this.requestedStart.delete(e), this.capturedId === e && (this.capturedId = void 0);
  }
  disableGesture(e, r) {
    let o = this.disabledGestures.get(e);
    o === void 0 && (o = /* @__PURE__ */ new Set(), this.disabledGestures.set(e, o)), o.add(r);
  }
  enableGesture(e, r) {
    const o = this.disabledGestures.get(e);
    o !== void 0 && o.delete(r);
  }
  disableScroll(e) {
    this.disabledScroll.add(e), this.disabledScroll.size === 1 && document.body.classList.add(BACKDROP_NO_SCROLL);
  }
  enableScroll(e) {
    this.disabledScroll.delete(e), this.disabledScroll.size === 0 && document.body.classList.remove(BACKDROP_NO_SCROLL);
  }
  canStart(e) {
    return !(this.capturedId !== void 0 || this.isDisabled(e));
  }
  isCaptured() {
    return this.capturedId !== void 0;
  }
  isScrollDisabled() {
    return this.disabledScroll.size > 0;
  }
  isDisabled(e) {
    const r = this.disabledGestures.get(e);
    return !!(r && r.size > 0);
  }
  newID() {
    return this.gestureId++, this.gestureId;
  }
}
class GestureDelegate {
  constructor(e, r, o, a, c) {
    this.id = r, this.name = o, this.disableScroll = c, this.priority = a * 1e6 + r, this.ctrl = e;
  }
  canStart() {
    return this.ctrl ? this.ctrl.canStart(this.name) : !1;
  }
  start() {
    return this.ctrl ? this.ctrl.start(this.name, this.id, this.priority) : !1;
  }
  capture() {
    if (!this.ctrl)
      return !1;
    const e = this.ctrl.capture(this.name, this.id, this.priority);
    return e && this.disableScroll && this.ctrl.disableScroll(this.id), e;
  }
  release() {
    this.ctrl && (this.ctrl.release(this.id), this.disableScroll && this.ctrl.enableScroll(this.id));
  }
  destroy() {
    this.release(), this.ctrl = void 0;
  }
}
class BlockerDelegate {
  constructor(e, r, o, a) {
    this.id = r, this.disable = o, this.disableScroll = a, this.ctrl = e;
  }
  block() {
    if (this.ctrl) {
      if (this.disable)
        for (const e of this.disable)
          this.ctrl.disableGesture(e, this.id);
      this.disableScroll && this.ctrl.disableScroll(this.id);
    }
  }
  unblock() {
    if (this.ctrl) {
      if (this.disable)
        for (const e of this.disable)
          this.ctrl.enableGesture(e, this.id);
      this.disableScroll && this.ctrl.enableScroll(this.id);
    }
  }
  destroy() {
    this.unblock(), this.ctrl = void 0;
  }
}
const BACKDROP_NO_SCROLL = "backdrop-no-scroll", GESTURE_CONTROLLER = new GestureController();
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const backdropIosCss = ":host{left:0;right:0;top:0;bottom:0;display:block;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);contain:strict;cursor:pointer;opacity:0.01;-ms-touch-action:none;touch-action:none;z-index:2}:host(.backdrop-hide){background:transparent}:host(.backdrop-no-tappable){cursor:auto}:host{background-color:var(--ion-backdrop-color, #000)}", backdropMdCss = ":host{left:0;right:0;top:0;bottom:0;display:block;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);contain:strict;cursor:pointer;opacity:0.01;-ms-touch-action:none;touch-action:none;z-index:2}:host(.backdrop-hide){background:transparent}:host(.backdrop-no-tappable){cursor:auto}:host{background-color:var(--ion-backdrop-color, #000)}", Backdrop = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionBackdropTap = createEvent(this, "ionBackdropTap", 7), this.blocker = GESTURE_CONTROLLER.createBlocker({
      disableScroll: !0
    }), this.visible = !0, this.tappable = !0, this.stopPropagation = !0;
  }
  connectedCallback() {
    this.stopPropagation && this.blocker.block();
  }
  disconnectedCallback() {
    this.blocker.unblock();
  }
  onMouseDown(e) {
    this.emitTap(e);
  }
  emitTap(e) {
    this.stopPropagation && (e.preventDefault(), e.stopPropagation()), this.tappable && this.ionBackdropTap.emit();
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { tabindex: "-1", "aria-hidden": "true", class: {
      [e]: !0,
      "backdrop-hide": !this.visible,
      "backdrop-no-tappable": !this.tappable
    } });
  }
  static get style() {
    return {
      ios: backdropIosCss,
      md: backdropMdCss
    };
  }
}, [33, "ion-backdrop", {
  visible: [4],
  tappable: [4],
  stopPropagation: [4, "stop-propagation"]
}, [[2, "click", "onMouseDown"]]]);
function defineCustomElement$R() {
  if (typeof customElements > "u")
    return;
  ["ion-backdrop"].forEach((e) => {
    switch (e) {
      case "ion-backdrop":
        customElements.get(e) || customElements.define(e, Backdrop);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const hostContext = (t, e) => e.closest(t) !== null, createColorClasses$1 = (t, e) => typeof t == "string" && t.length > 0 ? Object.assign({ "ion-color": !0, [`ion-color-${t}`]: !0 }, e) : e, getClassList = (t) => t !== void 0 ? (Array.isArray(t) ? t : t.split(" ")).filter((r) => r != null).map((r) => r.trim()).filter((r) => r !== "") : [], getClassMap = (t) => {
  const e = {};
  return getClassList(t).forEach((r) => e[r] = !0), e;
}, SCHEME = /^[a-z][a-z0-9+\-.]*:/, openURL = async (t, e, r, o) => {
  if (t != null && t[0] !== "#" && !SCHEME.test(t)) {
    const a = document.querySelector("ion-router");
    if (a)
      return e != null && e.preventDefault(), a.push(t, r, o);
  }
  return !1;
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const rippleEffectCss = ":host{left:0;right:0;top:0;bottom:0;position:absolute;contain:strict;pointer-events:none}:host(.unbounded){contain:layout size style}.ripple-effect{border-radius:50%;position:absolute;background-color:currentColor;color:inherit;contain:strict;opacity:0;-webkit-animation:225ms rippleAnimation forwards, 75ms fadeInAnimation forwards;animation:225ms rippleAnimation forwards, 75ms fadeInAnimation forwards;will-change:transform, opacity;pointer-events:none}.fade-out{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1));-webkit-animation:150ms fadeOutAnimation forwards;animation:150ms fadeOutAnimation forwards}@-webkit-keyframes rippleAnimation{from{-webkit-animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1))}}@keyframes rippleAnimation{from{-webkit-animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:translate(var(--translate-end)) scale(var(--final-scale, 1));transform:translate(var(--translate-end)) scale(var(--final-scale, 1))}}@-webkit-keyframes fadeInAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0}to{opacity:0.16}}@keyframes fadeInAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0}to{opacity:0.16}}@-webkit-keyframes fadeOutAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0.16}to{opacity:0}}@keyframes fadeOutAnimation{from{-webkit-animation-timing-function:linear;animation-timing-function:linear;opacity:0.16}to{opacity:0}}", RippleEffect = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.type = "bounded";
  }
  /**
   * Adds the ripple effect to the parent element.
   *
   * @param x The horizontal coordinate of where the ripple should start.
   * @param y The vertical coordinate of where the ripple should start.
   */
  async addRipple(e, r) {
    return new Promise((o) => {
      readTask(() => {
        const a = this.el.getBoundingClientRect(), c = a.width, u = a.height, d = Math.sqrt(c * c + u * u), p = Math.max(u, c), g = this.unbounded ? p : d + PADDING, b = Math.floor(p * INITIAL_ORIGIN_SCALE), x = g / b;
        let w = e - a.left, y = r - a.top;
        this.unbounded && (w = c * 0.5, y = u * 0.5);
        const I = w - b * 0.5, E = y - b * 0.5, T = c * 0.5 - w, C = u * 0.5 - y;
        writeTask(() => {
          const $ = document.createElement("div");
          $.classList.add("ripple-effect");
          const D = $.style;
          D.top = E + "px", D.left = I + "px", D.width = D.height = b + "px", D.setProperty("--final-scale", `${x}`), D.setProperty("--translate-end", `${T}px, ${C}px`), (this.el.shadowRoot || this.el).appendChild($), setTimeout(() => {
            o(() => {
              removeRipple($);
            });
          }, 225 + 100);
        });
      });
    });
  }
  get unbounded() {
    return this.type === "unbounded";
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { role: "presentation", class: {
      [e]: !0,
      unbounded: this.unbounded
    } });
  }
  get el() {
    return this;
  }
  static get style() {
    return rippleEffectCss;
  }
}, [1, "ion-ripple-effect", {
  type: [1],
  addRipple: [64]
}]), removeRipple = (t) => {
  t.classList.add("fade-out"), setTimeout(() => {
    t.remove();
  }, 200);
}, PADDING = 10, INITIAL_ORIGIN_SCALE = 0.5;
function defineCustomElement$Q() {
  if (typeof customElements > "u")
    return;
  ["ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-ripple-effect":
        customElements.get(e) || customElements.define(e, RippleEffect);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const buttonIosCss = ':host{--overflow:hidden;--ripple-color:currentColor;--border-width:initial;--border-color:initial;--border-style:initial;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--box-shadow:none;display:inline-block;width:auto;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:top;vertical-align:-webkit-baseline-middle;-webkit-font-kerning:none;font-kerning:none}:host(.button-disabled){cursor:default;opacity:0.5;pointer-events:none}:host(.button-solid){--background:var(--ion-color-primary, #3880ff);--color:var(--ion-color-primary-contrast, #fff)}:host(.button-outline){--border-color:var(--ion-color-primary, #3880ff);--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-clear){--border-width:0;--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-block){display:block}:host(.button-block) .button-native{margin-left:0;margin-right:0;width:100%;clear:both;contain:content}:host(.button-block) .button-native::after{clear:both}:host(.button-full){display:block}:host(.button-full) .button-native{margin-left:0;margin-right:0;width:100%;contain:content}:host(.button-full:not(.button-round)) .button-native{border-radius:0;border-right-width:0;border-left-width:0}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;width:100%;height:100%;min-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);line-height:1;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:layout style;cursor:pointer;opacity:var(--opacity);overflow:var(--overflow);z-index:0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}.button-native::-moz-focus-inner{border:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}::slotted([slot=start]),::slotted([slot=end]){-ms-flex-negative:0;flex-shrink:0}::slotted(ion-icon){font-size:1.35em;pointer-events:none}::slotted(ion-icon[slot=start]){-webkit-margin-start:-0.3em;margin-inline-start:-0.3em;-webkit-margin-end:0.3em;margin-inline-end:0.3em;margin-top:0;margin-bottom:0}::slotted(ion-icon[slot=end]){-webkit-margin-start:0.3em;margin-inline-start:0.3em;-webkit-margin-end:-0.2em;margin-inline-end:-0.2em;margin-top:0;margin-bottom:0}::slotted(ion-icon[slot=icon-only]){font-size:1.8em}ion-ripple-effect{color:var(--ripple-color)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}:host(.ion-focused){color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){:host(:hover){color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-activated){color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.button-solid.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.button-outline.ion-color) .button-native{border-color:var(--ion-color-base);background:transparent;color:var(--ion-color-base)}:host(.button-clear.ion-color) .button-native{background:transparent;color:var(--ion-color-base)}:host(.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{color:var(--ion-toolbar-color, var(--color))}:host(.button-outline.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{border-color:var(--ion-toolbar-color, var(--color, var(--border-color)))}:host(.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--background));color:var(--ion-toolbar-background, var(--color))}:host(.button-outline.ion-activated.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--color));color:var(--ion-toolbar-background, var(--background), var(--ion-color-primary-contrast, #fff))}:host{--border-radius:14px;--padding-top:13px;--padding-bottom:13px;--padding-start:1em;--padding-end:1em;--transition:background-color, opacity 100ms linear;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px;margin-top:4px;margin-bottom:4px;min-height:3.1em;font-size:min(1rem, 48px);font-weight:500;letter-spacing:0}:host(.button-solid){--background-activated:var(--ion-color-primary-shade, #3171e0);--background-focused:var(--ion-color-primary-shade, #3171e0);--background-hover:var(--ion-color-primary-tint, #4c8dff);--background-activated-opacity:1;--background-focused-opacity:1;--background-hover-opacity:1}:host(.button-outline){--border-radius:14px;--border-width:1px;--border-style:solid;--background-activated:var(--ion-color-primary, #3880ff);--background-focused:var(--ion-color-primary, #3880ff);--background-hover:transparent;--background-focused-opacity:.1;--color-activated:var(--ion-color-primary-contrast, #fff)}:host(.button-clear){--background-activated:transparent;--background-activated-opacity:0;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:transparent;--background-focused-opacity:.1;font-size:min(1.0625rem, 51px);font-weight:normal}:host(.in-buttons){font-size:clamp(17px, 1.0625rem, 21.08px);font-weight:400}:host(.button-large){--border-radius:16px;--padding-top:17px;--padding-start:1em;--padding-end:1em;--padding-bottom:17px;min-height:3.1em;font-size:min(1.25rem, 60px)}:host(.button-small){--border-radius:6px;--padding-top:4px;--padding-start:0.9em;--padding-end:0.9em;--padding-bottom:4px;min-height:2.1em;font-size:min(0.8125rem, 39px)}:host(.button-has-icon-only){--padding-top:0;--padding-bottom:0}:host(.button-round){--border-radius:64px;--padding-top:0;--padding-start:26px;--padding-end:26px;--padding-bottom:0}:host(.button-strong){font-weight:600}:host(.button-outline.ion-focused.ion-color) .button-native,:host(.button-clear.ion-focused.ion-color) .button-native{color:var(--ion-color-base)}:host(.button-outline.ion-focused.ion-color) .button-native::after,:host(.button-clear.ion-focused.ion-color) .button-native::after{background:var(--ion-color-base)}:host(.button-solid.ion-color.ion-focused) .button-native::after{background:var(--ion-color-shade)}@media (any-hover: hover){:host(.button-clear:not(.ion-activated):hover),:host(.button-outline:not(.ion-activated):hover){opacity:0.6}:host(.button-clear.ion-color:hover) .button-native,:host(.button-outline.ion-color:hover) .button-native{color:var(--ion-color-base)}:host(.button-clear.ion-color:hover) .button-native::after,:host(.button-outline.ion-color:hover) .button-native::after{background:transparent}:host(.button-solid.ion-color:hover) .button-native::after{background:var(--ion-color-tint)}:host(:hover.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color):not(.ion-activated)) .button-native::after{background:#fff;opacity:0.1}}:host(.button-clear.ion-activated){opacity:0.4}:host(.button-outline.ion-activated.ion-color) .button-native{color:var(--ion-color-contrast)}:host(.button-outline.ion-activated.ion-color) .button-native::after{background:var(--ion-color-base)}:host(.button-solid.ion-color.ion-activated) .button-native::after{background:var(--ion-color-shade)}', buttonMdCss = `:host{--overflow:hidden;--ripple-color:currentColor;--border-width:initial;--border-color:initial;--border-style:initial;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--box-shadow:none;display:inline-block;width:auto;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:top;vertical-align:-webkit-baseline-middle;-webkit-font-kerning:none;font-kerning:none}:host(.button-disabled){cursor:default;opacity:0.5;pointer-events:none}:host(.button-solid){--background:var(--ion-color-primary, #3880ff);--color:var(--ion-color-primary-contrast, #fff)}:host(.button-outline){--border-color:var(--ion-color-primary, #3880ff);--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-clear){--border-width:0;--background:transparent;--color:var(--ion-color-primary, #3880ff)}:host(.button-block){display:block}:host(.button-block) .button-native{margin-left:0;margin-right:0;width:100%;clear:both;contain:content}:host(.button-block) .button-native::after{clear:both}:host(.button-full){display:block}:host(.button-full) .button-native{margin-left:0;margin-right:0;width:100%;contain:content}:host(.button-full:not(.button-round)) .button-native{border-radius:0;border-right-width:0;border-left-width:0}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;width:100%;height:100%;min-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);line-height:1;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:layout style;cursor:pointer;opacity:var(--opacity);overflow:var(--overflow);z-index:0;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}.button-native::-moz-focus-inner{border:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}::slotted([slot=start]),::slotted([slot=end]){-ms-flex-negative:0;flex-shrink:0}::slotted(ion-icon){font-size:1.35em;pointer-events:none}::slotted(ion-icon[slot=start]){-webkit-margin-start:-0.3em;margin-inline-start:-0.3em;-webkit-margin-end:0.3em;margin-inline-end:0.3em;margin-top:0;margin-bottom:0}::slotted(ion-icon[slot=end]){-webkit-margin-start:0.3em;margin-inline-start:0.3em;-webkit-margin-end:-0.2em;margin-inline-end:-0.2em;margin-top:0;margin-bottom:0}::slotted(ion-icon[slot=icon-only]){font-size:1.8em}ion-ripple-effect{color:var(--ripple-color)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}:host(.ion-focused){color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){:host(:hover){color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-activated){color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.button-solid.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.button-outline.ion-color) .button-native{border-color:var(--ion-color-base);background:transparent;color:var(--ion-color-base)}:host(.button-clear.ion-color) .button-native{background:transparent;color:var(--ion-color-base)}:host(.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{color:var(--ion-toolbar-color, var(--color))}:host(.button-outline.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{border-color:var(--ion-toolbar-color, var(--color, var(--border-color)))}:host(.button-solid.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--background));color:var(--ion-toolbar-background, var(--color))}:host(.button-outline.ion-activated.in-toolbar:not(.ion-color):not(.in-toolbar-color)) .button-native{background:var(--ion-toolbar-color, var(--color));color:var(--ion-toolbar-background, var(--background), var(--ion-color-primary-contrast, #fff))}:host{--border-radius:4px;--padding-top:8px;--padding-bottom:8px;--padding-start:1.1em;--padding-end:1.1em;--transition:box-shadow 280ms cubic-bezier(.4, 0, .2, 1),
                background-color 15ms linear,
                color 15ms linear;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px;margin-top:4px;margin-bottom:4px;min-height:36px;font-size:0.875rem;font-weight:500;letter-spacing:0.06em;text-transform:uppercase}:host(.button-solid){--background-activated:transparent;--background-hover:var(--ion-color-primary-contrast, #fff);--background-focused:var(--ion-color-primary-contrast, #fff);--background-activated-opacity:0;--background-focused-opacity:.24;--background-hover-opacity:.08;--box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}:host(.button-solid.ion-activated){--box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}:host(.button-outline){--border-width:2px;--border-style:solid;--box-shadow:none;--background-activated:transparent;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:var(--ion-color-primary, #3880ff);--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04}:host(.button-outline.ion-activated.ion-color) .button-native{background:transparent}:host(.button-clear){--background-activated:transparent;--background-focused:var(--ion-color-primary, #3880ff);--background-hover:var(--ion-color-primary, #3880ff);--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04}:host(.button-round){--border-radius:64px;--padding-top:0;--padding-start:26px;--padding-end:26px;--padding-bottom:0}:host(.button-large){--padding-top:14px;--padding-start:1em;--padding-end:1em;--padding-bottom:14px;min-height:2.8em;font-size:1.25rem}:host(.button-small){--padding-top:4px;--padding-start:0.9em;--padding-end:0.9em;--padding-bottom:4px;min-height:2.1em;font-size:0.8125rem}:host(.button-has-icon-only){--padding-top:0;--padding-bottom:0}:host(.button-strong){font-weight:bold}::slotted(ion-icon[slot=icon-only]){padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}:host(.button-solid.ion-color.ion-focused) .button-native::after{background:var(--ion-color-contrast)}:host(.button-clear.ion-color.ion-focused) .button-native::after,:host(.button-outline.ion-color.ion-focused) .button-native::after{background:var(--ion-color-base)}@media (any-hover: hover){:host(.button-solid.ion-color:hover) .button-native::after{background:var(--ion-color-contrast)}:host(.button-clear.ion-color:hover) .button-native::after,:host(.button-outline.ion-color:hover) .button-native::after{background:var(--ion-color-base)}}`, Button = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.inItem = !1, this.inListHeader = !1, this.inToolbar = !1, this.formButtonEl = null, this.formEl = null, this.inheritedAttributes = {}, this.handleClick = (e) => {
      const { el: r } = this;
      this.type === "button" ? openURL(this.href, e, this.routerDirection, this.routerAnimation) : hasShadowDom(r) && this.submitForm(e);
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    }, this.color = void 0, this.buttonType = "button", this.disabled = !1, this.expand = void 0, this.fill = void 0, this.routerDirection = "forward", this.routerAnimation = void 0, this.download = void 0, this.href = void 0, this.rel = void 0, this.shape = void 0, this.size = void 0, this.strong = !1, this.target = void 0, this.type = "button", this.form = void 0;
  }
  disabledChanged() {
    const { disabled: e } = this;
    this.formButtonEl && (this.formButtonEl.disabled = e);
  }
  /**
   * This is responsible for rendering a hidden native
   * button element inside the associated form. This allows
   * users to submit a form by pressing "Enter" when a text
   * field inside of the form is focused. The native button
   * rendered inside of `ion-button` is in the Shadow DOM
   * and therefore does not participate in form submission
   * which is why the following code is necessary.
   */
  renderHiddenButton() {
    const e = this.formEl = this.findForm();
    if (e) {
      const { formButtonEl: r } = this;
      if (r !== null && e.contains(r))
        return;
      const o = this.formButtonEl = document.createElement("button");
      o.type = this.type, o.style.display = "none", o.disabled = this.disabled, e.appendChild(o);
    }
  }
  componentWillLoad() {
    this.inToolbar = !!this.el.closest("ion-buttons"), this.inListHeader = !!this.el.closest("ion-list-header"), this.inItem = !!this.el.closest("ion-item") || !!this.el.closest("ion-item-divider"), this.inheritedAttributes = inheritAriaAttributes(this.el);
  }
  get hasIconOnly() {
    return !!this.el.querySelector('[slot="icon-only"]');
  }
  get rippleType() {
    return (this.fill === void 0 || this.fill === "clear") && this.hasIconOnly && this.inToolbar ? "unbounded" : "bounded";
  }
  /**
   * Finds the form element based on the provided `form` selector
   * or element reference provided.
   */
  findForm() {
    const { form: e } = this;
    if (e instanceof HTMLFormElement)
      return e;
    if (typeof e == "string") {
      const r = document.getElementById(e);
      return r ? r instanceof HTMLFormElement ? r : (printIonWarning(`Form with selector: "#${e}" could not be found. Verify that the id is attached to a <form> element.`, this.el), null) : (printIonWarning(`Form with selector: "#${e}" could not be found. Verify that the id is correct and the form is rendered in the DOM.`, this.el), null);
    }
    return e !== void 0 ? (printIonWarning('The provided "form" element is invalid. Verify that the form is a HTMLFormElement and rendered in the DOM.', this.el), null) : this.el.closest("form");
  }
  submitForm(e) {
    this.formEl && this.formButtonEl && (e.preventDefault(), this.formButtonEl.click());
  }
  render() {
    const e = getIonMode$2(this), { buttonType: r, type: o, disabled: a, rel: c, target: u, size: d, href: p, color: g, expand: b, hasIconOnly: x, shape: w, strong: y, inheritedAttributes: I } = this, E = d === void 0 && this.inItem ? "small" : d, T = p === void 0 ? "button" : "a", C = T === "button" ? { type: o } : {
      download: this.download,
      href: p,
      rel: c,
      target: u
    };
    let $ = this.fill;
    return $ == null && ($ = this.inToolbar || this.inListHeader ? "clear" : "solid"), o !== "button" && this.renderHiddenButton(), h(Host, { onClick: this.handleClick, "aria-disabled": a ? "true" : null, class: createColorClasses$1(g, {
      [e]: !0,
      [r]: !0,
      [`${r}-${b}`]: b !== void 0,
      [`${r}-${E}`]: E !== void 0,
      [`${r}-${w}`]: w !== void 0,
      [`${r}-${$}`]: !0,
      [`${r}-strong`]: y,
      "in-toolbar": hostContext("ion-toolbar", this.el),
      "in-toolbar-color": hostContext("ion-toolbar[color]", this.el),
      "in-buttons": hostContext("ion-buttons", this.el),
      "button-has-icon-only": x,
      "button-disabled": a,
      "ion-activatable": !0,
      "ion-focusable": !0
    }) }, h(T, Object.assign({}, C, { class: "button-native", part: "native", disabled: a, onFocus: this.onFocus, onBlur: this.onBlur }, I), h("span", { class: "button-inner" }, h("slot", { name: "icon-only" }), h("slot", { name: "start" }), h("slot", null), h("slot", { name: "end" })), e === "md" && h("ion-ripple-effect", { type: this.rippleType })));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      disabled: ["disabledChanged"]
    };
  }
  static get style() {
    return {
      ios: buttonIosCss,
      md: buttonMdCss
    };
  }
}, [33, "ion-button", {
  color: [513],
  buttonType: [1025, "button-type"],
  disabled: [516],
  expand: [513],
  fill: [1537],
  routerDirection: [1, "router-direction"],
  routerAnimation: [16],
  download: [1],
  href: [1],
  rel: [1],
  shape: [513],
  size: [513],
  strong: [4],
  target: [1],
  type: [1],
  form: [1]
}, void 0, {
  disabled: ["disabledChanged"]
}]);
function defineCustomElement$P() {
  if (typeof customElements > "u")
    return;
  ["ion-button", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-button":
        customElements.get(e) || customElements.define(e, Button);
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$O = defineCustomElement$P;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const buttonsIosCss = ".sc-ion-buttons-ios-h{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:99}.sc-ion-buttons-ios-s ion-button{--padding-top:0;--padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}.sc-ion-buttons-ios-s ion-button{--padding-top:3px;--padding-bottom:3px;--padding-start:5px;--padding-end:5px;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px;min-height:32px}.sc-ion-buttons-ios-s .button-has-icon-only{--padding-top:0;--padding-bottom:0}.sc-ion-buttons-ios-s ion-button:not(.button-round){--border-radius:4px}.sc-ion-buttons-ios-h.ion-color.sc-ion-buttons-ios-s .button,.ion-color .sc-ion-buttons-ios-h.sc-ion-buttons-ios-s .button{--color:initial;--border-color:initial;--background-focused:var(--ion-color-contrast)}.sc-ion-buttons-ios-h.ion-color.sc-ion-buttons-ios-s .button-solid,.ion-color .sc-ion-buttons-ios-h.sc-ion-buttons-ios-s .button-solid{--background:var(--ion-color-contrast);--background-focused:#000;--background-focused-opacity:.12;--background-activated:#000;--background-activated-opacity:.12;--background-hover:var(--ion-color-base);--background-hover-opacity:0.45;--color:var(--ion-color-base);--color-focused:var(--ion-color-base)}.sc-ion-buttons-ios-h.ion-color.sc-ion-buttons-ios-s .button-clear,.ion-color .sc-ion-buttons-ios-h.sc-ion-buttons-ios-s .button-clear{--color-activated:var(--ion-color-contrast);--color-focused:var(--ion-color-contrast)}.sc-ion-buttons-ios-h.ion-color.sc-ion-buttons-ios-s .button-outline,.ion-color .sc-ion-buttons-ios-h.sc-ion-buttons-ios-s .button-outline{--color-activated:var(--ion-color-base);--color-focused:var(--ion-color-contrast);--background-activated:var(--ion-color-contrast)}.sc-ion-buttons-ios-s .button-clear,.sc-ion-buttons-ios-s .button-outline{--background-activated:transparent;--background-focused:currentColor;--background-hover:transparent}.sc-ion-buttons-ios-s .button-solid:not(.ion-color){--background-focused:#000;--background-focused-opacity:.12;--background-activated:#000;--background-activated-opacity:.12}.sc-ion-buttons-ios-s ion-icon[slot=start]{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-margin-end:0.3em;margin-inline-end:0.3em;font-size:1.41em;line-height:0.67}.sc-ion-buttons-ios-s ion-icon[slot=end]{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-margin-start:0.4em;margin-inline-start:0.4em;font-size:1.41em;line-height:0.67}.sc-ion-buttons-ios-s ion-icon[slot=icon-only]{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;font-size:1.65em;line-height:0.67}", buttonsMdCss = ".sc-ion-buttons-md-h{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:99}.sc-ion-buttons-md-s ion-button{--padding-top:0;--padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}.sc-ion-buttons-md-s ion-button{--padding-top:3px;--padding-bottom:3px;--padding-start:8px;--padding-end:8px;--box-shadow:none;-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:2px;margin-inline-end:2px;min-height:32px}.sc-ion-buttons-md-s .button-has-icon-only{--padding-top:0;--padding-bottom:0}.sc-ion-buttons-md-s ion-button:not(.button-round){--border-radius:2px}.sc-ion-buttons-md-h.ion-color.sc-ion-buttons-md-s .button,.ion-color .sc-ion-buttons-md-h.sc-ion-buttons-md-s .button{--color:initial;--color-focused:var(--ion-color-contrast);--color-hover:var(--ion-color-contrast);--background-activated:transparent;--background-focused:var(--ion-color-contrast);--background-hover:var(--ion-color-contrast)}.sc-ion-buttons-md-h.ion-color.sc-ion-buttons-md-s .button-solid,.ion-color .sc-ion-buttons-md-h.sc-ion-buttons-md-s .button-solid{--background:var(--ion-color-contrast);--background-activated:transparent;--background-focused:var(--ion-color-shade);--background-hover:var(--ion-color-base);--color:var(--ion-color-base);--color-focused:var(--ion-color-base);--color-hover:var(--ion-color-base)}.sc-ion-buttons-md-h.ion-color.sc-ion-buttons-md-s .button-outline,.ion-color .sc-ion-buttons-md-h.sc-ion-buttons-md-s .button-outline{--border-color:var(--ion-color-contrast)}.sc-ion-buttons-md-s .button-has-icon-only.button-clear{--padding-top:12px;--padding-end:12px;--padding-bottom:12px;--padding-start:12px;--border-radius:50%;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;width:3rem;height:3rem}.sc-ion-buttons-md-s .button{--background-hover:currentColor}.sc-ion-buttons-md-s .button-solid{--color:var(--ion-toolbar-background, var(--ion-background-color, #fff));--background:var(--ion-toolbar-color, var(--ion-text-color, #424242));--background-activated:transparent;--background-focused:currentColor}.sc-ion-buttons-md-s .button-outline{--color:initial;--background:transparent;--background-activated:transparent;--background-focused:currentColor;--background-hover:currentColor;--border-color:currentColor}.sc-ion-buttons-md-s .button-clear{--color:initial;--background:transparent;--background-activated:transparent;--background-focused:currentColor;--background-hover:currentColor}.sc-ion-buttons-md-s ion-icon[slot=start]{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-margin-end:0.3em;margin-inline-end:0.3em;font-size:1.4em}.sc-ion-buttons-md-s ion-icon[slot=end]{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-margin-start:0.4em;margin-inline-start:0.4em;font-size:1.4em}.sc-ion-buttons-md-s ion-icon[slot=icon-only]{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;font-size:1.8em}", Buttons = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.collapse = !1;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: {
      [e]: !0,
      "buttons-collapse": this.collapse
    } });
  }
  static get style() {
    return {
      ios: buttonsIosCss,
      md: buttonsMdCss
    };
  }
}, [34, "ion-buttons", {
  collapse: [4]
}]);
function defineCustomElement$N() {
  if (typeof customElements > "u")
    return;
  ["ion-buttons"].forEach((e) => {
    switch (e) {
      case "ion-buttons":
        customElements.get(e) || customElements.define(e, Buttons);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$M = defineCustomElement$N;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cardIosCss = ":host{--ion-safe-area-left:0px;--ion-safe-area-right:0px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.card-disabled){cursor:default;opacity:0.3;pointer-events:none}.card-native{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:inherit}.card-native::-moz-focus-inner{border:0}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}ion-ripple-effect{color:var(--ripple-color)}:host{--background:var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));--color:var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-600, #666666)));-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:24px;margin-bottom:24px;border-radius:8px;-webkit-transition:-webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:-webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);transition:transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1), -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1);font-size:0.875rem;-webkit-box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);box-shadow:0 4px 16px rgba(0, 0, 0, 0.12)}:host(.ion-activated){-webkit-transform:scale3d(0.97, 0.97, 1);transform:scale3d(0.97, 0.97, 1)}", cardMdCss = ":host{--ion-safe-area-left:0px;--ion-safe-area-right:0px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.card-disabled){cursor:default;opacity:0.3;pointer-events:none}.card-native{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:inherit}.card-native::-moz-focus-inner{border:0}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}ion-ripple-effect{color:var(--ripple-color)}:host{--background:var(--ion-card-background, var(--ion-item-background, var(--ion-background-color, #fff)));--color:var(--ion-card-color, var(--ion-item-color, var(--ion-color-step-550, #737373)));-webkit-margin-start:10px;margin-inline-start:10px;-webkit-margin-end:10px;margin-inline-end:10px;margin-top:10px;margin-bottom:10px;border-radius:4px;font-size:0.875rem;-webkit-box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}", Card = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inheritedAriaAttributes = {}, this.color = void 0, this.button = !1, this.type = "button", this.disabled = !1, this.download = void 0, this.href = void 0, this.rel = void 0, this.routerDirection = "forward", this.routerAnimation = void 0, this.target = void 0;
  }
  componentWillLoad() {
    this.inheritedAriaAttributes = inheritAttributes$2(this.el, ["aria-label"]);
  }
  isClickable() {
    return this.href !== void 0 || this.button;
  }
  renderCard(e) {
    const r = this.isClickable();
    if (!r)
      return [h("slot", null)];
    const { href: o, routerAnimation: a, routerDirection: c, inheritedAriaAttributes: u } = this, d = r ? o === void 0 ? "button" : "a" : "div", p = d === "button" ? { type: this.type } : {
      download: this.download,
      href: this.href,
      rel: this.rel,
      target: this.target
    };
    return h(d, Object.assign({}, p, u, { class: "card-native", part: "native", disabled: this.disabled, onClick: (g) => openURL(o, g, c, a) }), h("slot", null), r && e === "md" && h("ion-ripple-effect", null));
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: createColorClasses$1(this.color, {
      [e]: !0,
      "card-disabled": this.disabled,
      "ion-activatable": this.isClickable()
    }) }, this.renderCard(e));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: cardIosCss,
      md: cardMdCss
    };
  }
}, [33, "ion-card", {
  color: [513],
  button: [4],
  type: [1],
  disabled: [4],
  download: [1],
  href: [1],
  rel: [1],
  routerDirection: [1, "router-direction"],
  routerAnimation: [16],
  target: [1]
}]);
function defineCustomElement$1$p() {
  if (typeof customElements > "u")
    return;
  ["ion-card", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-card":
        customElements.get(e) || customElements.define(e, Card);
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$L = defineCustomElement$1$p;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cardContentIosCss = "ion-card-content{display:block;position:relative}.card-content-ios{-webkit-padding-start:20px;padding-inline-start:20px;-webkit-padding-end:20px;padding-inline-end:20px;padding-top:20px;padding-bottom:20px;font-size:1rem;line-height:1.4}.card-content-ios h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:1.5rem;font-weight:normal}.card-content-ios h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:1rem;font-weight:normal}.card-content-ios h3,.card-content-ios h4,.card-content-ios h5,.card-content-ios h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:0.875rem;font-weight:normal}.card-content-ios p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:0.875rem}ion-card-header+.card-content-ios{padding-top:0}", cardContentMdCss = "ion-card-content{display:block;position:relative}.card-content-md{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:13px;padding-bottom:13px;font-size:0.875rem;line-height:1.5}.card-content-md h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:1.5rem;font-weight:normal}.card-content-md h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:1rem;font-weight:normal}.card-content-md h3,.card-content-md h4,.card-content-md h5,.card-content-md h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:0.875rem;font-weight:normal}.card-content-md p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:0.875rem;font-weight:normal;line-height:1.5}ion-card-header+.card-content-md{padding-top:0}", CardContent = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost();
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: {
      [e]: !0,
      // Used internally for styling
      [`card-content-${e}`]: !0
    } });
  }
  static get style() {
    return {
      ios: cardContentIosCss,
      md: cardContentMdCss
    };
  }
}, [32, "ion-card-content"]);
function defineCustomElement$1$o() {
  if (typeof customElements > "u")
    return;
  ["ion-card-content"].forEach((e) => {
    switch (e) {
      case "ion-card-content":
        customElements.get(e) || customElements.define(e, CardContent);
        break;
    }
  });
}
const defineCustomElement$K = defineCustomElement$1$o;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cardHeaderIosCss = ":host{--background:transparent;--color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;background:var(--background);color:var(--color)}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{-webkit-padding-start:20px;padding-inline-start:20px;-webkit-padding-end:20px;padding-inline-end:20px;padding-top:20px;padding-bottom:16px;-ms-flex-direction:column-reverse;flex-direction:column-reverse}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.card-header-translucent){background-color:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.9);-webkit-backdrop-filter:saturate(180%) blur(30px);backdrop-filter:saturate(180%) blur(30px)}}", cardHeaderMdCss = ":host{--background:transparent;--color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;background:var(--background);color:var(--color)}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:16px;padding-bottom:16px}::slotted(ion-card-title:not(:first-child)),::slotted(ion-card-subtitle:not(:first-child)){margin-top:8px}", CardHeader = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0, this.translucent = !1;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: createColorClasses$1(this.color, {
      "card-header-translucent": this.translucent,
      "ion-inherit-color": !0,
      [e]: !0
    }) }, h("slot", null));
  }
  static get style() {
    return {
      ios: cardHeaderIosCss,
      md: cardHeaderMdCss
    };
  }
}, [33, "ion-card-header", {
  color: [513],
  translucent: [4]
}]);
function defineCustomElement$1$n() {
  if (typeof customElements > "u")
    return;
  ["ion-card-header"].forEach((e) => {
    switch (e) {
      case "ion-card-header":
        customElements.get(e) || customElements.define(e, CardHeader);
        break;
    }
  });
}
const defineCustomElement$J = defineCustomElement$1$n;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cardSubtitleIosCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-600, #666666);margin-left:0;margin-right:0;margin-top:0;margin-bottom:4px;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:0.75rem;font-weight:700;letter-spacing:0.4px;text-transform:uppercase}", cardSubtitleMdCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-550, #737373);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:0.875rem;font-weight:500}", CardSubtitle = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { role: "heading", "aria-level": "3", class: createColorClasses$1(this.color, {
      "ion-inherit-color": !0,
      [e]: !0
    }) }, h("slot", null));
  }
  static get style() {
    return {
      ios: cardSubtitleIosCss,
      md: cardSubtitleMdCss
    };
  }
}, [33, "ion-card-subtitle", {
  color: [513]
}]);
function defineCustomElement$1$m() {
  if (typeof customElements > "u")
    return;
  ["ion-card-subtitle"].forEach((e) => {
    switch (e) {
      case "ion-card-subtitle":
        customElements.get(e) || customElements.define(e, CardSubtitle);
        break;
    }
  });
}
const defineCustomElement$I = defineCustomElement$1$m;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const cardTitleIosCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-text-color, #000);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:1.75rem;font-weight:700;line-height:1.2}", cardTitleMdCss = ":host{display:block;position:relative;color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-850, #262626);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-size:1.25rem;font-weight:500;line-height:1.2}", CardTitle = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { role: "heading", "aria-level": "2", class: createColorClasses$1(this.color, {
      "ion-inherit-color": !0,
      [e]: !0
    }) }, h("slot", null));
  }
  static get style() {
    return {
      ios: cardTitleIosCss,
      md: cardTitleMdCss
    };
  }
}, [33, "ion-card-title", {
  color: [513]
}]);
function defineCustomElement$1$l() {
  if (typeof customElements > "u")
    return;
  ["ion-card-title"].forEach((e) => {
    switch (e) {
      case "ion-card-title":
        customElements.get(e) || customElements.define(e, CardTitle);
        break;
    }
  });
}
const defineCustomElement$H = defineCustomElement$1$l;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const createLegacyFormController = (t) => {
  const e = t;
  let r;
  return { hasLegacyControl: () => {
    if (r === void 0) {
      const a = e.label !== void 0 || hasLabelSlot(e), c = e.hasAttribute("aria-label") || // Shadow DOM form controls cannot use aria-labelledby
      e.hasAttribute("aria-labelledby") && e.shadowRoot === null, u = findItemLabel(e);
      r = e.legacy === !0 || !a && !c && u !== null;
    }
    return r;
  } };
}, hasLabelSlot = (t) => !!(NAMED_LABEL_SLOT_COMPONENTS.includes(t.tagName) && t.querySelector('[slot="label"]') !== null || UNNAMED_LABEL_SLOT_COMPONENTS.includes(t.tagName) && t.textContent !== ""), NAMED_LABEL_SLOT_COMPONENTS = ["ION-INPUT", "ION-TEXTAREA", "ION-SELECT", "ION-RANGE"], UNNAMED_LABEL_SLOT_COMPONENTS = ["ION-TOGGLE", "ION-CHECKBOX", "ION-RADIO"];
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const checkboxIosCss = ":host{--checkbox-background-checked:var(--ion-color-primary, #3880ff);--border-color-checked:var(--ion-color-primary, #3880ff);--checkmark-color:var(--ion-color-primary-contrast, #fff);--checkmark-width:1;--transition:none;display:inline-block;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.in-item){width:100%;height:100%}:host([slot=start]:not(.legacy-checkbox)),:host([slot=end]:not(.legacy-checkbox)){width:auto}:host(.legacy-checkbox){width:var(--size);height:var(--size)}:host(.ion-color){--checkbox-background-checked:var(--ion-color-base);--border-color-checked:var(--ion-color-base);--checkmark-color:var(--ion-color-contrast)}:host(.legacy-checkbox) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-checkbox) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-checkbox) label{left:0}:host-context([dir=rtl]):host(.legacy-checkbox) label,:host-context([dir=rtl]).legacy-checkbox label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-checkbox:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-checkbox) label::-moz-focus-inner{border:0}.checkbox-wrapper{display:-ms-flexbox;display:flex;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;cursor:inherit}.label-text-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}:host(.in-item:not(.legacy-checkbox)) .label-text-wrapper{margin-top:10px;margin-bottom:10px}:host(.in-item.checkbox-label-placement-stacked) .label-text-wrapper{margin-top:10px;margin-bottom:16px}:host(.in-item.checkbox-label-placement-stacked) .native-wrapper{margin-bottom:10px}.label-text-wrapper-hidden{display:none}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.checkbox-icon{border-radius:var(--border-radius);position:relative;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--checkbox-background);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.legacy-checkbox) .checkbox-icon{display:block;width:100%;height:100%}:host(:not(.legacy-checkbox)) .checkbox-icon{width:var(--size);height:var(--size)}.checkbox-icon path{fill:none;stroke:var(--checkmark-color);stroke-width:var(--checkmark-width);opacity:0}:host(.checkbox-justify-space-between) .checkbox-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.checkbox-justify-start) .checkbox-wrapper{-ms-flex-pack:start;justify-content:start}:host(.checkbox-justify-end) .checkbox-wrapper{-ms-flex-pack:end;justify-content:end}:host(.checkbox-alignment-start) .checkbox-wrapper{-ms-flex-align:start;align-items:start}:host(.checkbox-alignment-center) .checkbox-wrapper{-ms-flex-align:center;align-items:center}:host(.checkbox-label-placement-start) .checkbox-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.checkbox-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.checkbox-label-placement-end) .checkbox-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.checkbox-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.checkbox-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.checkbox-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}:host(.checkbox-label-placement-stacked) .checkbox-wrapper{-ms-flex-direction:column;flex-direction:column}:host(.checkbox-label-placement-stacked) .label-text-wrapper{-webkit-transform:scale(0.75);transform:scale(0.75);margin-left:0;margin-right:0;margin-bottom:16px;max-width:calc(100% / 0.75)}:host(.checkbox-label-placement-stacked.checkbox-alignment-start) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host-context([dir=rtl]):host(.checkbox-label-placement-stacked.checkbox-alignment-start) .label-text-wrapper,:host-context([dir=rtl]).checkbox-label-placement-stacked.checkbox-alignment-start .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){:host(.checkbox-label-placement-stacked.checkbox-alignment-start:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}}:host(.checkbox-label-placement-stacked.checkbox-alignment-center) .label-text-wrapper{-webkit-transform-origin:center top;transform-origin:center top}:host-context([dir=rtl]):host(.checkbox-label-placement-stacked.checkbox-alignment-center) .label-text-wrapper,:host-context([dir=rtl]).checkbox-label-placement-stacked.checkbox-alignment-center .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}@supports selector(:dir(rtl)){:host(.checkbox-label-placement-stacked.checkbox-alignment-center:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}}:host(.checkbox-checked) .checkbox-icon,:host(.checkbox-indeterminate) .checkbox-icon{border-color:var(--border-color-checked);background:var(--checkbox-background-checked)}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{opacity:1}:host(.checkbox-disabled){pointer-events:none}:host{--border-radius:50%;--border-width:0.0625rem;--border-style:solid;--border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.23);--checkbox-background:var(--ion-item-background, var(--ion-background-color, #fff));--size:min(1.625rem, 65.988px)}:host(.checkbox-disabled){opacity:0.3}:host(.in-item.legacy-checkbox){-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:10px;margin-bottom:9px;display:block;position:static}:host(.in-item.legacy-checkbox[slot=start]){-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:8px;margin-bottom:8px}", checkboxMdCss = ":host{--checkbox-background-checked:var(--ion-color-primary, #3880ff);--border-color-checked:var(--ion-color-primary, #3880ff);--checkmark-color:var(--ion-color-primary-contrast, #fff);--checkmark-width:1;--transition:none;display:inline-block;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(.in-item){width:100%;height:100%}:host([slot=start]:not(.legacy-checkbox)),:host([slot=end]:not(.legacy-checkbox)){width:auto}:host(.legacy-checkbox){width:var(--size);height:var(--size)}:host(.ion-color){--checkbox-background-checked:var(--ion-color-base);--border-color-checked:var(--ion-color-base);--checkmark-color:var(--ion-color-contrast)}:host(.legacy-checkbox) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-checkbox) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-checkbox) label{left:0}:host-context([dir=rtl]):host(.legacy-checkbox) label,:host-context([dir=rtl]).legacy-checkbox label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-checkbox:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-checkbox) label::-moz-focus-inner{border:0}.checkbox-wrapper{display:-ms-flexbox;display:flex;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;cursor:inherit}.label-text-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}:host(.in-item:not(.legacy-checkbox)) .label-text-wrapper{margin-top:10px;margin-bottom:10px}:host(.in-item.checkbox-label-placement-stacked) .label-text-wrapper{margin-top:10px;margin-bottom:16px}:host(.in-item.checkbox-label-placement-stacked) .native-wrapper{margin-bottom:10px}.label-text-wrapper-hidden{display:none}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.checkbox-icon{border-radius:var(--border-radius);position:relative;-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--checkbox-background);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.legacy-checkbox) .checkbox-icon{display:block;width:100%;height:100%}:host(:not(.legacy-checkbox)) .checkbox-icon{width:var(--size);height:var(--size)}.checkbox-icon path{fill:none;stroke:var(--checkmark-color);stroke-width:var(--checkmark-width);opacity:0}:host(.checkbox-justify-space-between) .checkbox-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.checkbox-justify-start) .checkbox-wrapper{-ms-flex-pack:start;justify-content:start}:host(.checkbox-justify-end) .checkbox-wrapper{-ms-flex-pack:end;justify-content:end}:host(.checkbox-alignment-start) .checkbox-wrapper{-ms-flex-align:start;align-items:start}:host(.checkbox-alignment-center) .checkbox-wrapper{-ms-flex-align:center;align-items:center}:host(.checkbox-label-placement-start) .checkbox-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.checkbox-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.checkbox-label-placement-end) .checkbox-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.checkbox-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.checkbox-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.checkbox-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}:host(.checkbox-label-placement-stacked) .checkbox-wrapper{-ms-flex-direction:column;flex-direction:column}:host(.checkbox-label-placement-stacked) .label-text-wrapper{-webkit-transform:scale(0.75);transform:scale(0.75);margin-left:0;margin-right:0;margin-bottom:16px;max-width:calc(100% / 0.75)}:host(.checkbox-label-placement-stacked.checkbox-alignment-start) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host-context([dir=rtl]):host(.checkbox-label-placement-stacked.checkbox-alignment-start) .label-text-wrapper,:host-context([dir=rtl]).checkbox-label-placement-stacked.checkbox-alignment-start .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){:host(.checkbox-label-placement-stacked.checkbox-alignment-start:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}}:host(.checkbox-label-placement-stacked.checkbox-alignment-center) .label-text-wrapper{-webkit-transform-origin:center top;transform-origin:center top}:host-context([dir=rtl]):host(.checkbox-label-placement-stacked.checkbox-alignment-center) .label-text-wrapper,:host-context([dir=rtl]).checkbox-label-placement-stacked.checkbox-alignment-center .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}@supports selector(:dir(rtl)){:host(.checkbox-label-placement-stacked.checkbox-alignment-center:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}}:host(.checkbox-checked) .checkbox-icon,:host(.checkbox-indeterminate) .checkbox-icon{border-color:var(--border-color-checked);background:var(--checkbox-background-checked)}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{opacity:1}:host(.checkbox-disabled){pointer-events:none}:host{--border-radius:calc(var(--size) * .125);--border-width:2px;--border-style:solid;--border-color:rgb(var(--ion-text-color-rgb, 0, 0, 0), 0.6);--checkmark-width:3;--checkbox-background:var(--ion-item-background, var(--ion-background-color, #fff));--transition:background 180ms cubic-bezier(0.4, 0, 0.2, 1);--size:18px}.checkbox-icon path{stroke-dasharray:30;stroke-dashoffset:30}:host(.checkbox-checked) .checkbox-icon path,:host(.checkbox-indeterminate) .checkbox-icon path{stroke-dashoffset:0;-webkit-transition:stroke-dashoffset 90ms linear 90ms;transition:stroke-dashoffset 90ms linear 90ms}:host(.legacy-checkbox.checkbox-disabled),:host(.checkbox-disabled) .label-text-wrapper{opacity:0.38}:host(.checkbox-disabled) .native-wrapper{opacity:0.63}:host(.in-item.legacy-checkbox){margin-left:0;margin-right:0;margin-top:18px;margin-bottom:18px;display:block;position:static}:host(.in-item.legacy-checkbox[slot=start]){-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:36px;margin-inline-end:36px;margin-top:18px;margin-bottom:18px}", Checkbox = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionChange = createEvent(this, "ionChange", 7), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.ionStyle = createEvent(this, "ionStyle", 7), this.inputId = `ion-cb-${checkboxIds++}`, this.inheritedAttributes = {}, this.hasLoggedDeprecationWarning = !1, this.setChecked = (e) => {
      const r = this.checked = e;
      this.ionChange.emit({
        checked: r,
        value: this.value
      });
    }, this.toggleChecked = (e) => {
      e.preventDefault(), this.setFocus(), this.setChecked(!this.checked), this.indeterminate = !1;
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    }, this.onClick = (e) => {
      this.disabled || this.toggleChecked(e);
    }, this.color = void 0, this.name = this.inputId, this.checked = !1, this.indeterminate = !1, this.disabled = !1, this.value = "on", this.labelPlacement = "start", this.justify = "space-between", this.alignment = "center", this.legacy = void 0;
  }
  connectedCallback() {
    this.legacyFormController = createLegacyFormController(this.el);
  }
  componentWillLoad() {
    this.emitStyle(), this.legacyFormController.hasLegacyControl() || (this.inheritedAttributes = Object.assign({}, inheritAriaAttributes(this.el)));
  }
  styleChanged() {
    this.emitStyle();
  }
  emitStyle() {
    const e = {
      "interactive-disabled": this.disabled,
      // TODO(FW-3100): remove this
      legacy: !!this.legacy
    };
    this.legacyFormController.hasLegacyControl() && (e["checkbox-checked"] = this.checked), this.ionStyle.emit(e);
  }
  setFocus() {
    this.focusEl && this.focusEl.focus();
  }
  // TODO(FW-3100): run contents of renderCheckbox directly instead
  render() {
    const { legacyFormController: e } = this;
    return e.hasLegacyControl() ? this.renderLegacyCheckbox() : this.renderCheckbox();
  }
  renderCheckbox() {
    const { color: e, checked: r, disabled: o, el: a, getSVGPath: c, indeterminate: u, inheritedAttributes: d, inputId: p, justify: g, labelPlacement: b, name: x, value: w, alignment: y } = this, I = getIonMode$2(this), E = c(I, u);
    return renderHiddenInput(!0, a, x, r ? w : "", o), h(Host, { class: createColorClasses$1(e, {
      [I]: !0,
      "in-item": hostContext("ion-item", a),
      "checkbox-checked": r,
      "checkbox-disabled": o,
      "checkbox-indeterminate": u,
      interactive: !0,
      [`checkbox-justify-${g}`]: !0,
      [`checkbox-alignment-${y}`]: !0,
      [`checkbox-label-placement-${b}`]: !0
    }), onClick: this.onClick }, h("label", { class: "checkbox-wrapper" }, h("input", Object.assign({ type: "checkbox", checked: r ? !0 : void 0, disabled: o, id: p, onChange: this.toggleChecked, onFocus: () => this.onFocus(), onBlur: () => this.onBlur(), ref: (T) => this.focusEl = T }, d)), h("div", { class: {
      "label-text-wrapper": !0,
      "label-text-wrapper-hidden": a.textContent === ""
    }, part: "label" }, h("slot", null)), h("div", { class: "native-wrapper" }, h("svg", { class: "checkbox-icon", viewBox: "0 0 24 24", part: "container" }, E))));
  }
  // TODO(FW-3100): remove this
  renderLegacyCheckbox() {
    this.hasLoggedDeprecationWarning || (printIonWarning(`ion-checkbox now requires providing a label with either the default slot or the "aria-label" attribute. To migrate, remove any usage of "ion-label" and pass the label text to either the component or the "aria-label" attribute.

Example: <ion-checkbox>Label</ion-checkbox>
Example with aria-label: <ion-checkbox aria-label="Label"></ion-checkbox>

Developers can use the "legacy" property to continue using the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.`, this.el), this.legacy && printIonWarning(`ion-checkbox is being used with the "legacy" property enabled which will forcibly enable the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.
Developers can dismiss this warning by removing their usage of the "legacy" property and using the new checkbox syntax.`, this.el), this.hasLoggedDeprecationWarning = !0);
    const { color: e, checked: r, disabled: o, el: a, getSVGPath: c, indeterminate: u, inputId: d, name: p, value: g } = this, b = getIonMode$2(this), { label: x, labelId: w, labelText: y } = getAriaLabel(a, d), I = c(b, u);
    return renderHiddenInput(!0, a, p, r ? g : "", o), h(Host, { "aria-labelledby": x ? w : null, "aria-checked": `${r}`, "aria-hidden": o ? "true" : null, role: "checkbox", class: createColorClasses$1(e, {
      [b]: !0,
      "in-item": hostContext("ion-item", a),
      "checkbox-checked": r,
      "checkbox-disabled": o,
      "checkbox-indeterminate": u,
      "legacy-checkbox": !0,
      interactive: !0
    }), onClick: this.onClick }, h("svg", { class: "checkbox-icon", viewBox: "0 0 24 24", part: "container" }, I), h("label", { htmlFor: d }, y), h("input", { type: "checkbox", "aria-checked": `${r}`, disabled: o, id: d, onChange: this.toggleChecked, onFocus: () => this.onFocus(), onBlur: () => this.onBlur(), ref: (E) => this.focusEl = E }));
  }
  getSVGPath(e, r) {
    let o = r ? h("path", { d: "M6 12L18 12", part: "mark" }) : h("path", { d: "M5.9,12.5l3.8,3.8l8.8-8.8", part: "mark" });
    return e === "md" && (o = r ? h("path", { d: "M2 12H22", part: "mark" }) : h("path", { d: "M1.73,12.91 8.1,19.28 22.79,4.59", part: "mark" })), o;
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      checked: ["styleChanged"],
      disabled: ["styleChanged"]
    };
  }
  static get style() {
    return {
      ios: checkboxIosCss,
      md: checkboxMdCss
    };
  }
}, [33, "ion-checkbox", {
  color: [513],
  name: [1],
  checked: [1028],
  indeterminate: [1028],
  disabled: [4],
  value: [8],
  labelPlacement: [1, "label-placement"],
  justify: [1],
  alignment: [1],
  legacy: [4]
}, void 0, {
  checked: ["styleChanged"],
  disabled: ["styleChanged"]
}]);
let checkboxIds = 0;
function defineCustomElement$G() {
  if (typeof customElements > "u")
    return;
  ["ion-checkbox"].forEach((e) => {
    switch (e) {
      case "ion-checkbox":
        customElements.get(e) || customElements.define(e, Checkbox);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const chipIosCss = ":host{--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.12);--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);border-radius:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:4px;margin-inline-end:4px;margin-top:4px;margin-bottom:4px;-webkit-padding-start:12px;padding-inline-start:12px;-webkit-padding-end:12px;padding-inline-end:12px;padding-top:6px;padding-bottom:6px;display:-ms-inline-flexbox;display:inline-flex;position:relative;-ms-flex-align:center;align-items:center;min-height:32px;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);cursor:pointer;overflow:hidden;vertical-align:middle;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.chip-disabled){cursor:default;opacity:0.4;pointer-events:none}:host(.ion-color){background:rgba(var(--ion-color-base-rgb), 0.08);color:var(--ion-color-shade)}:host(.ion-color:focus){background:rgba(var(--ion-color-base-rgb), 0.12)}:host(.ion-color.ion-activated){background:rgba(var(--ion-color-base-rgb), 0.16)}:host(.chip-outline){border-width:1px;border-style:solid}:host(.chip-outline){border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.32);background:transparent}:host(.chip-outline.ion-color){border-color:rgba(var(--ion-color-base-rgb), 0.32)}:host(.chip-outline:not(.ion-color):focus){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.04)}:host(.chip-outline.ion-activated:not(.ion-color)){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)}::slotted(ion-icon){font-size:1.4285714286em}:host(:not(.ion-color)) ::slotted(ion-icon){color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)}::slotted(ion-icon:first-child){-webkit-margin-start:-4px;margin-inline-start:-4px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-icon:last-child){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:-4px;margin-inline-end:-4px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-avatar){-ms-flex-negative:0;flex-shrink:0;width:1.7142857143em;height:1.7142857143em}::slotted(ion-avatar:first-child){-webkit-margin-start:-8px;margin-inline-start:-8px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-avatar:last-child){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:-8px;margin-inline-end:-8px;margin-top:-4px;margin-bottom:-4px}:host(:focus){outline:none}:host(:focus){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.16)}:host(.ion-activated){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}@media (any-hover: hover){:host(:hover){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.16)}:host(.ion-color:hover){background:rgba(var(--ion-color-base-rgb), 0.12)}:host(.chip-outline:not(.ion-color):hover){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.04)}}:host{font-size:clamp(13px, 0.875rem, 22px)}", chipMdCss = ":host{--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.12);--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.87);border-radius:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:4px;margin-inline-end:4px;margin-top:4px;margin-bottom:4px;-webkit-padding-start:12px;padding-inline-start:12px;-webkit-padding-end:12px;padding-inline-end:12px;padding-top:6px;padding-bottom:6px;display:-ms-inline-flexbox;display:inline-flex;position:relative;-ms-flex-align:center;align-items:center;min-height:32px;background:var(--background);color:var(--color);font-family:var(--ion-font-family, inherit);cursor:pointer;overflow:hidden;vertical-align:middle;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.chip-disabled){cursor:default;opacity:0.4;pointer-events:none}:host(.ion-color){background:rgba(var(--ion-color-base-rgb), 0.08);color:var(--ion-color-shade)}:host(.ion-color:focus){background:rgba(var(--ion-color-base-rgb), 0.12)}:host(.ion-color.ion-activated){background:rgba(var(--ion-color-base-rgb), 0.16)}:host(.chip-outline){border-width:1px;border-style:solid}:host(.chip-outline){border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.32);background:transparent}:host(.chip-outline.ion-color){border-color:rgba(var(--ion-color-base-rgb), 0.32)}:host(.chip-outline:not(.ion-color):focus){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.04)}:host(.chip-outline.ion-activated:not(.ion-color)){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)}::slotted(ion-icon){font-size:1.4285714286em}:host(:not(.ion-color)) ::slotted(ion-icon){color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)}::slotted(ion-icon:first-child){-webkit-margin-start:-4px;margin-inline-start:-4px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-icon:last-child){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:-4px;margin-inline-end:-4px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-avatar){-ms-flex-negative:0;flex-shrink:0;width:1.7142857143em;height:1.7142857143em}::slotted(ion-avatar:first-child){-webkit-margin-start:-8px;margin-inline-start:-8px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:-4px;margin-bottom:-4px}::slotted(ion-avatar:last-child){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:-8px;margin-inline-end:-8px;margin-top:-4px;margin-bottom:-4px}:host(:focus){outline:none}:host(:focus){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.16)}:host(.ion-activated){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}@media (any-hover: hover){:host(:hover){--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.16)}:host(.ion-color:hover){background:rgba(var(--ion-color-base-rgb), 0.12)}:host(.chip-outline:not(.ion-color):hover){background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.04)}}:host{font-size:0.875rem}", Chip = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0, this.outline = !1, this.disabled = !1;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { "aria-disabled": this.disabled ? "true" : null, class: createColorClasses$1(this.color, {
      [e]: !0,
      "chip-outline": this.outline,
      "chip-disabled": this.disabled,
      "ion-activatable": !0
    }) }, h("slot", null), e === "md" && h("ion-ripple-effect", null));
  }
  static get style() {
    return {
      ios: chipIosCss,
      md: chipMdCss
    };
  }
}, [33, "ion-chip", {
  color: [513],
  outline: [4],
  disabled: [4]
}]);
function defineCustomElement$1$k() {
  if (typeof customElements > "u")
    return;
  ["ion-chip", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-chip":
        customElements.get(e) || customElements.define(e, Chip);
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$F = defineCustomElement$1$k;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const win$1 = typeof window < "u" ? window : void 0;
win$1 && (win$1.CSS && win$1.CSS.supports && win$1.CSS.supports("--a: 0"));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const isRTL$1 = (t) => t && t.dir !== "" ? t.dir.toLowerCase() === "rtl" : (document == null ? void 0 : document.dir.toLowerCase()) === "rtl";
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const contentCss = ':host{--background:var(--ion-background-color, #fff);--color:var(--ion-text-color, #000);--padding-top:0px;--padding-bottom:0px;--padding-start:0px;--padding-end:0px;--keyboard-offset:0px;--offset-top:0px;--offset-bottom:0px;--overflow:auto;display:block;position:relative;-ms-flex:1;flex:1;width:100%;height:100%;margin:0 !important;padding:0 !important;font-family:var(--ion-font-family, inherit);contain:size style}:host(.ion-color) .inner-scroll{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.outer-content){--background:var(--ion-color-step-50, #f2f2f2)}#background-content{left:0px;right:0px;top:calc(var(--offset-top) * -1);bottom:calc(var(--offset-bottom) * -1);position:absolute;background:var(--background)}.inner-scroll{left:0px;right:0px;top:calc(var(--offset-top) * -1);bottom:calc(var(--offset-bottom) * -1);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:calc(var(--padding-top) + var(--offset-top));padding-bottom:calc(var(--padding-bottom) + var(--keyboard-offset) + var(--offset-bottom));position:absolute;color:var(--color);-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;-ms-touch-action:pan-x pan-y pinch-zoom;touch-action:pan-x pan-y pinch-zoom}.scroll-y,.scroll-x{-webkit-overflow-scrolling:touch;z-index:0;will-change:scroll-position}.scroll-y{overflow-y:var(--overflow);overscroll-behavior-y:contain}.scroll-x{overflow-x:var(--overflow);overscroll-behavior-x:contain}.overscroll::before,.overscroll::after{position:absolute;width:1px;height:1px;content:""}.overscroll::before{bottom:-1px}.overscroll::after{top:-1px}:host(.content-sizing){display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-height:0;contain:none}:host(.content-sizing) .inner-scroll{position:relative;top:0;bottom:0;margin-top:calc(var(--offset-top) * -1);margin-bottom:calc(var(--offset-bottom) * -1)}.transition-effect{display:none;position:absolute;width:100%;height:100vh;opacity:0;pointer-events:none}:host(.content-ltr) .transition-effect{left:-100%;}:host(.content-rtl) .transition-effect{right:-100%;}.transition-cover{position:absolute;right:0;width:100%;height:100%;background:black;opacity:0.1}.transition-shadow{display:block;position:absolute;width:100%;height:100%;-webkit-box-shadow:inset -9px 0 9px 0 rgba(0, 0, 100, 0.03);box-shadow:inset -9px 0 9px 0 rgba(0, 0, 100, 0.03)}:host(.content-ltr) .transition-shadow{right:0;}:host(.content-rtl) .transition-shadow{left:0;-webkit-transform:scaleX(-1);transform:scaleX(-1)}::slotted([slot=fixed]){position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0)}', Content = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionScrollStart = createEvent(this, "ionScrollStart", 7), this.ionScroll = createEvent(this, "ionScroll", 7), this.ionScrollEnd = createEvent(this, "ionScrollEnd", 7), this.watchDog = null, this.isScrolling = !1, this.lastScroll = 0, this.queued = !1, this.cTop = -1, this.cBottom = -1, this.isMainContent = !0, this.resizeTimeout = null, this.tabsElement = null, this.detail = {
      scrollTop: 0,
      scrollLeft: 0,
      type: "scroll",
      event: void 0,
      startX: 0,
      startY: 0,
      startTime: 0,
      currentX: 0,
      currentY: 0,
      velocityX: 0,
      velocityY: 0,
      deltaX: 0,
      deltaY: 0,
      currentTime: 0,
      data: void 0,
      isScrolling: !0
    }, this.color = void 0, this.fullscreen = !1, this.forceOverscroll = void 0, this.scrollX = !1, this.scrollY = !0, this.scrollEvents = !1;
  }
  connectedCallback() {
    if (this.isMainContent = this.el.closest("ion-menu, ion-popover, ion-modal") === null, hasLazyBuild(this.el)) {
      const e = this.tabsElement = this.el.closest("ion-tabs");
      e !== null && (this.tabsLoadCallback = () => this.resize(), e.addEventListener("ionTabBarLoaded", this.tabsLoadCallback));
    }
  }
  disconnectedCallback() {
    if (this.onScrollEnd(), hasLazyBuild(this.el)) {
      const { tabsElement: e, tabsLoadCallback: r } = this;
      e !== null && r !== void 0 && e.removeEventListener("ionTabBarLoaded", r), this.tabsElement = null, this.tabsLoadCallback = void 0;
    }
  }
  /**
   * Rotating certain devices can update
   * the safe area insets. As a result,
   * the fullscreen feature on ion-content
   * needs to be recalculated.
   *
   * We listen for "resize" because we
   * do not care what the orientation of
   * the device is. Other APIs
   * such as ScreenOrientation or
   * the deviceorientation event must have
   * permission from the user first whereas
   * the "resize" event does not.
   *
   * We also throttle the callback to minimize
   * thrashing when quickly resizing a window.
   */
  onResize() {
    this.resizeTimeout && (clearTimeout(this.resizeTimeout), this.resizeTimeout = null), this.resizeTimeout = setTimeout(() => {
      this.el.offsetParent !== null && this.resize();
    }, 100);
  }
  shouldForceOverscroll() {
    const { forceOverscroll: e } = this, r = getIonMode$2(this);
    return e === void 0 ? r === "ios" && isPlatform("ios") : e;
  }
  resize() {
    this.fullscreen ? readTask(() => this.readDimensions()) : (this.cTop !== 0 || this.cBottom !== 0) && (this.cTop = this.cBottom = 0, forceUpdate(this));
  }
  readDimensions() {
    const e = getPageElement(this.el), r = Math.max(this.el.offsetTop, 0), o = Math.max(e.offsetHeight - r - this.el.offsetHeight, 0);
    (r !== this.cTop || o !== this.cBottom) && (this.cTop = r, this.cBottom = o, forceUpdate(this));
  }
  onScroll(e) {
    const r = Date.now(), o = !this.isScrolling;
    this.lastScroll = r, o && this.onScrollStart(), !this.queued && this.scrollEvents && (this.queued = !0, readTask((a) => {
      this.queued = !1, this.detail.event = e, updateScrollDetail(this.detail, this.scrollEl, a, o), this.ionScroll.emit(this.detail);
    }));
  }
  /**
   * Get the element where the actual scrolling takes place.
   * This element can be used to subscribe to `scroll` events or manually modify
   * `scrollTop`. However, it's recommended to use the API provided by `ion-content`:
   *
   * i.e. Using `ionScroll`, `ionScrollStart`, `ionScrollEnd` for scrolling events
   * and `scrollToPoint()` to scroll the content into a certain point.
   */
  async getScrollElement() {
    return this.scrollEl || await new Promise((e) => componentOnReady(this.el, e)), Promise.resolve(this.scrollEl);
  }
  /**
   * Returns the background content element.
   * @internal
   */
  async getBackgroundElement() {
    return this.backgroundContentEl || await new Promise((e) => componentOnReady(this.el, e)), Promise.resolve(this.backgroundContentEl);
  }
  /**
   * Scroll to the top of the component.
   *
   * @param duration The amount of time to take scrolling to the top. Defaults to `0`.
   */
  scrollToTop(e = 0) {
    return this.scrollToPoint(void 0, 0, e);
  }
  /**
   * Scroll to the bottom of the component.
   *
   * @param duration The amount of time to take scrolling to the bottom. Defaults to `0`.
   */
  async scrollToBottom(e = 0) {
    const r = await this.getScrollElement(), o = r.scrollHeight - r.clientHeight;
    return this.scrollToPoint(void 0, o, e);
  }
  /**
   * Scroll by a specified X/Y distance in the component.
   *
   * @param x The amount to scroll by on the horizontal axis.
   * @param y The amount to scroll by on the vertical axis.
   * @param duration The amount of time to take scrolling by that amount.
   */
  async scrollByPoint(e, r, o) {
    const a = await this.getScrollElement();
    return this.scrollToPoint(e + a.scrollLeft, r + a.scrollTop, o);
  }
  /**
   * Scroll to a specified X/Y location in the component.
   *
   * @param x The point to scroll to on the horizontal axis.
   * @param y The point to scroll to on the vertical axis.
   * @param duration The amount of time to take scrolling to that point. Defaults to `0`.
   */
  async scrollToPoint(e, r, o = 0) {
    const a = await this.getScrollElement();
    if (o < 32) {
      r != null && (a.scrollTop = r), e != null && (a.scrollLeft = e);
      return;
    }
    let c, u = 0;
    const d = new Promise((y) => c = y), p = a.scrollTop, g = a.scrollLeft, b = r != null ? r - p : 0, x = e != null ? e - g : 0, w = (y) => {
      const I = Math.min(1, (y - u) / o) - 1, E = Math.pow(I, 3) + 1;
      b !== 0 && (a.scrollTop = Math.floor(E * b + p)), x !== 0 && (a.scrollLeft = Math.floor(E * x + g)), E < 1 ? requestAnimationFrame(w) : c();
    };
    return requestAnimationFrame((y) => {
      u = y, w(y);
    }), d;
  }
  onScrollStart() {
    this.isScrolling = !0, this.ionScrollStart.emit({
      isScrolling: !0
    }), this.watchDog && clearInterval(this.watchDog), this.watchDog = setInterval(() => {
      this.lastScroll < Date.now() - 120 && this.onScrollEnd();
    }, 100);
  }
  onScrollEnd() {
    this.watchDog && clearInterval(this.watchDog), this.watchDog = null, this.isScrolling && (this.isScrolling = !1, this.ionScrollEnd.emit({
      isScrolling: !1
    }));
  }
  render() {
    const { isMainContent: e, scrollX: r, scrollY: o, el: a } = this, c = isRTL$1(a) ? "rtl" : "ltr", u = getIonMode$2(this), d = this.shouldForceOverscroll(), p = u === "ios", g = e ? "main" : "div";
    return this.resize(), h(Host, { class: createColorClasses$1(this.color, {
      [u]: !0,
      "content-sizing": hostContext("ion-popover", this.el),
      overscroll: d,
      [`content-${c}`]: !0
    }), style: {
      "--offset-top": `${this.cTop}px`,
      "--offset-bottom": `${this.cBottom}px`
    } }, h("div", { ref: (b) => this.backgroundContentEl = b, id: "background-content", part: "background" }), h(g, { class: {
      "inner-scroll": !0,
      "scroll-x": r,
      "scroll-y": o,
      overscroll: (r || o) && d
    }, ref: (b) => this.scrollEl = b, onScroll: this.scrollEvents ? (b) => this.onScroll(b) : void 0, part: "scroll" }, h("slot", null)), p ? h("div", { class: "transition-effect" }, h("div", { class: "transition-cover" }), h("div", { class: "transition-shadow" })) : null, h("slot", { name: "fixed" }));
  }
  get el() {
    return this;
  }
  static get style() {
    return contentCss;
  }
}, [1, "ion-content", {
  color: [513],
  fullscreen: [4],
  forceOverscroll: [1028, "force-overscroll"],
  scrollX: [4, "scroll-x"],
  scrollY: [4, "scroll-y"],
  scrollEvents: [4, "scroll-events"],
  getScrollElement: [64],
  getBackgroundElement: [64],
  scrollToTop: [64],
  scrollToBottom: [64],
  scrollByPoint: [64],
  scrollToPoint: [64]
}, [[9, "resize", "onResize"]]]), getParentElement = (t) => {
  var e;
  return t.parentElement ? t.parentElement : !((e = t.parentNode) === null || e === void 0) && e.host ? t.parentNode.host : null;
}, getPageElement = (t) => {
  const e = t.closest("ion-tabs");
  if (e)
    return e;
  const r = t.closest("ion-app, ion-page, .ion-page, page-inner, .popover-content");
  return r || getParentElement(t);
}, updateScrollDetail = (t, e, r, o) => {
  const a = t.currentX, c = t.currentY, u = t.currentTime, d = e.scrollLeft, p = e.scrollTop, g = r - u;
  if (o && (t.startTime = r, t.startX = d, t.startY = p, t.velocityX = t.velocityY = 0), t.currentTime = r, t.currentX = t.scrollLeft = d, t.currentY = t.scrollTop = p, t.deltaX = d - t.startX, t.deltaY = p - t.startY, g > 0 && g < 100) {
    const b = (d - a) / g, x = (p - c) / g;
    t.velocityX = b * 0.7 + t.velocityX * 0.3, t.velocityY = x * 0.7 + t.velocityY * 0.3;
  }
};
function defineCustomElement$1$j() {
  if (typeof customElements > "u")
    return;
  ["ion-content"].forEach((e) => {
    switch (e) {
      case "ion-content":
        customElements.get(e) || customElements.define(e, Content);
        break;
    }
  });
}
const defineCustomElement$E = defineCustomElement$1$j;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const noteIosCss = ":host{color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-350, #a6a6a6);font-size:max(14px, 1rem)}", noteMdCss = ":host{color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-base)}:host{--color:var(--ion-color-step-600, #666666);font-size:0.875rem}", Note = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0;
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: createColorClasses$1(this.color, {
      [e]: !0
    }) }, h("slot", null));
  }
  static get style() {
    return {
      ios: noteIosCss,
      md: noteMdCss
    };
  }
}, [33, "ion-note", {
  color: [513]
}]);
function defineCustomElement$D() {
  if (typeof customElements > "u")
    return;
  ["ion-note"].forEach((e) => {
    switch (e) {
      case "ion-note":
        customElements.get(e) || customElements.define(e, Note);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const itemIosCss = ':host{--inner-min-width:4rem;--border-radius:0px;--border-width:0px;--border-style:solid;--padding-top:0px;--padding-bottom:0px;--padding-end:0px;--padding-start:0px;--inner-border-width:0px;--inner-padding-top:0px;--inner-padding-bottom:0px;--inner-padding-start:0px;--inner-padding-end:0px;--inner-box-shadow:none;--show-full-highlight:0;--show-inset-highlight:0;--detail-icon-color:initial;--detail-icon-font-size:1.25em;--detail-icon-opacity:0.25;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:initial;text-decoration:none;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native,:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-inner{border-color:var(--ion-color-shade)}:host(.ion-activated) .item-native{color:var(--color-activated)}:host(.ion-activated) .item-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.ion-color.ion-activated) .item-native{color:var(--ion-color-contrast)}:host(.ion-focused) .item-native{color:var(--color-focused)}:host(.ion-focused) .item-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-color.ion-focused) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .item-native::after{background:var(--ion-color-contrast)}@media (any-hover: hover){:host(.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--color-hover)}:host(.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--ion-color-contrast)}}:host(.item-has-interactive-control){cursor:pointer}:host(.item-interactive-disabled:not(.item-multiple-inputs)){cursor:default;pointer-events:none}:host(.item-disabled){cursor:default;opacity:0.3;pointer-events:none}.item-native{border-radius:var(--border-radius);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-right:var(--padding-end);padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));display:-ms-flexbox;display:flex;position:relative;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);overflow:inherit;z-index:1;-webkit-box-sizing:border-box;box-sizing:border-box}:host-context([dir=rtl]) .item-native{padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}[dir=rtl] .item-native{padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}@supports selector(:dir(rtl)){.item-native:dir(rtl){padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}}:host(.item-legacy) .item-native{-ms-flex-wrap:unset;flex-wrap:unset}.item-native::-moz-focus-inner{border:0}.item-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0;-webkit-transition:var(--transition);transition:var(--transition);z-index:-1}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.item-inner{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:var(--inner-padding-top);padding-bottom:var(--inner-padding-bottom);padding-right:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-left:var(--inner-padding-start);display:-ms-flexbox;display:flex;position:relative;-ms-flex:1 0 0px;flex:1 0 0;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-width:var(--inner-min-width);max-width:100%;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);-webkit-box-shadow:var(--inner-box-shadow);box-shadow:var(--inner-box-shadow);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host-context([dir=rtl]) .item-inner{padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}[dir=rtl] .item-inner{padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}@supports selector(:dir(rtl)){.item-inner:dir(rtl){padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}}:host(.item-legacy) .item-inner{-ms-flex:1;flex:1;-ms-flex-wrap:unset;flex-wrap:unset;max-width:unset}.item-bottom{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--inner-padding-end) + var(--ion-safe-area-right, 0px));display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}:host-context([dir=rtl]) .item-bottom{padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}[dir=rtl] .item-bottom{padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}@supports selector(:dir(rtl)){.item-bottom:dir(rtl){padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}}.item-detail-icon{-webkit-margin-start:calc(var(--inner-padding-end) / 2);margin-inline-start:calc(var(--inner-padding-end) / 2);-webkit-margin-end:-6px;margin-inline-end:-6px;color:var(--detail-icon-color);font-size:var(--detail-icon-font-size);opacity:var(--detail-icon-opacity)}::slotted(ion-icon){font-size:1.6em}::slotted(ion-button){--margin-top:0;--margin-bottom:0;--margin-start:0;--margin-end:0;z-index:1}::slotted(ion-label:not([slot=end])){-ms-flex:1;flex:1;width:-webkit-min-content;width:-moz-min-content;width:min-content;max-width:100%}:host(.item-input){-ms-flex-align:center;align-items:center}.input-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;max-width:100%;text-overflow:ellipsis;overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.item-legacy) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-wrap:unset;flex-wrap:unset;max-width:unset}:host(.item-label-stacked),:host(.item-label-floating){-ms-flex-align:start;align-items:start}:host(.item-label-stacked) .input-wrapper,:host(.item-label-floating) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}.item-highlight,.item-inner-highlight{left:0;right:0;top:0;bottom:0;border-radius:inherit;position:absolute;width:100%;height:100%;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:transform 200ms, border-bottom-width 200ms;transition:transform 200ms, border-bottom-width 200ms, -webkit-transform 200ms;z-index:2;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus),:host(.item-interactive.ion-touched.ion-invalid){--full-highlight-height:calc(var(--highlight-height) * var(--show-full-highlight));--inset-highlight-height:calc(var(--highlight-height) * var(--show-inset-highlight))}:host(.ion-focused) .item-highlight,:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-highlight,:host(.item-has-focus) .item-inner-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.ion-focused) .item-highlight,:host(.item-has-focus) .item-highlight{border-width:var(--full-highlight-height);opacity:var(--show-full-highlight)}:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-inner-highlight{border-bottom-width:var(--inset-highlight-height);opacity:var(--show-inset-highlight)}:host(.ion-focused.item-fill-solid) .item-highlight,:host(.item-has-focus.item-fill-solid) .item-highlight{border-width:calc(var(--full-highlight-height) - 1px)}:host(.ion-focused) .item-inner-highlight,:host(.ion-focused:not(.item-fill-outline)) .item-highlight,:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus:not(.item-fill-outline)) .item-highlight{border-top:none;border-right:none;border-left:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus){--highlight-background:var(--highlight-color-focused)}:host(.item-interactive.ion-valid){--highlight-background:var(--highlight-color-valid)}:host(.item-interactive.ion-invalid){--highlight-background:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=helper]){display:none}::slotted([slot=error]){display:none;color:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=error]){display:block}:host(:not(.item-label)) ::slotted(ion-select.legacy-select){--padding-start:0;max-width:none}:host(.item-label-stacked) ::slotted(ion-select.legacy-select),:host(.item-label-floating) ::slotted(ion-select.legacy-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0;-ms-flex-item-align:stretch;align-self:stretch;width:100%;max-width:100%}:host(:not(.item-label)) ::slotted(ion-datetime){--padding-start:0}:host(.item-label-stacked) ::slotted(ion-datetime),:host(.item-label-floating) ::slotted(ion-datetime){--padding-start:0;width:100%}:host(.item-multiple-inputs) ::slotted(ion-checkbox),:host(.item-multiple-inputs) ::slotted(ion-datetime),:host(.item-multiple-inputs) ::slotted(ion-radio),:host(.item-multiple-inputs) ::slotted(ion-select.legacy-select){position:relative}:host(.item-textarea){-ms-flex-align:stretch;align-items:stretch}::slotted(ion-reorder[slot]){margin-top:0;margin-bottom:0}ion-ripple-effect{color:var(--ripple-color)}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted([slot=helper]),::slotted([slot=error]),.item-counter{padding-top:5px;font-size:0.75rem;z-index:1}.item-counter{-webkit-margin-start:auto;margin-inline-start:auto;color:var(--ion-color-step-550, #737373);white-space:nowrap;-webkit-padding-start:16px;padding-inline-start:16px}@media (prefers-reduced-motion: reduce){.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}}:host{--min-height:44px;--transition:background-color 200ms linear, opacity 200ms linear;--padding-start:16px;--inner-padding-end:16px;--inner-border-width:0px 0px 0.55px 0px;--background:var(--ion-item-background, var(--ion-background-color, #fff));--background-activated:var(--ion-text-color, #000);--background-focused:var(--ion-text-color, #000);--background-hover:currentColor;--background-activated-opacity:.12;--background-focused-opacity:.15;--background-hover-opacity:.04;--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));--color:var(--ion-item-color, var(--ion-text-color, #000));--highlight-height:0px;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);--bottom-padding-start:0px;font-size:1rem}:host(.ion-activated){--transition:none}:host(.ion-color.ion-focused) .item-native::after{background:#000;opacity:0.15}:host(.ion-color.ion-activated) .item-native::after{background:#000;opacity:0.12}:host(.item-interactive){--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-full){--border-width:0px 0px 0.55px 0px;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-inset){--inner-border-width:0px 0px 0.55px 0px;--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-inset),:host(.item-lines-none){--border-width:0px;--show-full-highlight:0}:host(.item-lines-full),:host(.item-lines-none){--inner-border-width:0px;--show-inset-highlight:0}.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus) .item-highlight{border-top:none;border-right:none;border-left:none}::slotted([slot=start]){-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:2px;margin-bottom:2px}::slotted(ion-icon[slot=start]),::slotted(ion-icon[slot=end]){margin-top:7px;margin-bottom:7px}::slotted(ion-toggle[slot=start]),::slotted(ion-toggle[slot=end]){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}:host(.item-label-stacked) ::slotted([slot=end]),:host(.item-label-floating) ::slotted([slot=end]){margin-top:7px;margin-bottom:7px}::slotted(.button-small){--padding-top:1px;--padding-bottom:1px;--padding-start:.5em;--padding-end:.5em;min-height:24px;font-size:0.8125rem}::slotted(ion-avatar){width:36px;height:36px}::slotted(ion-thumbnail){--size:56px}::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:8px;margin-bottom:8px}:host(.item-radio) ::slotted(ion-label),:host(.item-toggle) ::slotted(ion-label){-webkit-margin-start:0px;margin-inline-start:0px}::slotted(ion-label){-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:10px;margin-bottom:10px}:host(.item-label-floating),:host(.item-label-stacked){--min-height:68px}:host(.item-label-stacked) ::slotted(ion-select.legacy-select),:host(.item-label-floating) ::slotted(ion-select.legacy-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0px}:host(.item-label-fixed) ::slotted(ion-select.legacy-select),:host(.item-label-fixed) ::slotted(ion-datetime){--padding-start:0}', itemMdCss = ':host{--inner-min-width:4rem;--border-radius:0px;--border-width:0px;--border-style:solid;--padding-top:0px;--padding-bottom:0px;--padding-end:0px;--padding-start:0px;--inner-border-width:0px;--inner-padding-top:0px;--inner-padding-bottom:0px;--inner-padding-start:0px;--inner-padding-end:0px;--inner-box-shadow:none;--show-full-highlight:0;--show-inset-highlight:0;--detail-icon-color:initial;--detail-icon-font-size:1.25em;--detail-icon-opacity:0.25;--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);text-align:initial;text-decoration:none;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-native,:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) .item-inner{border-color:var(--ion-color-shade)}:host(.ion-activated) .item-native{color:var(--color-activated)}:host(.ion-activated) .item-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}:host(.ion-color.ion-activated) .item-native{color:var(--ion-color-contrast)}:host(.ion-focused) .item-native{color:var(--color-focused)}:host(.ion-focused) .item-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-color.ion-focused) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .item-native::after{background:var(--ion-color-contrast)}@media (any-hover: hover){:host(.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--color-hover)}:host(.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-activatable:not(.ion-focused):hover) .item-native::after{background:var(--ion-color-contrast)}}:host(.item-has-interactive-control){cursor:pointer}:host(.item-interactive-disabled:not(.item-multiple-inputs)){cursor:default;pointer-events:none}:host(.item-disabled){cursor:default;opacity:0.3;pointer-events:none}.item-native{border-radius:var(--border-radius);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;padding-right:var(--padding-end);padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));display:-ms-flexbox;display:flex;position:relative;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;min-height:var(--min-height);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);overflow:inherit;z-index:1;-webkit-box-sizing:border-box;box-sizing:border-box}:host-context([dir=rtl]) .item-native{padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}[dir=rtl] .item-native{padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}@supports selector(:dir(rtl)){.item-native:dir(rtl){padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px));padding-left:var(--padding-end)}}:host(.item-legacy) .item-native{-ms-flex-wrap:unset;flex-wrap:unset}.item-native::-moz-focus-inner{border:0}.item-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0;-webkit-transition:var(--transition);transition:var(--transition);z-index:-1}button,a{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.item-inner{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:var(--inner-padding-top);padding-bottom:var(--inner-padding-bottom);padding-right:calc(var(--ion-safe-area-right, 0px) + var(--inner-padding-end));padding-left:var(--inner-padding-start);display:-ms-flexbox;display:flex;position:relative;-ms-flex:1 0 0px;flex:1 0 0;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-width:var(--inner-min-width);max-width:100%;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);-webkit-box-shadow:var(--inner-box-shadow);box-shadow:var(--inner-box-shadow);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host-context([dir=rtl]) .item-inner{padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}[dir=rtl] .item-inner{padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}@supports selector(:dir(rtl)){.item-inner:dir(rtl){padding-right:var(--inner-padding-start);padding-left:calc(var(--ion-safe-area-left, 0px) + var(--inner-padding-end))}}:host(.item-legacy) .item-inner{-ms-flex:1;flex:1;-ms-flex-wrap:unset;flex-wrap:unset;max-width:unset}.item-bottom{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-left:calc(var(--padding-start) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--inner-padding-end) + var(--ion-safe-area-right, 0px));display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}:host-context([dir=rtl]) .item-bottom{padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}[dir=rtl] .item-bottom{padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}@supports selector(:dir(rtl)){.item-bottom:dir(rtl){padding-left:calc(var(--inner-padding-end) + var(--ion-safe-area-left, 0px));padding-right:calc(var(--padding-start) + var(--ion-safe-area-right, 0px))}}.item-detail-icon{-webkit-margin-start:calc(var(--inner-padding-end) / 2);margin-inline-start:calc(var(--inner-padding-end) / 2);-webkit-margin-end:-6px;margin-inline-end:-6px;color:var(--detail-icon-color);font-size:var(--detail-icon-font-size);opacity:var(--detail-icon-opacity)}::slotted(ion-icon){font-size:1.6em}::slotted(ion-button){--margin-top:0;--margin-bottom:0;--margin-start:0;--margin-end:0;z-index:1}::slotted(ion-label:not([slot=end])){-ms-flex:1;flex:1;width:-webkit-min-content;width:-moz-min-content;width:min-content;max-width:100%}:host(.item-input){-ms-flex-align:center;align-items:center}.input-wrapper{display:-ms-flexbox;display:flex;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;max-width:100%;text-overflow:ellipsis;overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.item-legacy) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-wrap:unset;flex-wrap:unset;max-width:unset}:host(.item-label-stacked),:host(.item-label-floating){-ms-flex-align:start;align-items:start}:host(.item-label-stacked) .input-wrapper,:host(.item-label-floating) .input-wrapper{-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column}.item-highlight,.item-inner-highlight{left:0;right:0;top:0;bottom:0;border-radius:inherit;position:absolute;width:100%;height:100%;-webkit-transform:scaleX(0);transform:scaleX(0);-webkit-transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:border-bottom-width 200ms, -webkit-transform 200ms;transition:transform 200ms, border-bottom-width 200ms;transition:transform 200ms, border-bottom-width 200ms, -webkit-transform 200ms;z-index:2;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus),:host(.item-interactive.ion-touched.ion-invalid){--full-highlight-height:calc(var(--highlight-height) * var(--show-full-highlight));--inset-highlight-height:calc(var(--highlight-height) * var(--show-inset-highlight))}:host(.ion-focused) .item-highlight,:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-highlight,:host(.item-has-focus) .item-inner-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.ion-focused) .item-highlight,:host(.item-has-focus) .item-highlight{border-width:var(--full-highlight-height);opacity:var(--show-full-highlight)}:host(.ion-focused) .item-inner-highlight,:host(.item-has-focus) .item-inner-highlight{border-bottom-width:var(--inset-highlight-height);opacity:var(--show-inset-highlight)}:host(.ion-focused.item-fill-solid) .item-highlight,:host(.item-has-focus.item-fill-solid) .item-highlight{border-width:calc(var(--full-highlight-height) - 1px)}:host(.ion-focused) .item-inner-highlight,:host(.ion-focused:not(.item-fill-outline)) .item-highlight,:host(.item-has-focus) .item-inner-highlight,:host(.item-has-focus:not(.item-fill-outline)) .item-highlight{border-top:none;border-right:none;border-left:none}:host(.item-interactive.ion-focused),:host(.item-interactive.item-has-focus){--highlight-background:var(--highlight-color-focused)}:host(.item-interactive.ion-valid){--highlight-background:var(--highlight-color-valid)}:host(.item-interactive.ion-invalid){--highlight-background:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=helper]){display:none}::slotted([slot=error]){display:none;color:var(--highlight-color-invalid)}:host(.item-interactive.ion-invalid) ::slotted([slot=error]){display:block}:host(:not(.item-label)) ::slotted(ion-select.legacy-select){--padding-start:0;max-width:none}:host(.item-label-stacked) ::slotted(ion-select.legacy-select),:host(.item-label-floating) ::slotted(ion-select.legacy-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0;-ms-flex-item-align:stretch;align-self:stretch;width:100%;max-width:100%}:host(:not(.item-label)) ::slotted(ion-datetime){--padding-start:0}:host(.item-label-stacked) ::slotted(ion-datetime),:host(.item-label-floating) ::slotted(ion-datetime){--padding-start:0;width:100%}:host(.item-multiple-inputs) ::slotted(ion-checkbox),:host(.item-multiple-inputs) ::slotted(ion-datetime),:host(.item-multiple-inputs) ::slotted(ion-radio),:host(.item-multiple-inputs) ::slotted(ion-select.legacy-select){position:relative}:host(.item-textarea){-ms-flex-align:stretch;align-items:stretch}::slotted(ion-reorder[slot]){margin-top:0;margin-bottom:0}ion-ripple-effect{color:var(--ripple-color)}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted([slot=helper]),::slotted([slot=error]),.item-counter{padding-top:5px;font-size:0.75rem;z-index:1}.item-counter{-webkit-margin-start:auto;margin-inline-start:auto;color:var(--ion-color-step-550, #737373);white-space:nowrap;-webkit-padding-start:16px;padding-inline-start:16px}@media (prefers-reduced-motion: reduce){.item-highlight,.item-inner-highlight{-webkit-transition:none;transition:none}}:host{--min-height:48px;--background:var(--ion-item-background, var(--ion-background-color, #fff));--background-activated:transparent;--background-focused:currentColor;--background-hover:currentColor;--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04;--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))));--color:var(--ion-item-color, var(--ion-text-color, #000));--transition:opacity 15ms linear, background-color 15ms linear;--padding-start:16px;--inner-padding-end:16px;--inner-border-width:0 0 1px 0;--highlight-height:1px;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);font-size:1rem;font-weight:normal;text-transform:none}:host(.item-fill-outline){--highlight-height:2px}:host(.item-fill-none.item-interactive.ion-focus) .item-highlight,:host(.item-fill-none.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-none.item-interactive.ion-touched.ion-invalid) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-width:0 0 var(--full-highlight-height) 0;border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-none.item-interactive.ion-focus) .item-native,:host(.item-fill-none.item-interactive.item-has-focus) .item-native,:host(.item-fill-none.item-interactive.ion-touched.ion-invalid) .item-native{border-bottom-color:var(--highlight-background)}:host(.item-fill-outline.item-interactive.ion-focus) .item-highlight,:host(.item-fill-outline.item-interactive.item-has-focus) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1)}:host(.item-fill-outline.item-interactive.ion-focus) .item-highlight,:host(.item-fill-outline.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-outline.item-interactive.ion-touched.ion-invalid) .item-highlight{border-width:var(--full-highlight-height);border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-outline.item-interactive.ion-touched.ion-invalid) .item-native{border-color:var(--highlight-background)}:host(.item-fill-solid.item-interactive.ion-focus) .item-highlight,:host(.item-fill-solid.item-interactive.item-has-focus) .item-highlight,:host(.item-fill-solid.item-interactive.ion-touched.ion-invalid) .item-highlight{-webkit-transform:scaleX(1);transform:scaleX(1);border-width:0 0 var(--full-highlight-height) 0;border-style:var(--border-style);border-color:var(--highlight-background)}:host(.item-fill-solid.item-interactive.ion-focus) .item-native,:host(.item-fill-solid.item-interactive.item-has-focus) .item-native,:host(.item-fill-solid.item-interactive.ion-touched.ion-invalid) .item-native{border-bottom-color:var(--highlight-background)}:host(.ion-color.ion-activated) .item-native::after{background:transparent}:host(.item-has-focus) .item-native{caret-color:var(--highlight-background)}:host(.item-interactive){--border-width:0 0 1px 0;--inner-border-width:0;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-full){--border-width:0 0 1px 0;--show-full-highlight:1;--show-inset-highlight:0}:host(.item-lines-inset){--inner-border-width:0 0 1px 0;--show-full-highlight:0;--show-inset-highlight:1}:host(.item-lines-inset),:host(.item-lines-none){--border-width:0;--show-full-highlight:0}:host(.item-lines-full),:host(.item-lines-none){--inner-border-width:0;--show-inset-highlight:0}:host(.item-fill-outline) .item-highlight{--position-offset:calc(-1 * var(--border-width));top:var(--position-offset);width:calc(100% + 2 * var(--border-width));height:calc(100% + 2 * var(--border-width));-webkit-transition:none;transition:none}@supports (inset-inline-start: 0){:host(.item-fill-outline) .item-highlight{inset-inline-start:var(--position-offset)}}@supports not (inset-inline-start: 0){:host(.item-fill-outline) .item-highlight{left:var(--position-offset)}:host-context([dir=rtl]):host(.item-fill-outline) .item-highlight,:host-context([dir=rtl]).item-fill-outline .item-highlight{left:unset;right:unset;right:var(--position-offset)}@supports selector(:dir(rtl)){:host(.item-fill-outline:dir(rtl)) .item-highlight{left:unset;right:unset;right:var(--position-offset)}}}:host(.item-fill-outline.ion-focused) .item-native,:host(.item-fill-outline.item-has-focus) .item-native{border-color:transparent}:host(.item-multi-line) ::slotted([slot=start]),:host(.item-multi-line) ::slotted([slot=end]){margin-top:16px;margin-bottom:16px;-ms-flex-item-align:start;align-self:flex-start}::slotted([slot=start]){-webkit-margin-end:32px;margin-inline-end:32px}::slotted([slot=end]){-webkit-margin-start:32px;margin-inline-start:32px}:host(.item-fill-solid) ::slotted([slot=start]),:host(.item-fill-solid) ::slotted([slot=end]),:host(.item-fill-outline) ::slotted([slot=start]),:host(.item-fill-outline) ::slotted([slot=end]){-ms-flex-item-align:center;align-self:center}::slotted(ion-icon){color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54);font-size:1.5em}:host(.ion-color:not(.item-fill-solid):not(.item-fill-outline)) ::slotted(ion-icon){color:var(--ion-color-contrast)}::slotted(ion-icon[slot]){margin-top:12px;margin-bottom:12px}::slotted(ion-icon[slot=start]){-webkit-margin-end:32px;margin-inline-end:32px}::slotted(ion-icon[slot=end]){-webkit-margin-start:16px;margin-inline-start:16px}:host(.item-fill-solid) ::slotted(ion-icon[slot=start]),:host(.item-fill-outline) ::slotted(ion-icon[slot=start]){-webkit-margin-end:8px;margin-inline-end:8px}::slotted(ion-toggle[slot=start]),::slotted(ion-toggle[slot=end]){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}::slotted(ion-note){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-ms-flex-item-align:start;align-self:flex-start;font-size:0.6875rem}::slotted(ion-note[slot]:not([slot=helper]):not([slot=error])){padding-left:0;padding-right:0;padding-top:18px;padding-bottom:10px}::slotted(ion-note[slot=start]){-webkit-padding-end:16px;padding-inline-end:16px}::slotted(ion-note[slot=end]){-webkit-padding-start:16px;padding-inline-start:16px}::slotted(ion-avatar){width:40px;height:40px}::slotted(ion-thumbnail){--size:56px}::slotted(ion-avatar),::slotted(ion-thumbnail){margin-top:8px;margin-bottom:8px}::slotted(ion-avatar[slot=start]),::slotted(ion-thumbnail[slot=start]){-webkit-margin-end:16px;margin-inline-end:16px}::slotted(ion-avatar[slot=end]),::slotted(ion-thumbnail[slot=end]){-webkit-margin-start:16px;margin-inline-start:16px}::slotted(ion-label){margin-left:0;margin-right:0;margin-top:10px;margin-bottom:10px}:host(.item-label-stacked) ::slotted([slot=end]),:host(.item-label-floating) ::slotted([slot=end]){margin-top:7px;margin-bottom:7px}:host(.item-label-fixed) ::slotted(ion-select.legacy-select),:host(.item-label-fixed) ::slotted(ion-datetime){--padding-start:8px}:host(.item-toggle) ::slotted(ion-label),:host(.item-radio) ::slotted(ion-label){-webkit-margin-start:0;margin-inline-start:0}::slotted(.button-small){--padding-top:2px;--padding-bottom:2px;--padding-start:.6em;--padding-end:.6em;min-height:25px;font-size:0.75rem}:host(.item-label-floating),:host(.item-label-stacked){--min-height:55px}:host(.item-label-stacked) ::slotted(ion-select.legacy-select),:host(.item-label-floating) ::slotted(ion-select.legacy-select){--padding-top:8px;--padding-bottom:8px;--padding-start:0}:host(.ion-focused:not(.ion-color)) ::slotted(.label-stacked),:host(.ion-focused:not(.ion-color)) ::slotted(.label-floating),:host(.item-has-focus:not(.ion-color)) ::slotted(.label-stacked),:host(.item-has-focus:not(.ion-color)) ::slotted(.label-floating){color:var(--ion-color-primary, #3880ff)}:host(.ion-color){--highlight-color-focused:var(--ion-color-contrast)}:host(.item-label-color){--highlight-color-focused:var(--ion-color-base)}:host(.item-fill-solid.ion-color),:host(.item-fill-outline.ion-color){--highlight-color-focused:var(--ion-color-base)}:host(.item-fill-solid){--background:var(--ion-color-step-50, #f2f2f2);--background-hover:var(--ion-color-step-100, #e6e6e6);--background-focused:var(--ion-color-step-150, #d9d9d9);--border-width:0 0 1px 0;--inner-border-width:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.item-fill-solid),:host-context([dir=rtl]).item-fill-solid{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}@supports selector(:dir(rtl)){:host(.item-fill-solid:dir(rtl)){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}}:host(.item-fill-solid) .item-native{--border-color:var(--ion-color-step-500, gray)}:host(.item-fill-solid.ion-focused) .item-native,:host(.item-fill-solid.item-has-focus) .item-native{--background:var(--background-focused)}:host(.item-fill-solid.item-shape-round){border-top-left-radius:16px;border-top-right-radius:16px;border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.item-fill-solid.item-shape-round),:host-context([dir=rtl]).item-fill-solid.item-shape-round{border-top-left-radius:16px;border-top-right-radius:16px;border-bottom-right-radius:0;border-bottom-left-radius:0}@supports selector(:dir(rtl)){:host(.item-fill-solid.item-shape-round:dir(rtl)){border-top-left-radius:16px;border-top-right-radius:16px;border-bottom-right-radius:0;border-bottom-left-radius:0}}@media (any-hover: hover){:host(.item-fill-solid:hover) .item-native{--background:var(--background-hover);--border-color:var(--ion-color-step-750, #404040)}}:host(.item-fill-outline){--ripple-color:transparent;--background-focused:transparent;--background-hover:transparent;--border-color:var(--ion-color-step-500, gray);--border-width:1px;border:none;overflow:visible}:host(.item-fill-outline) .item-native{--native-padding-left:16px;border-radius:4px}:host(.item-fill-outline.item-shape-round) .item-native{--inner-padding-start:16px;border-radius:28px}:host(.item-fill-outline.item-shape-round) .item-bottom{-webkit-padding-start:32px;padding-inline-start:32px}:host(.item-fill-outline.item-label-floating.ion-focused) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.ion-focused) .item-native ::slotted(ion-textarea:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-focus) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-focus) .item-native ::slotted(ion-textarea:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-value) .item-native ::slotted(ion-input:not(:first-child)),:host(.item-fill-outline.item-label-floating.item-has-value) .item-native ::slotted(ion-textarea:not(:first-child)){-webkit-transform:translateY(-14px);transform:translateY(-14px)}@media (any-hover: hover){:host(.item-fill-outline:hover) .item-native{--border-color:var(--ion-color-step-750, #404040)}}.item-counter{letter-spacing:0.0333333333em}', Item = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.labelColorStyles = {}, this.itemStyles = /* @__PURE__ */ new Map(), this.inheritedAriaAttributes = {}, this.multipleInputs = !1, this.focusable = !0, this.color = void 0, this.button = !1, this.detail = void 0, this.detailIcon = chevronForward, this.disabled = !1, this.download = void 0, this.fill = void 0, this.shape = void 0, this.href = void 0, this.rel = void 0, this.lines = void 0, this.counter = !1, this.routerAnimation = void 0, this.routerDirection = "forward", this.target = void 0, this.type = "button", this.counterFormatter = void 0, this.counterString = void 0;
  }
  counterFormatterChanged() {
    this.updateCounterOutput(this.getFirstInput());
  }
  handleIonInput(e) {
    this.counter && e.target === this.getFirstInput() && this.updateCounterOutput(e.target);
  }
  labelColorChanged(e) {
    const { color: r } = this;
    r === void 0 && (this.labelColorStyles = e.detail);
  }
  itemStyle(e) {
    e.stopPropagation();
    const r = e.target.tagName, o = e.detail, a = {}, c = this.itemStyles.get(r) || {};
    let u = !1;
    Object.keys(o).forEach((d) => {
      if (o[d]) {
        const p = `item-${d}`;
        c[p] || (u = !0), a[p] = !0;
      }
    }), !u && Object.keys(a).length !== Object.keys(c).length && (u = !0), u && (this.itemStyles.set(r, a), forceUpdate(this));
  }
  connectedCallback() {
    this.counter && this.updateCounterOutput(this.getFirstInput()), this.hasStartEl();
  }
  componentWillLoad() {
    this.inheritedAriaAttributes = inheritAttributes$2(this.el, ["aria-label"]);
  }
  componentDidLoad() {
    const { el: e, counter: r, counterFormatter: o, fill: a, shape: c } = this;
    e.querySelector('[slot="helper"]') !== null && printIonWarning('The "helper" slot has been deprecated in favor of using the "helperText" property on ion-input or ion-textarea.', e), e.querySelector('[slot="error"]') !== null && printIonWarning('The "error" slot has been deprecated in favor of using the "errorText" property on ion-input or ion-textarea.', e), r === !0 && printIonWarning('The "counter" property has been deprecated in favor of using the "counter" property on ion-input or ion-textarea.', e), o !== void 0 && printIonWarning('The "counterFormatter" property has been deprecated in favor of using the "counterFormatter" property on ion-input or ion-textarea.', e), a !== void 0 && printIonWarning('The "fill" property has been deprecated in favor of using the "fill" property on ion-input or ion-textarea.', e), c !== void 0 && printIonWarning('The "shape" property has been deprecated in favor of using the "shape" property on ion-input or ion-textarea.', e), raf(() => {
      this.setMultipleInputs(), this.focusable = this.isFocusable();
    });
  }
  // If the item contains multiple clickable elements and/or inputs, then the item
  // should not have a clickable input cover over the entire item to prevent
  // interfering with their individual click events
  setMultipleInputs() {
    const e = this.el.querySelectorAll("ion-checkbox, ion-datetime, ion-select, ion-radio"), r = this.el.querySelectorAll("ion-input, ion-range, ion-searchbar, ion-segment, ion-textarea, ion-toggle"), o = this.el.querySelectorAll("ion-anchor, ion-button, a, button");
    this.multipleInputs = e.length + r.length > 1 || e.length + o.length > 1 || e.length > 0 && this.isClickable();
  }
  // If the item contains an input including a checkbox, datetime, select, or radio
  // then the item will have a clickable input cover that covers the item
  // that should get the hover, focused and activated states UNLESS it has multiple
  // inputs, then those need to individually get each click
  hasCover() {
    return this.el.querySelectorAll("ion-checkbox, ion-datetime, ion-select, ion-radio").length === 1 && !this.multipleInputs;
  }
  // If the item has an href or button property it will render a native
  // anchor or button that is clickable
  isClickable() {
    return this.href !== void 0 || this.button;
  }
  canActivate() {
    return this.isClickable() || this.hasCover();
  }
  isFocusable() {
    const e = this.el.querySelector(".ion-focusable");
    return this.canActivate() || e !== null;
  }
  getFirstInput() {
    return this.el.querySelectorAll("ion-input, ion-textarea")[0];
  }
  updateCounterOutput(e) {
    var r, o;
    const { counter: a, counterFormatter: c, defaultCounterFormatter: u } = this;
    if (a && !this.multipleInputs && (e == null ? void 0 : e.maxlength) !== void 0) {
      const d = (o = (r = e == null ? void 0 : e.value) === null || r === void 0 ? void 0 : r.toString().length) !== null && o !== void 0 ? o : 0;
      if (c === void 0)
        this.counterString = u(d, e.maxlength);
      else
        try {
          this.counterString = c(d, e.maxlength);
        } catch (p) {
          printIonError("Exception in provided `counterFormatter`.", p), this.counterString = u(d, e.maxlength);
        }
    }
  }
  defaultCounterFormatter(e, r) {
    return `${e} / ${r}`;
  }
  hasStartEl() {
    this.el.querySelector('[slot="start"]') !== null && this.el.classList.add("item-has-start-slot");
  }
  getFirstInteractive() {
    return this.el.querySelectorAll("ion-toggle:not([disabled]), ion-checkbox:not([disabled]), ion-radio:not([disabled]), ion-select:not([disabled])")[0];
  }
  render() {
    const { counterString: e, detail: r, detailIcon: o, download: a, fill: c, labelColorStyles: u, lines: d, disabled: p, href: g, rel: b, shape: x, target: w, routerAnimation: y, routerDirection: I, inheritedAriaAttributes: E, multipleInputs: T } = this, C = {}, $ = getIonMode$2(this), D = this.isClickable(), L = this.canActivate(), R = D ? g === void 0 ? "button" : "a" : "div", O = R === "button" ? { type: this.type } : {
      download: a,
      href: g,
      rel: b,
      target: w
    };
    let P = {};
    const z = this.getFirstInteractive();
    (D || z !== void 0 && !T) && (P = {
      onClick: (U) => {
        if (D && openURL(g, U, I, y), z !== void 0 && !T) {
          const V = U.composedPath()[0];
          U.isTrusted && this.el.shadowRoot.contains(V) && z.click();
        }
      }
    });
    const W = r !== void 0 ? r : $ === "ios" && D;
    this.itemStyles.forEach((U) => {
      Object.assign(C, U);
    });
    const A = p || C["item-interactive-disabled"] ? "true" : null, S = c || "none", F = hostContext("ion-list", this.el) && !hostContext("ion-radio-group", this.el);
    return h(Host, { "aria-disabled": A, class: Object.assign(Object.assign(Object.assign({}, C), u), createColorClasses$1(this.color, {
      item: !0,
      [$]: !0,
      "item-lines-default": d === void 0,
      [`item-lines-${d}`]: d !== void 0,
      [`item-fill-${S}`]: !0,
      [`item-shape-${x}`]: x !== void 0,
      "item-has-interactive-control": z !== void 0,
      "item-disabled": p,
      "in-list": F,
      "item-multiple-inputs": this.multipleInputs,
      "ion-activatable": L,
      "ion-focusable": this.focusable,
      "item-rtl": document.dir === "rtl"
    })), role: F ? "listitem" : null }, h(R, Object.assign({}, O, E, { class: "item-native", part: "native", disabled: p }, P), h("slot", { name: "start" }), h("div", { class: "item-inner" }, h("div", { class: "input-wrapper" }, h("slot", null)), h("slot", { name: "end" }), W && h("ion-icon", { icon: o, lazy: !1, class: "item-detail-icon", part: "detail-icon", "aria-hidden": "true", "flip-rtl": o === chevronForward }), h("div", { class: "item-inner-highlight" })), L && $ === "md" && h("ion-ripple-effect", null), h("div", { class: "item-highlight" })), h("div", { class: "item-bottom" }, h("slot", { name: "error" }), h("slot", { name: "helper" }), e && h("ion-note", { class: "item-counter" }, e)));
  }
  static get delegatesFocus() {
    return !0;
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      counterFormatter: ["counterFormatterChanged"]
    };
  }
  static get style() {
    return {
      ios: itemIosCss,
      md: itemMdCss
    };
  }
}, [49, "ion-item", {
  color: [513],
  button: [4],
  detail: [4],
  detailIcon: [1, "detail-icon"],
  disabled: [4],
  download: [1],
  fill: [1],
  shape: [1],
  href: [1],
  rel: [1],
  lines: [1],
  counter: [4],
  routerAnimation: [16],
  routerDirection: [1, "router-direction"],
  target: [1],
  type: [1],
  counterFormatter: [16],
  multipleInputs: [32],
  focusable: [32],
  counterString: [32]
}, [[0, "ionInput", "handleIonInput"], [0, "ionColor", "labelColorChanged"], [0, "ionStyle", "itemStyle"]], {
  counterFormatter: ["counterFormatterChanged"]
}]);
function defineCustomElement$C() {
  if (typeof customElements > "u")
    return;
  ["ion-item", "ion-icon", "ion-note", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-item":
        customElements.get(e) || customElements.define(e, Item);
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-note":
        customElements.get(e) || defineCustomElement$D();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const labelIosCss = ".item.sc-ion-label-ios-h,.item .sc-ion-label-ios-h{--color:initial;display:block;color:var(--color);font-family:var(--ion-font-family, inherit);font-size:inherit;text-overflow:ellipsis;-webkit-box-sizing:border-box;box-sizing:border-box}.item-legacy.sc-ion-label-ios-h,.item-legacy .sc-ion-label-ios-h{white-space:nowrap;overflow:hidden}.item.sc-ion-label-ios-h:not(.item-input):not(.item-legacy),.item:not(.item-input):not(.item-legacy) .sc-ion-label-ios-h{-ms-flex-positive:1;flex-grow:1}.ion-color.sc-ion-label-ios-h{color:var(--ion-color-base)}.ion-text-nowrap.sc-ion-label-ios-h{overflow:hidden}.item-interactive-disabled.sc-ion-label-ios-h:not(.item-multiple-inputs),.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-ios-h{cursor:default;opacity:0.3;pointer-events:none}.item-input.sc-ion-label-ios-h,.item-input .sc-ion-label-ios-h{-ms-flex:initial;flex:initial;max-width:200px;pointer-events:none}.item-textarea.sc-ion-label-ios-h,.item-textarea .sc-ion-label-ios-h{-ms-flex-item-align:baseline;align-self:baseline}.item-skeleton-text.sc-ion-label-ios-h,.item-skeleton-text .sc-ion-label-ios-h{overflow:hidden}.label-fixed.sc-ion-label-ios-h{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}.label-stacked.sc-ion-label-ios-h,.label-floating.sc-ion-label-ios-h{margin-bottom:0;-ms-flex-item-align:stretch;align-self:stretch;width:auto;max-width:100%}.label-no-animate.label-floating.sc-ion-label-ios-h{-webkit-transition:none;transition:none}.sc-ion-label-ios-s h1,.sc-ion-label-ios-s h2,.sc-ion-label-ios-s h3,.sc-ion-label-ios-s h4,.sc-ion-label-ios-s h5,.sc-ion-label-ios-s h6{text-overflow:inherit;overflow:inherit}.ion-text-wrap.sc-ion-label-ios-h{font-size:0.875rem;line-height:1.5}.label-stacked.sc-ion-label-ios-h{margin-bottom:4px;font-size:0.875rem}.label-floating.sc-ion-label-ios-h{margin-bottom:0;-webkit-transform:translate(0, 29px);transform:translate(0, 29px);-webkit-transform-origin:left top;transform-origin:left top;-webkit-transition:-webkit-transform 150ms ease-in-out;transition:-webkit-transform 150ms ease-in-out;transition:transform 150ms ease-in-out;transition:transform 150ms ease-in-out, -webkit-transform 150ms ease-in-out}[dir=rtl].sc-ion-label-ios-h -no-combinator.label-floating.sc-ion-label-ios-h,[dir=rtl] .sc-ion-label-ios-h -no-combinator.label-floating.sc-ion-label-ios-h,[dir=rtl].label-floating.sc-ion-label-ios-h,[dir=rtl] .label-floating.sc-ion-label-ios-h{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){.label-floating.sc-ion-label-ios-h:dir(rtl){-webkit-transform-origin:right top;transform-origin:right top}}.item-textarea.label-floating.sc-ion-label-ios-h,.item-textarea .label-floating.sc-ion-label-ios-h{-webkit-transform:translate(0, 28px);transform:translate(0, 28px)}.item-has-focus.label-floating.sc-ion-label-ios-h,.item-has-focus .label-floating.sc-ion-label-ios-h,.item-has-placeholder.sc-ion-label-ios-h:not(.item-input).label-floating,.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-ios-h,.item-has-value.label-floating.sc-ion-label-ios-h,.item-has-value .label-floating.sc-ion-label-ios-h{-webkit-transform:scale(0.82);transform:scale(0.82)}.sc-ion-label-ios-s h1{margin-left:0;margin-right:0;margin-top:3px;margin-bottom:2px;font-size:1.375rem;font-weight:normal}.sc-ion-label-ios-s h2{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:1.0625rem;font-weight:normal}.sc-ion-label-ios-s h3,.sc-ion-label-ios-s h4,.sc-ion-label-ios-s h5,.sc-ion-label-ios-s h6{margin-left:0;margin-right:0;margin-top:0;margin-bottom:3px;font-size:0.875rem;font-weight:normal;line-height:normal}.sc-ion-label-ios-s p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:0.875rem;line-height:normal;text-overflow:inherit;overflow:inherit}.sc-ion-label-ios-s>p{color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.4)}.sc-ion-label-ios-h.in-item-color.sc-ion-label-ios-s>p{color:inherit}.sc-ion-label-ios-s h2:last-child,.sc-ion-label-ios-s h3:last-child,.sc-ion-label-ios-s h4:last-child,.sc-ion-label-ios-s h5:last-child,.sc-ion-label-ios-s h6:last-child,.sc-ion-label-ios-s p:last-child{margin-bottom:0}", labelMdCss = '.item.sc-ion-label-md-h,.item .sc-ion-label-md-h{--color:initial;display:block;color:var(--color);font-family:var(--ion-font-family, inherit);font-size:inherit;text-overflow:ellipsis;-webkit-box-sizing:border-box;box-sizing:border-box}.item-legacy.sc-ion-label-md-h,.item-legacy .sc-ion-label-md-h{white-space:nowrap;overflow:hidden}.item.sc-ion-label-md-h:not(.item-input):not(.item-legacy),.item:not(.item-input):not(.item-legacy) .sc-ion-label-md-h{-ms-flex-positive:1;flex-grow:1}.ion-color.sc-ion-label-md-h{color:var(--ion-color-base)}.ion-text-nowrap.sc-ion-label-md-h{overflow:hidden}.item-interactive-disabled.sc-ion-label-md-h:not(.item-multiple-inputs),.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-md-h{cursor:default;opacity:0.3;pointer-events:none}.item-input.sc-ion-label-md-h,.item-input .sc-ion-label-md-h{-ms-flex:initial;flex:initial;max-width:200px;pointer-events:none}.item-textarea.sc-ion-label-md-h,.item-textarea .sc-ion-label-md-h{-ms-flex-item-align:baseline;align-self:baseline}.item-skeleton-text.sc-ion-label-md-h,.item-skeleton-text .sc-ion-label-md-h{overflow:hidden}.label-fixed.sc-ion-label-md-h{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}.label-stacked.sc-ion-label-md-h,.label-floating.sc-ion-label-md-h{margin-bottom:0;-ms-flex-item-align:stretch;align-self:stretch;width:auto;max-width:100%}.label-no-animate.label-floating.sc-ion-label-md-h{-webkit-transition:none;transition:none}.sc-ion-label-md-s h1,.sc-ion-label-md-s h2,.sc-ion-label-md-s h3,.sc-ion-label-md-s h4,.sc-ion-label-md-s h5,.sc-ion-label-md-s h6{text-overflow:inherit;overflow:inherit}.ion-text-wrap.sc-ion-label-md-h{line-height:1.5}.label-stacked.sc-ion-label-md-h,.label-floating.sc-ion-label-md-h{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-transform-origin:top left;transform-origin:top left}.label-stacked.label-rtl.sc-ion-label-md-h,.label-floating.label-rtl.sc-ion-label-md-h{-webkit-transform-origin:top right;transform-origin:top right}.label-stacked.sc-ion-label-md-h{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75);-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1)}.label-floating.sc-ion-label-md-h{-webkit-transform:translateY(96%);transform:translateY(96%);-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1)}.ion-focused.label-floating.sc-ion-label-md-h,.ion-focused .label-floating.sc-ion-label-md-h,.item-has-focus.label-floating.sc-ion-label-md-h,.item-has-focus .label-floating.sc-ion-label-md-h,.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating,.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h,.item-has-value.label-floating.sc-ion-label-md-h,.item-has-value .label-floating.sc-ion-label-md-h{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75)}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h{-webkit-transform:translateY(-6px) scale(0.75);transform:translateY(-6px) scale(0.75);position:relative;max-width:-webkit-min-content;max-width:-moz-min-content;max-width:min-content;background-color:var(--ion-item-background, var(--ion-background-color, #fff));overflow:visible;z-index:3}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::after,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::before,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::after,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::after{position:absolute;width:4px;height:100%;background-color:var(--ion-item-background, var(--ion-background-color, #fff));content:""}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::before,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::before,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::before,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::before{left:calc(-1 * 4px)}.item-fill-outline.ion-focused.label-floating.sc-ion-label-md-h::after,.item-fill-outline.ion-focused .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-focus .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).label-floating::after,.item-fill-outline.item-has-placeholder:not(.item-input) .label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value.label-floating.sc-ion-label-md-h::after,.item-fill-outline.item-has-value .label-floating.sc-ion-label-md-h::after{right:calc(-1 * 4px)}.item-fill-outline.ion-focused.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.ion-focused.item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).item-has-start-slot.label-floating,.item-fill-outline.item-has-placeholder:not(.item-input).item-has-start-slot .label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot.label-floating.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot .label-floating.sc-ion-label-md-h{-webkit-transform:translateX(-32px) translateY(-6px) scale(0.75);transform:translateX(-32px) translateY(-6px) scale(0.75)}.item-fill-outline.ion-focused.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.ion-focused.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-focus.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-placeholder.sc-ion-label-md-h:not(.item-input).item-has-start-slot.label-floating.label-rtl,.item-fill-outline.item-has-placeholder:not(.item-input).item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot.label-floating.label-rtl.sc-ion-label-md-h,.item-fill-outline.item-has-value.item-has-start-slot .label-floating.label-rtl.sc-ion-label-md-h{-webkit-transform:translateX(calc(-1 * -32px)) translateY(-6px) scale(0.75);transform:translateX(calc(-1 * -32px)) translateY(-6px) scale(0.75)}.ion-focused.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-focused .label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-primary, #3880ff)}.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-contrast)}.item-fill-solid.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.ion-focused.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-solid.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color.label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color .label-stacked.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color.label-floating.sc-ion-label-md-h:not(.ion-color),.item-fill-outline.item-has-focus.ion-color .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--ion-color-base)}.ion-invalid.ion-touched.label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched .label-stacked.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched.label-floating.sc-ion-label-md-h:not(.ion-color),.ion-invalid.ion-touched .label-floating.sc-ion-label-md-h:not(.ion-color){color:var(--highlight-color-invalid)}.sc-ion-label-md-s h1{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:1.5rem;font-weight:normal}.sc-ion-label-md-s h2{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:1rem;font-weight:normal}.sc-ion-label-md-s h3,.sc-ion-label-md-s h4,.sc-ion-label-md-s h5,.sc-ion-label-md-s h6{margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:0.875rem;font-weight:normal;line-height:normal}.sc-ion-label-md-s p{margin-left:0;margin-right:0;margin-top:0;margin-bottom:2px;font-size:0.875rem;line-height:1.25rem;text-overflow:inherit;overflow:inherit}.sc-ion-label-md-s>p{color:var(--ion-color-step-600, #666666)}.sc-ion-label-md-h.in-item-color.sc-ion-label-md-s>p{color:inherit}', Label = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.ionColor = createEvent(this, "ionColor", 7), this.ionStyle = createEvent(this, "ionStyle", 7), this.inRange = !1, this.color = void 0, this.position = void 0, this.noAnimate = !1;
  }
  componentWillLoad() {
    this.inRange = !!this.el.closest("ion-range"), this.noAnimate = this.position === "floating", this.emitStyle(), this.emitColor();
  }
  componentDidLoad() {
    this.noAnimate && setTimeout(() => {
      this.noAnimate = !1;
    }, 1e3);
  }
  colorChanged() {
    this.emitColor();
  }
  positionChanged() {
    this.emitStyle();
  }
  emitColor() {
    const { color: e } = this;
    this.ionColor.emit({
      "item-label-color": e !== void 0,
      [`ion-color-${e}`]: e !== void 0
    });
  }
  emitStyle() {
    const { inRange: e, position: r } = this;
    e || this.ionStyle.emit({
      label: !0,
      [`label-${r}`]: r !== void 0
    });
  }
  render() {
    const e = this.position, r = getIonMode$2(this);
    return h(Host, { class: createColorClasses$1(this.color, {
      [r]: !0,
      "in-item-color": hostContext("ion-item.ion-color", this.el),
      [`label-${e}`]: e !== void 0,
      "label-no-animate": this.noAnimate,
      "label-rtl": document.dir === "rtl"
    }) });
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      color: ["colorChanged"],
      position: ["positionChanged"]
    };
  }
  static get style() {
    return {
      ios: labelIosCss,
      md: labelMdCss
    };
  }
}, [34, "ion-label", {
  color: [513],
  position: [1],
  noAnimate: [32]
}, void 0, {
  color: ["colorChanged"],
  position: ["positionChanged"]
}]);
function defineCustomElement$B() {
  if (typeof customElements > "u")
    return;
  ["ion-label"].forEach((e) => {
    switch (e) {
      case "ion-label":
        customElements.get(e) || customElements.define(e, Label);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const win = typeof window < "u" ? window : void 0, doc = typeof document < "u" ? document : void 0;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const getCapacitor = () => {
  if (win !== void 0)
    return win.Capacitor;
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var ImpactStyle;
(function(t) {
  t.Heavy = "HEAVY", t.Medium = "MEDIUM", t.Light = "LIGHT";
})(ImpactStyle || (ImpactStyle = {}));
var NotificationType;
(function(t) {
  t.Success = "SUCCESS", t.Warning = "WARNING", t.Error = "ERROR";
})(NotificationType || (NotificationType = {}));
const HapticEngine = {
  getEngine() {
    const t = window.TapticEngine;
    if (t)
      return t;
    const e = getCapacitor();
    if (e != null && e.isPluginAvailable("Haptics"))
      return e.Plugins.Haptics;
  },
  available() {
    if (!this.getEngine())
      return !1;
    const e = getCapacitor();
    return (e == null ? void 0 : e.getPlatform()) === "web" ? typeof navigator < "u" && navigator.vibrate !== void 0 : !0;
  },
  isCordova() {
    return window.TapticEngine !== void 0;
  },
  isCapacitor() {
    return getCapacitor() !== void 0;
  },
  impact(t) {
    const e = this.getEngine();
    if (!e)
      return;
    const r = this.isCapacitor() ? t.style : t.style.toLowerCase();
    e.impact({ style: r });
  },
  notification(t) {
    const e = this.getEngine();
    if (!e)
      return;
    const r = this.isCapacitor() ? t.type : t.type.toLowerCase();
    e.notification({ type: r });
  },
  selection() {
    const t = this.isCapacitor() ? ImpactStyle.Light : "light";
    this.impact({ style: t });
  },
  selectionStart() {
    const t = this.getEngine();
    t && (this.isCapacitor() ? t.selectionStart() : t.gestureSelectionStart());
  },
  selectionChanged() {
    const t = this.getEngine();
    t && (this.isCapacitor() ? t.selectionChanged() : t.gestureSelectionChanged());
  },
  selectionEnd() {
    const t = this.getEngine();
    t && (this.isCapacitor() ? t.selectionEnd() : t.gestureSelectionEnd());
  }
}, hapticAvailable = () => HapticEngine.available(), hapticSelectionStart = () => {
  hapticAvailable() && HapticEngine.selectionStart();
}, hapticSelectionChanged = () => {
  hapticAvailable() && HapticEngine.selectionChanged();
}, hapticSelectionEnd = () => {
  hapticAvailable() && HapticEngine.selectionEnd();
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const attachComponent = async (t, e, r, o, a, c) => {
  var u;
  if (t)
    return t.attachViewToDom(e, r, a, o);
  if (!c && typeof r != "string" && !(r instanceof HTMLElement))
    throw new Error("framework delegate is missing");
  const d = typeof r == "string" ? (u = e.ownerDocument) === null || u === void 0 ? void 0 : u.createElement(r) : r;
  return o && o.forEach((p) => d.classList.add(p)), a && Object.assign(d, a), e.appendChild(d), await new Promise((p) => componentOnReady(d, p)), d;
}, detachComponent = (t, e) => {
  if (e) {
    if (t) {
      const r = e.parentElement;
      return t.removeViewFromDom(r, e);
    }
    e.remove();
  }
  return Promise.resolve();
}, CoreDelegate = () => {
  let t, e;
  return { attachViewToDom: async (a, c, u = {}, d = []) => {
    var p, g;
    t = a;
    let b;
    if (c) {
      const w = typeof c == "string" ? (p = t.ownerDocument) === null || p === void 0 ? void 0 : p.createElement(c) : c;
      d.forEach((y) => w.classList.add(y)), Object.assign(w, u), t.appendChild(w), b = w, await new Promise((y) => componentOnReady(w, y));
    } else if (t.children.length > 0 && (t.tagName === "ION-MODAL" || t.tagName === "ION-POPOVER") && !(b = t.children[0]).classList.contains("ion-delegate-host")) {
      const y = (g = t.ownerDocument) === null || g === void 0 ? void 0 : g.createElement("div");
      y.classList.add("ion-delegate-host"), d.forEach((I) => y.classList.add(I)), y.append(...t.children), t.appendChild(y), b = y;
    }
    const x = document.querySelector("ion-app") || document.body;
    return e = document.createComment("ionic teleport"), t.parentNode.insertBefore(e, t), x.appendChild(t), b ?? t;
  }, removeViewFromDom: () => (t && e && (e.parentNode.insertBefore(t, e), e.remove()), Promise.resolve()) };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const createLockController = () => {
  let t;
  return {
    lock: async () => {
      const r = t;
      let o;
      return t = new Promise((a) => o = a), r !== void 0 && await r, o;
    }
  };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const blockHardwareBackButton = () => {
  document.addEventListener("backbutton", () => {
  });
}, startHardwareBackButton = () => {
  const t = document;
  let e = !1;
  t.addEventListener("backbutton", () => {
    if (e)
      return;
    let r = 0, o = [];
    const a = new CustomEvent("ionBackButton", {
      bubbles: !1,
      detail: {
        register(d, p) {
          o.push({ priority: d, handler: p, id: r++ });
        }
      }
    });
    t.dispatchEvent(a);
    const c = async (d) => {
      try {
        if (d != null && d.handler) {
          const p = d.handler(u);
          p != null && await p;
        }
      } catch (p) {
        console.error(p);
      }
    }, u = () => {
      if (o.length > 0) {
        let d = {
          priority: Number.MIN_SAFE_INTEGER,
          handler: () => {
          },
          id: -1
        };
        o.forEach((p) => {
          p.priority >= d.priority && (d = p);
        }), e = !0, o = o.filter((p) => p.id !== d.id), c(d).then(() => e = !1);
      }
    };
    u();
  });
}, OVERLAY_BACK_BUTTON_PRIORITY = 100, MENU_BACK_BUTTON_PRIORITY = 99, hardwareBackButton = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MENU_BACK_BUTTON_PRIORITY,
  OVERLAY_BACK_BUTTON_PRIORITY,
  blockHardwareBackButton,
  startHardwareBackButton
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let lastOverlayIndex = 0, lastId = 0;
const activeAnimations = /* @__PURE__ */ new WeakMap(), createController$1 = (t) => ({
  create(e) {
    return createOverlay(t, e);
  },
  dismiss(e, r, o) {
    return dismissOverlay(document, e, r, t, o);
  },
  async getTop() {
    return getPresentedOverlay(document, t);
  }
}), alertController = /* @__PURE__ */ createController$1("ion-alert"), actionSheetController = /* @__PURE__ */ createController$1("ion-action-sheet"), popoverController = /* @__PURE__ */ createController$1("ion-popover"), toastController$1 = /* @__PURE__ */ createController$1("ion-toast"), prepareOverlay = (t) => {
  typeof document < "u" && connectListeners(document);
  const e = lastOverlayIndex++;
  t.overlayIndex = e;
}, setOverlayId = (t) => (t.hasAttribute("id") || (t.id = `ion-overlay-${++lastId}`), t.id), createOverlay = (t, e) => typeof window < "u" && typeof window.customElements < "u" ? window.customElements.whenDefined(t).then(() => {
  const r = document.createElement(t);
  return r.classList.add("overlay-hidden"), Object.assign(r, Object.assign(Object.assign({}, e), { hasController: !0 })), getAppRoot(document).appendChild(r), new Promise((o) => componentOnReady(r, o));
}) : Promise.resolve(), focusableQueryString = '[tabindex]:not([tabindex^="-"]):not([hidden]):not([disabled]), input:not([type=hidden]):not([tabindex^="-"]):not([hidden]):not([disabled]), textarea:not([tabindex^="-"]):not([hidden]):not([disabled]), button:not([tabindex^="-"]):not([hidden]):not([disabled]), select:not([tabindex^="-"]):not([hidden]):not([disabled]), .ion-focusable:not([tabindex^="-"]):not([hidden]):not([disabled]), .ion-focusable[disabled="false"]:not([tabindex^="-"]):not([hidden])', focusFirstDescendant = (t, e) => {
  let r = t.querySelector(focusableQueryString);
  const o = r == null ? void 0 : r.shadowRoot;
  o && (r = o.querySelector(focusableQueryString) || r), r ? focusElement(r) : e.focus();
}, isOverlayHidden = (t) => t.classList.contains("overlay-hidden"), focusLastDescendant = (t, e) => {
  const r = Array.from(t.querySelectorAll(focusableQueryString));
  let o = r.length > 0 ? r[r.length - 1] : null;
  const a = o == null ? void 0 : o.shadowRoot;
  a && (o = a.querySelector(focusableQueryString) || o), o ? o.focus() : e.focus();
}, trapKeyboardFocus = (t, e) => {
  const r = getPresentedOverlay(e, "ion-alert,ion-action-sheet,ion-loading,ion-modal,ion-picker,ion-popover"), o = t.target;
  if (!r || !o || r.classList.contains("ion-disable-focus-trap"))
    return;
  const a = () => {
    if (r === o)
      r.lastFocus = void 0;
    else {
      const u = getElementRoot(r);
      if (!u.contains(o))
        return;
      const d = u.querySelector(".ion-overlay-wrapper");
      if (!d)
        return;
      if (d.contains(o) || o === u.querySelector("ion-backdrop"))
        r.lastFocus = o;
      else {
        const p = r.lastFocus;
        focusFirstDescendant(d, r), p === e.activeElement && focusLastDescendant(d, r), r.lastFocus = e.activeElement;
      }
    }
  }, c = () => {
    if (r.contains(o))
      r.lastFocus = o;
    else {
      const u = r.lastFocus;
      focusFirstDescendant(r, r), u === e.activeElement && focusLastDescendant(r, r), r.lastFocus = e.activeElement;
    }
  };
  r.shadowRoot ? c() : a();
}, connectListeners = (t) => {
  lastOverlayIndex === 0 && (lastOverlayIndex = 1, t.addEventListener("focus", (e) => {
    trapKeyboardFocus(e, t);
  }, !0), t.addEventListener("ionBackButton", (e) => {
    const r = getPresentedOverlay(t);
    r != null && r.backdropDismiss && e.detail.register(OVERLAY_BACK_BUTTON_PRIORITY, () => r.dismiss(void 0, BACKDROP));
  }), t.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const r = getPresentedOverlay(t);
      r != null && r.backdropDismiss && r.dismiss(void 0, BACKDROP);
    }
  }));
}, dismissOverlay = (t, e, r, o, a) => {
  const c = getPresentedOverlay(t, o, a);
  return c ? c.dismiss(e, r) : Promise.reject("overlay does not exist");
}, getOverlays = (t, e) => (e === void 0 && (e = "ion-alert,ion-action-sheet,ion-loading,ion-modal,ion-picker,ion-popover,ion-toast"), Array.from(t.querySelectorAll(e)).filter((r) => r.overlayIndex > 0)), getPresentedOverlays = (t, e) => getOverlays(t, e).filter((r) => !isOverlayHidden(r)), getPresentedOverlay = (t, e, r) => {
  const o = getPresentedOverlays(t, e);
  return r === void 0 ? o[o.length - 1] : o.find((a) => a.id === r);
}, setRootAriaHidden = (t = !1) => {
  const r = getAppRoot(document).querySelector("ion-router-outlet, ion-nav, #ion-view-container-root");
  r && (t ? r.setAttribute("aria-hidden", "true") : r.removeAttribute("aria-hidden"));
}, present = async (t, e, r, o, a) => {
  var c, u;
  if (t.presented)
    return;
  setRootAriaHidden(!0), t.presented = !0, t.willPresent.emit(), (c = t.willPresentShorthand) === null || c === void 0 || c.emit();
  const d = getIonMode$2(t), p = t.enterAnimation ? t.enterAnimation : config$1.get(e, d === "ios" ? r : o);
  await overlayAnimation(t, p, t.el, a) && (t.didPresent.emit(), (u = t.didPresentShorthand) === null || u === void 0 || u.emit()), t.el.tagName !== "ION-TOAST" && focusPreviousElementOnDismiss(t.el), t.keyboardClose && (document.activeElement === null || !t.el.contains(document.activeElement)) && t.el.focus();
}, focusPreviousElementOnDismiss = async (t) => {
  let e = document.activeElement;
  if (!e)
    return;
  const r = e == null ? void 0 : e.shadowRoot;
  r && (e = r.querySelector(focusableQueryString) || e), await t.onDidDismiss(), e.focus();
}, dismiss = async (t, e, r, o, a, c, u) => {
  var d, p;
  if (!t.presented)
    return !1;
  doc !== void 0 && getPresentedOverlays(doc).length === 1 && setRootAriaHidden(!1), t.presented = !1;
  try {
    t.el.style.setProperty("pointer-events", "none"), t.willDismiss.emit({ data: e, role: r }), (d = t.willDismissShorthand) === null || d === void 0 || d.emit({ data: e, role: r });
    const g = getIonMode$2(t), b = t.leaveAnimation ? t.leaveAnimation : config$1.get(o, g === "ios" ? a : c);
    r !== GESTURE && await overlayAnimation(t, b, t.el, u), t.didDismiss.emit({ data: e, role: r }), (p = t.didDismissShorthand) === null || p === void 0 || p.emit({ data: e, role: r }), activeAnimations.delete(t), t.el.classList.add("overlay-hidden"), t.el.style.removeProperty("pointer-events"), t.el.lastFocus !== void 0 && (t.el.lastFocus = void 0);
  } catch (g) {
    console.error(g);
  }
  return t.el.remove(), !0;
}, getAppRoot = (t) => t.querySelector("ion-app") || t.body, overlayAnimation = async (t, e, r, o) => {
  r.classList.remove("overlay-hidden");
  const a = t.el, c = e(a, o);
  (!t.animated || !config$1.getBoolean("animated", !0)) && c.duration(0), t.keyboardClose && c.beforeAddWrite(() => {
    const d = r.ownerDocument.activeElement;
    d != null && d.matches("input,ion-input, ion-textarea") && d.blur();
  });
  const u = activeAnimations.get(t) || [];
  return activeAnimations.set(t, [...u, c]), await c.play(), !0;
}, eventMethod = (t, e) => {
  let r;
  const o = new Promise((a) => r = a);
  return onceEvent(t, e, (a) => {
    r(a.detail);
  }), o;
}, onceEvent = (t, e, r) => {
  const o = (a) => {
    removeEventListener(t, e, o), r(a);
  };
  addEventListener$1(t, e, o);
}, isCancel$2 = (t) => t === "cancel" || t === BACKDROP, defaultGate = (t) => t(), safeCall = (t, e) => {
  if (typeof t == "function")
    return config$1.get("_zoneGate", defaultGate)(() => {
      try {
        return t(e);
      } catch (o) {
        throw o;
      }
    });
}, BACKDROP = "backdrop", GESTURE = "gesture", OVERLAY_GESTURE_PRIORITY = 39, createDelegateController = (t) => {
  let e = !1, r;
  const o = CoreDelegate(), a = (d = !1) => {
    if (r && !d)
      return {
        delegate: r,
        inline: e
      };
    const { el: p, hasController: g, delegate: b } = t;
    return e = p.parentNode !== null && !g, r = e ? b || o : b, { inline: e, delegate: r };
  };
  return {
    attachViewToDom: async (d) => {
      const { delegate: p } = a(!0);
      if (p)
        return await p.attachViewToDom(t.el, d);
      const { hasController: g } = t;
      if (g && d !== void 0)
        throw new Error("framework delegate is missing");
      return null;
    },
    removeViewFromDom: () => {
      const { delegate: d } = a();
      d && t.el !== void 0 && d.removeViewFromDom(t.el.parentElement, t.el);
    }
  };
}, createTriggerController = () => {
  let t;
  const e = () => {
    t && (t(), t = void 0);
  };
  return {
    addClickListener: (o, a) => {
      e();
      const c = a !== void 0 ? document.getElementById(a) : null;
      if (!c) {
        printIonWarning(`A trigger element with the ID "${a}" was not found in the DOM. The trigger element must be in the DOM when the "trigger" property is set on an overlay component.`, o);
        return;
      }
      t = ((d, p) => {
        const g = () => {
          p.present();
        };
        return d.addEventListener("click", g), () => {
          d.removeEventListener("click", g);
        };
      })(c, o);
    },
    removeClickListener: e
  };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const LIFECYCLE_WILL_ENTER = "ionViewWillEnter", LIFECYCLE_DID_ENTER = "ionViewDidEnter", LIFECYCLE_WILL_LEAVE = "ionViewWillLeave", LIFECYCLE_DID_LEAVE = "ionViewDidLeave", LIFECYCLE_WILL_UNLOAD = "ionViewWillUnload", iosTransitionAnimation = () => import("./ios.transition-ca6ea50c.js"), mdTransitionAnimation = () => import("./md.transition-921897ed.js"), transition = (t) => new Promise((e, r) => {
  writeTask(() => {
    beforeTransition(t), runTransition(t).then((o) => {
      o.animation && o.animation.destroy(), afterTransition(t), e(o);
    }, (o) => {
      afterTransition(t), r(o);
    });
  });
}), beforeTransition = (t) => {
  const e = t.enteringEl, r = t.leavingEl;
  setZIndex(e, r, t.direction), t.showGoBack ? e.classList.add("can-go-back") : e.classList.remove("can-go-back"), setPageHidden(e, !1), e.style.setProperty("pointer-events", "none"), r && (setPageHidden(r, !1), r.style.setProperty("pointer-events", "none"));
}, runTransition = async (t) => {
  const e = await getAnimationBuilder(t);
  return e && Build.isBrowser ? animation(e, t) : noAnimation(t);
}, afterTransition = (t) => {
  const e = t.enteringEl, r = t.leavingEl;
  e.classList.remove("ion-page-invisible"), e.style.removeProperty("pointer-events"), r !== void 0 && (r.classList.remove("ion-page-invisible"), r.style.removeProperty("pointer-events"));
}, getAnimationBuilder = async (t) => !t.leavingEl || !t.animated || t.duration === 0 ? void 0 : t.animationBuilder ? t.animationBuilder : t.mode === "ios" ? (await iosTransitionAnimation()).iosTransitionAnimation : (await mdTransitionAnimation()).mdTransitionAnimation, animation = async (t, e) => {
  await waitForReady(e, !0);
  const r = t(e.baseEl, e);
  fireWillEvents(e.enteringEl, e.leavingEl);
  const o = await playTransition(r, e);
  return e.progressCallback && e.progressCallback(void 0), o && fireDidEvents(e.enteringEl, e.leavingEl), {
    hasCompleted: o,
    animation: r
  };
}, noAnimation = async (t) => {
  const e = t.enteringEl, r = t.leavingEl;
  return await waitForReady(t, !1), fireWillEvents(e, r), fireDidEvents(e, r), {
    hasCompleted: !0
  };
}, waitForReady = async (t, e) => {
  (t.deepWait !== void 0 ? t.deepWait : e) && await Promise.all([deepReady(t.enteringEl), deepReady(t.leavingEl)]), await notifyViewReady(t.viewIsReady, t.enteringEl);
}, notifyViewReady = async (t, e) => {
  t && await t(e);
}, playTransition = (t, e) => {
  const r = e.progressCallback, o = new Promise((a) => {
    t.onFinish((c) => a(c === 1));
  });
  return r ? (t.progressStart(!0), r(t)) : t.play(), o;
}, fireWillEvents = (t, e) => {
  lifecycle(e, LIFECYCLE_WILL_LEAVE), lifecycle(t, LIFECYCLE_WILL_ENTER);
}, fireDidEvents = (t, e) => {
  lifecycle(t, LIFECYCLE_DID_ENTER), lifecycle(e, LIFECYCLE_DID_LEAVE);
}, lifecycle = (t, e) => {
  if (t) {
    const r = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !1
    });
    t.dispatchEvent(r);
  }
}, waitForMount = () => new Promise((t) => raf(() => raf(() => t()))), deepReady = async (t) => {
  const e = t;
  if (e) {
    if (e.componentOnReady != null) {
      if (await e.componentOnReady() != null)
        return;
    } else if (e.__registerHost != null) {
      await new Promise((o) => raf(o));
      return;
    }
    await Promise.all(Array.from(e.children).map(deepReady));
  }
}, setPageHidden = (t, e) => {
  e ? (t.setAttribute("aria-hidden", "true"), t.classList.add("ion-page-hidden")) : (t.hidden = !1, t.removeAttribute("aria-hidden"), t.classList.remove("ion-page-hidden"));
}, setZIndex = (t, e, r) => {
  t !== void 0 && (t.style.zIndex = r === "back" ? "99" : "101"), e !== void 0 && (e.style.zIndex = "100");
}, getIonPageElement = (t) => {
  if (t.classList.contains("ion-page"))
    return t;
  const e = t.querySelector(":scope > .ion-page, :scope > ion-nav, :scope > ion-tabs");
  return e || t;
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
let animationPrefix;
const processKeyframes = (t) => (t.forEach((e) => {
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const o = e[r];
      if (r === "easing") {
        const a = "animation-timing-function";
        e[a] = o, delete e[r];
      } else {
        const a = convertCamelCaseToHypen(r);
        a !== r && (e[a] = o, delete e[r]);
      }
    }
}), t), convertCamelCaseToHypen = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), getAnimationPrefix = (t) => {
  if (animationPrefix === void 0) {
    const e = t.style.animationName !== void 0, r = t.style.webkitAnimationName !== void 0;
    animationPrefix = !e && r ? "-webkit-" : "";
  }
  return animationPrefix;
}, setStyleProperty = (t, e, r) => {
  const o = e.startsWith("animation") ? getAnimationPrefix(t) : "";
  t.style.setProperty(o + e, r);
}, removeStyleProperty = (t, e) => {
  const r = e.startsWith("animation") ? getAnimationPrefix(t) : "";
  t.style.removeProperty(r + e);
}, animationEnd = (t, e) => {
  let r;
  const o = { passive: !0 }, a = () => {
    r && r();
  }, c = (u) => {
    t === u.target && (a(), e(u));
  };
  return t && (t.addEventListener("webkitAnimationEnd", c, o), t.addEventListener("animationend", c, o), r = () => {
    t.removeEventListener("webkitAnimationEnd", c, o), t.removeEventListener("animationend", c, o);
  }), a;
}, generateKeyframeRules = (t = []) => t.map((e) => {
  const r = e.offset, o = [];
  for (const a in e)
    e.hasOwnProperty(a) && a !== "offset" && o.push(`${a}: ${e[a]};`);
  return `${r * 100}% { ${o.join(" ")} }`;
}).join(" "), keyframeIds = [], generateKeyframeName = (t) => {
  let e = keyframeIds.indexOf(t);
  return e < 0 && (e = keyframeIds.push(t) - 1), `ion-animation-${e}`;
}, getStyleContainer = (t) => {
  const e = t.getRootNode !== void 0 ? t.getRootNode() : t;
  return e.head || e;
}, createKeyframeStylesheet = (t, e, r) => {
  var o;
  const a = getStyleContainer(r), c = getAnimationPrefix(r), u = a.querySelector("#" + t);
  if (u)
    return u;
  const d = ((o = r.ownerDocument) !== null && o !== void 0 ? o : document).createElement("style");
  return d.id = t, d.textContent = `@${c}keyframes ${t} { ${e} } @${c}keyframes ${t}-alt { ${e} }`, a.appendChild(d), d;
}, addClassToArray = (t = [], e) => {
  if (e !== void 0) {
    const r = Array.isArray(e) ? e : [e];
    return [...t, ...r];
  }
  return t;
}, createAnimation = (t) => {
  let e, r, o, a, c, u, d = [], p = [], g = [], b = !1, x, w = {}, y = [], I = [], E = {}, T = 0, C = !1, $ = !1, D, L, R, O, P = !0, z = !1, W = !0, A, S, F = !1;
  const U = t, M = [], V = [], G = [], Q = [], fe = [], te = [], de = [], me = [], Me = [], ce = [], oe = [], be = typeof AnimationEffect == "function" || win !== void 0 && typeof win.AnimationEffect == "function", Te = typeof Element == "function" && typeof Element.prototype.animate == "function" && be, Ae = 100, je = () => oe, Xe = (ae) => (fe.forEach((_e) => {
    _e.destroy(ae);
  }), He(ae), Q.length = 0, fe.length = 0, d.length = 0, Ce(), b = !1, W = !0, S), He = (ae) => {
    Le(), ae && qe();
  }, Ke = () => {
    C = !1, $ = !1, W = !0, L = void 0, R = void 0, O = void 0, T = 0, z = !1, P = !0, F = !1;
  }, ot = () => T !== 0 && !F, K = (ae, _e) => {
    const De = _e.findIndex((ft) => ft.c === ae);
    De > -1 && _e.splice(De, 1);
  }, q = (ae, _e) => (G.push({ c: ae, o: _e }), S), se = (ae, _e) => ((_e != null && _e.oneTimeCallback ? V : M).push({ c: ae, o: _e }), S), Ce = () => (M.length = 0, V.length = 0, S), Le = () => {
    if (Te)
      oe.forEach((ae) => {
        ae.cancel();
      }), oe.length = 0;
    else {
      const ae = Q.slice();
      raf(() => {
        ae.forEach((_e) => {
          removeStyleProperty(_e, "animation-name"), removeStyleProperty(_e, "animation-duration"), removeStyleProperty(_e, "animation-timing-function"), removeStyleProperty(_e, "animation-iteration-count"), removeStyleProperty(_e, "animation-delay"), removeStyleProperty(_e, "animation-play-state"), removeStyleProperty(_e, "animation-fill-mode"), removeStyleProperty(_e, "animation-direction");
        });
      });
    }
  }, qe = () => {
    te.forEach((ae) => {
      ae != null && ae.parentNode && ae.parentNode.removeChild(ae);
    }), te.length = 0;
  }, Ct = (ae) => (de.push(ae), S), ke = (ae) => (me.push(ae), S), xe = (ae) => (Me.push(ae), S), Ne = (ae) => (ce.push(ae), S), Se = (ae) => (p = addClassToArray(p, ae), S), ie = (ae) => (g = addClassToArray(g, ae), S), he = (ae = {}) => (w = ae, S), Ye = (ae = []) => {
    for (const _e of ae)
      w[_e] = "";
    return S;
  }, et = (ae) => (y = addClassToArray(y, ae), S), bt = (ae) => (I = addClassToArray(I, ae), S), $e = (ae = {}) => (E = ae, S), Ee = (ae = []) => {
    for (const _e of ae)
      E[_e] = "";
    return S;
  }, Ie = () => c !== void 0 ? c : x ? x.getFill() : "both", ze = () => L !== void 0 ? L : u !== void 0 ? u : x ? x.getDirection() : "normal", ct = () => C ? "linear" : o !== void 0 ? o : x ? x.getEasing() : "linear", st = () => $ ? 0 : R !== void 0 ? R : r !== void 0 ? r : x ? x.getDuration() : 0, ht = () => a !== void 0 ? a : x ? x.getIterations() : 1, Rt = () => O !== void 0 ? O : e !== void 0 ? e : x ? x.getDelay() : 0, ar = () => d, To = (ae) => (u = ae, Ft(!0), S), Io = (ae) => (c = ae, Ft(!0), S), Oo = (ae) => (e = ae, Ft(!0), S), Ar = (ae) => (o = ae, Ft(!0), S), $r = (ae) => (!Te && ae === 0 && (ae = 1), r = ae, Ft(!0), S), Ao = (ae) => (a = ae, Ft(!0), S), $o = (ae) => (x = ae, S), Do = (ae) => {
    if (ae != null)
      if (ae.nodeType === 1)
        Q.push(ae);
      else if (ae.length >= 0)
        for (let _e = 0; _e < ae.length; _e++)
          Q.push(ae[_e]);
      else
        console.error("Invalid addElement value");
    return S;
  }, Lo = (ae) => {
    if (ae != null)
      if (Array.isArray(ae))
        for (const _e of ae)
          _e.parent(S), fe.push(_e);
      else
        ae.parent(S), fe.push(ae);
    return S;
  }, Dr = (ae) => {
    const _e = d !== ae;
    return d = ae, _e && Ro(d), S;
  }, Ro = (ae) => {
    Te ? je().forEach((_e) => {
      const De = _e.effect;
      if (De.setKeyframes)
        De.setKeyframes(ae);
      else {
        const ft = new KeyframeEffect(De.target, ae, De.getTiming());
        _e.effect = ft;
      }
    }) : Lr();
  }, Po = () => {
    de.forEach((ft) => ft()), me.forEach((ft) => ft());
    const ae = p, _e = g, De = w;
    Q.forEach((ft) => {
      const Et = ft.classList;
      ae.forEach((jt) => Et.add(jt)), _e.forEach((jt) => Et.remove(jt));
      for (const jt in De)
        De.hasOwnProperty(jt) && setStyleProperty(ft, jt, De[jt]);
    });
  }, No = () => {
    ur(), Me.forEach((Et) => Et()), ce.forEach((Et) => Et());
    const ae = P ? 1 : 0, _e = y, De = I, ft = E;
    Q.forEach((Et) => {
      const jt = Et.classList;
      _e.forEach((mn) => jt.add(mn)), De.forEach((mn) => jt.remove(mn));
      for (const mn in ft)
        ft.hasOwnProperty(mn) && setStyleProperty(Et, mn, ft[mn]);
    }), R = void 0, L = void 0, O = void 0, M.forEach((Et) => Et.c(ae, S)), V.forEach((Et) => Et.c(ae, S)), V.length = 0, W = !0, P && (z = !0), P = !0;
  }, un = () => {
    T !== 0 && (T--, T === 0 && (No(), x && x.animationFinish()));
  }, Lr = (ae = !0) => {
    qe();
    const _e = processKeyframes(d);
    Q.forEach((De) => {
      if (_e.length > 0) {
        const ft = generateKeyframeRules(_e);
        A = t !== void 0 ? t : generateKeyframeName(ft);
        const Et = createKeyframeStylesheet(A, ft, De);
        te.push(Et), setStyleProperty(De, "animation-duration", `${st()}ms`), setStyleProperty(De, "animation-timing-function", ct()), setStyleProperty(De, "animation-delay", `${Rt()}ms`), setStyleProperty(De, "animation-fill-mode", Ie()), setStyleProperty(De, "animation-direction", ze());
        const jt = ht() === 1 / 0 ? "infinite" : ht().toString();
        setStyleProperty(De, "animation-iteration-count", jt), setStyleProperty(De, "animation-play-state", "paused"), ae && setStyleProperty(De, "animation-name", `${Et.id}-alt`), raf(() => {
          setStyleProperty(De, "animation-name", Et.id || null);
        });
      }
    });
  }, lr = () => {
    Q.forEach((ae) => {
      const _e = ae.animate(d, {
        id: U,
        delay: Rt(),
        duration: st(),
        easing: ct(),
        iterations: ht(),
        fill: Ie(),
        direction: ze()
      });
      _e.pause(), oe.push(_e);
    }), oe.length > 0 && (oe[0].onfinish = () => {
      un();
    });
  }, Rr = (ae = !0) => {
    Po(), d.length > 0 && (Te ? lr() : Lr(ae)), b = !0;
  }, Rn = (ae) => {
    if (ae = Math.min(Math.max(ae, 0), 0.9999), Te)
      oe.forEach((_e) => {
        _e.currentTime = _e.effect.getComputedTiming().delay + st() * ae, _e.pause();
      });
    else {
      const _e = `-${st() * ae}ms`;
      Q.forEach((De) => {
        d.length > 0 && (setStyleProperty(De, "animation-delay", _e), setStyleProperty(De, "animation-play-state", "paused"));
      });
    }
  }, Nr = (ae) => {
    oe.forEach((_e) => {
      _e.effect.updateTiming({
        delay: Rt(),
        duration: st(),
        easing: ct(),
        iterations: ht(),
        fill: Ie(),
        direction: ze()
      });
    }), ae !== void 0 && Rn(ae);
  }, Mr = (ae = !0, _e) => {
    raf(() => {
      Q.forEach((De) => {
        setStyleProperty(De, "animation-name", A || null), setStyleProperty(De, "animation-duration", `${st()}ms`), setStyleProperty(De, "animation-timing-function", ct()), setStyleProperty(De, "animation-delay", _e !== void 0 ? `-${_e * st()}ms` : `${Rt()}ms`), setStyleProperty(De, "animation-fill-mode", Ie() || null), setStyleProperty(De, "animation-direction", ze() || null);
        const ft = ht() === 1 / 0 ? "infinite" : ht().toString();
        setStyleProperty(De, "animation-iteration-count", ft), ae && setStyleProperty(De, "animation-name", `${A}-alt`), raf(() => {
          setStyleProperty(De, "animation-name", A || null);
        });
      });
    });
  }, Ft = (ae = !1, _e = !0, De) => (ae && fe.forEach((ft) => {
    ft.update(ae, _e, De);
  }), Te ? Nr(De) : Mr(_e, De), S), Mo = (ae = !1, _e) => (fe.forEach((De) => {
    De.progressStart(ae, _e);
  }), cr(), C = ae, b || Rr(), Ft(!1, !0, _e), S), Fo = (ae) => (fe.forEach((_e) => {
    _e.progressStep(ae);
  }), Rn(ae), S), jo = (ae, _e, De) => (C = !1, fe.forEach((ft) => {
    ft.progressEnd(ae, _e, De);
  }), De !== void 0 && (R = De), z = !1, P = !0, ae === 0 ? (L = ze() === "reverse" ? "normal" : "reverse", L === "reverse" && (P = !1), Te ? (Ft(), Rn(1 - _e)) : (O = (1 - _e) * st() * -1, Ft(!1, !1))) : ae === 1 && (Te ? (Ft(), Rn(_e)) : (O = _e * st() * -1, Ft(!1, !1))), ae !== void 0 && !x && Fr(), S), cr = () => {
    b && (Te ? oe.forEach((ae) => {
      ae.pause();
    }) : Q.forEach((ae) => {
      setStyleProperty(ae, "animation-play-state", "paused");
    }), F = !0);
  }, Bo = () => (fe.forEach((ae) => {
    ae.pause();
  }), cr(), S), Uo = () => {
    D = void 0, un();
  }, ur = () => {
    D && clearTimeout(D);
  }, Vo = () => {
    if (ur(), raf(() => {
      Q.forEach((ae) => {
        d.length > 0 && setStyleProperty(ae, "animation-play-state", "running");
      });
    }), d.length === 0 || Q.length === 0)
      un();
    else {
      const ae = Rt() || 0, _e = st() || 0, De = ht() || 1;
      isFinite(De) && (D = setTimeout(Uo, ae + _e * De + Ae)), animationEnd(Q[0], () => {
        ur(), raf(() => {
          zo(), raf(un);
        });
      });
    }
  }, zo = () => {
    Q.forEach((ae) => {
      removeStyleProperty(ae, "animation-duration"), removeStyleProperty(ae, "animation-delay"), removeStyleProperty(ae, "animation-play-state");
    });
  }, Ho = () => {
    oe.forEach((ae) => {
      ae.play();
    }), (d.length === 0 || Q.length === 0) && un();
  }, Hn = () => {
    Te ? (Rn(0), Nr()) : Mr();
  }, Fr = (ae) => new Promise((_e) => {
    ae != null && ae.sync && ($ = !0, se(() => $ = !1, { oneTimeCallback: !0 })), b || Rr(), z && (Hn(), z = !1), W && (T = fe.length + 1, W = !1);
    const De = () => {
      K(ft, V), _e();
    }, ft = () => {
      K(De, G), _e();
    };
    se(ft, { oneTimeCallback: !0 }), q(De, { oneTimeCallback: !0 }), fe.forEach((Et) => {
      Et.play();
    }), Te ? Ho() : Vo(), F = !1;
  }), qn = () => {
    fe.forEach((ae) => {
      ae.stop();
    }), b && (Le(), b = !1), Ke(), G.forEach((ae) => ae.c(0, S)), G.length = 0;
  }, jr = (ae, _e) => {
    const De = d[0];
    return De !== void 0 && (De.offset === void 0 || De.offset === 0) ? De[ae] = _e : d = [{ offset: 0, [ae]: _e }, ...d], S;
  };
  return S = {
    parentAnimation: x,
    elements: Q,
    childAnimations: fe,
    id: U,
    animationFinish: un,
    from: jr,
    to: (ae, _e) => {
      const De = d[d.length - 1];
      return De !== void 0 && (De.offset === void 0 || De.offset === 1) ? De[ae] = _e : d = [...d, { offset: 1, [ae]: _e }], S;
    },
    fromTo: (ae, _e, De) => jr(ae, _e).to(ae, De),
    parent: $o,
    play: Fr,
    pause: Bo,
    stop: qn,
    destroy: Xe,
    keyframes: Dr,
    addAnimation: Lo,
    addElement: Do,
    update: Ft,
    fill: Io,
    direction: To,
    iterations: Ao,
    duration: $r,
    easing: Ar,
    delay: Oo,
    getWebAnimations: je,
    getKeyframes: ar,
    getFill: Ie,
    getDirection: ze,
    getDelay: Rt,
    getIterations: ht,
    getEasing: ct,
    getDuration: st,
    afterAddRead: xe,
    afterAddWrite: Ne,
    afterClearStyles: Ee,
    afterStyles: $e,
    afterRemoveClass: bt,
    afterAddClass: et,
    beforeAddRead: Ct,
    beforeAddWrite: ke,
    beforeClearStyles: Ye,
    beforeStyles: he,
    beforeRemoveClass: ie,
    beforeAddClass: Se,
    onFinish: se,
    isRunning: ot,
    progressStart: Mo,
    progressStep: Fo,
    progressEnd: jo
  };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const getArrowDimensions = (t) => {
  if (!t)
    return { arrowWidth: 0, arrowHeight: 0 };
  const { width: e, height: r } = t.getBoundingClientRect();
  return { arrowWidth: e, arrowHeight: r };
}, getPopoverDimensions = (t, e, r) => {
  const o = e.getBoundingClientRect(), a = o.height;
  let c = o.width;
  return t === "cover" && r && (c = r.getBoundingClientRect().width), {
    contentWidth: c,
    contentHeight: a
  };
}, configureDismissInteraction = (t, e, r, o) => {
  let a = [];
  const u = getElementRoot(o).querySelector(".popover-content");
  switch (e) {
    case "hover":
      a = [
        {
          /**
           * Do not use mouseover here
           * as this will causes the event to
           * be dispatched on each underlying
           * element rather than on the popover
           * content as a whole.
           */
          eventName: "mouseenter",
          callback: (d) => {
            document.elementFromPoint(d.clientX, d.clientY) !== t && r.dismiss(void 0, void 0, !1);
          }
        }
      ];
      break;
    case "context-menu":
    case "click":
    default:
      a = [
        {
          eventName: "click",
          callback: (d) => {
            if (d.target.closest("[data-ion-popover-trigger]") === t) {
              d.stopPropagation();
              return;
            }
            r.dismiss(void 0, void 0, !1);
          }
        }
      ];
      break;
  }
  return a.forEach(({ eventName: d, callback: p }) => u.addEventListener(d, p)), () => {
    a.forEach(({ eventName: d, callback: p }) => u.removeEventListener(d, p));
  };
}, configureTriggerInteraction = (t, e, r) => {
  let o = [];
  switch (e) {
    case "hover":
      let a;
      o = [
        {
          eventName: "mouseenter",
          callback: async (c) => {
            c.stopPropagation(), a && clearTimeout(a), a = setTimeout(() => {
              raf(() => {
                r.presentFromTrigger(c), a = void 0;
              });
            }, 100);
          }
        },
        {
          eventName: "mouseleave",
          callback: (c) => {
            a && clearTimeout(a);
            const u = c.relatedTarget;
            u && u.closest("ion-popover") !== r && r.dismiss(void 0, void 0, !1);
          }
        },
        {
          /**
           * stopPropagation here prevents the popover
           * from dismissing when dismiss-on-select="true".
           */
          eventName: "click",
          callback: (c) => c.stopPropagation()
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (c) => r.presentFromTrigger(c, !0)
        }
      ];
      break;
    case "context-menu":
      o = [
        {
          eventName: "contextmenu",
          callback: (c) => {
            c.preventDefault(), r.presentFromTrigger(c);
          }
        },
        {
          eventName: "click",
          callback: (c) => c.stopPropagation()
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (c) => r.presentFromTrigger(c, !0)
        }
      ];
      break;
    case "click":
    default:
      o = [
        {
          /**
           * Do not do a stopPropagation() here
           * because if you had two click triggers
           * then clicking the first trigger and then
           * clicking the second trigger would not cause
           * the first popover to dismiss.
           */
          eventName: "click",
          callback: (c) => r.presentFromTrigger(c)
        },
        {
          eventName: "ionPopoverActivateTrigger",
          callback: (c) => r.presentFromTrigger(c, !0)
        }
      ];
      break;
  }
  return o.forEach(({ eventName: a, callback: c }) => t.addEventListener(a, c)), t.setAttribute("data-ion-popover-trigger", "true"), () => {
    o.forEach(({ eventName: a, callback: c }) => t.removeEventListener(a, c)), t.removeAttribute("data-ion-popover-trigger");
  };
}, getIndexOfItem = (t, e) => !e || e.tagName !== "ION-ITEM" ? -1 : t.findIndex((r) => r === e), getNextItem = (t, e) => {
  const r = getIndexOfItem(t, e);
  return t[r + 1];
}, getPrevItem = (t, e) => {
  const r = getIndexOfItem(t, e);
  return t[r - 1];
}, focusItem = (t) => {
  const r = getElementRoot(t).querySelector("button");
  r && raf(() => r.focus());
}, isTriggerElement = (t) => t.hasAttribute("data-ion-popover-trigger"), configureKeyboardInteraction = (t) => {
  const e = async (r) => {
    var o;
    const a = document.activeElement;
    let c = [];
    const u = (o = r.target) === null || o === void 0 ? void 0 : o.tagName;
    if (!(u !== "ION-POPOVER" && u !== "ION-ITEM")) {
      try {
        c = Array.from(t.querySelectorAll("ion-item:not(ion-popover ion-popover *):not([disabled])"));
      } catch {
      }
      switch (r.key) {
        case "ArrowLeft":
          await t.getParentPopover() && t.dismiss(void 0, void 0, !1);
          break;
        case "ArrowDown":
          r.preventDefault();
          const p = getNextItem(c, a);
          p !== void 0 && focusItem(p);
          break;
        case "ArrowUp":
          r.preventDefault();
          const g = getPrevItem(c, a);
          g !== void 0 && focusItem(g);
          break;
        case "Home":
          r.preventDefault();
          const b = c[0];
          b !== void 0 && focusItem(b);
          break;
        case "End":
          r.preventDefault();
          const x = c[c.length - 1];
          x !== void 0 && focusItem(x);
          break;
        case "ArrowRight":
        case " ":
        case "Enter":
          if (a && isTriggerElement(a)) {
            const w = new CustomEvent("ionPopoverActivateTrigger");
            a.dispatchEvent(w);
          }
          break;
      }
    }
  };
  return t.addEventListener("keydown", e), () => t.removeEventListener("keydown", e);
}, getPopoverPosition = (t, e, r, o, a, c, u, d, p, g, b) => {
  var x;
  let w = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  };
  switch (c) {
    case "event":
      if (!b)
        return p;
      const R = b;
      w = {
        top: R.clientY,
        left: R.clientX,
        width: 1,
        height: 1
      };
      break;
    case "trigger":
    default:
      const O = b, P = g || ((x = O == null ? void 0 : O.detail) === null || x === void 0 ? void 0 : x.ionShadowTarget) || (O == null ? void 0 : O.target);
      if (!P)
        return p;
      const z = P.getBoundingClientRect();
      w = {
        top: z.top,
        left: z.left,
        width: z.width,
        height: z.height
      };
      break;
  }
  const y = calculatePopoverSide(u, w, e, r, o, a, t), I = calculatePopoverAlign(d, u, w, e, r), E = y.top + I.top, T = y.left + I.left, { arrowTop: C, arrowLeft: $ } = calculateArrowPosition(u, o, a, E, T, e, r, t), { originX: D, originY: L } = calculatePopoverOrigin(u, d, t);
  return { top: E, left: T, referenceCoordinates: w, arrowTop: C, arrowLeft: $, originX: D, originY: L };
}, calculatePopoverOrigin = (t, e, r) => {
  switch (t) {
    case "top":
      return { originX: getOriginXAlignment(e), originY: "bottom" };
    case "bottom":
      return { originX: getOriginXAlignment(e), originY: "top" };
    case "left":
      return { originX: "right", originY: getOriginYAlignment(e) };
    case "right":
      return { originX: "left", originY: getOriginYAlignment(e) };
    case "start":
      return { originX: r ? "left" : "right", originY: getOriginYAlignment(e) };
    case "end":
      return { originX: r ? "right" : "left", originY: getOriginYAlignment(e) };
  }
}, getOriginXAlignment = (t) => {
  switch (t) {
    case "start":
      return "left";
    case "center":
      return "center";
    case "end":
      return "right";
  }
}, getOriginYAlignment = (t) => {
  switch (t) {
    case "start":
      return "top";
    case "center":
      return "center";
    case "end":
      return "bottom";
  }
}, calculateArrowPosition = (t, e, r, o, a, c, u, d) => {
  const p = {
    arrowTop: o + u / 2 - e / 2,
    arrowLeft: a + c - e / 2
  }, g = { arrowTop: o + u / 2 - e / 2, arrowLeft: a - e * 1.5 };
  switch (t) {
    case "top":
      return { arrowTop: o + u, arrowLeft: a + c / 2 - e / 2 };
    case "bottom":
      return { arrowTop: o - r, arrowLeft: a + c / 2 - e / 2 };
    case "left":
      return p;
    case "right":
      return g;
    case "start":
      return d ? g : p;
    case "end":
      return d ? p : g;
    default:
      return { arrowTop: 0, arrowLeft: 0 };
  }
}, calculatePopoverSide = (t, e, r, o, a, c, u) => {
  const d = {
    top: e.top,
    left: e.left - r - a
  }, p = {
    top: e.top,
    left: e.left + e.width + a
  };
  switch (t) {
    case "top":
      return {
        top: e.top - o - c,
        left: e.left
      };
    case "right":
      return p;
    case "bottom":
      return {
        top: e.top + e.height + c,
        left: e.left
      };
    case "left":
      return d;
    case "start":
      return u ? p : d;
    case "end":
      return u ? d : p;
  }
}, calculatePopoverAlign = (t, e, r, o, a) => {
  switch (t) {
    case "center":
      return calculatePopoverCenterAlign(e, r, o, a);
    case "end":
      return calculatePopoverEndAlign(e, r, o, a);
    case "start":
    default:
      return { top: 0, left: 0 };
  }
}, calculatePopoverEndAlign = (t, e, r, o) => {
  switch (t) {
    case "start":
    case "end":
    case "left":
    case "right":
      return {
        top: -(o - e.height),
        left: 0
      };
    case "top":
    case "bottom":
    default:
      return {
        top: 0,
        left: -(r - e.width)
      };
  }
}, calculatePopoverCenterAlign = (t, e, r, o) => {
  switch (t) {
    case "start":
    case "end":
    case "left":
    case "right":
      return {
        top: -(o / 2 - e.height / 2),
        left: 0
      };
    case "top":
    case "bottom":
    default:
      return {
        top: 0,
        left: -(r / 2 - e.width / 2)
      };
  }
}, calculateWindowAdjustment = (t, e, r, o, a, c, u, d, p, g, b, x, w = 0, y = 0, I = 0) => {
  let E = w;
  const T = y;
  let C = r, $ = e, D, L = g, R = b, O = !1, P = !1;
  const z = x ? x.top + x.height : c / 2 - d / 2, W = x ? x.height : 0;
  let A = !1;
  return C < o + p ? (C = o, O = !0, L = "left") : u + o + C + p > a && (P = !0, C = a - u - o, L = "right"), z + W + d > c && (t === "top" || t === "bottom") && (z - d > 0 ? ($ = Math.max(12, z - d - W - (I - 1)), E = $ + d, R = "bottom", A = !0) : D = o), {
    top: $,
    left: C,
    bottom: D,
    originX: L,
    originY: R,
    checkSafeAreaLeft: O,
    checkSafeAreaRight: P,
    arrowTop: E,
    arrowLeft: T,
    addPopoverBottomClass: A
  };
}, shouldShowArrow = (t, e = !1, r, o) => !(!r && !o || t !== "top" && t !== "bottom" && e), POPOVER_IOS_BODY_PADDING = 5, iosEnterAnimation$4 = (t, e) => {
  var r;
  const { event: o, size: a, trigger: c, reference: u, side: d, align: p } = e, g = t.ownerDocument, b = g.dir === "rtl", x = g.defaultView.innerWidth, w = g.defaultView.innerHeight, y = getElementRoot(t), I = y.querySelector(".popover-content"), E = y.querySelector(".popover-arrow"), T = c || ((r = o == null ? void 0 : o.detail) === null || r === void 0 ? void 0 : r.ionShadowTarget) || (o == null ? void 0 : o.target), { contentWidth: C, contentHeight: $ } = getPopoverDimensions(a, I, T), { arrowWidth: D, arrowHeight: L } = getArrowDimensions(E), R = {
    top: w / 2 - $ / 2,
    left: x / 2 - C / 2,
    originX: b ? "right" : "left",
    originY: "top"
  }, O = getPopoverPosition(b, C, $, D, L, u, d, p, R, c, o), P = a === "cover" ? 0 : POPOVER_IOS_BODY_PADDING, z = a === "cover" ? 0 : 25, { originX: W, originY: A, top: S, left: F, bottom: U, checkSafeAreaLeft: M, checkSafeAreaRight: V, arrowTop: G, arrowLeft: Q, addPopoverBottomClass: fe } = calculateWindowAdjustment(d, O.top, O.left, P, x, w, C, $, z, O.originX, O.originY, O.referenceCoordinates, O.arrowTop, O.arrowLeft, L), te = createAnimation(), de = createAnimation(), me = createAnimation();
  return de.addElement(y.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), me.addElement(y.querySelector(".popover-arrow")).addElement(y.querySelector(".popover-content")).fromTo("opacity", 0.01, 1), te.easing("ease").duration(100).beforeAddWrite(() => {
    a === "cover" && t.style.setProperty("--width", `${C}px`), fe && t.classList.add("popover-bottom"), U !== void 0 && I.style.setProperty("bottom", `${U}px`);
    const Me = " + var(--ion-safe-area-left, 0)", ce = " - var(--ion-safe-area-right, 0)";
    let oe = `${F}px`;
    if (M && (oe = `${F}px${Me}`), V && (oe = `${F}px${ce}`), I.style.setProperty("top", `calc(${S}px + var(--offset-y, 0))`), I.style.setProperty("left", `calc(${oe} + var(--offset-x, 0))`), I.style.setProperty("transform-origin", `${A} ${W}`), E !== null) {
      const be = O.top !== S || O.left !== F;
      shouldShowArrow(d, be, o, c) ? (E.style.setProperty("top", `calc(${G}px + var(--offset-y, 0))`), E.style.setProperty("left", `calc(${Q}px + var(--offset-x, 0))`)) : E.style.setProperty("display", "none");
    }
  }).addAnimation([de, me]);
}, iosLeaveAnimation$4 = (t) => {
  const e = getElementRoot(t), r = e.querySelector(".popover-content"), o = e.querySelector(".popover-arrow"), a = createAnimation(), c = createAnimation(), u = createAnimation();
  return c.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), u.addElement(e.querySelector(".popover-arrow")).addElement(e.querySelector(".popover-content")).fromTo("opacity", 0.99, 0), a.easing("ease").afterAddWrite(() => {
    t.style.removeProperty("--width"), t.classList.remove("popover-bottom"), r.style.removeProperty("top"), r.style.removeProperty("left"), r.style.removeProperty("bottom"), r.style.removeProperty("transform-origin"), o && (o.style.removeProperty("top"), o.style.removeProperty("left"), o.style.removeProperty("display"));
  }).duration(300).addAnimation([c, u]);
}, POPOVER_MD_BODY_PADDING = 12, mdEnterAnimation$4 = (t, e) => {
  var r;
  const { event: o, size: a, trigger: c, reference: u, side: d, align: p } = e, g = t.ownerDocument, b = g.dir === "rtl", x = g.defaultView.innerWidth, w = g.defaultView.innerHeight, y = getElementRoot(t), I = y.querySelector(".popover-content"), E = c || ((r = o == null ? void 0 : o.detail) === null || r === void 0 ? void 0 : r.ionShadowTarget) || (o == null ? void 0 : o.target), { contentWidth: T, contentHeight: C } = getPopoverDimensions(a, I, E), $ = {
    top: w / 2 - C / 2,
    left: x / 2 - T / 2,
    originX: b ? "right" : "left",
    originY: "top"
  }, D = getPopoverPosition(b, T, C, 0, 0, u, d, p, $, c, o), L = a === "cover" ? 0 : POPOVER_MD_BODY_PADDING, { originX: R, originY: O, top: P, left: z, bottom: W } = calculateWindowAdjustment(d, D.top, D.left, L, x, w, T, C, 0, D.originX, D.originY, D.referenceCoordinates), A = createAnimation(), S = createAnimation(), F = createAnimation(), U = createAnimation(), M = createAnimation();
  return S.addElement(y.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), F.addElement(y.querySelector(".popover-wrapper")).duration(150).fromTo("opacity", 0.01, 1), U.addElement(I).beforeStyles({
    top: `calc(${P}px + var(--offset-y, 0px))`,
    left: `calc(${z}px + var(--offset-x, 0px))`,
    "transform-origin": `${O} ${R}`
  }).beforeAddWrite(() => {
    W !== void 0 && I.style.setProperty("bottom", `${W}px`);
  }).fromTo("transform", "scale(0.8)", "scale(1)"), M.addElement(y.querySelector(".popover-viewport")).fromTo("opacity", 0.01, 1), A.easing("cubic-bezier(0.36,0.66,0.04,1)").duration(300).beforeAddWrite(() => {
    a === "cover" && t.style.setProperty("--width", `${T}px`), O === "bottom" && t.classList.add("popover-bottom");
  }).addAnimation([S, F, U, M]);
}, mdLeaveAnimation$4 = (t) => {
  const e = getElementRoot(t), r = e.querySelector(".popover-content"), o = createAnimation(), a = createAnimation(), c = createAnimation();
  return a.addElement(e.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), c.addElement(e.querySelector(".popover-wrapper")).fromTo("opacity", 0.99, 0), o.easing("ease").afterAddWrite(() => {
    t.style.removeProperty("--width"), t.classList.remove("popover-bottom"), r.style.removeProperty("top"), r.style.removeProperty("left"), r.style.removeProperty("bottom"), r.style.removeProperty("transform-origin");
  }).duration(150).addAnimation([a, c]);
}, popoverIosCss = ':host{--background:var(--ion-background-color, #fff);--min-width:0;--min-height:0;--max-width:auto;--height:auto;--offset-x:0px;--offset-y:0px;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:fixed;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);z-index:1001}:host(.popover-nested){pointer-events:none}:host(.popover-nested) .popover-wrapper{pointer-events:auto}:host(.overlay-hidden){display:none}.popover-wrapper{z-index:10}.popover-content{display:-ms-flexbox;display:flex;position:absolute;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:auto;z-index:10}.popover-viewport{--ion-safe-area-top:0px;--ion-safe-area-right:0px;--ion-safe-area-bottom:0px;--ion-safe-area-left:0px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}:host(.popover-nested.popover-side-left){--offset-x:5px}:host(.popover-nested.popover-side-right){--offset-x:-5px}:host(.popover-nested.popover-side-start){--offset-x:5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-start),:host-context([dir=rtl]).popover-nested.popover-side-start{--offset-x:-5px}@supports selector(:dir(rtl)){:host(.popover-nested.popover-side-start:dir(rtl)){--offset-x:-5px}}:host(.popover-nested.popover-side-end){--offset-x:-5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-end),:host-context([dir=rtl]).popover-nested.popover-side-end{--offset-x:5px}@supports selector(:dir(rtl)){:host(.popover-nested.popover-side-end:dir(rtl)){--offset-x:5px}}:host{--width:200px;--max-height:90%;--box-shadow:none;--backdrop-opacity:var(--ion-backdrop-opacity, 0.08)}:host(.popover-desktop){--box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.12)}.popover-content{border-radius:10px}:host(.popover-desktop) .popover-content{border:0.5px solid var(--ion-color-step-100, #e6e6e6)}.popover-arrow{display:block;position:absolute;width:20px;height:10px;overflow:hidden}.popover-arrow::after{top:3px;border-radius:3px;position:absolute;width:14px;height:14px;-webkit-transform:rotate(45deg);transform:rotate(45deg);background:var(--background);content:"";z-index:10}@supports (inset-inline-start: 0){.popover-arrow::after{inset-inline-start:3px}}@supports not (inset-inline-start: 0){.popover-arrow::after{left:3px}:host-context([dir=rtl]) .popover-arrow::after{left:unset;right:unset;right:3px}[dir=rtl] .popover-arrow::after{left:unset;right:unset;right:3px}@supports selector(:dir(rtl)){.popover-arrow::after:dir(rtl){left:unset;right:unset;right:3px}}}:host(.popover-bottom) .popover-arrow{top:auto;bottom:-10px}:host(.popover-bottom) .popover-arrow::after{top:-6px}:host(.popover-side-left) .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}:host(.popover-side-right) .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}:host(.popover-side-top) .popover-arrow{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host(.popover-side-start) .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}:host-context([dir=rtl]):host(.popover-side-start) .popover-arrow,:host-context([dir=rtl]).popover-side-start .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}@supports selector(:dir(rtl)){:host(.popover-side-start:dir(rtl)) .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}}:host(.popover-side-end) .popover-arrow{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}:host-context([dir=rtl]):host(.popover-side-end) .popover-arrow,:host-context([dir=rtl]).popover-side-end .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}@supports selector(:dir(rtl)){:host(.popover-side-end:dir(rtl)) .popover-arrow{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}.popover-arrow,.popover-content{opacity:0}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.popover-translucent) .popover-content,:host(.popover-translucent) .popover-arrow::after{background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}}', popoverMdCss = ":host{--background:var(--ion-background-color, #fff);--min-width:0;--min-height:0;--max-width:auto;--height:auto;--offset-x:0px;--offset-y:0px;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:fixed;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);z-index:1001}:host(.popover-nested){pointer-events:none}:host(.popover-nested) .popover-wrapper{pointer-events:auto}:host(.overlay-hidden){display:none}.popover-wrapper{z-index:10}.popover-content{display:-ms-flexbox;display:flex;position:absolute;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:auto;z-index:10}.popover-viewport{--ion-safe-area-top:0px;--ion-safe-area-right:0px;--ion-safe-area-bottom:0px;--ion-safe-area-left:0px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;overflow:hidden}:host(.popover-nested.popover-side-left){--offset-x:5px}:host(.popover-nested.popover-side-right){--offset-x:-5px}:host(.popover-nested.popover-side-start){--offset-x:5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-start),:host-context([dir=rtl]).popover-nested.popover-side-start{--offset-x:-5px}@supports selector(:dir(rtl)){:host(.popover-nested.popover-side-start:dir(rtl)){--offset-x:-5px}}:host(.popover-nested.popover-side-end){--offset-x:-5px}:host-context([dir=rtl]):host(.popover-nested.popover-side-end),:host-context([dir=rtl]).popover-nested.popover-side-end{--offset-x:5px}@supports selector(:dir(rtl)){:host(.popover-nested.popover-side-end:dir(rtl)){--offset-x:5px}}:host{--width:250px;--max-height:90%;--box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);--backdrop-opacity:var(--ion-backdrop-opacity, 0.32)}.popover-content{border-radius:4px;-webkit-transform-origin:left top;transform-origin:left top}:host-context([dir=rtl]) .popover-content{-webkit-transform-origin:right top;transform-origin:right top}[dir=rtl] .popover-content{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){.popover-content:dir(rtl){-webkit-transform-origin:right top;transform-origin:right top}}.popover-viewport{-webkit-transition-delay:100ms;transition-delay:100ms}.popover-wrapper{opacity:0}", Popover = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.didPresent = createEvent(this, "ionPopoverDidPresent", 7), this.willPresent = createEvent(this, "ionPopoverWillPresent", 7), this.willDismiss = createEvent(this, "ionPopoverWillDismiss", 7), this.didDismiss = createEvent(this, "ionPopoverDidDismiss", 7), this.didPresentShorthand = createEvent(this, "didPresent", 7), this.willPresentShorthand = createEvent(this, "willPresent", 7), this.willDismissShorthand = createEvent(this, "willDismiss", 7), this.didDismissShorthand = createEvent(this, "didDismiss", 7), this.ionMount = createEvent(this, "ionMount", 7), this.parentPopover = null, this.coreDelegate = CoreDelegate(), this.lockController = createLockController(), this.inline = !1, this.focusDescendantOnPresent = !1, this.onBackdropTap = () => {
      this.dismiss(void 0, BACKDROP);
    }, this.onLifecycle = (e) => {
      const r = this.usersElement, o = LIFECYCLE_MAP$1[e.type];
      if (r && o) {
        const a = new CustomEvent(o, {
          bubbles: !1,
          cancelable: !1,
          detail: e.detail
        });
        r.dispatchEvent(a);
      }
    }, this.configureTriggerInteraction = () => {
      const { trigger: e, triggerAction: r, el: o, destroyTriggerInteraction: a } = this;
      if (a && a(), e === void 0)
        return;
      const c = this.triggerEl = e !== void 0 ? document.getElementById(e) : null;
      if (!c) {
        printIonWarning(`A trigger element with the ID "${e}" was not found in the DOM. The trigger element must be in the DOM when the "trigger" property is set on ion-popover.`, this.el);
        return;
      }
      this.destroyTriggerInteraction = configureTriggerInteraction(c, r, o);
    }, this.configureKeyboardInteraction = () => {
      const { destroyKeyboardInteraction: e, el: r } = this;
      e && e(), this.destroyKeyboardInteraction = configureKeyboardInteraction(r);
    }, this.configureDismissInteraction = () => {
      const { destroyDismissInteraction: e, parentPopover: r, triggerAction: o, triggerEl: a, el: c } = this;
      !r || !a || (e && e(), this.destroyDismissInteraction = configureDismissInteraction(a, o, c, r));
    }, this.presented = !1, this.hasController = !1, this.delegate = void 0, this.overlayIndex = void 0, this.enterAnimation = void 0, this.leaveAnimation = void 0, this.component = void 0, this.componentProps = void 0, this.keyboardClose = !0, this.cssClass = void 0, this.backdropDismiss = !0, this.event = void 0, this.showBackdrop = !0, this.translucent = !1, this.animated = !0, this.htmlAttributes = void 0, this.triggerAction = "click", this.trigger = void 0, this.size = "auto", this.dismissOnSelect = !1, this.reference = "trigger", this.side = "bottom", this.alignment = void 0, this.arrow = !0, this.isOpen = !1, this.keyboardEvents = !1, this.keepContentsMounted = !1;
  }
  onTriggerChange() {
    this.configureTriggerInteraction();
  }
  onIsOpenChange(e, r) {
    e === !0 && r === !1 ? this.present() : e === !1 && r === !0 && this.dismiss();
  }
  connectedCallback() {
    const { configureTriggerInteraction: e, el: r } = this;
    prepareOverlay(r), e();
  }
  disconnectedCallback() {
    const { destroyTriggerInteraction: e } = this;
    e && e();
  }
  componentWillLoad() {
    const { el: e } = this, r = setOverlayId(e);
    this.parentPopover = e.closest(`ion-popover:not(#${r})`), this.alignment === void 0 && (this.alignment = getIonMode$2(this) === "ios" ? "center" : "start");
  }
  componentDidLoad() {
    const { parentPopover: e, isOpen: r } = this;
    r === !0 && raf(() => this.present()), e && addEventListener$1(e, "ionPopoverWillDismiss", () => {
      this.dismiss(void 0, void 0, !1);
    }), this.configureTriggerInteraction();
  }
  /**
   * When opening a popover from a trigger, we should not be
   * modifying the `event` prop from inside the component.
   * Additionally, when pressing the "Right" arrow key, we need
   * to shift focus to the first descendant in the newly presented
   * popover.
   *
   * @internal
   */
  async presentFromTrigger(e, r = !1) {
    this.focusDescendantOnPresent = r, await this.present(e), this.focusDescendantOnPresent = !1;
  }
  /**
   * Determines whether or not an overlay
   * is being used inline or via a controller/JS
   * and returns the correct delegate.
   * By default, subsequent calls to getDelegate
   * will use a cached version of the delegate.
   * This is useful for calling dismiss after
   * present so that the correct delegate is given.
   */
  getDelegate(e = !1) {
    if (this.workingDelegate && !e)
      return {
        delegate: this.workingDelegate,
        inline: this.inline
      };
    const r = this.el.parentNode, o = this.inline = r !== null && !this.hasController, a = this.workingDelegate = o ? this.delegate || this.coreDelegate : this.delegate;
    return { inline: o, delegate: a };
  }
  /**
   * Present the popover overlay after it has been created.
   * Developers can pass a mouse, touch, or pointer event
   * to position the popover relative to where that event
   * was dispatched.
   */
  async present(e) {
    const r = await this.lockController.lock();
    if (this.presented) {
      r();
      return;
    }
    const { el: o } = this, { inline: a, delegate: c } = this.getDelegate(!0);
    this.ionMount.emit(), this.usersElement = await attachComponent(c, o, this.component, ["popover-viewport"], this.componentProps, a), this.keyboardEvents || this.configureKeyboardInteraction(), this.configureDismissInteraction(), hasLazyBuild(o) ? await deepReady(this.usersElement) : this.keepContentsMounted || await waitForMount(), await present(this, "popoverEnter", iosEnterAnimation$4, mdEnterAnimation$4, {
      event: e || this.event,
      size: this.size,
      trigger: this.triggerEl,
      reference: this.reference,
      side: this.side,
      align: this.alignment
    }), this.focusDescendantOnPresent && focusFirstDescendant(this.el, this.el), r();
  }
  /**
   * Dismiss the popover overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the popover. For example, 'cancel' or 'backdrop'.
   * @param dismissParentPopover If `true`, dismissing this popover will also dismiss
   * a parent popover if this popover is nested. Defaults to `true`.
   */
  async dismiss(e, r, o = !0) {
    const a = await this.lockController.lock(), { destroyKeyboardInteraction: c, destroyDismissInteraction: u } = this;
    o && this.parentPopover && this.parentPopover.dismiss(e, r, o);
    const d = await dismiss(this, e, r, "popoverLeave", iosLeaveAnimation$4, mdLeaveAnimation$4, this.event);
    if (d) {
      c && (c(), this.destroyKeyboardInteraction = void 0), u && (u(), this.destroyDismissInteraction = void 0);
      const { delegate: p } = this.getDelegate();
      await detachComponent(p, this.usersElement);
    }
    return a(), d;
  }
  /**
   * @internal
   */
  async getParentPopover() {
    return this.parentPopover;
  }
  /**
   * Returns a promise that resolves when the popover did dismiss.
   */
  onDidDismiss() {
    return eventMethod(this.el, "ionPopoverDidDismiss");
  }
  /**
   * Returns a promise that resolves when the popover will dismiss.
   */
  onWillDismiss() {
    return eventMethod(this.el, "ionPopoverWillDismiss");
  }
  render() {
    const e = getIonMode$2(this), { onLifecycle: r, parentPopover: o, dismissOnSelect: a, side: c, arrow: u, htmlAttributes: d } = this, p = isPlatform("desktop"), g = u && !o;
    return h(Host, Object.assign({ "aria-modal": "true", "no-router": !0, tabindex: "-1" }, d, { style: {
      zIndex: `${2e4 + this.overlayIndex}`
    }, class: Object.assign(Object.assign({}, getClassMap(this.cssClass)), { [e]: !0, "popover-translucent": this.translucent, "overlay-hidden": !0, "popover-desktop": p, [`popover-side-${c}`]: !0, "popover-nested": !!o }), onIonPopoverDidPresent: r, onIonPopoverWillPresent: r, onIonPopoverWillDismiss: r, onIonPopoverDidDismiss: r, onIonBackdropTap: this.onBackdropTap }), !o && h("ion-backdrop", { tappable: this.backdropDismiss, visible: this.showBackdrop, part: "backdrop" }), h("div", { class: "popover-wrapper ion-overlay-wrapper", onClick: a ? () => this.dismiss() : void 0 }, g && h("div", { class: "popover-arrow", part: "arrow" }), h("div", { class: "popover-content", part: "content" }, h("slot", null))));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      trigger: ["onTriggerChange"],
      triggerAction: ["onTriggerChange"],
      isOpen: ["onIsOpenChange"]
    };
  }
  static get style() {
    return {
      ios: popoverIosCss,
      md: popoverMdCss
    };
  }
}, [33, "ion-popover", {
  hasController: [4, "has-controller"],
  delegate: [16],
  overlayIndex: [2, "overlay-index"],
  enterAnimation: [16],
  leaveAnimation: [16],
  component: [1],
  componentProps: [16],
  keyboardClose: [4, "keyboard-close"],
  cssClass: [1, "css-class"],
  backdropDismiss: [4, "backdrop-dismiss"],
  event: [8],
  showBackdrop: [4, "show-backdrop"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  triggerAction: [1, "trigger-action"],
  trigger: [1],
  size: [1],
  dismissOnSelect: [4, "dismiss-on-select"],
  reference: [1],
  side: [1],
  alignment: [1025],
  arrow: [4],
  isOpen: [4, "is-open"],
  keyboardEvents: [4, "keyboard-events"],
  keepContentsMounted: [4, "keep-contents-mounted"],
  presented: [32],
  presentFromTrigger: [64],
  present: [64],
  dismiss: [64],
  getParentPopover: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}, void 0, {
  trigger: ["onTriggerChange"],
  triggerAction: ["onTriggerChange"],
  isOpen: ["onIsOpenChange"]
}]), LIFECYCLE_MAP$1 = {
  ionPopoverDidPresent: "ionViewDidEnter",
  ionPopoverWillPresent: "ionViewWillEnter",
  ionPopoverWillDismiss: "ionViewWillLeave",
  ionPopoverDidDismiss: "ionViewDidLeave"
};
function defineCustomElement$A() {
  if (typeof customElements > "u")
    return;
  ["ion-popover", "ion-backdrop"].forEach((e) => {
    switch (e) {
      case "ion-popover":
        customElements.get(e) || customElements.define(e, Popover);
        break;
      case "ion-backdrop":
        customElements.get(e) || defineCustomElement$R();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const fabCss = ":host{position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;z-index:999}:host(.fab-horizontal-center){left:0px;right:0px;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto}:host(.fab-horizontal-start){left:calc(10px + var(--ion-safe-area-left, 0px));}:host-context([dir=rtl]):host(.fab-horizontal-start),:host-context([dir=rtl]).fab-horizontal-start{right:calc(10px + var(--ion-safe-area-right, 0px));left:unset}@supports selector(:dir(rtl)){:host(.fab-horizontal-start:dir(rtl)){right:calc(10px + var(--ion-safe-area-right, 0px));left:unset}}:host(.fab-horizontal-end){right:calc(10px + var(--ion-safe-area-right, 0px));}:host-context([dir=rtl]):host(.fab-horizontal-end),:host-context([dir=rtl]).fab-horizontal-end{left:calc(10px + var(--ion-safe-area-left, 0px));right:unset}@supports selector(:dir(rtl)){:host(.fab-horizontal-end:dir(rtl)){left:calc(10px + var(--ion-safe-area-left, 0px));right:unset}}:host(.fab-vertical-top){top:10px}:host(.fab-vertical-top.fab-edge){top:0}:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-button){margin-top:-50%}:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-button.fab-button-small){margin-top:calc((-100% + 16px) / 2)}:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-list.fab-list-side-start),:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-list.fab-list-side-end){margin-top:-50%}:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-list.fab-list-side-top),:host(.fab-vertical-top.fab-edge) ::slotted(ion-fab-list.fab-list-side-bottom){margin-top:calc(50% + 10px)}:host(.fab-vertical-bottom){bottom:10px}:host(.fab-vertical-bottom.fab-edge){bottom:0}:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-button){margin-bottom:-50%}:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-button.fab-button-small){margin-bottom:calc((-100% + 16px) / 2)}:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-list.fab-list-side-start),:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-list.fab-list-side-end){margin-bottom:-50%}:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-list.fab-list-side-top),:host(.fab-vertical-bottom.fab-edge) ::slotted(ion-fab-list.fab-list-side-bottom){margin-bottom:calc(50% + 10px)}:host(.fab-vertical-center){top:0px;bottom:0px;margin-top:auto;margin-bottom:auto}", Fab = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.horizontal = void 0, this.vertical = void 0, this.edge = !1, this.activated = !1;
  }
  activatedChanged() {
    const e = this.activated, r = this.getFab();
    r && (r.activated = e), Array.from(this.el.querySelectorAll("ion-fab-list")).forEach((o) => {
      o.activated = e;
    });
  }
  componentDidLoad() {
    this.activated && this.activatedChanged();
  }
  /**
   * Close an active FAB list container.
   */
  async close() {
    this.activated = !1;
  }
  getFab() {
    return this.el.querySelector("ion-fab-button");
  }
  /**
   * Opens/Closes the FAB list container.
   * @internal
   */
  async toggle() {
    !!this.el.querySelector("ion-fab-list") && (this.activated = !this.activated);
  }
  render() {
    const { horizontal: e, vertical: r, edge: o } = this, a = getIonMode$2(this);
    return h(Host, { class: {
      [a]: !0,
      [`fab-horizontal-${e}`]: e !== void 0,
      [`fab-vertical-${r}`]: r !== void 0,
      "fab-edge": o
    } }, h("slot", null));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      activated: ["activatedChanged"]
    };
  }
  static get style() {
    return fabCss;
  }
}, [1, "ion-fab", {
  horizontal: [1],
  vertical: [1],
  edge: [4],
  activated: [1028],
  close: [64],
  toggle: [64]
}, void 0, {
  activated: ["activatedChanged"]
}]);
function defineCustomElement$1$i() {
  if (typeof customElements > "u")
    return;
  ["ion-fab"].forEach((e) => {
    switch (e) {
      case "ion-fab":
        customElements.get(e) || customElements.define(e, Fab);
        break;
    }
  });
}
const defineCustomElement$z = defineCustomElement$1$i;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const fabButtonIosCss = ':host{--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--background-hover:var(--ion-color-primary-contrast, #fff);--background-hover-opacity:.08;--transition:background-color, opacity 100ms linear;--ripple-color:currentColor;--border-radius:50%;--border-width:0;--border-style:none;--border-color:initial;--padding-top:0;--padding-end:0;--padding-bottom:0;--padding-start:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:56px;height:56px;font-size:14px;text-align:center;text-overflow:ellipsis;text-transform:none;white-space:nowrap;-webkit-font-kerning:none;font-kerning:none}.button-native{border-radius:var(--border-radius);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;-webkit-transform:var(--transform);transform:var(--transform);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);background-clip:padding-box;color:var(--color);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:strict;cursor:pointer;overflow:hidden;z-index:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-icon){line-height:1}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{left:0;right:0;top:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-transition:all ease-in-out 300ms;transition:all ease-in-out 300ms;-webkit-transition-property:opacity, -webkit-transform;transition-property:opacity, -webkit-transform;transition-property:transform, opacity;transition-property:transform, opacity, -webkit-transform;z-index:1}:host(.fab-button-disabled){cursor:default;opacity:0.5;pointer-events:none}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-activated) .button-native{color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}::slotted(ion-icon){line-height:1}:host(.fab-button-small){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:8px;margin-bottom:8px;width:40px;height:40px}.close-icon{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:0;margin-bottom:0;left:0;right:0;top:0;position:absolute;height:100%;-webkit-transform:scale(0.4) rotateZ(-45deg);transform:scale(0.4) rotateZ(-45deg);-webkit-transition:all ease-in-out 300ms;transition:all ease-in-out 300ms;-webkit-transition-property:opacity, -webkit-transform;transition-property:opacity, -webkit-transform;transition-property:transform, opacity;transition-property:transform, opacity, -webkit-transform;font-size:var(--close-icon-font-size);opacity:0;z-index:1}:host(.fab-button-close-active) .close-icon{-webkit-transform:scale(1) rotateZ(0deg);transform:scale(1) rotateZ(0deg);opacity:1}:host(.fab-button-close-active) .button-inner{-webkit-transform:scale(0.4) rotateZ(45deg);transform:scale(0.4) rotateZ(45deg);opacity:0}ion-ripple-effect{color:var(--ripple-color)}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.fab-button-translucent) .button-native{-webkit-backdrop-filter:var(--backdrop-filter);backdrop-filter:var(--backdrop-filter)}}:host(.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{--background:var(--ion-color-primary, #3880ff);--background-activated:var(--ion-color-primary-shade, #3171e0);--background-focused:var(--ion-color-primary-shade, #3171e0);--background-hover:var(--ion-color-primary-tint, #4c8dff);--background-activated-opacity:1;--background-focused-opacity:1;--background-hover-opacity:1;--color:var(--ion-color-primary-contrast, #fff);--box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);--transition:0.2s transform cubic-bezier(0.25, 1.11, 0.78, 1.59);--close-icon-font-size:28px}:host(.ion-activated){--box-shadow:0 4px 16px rgba(0, 0, 0, 0.12);--transform:scale(1.1);--transition:0.2s transform ease-out}::slotted(ion-icon){font-size:28px}:host(.fab-button-in-list){--background:var(--ion-color-light, #f4f5f8);--background-activated:var(--ion-color-light-shade, #d7d8da);--background-focused:var(--background-activated);--background-hover:var(--ion-color-light-tint, #f5f6f9);--color:var(--ion-color-light-contrast, #000);--color-activated:var(--ion-color-light-contrast, #000);--color-focused:var(--color-activated);--transition:transform 200ms ease 10ms, opacity 200ms ease 10ms}:host(.fab-button-in-list) ::slotted(ion-icon){font-size:18px}:host(.ion-color.ion-focused) .button-native::after{background:var(--ion-color-shade)}:host(.ion-color.ion-focused) .button-native,:host(.ion-color.ion-activated) .button-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .button-native::after,:host(.ion-color.ion-activated) .button-native::after{background:var(--ion-color-shade)}@media (any-hover: hover){:host(.ion-color:hover) .button-native{color:var(--ion-color-contrast)}:host(.ion-color:hover) .button-native::after{background:var(--ion-color-tint)}}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.fab-button-translucent){--background:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.9);--background-hover:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.8);--background-focused:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.82);--backdrop-filter:saturate(180%) blur(20px)}:host(.fab-button-translucent-in-list){--background:rgba(var(--ion-color-light-rgb, 244, 245, 248), 0.9);--background-hover:rgba(var(--ion-color-light-rgb, 244, 245, 248), 0.8);--background-focused:rgba(var(--ion-color-light-rgb, 244, 245, 248), 0.82)}}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){@media (any-hover: hover){:host(.fab-button-translucent.ion-color:hover) .button-native{background:rgba(var(--ion-color-base-rgb), 0.8)}}:host(.ion-color.fab-button-translucent) .button-native{background:rgba(var(--ion-color-base-rgb), 0.9)}:host(.ion-color.ion-focused.fab-button-translucent) .button-native,:host(.ion-color.ion-activated.fab-button-translucent) .button-native{background:var(--ion-color-base)}}', fabButtonMdCss = ':host{--color-activated:var(--color);--color-focused:var(--color);--color-hover:var(--color);--background-hover:var(--ion-color-primary-contrast, #fff);--background-hover-opacity:.08;--transition:background-color, opacity 100ms linear;--ripple-color:currentColor;--border-radius:50%;--border-width:0;--border-style:none;--border-color:initial;--padding-top:0;--padding-end:0;--padding-bottom:0;--padding-start:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;width:56px;height:56px;font-size:14px;text-align:center;text-overflow:ellipsis;text-transform:none;white-space:nowrap;-webkit-font-kerning:none;font-kerning:none}.button-native{border-radius:var(--border-radius);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;-webkit-transform:var(--transform);transform:var(--transform);-webkit-transition:var(--transition);transition:var(--transition);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);outline:none;background:var(--background);background-clip:padding-box;color:var(--color);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);contain:strict;cursor:pointer;overflow:hidden;z-index:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-icon){line-height:1}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{left:0;right:0;top:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;-webkit-transition:all ease-in-out 300ms;transition:all ease-in-out 300ms;-webkit-transition-property:opacity, -webkit-transform;transition-property:opacity, -webkit-transform;transition-property:transform, opacity;transition-property:transform, opacity, -webkit-transform;z-index:1}:host(.fab-button-disabled){cursor:default;opacity:0.5;pointer-events:none}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(.ion-activated) .button-native{color:var(--color-activated)}:host(.ion-activated) .button-native::after{background:var(--background-activated);opacity:var(--background-activated-opacity)}::slotted(ion-icon){line-height:1}:host(.fab-button-small){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:8px;margin-bottom:8px;width:40px;height:40px}.close-icon{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:0;margin-bottom:0;left:0;right:0;top:0;position:absolute;height:100%;-webkit-transform:scale(0.4) rotateZ(-45deg);transform:scale(0.4) rotateZ(-45deg);-webkit-transition:all ease-in-out 300ms;transition:all ease-in-out 300ms;-webkit-transition-property:opacity, -webkit-transform;transition-property:opacity, -webkit-transform;transition-property:transform, opacity;transition-property:transform, opacity, -webkit-transform;font-size:var(--close-icon-font-size);opacity:0;z-index:1}:host(.fab-button-close-active) .close-icon{-webkit-transform:scale(1) rotateZ(0deg);transform:scale(1) rotateZ(0deg);opacity:1}:host(.fab-button-close-active) .button-inner{-webkit-transform:scale(0.4) rotateZ(45deg);transform:scale(0.4) rotateZ(45deg);opacity:0}ion-ripple-effect{color:var(--ripple-color)}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.fab-button-translucent) .button-native{-webkit-backdrop-filter:var(--backdrop-filter);backdrop-filter:var(--backdrop-filter)}}:host(.ion-color) .button-native{background:var(--ion-color-base);color:var(--ion-color-contrast)}:host{--background:var(--ion-color-primary, #3880ff);--background-activated:transparent;--background-focused:currentColor;--background-hover:currentColor;--background-activated-opacity:0;--background-focused-opacity:.24;--background-hover-opacity:.08;--color:var(--ion-color-primary-contrast, #fff);--box-shadow:0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);--transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1), background-color 280ms cubic-bezier(0.4, 0, 0.2, 1), color 280ms cubic-bezier(0.4, 0, 0.2, 1), opacity 15ms linear 30ms, transform 270ms cubic-bezier(0, 0, 0.2, 1) 0ms;--close-icon-font-size:24px}:host(.ion-activated){--box-shadow:0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12)}::slotted(ion-icon){font-size:24px}:host(.fab-button-in-list){--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54);--color-activated:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54);--color-focused:var(--color-activated);--background:var(--ion-color-light, #f4f5f8);--background-activated:transparent;--background-focused:var(--ion-color-light-shade, #d7d8da);--background-hover:var(--ion-color-light-tint, #f5f6f9)}:host(.fab-button-in-list) ::slotted(ion-icon){font-size:18px}:host(.ion-color.ion-focused) .button-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-focused) .button-native::after{background:var(--ion-color-contrast)}:host(.ion-color.ion-activated) .button-native{color:var(--ion-color-contrast)}:host(.ion-color.ion-activated) .button-native::after{background:transparent}@media (any-hover: hover){:host(.ion-color:hover) .button-native{color:var(--ion-color-contrast)}:host(.ion-color:hover) .button-native::after{background:var(--ion-color-contrast)}}', FabButton = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.fab = null, this.inheritedAttributes = {}, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    }, this.onClick = () => {
      const { fab: e } = this;
      e && e.toggle();
    }, this.color = void 0, this.activated = !1, this.disabled = !1, this.download = void 0, this.href = void 0, this.rel = void 0, this.routerDirection = "forward", this.routerAnimation = void 0, this.target = void 0, this.show = !1, this.translucent = !1, this.type = "button", this.size = void 0, this.closeIcon = close$1;
  }
  connectedCallback() {
    this.fab = this.el.closest("ion-fab");
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAriaAttributes(this.el);
  }
  render() {
    const { el: e, disabled: r, color: o, href: a, activated: c, show: u, translucent: d, size: p, inheritedAttributes: g } = this, b = hostContext("ion-fab-list", e), x = getIonMode$2(this), w = a === void 0 ? "button" : "a", y = w === "button" ? { type: this.type } : {
      download: this.download,
      href: a,
      rel: this.rel,
      target: this.target
    };
    return h(Host, { onClick: this.onClick, "aria-disabled": r ? "true" : null, class: createColorClasses$1(o, {
      [x]: !0,
      "fab-button-in-list": b,
      "fab-button-translucent-in-list": b && d,
      "fab-button-close-active": c,
      "fab-button-show": u,
      "fab-button-disabled": r,
      "fab-button-translucent": d,
      "ion-activatable": !0,
      "ion-focusable": !0,
      [`fab-button-${p}`]: p !== void 0
    }) }, h(w, Object.assign({}, y, { class: "button-native", part: "native", disabled: r, onFocus: this.onFocus, onBlur: this.onBlur, onClick: (I) => openURL(a, I, this.routerDirection, this.routerAnimation) }, g), h("ion-icon", { "aria-hidden": "true", icon: this.closeIcon, part: "close-icon", class: "close-icon", lazy: !1 }), h("span", { class: "button-inner" }, h("slot", null)), x === "md" && h("ion-ripple-effect", null)));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: fabButtonIosCss,
      md: fabButtonMdCss
    };
  }
}, [33, "ion-fab-button", {
  color: [513],
  activated: [4],
  disabled: [4],
  download: [1],
  href: [1],
  rel: [1],
  routerDirection: [1, "router-direction"],
  routerAnimation: [16],
  target: [1],
  show: [4],
  translucent: [4],
  type: [1],
  size: [1],
  closeIcon: [1, "close-icon"]
}]);
function defineCustomElement$1$h() {
  if (typeof customElements > "u")
    return;
  ["ion-fab-button", "ion-icon", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-fab-button":
        customElements.get(e) || customElements.define(e, FabButton);
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$y = defineCustomElement$1$h;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const ION_CONTENT_TAG_NAME = "ION-CONTENT", ION_CONTENT_ELEMENT_SELECTOR = "ion-content", ION_CONTENT_CLASS_SELECTOR = ".ion-content-scroll-host", ION_CONTENT_SELECTOR = `${ION_CONTENT_ELEMENT_SELECTOR}, ${ION_CONTENT_CLASS_SELECTOR}`, isIonContent = (t) => t.tagName === ION_CONTENT_TAG_NAME, getScrollElement = async (t) => isIonContent(t) ? (await new Promise((e) => componentOnReady(t, e)), t.getScrollElement()) : t, findIonContent = (t) => {
  const e = t.querySelector(ION_CONTENT_CLASS_SELECTOR);
  return e || t.querySelector(ION_CONTENT_SELECTOR);
}, findClosestIonContent = (t) => t.closest(ION_CONTENT_SELECTOR), scrollToTop = (t, e) => isIonContent(t) ? t.scrollToTop(e) : Promise.resolve(t.scrollTo({
  top: 0,
  left: 0,
  behavior: e > 0 ? "smooth" : "auto"
})), scrollByPoint = (t, e, r, o) => isIonContent(t) ? t.scrollByPoint(e, r, o) : Promise.resolve(t.scrollBy({
  top: r,
  left: e,
  behavior: o > 0 ? "smooth" : "auto"
})), printIonContentErrorMsg = (t) => printRequiredElementError(t, ION_CONTENT_ELEMENT_SELECTOR), disableContentScrollY = (t) => {
  if (isIonContent(t)) {
    const e = t, r = e.scrollY;
    return e.scrollY = !1, r;
  } else
    return t.style.setProperty("overflow", "hidden"), !0;
}, resetContentScrollY = (t, e) => {
  isIonContent(t) ? t.scrollY = e : t.style.removeProperty("overflow");
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var ExceptionCode;
(function(t) {
  t.Unimplemented = "UNIMPLEMENTED", t.Unavailable = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
var KeyboardResize;
(function(t) {
  t.Body = "body", t.Ionic = "ionic", t.Native = "native", t.None = "none";
})(KeyboardResize || (KeyboardResize = {}));
const Keyboard = {
  getEngine() {
    const t = getCapacitor();
    if (t != null && t.isPluginAvailable("Keyboard"))
      return t.Plugins.Keyboard;
  },
  getResizeMode() {
    const t = this.getEngine();
    return t != null && t.getResizeMode ? t.getResizeMode().catch((e) => {
      if (e.code !== ExceptionCode.Unimplemented)
        throw e;
    }) : Promise.resolve(void 0);
  }
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const getResizeContainer = (t) => {
  if (doc === void 0 || t === KeyboardResize.None || t === void 0)
    return null;
  const e = doc.querySelector("ion-app");
  return e ?? doc.body;
}, getResizeContainerHeight = (t) => {
  const e = getResizeContainer(t);
  return e === null ? 0 : e.clientHeight;
}, createKeyboardController = async (t) => {
  let e, r, o, a;
  const c = async () => {
    const b = await Keyboard.getResizeMode(), x = b === void 0 ? void 0 : b.mode;
    e = () => {
      a === void 0 && (a = getResizeContainerHeight(x)), o = !0, u(o, x);
    }, r = () => {
      o = !1, u(o, x);
    }, win == null || win.addEventListener("keyboardWillShow", e), win == null || win.addEventListener("keyboardWillHide", r);
  }, u = (b, x) => {
    t && t(b, d(x));
  }, d = (b) => {
    if (
      /**
       * If we are in an SSR environment then there is
       * no window to resize. Additionally, if there
       * is no resize mode or the resize mode is "None"
       * then initialResizeContainerHeight will be 0
       */
      a === 0 || /**
       * If the keyboard is closed before the webview resizes initially
       * then the webview will never resize.
       */
      a === getResizeContainerHeight(b)
    )
      return;
    const x = getResizeContainer(b);
    if (x !== null)
      return new Promise((w) => {
        const y = () => {
          x.clientHeight === a && (I.disconnect(), w());
        }, I = new ResizeObserver(y);
        I.observe(x);
      });
  }, p = () => {
    win == null || win.removeEventListener("keyboardWillShow", e), win == null || win.removeEventListener("keyboardWillHide", r), e = r = void 0;
  }, g = () => o;
  return await c(), { init: c, destroy: p, isKeyboardVisible: g };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const handleFooterFade = (t, e) => {
  readTask(() => {
    const r = t.scrollTop, o = t.scrollHeight - t.clientHeight, a = 10, c = o - a, u = r - c, d = clamp(0, 1 - u / a, 1);
    writeTask(() => {
      e.style.setProperty("--opacity-scale", d.toString());
    });
  });
}, footerIosCss = "ion-footer{display:block;position:relative;-ms-flex-order:1;order:1;width:100%;z-index:10}ion-footer.footer-toolbar-padding ion-toolbar:last-of-type{padding-bottom:var(--ion-safe-area-bottom, 0)}.footer-ios ion-toolbar:first-of-type{--border-width:0.55px 0 0}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.footer-background{left:0;right:0;top:0;bottom:0;position:absolute;-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}.footer-translucent-ios ion-toolbar{--opacity:.8}}.footer-ios.ion-no-border ion-toolbar:first-of-type{--border-width:0}.footer-collapse-fade ion-toolbar{--opacity-scale:inherit}", footerMdCss = "ion-footer{display:block;position:relative;-ms-flex-order:1;order:1;width:100%;z-index:10}ion-footer.footer-toolbar-padding ion-toolbar:last-of-type{padding-bottom:var(--ion-safe-area-bottom, 0)}.footer-md{-webkit-box-shadow:0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);box-shadow:0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)}.footer-md.ion-no-border{-webkit-box-shadow:none;box-shadow:none}", Footer = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.keyboardCtrl = null, this.checkCollapsibleFooter = () => {
      if (getIonMode$2(this) !== "ios")
        return;
      const { collapse: r } = this, o = r === "fade";
      if (this.destroyCollapsibleFooter(), o) {
        const a = this.el.closest("ion-app,ion-page,.ion-page,page-inner"), c = a ? findIonContent(a) : null;
        if (!c) {
          printIonContentErrorMsg(this.el);
          return;
        }
        this.setupFadeFooter(c);
      }
    }, this.setupFadeFooter = async (e) => {
      const r = this.scrollEl = await getScrollElement(e);
      this.contentScrollCallback = () => {
        handleFooterFade(r, this.el);
      }, r.addEventListener("scroll", this.contentScrollCallback), handleFooterFade(r, this.el);
    }, this.keyboardVisible = !1, this.collapse = void 0, this.translucent = !1;
  }
  componentDidLoad() {
    this.checkCollapsibleFooter();
  }
  componentDidUpdate() {
    this.checkCollapsibleFooter();
  }
  async connectedCallback() {
    this.keyboardCtrl = await createKeyboardController(async (e, r) => {
      e === !1 && r !== void 0 && await r, this.keyboardVisible = e;
    });
  }
  disconnectedCallback() {
    this.keyboardCtrl && this.keyboardCtrl.destroy();
  }
  destroyCollapsibleFooter() {
    this.scrollEl && this.contentScrollCallback && (this.scrollEl.removeEventListener("scroll", this.contentScrollCallback), this.contentScrollCallback = void 0);
  }
  render() {
    const { translucent: e, collapse: r } = this, o = getIonMode$2(this), a = this.el.closest("ion-tabs"), c = a == null ? void 0 : a.querySelector(":scope > ion-tab-bar");
    return h(Host, { role: "contentinfo", class: {
      [o]: !0,
      // Used internally for styling
      [`footer-${o}`]: !0,
      "footer-translucent": e,
      [`footer-translucent-${o}`]: e,
      "footer-toolbar-padding": !this.keyboardVisible && (!c || c.slot !== "bottom"),
      [`footer-collapse-${r}`]: r !== void 0
    } }, o === "ios" && e && h("div", { class: "footer-background" }), h("slot", null));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: footerIosCss,
      md: footerMdCss
    };
  }
}, [36, "ion-footer", {
  collapse: [1],
  translucent: [4],
  keyboardVisible: [32]
}]);
function defineCustomElement$1$g() {
  if (typeof customElements > "u")
    return;
  ["ion-footer"].forEach((e) => {
    switch (e) {
      case "ion-footer":
        customElements.get(e) || customElements.define(e, Footer);
        break;
    }
  });
}
const defineCustomElement$x = defineCustomElement$1$g;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const TRANSITION = "all 0.2s ease-in-out", cloneElement = (t) => {
  const e = document.querySelector(`${t}.ion-cloned-element`);
  if (e !== null)
    return e;
  const r = document.createElement(t);
  return r.classList.add("ion-cloned-element"), r.style.setProperty("display", "none"), document.body.appendChild(r), r;
}, createHeaderIndex = (t) => {
  if (!t)
    return;
  const e = t.querySelectorAll("ion-toolbar");
  return {
    el: t,
    toolbars: Array.from(e).map((r) => {
      const o = r.querySelector("ion-title");
      return {
        el: r,
        background: r.shadowRoot.querySelector(".toolbar-background"),
        ionTitleEl: o,
        innerTitleEl: o ? o.shadowRoot.querySelector(".toolbar-title") : null,
        ionButtonsEl: Array.from(r.querySelectorAll("ion-buttons"))
      };
    })
  };
}, handleContentScroll = (t, e, r) => {
  readTask(() => {
    const o = t.scrollTop, a = clamp(1, 1 + -o / 500, 1.1);
    r.querySelector("ion-refresher.refresher-native") === null && writeTask(() => {
      scaleLargeTitles(e.toolbars, a);
    });
  });
}, setToolbarBackgroundOpacity = (t, e) => {
  t.collapse !== "fade" && (e === void 0 ? t.style.removeProperty("--opacity-scale") : t.style.setProperty("--opacity-scale", e.toString()));
}, handleToolbarBorderIntersection = (t, e, r) => {
  if (!t[0].isIntersecting)
    return;
  const o = t[0].intersectionRatio > 0.9 || r <= 0 ? 0 : (1 - t[0].intersectionRatio) * 100 / 75;
  setToolbarBackgroundOpacity(e.el, o === 1 ? void 0 : o);
}, handleToolbarIntersection = (t, e, r, o) => {
  writeTask(() => {
    const a = o.scrollTop;
    handleToolbarBorderIntersection(t, e, a);
    const c = t[0], u = c.intersectionRect, d = u.width * u.height, p = c.rootBounds.width * c.rootBounds.height, g = d === 0 && p === 0, b = Math.abs(u.left - c.boundingClientRect.left), x = Math.abs(u.right - c.boundingClientRect.right), w = d > 0 && (b >= 5 || x >= 5);
    g || w || (c.isIntersecting ? (setHeaderActive(e, !1), setHeaderActive(r)) : (u.x === 0 && u.y === 0 || u.width !== 0 && u.height !== 0) && a > 0 && (setHeaderActive(e), setHeaderActive(r, !1), setToolbarBackgroundOpacity(e.el)));
  });
}, setHeaderActive = (t, e = !0) => {
  const r = t.el;
  e ? (r.classList.remove("header-collapse-condense-inactive"), r.removeAttribute("aria-hidden")) : (r.classList.add("header-collapse-condense-inactive"), r.setAttribute("aria-hidden", "true"));
}, scaleLargeTitles = (t = [], e = 1, r = !1) => {
  t.forEach((o) => {
    const a = o.ionTitleEl, c = o.innerTitleEl;
    !a || a.size !== "large" || (c.style.transition = r ? TRANSITION : "", c.style.transform = `scale3d(${e}, ${e}, 1)`);
  });
}, handleHeaderFade = (t, e, r) => {
  readTask(() => {
    const o = t.scrollTop, a = e.clientHeight, c = r ? r.clientHeight : 0;
    if (r !== null && o < c) {
      e.style.setProperty("--opacity-scale", "0"), t.style.setProperty("clip-path", `inset(${a}px 0px 0px 0px)`);
      return;
    }
    const u = o - c, p = clamp(0, u / 10, 1);
    writeTask(() => {
      t.style.removeProperty("clip-path"), e.style.setProperty("--opacity-scale", p.toString());
    });
  });
}, headerIosCss = "ion-header{display:block;position:relative;-ms-flex-order:-1;order:-1;width:100%;z-index:10}ion-header ion-toolbar:first-of-type{padding-top:var(--ion-safe-area-top, 0)}.header-ios ion-toolbar:last-of-type{--border-width:0 0 0.55px}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.header-background{left:0;right:0;top:0;bottom:0;position:absolute;-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}.header-translucent-ios ion-toolbar{--opacity:.8}.header-collapse-condense-inactive .header-background{-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px)}}.header-ios.ion-no-border ion-toolbar:last-of-type{--border-width:0}.header-collapse-fade ion-toolbar{--opacity-scale:inherit}.header-collapse-condense{z-index:9}.header-collapse-condense ion-toolbar{position:-webkit-sticky;position:sticky;top:0}.header-collapse-condense ion-toolbar:first-of-type{padding-top:0px;z-index:1}.header-collapse-condense ion-toolbar{--background:var(--ion-background-color, #fff);z-index:0}.header-collapse-condense ion-toolbar:last-of-type{--border-width:0px}.header-collapse-condense ion-toolbar ion-searchbar{padding-top:0px;padding-bottom:13px}.header-collapse-main{--opacity-scale:1}.header-collapse-main ion-toolbar{--opacity-scale:inherit}.header-collapse-main ion-toolbar.in-toolbar ion-title,.header-collapse-main ion-toolbar.in-toolbar ion-buttons{-webkit-transition:all 0.2s ease-in-out;transition:all 0.2s ease-in-out}.header-collapse-condense-inactive:not(.header-collapse-condense) ion-toolbar.in-toolbar ion-title,.header-collapse-condense-inactive:not(.header-collapse-condense) ion-toolbar.in-toolbar ion-buttons.buttons-collapse{opacity:0;pointer-events:none}.header-collapse-condense-inactive.header-collapse-condense ion-toolbar.in-toolbar ion-title,.header-collapse-condense-inactive.header-collapse-condense ion-toolbar.in-toolbar ion-buttons.buttons-collapse{visibility:hidden}ion-header:not(.header-collapse-main):has(~ion-content ion-header[collapse=condense],~ion-content ion-header.header-collapse-condense){opacity:0}", headerMdCss = "ion-header{display:block;position:relative;-ms-flex-order:-1;order:-1;width:100%;z-index:10}ion-header ion-toolbar:first-of-type{padding-top:var(--ion-safe-area-top, 0)}.header-md{-webkit-box-shadow:0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);box-shadow:0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)}.header-collapse-condense{display:none}.header-md.ion-no-border{-webkit-box-shadow:none;box-shadow:none}", Header = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.inheritedAttributes = {}, this.setupFadeHeader = async (e, r) => {
      const o = this.scrollEl = await getScrollElement(e);
      this.contentScrollCallback = () => {
        handleHeaderFade(this.scrollEl, this.el, r);
      }, o.addEventListener("scroll", this.contentScrollCallback), handleHeaderFade(this.scrollEl, this.el, r);
    }, this.collapse = void 0, this.translucent = !1;
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAriaAttributes(this.el);
  }
  componentDidLoad() {
    this.checkCollapsibleHeader();
  }
  componentDidUpdate() {
    this.checkCollapsibleHeader();
  }
  disconnectedCallback() {
    this.destroyCollapsibleHeader();
  }
  async checkCollapsibleHeader() {
    if (getIonMode$2(this) !== "ios")
      return;
    const { collapse: r } = this, o = r === "condense", a = r === "fade";
    if (this.destroyCollapsibleHeader(), o) {
      const c = this.el.closest("ion-app,ion-page,.ion-page,page-inner"), u = c ? findIonContent(c) : null;
      writeTask(() => {
        const d = cloneElement("ion-title");
        d.size = "large", cloneElement("ion-back-button");
      }), await this.setupCondenseHeader(u, c);
    } else if (a) {
      const c = this.el.closest("ion-app,ion-page,.ion-page,page-inner"), u = c ? findIonContent(c) : null;
      if (!u) {
        printIonContentErrorMsg(this.el);
        return;
      }
      const d = u.querySelector('ion-header[collapse="condense"]');
      await this.setupFadeHeader(u, d);
    }
  }
  destroyCollapsibleHeader() {
    this.intersectionObserver && (this.intersectionObserver.disconnect(), this.intersectionObserver = void 0), this.scrollEl && this.contentScrollCallback && (this.scrollEl.removeEventListener("scroll", this.contentScrollCallback), this.contentScrollCallback = void 0), this.collapsibleMainHeader && (this.collapsibleMainHeader.classList.remove("header-collapse-main"), this.collapsibleMainHeader = void 0);
  }
  async setupCondenseHeader(e, r) {
    if (!e || !r) {
      printIonContentErrorMsg(this.el);
      return;
    }
    if (typeof IntersectionObserver > "u")
      return;
    this.scrollEl = await getScrollElement(e);
    const o = r.querySelectorAll("ion-header");
    if (this.collapsibleMainHeader = Array.from(o).find((d) => d.collapse !== "condense"), !this.collapsibleMainHeader)
      return;
    const a = createHeaderIndex(this.collapsibleMainHeader), c = createHeaderIndex(this.el);
    if (!a || !c)
      return;
    setHeaderActive(a, !1), setToolbarBackgroundOpacity(a.el, 0);
    const u = (d) => {
      handleToolbarIntersection(d, a, c, this.scrollEl);
    };
    this.intersectionObserver = new IntersectionObserver(u, {
      root: e,
      threshold: [0.25, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    }), this.intersectionObserver.observe(c.toolbars[c.toolbars.length - 1].el), this.contentScrollCallback = () => {
      handleContentScroll(this.scrollEl, c, e);
    }, this.scrollEl.addEventListener("scroll", this.contentScrollCallback), writeTask(() => {
      this.collapsibleMainHeader !== void 0 && this.collapsibleMainHeader.classList.add("header-collapse-main");
    });
  }
  render() {
    const { translucent: e, inheritedAttributes: r } = this, o = getIonMode$2(this), a = this.collapse || "none", c = hostContext("ion-menu", this.el) ? "none" : "banner";
    return h(Host, Object.assign({ role: c, class: {
      [o]: !0,
      // Used internally for styling
      [`header-${o}`]: !0,
      "header-translucent": this.translucent,
      [`header-collapse-${a}`]: !0,
      [`header-translucent-${o}`]: this.translucent
    } }, r), o === "ios" && e && h("div", { class: "header-background" }), h("slot", null));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: headerIosCss,
      md: headerMdCss
    };
  }
}, [36, "ion-header", {
  collapse: [1],
  translucent: [4]
}]);
function defineCustomElement$1$f() {
  if (typeof customElements > "u")
    return;
  ["ion-header"].forEach((e) => {
    switch (e) {
      case "ion-header":
        customElements.get(e) || customElements.define(e, Header);
        break;
    }
  });
}
const defineCustomElement$w = defineCustomElement$1$f;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const sanitizeDOMString = (t) => {
  try {
    if (t instanceof IonicSafeString)
      return t.value;
    if (!isSanitizerEnabled() || typeof t != "string" || t === "")
      return t;
    if (t.includes("onload="))
      return "";
    const e = document.createDocumentFragment(), r = document.createElement("div");
    e.appendChild(r), r.innerHTML = t, blockedTags.forEach((u) => {
      const d = e.querySelectorAll(u);
      for (let p = d.length - 1; p >= 0; p--) {
        const g = d[p];
        g.parentNode ? g.parentNode.removeChild(g) : e.removeChild(g);
        const b = getElementChildren(g);
        for (let x = 0; x < b.length; x++)
          sanitizeElement(b[x]);
      }
    });
    const o = getElementChildren(e);
    for (let u = 0; u < o.length; u++)
      sanitizeElement(o[u]);
    const a = document.createElement("div");
    a.appendChild(e);
    const c = a.querySelector("div");
    return c !== null ? c.innerHTML : a.innerHTML;
  } catch (e) {
    return console.error(e), "";
  }
}, sanitizeElement = (t) => {
  if (t.nodeType && t.nodeType !== 1)
    return;
  if (typeof NamedNodeMap < "u" && !(t.attributes instanceof NamedNodeMap)) {
    t.remove();
    return;
  }
  for (let r = t.attributes.length - 1; r >= 0; r--) {
    const o = t.attributes.item(r), a = o.name;
    if (!allowedAttributes.includes(a.toLowerCase())) {
      t.removeAttribute(a);
      continue;
    }
    const c = o.value, u = t[a];
    (c != null && c.toLowerCase().includes("javascript:") || u != null && u.toLowerCase().includes("javascript:")) && t.removeAttribute(a);
  }
  const e = getElementChildren(t);
  for (let r = 0; r < e.length; r++)
    sanitizeElement(e[r]);
}, getElementChildren = (t) => t.children != null ? t.children : t.childNodes, isSanitizerEnabled = () => {
  var t;
  const e = window, r = (t = e == null ? void 0 : e.Ionic) === null || t === void 0 ? void 0 : t.config;
  return r ? r.get ? r.get("sanitizerEnabled", !0) : r.sanitizerEnabled === !0 || r.sanitizerEnabled === void 0 : !0;
}, allowedAttributes = ["class", "id", "href", "src", "name", "slot"], blockedTags = ["script", "style", "iframe", "meta", "link", "object", "embed"];
class IonicSafeString {
  constructor(e) {
    this.value = e;
  }
}
const ENABLE_HTML_CONTENT_DEFAULT = !1;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const spinners = {
  bubbles: {
    dur: 1e3,
    circles: 9,
    fn: (t, e, r) => {
      const o = `${t * e / r - t}ms`, a = 2 * Math.PI * e / r;
      return {
        r: 5,
        style: {
          top: `${32 * Math.sin(a)}%`,
          left: `${32 * Math.cos(a)}%`,
          "animation-delay": o
        }
      };
    }
  },
  circles: {
    dur: 1e3,
    circles: 8,
    fn: (t, e, r) => {
      const o = e / r, a = `${t * o - t}ms`, c = 2 * Math.PI * o;
      return {
        r: 5,
        style: {
          top: `${32 * Math.sin(c)}%`,
          left: `${32 * Math.cos(c)}%`,
          "animation-delay": a
        }
      };
    }
  },
  circular: {
    dur: 1400,
    elmDuration: !0,
    circles: 1,
    fn: () => ({
      r: 20,
      cx: 48,
      cy: 48,
      fill: "none",
      viewBox: "24 24 48 48",
      transform: "translate(0,0)",
      style: {}
    })
  },
  crescent: {
    dur: 750,
    circles: 1,
    fn: () => ({
      r: 26,
      style: {}
    })
  },
  dots: {
    dur: 750,
    circles: 3,
    fn: (t, e) => {
      const r = -(110 * e) + "ms";
      return {
        r: 6,
        style: {
          left: `${32 - 32 * e}%`,
          "animation-delay": r
        }
      };
    }
  },
  lines: {
    dur: 1e3,
    lines: 8,
    fn: (t, e, r) => {
      const o = `rotate(${360 / r * e + (e < r / 2 ? 180 : -180)}deg)`, a = `${t * e / r - t}ms`;
      return {
        y1: 14,
        y2: 26,
        style: {
          transform: o,
          "animation-delay": a
        }
      };
    }
  },
  "lines-small": {
    dur: 1e3,
    lines: 8,
    fn: (t, e, r) => {
      const o = `rotate(${360 / r * e + (e < r / 2 ? 180 : -180)}deg)`, a = `${t * e / r - t}ms`;
      return {
        y1: 12,
        y2: 20,
        style: {
          transform: o,
          "animation-delay": a
        }
      };
    }
  },
  "lines-sharp": {
    dur: 1e3,
    lines: 12,
    fn: (t, e, r) => {
      const o = `rotate(${30 * e + (e < 6 ? 180 : -180)}deg)`, a = `${t * e / r - t}ms`;
      return {
        y1: 17,
        y2: 29,
        style: {
          transform: o,
          "animation-delay": a
        }
      };
    }
  },
  "lines-sharp-small": {
    dur: 1e3,
    lines: 12,
    fn: (t, e, r) => {
      const o = `rotate(${30 * e + (e < 6 ? 180 : -180)}deg)`, a = `${t * e / r - t}ms`;
      return {
        y1: 12,
        y2: 20,
        style: {
          transform: o,
          "animation-delay": a
        }
      };
    }
  }
}, SPINNERS = spinners, spinnerCss = ":host{display:inline-block;position:relative;width:28px;height:28px;color:var(--color);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host(.ion-color){color:var(--ion-color-base)}svg{-webkit-transform-origin:center;transform-origin:center;position:absolute;top:0;left:0;width:100%;height:100%;-webkit-transform:translateZ(0);transform:translateZ(0)}:host-context([dir=rtl]) svg{-webkit-transform-origin:calc(100% - center);transform-origin:calc(100% - center)}[dir=rtl] svg{-webkit-transform-origin:calc(100% - center);transform-origin:calc(100% - center)}@supports selector(:dir(rtl)){svg:dir(rtl){-webkit-transform-origin:calc(100% - center);transform-origin:calc(100% - center)}}:host(.spinner-lines) line,:host(.spinner-lines-small) line{stroke-width:7px}:host(.spinner-lines-sharp) line,:host(.spinner-lines-sharp-small) line{stroke-width:4px}:host(.spinner-lines) line,:host(.spinner-lines-small) line,:host(.spinner-lines-sharp) line,:host(.spinner-lines-sharp-small) line{stroke-linecap:round;stroke:currentColor}:host(.spinner-lines) svg,:host(.spinner-lines-small) svg,:host(.spinner-lines-sharp) svg,:host(.spinner-lines-sharp-small) svg{-webkit-animation:spinner-fade-out 1s linear infinite;animation:spinner-fade-out 1s linear infinite}:host(.spinner-bubbles) svg{-webkit-animation:spinner-scale-out 1s linear infinite;animation:spinner-scale-out 1s linear infinite;fill:currentColor}:host(.spinner-circles) svg{-webkit-animation:spinner-fade-out 1s linear infinite;animation:spinner-fade-out 1s linear infinite;fill:currentColor}:host(.spinner-crescent) circle{fill:transparent;stroke-width:4px;stroke-dasharray:128px;stroke-dashoffset:82px;stroke:currentColor}:host(.spinner-crescent) svg{-webkit-animation:spinner-rotate 1s linear infinite;animation:spinner-rotate 1s linear infinite}:host(.spinner-dots) circle{stroke-width:0;fill:currentColor}:host(.spinner-dots) svg{-webkit-animation:spinner-dots 1s linear infinite;animation:spinner-dots 1s linear infinite}:host(.spinner-circular) svg{-webkit-animation:spinner-circular linear infinite;animation:spinner-circular linear infinite}:host(.spinner-circular) circle{-webkit-animation:spinner-circular-inner ease-in-out infinite;animation:spinner-circular-inner ease-in-out infinite;stroke:currentColor;stroke-dasharray:80px, 200px;stroke-dashoffset:0px;stroke-width:5.6;fill:none}:host(.spinner-paused),:host(.spinner-paused) svg,:host(.spinner-paused) circle{-webkit-animation-play-state:paused;animation-play-state:paused}@-webkit-keyframes spinner-fade-out{0%{opacity:1}100%{opacity:0}}@keyframes spinner-fade-out{0%{opacity:1}100%{opacity:0}}@-webkit-keyframes spinner-scale-out{0%{-webkit-transform:scale(1, 1);transform:scale(1, 1)}100%{-webkit-transform:scale(0, 0);transform:scale(0, 0)}}@keyframes spinner-scale-out{0%{-webkit-transform:scale(1, 1);transform:scale(1, 1)}100%{-webkit-transform:scale(0, 0);transform:scale(0, 0)}}@-webkit-keyframes spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes spinner-dots{0%{-webkit-transform:scale(1, 1);transform:scale(1, 1);opacity:0.9}50%{-webkit-transform:scale(0.4, 0.4);transform:scale(0.4, 0.4);opacity:0.3}100%{-webkit-transform:scale(1, 1);transform:scale(1, 1);opacity:0.9}}@keyframes spinner-dots{0%{-webkit-transform:scale(1, 1);transform:scale(1, 1);opacity:0.9}50%{-webkit-transform:scale(0.4, 0.4);transform:scale(0.4, 0.4);opacity:0.3}100%{-webkit-transform:scale(1, 1);transform:scale(1, 1);opacity:0.9}}@-webkit-keyframes spinner-circular{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-circular{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes spinner-circular-inner{0%{stroke-dasharray:1px, 200px;stroke-dashoffset:0px}50%{stroke-dasharray:100px, 200px;stroke-dashoffset:-15px}100%{stroke-dasharray:100px, 200px;stroke-dashoffset:-125px}}@keyframes spinner-circular-inner{0%{stroke-dasharray:1px, 200px;stroke-dashoffset:0px}50%{stroke-dasharray:100px, 200px;stroke-dashoffset:-15px}100%{stroke-dasharray:100px, 200px;stroke-dashoffset:-125px}}", Spinner = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0, this.duration = void 0, this.name = void 0, this.paused = !1;
  }
  getName() {
    const e = this.name || config$1.get("spinner"), r = getIonMode$2(this);
    return e || (r === "ios" ? "lines" : "circular");
  }
  render() {
    var e;
    const r = this, o = getIonMode$2(r), a = r.getName(), c = (e = SPINNERS[a]) !== null && e !== void 0 ? e : SPINNERS.lines, u = typeof r.duration == "number" && r.duration > 10 ? r.duration : c.dur, d = [];
    if (c.circles !== void 0)
      for (let p = 0; p < c.circles; p++)
        d.push(buildCircle(c, u, p, c.circles));
    else if (c.lines !== void 0)
      for (let p = 0; p < c.lines; p++)
        d.push(buildLine(c, u, p, c.lines));
    return h(Host, { class: createColorClasses$1(r.color, {
      [o]: !0,
      [`spinner-${a}`]: !0,
      "spinner-paused": r.paused || config$1.getBoolean("_testing")
    }), role: "progressbar", style: c.elmDuration ? { animationDuration: u + "ms" } : {} }, d);
  }
  static get style() {
    return spinnerCss;
  }
}, [1, "ion-spinner", {
  color: [513],
  duration: [2],
  name: [1],
  paused: [4]
}]), buildCircle = (t, e, r, o) => {
  const a = t.fn(e, r, o);
  return a.style["animation-duration"] = e + "ms", h("svg", { viewBox: a.viewBox || "0 0 64 64", style: a.style }, h("circle", { transform: a.transform || "translate(32,32)", cx: a.cx, cy: a.cy, r: a.r, style: t.elmDuration ? { animationDuration: e + "ms" } : {} }));
}, buildLine = (t, e, r, o) => {
  const a = t.fn(e, r, o);
  return a.style["animation-duration"] = e + "ms", h("svg", { viewBox: a.viewBox || "0 0 64 64", style: a.style }, h("line", { transform: "translate(32,32)", y1: a.y1, y2: a.y2 }));
};
function defineCustomElement$v() {
  if (typeof customElements > "u")
    return;
  ["ion-spinner"].forEach((e) => {
    switch (e) {
      case "ion-spinner":
        customElements.get(e) || customElements.define(e, Spinner);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const createNotchController = (t, e, r) => {
  let o;
  const a = () => (
    /**
     * If the notch is not being used
     * then we do not need to set the notch width.
     */
    !(e() === void 0 || /**
     * If either the label property is being
     * used or the label slot is not defined,
     * then we do not need to estimate the notch width.
     */
    t.label !== void 0 || r() === null)
  ), c = () => {
    a() && raf(() => {
      u();
    });
  }, u = () => {
    const p = e();
    if (p === void 0)
      return;
    if (!a()) {
      p.style.removeProperty("width");
      return;
    }
    const g = r().scrollWidth;
    if (
      /**
       * If the computed width of the label is 0
       * and notchSpacerEl's offsetParent is null
       * then that means the element is hidden.
       * As a result, we need to wait for the element
       * to become visible before setting the notch width.
       *
       * We do not check el.offsetParent because
       * that can be null if the host element has
       * position: fixed applied to it.
       * notchSpacerEl does not have position: fixed.
       */
      g === 0 && p.offsetParent === null && win !== void 0 && "IntersectionObserver" in win
    ) {
      if (o !== void 0)
        return;
      const b = o = new IntersectionObserver(
        (x) => {
          x[0].intersectionRatio === 1 && (u(), b.disconnect(), o = void 0);
        },
        /**
         * Set the root to be the host element
         * This causes the IO callback
         * to be fired in WebKit as soon as the element
         * is visible. If we used the default root value
         * then WebKit would only fire the IO callback
         * after any animations (such as a modal transition)
         * finished, and there would potentially be a flicker.
         */
        { threshold: 0.01, root: t }
      );
      b.observe(p);
      return;
    }
    p.style.setProperty("width", `${g * 0.75}px`);
  };
  return {
    calculateNotchWidth: c,
    destroy: () => {
      o && (o.disconnect(), o = void 0);
    }
  };
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$u = defineCustomElement$C;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const watchForOptions = (t, e, r) => {
  if (typeof MutationObserver > "u")
    return;
  const o = new MutationObserver((a) => {
    r(getSelectedOption(a, e));
  });
  return o.observe(t, {
    childList: !0,
    subtree: !0
  }), o;
}, getSelectedOption = (t, e) => {
  let r;
  return t.forEach((o) => {
    for (let a = 0; a < o.addedNodes.length; a++)
      r = findCheckedOption(o.addedNodes[a], e) || r;
  }), r;
}, findCheckedOption = (t, e) => {
  if (t.nodeType !== 1)
    return;
  const r = t;
  return (r.tagName === e.toUpperCase() ? [r] : Array.from(r.querySelectorAll(e))).find((a) => a.value === r.value);
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$t = defineCustomElement$B;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const listIosCss = "ion-list{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:block;contain:content;list-style-type:none}ion-list.list-inset{-webkit-transform:translateZ(0);transform:translateZ(0);overflow:hidden}.list-ios{background:var(--ion-item-background, var(--ion-background-color, #fff))}.list-ios.list-inset{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:16px;margin-bottom:16px;border-radius:10px}.list-ios.list-inset ion-item:only-child,.list-ios.list-inset ion-item:not(:only-of-type):last-of-type,.list-ios.list-inset ion-item-sliding:last-of-type ion-item{--border-width:0;--inner-border-width:0}.list-ios.list-inset+ion-list.list-inset{margin-top:0}.list-ios-lines-none .item-lines-default{--inner-border-width:0px;--border-width:0px}.list-ios-lines-full .item-lines-default{--inner-border-width:0px;--border-width:0 0 0.55px 0}.list-ios-lines-inset .item-lines-default{--inner-border-width:0 0 0.55px 0;--border-width:0px}ion-card .list-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", listMdCss = "ion-list{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:block;contain:content;list-style-type:none}ion-list.list-inset{-webkit-transform:translateZ(0);transform:translateZ(0);overflow:hidden}.list-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:8px;padding-bottom:8px;background:var(--ion-item-background, var(--ion-background-color, #fff))}@supports (inset-inline-start: 0){.list-md>.input:last-child::after{inset-inline-start:0}}@supports not (inset-inline-start: 0){.list-md>.input:last-child::after{left:0}:host-context([dir=rtl]) .list-md>.input:last-child::after{left:unset;right:unset;right:0}[dir=rtl] .list-md>.input:last-child::after{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){.list-md>.input:last-child::after:dir(rtl){left:unset;right:unset;right:0}}}.list-md.list-inset{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:16px;margin-bottom:16px;border-radius:2px}.list-md.list-inset ion-item:not(:only-of-type):first-of-type,.list-md.list-inset ion-item-sliding:first-of-type ion-item{--border-radius:2px 2px 0 0}.list-md.list-inset ion-item:not(:only-of-type):last-of-type,.list-md.list-inset ion-item-sliding:last-of-type ion-item{--border-radius:0 0 2px 2px;--border-width:0;--inner-border-width:0}.list-md.list-inset ion-item:only-child{--border-radius:2px;--border-width:0;--inner-border-width:0}.list-md.list-inset+ion-list.list-inset{margin-top:0}.list-md-lines-none .item-lines-default{--inner-border-width:0px;--border-width:0px}.list-md-lines-full .item-lines-default{--inner-border-width:0px;--border-width:0 0 1px 0}.list-md-lines-inset .item-lines-default{--inner-border-width:0 0 1px 0;--border-width:0px}ion-card .list-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", List = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.lines = void 0, this.inset = !1;
  }
  /**
   * If `ion-item-sliding` are used inside the list, this method closes
   * any open sliding item.
   *
   * Returns `true` if an actual `ion-item-sliding` is closed.
   */
  async closeSlidingItems() {
    const e = this.el.querySelector("ion-item-sliding");
    return e != null && e.closeOpened ? e.closeOpened() : !1;
  }
  render() {
    const e = getIonMode$2(this), { lines: r, inset: o } = this;
    return h(Host, { role: "list", class: {
      [e]: !0,
      // Used internally for styling
      [`list-${e}`]: !0,
      "list-inset": o,
      [`list-lines-${r}`]: r !== void 0,
      [`list-${e}-lines-${r}`]: r !== void 0
    } });
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: listIosCss,
      md: listMdCss
    };
  }
}, [32, "ion-list", {
  lines: [1],
  inset: [4],
  closeSlidingItems: [64]
}]);
function defineCustomElement$s() {
  if (typeof customElements > "u")
    return;
  ["ion-list"].forEach((e) => {
    switch (e) {
      case "ion-list":
        customElements.get(e) || customElements.define(e, List);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$r = defineCustomElement$s;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const listHeaderIosCss = ":host{--border-style:solid;--border-width:0;--inner-border-width:0;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:40px;border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);color:var(--color);overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}.list-header-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex:1 1 auto;flex:1 1 auto}:host(.list-header-lines-inset),:host(.list-header-lines-none){--border-width:0}:host(.list-header-lines-full),:host(.list-header-lines-none){--inner-border-width:0}:host{--background:transparent;--color:var(--ion-color-step-850, #262626);--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));padding-right:var(--ion-safe-area-right);padding-left:calc(var(--ion-safe-area-left, 0px) + 16px);position:relative;-ms-flex-align:end;align-items:flex-end;font-size:min(1.375rem, 56.1px);font-weight:700;letter-spacing:0}:host-context([dir=rtl]){padding-right:calc(var(--ion-safe-area-right, 0px) + 16px);padding-left:var(--ion-safe-area-left)}@supports selector(:dir(rtl)){:host(:dir(rtl)){padding-right:calc(var(--ion-safe-area-right, 0px) + 16px);padding-left:var(--ion-safe-area-left)}}::slotted(ion-button),::slotted(ion-label){margin-top:29px;margin-bottom:6px}::slotted(ion-button){--padding-top:0;--padding-bottom:0;-webkit-margin-start:3px;margin-inline-start:3px;-webkit-margin-end:3px;margin-inline-end:3px;min-height:1.4em}:host(.list-header-lines-full){--border-width:0 0 0.55px 0}:host(.list-header-lines-inset){--inner-border-width:0 0 0.55px 0}", listHeaderMdCss = ":host{--border-style:solid;--border-width:0;--inner-border-width:0;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:40px;border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);color:var(--color);overflow:hidden}:host(.ion-color){background:var(--ion-color-base);color:var(--ion-color-contrast)}.list-header-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex:1;flex:1;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-item-align:stretch;align-self:stretch;min-height:inherit;border-width:var(--inner-border-width);border-style:var(--border-style);border-color:var(--border-color);overflow:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex:1 1 auto;flex:1 1 auto}:host(.list-header-lines-inset),:host(.list-header-lines-none){--border-width:0}:host(.list-header-lines-full),:host(.list-header-lines-none){--inner-border-width:0}:host{--background:transparent;--color:var(--ion-text-color, #000);--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))));padding-right:var(--ion-safe-area-right);padding-left:calc(var(--ion-safe-area-left, 0px) + 16px);min-height:45px;font-size:0.875rem}:host-context([dir=rtl]){padding-right:calc(var(--ion-safe-area-right, 0px) + 16px);padding-left:var(--ion-safe-area-left)}@supports selector(:dir(rtl)){:host(:dir(rtl)){padding-right:calc(var(--ion-safe-area-right, 0px) + 16px);padding-left:var(--ion-safe-area-left)}}:host(.list-header-lines-full){--border-width:0 0 1px 0}:host(.list-header-lines-inset){--inner-border-width:0 0 1px 0}", ListHeader = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.color = void 0, this.lines = void 0;
  }
  render() {
    const { lines: e } = this, r = getIonMode$2(this);
    return h(Host, { class: createColorClasses$1(this.color, {
      [r]: !0,
      [`list-header-lines-${e}`]: e !== void 0
    }) }, h("div", { class: "list-header-inner" }, h("slot", null)));
  }
  static get style() {
    return {
      ios: listHeaderIosCss,
      md: listHeaderMdCss
    };
  }
}, [33, "ion-list-header", {
  color: [513],
  lines: [1]
}]);
function defineCustomElement$q() {
  if (typeof customElements > "u")
    return;
  ["ion-list-header"].forEach((e) => {
    switch (e) {
      case "ion-list-header":
        customElements.get(e) || customElements.define(e, ListHeader);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$p = defineCustomElement$q;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const getTimeGivenProgression = (t, e, r, o, a) => solveCubicBezier(t[1], e[1], r[1], o[1], a).map((c) => solveCubicParametricEquation(t[0], e[0], r[0], o[0], c)), solveCubicParametricEquation = (t, e, r, o, a) => {
  const c = 3 * e * Math.pow(a - 1, 2), u = -3 * r * a + 3 * r + o * a, d = t * Math.pow(a - 1, 3);
  return a * (c + a * u) - d;
}, solveCubicBezier = (t, e, r, o, a) => (t -= a, e -= a, r -= a, o -= a, solveCubicEquation(o - 3 * r + 3 * e - t, 3 * r - 6 * e + 3 * t, 3 * e - 3 * t, t).filter((u) => u >= 0 && u <= 1)), solveQuadraticEquation = (t, e, r) => {
  const o = e * e - 4 * t * r;
  return o < 0 ? [] : [(-e + Math.sqrt(o)) / (2 * t), (-e - Math.sqrt(o)) / (2 * t)];
}, solveCubicEquation = (t, e, r, o) => {
  if (t === 0)
    return solveQuadraticEquation(e, r, o);
  e /= t, r /= t, o /= t;
  const a = (3 * r - e * e) / 3, c = (2 * e * e * e - 9 * e * r + 27 * o) / 27;
  if (a === 0)
    return [Math.pow(-c, 1 / 3)];
  if (c === 0)
    return [Math.sqrt(-a), -Math.sqrt(-a)];
  const u = Math.pow(c / 2, 2) + Math.pow(a / 3, 3);
  if (u === 0)
    return [Math.pow(c / 2, 1 / 2) - e / 3];
  if (u > 0)
    return [
      Math.pow(-(c / 2) + Math.sqrt(u), 1 / 3) - Math.pow(c / 2 + Math.sqrt(u), 1 / 3) - e / 3
    ];
  const d = Math.sqrt(Math.pow(-(a / 3), 3)), p = Math.acos(-(c / (2 * Math.sqrt(Math.pow(-(a / 3), 3))))), g = 2 * Math.pow(d, 1 / 3);
  return [
    g * Math.cos(p / 3) - e / 3,
    g * Math.cos((p + 2 * Math.PI) / 3) - e / 3,
    g * Math.cos((p + 4 * Math.PI) / 3) - e / 3
  ];
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const VIEW_STATE_NEW = 1, VIEW_STATE_ATTACHED = 2, VIEW_STATE_DESTROYED = 3;
class ViewController {
  constructor(e, r) {
    this.component = e, this.params = r, this.state = VIEW_STATE_NEW;
  }
  async init(e) {
    if (this.state = VIEW_STATE_ATTACHED, !this.element) {
      const r = this.component;
      this.element = await attachComponent(this.delegate, e, r, ["ion-page", "ion-page-invisible"], this.params);
    }
  }
  /**
   * DOM WRITE
   */
  _destroy() {
    assert(this.state !== VIEW_STATE_DESTROYED, "view state must be ATTACHED");
    const e = this.element;
    e && (this.delegate ? this.delegate.removeViewFromDom(e.parentElement, e) : e.remove()), this.nav = void 0, this.state = VIEW_STATE_DESTROYED;
  }
}
const matches = (t, e, r) => !t || t.component !== e ? !1 : shallowEqualStringMap(t.params, r), convertToView = (t, e) => t ? t instanceof ViewController ? t : new ViewController(t, e) : null, convertToViews = (t) => t.map((e) => e instanceof ViewController ? e : "component" in e ? convertToView(e.component, e.componentProps === null ? void 0 : e.componentProps) : convertToView(e, void 0)).filter((e) => e !== null), navCss = ":host{left:0;right:0;top:0;bottom:0;position:absolute;contain:layout size style;z-index:0}", Nav = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionNavWillLoad = createEvent(this, "ionNavWillLoad", 7), this.ionNavWillChange = createEvent(this, "ionNavWillChange", 3), this.ionNavDidChange = createEvent(this, "ionNavDidChange", 3), this.transInstr = [], this.gestureOrAnimationInProgress = !1, this.useRouter = !1, this.isTransitioning = !1, this.destroyed = !1, this.views = [], this.didLoad = !1, this.delegate = void 0, this.swipeGesture = void 0, this.animated = !0, this.animation = void 0, this.rootParams = void 0, this.root = void 0;
  }
  swipeGestureChanged() {
    this.gesture && this.gesture.enable(this.swipeGesture === !0);
  }
  rootChanged() {
    this.root !== void 0 && this.didLoad !== !1 && (this.useRouter || this.root !== void 0 && this.setRoot(this.root, this.rootParams));
  }
  componentWillLoad() {
    if (this.useRouter = document.querySelector("ion-router") !== null && this.el.closest("[no-router]") === null, this.swipeGesture === void 0) {
      const e = getIonMode$2(this);
      this.swipeGesture = config$1.getBoolean("swipeBackEnabled", e === "ios");
    }
    this.ionNavWillLoad.emit();
  }
  async componentDidLoad() {
    this.didLoad = !0, this.rootChanged(), this.gesture = (await import("./swipe-back-cfbc0910.js")).createSwipeBackGesture(this.el, this.canStart.bind(this), this.onStart.bind(this), this.onMove.bind(this), this.onEnd.bind(this)), this.swipeGestureChanged();
  }
  connectedCallback() {
    this.destroyed = !1;
  }
  disconnectedCallback() {
    for (const e of this.views)
      lifecycle(e.element, LIFECYCLE_WILL_UNLOAD), e._destroy();
    this.gesture && (this.gesture.destroy(), this.gesture = void 0), this.transInstr.length = 0, this.views.length = 0, this.destroyed = !0;
  }
  /**
   * Push a new component onto the current navigation stack. Pass any additional
   * information along as an object. This additional information is accessible
   * through NavParams.
   *
   * @param component The component to push onto the navigation stack.
   * @param componentProps Any properties of the component.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  push(e, r, o, a) {
    return this.insert(-1, e, r, o, a);
  }
  /**
   * Inserts a component into the navigation stack at the specified index.
   * This is useful to add a component at any point in the navigation stack.
   *
   * @param insertIndex The index to insert the component at in the stack.
   * @param component The component to insert into the navigation stack.
   * @param componentProps Any properties of the component.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  insert(e, r, o, a, c) {
    return this.insertPages(e, [{ component: r, componentProps: o }], a, c);
  }
  /**
   * Inserts an array of components into the navigation stack at the specified index.
   * The last component in the array will become instantiated as a view, and animate
   * in to become the active view.
   *
   * @param insertIndex The index to insert the components at in the stack.
   * @param insertComponents The components to insert into the navigation stack.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  insertPages(e, r, o, a) {
    return this.queueTrns({
      insertStart: e,
      insertViews: r,
      opts: o
    }, a);
  }
  /**
   * Pop a component off of the navigation stack. Navigates back from the current
   * component.
   *
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  pop(e, r) {
    return this.removeIndex(-1, 1, e, r);
  }
  /**
   * Pop to a specific index in the navigation stack.
   *
   * @param indexOrViewCtrl The index or view controller to pop to.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  popTo(e, r, o) {
    const a = {
      removeStart: -1,
      removeCount: -1,
      opts: r
    };
    return typeof e == "object" && e.component ? (a.removeView = e, a.removeStart = 1) : typeof e == "number" && (a.removeStart = e + 1), this.queueTrns(a, o);
  }
  /**
   * Navigate back to the root of the stack, no matter how far back that is.
   *
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  popToRoot(e, r) {
    return this.removeIndex(1, -1, e, r);
  }
  /**
   * Removes a component from the navigation stack at the specified index.
   *
   * @param startIndex The number to begin removal at.
   * @param removeCount The number of components to remove.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  removeIndex(e, r = 1, o, a) {
    return this.queueTrns({
      removeStart: e,
      removeCount: r,
      opts: o
    }, a);
  }
  /**
   * Set the root for the current navigation stack to a component.
   *
   * @param component The component to set as the root of the navigation stack.
   * @param componentProps Any properties of the component.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  setRoot(e, r, o, a) {
    return this.setPages([{ component: e, componentProps: r }], o, a);
  }
  /**
   * Set the views of the current navigation stack and navigate to the last view.
   * By default animations are disabled, but they can be enabled by passing options
   * to the navigation controller. Navigation parameters can also be passed to the
   * individual pages in the array.
   *
   * @param views The list of views to set as the navigation stack.
   * @param opts The navigation options.
   * @param done The transition complete function.
   */
  setPages(e, r, o) {
    return r ?? (r = {}), r.animated !== !0 && (r.animated = !1), this.queueTrns({
      insertStart: 0,
      insertViews: e,
      removeStart: 0,
      removeCount: -1,
      opts: r
    }, o);
  }
  /**
   * Called by the router to update the view.
   *
   * @param id The component tag.
   * @param params The component params.
   * @param direction A direction hint.
   * @param animation an AnimationBuilder.
   *
   * @return the status.
   * @internal
   */
  setRouteId(e, r, o, a) {
    const c = this.getActiveSync();
    if (matches(c, e, r))
      return Promise.resolve({
        changed: !1,
        element: c.element
      });
    let u;
    const d = new Promise((b) => u = b);
    let p;
    const g = {
      updateURL: !1,
      viewIsReady: (b) => {
        let x;
        const w = new Promise((y) => x = y);
        return u({
          changed: !0,
          element: b,
          markVisible: async () => {
            x(), await p;
          }
        }), w;
      }
    };
    if (o === "root")
      p = this.setRoot(e, r, g);
    else {
      const b = this.views.find((x) => matches(x, e, r));
      b ? p = this.popTo(b, Object.assign(Object.assign({}, g), { direction: "back", animationBuilder: a })) : o === "forward" ? p = this.push(e, r, Object.assign(Object.assign({}, g), { animationBuilder: a })) : o === "back" && (p = this.setRoot(e, r, Object.assign(Object.assign({}, g), { direction: "back", animated: !0, animationBuilder: a })));
    }
    return d;
  }
  /**
   * Called by <ion-router> to retrieve the current component.
   *
   * @internal
   */
  async getRouteId() {
    const e = this.getActiveSync();
    if (e)
      return {
        id: e.element.tagName,
        params: e.params,
        element: e.element
      };
  }
  /**
   * Get the active view.
   */
  async getActive() {
    return this.getActiveSync();
  }
  /**
   * Get the view at the specified index.
   *
   * @param index The index of the view.
   */
  async getByIndex(e) {
    return this.views[e];
  }
  /**
   * Returns `true` if the current view can go back.
   *
   * @param view The view to check.
   */
  async canGoBack(e) {
    return this.canGoBackSync(e);
  }
  /**
   * Get the previous view.
   *
   * @param view The view to get.
   */
  async getPrevious(e) {
    return this.getPreviousSync(e);
  }
  getLength() {
    return this.views.length;
  }
  getActiveSync() {
    return this.views[this.views.length - 1];
  }
  canGoBackSync(e = this.getActiveSync()) {
    return !!(e && this.getPreviousSync(e));
  }
  getPreviousSync(e = this.getActiveSync()) {
    if (!e)
      return;
    const r = this.views, o = r.indexOf(e);
    return o > 0 ? r[o - 1] : void 0;
  }
  /**
   * Adds a navigation stack change to the queue and schedules it to run.
   *
   * @returns Whether the transition succeeds.
   */
  async queueTrns(e, r) {
    var o, a;
    if (this.isTransitioning && (!((o = e.opts) === null || o === void 0) && o.skipIfBusy))
      return !1;
    const c = new Promise((u, d) => {
      e.resolve = u, e.reject = d;
    });
    if (e.done = r, e.opts && e.opts.updateURL !== !1 && this.useRouter) {
      const u = document.querySelector("ion-router");
      if (u) {
        const d = await u.canTransition();
        if (d === !1)
          return !1;
        if (typeof d == "string")
          return u.push(d, e.opts.direction || "back"), !1;
      }
    }
    return ((a = e.insertViews) === null || a === void 0 ? void 0 : a.length) === 0 && (e.insertViews = void 0), this.transInstr.push(e), this.nextTrns(), c;
  }
  success(e, r) {
    if (this.destroyed) {
      this.fireError("nav controller was destroyed", r);
      return;
    }
    if (r.done && r.done(e.hasCompleted, e.requiresTransition, e.enteringView, e.leavingView, e.direction), r.resolve(e.hasCompleted), r.opts.updateURL !== !1 && this.useRouter) {
      const o = document.querySelector("ion-router");
      if (o) {
        const a = e.direction === "back" ? "back" : "forward";
        o.navChanged(a);
      }
    }
  }
  failed(e, r) {
    if (this.destroyed) {
      this.fireError("nav controller was destroyed", r);
      return;
    }
    this.transInstr.length = 0, this.fireError(e, r);
  }
  fireError(e, r) {
    r.done && r.done(!1, !1, e), r.reject && !this.destroyed ? r.reject(e) : r.resolve(!1);
  }
  /**
   * Consumes the next transition in the queue.
   *
   * @returns whether the transition is executed.
   */
  nextTrns() {
    if (this.isTransitioning)
      return !1;
    const e = this.transInstr.shift();
    return e ? (this.runTransition(e), !0) : !1;
  }
  /** Executes all the transition instruction from the queue. */
  async runTransition(e) {
    try {
      this.ionNavWillChange.emit(), this.isTransitioning = !0, this.prepareTI(e);
      const r = this.getActiveSync(), o = this.getEnteringView(e, r);
      if (!r && !o)
        throw new Error("no views in the stack to be removed");
      o && o.state === VIEW_STATE_NEW && await o.init(this.el), this.postViewInit(o, r, e);
      const a = (e.enteringRequiresTransition || e.leavingRequiresTransition) && o !== r;
      a && e.opts && r && (e.opts.direction === "back" && (e.opts.animationBuilder = e.opts.animationBuilder || (o == null ? void 0 : o.animationBuilder)), r.animationBuilder = e.opts.animationBuilder);
      let c;
      a ? c = await this.transition(o, r, e) : c = {
        hasCompleted: !0,
        requiresTransition: !1
      }, this.success(c, e), this.ionNavDidChange.emit();
    } catch (r) {
      this.failed(r, e);
    }
    this.isTransitioning = !1, this.nextTrns();
  }
  prepareTI(e) {
    var r, o, a;
    const c = this.views.length;
    if ((r = e.opts) !== null && r !== void 0 || (e.opts = {}), (o = (a = e.opts).delegate) !== null && o !== void 0 || (a.delegate = this.delegate), e.removeView !== void 0) {
      assert(e.removeStart !== void 0, "removeView needs removeStart"), assert(e.removeCount !== void 0, "removeView needs removeCount");
      const p = this.views.indexOf(e.removeView);
      if (p < 0)
        throw new Error("removeView was not found");
      e.removeStart += p;
    }
    e.removeStart !== void 0 && (e.removeStart < 0 && (e.removeStart = c - 1), e.removeCount < 0 && (e.removeCount = c - e.removeStart), e.leavingRequiresTransition = e.removeCount > 0 && e.removeStart + e.removeCount === c), e.insertViews && ((e.insertStart < 0 || e.insertStart > c) && (e.insertStart = c), e.enteringRequiresTransition = e.insertStart === c);
    const u = e.insertViews;
    if (!u)
      return;
    assert(u.length > 0, "length can not be zero");
    const d = convertToViews(u);
    if (d.length === 0)
      throw new Error("invalid views to insert");
    for (const p of d) {
      p.delegate = e.opts.delegate;
      const g = p.nav;
      if (g && g !== this)
        throw new Error("inserted view was already inserted");
      if (p.state === VIEW_STATE_DESTROYED)
        throw new Error("inserted view was already destroyed");
    }
    e.insertViews = d;
  }
  /**
   * Returns the view that will be entered considering the transition instructions.
   *
   * @param ti The instructions.
   * @param leavingView The view being left or undefined if none.
   *
   * @returns The view that will be entered, undefined if none.
   */
  getEnteringView(e, r) {
    const o = e.insertViews;
    if (o !== void 0)
      return o[o.length - 1];
    const a = e.removeStart;
    if (a !== void 0) {
      const c = this.views, u = a + e.removeCount;
      for (let d = c.length - 1; d >= 0; d--) {
        const p = c[d];
        if ((d < a || d >= u) && p !== r)
          return p;
      }
    }
  }
  /**
   * Adds and Removes the views from the navigation stack.
   *
   * @param enteringView The view being entered.
   * @param leavingView The view being left.
   * @param ti The instructions.
   */
  postViewInit(e, r, o) {
    var a, c, u;
    assert(r || e, "Both leavingView and enteringView are null"), assert(o.resolve, "resolve must be valid"), assert(o.reject, "reject must be valid");
    const d = o.opts, { insertViews: p, removeStart: g, removeCount: b } = o;
    let x;
    if (g !== void 0 && b !== void 0) {
      assert(g >= 0, "removeStart can not be negative"), assert(b >= 0, "removeCount can not be negative"), x = [];
      for (let y = g; y < g + b; y++) {
        const I = this.views[y];
        I !== void 0 && I !== e && I !== r && x.push(I);
      }
      (a = d.direction) !== null && a !== void 0 || (d.direction = "back");
    }
    const w = this.views.length + ((c = p == null ? void 0 : p.length) !== null && c !== void 0 ? c : 0) - (b ?? 0);
    if (assert(w >= 0, "final balance can not be negative"), w === 0)
      throw console.warn("You can't remove all the pages in the navigation stack. nav.pop() is probably called too many times.", this, this.el), new Error("navigation stack needs at least one root page");
    if (p) {
      let y = o.insertStart;
      for (const I of p)
        this.insertViewAt(I, y), y++;
      o.enteringRequiresTransition && ((u = d.direction) !== null && u !== void 0 || (d.direction = "forward"));
    }
    if (x && x.length > 0) {
      for (const y of x)
        lifecycle(y.element, LIFECYCLE_WILL_LEAVE), lifecycle(y.element, LIFECYCLE_DID_LEAVE), lifecycle(y.element, LIFECYCLE_WILL_UNLOAD);
      for (const y of x)
        this.destroyView(y);
    }
  }
  async transition(e, r, o) {
    const a = o.opts, c = a.progressAnimation ? (x) => {
      x !== void 0 && !this.gestureOrAnimationInProgress ? (this.gestureOrAnimationInProgress = !0, x.onFinish(() => {
        this.gestureOrAnimationInProgress = !1;
      }, { oneTimeCallback: !0 }), x.progressEnd(0, 0, 0)) : this.sbAni = x;
    } : void 0, u = getIonMode$2(this), d = e.element, p = r && r.element, g = Object.assign(Object.assign({
      mode: u,
      showGoBack: this.canGoBackSync(e),
      baseEl: this.el,
      progressCallback: c,
      animated: this.animated && config$1.getBoolean("animated", !0),
      enteringEl: d,
      leavingEl: p
    }, a), { animationBuilder: a.animationBuilder || this.animation || config$1.get("navAnimation") }), { hasCompleted: b } = await transition(g);
    return this.transitionFinish(b, e, r, a);
  }
  transitionFinish(e, r, o, a) {
    const c = e ? r : o;
    return c && this.unmountInactiveViews(c), {
      hasCompleted: e,
      requiresTransition: !0,
      enteringView: r,
      leavingView: o,
      direction: a.direction
    };
  }
  /**
   * Inserts a view at the specified index.
   *
   * When the view already is in the stack it will be moved to the new position.
   *
   * @param view The view to insert.
   * @param index The index where to insert the view.
   */
  insertViewAt(e, r) {
    const o = this.views, a = o.indexOf(e);
    a > -1 ? (assert(e.nav === this, "view is not part of the nav"), o.splice(a, 1), o.splice(r, 0, e)) : (assert(!e.nav, "nav is used"), e.nav = this, o.splice(r, 0, e));
  }
  /**
   * Removes a view from the stack.
   *
   * @param view The view to remove.
   */
  removeView(e) {
    assert(e.state === VIEW_STATE_ATTACHED || e.state === VIEW_STATE_DESTROYED, "view state should be loaded or destroyed");
    const r = this.views, o = r.indexOf(e);
    assert(o > -1, "view must be part of the stack"), o >= 0 && r.splice(o, 1);
  }
  destroyView(e) {
    e._destroy(), this.removeView(e);
  }
  /**
   * Unmounts all inactive views after the specified active view.
   *
   * DOM WRITE
   *
   * @param activeView The view that is actively visible in the stack. Used to calculate which views to unmount.
   */
  unmountInactiveViews(e) {
    if (this.destroyed)
      return;
    const r = this.views, o = r.indexOf(e);
    for (let a = r.length - 1; a >= 0; a--) {
      const c = r[a], u = c.element;
      u && (a > o ? (lifecycle(u, LIFECYCLE_WILL_UNLOAD), this.destroyView(c)) : a < o && setPageHidden(u, !0));
    }
  }
  canStart() {
    return !this.gestureOrAnimationInProgress && !!this.swipeGesture && !this.isTransitioning && this.transInstr.length === 0 && this.canGoBackSync();
  }
  onStart() {
    this.gestureOrAnimationInProgress = !0, this.pop({ direction: "back", progressAnimation: !0 });
  }
  onMove(e) {
    this.sbAni && this.sbAni.progressStep(e);
  }
  onEnd(e, r, o) {
    if (this.sbAni) {
      this.sbAni.onFinish(() => {
        this.gestureOrAnimationInProgress = !1;
      }, { oneTimeCallback: !0 });
      let a = e ? -1e-3 : 1e-3;
      e ? a += getTimeGivenProgression([0, 0], [0.32, 0.72], [0, 1], [1, 1], r)[0] : (this.sbAni.easing("cubic-bezier(1, 0, 0.68, 0.28)"), a += getTimeGivenProgression([0, 0], [1, 0], [0.68, 0.28], [1, 1], r)[0]), this.sbAni.progressEnd(e ? 1 : 0, a, o);
    } else
      this.gestureOrAnimationInProgress = !1;
  }
  render() {
    return h("slot", null);
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      swipeGesture: ["swipeGestureChanged"],
      root: ["rootChanged"]
    };
  }
  static get style() {
    return navCss;
  }
}, [1, "ion-nav", {
  delegate: [16],
  swipeGesture: [1028, "swipe-gesture"],
  animated: [4],
  animation: [16],
  rootParams: [16],
  root: [1],
  push: [64],
  insert: [64],
  insertPages: [64],
  pop: [64],
  popTo: [64],
  popToRoot: [64],
  removeIndex: [64],
  setRoot: [64],
  setPages: [64],
  setRouteId: [64],
  getRouteId: [64],
  getActive: [64],
  getByIndex: [64],
  canGoBack: [64],
  getPrevious: [64]
}, void 0, {
  swipeGesture: ["swipeGestureChanged"],
  root: ["rootChanged"]
}]);
function defineCustomElement$1$e() {
  if (typeof customElements > "u")
    return;
  ["ion-nav"].forEach((e) => {
    switch (e) {
      case "ion-nav":
        customElements.get(e) || customElements.define(e, Nav);
        break;
    }
  });
}
const defineCustomElement$o = defineCustomElement$1$e;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$n = defineCustomElement$D;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const compareOptions = (t, e, r) => typeof r == "function" ? r(t, e) : typeof r == "string" ? t[r] === e[r] : Array.isArray(e) ? e.includes(t) : t === e, isOptionSelected = (t, e, r) => t === void 0 ? !1 : Array.isArray(t) ? t.some((o) => compareOptions(o, e, r)) : compareOptions(t, e, r), radioIosCss = ':host{--inner-border-radius:50%;display:inline-block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:100%;min-height:inherit;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(:not(.legacy-radio)){cursor:pointer}:host(.radio-disabled){pointer-events:none}.radio-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;contain:layout size style}.radio-icon,.radio-inner{-webkit-box-sizing:border-box;box-sizing:border-box}:host(.legacy-radio) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-radio) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-radio) label{left:0}:host-context([dir=rtl]):host(.legacy-radio) label,:host-context([dir=rtl]).legacy-radio label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-radio:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-radio) label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}:host(:focus){outline:none}:host(.in-item:not(.legacy-radio)){width:100%;height:100%}:host([slot=start]:not(.legacy-radio)),:host([slot=end]:not(.legacy-radio)){width:auto}.radio-wrapper{display:-ms-flexbox;display:flex;position:relative;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;min-height:inherit;cursor:inherit}.label-text-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}:host(.in-item:not(.legacy-radio)) .label-text-wrapper{margin-top:10px;margin-bottom:10px}:host(.in-item.radio-label-placement-stacked) .label-text-wrapper{margin-top:10px;margin-bottom:16px}:host(.in-item.radio-label-placement-stacked) .native-wrapper{margin-bottom:10px}.label-text-wrapper-hidden{display:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}:host(.radio-justify-space-between) .radio-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.radio-justify-start) .radio-wrapper{-ms-flex-pack:start;justify-content:start}:host(.radio-justify-end) .radio-wrapper{-ms-flex-pack:end;justify-content:end}:host(.radio-alignment-start) .radio-wrapper{-ms-flex-align:start;align-items:start}:host(.radio-alignment-center) .radio-wrapper{-ms-flex-align:center;align-items:center}:host(.radio-label-placement-start) .radio-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.radio-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.radio-label-placement-end) .radio-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.radio-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.radio-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.radio-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px}:host(.radio-label-placement-stacked) .radio-wrapper{-ms-flex-direction:column;flex-direction:column}:host(.radio-label-placement-stacked) .label-text-wrapper{-webkit-transform:scale(0.75);transform:scale(0.75);margin-left:0;margin-right:0;margin-bottom:16px;max-width:calc(100% / 0.75)}:host(.radio-label-placement-stacked.radio-alignment-start) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host-context([dir=rtl]):host(.radio-label-placement-stacked.radio-alignment-start) .label-text-wrapper,:host-context([dir=rtl]).radio-label-placement-stacked.radio-alignment-start .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){:host(.radio-label-placement-stacked.radio-alignment-start:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}}:host(.radio-label-placement-stacked.radio-alignment-center) .label-text-wrapper{-webkit-transform-origin:center top;transform-origin:center top}:host-context([dir=rtl]):host(.radio-label-placement-stacked.radio-alignment-center) .label-text-wrapper,:host-context([dir=rtl]).radio-label-placement-stacked.radio-alignment-center .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}@supports selector(:dir(rtl)){:host(.radio-label-placement-stacked.radio-alignment-center:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}}:host{--color-checked:var(--ion-color-primary, #3880ff)}:host(.legacy-radio){width:0.9375rem;height:1.5rem}:host(.ion-color.radio-checked) .radio-inner{border-color:var(--ion-color-base)}.item-radio.item-ios ion-label{-webkit-margin-start:0;margin-inline-start:0}.radio-inner{width:33%;height:50%}:host(.radio-checked) .radio-inner{-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:0.125rem;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--color-checked)}:host(.radio-disabled){opacity:0.3}:host(.ion-focused) .radio-icon::after{border-radius:var(--inner-border-radius);top:-8px;display:block;position:absolute;width:36px;height:36px;background:var(--ion-color-primary-tint, #4c8dff);content:"";opacity:0.2}@supports (inset-inline-start: 0){:host(.ion-focused) .radio-icon::after{inset-inline-start:-9px}}@supports not (inset-inline-start: 0){:host(.ion-focused) .radio-icon::after{left:-9px}:host-context([dir=rtl]):host(.ion-focused) .radio-icon::after,:host-context([dir=rtl]).ion-focused .radio-icon::after{left:unset;right:unset;right:-9px}@supports selector(:dir(rtl)){:host(.ion-focused:dir(rtl)) .radio-icon::after{left:unset;right:unset;right:-9px}}}:host(.in-item.legacy-radio){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:11px;margin-inline-end:11px;margin-top:8px;margin-bottom:8px;display:block;position:static}:host(.in-item.legacy-radio[slot=start]){-webkit-margin-start:3px;margin-inline-start:3px;-webkit-margin-end:21px;margin-inline-end:21px;margin-top:8px;margin-bottom:8px}.native-wrapper .radio-icon{width:0.9375rem;height:1.5rem}', radioMdCss = ':host{--inner-border-radius:50%;display:inline-block;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:100%;min-height:inherit;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2}:host(:not(.legacy-radio)){cursor:pointer}:host(.radio-disabled){pointer-events:none}.radio-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;contain:layout size style}.radio-icon,.radio-inner{-webkit-box-sizing:border-box;box-sizing:border-box}:host(.legacy-radio) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-radio) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-radio) label{left:0}:host-context([dir=rtl]):host(.legacy-radio) label,:host-context([dir=rtl]).legacy-radio label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-radio:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-radio) label::-moz-focus-inner{border:0}input{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}:host(:focus){outline:none}:host(.in-item:not(.legacy-radio)){width:100%;height:100%}:host([slot=start]:not(.legacy-radio)),:host([slot=end]:not(.legacy-radio)){width:auto}.radio-wrapper{display:-ms-flexbox;display:flex;position:relative;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;min-height:inherit;cursor:inherit}.label-text-wrapper{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}:host(.in-item:not(.legacy-radio)) .label-text-wrapper{margin-top:10px;margin-bottom:10px}:host(.in-item.radio-label-placement-stacked) .label-text-wrapper{margin-top:10px;margin-bottom:16px}:host(.in-item.radio-label-placement-stacked) .native-wrapper{margin-bottom:10px}.label-text-wrapper-hidden{display:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}:host(.radio-justify-space-between) .radio-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.radio-justify-start) .radio-wrapper{-ms-flex-pack:start;justify-content:start}:host(.radio-justify-end) .radio-wrapper{-ms-flex-pack:end;justify-content:end}:host(.radio-alignment-start) .radio-wrapper{-ms-flex-align:start;align-items:start}:host(.radio-alignment-center) .radio-wrapper{-ms-flex-align:center;align-items:center}:host(.radio-label-placement-start) .radio-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.radio-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.radio-label-placement-end) .radio-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.radio-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.radio-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px}:host(.radio-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px}:host(.radio-label-placement-stacked) .radio-wrapper{-ms-flex-direction:column;flex-direction:column}:host(.radio-label-placement-stacked) .label-text-wrapper{-webkit-transform:scale(0.75);transform:scale(0.75);margin-left:0;margin-right:0;margin-bottom:16px;max-width:calc(100% / 0.75)}:host(.radio-label-placement-stacked.radio-alignment-start) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host-context([dir=rtl]):host(.radio-label-placement-stacked.radio-alignment-start) .label-text-wrapper,:host-context([dir=rtl]).radio-label-placement-stacked.radio-alignment-start .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}@supports selector(:dir(rtl)){:host(.radio-label-placement-stacked.radio-alignment-start:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}}:host(.radio-label-placement-stacked.radio-alignment-center) .label-text-wrapper{-webkit-transform-origin:center top;transform-origin:center top}:host-context([dir=rtl]):host(.radio-label-placement-stacked.radio-alignment-center) .label-text-wrapper,:host-context([dir=rtl]).radio-label-placement-stacked.radio-alignment-center .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}@supports selector(:dir(rtl)){:host(.radio-label-placement-stacked.radio-alignment-center:dir(rtl)) .label-text-wrapper{-webkit-transform-origin:calc(100% - center) top;transform-origin:calc(100% - center) top}}:host{--color:rgb(var(--ion-text-color-rgb, 0, 0, 0), 0.6);--color-checked:var(--ion-color-primary, #3880ff);--border-width:0.125rem;--border-style:solid;--border-radius:50%}:host(.legacy-radio){width:1.25rem;height:1.25rem}:host(.ion-color) .radio-inner{background:var(--ion-color-base)}:host(.ion-color.radio-checked) .radio-icon{border-color:var(--ion-color-base)}.radio-icon{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;border-radius:var(--border-radius);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--color)}.radio-inner{border-radius:var(--inner-border-radius);width:calc(50% + var(--border-width));height:calc(50% + var(--border-width));-webkit-transform:scale3d(0, 0, 0);transform:scale3d(0, 0, 0);-webkit-transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);background:var(--color-checked)}:host(.radio-checked) .radio-icon{border-color:var(--color-checked)}:host(.radio-checked) .radio-inner{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}:host(.legacy-radio.radio-disabled),:host(.radio-disabled) .label-text-wrapper{opacity:0.38}:host(.radio-disabled) .native-wrapper{opacity:0.63}:host(.ion-focused.legacy-radio) .radio-icon::after{top:-12px}@supports (inset-inline-start: 0){:host(.ion-focused.legacy-radio) .radio-icon::after{inset-inline-start:-12px}}@supports not (inset-inline-start: 0){:host(.ion-focused.legacy-radio) .radio-icon::after{left:-12px}:host-context([dir=rtl]):host(.ion-focused.legacy-radio) .radio-icon::after,:host-context([dir=rtl]).ion-focused.legacy-radio .radio-icon::after{left:unset;right:unset;right:-12px}@supports selector(:dir(rtl)){:host(.ion-focused.legacy-radio:dir(rtl)) .radio-icon::after{left:unset;right:unset;right:-12px}}}:host(.ion-focused) .radio-icon::after{border-radius:var(--inner-border-radius);display:block;position:absolute;width:36px;height:36px;background:var(--ion-color-primary-tint, #4c8dff);content:"";opacity:0.2}:host(.in-item.legacy-radio){margin-left:0;margin-right:0;margin-top:9px;margin-bottom:9px;display:block;position:static}:host(.in-item.legacy-radio[slot=start]){-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:36px;margin-inline-end:36px;margin-top:11px;margin-bottom:10px}.native-wrapper .radio-icon{width:1.25rem;height:1.25rem}', Radio = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionStyle = createEvent(this, "ionStyle", 7), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.inputId = `ion-rb-${radioButtonIds++}`, this.radioGroup = null, this.hasLoggedDeprecationWarning = !1, this.updateState = () => {
      if (this.radioGroup) {
        const { compareWith: e, value: r } = this.radioGroup;
        this.checked = isOptionSelected(r, this.value, e);
      }
    }, this.onClick = () => {
      const { radioGroup: e, checked: r, disabled: o } = this;
      if (!o) {
        if (this.legacyFormController.hasLegacyControl()) {
          this.checked = this.nativeInput.checked;
          return;
        }
        r && (e != null && e.allowEmptySelection) ? this.checked = !1 : this.checked = !0;
      }
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    }, this.checked = !1, this.buttonTabindex = -1, this.color = void 0, this.name = this.inputId, this.disabled = !1, this.value = void 0, this.labelPlacement = "start", this.legacy = void 0, this.justify = "space-between", this.alignment = "center";
  }
  valueChanged() {
    this.updateState();
  }
  /** @internal */
  async setFocus(e) {
    e.stopPropagation(), e.preventDefault(), this.el.focus();
  }
  /** @internal */
  async setButtonTabindex(e) {
    this.buttonTabindex = e;
  }
  connectedCallback() {
    this.legacyFormController = createLegacyFormController(this.el), this.value === void 0 && (this.value = this.inputId);
    const e = this.radioGroup = this.el.closest("ion-radio-group");
    e && (this.updateState(), addEventListener$1(e, "ionValueChange", this.updateState));
  }
  disconnectedCallback() {
    const e = this.radioGroup;
    e && (removeEventListener(e, "ionValueChange", this.updateState), this.radioGroup = null);
  }
  componentWillLoad() {
    this.emitStyle();
  }
  styleChanged() {
    this.emitStyle();
  }
  emitStyle() {
    const e = {
      "interactive-disabled": this.disabled,
      // TODO(FW-3125): remove this
      legacy: !!this.legacy
    };
    this.legacyFormController.hasLegacyControl() && (e["radio-checked"] = this.checked), this.ionStyle.emit(e);
  }
  get hasLabel() {
    return this.el.textContent !== "";
  }
  renderRadioControl() {
    return h("div", { class: "radio-icon", part: "container" }, h("div", { class: "radio-inner", part: "mark" }), h("div", { class: "radio-ripple" }));
  }
  render() {
    const { legacyFormController: e } = this;
    return e.hasLegacyControl() ? this.renderLegacyRadio() : this.renderRadio();
  }
  renderRadio() {
    const { checked: e, disabled: r, color: o, el: a, justify: c, labelPlacement: u, hasLabel: d, buttonTabindex: p, alignment: g } = this, b = getIonMode$2(this), x = hostContext("ion-item", a);
    return h(Host, { onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.onClick, class: createColorClasses$1(o, {
      [b]: !0,
      "in-item": x,
      "radio-checked": e,
      "radio-disabled": r,
      [`radio-justify-${c}`]: !0,
      [`radio-alignment-${g}`]: !0,
      [`radio-label-placement-${u}`]: !0,
      // Focus and active styling should not apply when the radio is in an item
      "ion-activatable": !x,
      "ion-focusable": !x
    }), role: "radio", "aria-checked": e ? "true" : "false", "aria-disabled": r ? "true" : null, tabindex: p }, h("label", { class: "radio-wrapper" }, h("div", { class: {
      "label-text-wrapper": !0,
      "label-text-wrapper-hidden": !d
    }, part: "label" }, h("slot", null)), h("div", { class: "native-wrapper" }, this.renderRadioControl())));
  }
  renderLegacyRadio() {
    this.hasLoggedDeprecationWarning || (printIonWarning(`ion-radio now requires providing a label with either the default slot or the "aria-label" attribute. To migrate, remove any usage of "ion-label" and pass the label text to either the component or the "aria-label" attribute.

Example: <ion-radio>Option Label</ion-radio>
Example with aria-label: <ion-radio aria-label="Option Label"></ion-radio>

Developers can use the "legacy" property to continue using the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.`, this.el), this.legacy && printIonWarning(`ion-radio is being used with the "legacy" property enabled which will forcibly enable the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.

Developers can dismiss this warning by removing their usage of the "legacy" property and using the new radio syntax.`, this.el), this.hasLoggedDeprecationWarning = !0);
    const { inputId: e, disabled: r, checked: o, color: a, el: c, buttonTabindex: u } = this, d = getIonMode$2(this), { label: p, labelId: g, labelText: b } = getAriaLabel(c, e);
    return h(Host, { "aria-checked": `${o}`, "aria-hidden": r ? "true" : null, "aria-labelledby": p ? g : null, role: "radio", tabindex: u, onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.onClick, class: createColorClasses$1(a, {
      [d]: !0,
      "in-item": hostContext("ion-item", c),
      interactive: !0,
      "radio-checked": o,
      "radio-disabled": r,
      "legacy-radio": !0
    }) }, this.renderRadioControl(), h("label", { htmlFor: e }, b), h("input", { type: "radio", checked: o, disabled: r, tabindex: "-1", id: e, ref: (x) => this.nativeInput = x }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      value: ["valueChanged"],
      checked: ["styleChanged"],
      color: ["styleChanged"],
      disabled: ["styleChanged"]
    };
  }
  static get style() {
    return {
      ios: radioIosCss,
      md: radioMdCss
    };
  }
}, [33, "ion-radio", {
  color: [513],
  name: [1],
  disabled: [4],
  value: [8],
  labelPlacement: [1, "label-placement"],
  legacy: [4],
  justify: [1],
  alignment: [1],
  checked: [32],
  buttonTabindex: [32],
  setFocus: [64],
  setButtonTabindex: [64]
}, void 0, {
  value: ["valueChanged"],
  checked: ["styleChanged"],
  color: ["styleChanged"],
  disabled: ["styleChanged"]
}]);
let radioButtonIds = 0;
function defineCustomElement$m() {
  if (typeof customElements > "u")
    return;
  ["ion-radio"].forEach((e) => {
    switch (e) {
      case "ion-radio":
        customElements.get(e) || customElements.define(e, Radio);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$l = defineCustomElement$m;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const RadioGroup = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.ionChange = createEvent(this, "ionChange", 7), this.ionValueChange = createEvent(this, "ionValueChange", 7), this.inputId = `ion-rg-${radioGroupIds++}`, this.labelId = `${this.inputId}-lbl`, this.setRadioTabindex = (e) => {
      const r = this.getRadios(), o = r.find((u) => !u.disabled), a = r.find((u) => u.value === e && !u.disabled);
      if (!o && !a)
        return;
      const c = a || o;
      for (const u of r) {
        const d = u === c ? 0 : -1;
        u.setButtonTabindex(d);
      }
    }, this.onClick = (e) => {
      e.preventDefault();
      const r = e.target && e.target.closest("ion-radio");
      if (r && !r.disabled) {
        const o = this.value, a = r.value;
        a !== o ? (this.value = a, this.emitValueChange(e)) : this.allowEmptySelection && (this.value = void 0, this.emitValueChange(e));
      }
    }, this.allowEmptySelection = !1, this.compareWith = void 0, this.name = this.inputId, this.value = void 0;
  }
  valueChanged(e) {
    this.setRadioTabindex(e), this.ionValueChange.emit({ value: e });
  }
  componentDidLoad() {
    this.valueChanged(this.value);
  }
  async connectedCallback() {
    const e = this.el.querySelector("ion-list-header") || this.el.querySelector("ion-item-divider");
    if (e) {
      const r = this.label = e.querySelector("ion-label");
      r && (this.labelId = r.id = this.name + "-lbl");
    }
  }
  getRadios() {
    return Array.from(this.el.querySelectorAll("ion-radio"));
  }
  /**
   * Emits an `ionChange` event.
   *
   * This API should be called for user committed changes.
   * This API should not be used for external value changes.
   */
  emitValueChange(e) {
    const { value: r } = this;
    this.ionChange.emit({ value: r, event: e });
  }
  onKeydown(e) {
    const r = !!this.el.closest("ion-select-popover");
    if (e.target && !this.el.contains(e.target))
      return;
    const o = this.getRadios().filter((a) => !a.disabled);
    if (e.target && o.includes(e.target)) {
      const a = o.findIndex((d) => d === e.target), c = o[a];
      let u;
      if (["ArrowDown", "ArrowRight"].includes(e.key) && (u = a === o.length - 1 ? o[0] : o[a + 1]), ["ArrowUp", "ArrowLeft"].includes(e.key) && (u = a === 0 ? o[o.length - 1] : o[a - 1]), u && o.includes(u) && (u.setFocus(e), r || (this.value = u.value, this.emitValueChange(e))), [" "].includes(e.key)) {
        const d = this.value;
        this.value = this.allowEmptySelection && this.value !== void 0 ? void 0 : c.value, (d !== this.value || this.allowEmptySelection) && this.emitValueChange(e), e.preventDefault();
      }
    }
  }
  render() {
    const { label: e, labelId: r, el: o, name: a, value: c } = this, u = getIonMode$2(this);
    return renderHiddenInput(!0, o, a, c, !1), h(Host, { role: "radiogroup", "aria-labelledby": e ? r : null, onClick: this.onClick, class: u });
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      value: ["valueChanged"]
    };
  }
}, [0, "ion-radio-group", {
  allowEmptySelection: [4, "allow-empty-selection"],
  compareWith: [1, "compare-with"],
  name: [1],
  value: [1032]
}, [[4, "keydown", "onKeydown"]], {
  value: ["valueChanged"]
}]);
let radioGroupIds = 0;
function defineCustomElement$k() {
  if (typeof customElements > "u")
    return;
  ["ion-radio-group"].forEach((e) => {
    switch (e) {
      case "ion-radio-group":
        customElements.get(e) || customElements.define(e, RadioGroup);
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$j = defineCustomElement$k;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const searchbarIosCss = ".sc-ion-searchbar-ios-h{--placeholder-color:initial;--placeholder-font-style:initial;--placeholder-font-weight:initial;--placeholder-opacity:0.6;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;width:100%;color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}.ion-color.sc-ion-searchbar-ios-h{color:var(--ion-color-contrast)}.ion-color.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios{background:var(--ion-color-base)}.ion-color.sc-ion-searchbar-ios-h .searchbar-clear-button.sc-ion-searchbar-ios,.ion-color.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios,.ion-color.sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios{color:inherit}.searchbar-search-icon.sc-ion-searchbar-ios{color:var(--icon-color);pointer-events:none}.searchbar-input-container.sc-ion-searchbar-ios{display:block;position:relative;-ms-flex-negative:1;flex-shrink:1;width:100%}.searchbar-input.sc-ion-searchbar-ios{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;border-radius:var(--border-radius);display:block;width:100%;min-height:inherit;border:0;outline:none;background:var(--background);font-family:inherit;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-input.sc-ion-searchbar-ios::-webkit-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-ios::-moz-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-ios:-ms-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-ios::-ms-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-ios::placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-ios::-webkit-search-cancel-button,.searchbar-input.sc-ion-searchbar-ios::-ms-clear{display:none}.searchbar-cancel-button.sc-ion-searchbar-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:none;height:100%;border:0;outline:none;color:var(--cancel-button-color);cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-cancel-button.sc-ion-searchbar-ios>div.sc-ion-searchbar-ios{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.searchbar-clear-button.sc-ion-searchbar-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:none;min-height:0;outline:none;color:var(--clear-button-color);-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-clear-button.sc-ion-searchbar-ios:focus{opacity:0.5}.searchbar-has-value.searchbar-should-show-clear.sc-ion-searchbar-ios-h .searchbar-clear-button.sc-ion-searchbar-ios{display:block}.searchbar-disabled.sc-ion-searchbar-ios-h{cursor:default;opacity:0.4;pointer-events:none}.sc-ion-searchbar-ios-h{--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.07);--border-radius:10px;--box-shadow:none;--cancel-button-color:var(--ion-color-primary, #3880ff);--clear-button-color:var(--ion-color-step-600, #666666);--color:var(--ion-text-color, #000);--icon-color:var(--ion-color-step-600, #666666);-webkit-padding-start:12px;padding-inline-start:12px;-webkit-padding-end:12px;padding-inline-end:12px;padding-top:12px;padding-bottom:12px;min-height:60px;contain:content}.searchbar-input-container.sc-ion-searchbar-ios{min-height:36px}.searchbar-search-icon.sc-ion-searchbar-ios{-webkit-margin-start:calc(50% - 60px);margin-inline-start:calc(50% - 60px);top:0;position:absolute;width:1.375rem;height:100%;contain:strict}@supports (inset-inline-start: 0){.searchbar-search-icon.sc-ion-searchbar-ios{inset-inline-start:5px}}@supports not (inset-inline-start: 0){.searchbar-search-icon.sc-ion-searchbar-ios{left:5px}[dir=rtl].sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios,[dir=rtl] .sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios{left:unset;right:unset;right:5px}[dir=rtl].sc-ion-searchbar-ios .searchbar-search-icon.sc-ion-searchbar-ios{left:unset;right:unset;right:5px}@supports selector(:dir(rtl)){.searchbar-search-icon.sc-ion-searchbar-ios:dir(rtl){left:unset;right:unset;right:5px}}}.searchbar-input.sc-ion-searchbar-ios{-webkit-padding-start:0px;padding-inline-start:0px;-webkit-padding-end:0px;padding-inline-end:0px;padding-top:6px;padding-bottom:6px;height:100%;font-size:1.0625rem;font-weight:400;contain:strict}.searchbar-has-value.searchbar-should-show-clear.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios{-webkit-padding-start:1.75rem;padding-inline-start:1.75rem;-webkit-padding-end:1.75rem;padding-inline-end:1.75rem}.searchbar-clear-button.sc-ion-searchbar-ios{top:0;background-position:center;position:absolute;width:1.875rem;height:100%;border:0;background-color:transparent}@supports (inset-inline-start: 0){.searchbar-clear-button.sc-ion-searchbar-ios{inset-inline-end:0}}@supports not (inset-inline-start: 0){.searchbar-clear-button.sc-ion-searchbar-ios{right:0}[dir=rtl].sc-ion-searchbar-ios-h .searchbar-clear-button.sc-ion-searchbar-ios,[dir=rtl] .sc-ion-searchbar-ios-h .searchbar-clear-button.sc-ion-searchbar-ios{left:unset;right:unset;left:0}[dir=rtl].sc-ion-searchbar-ios .searchbar-clear-button.sc-ion-searchbar-ios{left:unset;right:unset;left:0}@supports selector(:dir(rtl)){.searchbar-clear-button.sc-ion-searchbar-ios:dir(rtl){left:unset;right:unset;left:0}}}.searchbar-clear-icon.sc-ion-searchbar-ios{width:1.125rem;height:100%}.searchbar-cancel-button.sc-ion-searchbar-ios{-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:0;padding-inline-end:0;padding-top:0;padding-bottom:0;-ms-flex-negative:0;flex-shrink:0;background-color:transparent;font-size:16px}.searchbar-left-aligned.sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios{-webkit-margin-start:0;margin-inline-start:0}.searchbar-left-aligned.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios{-webkit-padding-start:1.875rem;padding-inline-start:1.875rem}.searchbar-has-focus.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios,.searchbar-should-show-cancel.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios,.searchbar-animated.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios{display:block}.searchbar-animated.sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios,.searchbar-animated.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios{-webkit-transition:all 300ms ease;transition:all 300ms ease}.searchbar-animated.searchbar-has-focus.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios,.searchbar-animated.searchbar-should-show-cancel.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios{opacity:1;pointer-events:auto}.searchbar-animated.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios{-webkit-margin-end:-100%;margin-inline-end:-100%;-webkit-transform:translate3d(0,  0,  0);transform:translate3d(0,  0,  0);-webkit-transition:all 300ms ease;transition:all 300ms ease;opacity:0;pointer-events:none}.searchbar-no-animate.sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios,.searchbar-no-animate.sc-ion-searchbar-ios-h .searchbar-input.sc-ion-searchbar-ios,.searchbar-no-animate.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios{-webkit-transition-duration:0ms;transition-duration:0ms}.ion-color.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios{color:var(--ion-color-base)}@media (any-hover: hover){.ion-color.sc-ion-searchbar-ios-h .searchbar-cancel-button.sc-ion-searchbar-ios:hover{color:var(--ion-color-tint)}}ion-toolbar.sc-ion-searchbar-ios-h,ion-toolbar .sc-ion-searchbar-ios-h{padding-top:1px;padding-bottom:15px;min-height:52px}ion-toolbar.ion-color.sc-ion-searchbar-ios-h:not(.ion-color),ion-toolbar.ion-color .sc-ion-searchbar-ios-h:not(.ion-color){color:inherit}ion-toolbar.ion-color.sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-cancel-button.sc-ion-searchbar-ios,ion-toolbar.ion-color .sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-cancel-button.sc-ion-searchbar-ios{color:currentColor}ion-toolbar.ion-color.sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios,ion-toolbar.ion-color .sc-ion-searchbar-ios-h .searchbar-search-icon.sc-ion-searchbar-ios{color:currentColor;opacity:0.5}ion-toolbar.ion-color.sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-input.sc-ion-searchbar-ios,ion-toolbar.ion-color .sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-input.sc-ion-searchbar-ios{background:rgba(var(--ion-color-contrast-rgb), 0.07);color:currentColor}ion-toolbar.ion-color.sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-clear-button.sc-ion-searchbar-ios,ion-toolbar.ion-color .sc-ion-searchbar-ios-h:not(.ion-color) .searchbar-clear-button.sc-ion-searchbar-ios{color:currentColor;opacity:0.5}", searchbarMdCss = ".sc-ion-searchbar-md-h{--placeholder-color:initial;--placeholder-font-style:initial;--placeholder-font-weight:initial;--placeholder-opacity:0.6;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;width:100%;color:var(--color);font-family:var(--ion-font-family, inherit);-webkit-box-sizing:border-box;box-sizing:border-box}.ion-color.sc-ion-searchbar-md-h{color:var(--ion-color-contrast)}.ion-color.sc-ion-searchbar-md-h .searchbar-input.sc-ion-searchbar-md{background:var(--ion-color-base)}.ion-color.sc-ion-searchbar-md-h .searchbar-clear-button.sc-ion-searchbar-md,.ion-color.sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md,.ion-color.sc-ion-searchbar-md-h .searchbar-search-icon.sc-ion-searchbar-md{color:inherit}.searchbar-search-icon.sc-ion-searchbar-md{color:var(--icon-color);pointer-events:none}.searchbar-input-container.sc-ion-searchbar-md{display:block;position:relative;-ms-flex-negative:1;flex-shrink:1;width:100%}.searchbar-input.sc-ion-searchbar-md{font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;border-radius:var(--border-radius);display:block;width:100%;min-height:inherit;border:0;outline:none;background:var(--background);font-family:inherit;-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-input.sc-ion-searchbar-md::-webkit-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-md::-moz-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-md:-ms-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-md::-ms-input-placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-md::placeholder{color:var(--placeholder-color);font-family:inherit;font-style:var(--placeholder-font-style);font-weight:var(--placeholder-font-weight);opacity:var(--placeholder-opacity)}.searchbar-input.sc-ion-searchbar-md::-webkit-search-cancel-button,.searchbar-input.sc-ion-searchbar-md::-ms-clear{display:none}.searchbar-cancel-button.sc-ion-searchbar-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:none;height:100%;border:0;outline:none;color:var(--cancel-button-color);cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-cancel-button.sc-ion-searchbar-md>div.sc-ion-searchbar-md{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%}.searchbar-clear-button.sc-ion-searchbar-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:none;min-height:0;outline:none;color:var(--clear-button-color);-webkit-appearance:none;-moz-appearance:none;appearance:none}.searchbar-clear-button.sc-ion-searchbar-md:focus{opacity:0.5}.searchbar-has-value.searchbar-should-show-clear.sc-ion-searchbar-md-h .searchbar-clear-button.sc-ion-searchbar-md{display:block}.searchbar-disabled.sc-ion-searchbar-md-h{cursor:default;opacity:0.4;pointer-events:none}.sc-ion-searchbar-md-h{--background:var(--ion-background-color, #fff);--border-radius:2px;--box-shadow:0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);--cancel-button-color:var(--ion-color-step-900, #1a1a1a);--clear-button-color:initial;--color:var(--ion-color-step-850, #262626);--icon-color:var(--ion-color-step-600, #666666);-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px;padding-top:8px;padding-bottom:8px;background:inherit}.searchbar-search-icon.sc-ion-searchbar-md{top:11px;width:1.3125rem;height:1.3125rem}@supports (inset-inline-start: 0){.searchbar-search-icon.sc-ion-searchbar-md{inset-inline-start:16px}}@supports not (inset-inline-start: 0){.searchbar-search-icon.sc-ion-searchbar-md{left:16px}[dir=rtl].sc-ion-searchbar-md-h .searchbar-search-icon.sc-ion-searchbar-md,[dir=rtl] .sc-ion-searchbar-md-h .searchbar-search-icon.sc-ion-searchbar-md{left:unset;right:unset;right:16px}[dir=rtl].sc-ion-searchbar-md .searchbar-search-icon.sc-ion-searchbar-md{left:unset;right:unset;right:16px}@supports selector(:dir(rtl)){.searchbar-search-icon.sc-ion-searchbar-md:dir(rtl){left:unset;right:unset;right:16px}}}.searchbar-cancel-button.sc-ion-searchbar-md{top:0;background-color:transparent;font-size:1.5em}@supports (inset-inline-start: 0){.searchbar-cancel-button.sc-ion-searchbar-md{inset-inline-start:9px}}@supports not (inset-inline-start: 0){.searchbar-cancel-button.sc-ion-searchbar-md{left:9px}[dir=rtl].sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md,[dir=rtl] .sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md{left:unset;right:unset;right:9px}[dir=rtl].sc-ion-searchbar-md .searchbar-cancel-button.sc-ion-searchbar-md{left:unset;right:unset;right:9px}@supports selector(:dir(rtl)){.searchbar-cancel-button.sc-ion-searchbar-md:dir(rtl){left:unset;right:unset;right:9px}}}.searchbar-search-icon.sc-ion-searchbar-md,.searchbar-cancel-button.sc-ion-searchbar-md{position:absolute}.searchbar-search-icon.ion-activated.sc-ion-searchbar-md,.searchbar-cancel-button.ion-activated.sc-ion-searchbar-md{background-color:transparent}.searchbar-input.sc-ion-searchbar-md{-webkit-padding-start:3.4375rem;padding-inline-start:3.4375rem;-webkit-padding-end:3.4375rem;padding-inline-end:3.4375rem;padding-top:0.375rem;padding-bottom:0.375rem;background-position:left 8px center;height:auto;font-size:1rem;font-weight:400;line-height:30px}[dir=rtl].sc-ion-searchbar-md-h .searchbar-input.sc-ion-searchbar-md,[dir=rtl] .sc-ion-searchbar-md-h .searchbar-input.sc-ion-searchbar-md{background-position:right 8px center}[dir=rtl].sc-ion-searchbar-md .searchbar-input.sc-ion-searchbar-md{background-position:right 8px center}@supports selector(:dir(rtl)){.searchbar-input.sc-ion-searchbar-md:dir(rtl){background-position:right 8px center}}.searchbar-clear-button.sc-ion-searchbar-md{top:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;position:absolute;height:100%;border:0;background-color:transparent}@supports (inset-inline-start: 0){.searchbar-clear-button.sc-ion-searchbar-md{inset-inline-end:13px}}@supports not (inset-inline-start: 0){.searchbar-clear-button.sc-ion-searchbar-md{right:13px}[dir=rtl].sc-ion-searchbar-md-h .searchbar-clear-button.sc-ion-searchbar-md,[dir=rtl] .sc-ion-searchbar-md-h .searchbar-clear-button.sc-ion-searchbar-md{left:unset;right:unset;left:13px}[dir=rtl].sc-ion-searchbar-md .searchbar-clear-button.sc-ion-searchbar-md{left:unset;right:unset;left:13px}@supports selector(:dir(rtl)){.searchbar-clear-button.sc-ion-searchbar-md:dir(rtl){left:unset;right:unset;left:13px}}}.searchbar-clear-button.ion-activated.sc-ion-searchbar-md{background-color:transparent}.searchbar-clear-icon.sc-ion-searchbar-md{width:1.375rem;height:100%}.searchbar-has-focus.sc-ion-searchbar-md-h .searchbar-search-icon.sc-ion-searchbar-md{display:block}.searchbar-has-focus.sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md,.searchbar-should-show-cancel.sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md{display:block}.searchbar-has-focus.sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md+.searchbar-search-icon.sc-ion-searchbar-md,.searchbar-should-show-cancel.sc-ion-searchbar-md-h .searchbar-cancel-button.sc-ion-searchbar-md+.searchbar-search-icon.sc-ion-searchbar-md{display:none}ion-toolbar.sc-ion-searchbar-md-h,ion-toolbar .sc-ion-searchbar-md-h{-webkit-padding-start:7px;padding-inline-start:7px;-webkit-padding-end:7px;padding-inline-end:7px;padding-top:3px;padding-bottom:3px}", Searchbar = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.ionInput = createEvent(this, "ionInput", 7), this.ionChange = createEvent(this, "ionChange", 7), this.ionCancel = createEvent(this, "ionCancel", 7), this.ionClear = createEvent(this, "ionClear", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionStyle = createEvent(this, "ionStyle", 7), this.isCancelVisible = !1, this.shouldAlignLeft = !0, this.inputId = `ion-searchbar-${searchbarIds++}`, this.onClearInput = async (e) => (this.ionClear.emit(), new Promise((r) => {
      setTimeout(() => {
        const o = this.getValue();
        o !== "" && (this.value = "", this.emitInputChange(), e && !this.focused && (this.setFocus(), this.focusedValue = o)), r();
      }, 16 * 4);
    })), this.onCancelSearchbar = async (e) => {
      e && (e.preventDefault(), e.stopPropagation()), this.ionCancel.emit();
      const r = this.getValue(), o = this.focused;
      await this.onClearInput(), r && !o && this.emitValueChange(e), this.nativeInput && this.nativeInput.blur();
    }, this.onInput = (e) => {
      const r = e.target;
      r && (this.value = r.value), this.emitInputChange(e);
    }, this.onChange = (e) => {
      this.emitValueChange(e);
    }, this.onBlur = (e) => {
      this.focused = !1, this.ionBlur.emit(), this.positionElements(), this.focusedValue !== this.value && this.emitValueChange(e), this.focusedValue = void 0;
    }, this.onFocus = () => {
      this.focused = !0, this.focusedValue = this.value, this.ionFocus.emit(), this.positionElements();
    }, this.focused = !1, this.noAnimate = !0, this.color = void 0, this.animated = !1, this.autocomplete = "off", this.autocorrect = "off", this.cancelButtonIcon = config$1.get("backButtonIcon", arrowBackSharp), this.cancelButtonText = "Cancel", this.clearIcon = void 0, this.debounce = void 0, this.disabled = !1, this.inputmode = void 0, this.enterkeyhint = void 0, this.name = this.inputId, this.placeholder = "Search", this.searchIcon = void 0, this.showCancelButton = "never", this.showClearButton = "always", this.spellcheck = !1, this.type = "search", this.value = "";
  }
  debounceChanged() {
    const { ionInput: e, debounce: r, originalIonInput: o } = this;
    this.ionInput = r === void 0 ? o ?? e : debounceEvent(e, r);
  }
  valueChanged() {
    const e = this.nativeInput, r = this.getValue();
    e && e.value !== r && (e.value = r);
  }
  showCancelButtonChanged() {
    requestAnimationFrame(() => {
      this.positionElements(), forceUpdate(this);
    });
  }
  connectedCallback() {
    this.emitStyle();
  }
  componentDidLoad() {
    this.originalIonInput = this.ionInput, this.positionElements(), this.debounceChanged(), setTimeout(() => {
      this.noAnimate = !1;
    }, 300);
  }
  emitStyle() {
    this.ionStyle.emit({
      searchbar: !0
    });
  }
  /**
   * Sets focus on the native `input` in `ion-searchbar`. Use this method instead of the global
   * `input.focus()`.
   *
   * Developers who wish to focus an input when a page enters
   * should call `setFocus()` in the `ionViewDidEnter()` lifecycle method.
   *
   * Developers who wish to focus an input when an overlay is presented
   * should call `setFocus` after `didPresent` has resolved.
   *
   * See [managing focus](/docs/developing/managing-focus) for more information.
   */
  async setFocus() {
    this.nativeInput && this.nativeInput.focus();
  }
  /**
   * Returns the native `<input>` element used under the hood.
   */
  async getInputElement() {
    return this.nativeInput || await new Promise((e) => componentOnReady(this.el, e)), Promise.resolve(this.nativeInput);
  }
  /**
   * Emits an `ionChange` event.
   *
   * This API should be called for user committed changes.
   * This API should not be used for external value changes.
   */
  emitValueChange(e) {
    const { value: r } = this, o = r == null ? r : r.toString();
    this.focusedValue = o, this.ionChange.emit({ value: o, event: e });
  }
  /**
   * Emits an `ionInput` event.
   */
  emitInputChange(e) {
    const { value: r } = this;
    this.ionInput.emit({ value: r, event: e });
  }
  /**
   * Positions the input search icon, placeholder, and the cancel button
   * based on the input value and if it is focused. (ios only)
   */
  positionElements() {
    const e = this.getValue(), r = this.shouldAlignLeft, o = getIonMode$2(this), a = !this.animated || e.trim() !== "" || !!this.focused;
    this.shouldAlignLeft = a, o === "ios" && (r !== a && this.positionPlaceholder(), this.animated && this.positionCancelButton());
  }
  /**
   * Positions the input placeholder
   */
  positionPlaceholder() {
    const e = this.nativeInput;
    if (!e)
      return;
    const r = isRTL$1(this.el), o = (this.el.shadowRoot || this.el).querySelector(".searchbar-search-icon");
    if (this.shouldAlignLeft)
      e.removeAttribute("style"), o.removeAttribute("style");
    else {
      const a = document, c = a.createElement("span");
      c.innerText = this.placeholder || "", a.body.appendChild(c), raf(() => {
        const u = c.offsetWidth;
        c.remove();
        const d = "calc(50% - " + u / 2 + "px)", p = "calc(50% - " + (u / 2 + o.clientWidth + 8) + "px)";
        r ? (e.style.paddingRight = d, o.style.marginRight = p) : (e.style.paddingLeft = d, o.style.marginLeft = p);
      });
    }
  }
  /**
   * Show the iOS Cancel button on focus, hide it offscreen otherwise
   */
  positionCancelButton() {
    const e = isRTL$1(this.el), r = (this.el.shadowRoot || this.el).querySelector(".searchbar-cancel-button"), o = this.shouldShowCancelButton();
    if (r !== null && o !== this.isCancelVisible) {
      const a = r.style;
      if (this.isCancelVisible = o, o)
        e ? a.marginLeft = "0" : a.marginRight = "0";
      else {
        const c = r.offsetWidth;
        c > 0 && (e ? a.marginLeft = -c + "px" : a.marginRight = -c + "px");
      }
    }
  }
  getValue() {
    return this.value || "";
  }
  hasValue() {
    return this.getValue() !== "";
  }
  /**
   * Determines whether or not the cancel button should be visible onscreen.
   * Cancel button should be shown if one of two conditions applies:
   * 1. `showCancelButton` is set to `always`.
   * 2. `showCancelButton` is set to `focus`, and the searchbar has been focused.
   */
  shouldShowCancelButton() {
    return !(this.showCancelButton === "never" || this.showCancelButton === "focus" && !this.focused);
  }
  /**
   * Determines whether or not the clear button should be visible onscreen.
   * Clear button should be shown if one of two conditions applies:
   * 1. `showClearButton` is set to `always`.
   * 2. `showClearButton` is set to `focus`, and the searchbar has been focused.
   */
  shouldShowClearButton() {
    return !(this.showClearButton === "never" || this.showClearButton === "focus" && !this.focused);
  }
  render() {
    const { cancelButtonText: e } = this, r = this.animated && config$1.getBoolean("animated", !0), o = getIonMode$2(this), a = this.clearIcon || (o === "ios" ? closeCircle : closeSharp), c = this.searchIcon || (o === "ios" ? searchOutline$1 : searchSharp), u = this.shouldShowCancelButton(), d = this.showCancelButton !== "never" && h("button", { "aria-label": e, "aria-hidden": u ? void 0 : "true", type: "button", tabIndex: o === "ios" && !u ? -1 : void 0, onMouseDown: this.onCancelSearchbar, onTouchStart: this.onCancelSearchbar, class: "searchbar-cancel-button" }, h("div", { "aria-hidden": "true" }, o === "md" ? h("ion-icon", { "aria-hidden": "true", mode: o, icon: this.cancelButtonIcon, lazy: !1 }) : e));
    return h(Host, { role: "search", "aria-disabled": this.disabled ? "true" : null, class: createColorClasses$1(this.color, {
      [o]: !0,
      "searchbar-animated": r,
      "searchbar-disabled": this.disabled,
      "searchbar-no-animate": r && this.noAnimate,
      "searchbar-has-value": this.hasValue(),
      "searchbar-left-aligned": this.shouldAlignLeft,
      "searchbar-has-focus": this.focused,
      "searchbar-should-show-clear": this.shouldShowClearButton(),
      "searchbar-should-show-cancel": this.shouldShowCancelButton()
    }) }, h("div", { class: "searchbar-input-container" }, h("input", { "aria-label": "search text", disabled: this.disabled, ref: (p) => this.nativeInput = p, class: "searchbar-input", inputMode: this.inputmode, enterKeyHint: this.enterkeyhint, name: this.name, onInput: this.onInput, onChange: this.onChange, onBlur: this.onBlur, onFocus: this.onFocus, placeholder: this.placeholder, type: this.type, value: this.getValue(), autoComplete: this.autocomplete, autoCorrect: this.autocorrect, spellcheck: this.spellcheck }), o === "md" && d, h("ion-icon", { "aria-hidden": "true", mode: o, icon: c, lazy: !1, class: "searchbar-search-icon" }), h("button", { "aria-label": "reset", type: "button", "no-blur": !0, class: "searchbar-clear-button", onPointerDown: (p) => {
      p.preventDefault();
    }, onClick: () => this.onClearInput(!0) }, h("ion-icon", { "aria-hidden": "true", mode: o, icon: a, lazy: !1, class: "searchbar-clear-icon" }))), o === "ios" && d);
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      debounce: ["debounceChanged"],
      value: ["valueChanged"],
      showCancelButton: ["showCancelButtonChanged"]
    };
  }
  static get style() {
    return {
      ios: searchbarIosCss,
      md: searchbarMdCss
    };
  }
}, [34, "ion-searchbar", {
  color: [513],
  animated: [4],
  autocomplete: [1],
  autocorrect: [1],
  cancelButtonIcon: [1, "cancel-button-icon"],
  cancelButtonText: [1, "cancel-button-text"],
  clearIcon: [1, "clear-icon"],
  debounce: [2],
  disabled: [4],
  inputmode: [1],
  enterkeyhint: [1],
  name: [1],
  placeholder: [1],
  searchIcon: [1, "search-icon"],
  showCancelButton: [1, "show-cancel-button"],
  showClearButton: [1, "show-clear-button"],
  spellcheck: [4],
  type: [1],
  value: [1025],
  focused: [32],
  noAnimate: [32],
  setFocus: [64],
  getInputElement: [64]
}, void 0, {
  debounce: ["debounceChanged"],
  value: ["valueChanged"],
  showCancelButton: ["showCancelButtonChanged"]
}]);
let searchbarIds = 0;
function defineCustomElement$1$d() {
  if (typeof customElements > "u")
    return;
  ["ion-searchbar", "ion-icon"].forEach((e) => {
    switch (e) {
      case "ion-searchbar":
        customElements.get(e) || customElements.define(e, Searchbar);
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
    }
  });
}
const defineCustomElement$i = defineCustomElement$1$d;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const segmentIosCss = ":host{--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:grid;grid-auto-columns:1fr;position:relative;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:center;justify-content:center;width:100%;background:var(--background);font-family:var(--ion-font-family, inherit);text-align:center;contain:paint;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host(.segment-scrollable){-ms-flex-pack:start;justify-content:start;width:auto;overflow-x:auto;grid-auto-columns:minmax(-webkit-min-content, 1fr);grid-auto-columns:minmax(min-content, 1fr)}:host(.segment-scrollable::-webkit-scrollbar){display:none}:host{--background:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.065);border-radius:8px;overflow:hidden;z-index:0}:host(.ion-color){background:rgba(var(--ion-color-base-rgb), 0.065)}:host(.in-toolbar){-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:0;margin-bottom:0;width:auto}:host(.in-toolbar:not(.ion-color)){background:var(--ion-toolbar-segment-background, var(--background))}:host(.in-toolbar-color:not(.ion-color)){background:rgba(var(--ion-color-contrast-rgb), 0.11)}", segmentMdCss = ":host{--ripple-color:currentColor;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:grid;grid-auto-columns:1fr;position:relative;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:center;justify-content:center;width:100%;background:var(--background);font-family:var(--ion-font-family, inherit);text-align:center;contain:paint;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host(.segment-scrollable){-ms-flex-pack:start;justify-content:start;width:auto;overflow-x:auto;grid-auto-columns:minmax(-webkit-min-content, 1fr);grid-auto-columns:minmax(min-content, 1fr)}:host(.segment-scrollable::-webkit-scrollbar){display:none}:host{--background:transparent;grid-auto-columns:minmax(auto, 360px)}:host(.in-toolbar){min-height:var(--min-height)}:host(.segment-scrollable) ::slotted(ion-segment-button){min-width:auto}", Segment = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionChange = createEvent(this, "ionChange", 7), this.ionSelect = createEvent(this, "ionSelect", 7), this.ionStyle = createEvent(this, "ionStyle", 7), this.onClick = (e) => {
      const r = e.target, o = this.checked;
      r.tagName !== "ION-SEGMENT" && (this.value = r.value, r !== o && this.emitValueChange(), (this.scrollable || !this.swipeGesture) && (o ? this.checkButton(o, r) : this.setCheckedClasses()));
    }, this.getSegmentButton = (e) => {
      var r, o;
      const a = this.getButtons().filter((u) => !u.disabled), c = a.findIndex((u) => u === document.activeElement);
      switch (e) {
        case "first":
          return a[0];
        case "last":
          return a[a.length - 1];
        case "next":
          return (r = a[c + 1]) !== null && r !== void 0 ? r : a[0];
        case "previous":
          return (o = a[c - 1]) !== null && o !== void 0 ? o : a[a.length - 1];
        default:
          return null;
      }
    }, this.activated = !1, this.color = void 0, this.disabled = !1, this.scrollable = !1, this.swipeGesture = !0, this.value = void 0, this.selectOnFocus = !1;
  }
  colorChanged(e, r) {
    (r === void 0 && e !== void 0 || r !== void 0 && e === void 0) && this.emitStyle();
  }
  swipeGestureChanged() {
    this.gestureChanged();
  }
  valueChanged(e) {
    this.ionSelect.emit({ value: e }), this.scrollActiveButtonIntoView();
  }
  disabledChanged() {
    this.gestureChanged();
    const e = this.getButtons();
    for (const r of e)
      r.disabled = this.disabled;
  }
  gestureChanged() {
    this.gesture && this.gesture.enable(!this.scrollable && !this.disabled && this.swipeGesture);
  }
  connectedCallback() {
    this.emitStyle();
  }
  componentWillLoad() {
    this.emitStyle();
  }
  async componentDidLoad() {
    this.setCheckedClasses(), raf(() => {
      this.scrollActiveButtonIntoView(!1);
    }), this.gesture = (await Promise.resolve().then(() => index3)).createGesture({
      el: this.el,
      gestureName: "segment",
      gesturePriority: 100,
      threshold: 0,
      passive: !1,
      onStart: (e) => this.onStart(e),
      onMove: (e) => this.onMove(e),
      onEnd: (e) => this.onEnd(e)
    }), this.gestureChanged(), this.disabled && this.disabledChanged();
  }
  onStart(e) {
    this.valueBeforeGesture = this.value, this.activate(e);
  }
  onMove(e) {
    this.setNextIndex(e);
  }
  onEnd(e) {
    this.setActivated(!1), this.setNextIndex(e, !0), e.event.stopImmediatePropagation();
    const r = this.value;
    r !== void 0 && this.valueBeforeGesture !== r && this.emitValueChange(), this.valueBeforeGesture = void 0;
  }
  /**
   * Emits an `ionChange` event.
   *
   * This API should be called for user committed changes.
   * This API should not be used for external value changes.
   */
  emitValueChange() {
    const { value: e } = this;
    this.ionChange.emit({ value: e });
  }
  getButtons() {
    return Array.from(this.el.querySelectorAll("ion-segment-button"));
  }
  get checked() {
    return this.getButtons().find((e) => e.value === this.value);
  }
  /*
   * Activate both the segment and the buttons
   * due to a bug with ::slotted in Safari
   */
  setActivated(e) {
    this.getButtons().forEach((o) => {
      e ? o.classList.add("segment-button-activated") : o.classList.remove("segment-button-activated");
    }), this.activated = e;
  }
  activate(e) {
    const r = e.event.target, a = this.getButtons().find((c) => c.value === this.value);
    r.tagName === "ION-SEGMENT-BUTTON" && (a || (this.value = r.value, this.setCheckedClasses()), this.value === r.value && this.setActivated(!0));
  }
  getIndicator(e) {
    return (e.shadowRoot || e).querySelector(".segment-button-indicator");
  }
  checkButton(e, r) {
    const o = this.getIndicator(e), a = this.getIndicator(r);
    if (o === null || a === null)
      return;
    const c = o.getBoundingClientRect(), u = a.getBoundingClientRect(), d = c.width / u.width, g = `translate3d(${c.left - u.left}px, 0, 0) scaleX(${d})`;
    writeTask(() => {
      a.classList.remove("segment-button-indicator-animated"), a.style.setProperty("transform", g), a.getBoundingClientRect(), a.classList.add("segment-button-indicator-animated"), a.style.setProperty("transform", "");
    }), this.value = r.value, this.setCheckedClasses();
  }
  setCheckedClasses() {
    const e = this.getButtons(), o = e.findIndex((a) => a.value === this.value) + 1;
    for (const a of e)
      a.classList.remove("segment-button-after-checked");
    o < e.length && e[o].classList.add("segment-button-after-checked");
  }
  scrollActiveButtonIntoView(e = !0) {
    const { scrollable: r, value: o, el: a } = this;
    if (r) {
      const u = this.getButtons().find((d) => d.value === o);
      if (u !== void 0) {
        const d = a.getBoundingClientRect(), p = u.getBoundingClientRect(), b = p.x - d.x - d.width / 2 + p.width / 2;
        a.scrollBy({
          top: 0,
          left: b,
          behavior: e ? "smooth" : "instant"
        });
      }
    }
  }
  setNextIndex(e, r = !1) {
    const o = isRTL$1(this.el), a = this.activated, c = this.getButtons(), u = c.findIndex((D) => D.value === this.value), d = c[u];
    let p, g;
    if (u === -1)
      return;
    const b = d.getBoundingClientRect(), x = b.left, w = b.width, y = e.currentX, I = b.top + b.height / 2, T = this.el.getRootNode().elementFromPoint(y, I), C = o ? y > x + w : y < x, $ = o ? y < x : y > x + w;
    if (a && !r) {
      if (C) {
        const D = u - 1;
        D >= 0 && (g = D);
      } else if ($ && a && !r) {
        const D = u + 1;
        D < c.length && (g = D);
      }
      g !== void 0 && !c[g].disabled && (p = c[g]);
    }
    if (!a && r && (p = T), p != null) {
      if (p.tagName === "ION-SEGMENT")
        return !1;
      d !== p && this.checkButton(d, p);
    }
    return !0;
  }
  emitStyle() {
    this.ionStyle.emit({
      segment: !0
    });
  }
  onKeyDown(e) {
    const r = isRTL$1(this.el);
    let o = this.selectOnFocus, a;
    switch (e.key) {
      case "ArrowRight":
        e.preventDefault(), a = r ? this.getSegmentButton("previous") : this.getSegmentButton("next");
        break;
      case "ArrowLeft":
        e.preventDefault(), a = r ? this.getSegmentButton("next") : this.getSegmentButton("previous");
        break;
      case "Home":
        e.preventDefault(), a = this.getSegmentButton("first");
        break;
      case "End":
        e.preventDefault(), a = this.getSegmentButton("last");
        break;
      case " ":
      case "Enter":
        e.preventDefault(), a = document.activeElement, o = !0;
    }
    if (a) {
      if (o) {
        const c = this.checked;
        this.checkButton(c || a, a), a !== c && this.emitValueChange();
      }
      a.setFocus();
    }
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { role: "tablist", onClick: this.onClick, class: createColorClasses$1(this.color, {
      [e]: !0,
      "in-toolbar": hostContext("ion-toolbar", this.el),
      "in-toolbar-color": hostContext("ion-toolbar[color]", this.el),
      "segment-activated": this.activated,
      "segment-disabled": this.disabled,
      "segment-scrollable": this.scrollable
    }) }, h("slot", null));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      color: ["colorChanged"],
      swipeGesture: ["swipeGestureChanged"],
      value: ["valueChanged"],
      disabled: ["disabledChanged"]
    };
  }
  static get style() {
    return {
      ios: segmentIosCss,
      md: segmentMdCss
    };
  }
}, [33, "ion-segment", {
  color: [513],
  disabled: [4],
  scrollable: [4],
  swipeGesture: [4, "swipe-gesture"],
  value: [1032],
  selectOnFocus: [4, "select-on-focus"],
  activated: [32]
}, [[0, "keydown", "onKeyDown"]], {
  color: ["colorChanged"],
  swipeGesture: ["swipeGestureChanged"],
  value: ["valueChanged"],
  disabled: ["disabledChanged"]
}]);
function defineCustomElement$1$c() {
  if (typeof customElements > "u")
    return;
  ["ion-segment"].forEach((e) => {
    switch (e) {
      case "ion-segment":
        customElements.get(e) || customElements.define(e, Segment);
        break;
    }
  });
}
const defineCustomElement$h = defineCustomElement$1$c;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const segmentButtonIosCss = ':host{--color:initial;--color-hover:var(--color);--color-checked:var(--color);--color-disabled:var(--color);--padding-start:0;--padding-end:0;--padding-top:0;--padding-bottom:0;border-radius:var(--border-radius);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;height:auto;background:var(--background);color:var(--color);text-decoration:none;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;grid-row:1;-webkit-font-kerning:none;font-kerning:none}.button-native{border-radius:0;font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;-webkit-margin-start:var(--margin-start);margin-inline-start:var(--margin-start);-webkit-margin-end:var(--margin-end);margin-inline-end:var(--margin-end);margin-top:var(--margin-top);margin-bottom:var(--margin-bottom);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);-webkit-transform:translate3d(0,  0,  0);transform:translate3d(0,  0,  0);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;min-width:inherit;max-width:inherit;height:auto;min-height:inherit;max-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border:none;outline:none;background:transparent;contain:content;pointer-events:none;overflow:hidden;z-index:2}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:inherit;flex-flow:inherit;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}:host(.segment-button-checked){background:var(--background-checked);color:var(--color-checked)}:host(.segment-button-disabled){cursor:default;pointer-events:none}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(:focus){outline:none}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.segment-button-checked:hover) .button-native{color:var(--color-checked)}}::slotted(ion-icon){-ms-flex-negative:0;flex-shrink:0;-ms-flex-order:-1;order:-1;pointer-events:none}::slotted(ion-label){display:block;-ms-flex-item-align:center;align-self:center;max-width:100%;line-height:22px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.segment-button-layout-icon-top) .button-native{-ms-flex-direction:column;flex-direction:column}:host(.segment-button-layout-icon-start) .button-native{-ms-flex-direction:row;flex-direction:row}:host(.segment-button-layout-icon-end) .button-native{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.segment-button-layout-icon-bottom) .button-native{-ms-flex-direction:column-reverse;flex-direction:column-reverse}:host(.segment-button-layout-icon-hide) ::slotted(ion-icon){display:none}:host(.segment-button-layout-label-hide) ::slotted(ion-label){display:none}ion-ripple-effect{color:var(--ripple-color, var(--color-checked))}.segment-button-indicator{-webkit-transform-origin:left;transform-origin:left;position:absolute;opacity:0;-webkit-box-sizing:border-box;box-sizing:border-box;will-change:transform, opacity;pointer-events:none}.segment-button-indicator-background{width:100%;height:var(--indicator-height);-webkit-transform:var(--indicator-transform);transform:var(--indicator-transform);-webkit-box-shadow:var(--indicator-box-shadow);box-shadow:var(--indicator-box-shadow);pointer-events:none}.segment-button-indicator-animated{-webkit-transition:var(--indicator-transition);transition:var(--indicator-transition)}:host(.segment-button-checked) .segment-button-indicator{opacity:1}@media (prefers-reduced-motion: reduce){.segment-button-indicator-background{-webkit-transform:none;transform:none}.segment-button-indicator-animated{-webkit-transition:none;transition:none}}:host{--background:none;--background-checked:none;--background-hover:none;--background-hover-opacity:0;--background-focused:none;--background-focused-opacity:0;--border-radius:7px;--border-width:1px;--border-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.12);--border-style:solid;--indicator-box-shadow:0 0 5px rgba(0, 0, 0, 0.16);--indicator-color:var(--ion-color-step-350, var(--ion-background-color, #fff));--indicator-height:100%;--indicator-transition:transform 260ms cubic-bezier(0.4, 0, 0.2, 1);--indicator-transform:none;--transition:100ms all linear;--padding-top:0;--padding-end:13px;--padding-bottom:0;--padding-start:13px;margin-top:2px;margin-bottom:2px;position:relative;-ms-flex-direction:row;flex-direction:row;min-width:70px;min-height:28px;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);font-size:13px;font-weight:450;line-height:37px}:host::before{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:5px;-webkit-transition:160ms opacity ease-in-out;transition:160ms opacity ease-in-out;-webkit-transition-delay:100ms;transition-delay:100ms;border-left:var(--border-width) var(--border-style) var(--border-color);content:"";opacity:1;will-change:opacity}:host(:first-of-type)::before{border-left-color:transparent}:host(.segment-button-disabled){opacity:0.3}::slotted(ion-icon){font-size:24px}:host(.segment-button-layout-icon-start) ::slotted(ion-label){-webkit-margin-start:2px;margin-inline-start:2px;-webkit-margin-end:0;margin-inline-end:0}:host(.segment-button-layout-icon-end) ::slotted(ion-label){-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:2px;margin-inline-end:2px}.segment-button-indicator{-webkit-padding-start:2px;padding-inline-start:2px;-webkit-padding-end:2px;padding-inline-end:2px;left:0;right:0;top:0;bottom:0}.segment-button-indicator-background{border-radius:var(--border-radius);background:var(--indicator-color)}.segment-button-indicator-background{-webkit-transition:var(--indicator-transition);transition:var(--indicator-transition)}:host(.segment-button-checked)::before,:host(.segment-button-after-checked)::before{opacity:0}:host(.segment-button-checked){z-index:-1}:host(.segment-button-activated){--indicator-transform:scale(0.95)}:host(.ion-focused) .button-native{opacity:0.7}@media (any-hover: hover){:host(:hover) .button-native{opacity:0.5}:host(.segment-button-checked:hover) .button-native{opacity:1}}:host(.in-segment-color){background:none;color:var(--ion-text-color, #000)}:host(.in-segment-color) .segment-button-indicator-background{background:var(--ion-color-step-350, var(--ion-background-color, #fff))}@media (any-hover: hover){:host(.in-segment-color:hover) .button-native,:host(.in-segment-color.segment-button-checked:hover) .button-native{color:var(--ion-text-color, #000)}}:host(.in-toolbar:not(.in-segment-color)){--background-checked:var(--ion-toolbar-segment-background-checked, none);--color:var(--ion-toolbar-segment-color, var(--ion-toolbar-color), initial);--color-checked:var(--ion-toolbar-segment-color-checked, var(--ion-toolbar-color), initial);--indicator-color:var(--ion-toolbar-segment-indicator-color, var(--ion-color-step-350, var(--ion-background-color, #fff)))}:host(.in-toolbar-color) .segment-button-indicator-background{background:var(--ion-color-contrast)}:host(.in-toolbar-color:not(.in-segment-color)) .button-native{color:var(--ion-color-contrast)}:host(.in-toolbar-color.segment-button-checked:not(.in-segment-color)) .button-native{color:var(--ion-color-base)}@media (any-hover: hover){:host(.in-toolbar-color:not(.in-segment-color):hover) .button-native{color:var(--ion-color-contrast)}:host(.in-toolbar-color.segment-button-checked:not(.in-segment-color):hover) .button-native{color:var(--ion-color-base)}}', segmentButtonMdCss = ':host{--color:initial;--color-hover:var(--color);--color-checked:var(--color);--color-disabled:var(--color);--padding-start:0;--padding-end:0;--padding-top:0;--padding-bottom:0;border-radius:var(--border-radius);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:column;flex-direction:column;height:auto;background:var(--background);color:var(--color);text-decoration:none;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;grid-row:1;-webkit-font-kerning:none;font-kerning:none}.button-native{border-radius:0;font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;-webkit-margin-start:var(--margin-start);margin-inline-start:var(--margin-start);-webkit-margin-end:var(--margin-end);margin-inline-end:var(--margin-end);margin-top:var(--margin-top);margin-bottom:var(--margin-bottom);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);-webkit-transform:translate3d(0,  0,  0);transform:translate3d(0,  0,  0);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;min-width:inherit;max-width:inherit;height:auto;min-height:inherit;max-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border:none;outline:none;background:transparent;contain:content;pointer-events:none;overflow:hidden;z-index:2}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:inherit;flex-flow:inherit;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}:host(.segment-button-checked){background:var(--background-checked);color:var(--color-checked)}:host(.segment-button-disabled){cursor:default;pointer-events:none}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}:host(:focus){outline:none}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}:host(.segment-button-checked:hover) .button-native{color:var(--color-checked)}}::slotted(ion-icon){-ms-flex-negative:0;flex-shrink:0;-ms-flex-order:-1;order:-1;pointer-events:none}::slotted(ion-label){display:block;-ms-flex-item-align:center;align-self:center;max-width:100%;line-height:22px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}:host(.segment-button-layout-icon-top) .button-native{-ms-flex-direction:column;flex-direction:column}:host(.segment-button-layout-icon-start) .button-native{-ms-flex-direction:row;flex-direction:row}:host(.segment-button-layout-icon-end) .button-native{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.segment-button-layout-icon-bottom) .button-native{-ms-flex-direction:column-reverse;flex-direction:column-reverse}:host(.segment-button-layout-icon-hide) ::slotted(ion-icon){display:none}:host(.segment-button-layout-label-hide) ::slotted(ion-label){display:none}ion-ripple-effect{color:var(--ripple-color, var(--color-checked))}.segment-button-indicator{-webkit-transform-origin:left;transform-origin:left;position:absolute;opacity:0;-webkit-box-sizing:border-box;box-sizing:border-box;will-change:transform, opacity;pointer-events:none}.segment-button-indicator-background{width:100%;height:var(--indicator-height);-webkit-transform:var(--indicator-transform);transform:var(--indicator-transform);-webkit-box-shadow:var(--indicator-box-shadow);box-shadow:var(--indicator-box-shadow);pointer-events:none}.segment-button-indicator-animated{-webkit-transition:var(--indicator-transition);transition:var(--indicator-transition)}:host(.segment-button-checked) .segment-button-indicator{opacity:1}@media (prefers-reduced-motion: reduce){.segment-button-indicator-background{-webkit-transform:none;transform:none}.segment-button-indicator-animated{-webkit-transition:none;transition:none}}:host{--background:none;--background-checked:none;--background-hover:var(--color-checked);--background-focused:var(--color-checked);--background-activated-opacity:0;--background-focused-opacity:.12;--background-hover-opacity:.04;--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.6);--color-checked:var(--ion-color-primary, #3880ff);--indicator-box-shadow:none;--indicator-color:var(--color-checked);--indicator-height:2px;--indicator-transition:transform 250ms cubic-bezier(0.4, 0, 0.2, 1);--indicator-transform:none;--padding-top:0;--padding-end:16px;--padding-bottom:0;--padding-start:16px;--transition:color 0.15s linear 0s, opacity 0.15s linear 0s;min-width:90px;min-height:48px;border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);font-size:14px;font-weight:500;letter-spacing:0.06em;line-height:40px;text-transform:uppercase}:host(.segment-button-disabled){opacity:0.3}:host(.in-segment-color){background:none;color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.6)}:host(.in-segment-color) ion-ripple-effect{color:var(--ion-color-base)}:host(.in-segment-color) .segment-button-indicator-background{background:var(--ion-color-base)}:host(.in-segment-color.segment-button-checked) .button-native{color:var(--ion-color-base)}:host(.in-segment-color.ion-focused) .button-native::after{background:var(--ion-color-base)}@media (any-hover: hover){:host(.in-segment-color:hover) .button-native{color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.6)}:host(.in-segment-color:hover) .button-native::after{background:var(--ion-color-base)}:host(.in-segment-color.segment-button-checked:hover) .button-native{color:var(--ion-color-base)}}:host(.in-toolbar:not(.in-segment-color)){--background:var(--ion-toolbar-segment-background, none);--background-checked:var(--ion-toolbar-segment-background-checked, none);--color:var(--ion-toolbar-segment-color, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.6));--color-checked:var(--ion-toolbar-segment-color-checked, var(--ion-color-primary, #3880ff));--indicator-color:var(--ion-toolbar-segment-color-checked, var(--color-checked))}:host(.in-toolbar-color:not(.in-segment-color)) .button-native{color:rgba(var(--ion-color-contrast-rgb), 0.6)}:host(.in-toolbar-color.segment-button-checked:not(.in-segment-color)) .button-native{color:var(--ion-color-contrast)}@media (any-hover: hover){:host(.in-toolbar-color:not(.in-segment-color)) .button-native::after{background:var(--ion-color-contrast)}}::slotted(ion-icon){margin-top:12px;margin-bottom:12px;font-size:24px}::slotted(ion-label){margin-top:12px;margin-bottom:12px}:host(.segment-button-layout-icon-top) ::slotted(ion-label),:host(.segment-button-layout-icon-bottom) ::slotted(ion-icon){margin-top:0}:host(.segment-button-layout-icon-top) ::slotted(ion-icon),:host(.segment-button-layout-icon-bottom) ::slotted(ion-label){margin-bottom:0}:host(.segment-button-layout-icon-start) ::slotted(ion-label){-webkit-margin-start:8px;margin-inline-start:8px;-webkit-margin-end:0;margin-inline-end:0}:host(.segment-button-layout-icon-end) ::slotted(ion-label){-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px}:host(.segment-button-has-icon-only) ::slotted(ion-icon){margin-top:12px;margin-bottom:12px}:host(.segment-button-has-label-only) ::slotted(ion-label){margin-top:12px;margin-bottom:12px}.segment-button-indicator{left:0;right:0;bottom:0}.segment-button-indicator-background{background:var(--indicator-color)}:host(.in-toolbar:not(.in-segment-color)) .segment-button-indicator-background{background:var(--ion-toolbar-segment-indicator-color, var(--indicator-color))}:host(.in-toolbar-color:not(.in-segment-color)) .segment-button-indicator-background{background:var(--ion-color-contrast)}';
let ids = 0;
const SegmentButton = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.segmentEl = null, this.inheritedAttributes = {}, this.updateStyle = () => {
      forceUpdate(this);
    }, this.updateState = () => {
      const { segmentEl: e } = this;
      e && (this.checked = e.value === this.value, e.disabled && (this.disabled = !0));
    }, this.checked = !1, this.disabled = !1, this.layout = "icon-top", this.type = "button", this.value = "ion-sb-" + ids++;
  }
  valueChanged() {
    this.updateState();
  }
  connectedCallback() {
    const e = this.segmentEl = this.el.closest("ion-segment");
    e && (this.updateState(), addEventListener$1(e, "ionSelect", this.updateState), addEventListener$1(e, "ionStyle", this.updateStyle));
  }
  disconnectedCallback() {
    const e = this.segmentEl;
    e && (removeEventListener(e, "ionSelect", this.updateState), removeEventListener(e, "ionStyle", this.updateStyle), this.segmentEl = null);
  }
  componentWillLoad() {
    this.inheritedAttributes = Object.assign({}, inheritAttributes$2(this.el, ["aria-label"]));
  }
  get hasLabel() {
    return !!this.el.querySelector("ion-label");
  }
  get hasIcon() {
    return !!this.el.querySelector("ion-icon");
  }
  /**
   * @internal
   * Focuses the native <button> element
   * inside of ion-segment-button.
   */
  async setFocus() {
    const { nativeEl: e } = this;
    e !== void 0 && e.focus();
  }
  render() {
    const { checked: e, type: r, disabled: o, hasIcon: a, hasLabel: c, layout: u, segmentEl: d } = this, p = getIonMode$2(this), g = () => (d == null ? void 0 : d.color) !== void 0;
    return h(Host, { class: {
      [p]: !0,
      "in-toolbar": hostContext("ion-toolbar", this.el),
      "in-toolbar-color": hostContext("ion-toolbar[color]", this.el),
      "in-segment": hostContext("ion-segment", this.el),
      "in-segment-color": g(),
      "segment-button-has-label": c,
      "segment-button-has-icon": a,
      "segment-button-has-label-only": c && !a,
      "segment-button-has-icon-only": a && !c,
      "segment-button-disabled": o,
      "segment-button-checked": e,
      [`segment-button-layout-${u}`]: !0,
      "ion-activatable": !0,
      "ion-activatable-instant": !0,
      "ion-focusable": !0
    } }, h("button", Object.assign({ "aria-selected": e ? "true" : "false", role: "tab", ref: (b) => this.nativeEl = b, type: r, class: "button-native", part: "native", disabled: o }, this.inheritedAttributes), h("span", { class: "button-inner" }, h("slot", null)), p === "md" && h("ion-ripple-effect", null)), h("div", { part: "indicator", class: {
      "segment-button-indicator": !0,
      "segment-button-indicator-animated": !0
    } }, h("div", { part: "indicator-background", class: "segment-button-indicator-background" })));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      value: ["valueChanged"]
    };
  }
  static get style() {
    return {
      ios: segmentButtonIosCss,
      md: segmentButtonMdCss
    };
  }
}, [33, "ion-segment-button", {
  disabled: [1028],
  layout: [1],
  type: [1],
  value: [8],
  checked: [32],
  setFocus: [64]
}, void 0, {
  value: ["valueChanged"]
}]);
function defineCustomElement$1$b() {
  if (typeof customElements > "u")
    return;
  ["ion-segment-button", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-segment-button":
        customElements.get(e) || customElements.define(e, SegmentButton);
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$g = defineCustomElement$1$b;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const addEventListener = (t, e, r, o) => {
  const a = supportsPassive(t) ? {
    capture: !!o.capture,
    passive: !!o.passive
  } : !!o.capture;
  let c, u;
  return t.__zone_symbol__addEventListener ? (c = "__zone_symbol__addEventListener", u = "__zone_symbol__removeEventListener") : (c = "addEventListener", u = "removeEventListener"), t[c](e, r, a), () => {
    t[u](e, r, a);
  };
}, supportsPassive = (t) => {
  if (_sPassive === void 0)
    try {
      const e = Object.defineProperty({}, "passive", {
        get: () => {
          _sPassive = !0;
        }
      });
      t.addEventListener("optsTest", () => {
      }, e);
    } catch {
      _sPassive = !1;
    }
  return !!_sPassive;
};
let _sPassive;
const MOUSE_WAIT = 2e3, createPointerEvents = (t, e, r, o, a) => {
  let c, u, d, p, g, b, x, w = 0;
  const y = (O) => {
    w = Date.now() + MOUSE_WAIT, e(O) && (!u && r && (u = addEventListener(t, "touchmove", r, a)), d || (d = addEventListener(O.target, "touchend", E, a)), p || (p = addEventListener(O.target, "touchcancel", E, a)));
  }, I = (O) => {
    w > Date.now() || e(O) && (!b && r && (b = addEventListener(getDocument(t), "mousemove", r, a)), x || (x = addEventListener(getDocument(t), "mouseup", T, a)));
  }, E = (O) => {
    C(), o && o(O);
  }, T = (O) => {
    $(), o && o(O);
  }, C = () => {
    u && u(), d && d(), p && p(), u = d = p = void 0;
  }, $ = () => {
    b && b(), x && x(), b = x = void 0;
  }, D = () => {
    C(), $();
  }, L = (O = !0) => {
    O ? (c || (c = addEventListener(t, "touchstart", y, a)), g || (g = addEventListener(t, "mousedown", I, a))) : (c && c(), g && g(), c = g = void 0, D());
  };
  return {
    enable: L,
    stop: D,
    destroy: () => {
      L(!1), o = r = e = void 0;
    }
  };
}, getDocument = (t) => t instanceof Document ? t : t.ownerDocument, createPanRecognizer = (t, e, r) => {
  const o = r * (Math.PI / 180), a = t === "x", c = Math.cos(o), u = e * e;
  let d = 0, p = 0, g = !1, b = 0;
  return {
    start(x, w) {
      d = x, p = w, b = 0, g = !0;
    },
    detect(x, w) {
      if (!g)
        return !1;
      const y = x - d, I = w - p, E = y * y + I * I;
      if (E < u)
        return !1;
      const T = Math.sqrt(E), C = (a ? y : I) / T;
      return C > c ? b = 1 : C < -c ? b = -1 : b = 0, g = !1, !0;
    },
    isGesture() {
      return b !== 0;
    },
    getDirection() {
      return b;
    }
  };
}, createGesture = (t) => {
  let e = !1, r = !1, o = !0, a = !1;
  const c = Object.assign({ disableScroll: !1, direction: "x", gesturePriority: 0, passive: !0, maxAngle: 40, threshold: 10 }, t), u = c.canStart, d = c.onWillStart, p = c.onStart, g = c.onEnd, b = c.notCaptured, x = c.onMove, w = c.threshold, y = c.passive, I = c.blurOnStart, E = {
    type: "pan",
    startX: 0,
    startY: 0,
    startTime: 0,
    currentX: 0,
    currentY: 0,
    velocityX: 0,
    velocityY: 0,
    deltaX: 0,
    deltaY: 0,
    currentTime: 0,
    event: void 0,
    data: void 0
  }, T = createPanRecognizer(c.direction, c.threshold, c.maxAngle), C = GESTURE_CONTROLLER.createGesture({
    name: t.gestureName,
    priority: t.gesturePriority,
    disableScroll: t.disableScroll
  }), $ = (F) => {
    const U = now(F);
    return r || !o || (updateDetail(F, E), E.startX = E.currentX, E.startY = E.currentY, E.startTime = E.currentTime = U, E.velocityX = E.velocityY = E.deltaX = E.deltaY = 0, E.event = F, u && u(E) === !1) || (C.release(), !C.start()) ? !1 : (r = !0, w === 0 ? R() : (T.start(E.startX, E.startY), !0));
  }, D = (F) => {
    if (e) {
      !a && o && (a = !0, calcGestureData(E, F), requestAnimationFrame(L));
      return;
    }
    calcGestureData(E, F), T.detect(E.currentX, E.currentY) && (!T.isGesture() || !R()) && S();
  }, L = () => {
    e && (a = !1, x && x(E));
  }, R = () => C.capture() ? (e = !0, o = !1, E.startX = E.currentX, E.startY = E.currentY, E.startTime = E.currentTime, d ? d(E).then(P) : P(), !0) : !1, O = () => {
    if (typeof document < "u") {
      const F = document.activeElement;
      F != null && F.blur && F.blur();
    }
  }, P = () => {
    I && O(), p && p(E), o = !0;
  }, z = () => {
    e = !1, r = !1, a = !1, o = !0, C.release();
  }, W = (F) => {
    const U = e, M = o;
    if (z(), !!M) {
      if (calcGestureData(E, F), U) {
        g && g(E);
        return;
      }
      b && b(E);
    }
  }, A = createPointerEvents(c.el, $, D, W, {
    capture: !1,
    passive: y
  }), S = () => {
    z(), A.stop(), b && b(E);
  };
  return {
    enable(F = !0) {
      F || (e && W(void 0), z()), A.enable(F);
    },
    destroy() {
      C.destroy(), A.destroy();
    }
  };
}, calcGestureData = (t, e) => {
  if (!e)
    return;
  const r = t.currentX, o = t.currentY, a = t.currentTime;
  updateDetail(e, t);
  const c = t.currentX, u = t.currentY, p = (t.currentTime = now(e)) - a;
  if (p > 0 && p < 100) {
    const g = (c - r) / p, b = (u - o) / p;
    t.velocityX = g * 0.7 + t.velocityX * 0.3, t.velocityY = b * 0.7 + t.velocityY * 0.3;
  }
  t.deltaX = c - t.startX, t.deltaY = u - t.startY, t.event = e;
}, updateDetail = (t, e) => {
  let r = 0, o = 0;
  if (t) {
    const a = t.changedTouches;
    if (a && a.length > 0) {
      const c = a[0];
      r = c.clientX, o = c.clientY;
    } else
      t.pageX !== void 0 && (r = t.pageX, o = t.pageY);
  }
  e.currentX = r, e.currentY = o;
}, now = (t) => t.timeStamp || Date.now(), index3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GESTURE_CONTROLLER,
  createGesture
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const createButtonActiveGesture = (t, e) => {
  let r, o;
  const a = (d, p, g) => {
    if (typeof document > "u")
      return;
    const b = document.elementFromPoint(d, p);
    if (!b || !e(b)) {
      u();
      return;
    }
    b !== r && (u(), c(b, g));
  }, c = (d, p) => {
    r = d, o || (o = r);
    const g = r;
    writeTask(() => g.classList.add("ion-activated")), p();
  }, u = (d = !1) => {
    if (!r)
      return;
    const p = r;
    writeTask(() => p.classList.remove("ion-activated")), d && o !== r && r.click(), r = void 0;
  };
  return createGesture({
    el: t,
    gestureName: "buttonActiveDrag",
    threshold: 0,
    onStart: (d) => a(d.currentX, d.currentY, hapticSelectionStart),
    onMove: (d) => a(d.currentX, d.currentY, hapticSelectionChanged),
    onEnd: () => {
      u(!0), hapticSelectionEnd(), o = void 0;
    }
  });
};
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const iosEnterAnimation$3 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(t.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(100%)", "translateY(0%)"), e.addElement(t).easing("cubic-bezier(.36,.66,.04,1)").duration(400).addAnimation([r, o]);
}, iosLeaveAnimation$3 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(t.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(0%)", "translateY(100%)"), e.addElement(t).easing("cubic-bezier(.36,.66,.04,1)").duration(450).addAnimation([r, o]);
}, mdEnterAnimation$3 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(t.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(100%)", "translateY(0%)"), e.addElement(t).easing("cubic-bezier(.36,.66,.04,1)").duration(400).addAnimation([r, o]);
}, mdLeaveAnimation$3 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(t.querySelector(".action-sheet-wrapper")).fromTo("transform", "translateY(0%)", "translateY(100%)"), e.addElement(t).easing("cubic-bezier(.36,.66,.04,1)").duration(450).addAnimation([r, o]);
}, actionSheetIosCss = '.sc-ion-action-sheet-ios-h{--color:initial;--button-color-activated:var(--button-color);--button-color-focused:var(--button-color);--button-color-hover:var(--button-color);--button-color-selected:var(--button-color);--min-width:auto;--width:100%;--max-width:500px;--min-height:auto;--height:auto;--max-height:calc(100% - (var(--ion-safe-area-top) + var(--ion-safe-area-bottom)));-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:block;position:fixed;outline:none;font-family:var(--ion-font-family, inherit);-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-action-sheet-ios-h{display:none}.action-sheet-wrapper.sc-ion-action-sheet-ios{left:0;right:0;bottom:0;-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);display:block;position:absolute;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);z-index:10;pointer-events:none}.action-sheet-button.sc-ion-action-sheet-ios{display:block;position:relative;width:100%;border:0;outline:none;background:var(--button-background);color:var(--button-color);font-family:inherit;overflow:hidden}.action-sheet-button-inner.sc-ion-action-sheet-ios{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;width:100%;height:100%;z-index:1}.action-sheet-container.sc-ion-action-sheet-ios{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:end;justify-content:flex-end;height:100%;max-height:calc(100vh - (var(--ion-safe-area-top, 0) + var(--ion-safe-area-bottom, 0)));max-height:calc(100dvh - (var(--ion-safe-area-top, 0) + var(--ion-safe-area-bottom, 0)))}.action-sheet-group.sc-ion-action-sheet-ios{-ms-flex-negative:2;flex-shrink:2;overscroll-behavior-y:contain;overflow-y:auto;-webkit-overflow-scrolling:touch;pointer-events:all;background:var(--background)}@media (any-pointer: coarse){.action-sheet-group.sc-ion-action-sheet-ios::-webkit-scrollbar{display:none}}.action-sheet-group-cancel.sc-ion-action-sheet-ios{-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.action-sheet-button.sc-ion-action-sheet-ios::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.action-sheet-selected.sc-ion-action-sheet-ios{color:var(--button-color-selected)}.action-sheet-selected.sc-ion-action-sheet-ios::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-button.ion-activated.sc-ion-action-sheet-ios{color:var(--button-color-activated)}.action-sheet-button.ion-activated.sc-ion-action-sheet-ios::after{background:var(--button-background-activated);opacity:var(--button-background-activated-opacity)}.action-sheet-button.ion-focused.sc-ion-action-sheet-ios{color:var(--button-color-focused)}.action-sheet-button.ion-focused.sc-ion-action-sheet-ios::after{background:var(--button-background-focused);opacity:var(--button-background-focused-opacity)}@media (any-hover: hover){.action-sheet-button.sc-ion-action-sheet-ios:hover{color:var(--button-color-hover)}.action-sheet-button.sc-ion-action-sheet-ios:hover::after{background:var(--button-background-hover);opacity:var(--button-background-hover-opacity)}}.sc-ion-action-sheet-ios-h{--background:var(--ion-overlay-background-color, var(--ion-color-step-100, #f9f9f9));--backdrop-opacity:var(--ion-backdrop-opacity, 0.4);--button-background:linear-gradient(0deg, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08), rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08) 50%, transparent 50%) bottom/100% 1px no-repeat transparent;--button-background-activated:var(--ion-text-color, #000);--button-background-activated-opacity:.08;--button-background-hover:currentColor;--button-background-hover-opacity:.04;--button-background-focused:currentColor;--button-background-focused-opacity:.12;--button-background-selected:var(--ion-color-step-150, var(--ion-background-color, #fff));--button-background-selected-opacity:1;--button-color:var(--ion-color-primary, #3880ff);--color:var(--ion-color-step-400, #999999);text-align:center}.action-sheet-wrapper.sc-ion-action-sheet-ios{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:var(--ion-safe-area-top, 0);margin-bottom:var(--ion-safe-area-bottom, 0)}.action-sheet-container.sc-ion-action-sheet-ios{-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px;padding-top:0;padding-bottom:0}.action-sheet-group.sc-ion-action-sheet-ios{border-radius:13px;margin-bottom:8px}.action-sheet-group.sc-ion-action-sheet-ios:first-child{margin-top:10px}.action-sheet-group.sc-ion-action-sheet-ios:last-child{margin-bottom:10px}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-group.sc-ion-action-sheet-ios{background-color:transparent;-webkit-backdrop-filter:saturate(280%) blur(20px);backdrop-filter:saturate(280%) blur(20px)}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-title.sc-ion-action-sheet-ios,.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-button.sc-ion-action-sheet-ios{background-color:transparent;background-image:-webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8)), to(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8))), -webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4)), color-stop(50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4)), color-stop(50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8)));background-image:linear-gradient(0deg, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8), rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8) 100%), linear-gradient(0deg, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4), rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.4) 50%, rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8) 50%);background-repeat:no-repeat;background-position:top, bottom;background-size:100% calc(100% - 1px), 100% 1px;-webkit-backdrop-filter:saturate(120%);backdrop-filter:saturate(120%)}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-button.ion-activated.sc-ion-action-sheet-ios{background-color:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.7);background-image:none}.action-sheet-translucent.sc-ion-action-sheet-ios-h .action-sheet-cancel.sc-ion-action-sheet-ios{background:var(--button-background-selected)}}.action-sheet-title.sc-ion-action-sheet-ios{background:-webkit-gradient(linear, left bottom, left top, from(rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)), color-stop(50%, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08)), color-stop(50%, transparent)) bottom/100% 1px no-repeat transparent;background:linear-gradient(0deg, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08), rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.08) 50%, transparent 50%) bottom/100% 1px no-repeat transparent}.action-sheet-title.sc-ion-action-sheet-ios{-webkit-padding-start:10px;padding-inline-start:10px;-webkit-padding-end:10px;padding-inline-end:10px;padding-top:14px;padding-bottom:13px;color:var(--color, var(--ion-color-step-400, #999999));font-size:max(13px, 0.8125rem);font-weight:400;text-align:center}.action-sheet-title.action-sheet-has-sub-title.sc-ion-action-sheet-ios{font-weight:600}.action-sheet-sub-title.sc-ion-action-sheet-ios{padding-left:0;padding-right:0;padding-top:6px;padding-bottom:0;font-size:max(13px, 0.8125rem);font-weight:400}.action-sheet-button.sc-ion-action-sheet-ios{-webkit-padding-start:14px;padding-inline-start:14px;-webkit-padding-end:14px;padding-inline-end:14px;padding-top:14px;padding-bottom:14px;min-height:56px;font-size:max(20px, 1.25rem);contain:content}.action-sheet-button.sc-ion-action-sheet-ios .action-sheet-icon.sc-ion-action-sheet-ios{-webkit-margin-end:0.3em;margin-inline-end:0.3em;font-size:max(28px, 1.75rem);pointer-events:none}.action-sheet-button.sc-ion-action-sheet-ios:last-child{background-image:none}.action-sheet-selected.sc-ion-action-sheet-ios{font-weight:bold}.action-sheet-cancel.sc-ion-action-sheet-ios{font-weight:600}.action-sheet-cancel.sc-ion-action-sheet-ios::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-destructive.sc-ion-action-sheet-ios,.action-sheet-destructive.ion-activated.sc-ion-action-sheet-ios,.action-sheet-destructive.ion-focused.sc-ion-action-sheet-ios{color:var(--ion-color-danger, #eb445a)}@media (any-hover: hover){.action-sheet-destructive.sc-ion-action-sheet-ios:hover{color:var(--ion-color-danger, #eb445a)}}', actionSheetMdCss = '.sc-ion-action-sheet-md-h{--color:initial;--button-color-activated:var(--button-color);--button-color-focused:var(--button-color);--button-color-hover:var(--button-color);--button-color-selected:var(--button-color);--min-width:auto;--width:100%;--max-width:500px;--min-height:auto;--height:auto;--max-height:calc(100% - (var(--ion-safe-area-top) + var(--ion-safe-area-bottom)));-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:block;position:fixed;outline:none;font-family:var(--ion-font-family, inherit);-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-action-sheet-md-h{display:none}.action-sheet-wrapper.sc-ion-action-sheet-md{left:0;right:0;bottom:0;-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);display:block;position:absolute;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);z-index:10;pointer-events:none}.action-sheet-button.sc-ion-action-sheet-md{display:block;position:relative;width:100%;border:0;outline:none;background:var(--button-background);color:var(--button-color);font-family:inherit;overflow:hidden}.action-sheet-button-inner.sc-ion-action-sheet-md{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none;width:100%;height:100%;z-index:1}.action-sheet-container.sc-ion-action-sheet-md{display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:end;justify-content:flex-end;height:100%;max-height:calc(100vh - (var(--ion-safe-area-top, 0) + var(--ion-safe-area-bottom, 0)));max-height:calc(100dvh - (var(--ion-safe-area-top, 0) + var(--ion-safe-area-bottom, 0)))}.action-sheet-group.sc-ion-action-sheet-md{-ms-flex-negative:2;flex-shrink:2;overscroll-behavior-y:contain;overflow-y:auto;-webkit-overflow-scrolling:touch;pointer-events:all;background:var(--background)}@media (any-pointer: coarse){.action-sheet-group.sc-ion-action-sheet-md::-webkit-scrollbar{display:none}}.action-sheet-group-cancel.sc-ion-action-sheet-md{-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.action-sheet-button.sc-ion-action-sheet-md::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.action-sheet-selected.sc-ion-action-sheet-md{color:var(--button-color-selected)}.action-sheet-selected.sc-ion-action-sheet-md::after{background:var(--button-background-selected);opacity:var(--button-background-selected-opacity)}.action-sheet-button.ion-activated.sc-ion-action-sheet-md{color:var(--button-color-activated)}.action-sheet-button.ion-activated.sc-ion-action-sheet-md::after{background:var(--button-background-activated);opacity:var(--button-background-activated-opacity)}.action-sheet-button.ion-focused.sc-ion-action-sheet-md{color:var(--button-color-focused)}.action-sheet-button.ion-focused.sc-ion-action-sheet-md::after{background:var(--button-background-focused);opacity:var(--button-background-focused-opacity)}@media (any-hover: hover){.action-sheet-button.sc-ion-action-sheet-md:hover{color:var(--button-color-hover)}.action-sheet-button.sc-ion-action-sheet-md:hover::after{background:var(--button-background-hover);opacity:var(--button-background-hover-opacity)}}.sc-ion-action-sheet-md-h{--background:var(--ion-overlay-background-color, var(--ion-background-color, #fff));--backdrop-opacity:var(--ion-backdrop-opacity, 0.32);--button-background:transparent;--button-background-selected:currentColor;--button-background-selected-opacity:0;--button-background-activated:transparent;--button-background-activated-opacity:0;--button-background-hover:currentColor;--button-background-hover-opacity:.04;--button-background-focused:currentColor;--button-background-focused-opacity:.12;--button-color:var(--ion-color-step-850, #262626);--color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54)}.action-sheet-wrapper.sc-ion-action-sheet-md{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:var(--ion-safe-area-top, 0);margin-bottom:0}.action-sheet-title.sc-ion-action-sheet-md{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:20px;padding-bottom:17px;min-height:60px;color:var(--color, rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.54));font-size:1rem;text-align:start}.action-sheet-sub-title.sc-ion-action-sheet-md{padding-left:0;padding-right:0;padding-top:16px;padding-bottom:0;font-size:0.875rem}.action-sheet-group.sc-ion-action-sheet-md:first-child{padding-top:0}.action-sheet-group.sc-ion-action-sheet-md:last-child{padding-bottom:var(--ion-safe-area-bottom)}.action-sheet-button.sc-ion-action-sheet-md{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:12px;padding-bottom:12px;position:relative;min-height:52px;font-size:1rem;text-align:start;contain:content;overflow:hidden}.action-sheet-icon.sc-ion-action-sheet-md{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:32px;margin-inline-end:32px;margin-top:0;margin-bottom:0;color:var(--color);font-size:1.5rem}.action-sheet-button-inner.sc-ion-action-sheet-md{-ms-flex-pack:start;justify-content:flex-start}.action-sheet-selected.sc-ion-action-sheet-md{font-weight:bold}', ActionSheet = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.didPresent = createEvent(this, "ionActionSheetDidPresent", 7), this.willPresent = createEvent(this, "ionActionSheetWillPresent", 7), this.willDismiss = createEvent(this, "ionActionSheetWillDismiss", 7), this.didDismiss = createEvent(this, "ionActionSheetDidDismiss", 7), this.didPresentShorthand = createEvent(this, "didPresent", 7), this.willPresentShorthand = createEvent(this, "willPresent", 7), this.willDismissShorthand = createEvent(this, "willDismiss", 7), this.didDismissShorthand = createEvent(this, "didDismiss", 7), this.delegateController = createDelegateController(this), this.lockController = createLockController(), this.triggerController = createTriggerController(), this.presented = !1, this.onBackdropTap = () => {
      this.dismiss(void 0, BACKDROP);
    }, this.dispatchCancelHandler = (e) => {
      const r = e.detail.role;
      if (isCancel$2(r)) {
        const o = this.getButtons().find((a) => a.role === "cancel");
        this.callButtonHandler(o);
      }
    }, this.overlayIndex = void 0, this.delegate = void 0, this.hasController = !1, this.keyboardClose = !0, this.enterAnimation = void 0, this.leaveAnimation = void 0, this.buttons = [], this.cssClass = void 0, this.backdropDismiss = !0, this.header = void 0, this.subHeader = void 0, this.translucent = !1, this.animated = !0, this.htmlAttributes = void 0, this.isOpen = !1, this.trigger = void 0;
  }
  onIsOpenChange(e, r) {
    e === !0 && r === !1 ? this.present() : e === !1 && r === !0 && this.dismiss();
  }
  triggerChanged() {
    const { trigger: e, el: r, triggerController: o } = this;
    e && o.addClickListener(r, e);
  }
  /**
   * Present the action sheet overlay after it has been created.
   */
  async present() {
    const e = await this.lockController.lock();
    await this.delegateController.attachViewToDom(), await present(this, "actionSheetEnter", iosEnterAnimation$3, mdEnterAnimation$3), e();
  }
  /**
   * Dismiss the action sheet overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the action sheet.
   * This can be useful in a button handler for determining which button was
   * clicked to dismiss the action sheet.
   * Some examples include: ``"cancel"`, `"destructive"`, "selected"`, and `"backdrop"`.
   */
  async dismiss(e, r) {
    const o = await this.lockController.lock(), a = await dismiss(this, e, r, "actionSheetLeave", iosLeaveAnimation$3, mdLeaveAnimation$3);
    return a && this.delegateController.removeViewFromDom(), o(), a;
  }
  /**
   * Returns a promise that resolves when the action sheet did dismiss.
   */
  onDidDismiss() {
    return eventMethod(this.el, "ionActionSheetDidDismiss");
  }
  /**
   * Returns a promise that resolves when the action sheet will dismiss.
   *
   */
  onWillDismiss() {
    return eventMethod(this.el, "ionActionSheetWillDismiss");
  }
  async buttonClick(e) {
    const r = e.role;
    return isCancel$2(r) ? this.dismiss(e.data, r) : await this.callButtonHandler(e) ? this.dismiss(e.data, e.role) : Promise.resolve();
  }
  async callButtonHandler(e) {
    return !(e && await safeCall(e.handler) === !1);
  }
  getButtons() {
    return this.buttons.map((e) => typeof e == "string" ? { text: e } : e);
  }
  connectedCallback() {
    prepareOverlay(this.el), this.triggerChanged();
  }
  disconnectedCallback() {
    this.gesture && (this.gesture.destroy(), this.gesture = void 0), this.triggerController.removeClickListener();
  }
  componentWillLoad() {
    setOverlayId(this.el);
  }
  componentDidLoad() {
    const { groupEl: e, wrapperEl: r } = this;
    !this.gesture && getIonMode$2(this) === "ios" && r && e && readTask(() => {
      e.scrollHeight > e.clientHeight || (this.gesture = createButtonActiveGesture(r, (a) => a.classList.contains("action-sheet-button")), this.gesture.enable(!0));
    }), this.isOpen === !0 && raf(() => this.present()), this.triggerChanged();
  }
  render() {
    const { header: e, htmlAttributes: r, overlayIndex: o } = this, a = getIonMode$2(this), c = this.getButtons(), u = c.find((g) => g.role === "cancel"), d = c.filter((g) => g.role !== "cancel"), p = `action-sheet-${o}-header`;
    return h(Host, Object.assign({ role: "dialog", "aria-modal": "true", "aria-labelledby": e !== void 0 ? p : null, tabindex: "-1" }, r, { style: {
      zIndex: `${2e4 + this.overlayIndex}`
    }, class: Object.assign(Object.assign({ [a]: !0 }, getClassMap(this.cssClass)), { "overlay-hidden": !0, "action-sheet-translucent": this.translucent }), onIonActionSheetWillDismiss: this.dispatchCancelHandler, onIonBackdropTap: this.onBackdropTap }), h("ion-backdrop", { tappable: this.backdropDismiss }), h("div", { tabindex: "0" }), h("div", { class: "action-sheet-wrapper ion-overlay-wrapper", ref: (g) => this.wrapperEl = g }, h("div", { class: "action-sheet-container" }, h("div", { class: "action-sheet-group", ref: (g) => this.groupEl = g }, e !== void 0 && h("div", { id: p, class: {
      "action-sheet-title": !0,
      "action-sheet-has-sub-title": this.subHeader !== void 0
    } }, e, this.subHeader && h("div", { class: "action-sheet-sub-title" }, this.subHeader)), d.map((g) => h("button", Object.assign({}, g.htmlAttributes, { type: "button", id: g.id, class: buttonClass$2(g), onClick: () => this.buttonClick(g) }), h("span", { class: "action-sheet-button-inner" }, g.icon && h("ion-icon", { icon: g.icon, "aria-hidden": "true", lazy: !1, class: "action-sheet-icon" }), g.text), a === "md" && h("ion-ripple-effect", null)))), u && h("div", { class: "action-sheet-group action-sheet-group-cancel" }, h("button", Object.assign({}, u.htmlAttributes, { type: "button", class: buttonClass$2(u), onClick: () => this.buttonClick(u) }), h("span", { class: "action-sheet-button-inner" }, u.icon && h("ion-icon", { icon: u.icon, "aria-hidden": "true", lazy: !1, class: "action-sheet-icon" }), u.text), a === "md" && h("ion-ripple-effect", null))))), h("div", { tabindex: "0" }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      isOpen: ["onIsOpenChange"],
      trigger: ["triggerChanged"]
    };
  }
  static get style() {
    return {
      ios: actionSheetIosCss,
      md: actionSheetMdCss
    };
  }
}, [34, "ion-action-sheet", {
  overlayIndex: [2, "overlay-index"],
  delegate: [16],
  hasController: [4, "has-controller"],
  keyboardClose: [4, "keyboard-close"],
  enterAnimation: [16],
  leaveAnimation: [16],
  buttons: [16],
  cssClass: [1, "css-class"],
  backdropDismiss: [4, "backdrop-dismiss"],
  header: [1],
  subHeader: [1, "sub-header"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  isOpen: [4, "is-open"],
  trigger: [1],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}, void 0, {
  isOpen: ["onIsOpenChange"],
  trigger: ["triggerChanged"]
}]), buttonClass$2 = (t) => Object.assign({ "action-sheet-button": !0, "ion-activatable": !0, "ion-focusable": !0, [`action-sheet-${t.role}`]: t.role !== void 0 }, getClassMap(t.cssClass));
function defineCustomElement$f() {
  if (typeof customElements > "u")
    return;
  ["ion-action-sheet", "ion-backdrop", "ion-icon", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-action-sheet":
        customElements.get(e) || customElements.define(e, ActionSheet);
        break;
      case "ion-backdrop":
        customElements.get(e) || defineCustomElement$R();
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const iosEnterAnimation$2 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(t.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: "0.01", transform: "scale(1.1)" },
    { offset: 1, opacity: "1", transform: "scale(1)" }
  ]), e.addElement(t).easing("ease-in-out").duration(200).addAnimation([r, o]);
}, iosLeaveAnimation$2 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(t.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: 0.99, transform: "scale(1)" },
    { offset: 1, opacity: 0, transform: "scale(0.9)" }
  ]), e.addElement(t).easing("ease-in-out").duration(200).addAnimation([r, o]);
}, mdEnterAnimation$2 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), o.addElement(t.querySelector(".alert-wrapper")).keyframes([
    { offset: 0, opacity: "0.01", transform: "scale(0.9)" },
    { offset: 1, opacity: "1", transform: "scale(1)" }
  ]), e.addElement(t).easing("ease-in-out").duration(150).addAnimation([r, o]);
}, mdLeaveAnimation$2 = (t) => {
  const e = createAnimation(), r = createAnimation(), o = createAnimation();
  return r.addElement(t.querySelector("ion-backdrop")).fromTo("opacity", "var(--backdrop-opacity)", 0), o.addElement(t.querySelector(".alert-wrapper")).fromTo("opacity", 0.99, 0), e.addElement(t).easing("ease-in-out").duration(150).addAnimation([r, o]);
}, alertIosCss = ".sc-ion-alert-ios-h{--min-width:250px;--width:auto;--min-height:auto;--height:auto;--max-height:90%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;font-family:var(--ion-font-family, inherit);contain:strict;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-alert-ios-h{display:none}.alert-top.sc-ion-alert-ios-h{padding-top:50px;-ms-flex-align:start;align-items:flex-start}.alert-wrapper.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);contain:content;opacity:0;z-index:10}.alert-title.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-sub-title.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-weight:normal}.alert-message.sc-ion-alert-ios,.alert-input-group.sc-ion-alert-ios{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-overflow-scrolling:touch;overflow-y:auto;overscroll-behavior-y:contain}.alert-checkbox-label.sc-ion-alert-ios,.alert-radio-label.sc-ion-alert-ios{overflow-wrap:anywhere}@media (any-pointer: coarse){.alert-checkbox-group.sc-ion-alert-ios::-webkit-scrollbar,.alert-radio-group.sc-ion-alert-ios::-webkit-scrollbar,.alert-message.sc-ion-alert-ios::-webkit-scrollbar{display:none}}.alert-input.sc-ion-alert-ios{padding-left:0;padding-right:0;padding-top:10px;padding-bottom:10px;width:100%;border:0;background:inherit;font:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.alert-button-group.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}.alert-button-group-vertical.sc-ion-alert-ios{-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.alert-button.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;border:0;font-size:0.875rem;line-height:1.25rem;z-index:0}.alert-button.ion-focused.sc-ion-alert-ios,.alert-tappable.ion-focused.sc-ion-alert-ios{background:var(--ion-color-step-100, #e6e6e6)}.alert-button-inner.sc-ion-alert-ios{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;min-height:inherit}.alert-input-disabled.sc-ion-alert-ios,.alert-checkbox-button-disabled.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios,.alert-radio-button-disabled.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios{cursor:default;opacity:0.5;pointer-events:none}.alert-tappable.sc-ion-alert-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;width:100%;border:0;background:transparent;font-size:inherit;line-height:initial;text-align:start;-webkit-appearance:none;-moz-appearance:none;appearance:none;contain:content}.alert-button.sc-ion-alert-ios,.alert-checkbox.sc-ion-alert-ios,.alert-input.sc-ion-alert-ios,.alert-radio.sc-ion-alert-ios{outline:none}.alert-radio-icon.sc-ion-alert-ios,.alert-checkbox-icon.sc-ion-alert-ios,.alert-checkbox-inner.sc-ion-alert-ios{-webkit-box-sizing:border-box;box-sizing:border-box}textarea.alert-input.sc-ion-alert-ios{min-height:37px;resize:none}.sc-ion-alert-ios-h{--background:var(--ion-overlay-background-color, var(--ion-color-step-100, #f9f9f9));--max-width:clamp(270px, 16.875rem, 324px);--backdrop-opacity:var(--ion-backdrop-opacity, 0.3);font-size:max(14px, 0.875rem)}.alert-wrapper.sc-ion-alert-ios{border-radius:13px;-webkit-box-shadow:none;box-shadow:none;overflow:hidden}.alert-button.sc-ion-alert-ios .alert-button-inner.sc-ion-alert-ios{pointer-events:none}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){.alert-translucent.sc-ion-alert-ios-h .alert-wrapper.sc-ion-alert-ios{background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.9);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}}.alert-head.sc-ion-alert-ios{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:12px;padding-bottom:7px;text-align:center}.alert-title.sc-ion-alert-ios{margin-top:8px;color:var(--ion-text-color, #000);font-size:max(17px, 1.0625rem);font-weight:600}.alert-sub-title.sc-ion-alert-ios{color:var(--ion-color-step-600, #666666);font-size:max(14px, 0.875rem)}.alert-message.sc-ion-alert-ios,.alert-input-group.sc-ion-alert-ios{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:0;padding-bottom:21px;color:var(--ion-text-color, #000);font-size:max(13px, 0.8125rem);text-align:center}.alert-message.sc-ion-alert-ios{max-height:240px}.alert-message.sc-ion-alert-ios:empty{padding-left:0;padding-right:0;padding-top:0;padding-bottom:12px}.alert-input.sc-ion-alert-ios{border-radius:4px;margin-top:10px;-webkit-padding-start:6px;padding-inline-start:6px;-webkit-padding-end:6px;padding-inline-end:6px;padding-top:6px;padding-bottom:6px;border:0.55px solid var(--ion-color-step-250, #bfbfbf);background-color:var(--ion-background-color, #fff);-webkit-appearance:none;-moz-appearance:none;appearance:none}.alert-input.sc-ion-alert-ios::-webkit-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-moz-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios:-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-ios::-ms-clear{display:none}.alert-input.sc-ion-alert-ios::-webkit-date-and-time-value{height:18px}.alert-radio-group.sc-ion-alert-ios,.alert-checkbox-group.sc-ion-alert-ios{-ms-scroll-chaining:none;overscroll-behavior:contain;max-height:240px;border-top:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);overflow-y:auto;-webkit-overflow-scrolling:touch}.alert-tappable.sc-ion-alert-ios{min-height:44px}.alert-radio-label.sc-ion-alert-ios{-webkit-padding-start:13px;padding-inline-start:13px;-webkit-padding-end:13px;padding-inline-end:13px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;-ms-flex-order:0;order:0;color:var(--ion-text-color, #000)}[aria-checked=true].sc-ion-alert-ios .alert-radio-label.sc-ion-alert-ios{color:var(--ion-color-primary, #3880ff)}.alert-radio-icon.sc-ion-alert-ios{position:relative;-ms-flex-order:1;order:1;min-width:30px}[aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{top:-7px;position:absolute;width:6px;height:12px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:2px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-color-primary, #3880ff)}@supports (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{inset-inline-start:7px}}@supports not (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{left:7px}[dir=rtl].sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios,[dir=rtl] .sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{left:unset;right:unset;right:7px}[dir=rtl].sc-ion-alert-ios [aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios{left:unset;right:unset;right:7px}@supports selector(:dir(rtl)){[aria-checked=true].sc-ion-alert-ios .alert-radio-inner.sc-ion-alert-ios:dir(rtl){left:unset;right:unset;right:7px}}}.alert-checkbox-label.sc-ion-alert-ios{-webkit-padding-start:13px;padding-inline-start:13px;-webkit-padding-end:13px;padding-inline-end:13px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;color:var(--ion-text-color, #000)}.alert-checkbox-icon.sc-ion-alert-ios{border-radius:50%;-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:6px;margin-inline-end:6px;margin-top:10px;margin-bottom:10px;position:relative;width:min(1.5rem, 66px);height:min(1.5rem, 66px);border-width:0.0625rem;border-style:solid;border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-250, #c8c7cc)));background-color:var(--ion-item-background, var(--ion-background-color, #fff));contain:strict}[aria-checked=true].sc-ion-alert-ios .alert-checkbox-icon.sc-ion-alert-ios{border-color:var(--ion-color-primary, #3880ff);background-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{top:calc(min(1.5rem, 66px) / 6);position:absolute;width:calc(min(1.5rem, 66px) / 6 + 1px);height:calc(min(1.5rem, 66px) * 0.5);-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:0.0625rem;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-background-color, #fff)}@supports (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{inset-inline-start:calc(min(1.5rem, 66px) / 3 + 1px)}}@supports not (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{left:calc(min(1.5rem, 66px) / 3 + 1px)}[dir=rtl].sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios,[dir=rtl] .sc-ion-alert-ios-h [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{left:unset;right:unset;right:calc(min(1.5rem, 66px) / 3 + 1px)}[dir=rtl].sc-ion-alert-ios [aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios{left:unset;right:unset;right:calc(min(1.5rem, 66px) / 3 + 1px)}@supports selector(:dir(rtl)){[aria-checked=true].sc-ion-alert-ios .alert-checkbox-inner.sc-ion-alert-ios:dir(rtl){left:unset;right:unset;right:calc(min(1.5rem, 66px) / 3 + 1px)}}}.alert-button-group.sc-ion-alert-ios{-webkit-margin-end:-0.55px;margin-inline-end:-0.55px;-ms-flex-wrap:wrap;flex-wrap:wrap}.alert-button.sc-ion-alert-ios{-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;border-radius:0;-ms-flex:1 1 auto;flex:1 1 auto;min-width:50%;height:max(44px, 2.75rem);border-top:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2);background-color:transparent;color:var(--ion-color-primary, #3880ff);font-size:max(17px, 1.0625rem);overflow:hidden}[dir=rtl].sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:first-child,[dir=rtl] .sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:first-child{border-right:0}[dir=rtl].sc-ion-alert-ios .alert-button.sc-ion-alert-ios:first-child{border-right:0}@supports selector(:dir(rtl)){.alert-button.sc-ion-alert-ios:first-child:dir(rtl){border-right:0}}.alert-button.sc-ion-alert-ios:last-child{border-right:0;font-weight:bold}[dir=rtl].sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:last-child,[dir=rtl] .sc-ion-alert-ios-h .alert-button.sc-ion-alert-ios:last-child{border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}[dir=rtl].sc-ion-alert-ios .alert-button.sc-ion-alert-ios:last-child{border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}@supports selector(:dir(rtl)){.alert-button.sc-ion-alert-ios:last-child:dir(rtl){border-right:0.55px solid rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.2)}}.alert-button.ion-activated.sc-ion-alert-ios{background-color:rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.1)}.alert-button-role-destructive.sc-ion-alert-ios,.alert-button-role-destructive.ion-activated.sc-ion-alert-ios,.alert-button-role-destructive.ion-focused.sc-ion-alert-ios{color:var(--ion-color-danger, #eb445a)}", alertMdCss = ".sc-ion-alert-md-h{--min-width:250px;--width:auto;--min-height:auto;--height:auto;--max-height:90%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;font-family:var(--ion-font-family, inherit);contain:strict;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1001}.overlay-hidden.sc-ion-alert-md-h{display:none}.alert-top.sc-ion-alert-md-h{padding-top:50px;-ms-flex-align:start;align-items:flex-start}.alert-wrapper.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);background:var(--background);contain:content;opacity:0;z-index:10}.alert-title.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-sub-title.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;font-weight:normal}.alert-message.sc-ion-alert-md,.alert-input-group.sc-ion-alert-md{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-overflow-scrolling:touch;overflow-y:auto;overscroll-behavior-y:contain}.alert-checkbox-label.sc-ion-alert-md,.alert-radio-label.sc-ion-alert-md{overflow-wrap:anywhere}@media (any-pointer: coarse){.alert-checkbox-group.sc-ion-alert-md::-webkit-scrollbar,.alert-radio-group.sc-ion-alert-md::-webkit-scrollbar,.alert-message.sc-ion-alert-md::-webkit-scrollbar{display:none}}.alert-input.sc-ion-alert-md{padding-left:0;padding-right:0;padding-top:10px;padding-bottom:10px;width:100%;border:0;background:inherit;font:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.alert-button-group.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}.alert-button-group-vertical.sc-ion-alert-md{-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.alert-button.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;display:block;border:0;font-size:0.875rem;line-height:1.25rem;z-index:0}.alert-button.ion-focused.sc-ion-alert-md,.alert-tappable.ion-focused.sc-ion-alert-md{background:var(--ion-color-step-100, #e6e6e6)}.alert-button-inner.sc-ion-alert-md{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;min-height:inherit}.alert-input-disabled.sc-ion-alert-md,.alert-checkbox-button-disabled.sc-ion-alert-md .alert-button-inner.sc-ion-alert-md,.alert-radio-button-disabled.sc-ion-alert-md .alert-button-inner.sc-ion-alert-md{cursor:default;opacity:0.5;pointer-events:none}.alert-tappable.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;padding-left:0;padding-right:0;padding-top:0;padding-bottom:0;display:-ms-flexbox;display:flex;width:100%;border:0;background:transparent;font-size:inherit;line-height:initial;text-align:start;-webkit-appearance:none;-moz-appearance:none;appearance:none;contain:content}.alert-button.sc-ion-alert-md,.alert-checkbox.sc-ion-alert-md,.alert-input.sc-ion-alert-md,.alert-radio.sc-ion-alert-md{outline:none}.alert-radio-icon.sc-ion-alert-md,.alert-checkbox-icon.sc-ion-alert-md,.alert-checkbox-inner.sc-ion-alert-md{-webkit-box-sizing:border-box;box-sizing:border-box}textarea.alert-input.sc-ion-alert-md{min-height:37px;resize:none}.sc-ion-alert-md-h{--background:var(--ion-overlay-background-color, var(--ion-background-color, #fff));--max-width:280px;--backdrop-opacity:var(--ion-backdrop-opacity, 0.32);font-size:0.875rem}.alert-wrapper.sc-ion-alert-md{border-radius:4px;-webkit-box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)}.alert-head.sc-ion-alert-md{-webkit-padding-start:23px;padding-inline-start:23px;-webkit-padding-end:23px;padding-inline-end:23px;padding-top:20px;padding-bottom:15px;text-align:start}.alert-title.sc-ion-alert-md{color:var(--ion-text-color, #000);font-size:1.25rem;font-weight:500}.alert-sub-title.sc-ion-alert-md{color:var(--ion-text-color, #000);font-size:1rem}.alert-message.sc-ion-alert-md,.alert-input-group.sc-ion-alert-md{-webkit-padding-start:24px;padding-inline-start:24px;-webkit-padding-end:24px;padding-inline-end:24px;padding-top:20px;padding-bottom:20px;color:var(--ion-color-step-550, #737373)}.alert-message.sc-ion-alert-md{font-size:1rem}@media screen and (max-width: 767px){.alert-message.sc-ion-alert-md{max-height:266px}}.alert-message.sc-ion-alert-md:empty{padding-left:0;padding-right:0;padding-top:0;padding-bottom:0}.alert-head.sc-ion-alert-md+.alert-message.sc-ion-alert-md{padding-top:0}.alert-input.sc-ion-alert-md{margin-left:0;margin-right:0;margin-top:5px;margin-bottom:5px;border-bottom:1px solid var(--ion-color-step-150, #d9d9d9);color:var(--ion-text-color, #000)}.alert-input.sc-ion-alert-md::-webkit-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-moz-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md:-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-ms-input-placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::placeholder{color:var(--ion-placeholder-color, var(--ion-color-step-400, #999999));font-family:inherit;font-weight:inherit}.alert-input.sc-ion-alert-md::-ms-clear{display:none}.alert-input.sc-ion-alert-md:focus{margin-bottom:4px;border-bottom:2px solid var(--ion-color-primary, #3880ff)}.alert-radio-group.sc-ion-alert-md,.alert-checkbox-group.sc-ion-alert-md{position:relative;border-top:1px solid var(--ion-color-step-150, #d9d9d9);border-bottom:1px solid var(--ion-color-step-150, #d9d9d9);overflow:auto}@media screen and (max-width: 767px){.alert-radio-group.sc-ion-alert-md,.alert-checkbox-group.sc-ion-alert-md{max-height:266px}}.alert-tappable.sc-ion-alert-md{position:relative;min-height:48px}.alert-radio-label.sc-ion-alert-md{-webkit-padding-start:52px;padding-inline-start:52px;-webkit-padding-end:26px;padding-inline-end:26px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;color:var(--ion-color-step-850, #262626);font-size:1rem}.alert-radio-icon.sc-ion-alert-md{top:0;border-radius:50%;display:block;position:relative;width:20px;height:20px;border-width:2px;border-style:solid;border-color:var(--ion-color-step-550, #737373)}@supports (inset-inline-start: 0){.alert-radio-icon.sc-ion-alert-md{inset-inline-start:26px}}@supports not (inset-inline-start: 0){.alert-radio-icon.sc-ion-alert-md{left:26px}[dir=rtl].sc-ion-alert-md-h .alert-radio-icon.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-radio-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}[dir=rtl].sc-ion-alert-md .alert-radio-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}@supports selector(:dir(rtl)){.alert-radio-icon.sc-ion-alert-md:dir(rtl){left:unset;right:unset;right:26px}}}.alert-radio-inner.sc-ion-alert-md{top:3px;border-radius:50%;position:absolute;width:10px;height:10px;-webkit-transform:scale3d(0, 0, 0);transform:scale3d(0, 0, 0);-webkit-transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1);transition:transform 280ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:var(--ion-color-primary, #3880ff)}@supports (inset-inline-start: 0){.alert-radio-inner.sc-ion-alert-md{inset-inline-start:3px}}@supports not (inset-inline-start: 0){.alert-radio-inner.sc-ion-alert-md{left:3px}[dir=rtl].sc-ion-alert-md-h .alert-radio-inner.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-radio-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}[dir=rtl].sc-ion-alert-md .alert-radio-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}@supports selector(:dir(rtl)){.alert-radio-inner.sc-ion-alert-md:dir(rtl){left:unset;right:unset;right:3px}}}[aria-checked=true].sc-ion-alert-md .alert-radio-label.sc-ion-alert-md{color:var(--ion-color-step-850, #262626)}[aria-checked=true].sc-ion-alert-md .alert-radio-icon.sc-ion-alert-md{border-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-md .alert-radio-inner.sc-ion-alert-md{-webkit-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1)}.alert-checkbox-label.sc-ion-alert-md{-webkit-padding-start:53px;padding-inline-start:53px;-webkit-padding-end:26px;padding-inline-end:26px;padding-top:13px;padding-bottom:13px;-ms-flex:1;flex:1;width:calc(100% - 53px);color:var(--ion-color-step-850, #262626);font-size:1rem}.alert-checkbox-icon.sc-ion-alert-md{top:0;border-radius:2px;position:relative;width:16px;height:16px;border-width:2px;border-style:solid;border-color:var(--ion-color-step-550, #737373);contain:strict}@supports (inset-inline-start: 0){.alert-checkbox-icon.sc-ion-alert-md{inset-inline-start:26px}}@supports not (inset-inline-start: 0){.alert-checkbox-icon.sc-ion-alert-md{left:26px}[dir=rtl].sc-ion-alert-md-h .alert-checkbox-icon.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h .alert-checkbox-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}[dir=rtl].sc-ion-alert-md .alert-checkbox-icon.sc-ion-alert-md{left:unset;right:unset;right:26px}@supports selector(:dir(rtl)){.alert-checkbox-icon.sc-ion-alert-md:dir(rtl){left:unset;right:unset;right:26px}}}[aria-checked=true].sc-ion-alert-md .alert-checkbox-icon.sc-ion-alert-md{border-color:var(--ion-color-primary, #3880ff);background-color:var(--ion-color-primary, #3880ff)}[aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{top:0;position:absolute;width:6px;height:10px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-width:2px;border-top-width:0;border-left-width:0;border-style:solid;border-color:var(--ion-color-primary-contrast, #fff)}@supports (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{inset-inline-start:3px}}@supports not (inset-inline-start: 0){[aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{left:3px}[dir=rtl].sc-ion-alert-md-h [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md,[dir=rtl] .sc-ion-alert-md-h [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}[dir=rtl].sc-ion-alert-md [aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md{left:unset;right:unset;right:3px}@supports selector(:dir(rtl)){[aria-checked=true].sc-ion-alert-md .alert-checkbox-inner.sc-ion-alert-md:dir(rtl){left:unset;right:unset;right:3px}}}.alert-button-group.sc-ion-alert-md{-webkit-padding-start:8px;padding-inline-start:8px;-webkit-padding-end:8px;padding-inline-end:8px;padding-top:8px;padding-bottom:8px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse;-ms-flex-pack:end;justify-content:flex-end}.alert-button.sc-ion-alert-md{border-radius:2px;-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:8px;margin-inline-end:8px;margin-top:0;margin-bottom:0;-webkit-padding-start:10px;padding-inline-start:10px;-webkit-padding-end:10px;padding-inline-end:10px;padding-top:10px;padding-bottom:10px;position:relative;background-color:transparent;color:var(--ion-color-primary, #3880ff);font-weight:500;text-align:end;text-transform:uppercase;overflow:hidden}.alert-button-inner.sc-ion-alert-md{-ms-flex-pack:end;justify-content:flex-end}@media screen and (min-width: 768px){.sc-ion-alert-md-h{--max-width:min(100vw - 96px, 560px);--max-height:min(100vh - 96px, 560px)}}", Alert = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.didPresent = createEvent(this, "ionAlertDidPresent", 7), this.willPresent = createEvent(this, "ionAlertWillPresent", 7), this.willDismiss = createEvent(this, "ionAlertWillDismiss", 7), this.didDismiss = createEvent(this, "ionAlertDidDismiss", 7), this.didPresentShorthand = createEvent(this, "didPresent", 7), this.willPresentShorthand = createEvent(this, "willPresent", 7), this.willDismissShorthand = createEvent(this, "willDismiss", 7), this.didDismissShorthand = createEvent(this, "didDismiss", 7), this.delegateController = createDelegateController(this), this.lockController = createLockController(), this.triggerController = createTriggerController(), this.customHTMLEnabled = config$1.get("innerHTMLTemplatesEnabled", ENABLE_HTML_CONTENT_DEFAULT), this.processedInputs = [], this.processedButtons = [], this.presented = !1, this.onBackdropTap = () => {
      this.dismiss(void 0, BACKDROP);
    }, this.dispatchCancelHandler = (e) => {
      const r = e.detail.role;
      if (isCancel$2(r)) {
        const o = this.processedButtons.find((a) => a.role === "cancel");
        this.callButtonHandler(o);
      }
    }, this.overlayIndex = void 0, this.delegate = void 0, this.hasController = !1, this.keyboardClose = !0, this.enterAnimation = void 0, this.leaveAnimation = void 0, this.cssClass = void 0, this.header = void 0, this.subHeader = void 0, this.message = void 0, this.buttons = [], this.inputs = [], this.backdropDismiss = !0, this.translucent = !1, this.animated = !0, this.htmlAttributes = void 0, this.isOpen = !1, this.trigger = void 0;
  }
  onIsOpenChange(e, r) {
    e === !0 && r === !1 ? this.present() : e === !1 && r === !0 && this.dismiss();
  }
  triggerChanged() {
    const { trigger: e, el: r, triggerController: o } = this;
    e && o.addClickListener(r, e);
  }
  onKeydown(e) {
    const r = new Set(this.processedInputs.map((d) => d.type));
    if (r.has("checkbox") && e.key === "Enter") {
      e.preventDefault();
      return;
    }
    if (!r.has("radio") || e.target && !this.el.contains(e.target) || e.target.classList.contains("alert-button"))
      return;
    const o = this.el.querySelectorAll(".alert-radio"), a = Array.from(o).filter((d) => !d.disabled), c = a.findIndex((d) => d.id === e.target.id);
    let u;
    if (["ArrowDown", "ArrowRight"].includes(e.key) && (u = c === a.length - 1 ? a[0] : a[c + 1]), ["ArrowUp", "ArrowLeft"].includes(e.key) && (u = c === 0 ? a[a.length - 1] : a[c - 1]), u && a.includes(u)) {
      const d = this.processedInputs.find((p) => p.id === (u == null ? void 0 : u.id));
      d && (this.rbClick(d), u.focus());
    }
  }
  buttonsChanged() {
    const e = this.buttons;
    this.processedButtons = e.map((r) => typeof r == "string" ? { text: r, role: r.toLowerCase() === "cancel" ? "cancel" : void 0 } : r);
  }
  inputsChanged() {
    const e = this.inputs, r = e.find((u) => !u.disabled), a = e.find((u) => u.checked && !u.disabled) || r, c = new Set(e.map((u) => u.type));
    c.has("checkbox") && c.has("radio") && console.warn(`Alert cannot mix input types: ${Array.from(c.values()).join("/")}. Please see alert docs for more info.`), this.inputType = c.values().next().value, this.processedInputs = e.map((u, d) => {
      var p;
      return {
        type: u.type || "text",
        name: u.name || `${d}`,
        placeholder: u.placeholder || "",
        value: u.value,
        label: u.label,
        checked: !!u.checked,
        disabled: !!u.disabled,
        id: u.id || `alert-input-${this.overlayIndex}-${d}`,
        handler: u.handler,
        min: u.min,
        max: u.max,
        cssClass: (p = u.cssClass) !== null && p !== void 0 ? p : "",
        attributes: u.attributes || {},
        tabindex: u.type === "radio" && u !== a ? -1 : 0
      };
    });
  }
  connectedCallback() {
    prepareOverlay(this.el), this.triggerChanged();
  }
  componentWillLoad() {
    setOverlayId(this.el), this.inputsChanged(), this.buttonsChanged();
  }
  disconnectedCallback() {
    this.triggerController.removeClickListener(), this.gesture && (this.gesture.destroy(), this.gesture = void 0);
  }
  componentDidLoad() {
    !this.gesture && getIonMode$2(this) === "ios" && this.wrapperEl && (this.gesture = createButtonActiveGesture(this.wrapperEl, (e) => e.classList.contains("alert-button")), this.gesture.enable(!0)), this.isOpen === !0 && raf(() => this.present()), this.triggerChanged();
  }
  /**
   * Present the alert overlay after it has been created.
   */
  async present() {
    const e = await this.lockController.lock();
    await this.delegateController.attachViewToDom(), await present(this, "alertEnter", iosEnterAnimation$2, mdEnterAnimation$2), e();
  }
  /**
   * Dismiss the alert overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the alert.
   * This can be useful in a button handler for determining which button was
   * clicked to dismiss the alert.
   * Some examples include: ``"cancel"`, `"destructive"`, "selected"`, and `"backdrop"`.
   */
  async dismiss(e, r) {
    const o = await this.lockController.lock(), a = await dismiss(this, e, r, "alertLeave", iosLeaveAnimation$2, mdLeaveAnimation$2);
    return a && this.delegateController.removeViewFromDom(), o(), a;
  }
  /**
   * Returns a promise that resolves when the alert did dismiss.
   */
  onDidDismiss() {
    return eventMethod(this.el, "ionAlertDidDismiss");
  }
  /**
   * Returns a promise that resolves when the alert will dismiss.
   */
  onWillDismiss() {
    return eventMethod(this.el, "ionAlertWillDismiss");
  }
  rbClick(e) {
    for (const r of this.processedInputs)
      r.checked = r === e, r.tabindex = r === e ? 0 : -1;
    this.activeId = e.id, safeCall(e.handler, e), forceUpdate(this);
  }
  cbClick(e) {
    e.checked = !e.checked, safeCall(e.handler, e), forceUpdate(this);
  }
  async buttonClick(e) {
    const r = e.role, o = this.getValues();
    if (isCancel$2(r))
      return this.dismiss({ values: o }, r);
    const a = await this.callButtonHandler(e, o);
    return a !== !1 ? this.dismiss(Object.assign({ values: o }, a), e.role) : !1;
  }
  async callButtonHandler(e, r) {
    if (e != null && e.handler) {
      const o = await safeCall(e.handler, r);
      if (o === !1)
        return !1;
      if (typeof o == "object")
        return o;
    }
    return {};
  }
  getValues() {
    if (this.processedInputs.length === 0)
      return;
    if (this.inputType === "radio") {
      const r = this.processedInputs.find((o) => !!o.checked);
      return r ? r.value : void 0;
    }
    if (this.inputType === "checkbox")
      return this.processedInputs.filter((r) => r.checked).map((r) => r.value);
    const e = {};
    return this.processedInputs.forEach((r) => {
      e[r.name] = r.value || "";
    }), e;
  }
  renderAlertInputs() {
    switch (this.inputType) {
      case "checkbox":
        return this.renderCheckbox();
      case "radio":
        return this.renderRadio();
      default:
        return this.renderInput();
    }
  }
  renderCheckbox() {
    const e = this.processedInputs, r = getIonMode$2(this);
    return e.length === 0 ? null : h("div", { class: "alert-checkbox-group" }, e.map((o) => h("button", { type: "button", onClick: () => this.cbClick(o), "aria-checked": `${o.checked}`, id: o.id, disabled: o.disabled, tabIndex: o.tabindex, role: "checkbox", class: Object.assign(Object.assign({}, getClassMap(o.cssClass)), { "alert-tappable": !0, "alert-checkbox": !0, "alert-checkbox-button": !0, "ion-focusable": !0, "alert-checkbox-button-disabled": o.disabled || !1 }) }, h("div", { class: "alert-button-inner" }, h("div", { class: "alert-checkbox-icon" }, h("div", { class: "alert-checkbox-inner" })), h("div", { class: "alert-checkbox-label" }, o.label)), r === "md" && h("ion-ripple-effect", null))));
  }
  renderRadio() {
    const e = this.processedInputs;
    return e.length === 0 ? null : h("div", { class: "alert-radio-group", role: "radiogroup", "aria-activedescendant": this.activeId }, e.map((r) => h("button", { type: "button", onClick: () => this.rbClick(r), "aria-checked": `${r.checked}`, disabled: r.disabled, id: r.id, tabIndex: r.tabindex, class: Object.assign(Object.assign({}, getClassMap(r.cssClass)), { "alert-radio-button": !0, "alert-tappable": !0, "alert-radio": !0, "ion-focusable": !0, "alert-radio-button-disabled": r.disabled || !1 }), role: "radio" }, h("div", { class: "alert-button-inner" }, h("div", { class: "alert-radio-icon" }, h("div", { class: "alert-radio-inner" })), h("div", { class: "alert-radio-label" }, r.label)))));
  }
  renderInput() {
    const e = this.processedInputs;
    return e.length === 0 ? null : h("div", { class: "alert-input-group" }, e.map((r) => {
      var o, a, c, u;
      return r.type === "textarea" ? h("div", { class: "alert-input-wrapper" }, h("textarea", Object.assign({ placeholder: r.placeholder, value: r.value, id: r.id, tabIndex: r.tabindex }, r.attributes, { disabled: (a = (o = r.attributes) === null || o === void 0 ? void 0 : o.disabled) !== null && a !== void 0 ? a : r.disabled, class: inputClass(r), onInput: (d) => {
        var p;
        r.value = d.target.value, !((p = r.attributes) === null || p === void 0) && p.onInput && r.attributes.onInput(d);
      } }))) : h("div", { class: "alert-input-wrapper" }, h("input", Object.assign({ placeholder: r.placeholder, type: r.type, min: r.min, max: r.max, value: r.value, id: r.id, tabIndex: r.tabindex }, r.attributes, { disabled: (u = (c = r.attributes) === null || c === void 0 ? void 0 : c.disabled) !== null && u !== void 0 ? u : r.disabled, class: inputClass(r), onInput: (d) => {
        var p;
        r.value = d.target.value, !((p = r.attributes) === null || p === void 0) && p.onInput && r.attributes.onInput(d);
      } })));
    }));
  }
  renderAlertButtons() {
    const e = this.processedButtons, r = getIonMode$2(this), o = {
      "alert-button-group": !0,
      "alert-button-group-vertical": e.length > 2
    };
    return h("div", { class: o }, e.map((a) => h("button", Object.assign({}, a.htmlAttributes, { type: "button", id: a.id, class: buttonClass$1(a), tabIndex: 0, onClick: () => this.buttonClick(a) }), h("span", { class: "alert-button-inner" }, a.text), r === "md" && h("ion-ripple-effect", null))));
  }
  renderAlertMessage(e) {
    const { customHTMLEnabled: r, message: o } = this;
    return r ? h("div", { id: e, class: "alert-message", innerHTML: sanitizeDOMString(o) }) : h("div", { id: e, class: "alert-message" }, o);
  }
  render() {
    const { overlayIndex: e, header: r, subHeader: o, message: a, htmlAttributes: c } = this, u = getIonMode$2(this), d = `alert-${e}-hdr`, p = `alert-${e}-sub-hdr`, g = `alert-${e}-msg`, b = this.inputs.length > 0 || this.buttons.length > 0 ? "alertdialog" : "alert";
    return h(Host, Object.assign({ role: b, "aria-modal": "true", "aria-labelledby": r ? d : o ? p : null, "aria-describedby": a !== void 0 ? g : null, tabindex: "-1" }, c, { style: {
      zIndex: `${2e4 + e}`
    }, class: Object.assign(Object.assign({}, getClassMap(this.cssClass)), { [u]: !0, "overlay-hidden": !0, "alert-translucent": this.translucent }), onIonAlertWillDismiss: this.dispatchCancelHandler, onIonBackdropTap: this.onBackdropTap }), h("ion-backdrop", { tappable: this.backdropDismiss }), h("div", { tabindex: "0" }), h("div", { class: "alert-wrapper ion-overlay-wrapper", ref: (w) => this.wrapperEl = w }, h("div", { class: "alert-head" }, r && h("h2", { id: d, class: "alert-title" }, r), o && h("h2", { id: p, class: "alert-sub-title" }, o)), this.renderAlertMessage(g), this.renderAlertInputs(), this.renderAlertButtons()), h("div", { tabindex: "0" }));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      isOpen: ["onIsOpenChange"],
      trigger: ["triggerChanged"],
      buttons: ["buttonsChanged"],
      inputs: ["inputsChanged"]
    };
  }
  static get style() {
    return {
      ios: alertIosCss,
      md: alertMdCss
    };
  }
}, [34, "ion-alert", {
  overlayIndex: [2, "overlay-index"],
  delegate: [16],
  hasController: [4, "has-controller"],
  keyboardClose: [4, "keyboard-close"],
  enterAnimation: [16],
  leaveAnimation: [16],
  cssClass: [1, "css-class"],
  header: [1],
  subHeader: [1, "sub-header"],
  message: [1],
  buttons: [16],
  inputs: [1040],
  backdropDismiss: [4, "backdrop-dismiss"],
  translucent: [4],
  animated: [4],
  htmlAttributes: [16],
  isOpen: [4, "is-open"],
  trigger: [1],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}, [[4, "keydown", "onKeydown"]], {
  isOpen: ["onIsOpenChange"],
  trigger: ["triggerChanged"],
  buttons: ["buttonsChanged"],
  inputs: ["inputsChanged"]
}]), inputClass = (t) => {
  var e, r, o;
  return Object.assign(Object.assign({ "alert-input": !0, "alert-input-disabled": ((r = (e = t.attributes) === null || e === void 0 ? void 0 : e.disabled) !== null && r !== void 0 ? r : t.disabled) || !1 }, getClassMap(t.cssClass)), getClassMap(t.attributes ? (o = t.attributes.class) === null || o === void 0 ? void 0 : o.toString() : ""));
}, buttonClass$1 = (t) => Object.assign({ "alert-button": !0, "ion-focusable": !0, "ion-activatable": !0, [`alert-button-role-${t.role}`]: t.role !== void 0 }, getClassMap(t.cssClass));
function defineCustomElement$e() {
  if (typeof customElements > "u")
    return;
  ["ion-alert", "ion-backdrop", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-alert":
        customElements.get(e) || customElements.define(e, Alert);
        break;
      case "ion-backdrop":
        customElements.get(e) || defineCustomElement$R();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const selectPopoverIosCss = ".sc-ion-select-popover-ios-h ion-list.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-ios,ion-label.sc-ion-select-popover-ios{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}", selectPopoverMdCss = ".sc-ion-select-popover-md-h ion-list.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list-header.sc-ion-select-popover-md,ion-label.sc-ion-select-popover-md{margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}ion-list.sc-ion-select-popover-md ion-radio.sc-ion-select-popover-md::part(container){opacity:0}ion-item.sc-ion-select-popover-md{--inner-border-width:0}.item-radio-checked.sc-ion-select-popover-md{--background:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08);--background-focused:var(--ion-color-primary, #3880ff);--background-focused-opacity:0.2;--background-hover:var(--ion-color-primary, #3880ff);--background-hover-opacity:0.12}.item-checkbox-checked.sc-ion-select-popover-md{--background-activated:var(--ion-item-color, var(--ion-text-color, #000));--background-focused:var(--ion-item-color, var(--ion-text-color, #000));--background-hover:var(--ion-item-color, var(--ion-text-color, #000));--color:var(--ion-color-primary, #3880ff)}", SelectPopover = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.header = void 0, this.subHeader = void 0, this.message = void 0, this.multiple = void 0, this.options = [];
  }
  findOptionFromEvent(e) {
    const { options: r } = this;
    return r.find((o) => o.value === e.target.value);
  }
  /**
   * When an option is selected we need to get the value(s)
   * of the selected option(s) and return it in the option
   * handler
   */
  callOptionHandler(e) {
    const r = this.findOptionFromEvent(e), o = this.getValues(e);
    r != null && r.handler && safeCall(r.handler, o);
  }
  /**
   * Dismisses the host popover that the `ion-select-popover`
   * is rendered within.
   */
  dismissParentPopover() {
    const e = this.el.closest("ion-popover");
    e && e.dismiss();
  }
  setChecked(e) {
    const { multiple: r } = this, o = this.findOptionFromEvent(e);
    r && o && (o.checked = e.detail.checked);
  }
  getValues(e) {
    const { multiple: r, options: o } = this;
    if (r)
      return o.filter((c) => c.checked).map((c) => c.value);
    const a = this.findOptionFromEvent(e);
    return a ? a.value : void 0;
  }
  renderOptions(e) {
    const { multiple: r } = this;
    switch (r) {
      case !0:
        return this.renderCheckboxOptions(e);
      default:
        return this.renderRadioOptions(e);
    }
  }
  renderCheckboxOptions(e) {
    return e.map((r) => h("ion-item", { class: Object.assign({
      // TODO FW-4784
      "item-checkbox-checked": r.checked
    }, getClassMap(r.cssClass)) }, h("ion-checkbox", { value: r.value, disabled: r.disabled, checked: r.checked, justify: "start", labelPlacement: "end", onIonChange: (o) => {
      this.setChecked(o), this.callOptionHandler(o), forceUpdate(this);
    } }, r.text)));
  }
  renderRadioOptions(e) {
    const r = e.filter((o) => o.checked).map((o) => o.value)[0];
    return h("ion-radio-group", { value: r, onIonChange: (o) => this.callOptionHandler(o) }, e.map((o) => h("ion-item", { class: Object.assign({
      // TODO FW-4784
      "item-radio-checked": o.value === r
    }, getClassMap(o.cssClass)) }, h("ion-radio", { value: o.value, disabled: o.disabled, onClick: () => this.dismissParentPopover(), onKeyUp: (a) => {
      a.key === " " && this.dismissParentPopover();
    } }, o.text))));
  }
  render() {
    const { header: e, message: r, options: o, subHeader: a } = this, c = a !== void 0 || r !== void 0;
    return h(Host, { class: getIonMode$2(this) }, h("ion-list", null, e !== void 0 && h("ion-list-header", null, e), c && h("ion-item", null, h("ion-label", { class: "ion-text-wrap" }, a !== void 0 && h("h3", null, a), r !== void 0 && h("p", null, r))), this.renderOptions(o)));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: selectPopoverIosCss,
      md: selectPopoverMdCss
    };
  }
}, [34, "ion-select-popover", {
  header: [1],
  subHeader: [1, "sub-header"],
  message: [1],
  multiple: [4],
  options: [16]
}]);
function defineCustomElement$d() {
  if (typeof customElements > "u")
    return;
  ["ion-select-popover", "ion-checkbox", "ion-icon", "ion-item", "ion-label", "ion-list", "ion-list-header", "ion-note", "ion-radio", "ion-radio-group", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-select-popover":
        customElements.get(e) || customElements.define(e, SelectPopover);
        break;
      case "ion-checkbox":
        customElements.get(e) || defineCustomElement$G();
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-item":
        customElements.get(e) || defineCustomElement$C();
        break;
      case "ion-label":
        customElements.get(e) || defineCustomElement$B();
        break;
      case "ion-list":
        customElements.get(e) || defineCustomElement$s();
        break;
      case "ion-list-header":
        customElements.get(e) || defineCustomElement$q();
        break;
      case "ion-note":
        customElements.get(e) || defineCustomElement$D();
        break;
      case "ion-radio":
        customElements.get(e) || defineCustomElement$m();
        break;
      case "ion-radio-group":
        customElements.get(e) || defineCustomElement$k();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const selectIosCss = ":host{--padding-top:0px;--padding-end:0px;--padding-bottom:0px;--padding-start:0px;--placeholder-color:currentColor;--placeholder-opacity:0.6;--background:transparent;--border-style:solid;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);--highlight-color:var(--highlight-color-focused);display:block;position:relative;font-family:var(--ion-font-family, inherit);white-space:nowrap;cursor:pointer;z-index:2}:host(:not(.legacy-select)){width:100%;min-height:44px}:host(.select-label-placement-floating),:host(.select-label-placement-stacked){min-height:56px}:host(.ion-color){--highlight-color-focused:var(--ion-color-base)}:host(.legacy-select){-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden}:host(.in-item:not(.legacy-select)){-ms-flex:1 1 0px;flex:1 1 0}:host(.in-item.legacy-select){position:static;max-width:45%}:host(.select-disabled){pointer-events:none}:host(.ion-focused) button{border:2px solid #5e9ed6}:host([slot=start]:not(.legacy-select)),:host([slot=end]:not(.legacy-select)){width:auto}.select-placeholder{color:var(--placeholder-color);opacity:var(--placeholder-opacity)}:host(.legacy-select) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-select) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-select) label{left:0}:host-context([dir=rtl]):host(.legacy-select) label,:host-context([dir=rtl]).legacy-select label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-select:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-select) label::-moz-focus-inner{border:0}button{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.select-icon{-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:0;margin-inline-end:0;margin-top:0;margin-bottom:0;position:relative;-ms-flex-negative:0;flex-shrink:0}:host(.in-item-color) .select-icon{color:inherit}:host(.select-label-placement-stacked) .select-icon,:host(.select-label-placement-floating) .select-icon{position:absolute;height:100%}:host(.select-ltr.select-label-placement-stacked) .select-icon,:host(.select-ltr.select-label-placement-floating) .select-icon{right:var(--padding-end, 0)}:host(.select-rtl.select-label-placement-stacked) .select-icon,:host(.select-rtl.select-label-placement-floating) .select-icon{left:var(--padding-start, 0)}.select-text{-ms-flex:1;flex:1;min-width:16px;font-size:inherit;text-overflow:ellipsis;white-space:inherit;overflow:hidden}.select-wrapper{-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);border-radius:var(--border-radius);display:-ms-flexbox;display:flex;position:relative;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;min-height:inherit;-webkit-transition:background-color 15ms linear;transition:background-color 15ms linear;background:var(--background);line-height:normal;cursor:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.select-wrapper .select-placeholder{-webkit-transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)}.select-wrapper-inner{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden}:host(.select-label-placement-stacked) .select-wrapper-inner,:host(.select-label-placement-floating) .select-wrapper-inner{-ms-flex-positive:1;flex-grow:1}:host(.ion-touched.ion-invalid){--highlight-color:var(--highlight-color-invalid)}:host(.ion-valid){--highlight-color:var(--highlight-color-valid)}.label-text-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;max-width:200px;-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);pointer-events:none}.label-text,::slotted([slot=label]){text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.label-text-wrapper-hidden,.select-outline-notch-hidden{display:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);overflow:hidden}:host(.select-justify-space-between) .select-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.select-justify-start) .select-wrapper{-ms-flex-pack:start;justify-content:start}:host(.select-justify-end) .select-wrapper{-ms-flex-pack:end;justify-content:end}:host(.select-label-placement-start) .select-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.select-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:0;margin-bottom:0}:host(.select-label-placement-end) .select-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.select-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0;margin-top:0;margin-bottom:0}:host(.select-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:0;margin-bottom:0}:host(.select-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}:host(.select-label-placement-stacked) .select-wrapper,:host(.select-label-placement-floating) .select-wrapper{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:start}:host(.select-label-placement-stacked) .label-text-wrapper,:host(.select-label-placement-floating) .label-text-wrapper{max-width:100%}:host(.select-ltr.select-label-placement-stacked) .label-text-wrapper,:host(.select-ltr.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host(.select-rtl.select-label-placement-stacked) .label-text-wrapper,:host(.select-rtl.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}:host(.select-label-placement-stacked) .native-wrapper,:host(.select-label-placement-floating) .native-wrapper{margin-left:0;margin-right:0;margin-top:1px;margin-bottom:0;-ms-flex-positive:1;flex-grow:1;width:100%}:host(.select-label-placement-floating) .label-text-wrapper{-webkit-transform:translateY(100%) scale(1);transform:translateY(100%) scale(1)}:host(.select-label-placement-floating:not(.label-floating)) .native-wrapper .select-placeholder{opacity:0}:host(.select-expanded.select-label-placement-floating) .native-wrapper .select-placeholder,:host(.ion-focused.select-label-placement-floating) .native-wrapper .select-placeholder,:host(.has-value.select-label-placement-floating) .native-wrapper .select-placeholder{opacity:1}:host(.label-floating) .label-text-wrapper{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75);max-width:calc(100% / 0.75)}::slotted([slot=start]),::slotted([slot=end]){-ms-flex-negative:0;flex-shrink:0}::slotted([slot=start]){-webkit-margin-end:16px;margin-inline-end:16px;-webkit-margin-start:0;margin-inline-start:0}::slotted([slot=end]){-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.legacy-select){--padding-top:10px;--padding-end:8px;--padding-bottom:10px;--padding-start:16px}.select-icon{width:1.125rem;height:1.125rem;color:var(--ion-color-step-650, #595959)}:host(.select-label-placement-stacked) .select-wrapper-inner,:host(.select-label-placement-floating) .select-wrapper-inner{width:calc(100% - 1.125rem - 4px)}:host(.select-disabled){opacity:0.3}::slotted(ion-button[slot=start].button-has-icon-only),::slotted(ion-button[slot=end].button-has-icon-only){--border-radius:50%;--padding-start:0;--padding-end:0;--padding-top:0;--padding-bottom:0;aspect-ratio:1}", selectMdCss = ":host{--padding-top:0px;--padding-end:0px;--padding-bottom:0px;--padding-start:0px;--placeholder-color:currentColor;--placeholder-opacity:0.6;--background:transparent;--border-style:solid;--highlight-color-focused:var(--ion-color-primary, #3880ff);--highlight-color-valid:var(--ion-color-success, #2dd36f);--highlight-color-invalid:var(--ion-color-danger, #eb445a);--highlight-color:var(--highlight-color-focused);display:block;position:relative;font-family:var(--ion-font-family, inherit);white-space:nowrap;cursor:pointer;z-index:2}:host(:not(.legacy-select)){width:100%;min-height:44px}:host(.select-label-placement-floating),:host(.select-label-placement-stacked){min-height:56px}:host(.ion-color){--highlight-color-focused:var(--ion-color-base)}:host(.legacy-select){-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden}:host(.in-item:not(.legacy-select)){-ms-flex:1 1 0px;flex:1 1 0}:host(.in-item.legacy-select){position:static;max-width:45%}:host(.select-disabled){pointer-events:none}:host(.ion-focused) button{border:2px solid #5e9ed6}:host([slot=start]:not(.legacy-select)),:host([slot=end]:not(.legacy-select)){width:auto}.select-placeholder{color:var(--placeholder-color);opacity:var(--placeholder-opacity)}:host(.legacy-select) label{top:0;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;opacity:0}@supports (inset-inline-start: 0){:host(.legacy-select) label{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.legacy-select) label{left:0}:host-context([dir=rtl]):host(.legacy-select) label,:host-context([dir=rtl]).legacy-select label{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.legacy-select:dir(rtl)) label{left:unset;right:unset;right:0}}}:host(.legacy-select) label::-moz-focus-inner{border:0}button{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;margin:0;padding:0;border:0;outline:0;clip:rect(0 0 0 0);opacity:0;overflow:hidden;-webkit-appearance:none;-moz-appearance:none}.select-icon{-webkit-margin-start:4px;margin-inline-start:4px;-webkit-margin-end:0;margin-inline-end:0;margin-top:0;margin-bottom:0;position:relative;-ms-flex-negative:0;flex-shrink:0}:host(.in-item-color) .select-icon{color:inherit}:host(.select-label-placement-stacked) .select-icon,:host(.select-label-placement-floating) .select-icon{position:absolute;height:100%}:host(.select-ltr.select-label-placement-stacked) .select-icon,:host(.select-ltr.select-label-placement-floating) .select-icon{right:var(--padding-end, 0)}:host(.select-rtl.select-label-placement-stacked) .select-icon,:host(.select-rtl.select-label-placement-floating) .select-icon{left:var(--padding-start, 0)}.select-text{-ms-flex:1;flex:1;min-width:16px;font-size:inherit;text-overflow:ellipsis;white-space:inherit;overflow:hidden}.select-wrapper{-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);border-radius:var(--border-radius);display:-ms-flexbox;display:flex;position:relative;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center;height:inherit;min-height:inherit;-webkit-transition:background-color 15ms linear;transition:background-color 15ms linear;background:var(--background);line-height:normal;cursor:inherit;-webkit-box-sizing:border-box;box-sizing:border-box}.select-wrapper .select-placeholder{-webkit-transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)}.select-wrapper-inner{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow:hidden}:host(.select-label-placement-stacked) .select-wrapper-inner,:host(.select-label-placement-floating) .select-wrapper-inner{-ms-flex-positive:1;flex-grow:1}:host(.ion-touched.ion-invalid){--highlight-color:var(--highlight-color-invalid)}:host(.ion-valid){--highlight-color:var(--highlight-color-valid)}.label-text-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;max-width:200px;-webkit-transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:color 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 150ms cubic-bezier(0.4, 0, 0.2, 1);pointer-events:none}.label-text,::slotted([slot=label]){text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.label-text-wrapper-hidden,.select-outline-notch-hidden{display:none}.native-wrapper{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-webkit-transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);transition:opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);overflow:hidden}:host(.select-justify-space-between) .select-wrapper{-ms-flex-pack:justify;justify-content:space-between}:host(.select-justify-start) .select-wrapper{-ms-flex-pack:start;justify-content:start}:host(.select-justify-end) .select-wrapper{-ms-flex-pack:end;justify-content:end}:host(.select-label-placement-start) .select-wrapper{-ms-flex-direction:row;flex-direction:row}:host(.select-label-placement-start) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:0;margin-bottom:0}:host(.select-label-placement-end) .select-wrapper{-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.select-label-placement-end) .label-text-wrapper{-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0;margin-top:0;margin-bottom:0}:host(.select-label-placement-fixed) .label-text-wrapper{-webkit-margin-start:0;margin-inline-start:0;-webkit-margin-end:16px;margin-inline-end:16px;margin-top:0;margin-bottom:0}:host(.select-label-placement-fixed) .label-text-wrapper{-ms-flex:0 0 100px;flex:0 0 100px;width:100px;min-width:100px;max-width:200px}:host(.select-label-placement-stacked) .select-wrapper,:host(.select-label-placement-floating) .select-wrapper{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:start}:host(.select-label-placement-stacked) .label-text-wrapper,:host(.select-label-placement-floating) .label-text-wrapper{max-width:100%}:host(.select-ltr.select-label-placement-stacked) .label-text-wrapper,:host(.select-ltr.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host(.select-rtl.select-label-placement-stacked) .label-text-wrapper,:host(.select-rtl.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}:host(.select-label-placement-stacked) .native-wrapper,:host(.select-label-placement-floating) .native-wrapper{margin-left:0;margin-right:0;margin-top:1px;margin-bottom:0;-ms-flex-positive:1;flex-grow:1;width:100%}:host(.select-label-placement-floating) .label-text-wrapper{-webkit-transform:translateY(100%) scale(1);transform:translateY(100%) scale(1)}:host(.select-label-placement-floating:not(.label-floating)) .native-wrapper .select-placeholder{opacity:0}:host(.select-expanded.select-label-placement-floating) .native-wrapper .select-placeholder,:host(.ion-focused.select-label-placement-floating) .native-wrapper .select-placeholder,:host(.has-value.select-label-placement-floating) .native-wrapper .select-placeholder{opacity:1}:host(.label-floating) .label-text-wrapper{-webkit-transform:translateY(50%) scale(0.75);transform:translateY(50%) scale(0.75);max-width:calc(100% / 0.75)}::slotted([slot=start]),::slotted([slot=end]){-ms-flex-negative:0;flex-shrink:0}::slotted([slot=start]){-webkit-margin-end:16px;margin-inline-end:16px;-webkit-margin-start:0;margin-inline-start:0}::slotted([slot=end]){-webkit-margin-start:16px;margin-inline-start:16px;-webkit-margin-end:0;margin-inline-end:0}:host(.select-fill-solid){--background:var(--ion-color-step-50, #f2f2f2);--border-color:var(--ion-color-step-500, gray);--border-radius:4px;--padding-start:16px;--padding-end:16px;min-height:56px}:host(.select-fill-solid) .select-wrapper{border-bottom:var(--border-width) var(--border-style) var(--border-color)}:host(.has-focus.select-fill-solid.ion-valid),:host(.select-fill-solid.ion-touched.ion-invalid){--border-color:var(--highlight-color)}:host(.select-fill-solid) .select-bottom{border-top:none}@media (any-hover: hover){:host(.select-fill-solid:hover){--background:var(--ion-color-step-100, #e6e6e6);--border-color:var(--ion-color-step-750, #404040)}}:host(.select-fill-solid.select-expanded),:host(.select-fill-solid.ion-focused){--background:var(--ion-color-step-150, #d9d9d9);--border-color:var(--ion-color-step-750, #404040)}:host(.select-fill-solid) .select-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0px;border-bottom-left-radius:0px}:host-context([dir=rtl]):host(.select-fill-solid) .select-wrapper,:host-context([dir=rtl]).select-fill-solid .select-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0px;border-bottom-left-radius:0px}@supports selector(:dir(rtl)){:host(.select-fill-solid:dir(rtl)) .select-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0px;border-bottom-left-radius:0px}}:host(.label-floating.select-fill-solid) .label-text-wrapper{max-width:calc(100% / 0.75)}:host(.select-fill-outline){--border-color:var(--ion-color-step-300, #b3b3b3);--border-radius:4px;--padding-start:16px;--padding-end:16px;min-height:56px}:host(.select-fill-outline.select-shape-round){--border-radius:28px;--padding-start:32px;--padding-end:32px}:host(.has-focus.select-fill-outline.ion-valid),:host(.select-fill-outline.ion-touched.ion-invalid){--border-color:var(--highlight-color)}@media (any-hover: hover){:host(.select-fill-outline:hover){--border-color:var(--ion-color-step-750, #404040)}}:host(.select-fill-outline.select-expanded),:host(.select-fill-outline.ion-focused){--border-width:2px;--border-color:var(--highlight-color)}:host(.select-fill-outline) .select-bottom{border-top:none}:host(.select-fill-outline) .select-wrapper{border-bottom:none}:host(.select-ltr.select-fill-outline.select-label-placement-stacked) .label-text-wrapper,:host(.select-ltr.select-fill-outline.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:left top;transform-origin:left top}:host(.select-rtl.select-fill-outline.select-label-placement-stacked) .label-text-wrapper,:host(.select-rtl.select-fill-outline.select-label-placement-floating) .label-text-wrapper{-webkit-transform-origin:right top;transform-origin:right top}:host(.select-fill-outline.select-label-placement-stacked) .label-text-wrapper,:host(.select-fill-outline.select-label-placement-floating) .label-text-wrapper{position:absolute;max-width:calc(100% - var(--padding-start) - var(--padding-end))}:host(.select-fill-outline) .label-text-wrapper{position:relative;z-index:1}:host(.label-floating.select-fill-outline) .label-text-wrapper{-webkit-transform:translateY(-32%) scale(0.75);transform:translateY(-32%) scale(0.75);margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;max-width:calc((100% - var(--padding-start) - var(--padding-end) - 8px) / 0.75)}:host(.select-fill-outline.select-label-placement-stacked) select,:host(.select-fill-outline.select-label-placement-floating) select{margin-left:0;margin-right:0;margin-top:6px;margin-bottom:6px}:host(.select-fill-outline) .select-outline-container{left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;width:100%;height:100%}:host(.select-fill-outline) .select-outline-start,:host(.select-fill-outline) .select-outline-end{pointer-events:none}:host(.select-fill-outline) .select-outline-start,:host(.select-fill-outline) .select-outline-notch,:host(.select-fill-outline) .select-outline-end{border-top:var(--border-width) var(--border-style) var(--border-color);border-bottom:var(--border-width) var(--border-style) var(--border-color);-webkit-box-sizing:border-box;box-sizing:border-box}:host(.select-fill-outline) .select-outline-notch{max-width:calc(100% - var(--padding-start) - var(--padding-end))}:host(.select-fill-outline) .notch-spacer{-webkit-padding-end:8px;padding-inline-end:8px;font-size:calc(1em * 0.75);opacity:0;pointer-events:none}:host(.select-fill-outline) .select-outline-start{-webkit-border-start:var(--border-width) var(--border-style) var(--border-color);border-inline-start:var(--border-width) var(--border-style) var(--border-color)}:host(.select-ltr.select-fill-outline) .select-outline-start{border-radius:var(--border-radius) 0px 0px var(--border-radius)}:host(.select-rtl.select-fill-outline) .select-outline-start{border-radius:0px var(--border-radius) var(--border-radius) 0px}:host(.select-fill-outline) .select-outline-start{width:calc(var(--padding-start) - 4px)}:host(.select-fill-outline) .select-outline-end{-webkit-border-end:var(--border-width) var(--border-style) var(--border-color);border-inline-end:var(--border-width) var(--border-style) var(--border-color)}:host(.select-ltr.select-fill-outline) .select-outline-end{border-radius:0px var(--border-radius) var(--border-radius) 0px}:host(.select-rtl.select-fill-outline) .select-outline-end{border-radius:var(--border-radius) 0px 0px var(--border-radius)}:host(.select-fill-outline) .select-outline-end{-ms-flex-positive:1;flex-grow:1}:host(.label-floating.select-fill-outline) .select-outline-notch{border-top:none}:host{--border-width:1px;--border-color:var(--ion-item-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.13))))}:host(.legacy-select){--padding-top:10px;--padding-end:0;--padding-bottom:10px;--padding-start:16px}.select-icon{width:0.8125rem;-webkit-transition:-webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:-webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);transition:transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);color:var(--ion-color-step-500, gray)}:host(.select-label-placement-floating.select-expanded) .label-text-wrapper,:host(.select-label-placement-floating.ion-focused) .label-text-wrapper,:host(.select-label-placement-stacked.select-expanded) .label-text-wrapper,:host(.select-label-placement-stacked.ion-focused) .label-text-wrapper{color:var(--highlight-color)}:host(.has-focus.select-label-placement-floating.ion-valid) .label-text-wrapper,:host(.select-label-placement-floating.ion-touched.ion-invalid) .label-text-wrapper,:host(.has-focus.select-label-placement-stacked.ion-valid) .label-text-wrapper,:host(.select-label-placement-stacked.ion-touched.ion-invalid) .label-text-wrapper{color:var(--highlight-color)}.select-highlight{bottom:-1px;position:absolute;width:100%;height:2px;-webkit-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform 200ms;transition:-webkit-transform 200ms;transition:transform 200ms;transition:transform 200ms, -webkit-transform 200ms;background:var(--highlight-color)}@supports (inset-inline-start: 0){.select-highlight{inset-inline-start:0}}@supports not (inset-inline-start: 0){.select-highlight{left:0}:host-context([dir=rtl]) .select-highlight{left:unset;right:unset;right:0}[dir=rtl] .select-highlight{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){.select-highlight:dir(rtl){left:unset;right:unset;right:0}}}:host(.select-expanded) .select-highlight,:host(.ion-focused) .select-highlight{-webkit-transform:scale(1);transform:scale(1)}:host(.in-item) .select-highlight{bottom:0}@supports (inset-inline-start: 0){:host(.in-item) .select-highlight{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host(.in-item) .select-highlight{left:0}:host-context([dir=rtl]):host(.in-item) .select-highlight,:host-context([dir=rtl]).in-item .select-highlight{left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(.in-item:dir(rtl)) .select-highlight{left:unset;right:unset;right:0}}}:host(.select-expanded:not(.legacy-select):not(.has-expanded-icon)) .select-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host(.select-expanded) .select-wrapper .select-icon,:host(.has-focus.ion-valid) .select-wrapper .select-icon,:host(.ion-touched.ion-invalid) .select-wrapper .select-icon,:host(.ion-focused) .select-wrapper .select-icon{color:var(--highlight-color)}:host-context(.item-label-stacked) .select-icon,:host-context(.item-label-floating:not(.item-fill-outline)) .select-icon,:host-context(.item-label-floating.item-fill-outline){-webkit-transform:translate3d(0,  -9px,  0);transform:translate3d(0,  -9px,  0)}:host-context(.item-has-focus):host(:not(.has-expanded-icon)) .select-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host-context(.item-has-focus.item-label-stacked):host(:not(.has-expanded-icon)) .select-icon,:host-context(.item-has-focus.item-label-floating:not(.item-fill-outline)):host(:not(.has-expanded-icon)) .select-icon{-webkit-transform:translate3d(0,  -9px,  0) rotate(180deg);transform:translate3d(0,  -9px,  0) rotate(180deg)}:host(.select-shape-round){--border-radius:16px}:host(.select-label-placement-stacked) .select-wrapper-inner,:host(.select-label-placement-floating) .select-wrapper-inner{width:calc(100% - 0.8125rem - 4px)}:host(.select-disabled){opacity:0.38}::slotted(ion-button[slot=start].button-has-icon-only),::slotted(ion-button[slot=end].button-has-icon-only){--border-radius:50%;--padding-start:8px;--padding-end:8px;--padding-top:8px;--padding-bottom:8px;aspect-ratio:1;min-height:40px}", Select = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionChange = createEvent(this, "ionChange", 7), this.ionCancel = createEvent(this, "ionCancel", 7), this.ionDismiss = createEvent(this, "ionDismiss", 7), this.ionFocus = createEvent(this, "ionFocus", 7), this.ionBlur = createEvent(this, "ionBlur", 7), this.ionStyle = createEvent(this, "ionStyle", 7), this.inputId = `ion-sel-${selectIds++}`, this.inheritedAttributes = {}, this.hasLoggedDeprecationWarning = !1, this.onClick = (e) => {
      const r = e.target, o = r.closest('[slot="start"], [slot="end"]');
      r === this.el || o === null ? (this.setFocus(), this.open(e)) : (e.stopPropagation(), e.preventDefault());
    }, this.onFocus = () => {
      this.ionFocus.emit();
    }, this.onBlur = () => {
      this.ionBlur.emit();
    }, this.isExpanded = !1, this.cancelText = "Cancel", this.color = void 0, this.compareWith = void 0, this.disabled = !1, this.fill = void 0, this.interface = "alert", this.interfaceOptions = {}, this.justify = "space-between", this.label = void 0, this.labelPlacement = "start", this.legacy = void 0, this.multiple = !1, this.name = this.inputId, this.okText = "OK", this.placeholder = void 0, this.selectedText = void 0, this.toggleIcon = void 0, this.expandedIcon = void 0, this.shape = void 0, this.value = void 0;
  }
  styleChanged() {
    this.emitStyle();
  }
  setValue(e) {
    this.value = e, this.ionChange.emit({ value: e });
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAttributes$2(this.el, ["aria-label"]);
  }
  async connectedCallback() {
    const { el: e } = this;
    this.legacyFormController = createLegacyFormController(e), this.notchController = createNotchController(e, () => this.notchSpacerEl, () => this.labelSlot), this.updateOverlayOptions(), this.emitStyle(), this.mutationO = watchForOptions(this.el, "ion-select-option", async () => {
      this.updateOverlayOptions(), forceUpdate(this);
    });
  }
  disconnectedCallback() {
    this.mutationO && (this.mutationO.disconnect(), this.mutationO = void 0), this.notchController && (this.notchController.destroy(), this.notchController = void 0);
  }
  /**
   * Open the select overlay. The overlay is either an alert, action sheet, or popover,
   * depending on the `interface` property on the `ion-select`.
   *
   * @param event The user interface event that called the open.
   */
  async open(e) {
    if (this.disabled || this.isExpanded)
      return;
    this.isExpanded = !0;
    const r = this.overlay = await this.createOverlay(e);
    if (r.onDidDismiss().then(() => {
      this.overlay = void 0, this.isExpanded = !1, this.ionDismiss.emit(), this.setFocus();
    }), await r.present(), this.interface === "popover") {
      const o = this.childOpts.map((a) => a.value).indexOf(this.value);
      if (o > -1) {
        const a = r.querySelector(`.select-interface-option:nth-child(${o + 1})`);
        if (a) {
          focusElement(a);
          const c = a.querySelector("ion-radio, ion-checkbox");
          c && c.focus();
        }
      } else {
        const a = r.querySelector("ion-radio:not(.radio-disabled), ion-checkbox:not(.checkbox-disabled)");
        a && (focusElement(a.closest("ion-item")), a.focus());
      }
    }
    return r;
  }
  createOverlay(e) {
    let r = this.interface;
    return r === "action-sheet" && this.multiple && (console.warn(`Select interface cannot be "${r}" with a multi-value select. Using the "alert" interface instead.`), r = "alert"), r === "popover" && !e && (console.warn(`Select interface cannot be a "${r}" without passing an event. Using the "alert" interface instead.`), r = "alert"), r === "action-sheet" ? this.openActionSheet() : r === "popover" ? this.openPopover(e) : this.openAlert();
  }
  updateOverlayOptions() {
    const e = this.overlay;
    if (!e)
      return;
    const r = this.childOpts, o = this.value;
    switch (this.interface) {
      case "action-sheet":
        e.buttons = this.createActionSheetButtons(r, o);
        break;
      case "popover":
        const a = e.querySelector("ion-select-popover");
        a && (a.options = this.createPopoverOptions(r, o));
        break;
      case "alert":
        const c = this.multiple ? "checkbox" : "radio";
        e.inputs = this.createAlertInputs(r, c, o);
        break;
    }
  }
  createActionSheetButtons(e, r) {
    const o = e.map((a) => {
      const c = getOptionValue(a), u = Array.from(a.classList).filter((p) => p !== "hydrated").join(" "), d = `${OPTION_CLASS} ${u}`;
      return {
        role: isOptionSelected(r, c, this.compareWith) ? "selected" : "",
        text: a.textContent,
        cssClass: d,
        handler: () => {
          this.setValue(c);
        }
      };
    });
    return o.push({
      text: this.cancelText,
      role: "cancel",
      handler: () => {
        this.ionCancel.emit();
      }
    }), o;
  }
  createAlertInputs(e, r, o) {
    return e.map((c) => {
      const u = getOptionValue(c), d = Array.from(c.classList).filter((g) => g !== "hydrated").join(" "), p = `${OPTION_CLASS} ${d}`;
      return {
        type: r,
        cssClass: p,
        label: c.textContent || "",
        value: u,
        checked: isOptionSelected(o, u, this.compareWith),
        disabled: c.disabled
      };
    });
  }
  createPopoverOptions(e, r) {
    return e.map((a) => {
      const c = getOptionValue(a), u = Array.from(a.classList).filter((p) => p !== "hydrated").join(" "), d = `${OPTION_CLASS} ${u}`;
      return {
        text: a.textContent || "",
        cssClass: d,
        value: c,
        checked: isOptionSelected(r, c, this.compareWith),
        disabled: a.disabled,
        handler: (p) => {
          this.setValue(p), this.multiple || this.close();
        }
      };
    });
  }
  async openPopover(e) {
    const { fill: r, labelPlacement: o } = this, a = this.interfaceOptions, c = getIonMode$2(this), u = c !== "md", d = this.multiple, p = this.value;
    let g = e, b = "auto";
    if (this.legacyFormController.hasLegacyControl()) {
      const w = this.el.closest("ion-item");
      w && (w.classList.contains("item-label-floating") || w.classList.contains("item-label-stacked")) && (g = Object.assign(Object.assign({}, e), { detail: {
        ionShadowTarget: w
      } }), b = "cover");
    } else
      o === "floating" || o === "stacked" || c === "md" && r !== void 0 ? b = "cover" : g = Object.assign(Object.assign({}, e), { detail: {
        ionShadowTarget: this.nativeWrapperEl
      } });
    const x = Object.assign(Object.assign({
      mode: c,
      event: g,
      alignment: "center",
      size: b,
      showBackdrop: u
    }, a), { component: "ion-select-popover", cssClass: ["select-popover", a.cssClass], componentProps: {
      header: a.header,
      subHeader: a.subHeader,
      message: a.message,
      multiple: d,
      value: p,
      options: this.createPopoverOptions(this.childOpts, p)
    } });
    return popoverController.create(x);
  }
  async openActionSheet() {
    const e = getIonMode$2(this), r = this.interfaceOptions, o = Object.assign(Object.assign({ mode: e }, r), { buttons: this.createActionSheetButtons(this.childOpts, this.value), cssClass: ["select-action-sheet", r.cssClass] });
    return actionSheetController.create(o);
  }
  async openAlert() {
    let e, r;
    this.legacyFormController.hasLegacyControl() ? (e = this.getLabel(), r = e ? e.textContent : null) : r = this.labelText;
    const o = this.interfaceOptions, a = this.multiple ? "checkbox" : "radio", c = getIonMode$2(this), u = Object.assign(Object.assign({ mode: c }, o), { header: o.header ? o.header : r, inputs: this.createAlertInputs(this.childOpts, a, this.value), buttons: [
      {
        text: this.cancelText,
        role: "cancel",
        handler: () => {
          this.ionCancel.emit();
        }
      },
      {
        text: this.okText,
        handler: (d) => {
          this.setValue(d);
        }
      }
    ], cssClass: [
      "select-alert",
      o.cssClass,
      this.multiple ? "multiple-select-alert" : "single-select-alert"
    ] });
    return alertController.create(u);
  }
  /**
   * Close the select interface.
   */
  close() {
    return this.overlay ? this.overlay.dismiss() : Promise.resolve(!1);
  }
  // TODO FW-3194 Remove this
  getLabel() {
    return findItemLabel(this.el);
  }
  hasValue() {
    return this.getText() !== "";
  }
  get childOpts() {
    return Array.from(this.el.querySelectorAll("ion-select-option"));
  }
  /**
   * Returns any plaintext associated with
   * the label (either prop or slot).
   * Note: This will not return any custom
   * HTML. Use the `hasLabel` getter if you
   * want to know if any slotted label content
   * was passed.
   */
  get labelText() {
    const { label: e } = this;
    if (e !== void 0)
      return e;
    const { labelSlot: r } = this;
    if (r !== null)
      return r.textContent;
  }
  getText() {
    const e = this.selectedText;
    return e != null && e !== "" ? e : generateText(this.childOpts, this.value, this.compareWith);
  }
  setFocus() {
    this.focusEl && this.focusEl.focus();
  }
  emitStyle() {
    const { disabled: e } = this, r = {
      "interactive-disabled": e
    };
    this.legacyFormController.hasLegacyControl() && (r.interactive = !0, r.select = !0, r["select-disabled"] = e, r["has-placeholder"] = this.placeholder !== void 0, r["has-value"] = this.hasValue(), r["has-focus"] = this.isExpanded, r.legacy = !!this.legacy), this.ionStyle.emit(r);
  }
  renderLabel() {
    const { label: e } = this;
    return h("div", { class: {
      "label-text-wrapper": !0,
      "label-text-wrapper-hidden": !this.hasLabel
    }, part: "label" }, e === void 0 ? h("slot", { name: "label" }) : h("div", { class: "label-text" }, e));
  }
  componentDidRender() {
    var e;
    (e = this.notchController) === null || e === void 0 || e.calculateNotchWidth();
  }
  /**
   * Gets any content passed into the `label` slot,
   * not the <slot> definition.
   */
  get labelSlot() {
    return this.el.querySelector('[slot="label"]');
  }
  /**
   * Returns `true` if label content is provided
   * either by a prop or a content. If you want
   * to get the plaintext value of the label use
   * the `labelText` getter instead.
   */
  get hasLabel() {
    return this.label !== void 0 || this.labelSlot !== null;
  }
  /**
   * Renders the border container
   * when fill="outline".
   */
  renderLabelContainer() {
    return getIonMode$2(this) === "md" && this.fill === "outline" ? [
      h("div", { class: "select-outline-container" }, h("div", { class: "select-outline-start" }), h("div", { class: {
        "select-outline-notch": !0,
        "select-outline-notch-hidden": !this.hasLabel
      } }, h("div", { class: "notch-spacer", "aria-hidden": "true", ref: (o) => this.notchSpacerEl = o }, this.label)), h("div", { class: "select-outline-end" })),
      this.renderLabel()
    ] : this.renderLabel();
  }
  renderSelect() {
    const { disabled: e, el: r, isExpanded: o, expandedIcon: a, labelPlacement: c, justify: u, placeholder: d, fill: p, shape: g, name: b, value: x } = this, w = getIonMode$2(this), y = c === "floating" || c === "stacked", I = !y, E = isRTL$1(r) ? "rtl" : "ltr", T = hostContext("ion-item", this.el), C = w === "md" && p !== "outline" && !T, $ = this.hasValue(), D = r.querySelector('[slot="start"], [slot="end"]') !== null;
    renderHiddenInput(!0, r, b, parseValue$1(x), e);
    const L = c === "stacked" || c === "floating" && ($ || o || D);
    return h(Host, { onClick: this.onClick, class: createColorClasses$1(this.color, {
      [w]: !0,
      "in-item": T,
      "in-item-color": hostContext("ion-item.ion-color", r),
      "select-disabled": e,
      "select-expanded": o,
      "has-expanded-icon": a !== void 0,
      "has-value": $,
      "label-floating": L,
      "has-placeholder": d !== void 0,
      "ion-focusable": !0,
      [`select-${E}`]: !0,
      [`select-fill-${p}`]: p !== void 0,
      [`select-justify-${u}`]: I,
      [`select-shape-${g}`]: g !== void 0,
      [`select-label-placement-${c}`]: !0
    }) }, h("label", { class: "select-wrapper", id: "select-label" }, this.renderLabelContainer(), h("div", { class: "select-wrapper-inner" }, h("slot", { name: "start" }), h("div", { class: "native-wrapper", ref: (R) => this.nativeWrapperEl = R, part: "container" }, this.renderSelectText(), this.renderListbox()), h("slot", { name: "end" }), !y && this.renderSelectIcon()), y && this.renderSelectIcon(), C && h("div", { class: "select-highlight" })));
  }
  // TODO FW-3194 - Remove this
  renderLegacySelect() {
    this.hasLoggedDeprecationWarning || (printIonWarning(`ion-select now requires providing a label with either the "label" property or the "aria-label" attribute. To migrate, remove any usage of "ion-label" and pass the label text to either the "label" property or the "aria-label" attribute.

Example: <ion-select label="Favorite Color">...</ion-select>
Example with aria-label: <ion-select aria-label="Favorite Color">...</ion-select>

Developers can use the "legacy" property to continue using the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.`, this.el), this.legacy && printIonWarning(`ion-select is being used with the "legacy" property enabled which will forcibly enable the legacy form markup. This property will be removed in an upcoming major release of Ionic where this form control will use the modern form markup.
    Developers can dismiss this warning by removing their usage of the "legacy" property and using the new select syntax.`, this.el), this.hasLoggedDeprecationWarning = !0);
    const { disabled: e, el: r, inputId: o, isExpanded: a, expandedIcon: c, name: u, placeholder: d, value: p } = this, g = getIonMode$2(this), { labelText: b, labelId: x } = getAriaLabel(r, o);
    renderHiddenInput(!0, r, u, parseValue$1(p), e);
    let y = this.getText();
    y === "" && d !== void 0 && (y = d);
    const I = b !== void 0 ? y !== "" ? `${y}, ${b}` : b : y;
    return h(Host, { onClick: this.onClick, role: "button", "aria-haspopup": "listbox", "aria-disabled": e ? "true" : null, "aria-label": I, class: {
      [g]: !0,
      "in-item": hostContext("ion-item", r),
      "in-item-color": hostContext("ion-item.ion-color", r),
      "select-disabled": e,
      "select-expanded": a,
      "has-expanded-icon": c !== void 0,
      "legacy-select": !0
    } }, this.renderSelectText(), this.renderSelectIcon(), h("label", { id: x }, I), this.renderListbox());
  }
  /**
   * Renders either the placeholder
   * or the selected values based on
   * the state of the select.
   */
  renderSelectText() {
    const { placeholder: e } = this, r = this.getText();
    let o = !1, a = r;
    return a === "" && e !== void 0 && (a = e, o = !0), h("div", { "aria-hidden": "true", class: {
      "select-text": !0,
      "select-placeholder": o
    }, part: o ? "placeholder" : "text" }, a);
  }
  /**
   * Renders the chevron icon
   * next to the select text.
   */
  renderSelectIcon() {
    const e = getIonMode$2(this), { isExpanded: r, toggleIcon: o, expandedIcon: a } = this;
    let c;
    return r && a !== void 0 ? c = a : c = o ?? (e === "ios" ? chevronExpand : caretDownSharp), h("ion-icon", { class: "select-icon", part: "icon", "aria-hidden": "true", icon: c });
  }
  get ariaLabel() {
    var e, r;
    const { placeholder: o, el: a, inputId: c, inheritedAttributes: u } = this, d = this.getText(), { labelText: p } = getAriaLabel(a, c), g = (r = (e = this.labelText) !== null && e !== void 0 ? e : u["aria-label"]) !== null && r !== void 0 ? r : p;
    let b = d;
    return b === "" && o !== void 0 && (b = o), g !== void 0 && (b = b === "" ? g : `${g}, ${b}`), b;
  }
  renderListbox() {
    const { disabled: e, inputId: r, isExpanded: o } = this;
    return h("button", { disabled: e, id: r, "aria-label": this.ariaLabel, "aria-haspopup": "dialog", "aria-expanded": `${o}`, onFocus: this.onFocus, onBlur: this.onBlur, ref: (a) => this.focusEl = a });
  }
  render() {
    const { legacyFormController: e } = this;
    return e.hasLegacyControl() ? this.renderLegacySelect() : this.renderSelect();
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      disabled: ["styleChanged"],
      isExpanded: ["styleChanged"],
      placeholder: ["styleChanged"],
      value: ["styleChanged"]
    };
  }
  static get style() {
    return {
      ios: selectIosCss,
      md: selectMdCss
    };
  }
}, [33, "ion-select", {
  cancelText: [1, "cancel-text"],
  color: [513],
  compareWith: [1, "compare-with"],
  disabled: [4],
  fill: [1],
  interface: [1],
  interfaceOptions: [8, "interface-options"],
  justify: [1],
  label: [1],
  labelPlacement: [1, "label-placement"],
  legacy: [4],
  multiple: [4],
  name: [1],
  okText: [1, "ok-text"],
  placeholder: [1],
  selectedText: [1, "selected-text"],
  toggleIcon: [1, "toggle-icon"],
  expandedIcon: [1, "expanded-icon"],
  shape: [1],
  value: [1032],
  isExpanded: [32],
  open: [64]
}, void 0, {
  disabled: ["styleChanged"],
  isExpanded: ["styleChanged"],
  placeholder: ["styleChanged"],
  value: ["styleChanged"]
}]), getOptionValue = (t) => {
  const e = t.value;
  return e === void 0 ? t.textContent || "" : e;
}, parseValue$1 = (t) => {
  if (t != null)
    return Array.isArray(t) ? t.join(",") : t.toString();
}, generateText = (t, e, r) => e === void 0 ? "" : Array.isArray(e) ? e.map((o) => textForValue(t, o, r)).filter((o) => o !== null).join(", ") : textForValue(t, e, r) || "", textForValue = (t, e, r) => {
  const o = t.find((a) => compareOptions(e, getOptionValue(a), r));
  return o ? o.textContent : null;
};
let selectIds = 0;
const OPTION_CLASS = "select-interface-option";
function defineCustomElement$1$a() {
  if (typeof customElements > "u")
    return;
  ["ion-select", "ion-action-sheet", "ion-alert", "ion-backdrop", "ion-checkbox", "ion-icon", "ion-item", "ion-label", "ion-list", "ion-list-header", "ion-note", "ion-popover", "ion-radio", "ion-radio-group", "ion-ripple-effect", "ion-select-popover"].forEach((e) => {
    switch (e) {
      case "ion-select":
        customElements.get(e) || customElements.define(e, Select);
        break;
      case "ion-action-sheet":
        customElements.get(e) || defineCustomElement$f();
        break;
      case "ion-alert":
        customElements.get(e) || defineCustomElement$e();
        break;
      case "ion-backdrop":
        customElements.get(e) || defineCustomElement$R();
        break;
      case "ion-checkbox":
        customElements.get(e) || defineCustomElement$G();
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-item":
        customElements.get(e) || defineCustomElement$C();
        break;
      case "ion-label":
        customElements.get(e) || defineCustomElement$B();
        break;
      case "ion-list":
        customElements.get(e) || defineCustomElement$s();
        break;
      case "ion-list-header":
        customElements.get(e) || defineCustomElement$q();
        break;
      case "ion-note":
        customElements.get(e) || defineCustomElement$D();
        break;
      case "ion-popover":
        customElements.get(e) || defineCustomElement$A();
        break;
      case "ion-radio":
        customElements.get(e) || defineCustomElement$m();
        break;
      case "ion-radio-group":
        customElements.get(e) || defineCustomElement$k();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
      case "ion-select-popover":
        customElements.get(e) || defineCustomElement$d();
        break;
    }
  });
}
const defineCustomElement$c = defineCustomElement$1$a;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const selectOptionCss = ":host{display:none}", SelectOption = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inputId = `ion-selopt-${selectOptionIds++}`, this.disabled = !1, this.value = void 0;
  }
  render() {
    return h(Host, { role: "option", id: this.inputId, class: getIonMode$2(this) });
  }
  get el() {
    return this;
  }
  static get style() {
    return selectOptionCss;
  }
}, [1, "ion-select-option", {
  disabled: [4],
  value: [8]
}]);
let selectOptionIds = 0;
function defineCustomElement$1$9() {
  if (typeof customElements > "u")
    return;
  ["ion-select-option"].forEach((e) => {
    switch (e) {
      case "ion-select-option":
        customElements.get(e) || customElements.define(e, SelectOption);
        break;
    }
  });
}
const defineCustomElement$b = defineCustomElement$1$9;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const defineCustomElement$a = defineCustomElement$v;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const titleIosCss = ":host{--color:initial;display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-align:center;align-items:center;-webkit-transform:translateZ(0);transform:translateZ(0);color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}.toolbar-title{display:block;width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;pointer-events:auto}:host(.title-small) .toolbar-title{white-space:normal}:host{top:0;-webkit-padding-start:90px;padding-inline-start:90px;-webkit-padding-end:90px;padding-inline-end:90px;padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);position:absolute;width:100%;height:100%;-webkit-transform:translateZ(0);transform:translateZ(0);font-size:min(1.0625rem, 20.4px);font-weight:600;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;pointer-events:none}@supports (inset-inline-start: 0){:host{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host{left:0}:host-context([dir=rtl]){left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(:dir(rtl)){left:unset;right:unset;right:0}}}:host(.title-small){-webkit-padding-start:9px;padding-inline-start:9px;-webkit-padding-end:9px;padding-inline-end:9px;padding-top:6px;padding-bottom:16px;position:relative;font-size:min(0.8125rem, 23.4px);font-weight:normal}:host(.title-large){-webkit-padding-start:12px;padding-inline-start:12px;-webkit-padding-end:12px;padding-inline-end:12px;padding-top:2px;padding-bottom:4px;-webkit-transform-origin:left center;transform-origin:left center;position:static;-ms-flex-align:end;align-items:flex-end;min-width:100%;font-size:min(2.125rem, 61.2px);font-weight:700;text-align:start}:host(.title-large.title-rtl){-webkit-transform-origin:right center;transform-origin:right center}:host(.title-large.ion-cloned-element){--color:var(--ion-text-color, #000);font-family:var(--ion-font-family)}:host(.title-large) .toolbar-title{-webkit-transform-origin:inherit;transform-origin:inherit;width:auto}:host-context([dir=rtl]):host(.title-large) .toolbar-title,:host-context([dir=rtl]).title-large .toolbar-title{-webkit-transform-origin:calc(100% - inherit);transform-origin:calc(100% - inherit)}@supports selector(:dir(rtl)){:host(.title-large:dir(rtl)) .toolbar-title{-webkit-transform-origin:calc(100% - inherit);transform-origin:calc(100% - inherit)}}", titleMdCss = ":host{--color:initial;display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-align:center;align-items:center;-webkit-transform:translateZ(0);transform:translateZ(0);color:var(--color)}:host(.ion-color){color:var(--ion-color-base)}.toolbar-title{display:block;width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;pointer-events:auto}:host(.title-small) .toolbar-title{white-space:normal}:host{-webkit-padding-start:20px;padding-inline-start:20px;-webkit-padding-end:20px;padding-inline-end:20px;padding-top:0;padding-bottom:0;font-size:1.25rem;font-weight:500;letter-spacing:0.0125em}:host(.title-small){width:100%;height:100%;font-size:0.9375rem;font-weight:normal}", ToolbarTitle = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionStyle = createEvent(this, "ionStyle", 7), this.color = void 0, this.size = void 0;
  }
  sizeChanged() {
    this.emitStyle();
  }
  connectedCallback() {
    this.emitStyle();
  }
  emitStyle() {
    const e = this.getSize();
    this.ionStyle.emit({
      [`title-${e}`]: !0
    });
  }
  getSize() {
    return this.size !== void 0 ? this.size : "default";
  }
  render() {
    const e = getIonMode$2(this), r = this.getSize();
    return h(Host, { class: createColorClasses$1(this.color, {
      [e]: !0,
      [`title-${r}`]: !0,
      "title-rtl": document.dir === "rtl"
    }) }, h("div", { class: "toolbar-title" }, h("slot", null)));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      size: ["sizeChanged"]
    };
  }
  static get style() {
    return {
      ios: titleIosCss,
      md: titleMdCss
    };
  }
}, [33, "ion-title", {
  color: [513],
  size: [1]
}, void 0, {
  size: ["sizeChanged"]
}]);
function defineCustomElement$1$8() {
  if (typeof customElements > "u")
    return;
  ["ion-title"].forEach((e) => {
    switch (e) {
      case "ion-title":
        customElements.get(e) || customElements.define(e, ToolbarTitle);
        break;
    }
  });
}
const defineCustomElement$9 = defineCustomElement$1$8;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const toolbarIosCss = ":host{--border-width:0;--border-style:solid;--opacity:1;--opacity-scale:1;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;width:100%;padding-right:var(--ion-safe-area-right);padding-left:var(--ion-safe-area-left);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;z-index:10;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-contrast)}:host(.ion-color) .toolbar-background{background:var(--ion-color-base)}.toolbar-container{-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:var(--min-height);contain:content;overflow:hidden;z-index:10;-webkit-box-sizing:border-box;box-sizing:border-box}.toolbar-background{left:0;right:0;top:0;bottom:0;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);contain:strict;opacity:calc(var(--opacity) * var(--opacity-scale));z-index:-1;pointer-events:none}::slotted(ion-progress-bar){left:0;right:0;bottom:0;position:absolute}:host{--background:var(--ion-toolbar-background, var(--ion-color-step-50, #f7f7f7));--color:var(--ion-toolbar-color, var(--ion-text-color, #000));--border-color:var(--ion-toolbar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.2))));--padding-top:3px;--padding-bottom:3px;--padding-start:4px;--padding-end:4px;--min-height:44px}.toolbar-content{-ms-flex:1;flex:1;-ms-flex-order:4;order:4;min-width:0}:host(.toolbar-segment) .toolbar-content{display:-ms-inline-flexbox;display:inline-flex}:host(.toolbar-searchbar) .toolbar-container{padding-top:0;padding-bottom:0}:host(.toolbar-searchbar) ::slotted(*){-ms-flex-item-align:start;align-self:start}:host(.toolbar-searchbar) ::slotted(ion-chip){margin-top:3px}::slotted(ion-buttons){min-height:38px}::slotted([slot=start]){-ms-flex-order:2;order:2}::slotted([slot=secondary]){-ms-flex-order:3;order:3}::slotted([slot=primary]){-ms-flex-order:5;order:5;text-align:end}::slotted([slot=end]){-ms-flex-order:6;order:6;text-align:end}:host(.toolbar-title-large) .toolbar-container{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:start;align-items:flex-start}:host(.toolbar-title-large) .toolbar-content ion-title{-ms-flex:1;flex:1;-ms-flex-order:8;order:8;min-width:100%}", toolbarMdCss = ":host{--border-width:0;--border-style:solid;--opacity:1;--opacity-scale:1;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:block;position:relative;width:100%;padding-right:var(--ion-safe-area-right);padding-left:var(--ion-safe-area-left);color:var(--color);font-family:var(--ion-font-family, inherit);contain:content;z-index:10;-webkit-box-sizing:border-box;box-sizing:border-box}:host(.ion-color){color:var(--ion-color-contrast)}:host(.ion-color) .toolbar-background{background:var(--ion-color-base)}.toolbar-container{-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;min-height:var(--min-height);contain:content;overflow:hidden;z-index:10;-webkit-box-sizing:border-box;box-sizing:border-box}.toolbar-background{left:0;right:0;top:0;bottom:0;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);contain:strict;opacity:calc(var(--opacity) * var(--opacity-scale));z-index:-1;pointer-events:none}::slotted(ion-progress-bar){left:0;right:0;bottom:0;position:absolute}:host{--background:var(--ion-toolbar-background, var(--ion-background-color, #fff));--color:var(--ion-toolbar-color, var(--ion-text-color, #424242));--border-color:var(--ion-toolbar-border-color, var(--ion-border-color, var(--ion-color-step-150, #c1c4cd)));--padding-top:0;--padding-bottom:0;--padding-start:0;--padding-end:0;--min-height:56px}.toolbar-content{-ms-flex:1;flex:1;-ms-flex-order:3;order:3;min-width:0;max-width:100%}::slotted(.buttons-first-slot){-webkit-margin-start:4px;margin-inline-start:4px}::slotted(.buttons-last-slot){-webkit-margin-end:4px;margin-inline-end:4px}::slotted([slot=start]){-ms-flex-order:2;order:2}::slotted([slot=secondary]){-ms-flex-order:4;order:4}::slotted([slot=primary]){-ms-flex-order:5;order:5;text-align:end}::slotted([slot=end]){-ms-flex-order:6;order:6;text-align:end}", Toolbar = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.childrenStyles = /* @__PURE__ */ new Map(), this.color = void 0;
  }
  componentWillLoad() {
    const e = Array.from(this.el.querySelectorAll("ion-buttons")), r = e.find((c) => c.slot === "start");
    r && r.classList.add("buttons-first-slot");
    const o = e.reverse(), a = o.find((c) => c.slot === "end") || o.find((c) => c.slot === "primary") || o.find((c) => c.slot === "secondary");
    a && a.classList.add("buttons-last-slot");
  }
  childrenStyle(e) {
    e.stopPropagation();
    const r = e.target.tagName, o = e.detail, a = {}, c = this.childrenStyles.get(r) || {};
    let u = !1;
    Object.keys(o).forEach((d) => {
      const p = `toolbar-${d}`, g = o[d];
      g !== c[p] && (u = !0), g && (a[p] = !0);
    }), u && (this.childrenStyles.set(r, a), forceUpdate(this));
  }
  render() {
    const e = getIonMode$2(this), r = {};
    return this.childrenStyles.forEach((o) => {
      Object.assign(r, o);
    }), h(Host, { class: Object.assign(Object.assign({}, r), createColorClasses$1(this.color, {
      [e]: !0,
      "in-toolbar": hostContext("ion-toolbar", this.el)
    })) }, h("div", { class: "toolbar-background" }), h("div", { class: "toolbar-container" }, h("slot", { name: "start" }), h("slot", { name: "secondary" }), h("div", { class: "toolbar-content" }, h("slot", null)), h("slot", { name: "primary" }), h("slot", { name: "end" })));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: toolbarIosCss,
      md: toolbarMdCss
    };
  }
}, [33, "ion-toolbar", {
  color: [513]
}, [[0, "ionStyle", "childrenStyle"]]]);
function defineCustomElement$1$7() {
  if (typeof customElements > "u")
    return;
  ["ion-toolbar"].forEach((e) => {
    switch (e) {
      case "ion-toolbar":
        customElements.get(e) || customElements.define(e, Toolbar);
        break;
    }
  });
}
const defineCustomElement$8 = defineCustomElement$1$7;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const backButtonIosCss = ':host{--background:transparent;--color-focused:currentColor;--color-hover:currentColor;--icon-margin-top:0;--icon-margin-bottom:0;--icon-padding-top:0;--icon-padding-end:0;--icon-padding-bottom:0;--icon-padding-start:0;--margin-top:0;--margin-end:0;--margin-bottom:0;--margin-start:0;--min-width:auto;--min-height:auto;--padding-top:0;--padding-end:0;--padding-bottom:0;--padding-start:0;--opacity:1;--ripple-color:currentColor;--transition:background-color, opacity 100ms linear;display:none;min-width:var(--min-width);min-height:var(--min-height);color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;text-overflow:ellipsis;text-transform:none;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-kerning:none;font-kerning:none}ion-ripple-effect{color:var(--ripple-color)}:host(.ion-color) .button-native{color:var(--ion-color-base)}:host(.show-back-button){display:block}:host(.back-button-disabled){cursor:default;opacity:0.5;pointer-events:none}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-margin-start:var(--margin-start);margin-inline-start:var(--margin-start);-webkit-margin-end:var(--margin-end);margin-inline-end:var(--margin-end);margin-top:var(--margin-top);margin-bottom:var(--margin-bottom);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;min-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border:0;outline:none;background:var(--background);line-height:1;cursor:pointer;opacity:var(--opacity);overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}ion-icon{-webkit-padding-start:var(--icon-padding-start);padding-inline-start:var(--icon-padding-start);-webkit-padding-end:var(--icon-padding-end);padding-inline-end:var(--icon-padding-end);padding-top:var(--icon-padding-top);padding-bottom:var(--icon-padding-bottom);-webkit-margin-start:var(--icon-margin-start);margin-inline-start:var(--icon-margin-start);-webkit-margin-end:var(--icon-margin-end);margin-inline-end:var(--icon-margin-end);margin-top:var(--icon-margin-top);margin-bottom:var(--icon-margin-bottom);display:inherit;font-size:var(--icon-font-size);font-weight:var(--icon-font-weight);pointer-events:none}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-color.ion-focused) .button-native{color:var(--ion-color-base)}@media (any-hover: hover){:host(.ion-color:hover) .button-native{color:var(--ion-color-base)}}:host(.in-toolbar:not(.in-toolbar-color)){color:var(--ion-toolbar-color, var(--color))}:host{--background-hover:transparent;--background-hover-opacity:1;--background-focused:currentColor;--background-focused-opacity:.1;--border-radius:4px;--color:var(--ion-color-primary, #3880ff);--icon-margin-end:1px;--icon-margin-start:-4px;--icon-font-size:1.6em;--min-height:32px;font-size:clamp(17px, 1.0625rem, 21.998px)}.button-native{-webkit-transform:translateZ(0);transform:translateZ(0);overflow:visible;z-index:99}:host(.ion-activated) .button-native{opacity:0.4}@media (any-hover: hover){:host(:hover){opacity:0.6}}', backButtonMdCss = ':host{--background:transparent;--color-focused:currentColor;--color-hover:currentColor;--icon-margin-top:0;--icon-margin-bottom:0;--icon-padding-top:0;--icon-padding-end:0;--icon-padding-bottom:0;--icon-padding-start:0;--margin-top:0;--margin-end:0;--margin-bottom:0;--margin-start:0;--min-width:auto;--min-height:auto;--padding-top:0;--padding-end:0;--padding-bottom:0;--padding-start:0;--opacity:1;--ripple-color:currentColor;--transition:background-color, opacity 100ms linear;display:none;min-width:var(--min-width);min-height:var(--min-height);color:var(--color);font-family:var(--ion-font-family, inherit);text-align:center;text-decoration:none;text-overflow:ellipsis;text-transform:none;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-font-kerning:none;font-kerning:none}ion-ripple-effect{color:var(--ripple-color)}:host(.ion-color) .button-native{color:var(--ion-color-base)}:host(.show-back-button){display:block}:host(.back-button-disabled){cursor:default;opacity:0.5;pointer-events:none}.button-native{border-radius:var(--border-radius);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-margin-start:var(--margin-start);margin-inline-start:var(--margin-start);-webkit-margin-end:var(--margin-end);margin-inline-end:var(--margin-end);margin-top:var(--margin-top);margin-bottom:var(--margin-bottom);-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:block;position:relative;width:100%;height:100%;min-height:inherit;-webkit-transition:var(--transition);transition:var(--transition);border:0;outline:none;background:var(--background);line-height:1;cursor:pointer;opacity:var(--opacity);overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-negative:0;flex-shrink:0;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;z-index:1}ion-icon{-webkit-padding-start:var(--icon-padding-start);padding-inline-start:var(--icon-padding-start);-webkit-padding-end:var(--icon-padding-end);padding-inline-end:var(--icon-padding-end);padding-top:var(--icon-padding-top);padding-bottom:var(--icon-padding-bottom);-webkit-margin-start:var(--icon-margin-start);margin-inline-start:var(--icon-margin-start);-webkit-margin-end:var(--icon-margin-end);margin-inline-end:var(--icon-margin-end);margin-top:var(--icon-margin-top);margin-bottom:var(--icon-margin-bottom);display:inherit;font-size:var(--icon-font-size);font-weight:var(--icon-font-weight);pointer-events:none}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}@media (any-hover: hover){:host(:hover) .button-native{color:var(--color-hover)}:host(:hover) .button-native::after{background:var(--background-hover);opacity:var(--background-hover-opacity)}}:host(.ion-color.ion-focused) .button-native{color:var(--ion-color-base)}@media (any-hover: hover){:host(.ion-color:hover) .button-native{color:var(--ion-color-base)}}:host(.in-toolbar:not(.in-toolbar-color)){color:var(--ion-toolbar-color, var(--color))}:host{--border-radius:4px;--background-focused:currentColor;--background-focused-opacity:.12;--background-hover:currentColor;--background-hover-opacity:0.04;--color:currentColor;--icon-margin-end:0;--icon-margin-start:0;--icon-font-size:1.5rem;--icon-font-weight:normal;--min-height:32px;--min-width:44px;--padding-start:12px;--padding-end:12px;font-size:0.875rem;font-weight:500;text-transform:uppercase}:host(.back-button-has-icon-only){--border-radius:50%;min-width:48px;min-height:48px;aspect-ratio:1/1}.button-native{-webkit-box-shadow:none;box-shadow:none}.button-text{-webkit-padding-start:4px;padding-inline-start:4px;-webkit-padding-end:4px;padding-inline-end:4px;padding-top:0;padding-bottom:0}ion-icon{line-height:0.67;text-align:start}@media (any-hover: hover){:host(.ion-color:hover) .button-native::after{background:var(--ion-color-base)}}:host(.ion-color.ion-focused) .button-native::after{background:var(--ion-color-base)}', BackButton = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.inheritedAttributes = {}, this.onClick = async (e) => {
      const r = this.el.closest("ion-nav");
      return e.preventDefault(), r && await r.canGoBack() ? r.pop({ animationBuilder: this.routerAnimation, skipIfBusy: !0 }) : openURL(this.defaultHref, e, "back", this.routerAnimation);
    }, this.color = void 0, this.defaultHref = void 0, this.disabled = !1, this.icon = void 0, this.text = void 0, this.type = "button", this.routerAnimation = void 0;
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAriaAttributes(this.el), this.defaultHref === void 0 && (this.defaultHref = config$1.get("backButtonDefaultHref"));
  }
  get backButtonIcon() {
    const e = this.icon;
    return e ?? (getIonMode$2(this) === "ios" ? config$1.get("backButtonIcon", chevronBack) : config$1.get("backButtonIcon", arrowBackSharp));
  }
  get backButtonText() {
    const e = getIonMode$2(this) === "ios" ? "Back" : null;
    return this.text != null ? this.text : config$1.get("backButtonText", e);
  }
  get hasIconOnly() {
    return this.backButtonIcon && !this.backButtonText;
  }
  get rippleType() {
    return this.hasIconOnly ? "unbounded" : "bounded";
  }
  render() {
    const { color: e, defaultHref: r, disabled: o, type: a, hasIconOnly: c, backButtonIcon: u, backButtonText: d, icon: p, inheritedAttributes: g } = this, b = r !== void 0, x = getIonMode$2(this), w = g["aria-label"] || d || "back";
    return h(Host, { onClick: this.onClick, class: createColorClasses$1(e, {
      [x]: !0,
      button: !0,
      "back-button-disabled": o,
      "back-button-has-icon-only": c,
      "in-toolbar": hostContext("ion-toolbar", this.el),
      "in-toolbar-color": hostContext("ion-toolbar[color]", this.el),
      "ion-activatable": !0,
      "ion-focusable": !0,
      "show-back-button": b
    }) }, h("button", { type: a, disabled: o, class: "button-native", part: "native", "aria-label": w }, h("span", { class: "button-inner" }, u && h("ion-icon", { part: "icon", icon: u, "aria-hidden": "true", lazy: !1, "flip-rtl": p === void 0 }), d && h("span", { part: "text", "aria-hidden": "true", class: "button-text" }, d)), x === "md" && h("ion-ripple-effect", { type: this.rippleType })));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: backButtonIosCss,
      md: backButtonMdCss
    };
  }
}, [33, "ion-back-button", {
  color: [513],
  defaultHref: [1025, "default-href"],
  disabled: [516],
  icon: [1],
  text: [1],
  type: [1],
  routerAnimation: [16]
}]);
function defineCustomElement$1$6() {
  if (typeof customElements > "u")
    return;
  ["ion-back-button", "ion-icon", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-back-button":
        customElements.get(e) || customElements.define(e, BackButton);
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$7 = defineCustomElement$1$6;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const tabButtonIosCss = ':host{--ripple-color:var(--color-selected);--background-focused-opacity:1;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;outline:none;background:var(--background);color:var(--color)}.button-native{border-radius:inherit;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;height:100%;border:0;outline:none;background:transparent;text-decoration:none;cursor:pointer;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-drag:none}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:inherit;flex-flow:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;height:100%;z-index:1}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){a:hover{color:var(--color-selected)}}:host(.tab-selected){color:var(--color-selected)}:host(.tab-hidden){display:none !important}:host(.tab-disabled){pointer-events:none;opacity:0.4}::slotted(ion-label),::slotted(ion-icon){display:block;-ms-flex-item-align:center;align-self:center;max-width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex-order:0;order:0}::slotted(ion-icon){-ms-flex-order:-1;order:-1;height:1em}:host(.tab-has-label-only) ::slotted(ion-label){white-space:normal}::slotted(ion-badge){-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;z-index:1}:host(.tab-layout-icon-start){-ms-flex-direction:row;flex-direction:row}:host(.tab-layout-icon-end){-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.tab-layout-icon-bottom){-ms-flex-direction:column-reverse;flex-direction:column-reverse}:host(.tab-layout-icon-hide) ::slotted(ion-icon){display:none}:host(.tab-layout-label-hide) ::slotted(ion-label){display:none}ion-ripple-effect{color:var(--ripple-color)}:host{--padding-top:0;--padding-end:2px;--padding-bottom:0;--padding-start:2px;max-width:240px;font-size:10px}::slotted(ion-badge){-webkit-padding-start:6px;padding-inline-start:6px;-webkit-padding-end:6px;padding-inline-end:6px;padding-top:1px;padding-bottom:1px;top:4px;height:auto;font-size:12px;line-height:16px}@supports (inset-inline-start: 0){::slotted(ion-badge){inset-inline-start:calc(50% + 6px)}}@supports not (inset-inline-start: 0){::slotted(ion-badge){left:calc(50% + 6px)}:host-context([dir=rtl]) ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 6px)}[dir=rtl] ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 6px)}@supports selector(:dir(rtl)){::slotted(ion-badge):dir(rtl){left:unset;right:unset;right:calc(50% + 6px)}}}::slotted(ion-icon){margin-top:2px;margin-bottom:2px;font-size:30px}::slotted(ion-icon::before){vertical-align:top}::slotted(ion-label){margin-top:0;margin-bottom:1px;min-height:11px;font-weight:500}:host(.tab-has-label-only) ::slotted(ion-label){margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;font-size:12px;font-size:14px;line-height:1.1}:host(.tab-layout-icon-end) ::slotted(ion-label),:host(.tab-layout-icon-start) ::slotted(ion-label),:host(.tab-layout-icon-hide) ::slotted(ion-label){margin-top:2px;margin-bottom:2px;font-size:14px;line-height:1.1}:host(.tab-layout-icon-end) ::slotted(ion-icon),:host(.tab-layout-icon-start) ::slotted(ion-icon){min-width:24px;height:26px;margin-top:2px;margin-bottom:1px;font-size:24px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-bottom) ::slotted(ion-badge){inset-inline-start:calc(50% + 12px)}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-bottom) ::slotted(ion-badge){left:calc(50% + 12px)}:host-context([dir=rtl]):host(.tab-layout-icon-bottom) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-bottom ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 12px)}@supports selector(:dir(rtl)){:host(.tab-layout-icon-bottom:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 12px)}}}:host(.tab-layout-icon-bottom) ::slotted(ion-icon){margin-top:0;margin-bottom:1px}:host(.tab-layout-icon-bottom) ::slotted(ion-label){margin-top:4px}:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){top:10px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){inset-inline-start:calc(50% + 35px)}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){left:calc(50% + 35px)}:host-context([dir=rtl]):host(.tab-layout-icon-start) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-start ::slotted(ion-badge),:host-context([dir=rtl]):host(.tab-layout-icon-end) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-end ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 35px)}@supports selector(:dir(rtl)){:host(.tab-layout-icon-start:dir(rtl)) ::slotted(ion-badge),:host(.tab-layout-icon-end:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 35px)}}}:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){top:10px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){inset-inline-start:calc(50% + 30px)}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){left:calc(50% + 30px)}:host-context([dir=rtl]):host(.tab-layout-icon-hide) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-hide ::slotted(ion-badge),:host-context([dir=rtl]):host(.tab-has-label-only) ::slotted(ion-badge),:host-context([dir=rtl]).tab-has-label-only ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 30px)}@supports selector(:dir(rtl)){:host(.tab-layout-icon-hide:dir(rtl)) ::slotted(ion-badge),:host(.tab-has-label-only:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 30px)}}}:host(.tab-layout-label-hide) ::slotted(ion-badge),:host(.tab-has-icon-only) ::slotted(ion-badge){top:10px}:host(.tab-layout-label-hide) ::slotted(ion-icon){margin-left:0;margin-right:0;margin-top:0;margin-bottom:0}', tabButtonMdCss = ':host{--ripple-color:var(--color-selected);--background-focused-opacity:1;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100%;outline:none;background:var(--background);color:var(--color)}.button-native{border-radius:inherit;margin-left:0;margin-right:0;margin-top:0;margin-bottom:0;-webkit-padding-start:var(--padding-start);padding-inline-start:var(--padding-start);-webkit-padding-end:var(--padding-end);padding-inline-end:var(--padding-end);padding-top:var(--padding-top);padding-bottom:var(--padding-bottom);font-family:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;text-decoration:inherit;text-indent:inherit;text-overflow:inherit;text-transform:inherit;text-align:inherit;white-space:inherit;color:inherit;display:-ms-flexbox;display:flex;position:relative;-ms-flex-direction:inherit;flex-direction:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;height:100%;border:0;outline:none;background:transparent;text-decoration:none;cursor:pointer;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-drag:none}.button-native::after{left:0;right:0;top:0;bottom:0;position:absolute;content:"";opacity:0}.button-inner{display:-ms-flexbox;display:flex;position:relative;-ms-flex-flow:inherit;flex-flow:inherit;-ms-flex-align:inherit;align-items:inherit;-ms-flex-pack:inherit;justify-content:inherit;width:100%;height:100%;z-index:1}:host(.ion-focused) .button-native{color:var(--color-focused)}:host(.ion-focused) .button-native::after{background:var(--background-focused);opacity:var(--background-focused-opacity)}@media (any-hover: hover){a:hover{color:var(--color-selected)}}:host(.tab-selected){color:var(--color-selected)}:host(.tab-hidden){display:none !important}:host(.tab-disabled){pointer-events:none;opacity:0.4}::slotted(ion-label),::slotted(ion-icon){display:block;-ms-flex-item-align:center;align-self:center;max-width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box}::slotted(ion-label){-ms-flex-order:0;order:0}::slotted(ion-icon){-ms-flex-order:-1;order:-1;height:1em}:host(.tab-has-label-only) ::slotted(ion-label){white-space:normal}::slotted(ion-badge){-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;z-index:1}:host(.tab-layout-icon-start){-ms-flex-direction:row;flex-direction:row}:host(.tab-layout-icon-end){-ms-flex-direction:row-reverse;flex-direction:row-reverse}:host(.tab-layout-icon-bottom){-ms-flex-direction:column-reverse;flex-direction:column-reverse}:host(.tab-layout-icon-hide) ::slotted(ion-icon){display:none}:host(.tab-layout-label-hide) ::slotted(ion-label){display:none}ion-ripple-effect{color:var(--ripple-color)}:host{--padding-top:0;--padding-end:12px;--padding-bottom:0;--padding-start:12px;max-width:168px;font-size:12px;font-weight:normal;letter-spacing:0.03em}::slotted(ion-label){margin-left:0;margin-right:0;margin-top:2px;margin-bottom:2px;text-transform:none}::slotted(ion-icon){margin-left:0;margin-right:0;margin-top:16px;margin-bottom:16px;-webkit-transform-origin:center center;transform-origin:center center;font-size:22px}:host-context([dir=rtl]) ::slotted(ion-icon){-webkit-transform-origin:calc(100% - center) center;transform-origin:calc(100% - center) center}[dir=rtl] ::slotted(ion-icon){-webkit-transform-origin:calc(100% - center) center;transform-origin:calc(100% - center) center}@supports selector(:dir(rtl)){::slotted(ion-icon):dir(rtl){-webkit-transform-origin:calc(100% - center) center;transform-origin:calc(100% - center) center}}::slotted(ion-badge){border-radius:8px;-webkit-padding-start:2px;padding-inline-start:2px;-webkit-padding-end:2px;padding-inline-end:2px;padding-top:3px;padding-bottom:2px;top:8px;min-width:12px;font-size:8px;font-weight:normal}@supports (inset-inline-start: 0){::slotted(ion-badge){inset-inline-start:calc(50% + 6px)}}@supports not (inset-inline-start: 0){::slotted(ion-badge){left:calc(50% + 6px)}:host-context([dir=rtl]) ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 6px)}[dir=rtl] ::slotted(ion-badge){left:unset;right:unset;right:calc(50% + 6px)}@supports selector(:dir(rtl)){::slotted(ion-badge):dir(rtl){left:unset;right:unset;right:calc(50% + 6px)}}}::slotted(ion-badge:empty){display:block;min-width:8px;height:8px}:host(.tab-layout-icon-top) ::slotted(ion-icon){margin-top:6px;margin-bottom:2px}:host(.tab-layout-icon-top) ::slotted(ion-label){margin-top:0;margin-bottom:6px}:host(.tab-layout-icon-bottom) ::slotted(ion-badge){top:8px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-bottom) ::slotted(ion-badge){inset-inline-start:70%}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-bottom) ::slotted(ion-badge){left:70%}:host-context([dir=rtl]):host(.tab-layout-icon-bottom) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-bottom ::slotted(ion-badge){left:unset;right:unset;right:70%}@supports selector(:dir(rtl)){:host(.tab-layout-icon-bottom:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:70%}}}:host(.tab-layout-icon-bottom) ::slotted(ion-icon){margin-top:0;margin-bottom:6px}:host(.tab-layout-icon-bottom) ::slotted(ion-label){margin-top:6px;margin-bottom:0}:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){top:16px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){inset-inline-start:80%}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-start) ::slotted(ion-badge),:host(.tab-layout-icon-end) ::slotted(ion-badge){left:80%}:host-context([dir=rtl]):host(.tab-layout-icon-start) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-start ::slotted(ion-badge),:host-context([dir=rtl]):host(.tab-layout-icon-end) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-end ::slotted(ion-badge){left:unset;right:unset;right:80%}@supports selector(:dir(rtl)){:host(.tab-layout-icon-start:dir(rtl)) ::slotted(ion-badge),:host(.tab-layout-icon-end:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:80%}}}:host(.tab-layout-icon-start) ::slotted(ion-icon){-webkit-margin-end:6px;margin-inline-end:6px}:host(.tab-layout-icon-end) ::slotted(ion-icon){-webkit-margin-start:6px;margin-inline-start:6px}:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){top:16px}@supports (inset-inline-start: 0){:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){inset-inline-start:70%}}@supports not (inset-inline-start: 0){:host(.tab-layout-icon-hide) ::slotted(ion-badge),:host(.tab-has-label-only) ::slotted(ion-badge){left:70%}:host-context([dir=rtl]):host(.tab-layout-icon-hide) ::slotted(ion-badge),:host-context([dir=rtl]).tab-layout-icon-hide ::slotted(ion-badge),:host-context([dir=rtl]):host(.tab-has-label-only) ::slotted(ion-badge),:host-context([dir=rtl]).tab-has-label-only ::slotted(ion-badge){left:unset;right:unset;right:70%}@supports selector(:dir(rtl)){:host(.tab-layout-icon-hide:dir(rtl)) ::slotted(ion-badge),:host(.tab-has-label-only:dir(rtl)) ::slotted(ion-badge){left:unset;right:unset;right:70%}}}:host(.tab-layout-icon-hide) ::slotted(ion-label),:host(.tab-has-label-only) ::slotted(ion-label){margin-top:0;margin-bottom:0}:host(.tab-layout-label-hide) ::slotted(ion-badge),:host(.tab-has-icon-only) ::slotted(ion-badge){top:16px}:host(.tab-layout-label-hide) ::slotted(ion-icon),:host(.tab-has-icon-only) ::slotted(ion-icon){margin-top:0;margin-bottom:0;font-size:24px}', TabButton = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionTabButtonClick = createEvent(this, "ionTabButtonClick", 7), this.inheritedAttributes = {}, this.onKeyUp = (e) => {
      (e.key === "Enter" || e.key === " ") && this.selectTab(e);
    }, this.onClick = (e) => {
      this.selectTab(e);
    }, this.disabled = !1, this.download = void 0, this.href = void 0, this.rel = void 0, this.layout = void 0, this.selected = !1, this.tab = void 0, this.target = void 0;
  }
  onTabBarChanged(e) {
    const r = e.target, o = this.el.parentElement;
    (e.composedPath().includes(o) || r != null && r.contains(this.el)) && (this.selected = this.tab === e.detail.tab);
  }
  componentWillLoad() {
    this.inheritedAttributes = Object.assign({}, inheritAttributes$2(this.el, ["aria-label"])), this.layout === void 0 && (this.layout = config$1.get("tabButtonLayout", "icon-top"));
  }
  selectTab(e) {
    this.tab !== void 0 && (this.disabled || this.ionTabButtonClick.emit({
      tab: this.tab,
      href: this.href,
      selected: this.selected
    }), e.preventDefault());
  }
  get hasLabel() {
    return !!this.el.querySelector("ion-label");
  }
  get hasIcon() {
    return !!this.el.querySelector("ion-icon");
  }
  render() {
    const { disabled: e, hasIcon: r, hasLabel: o, href: a, rel: c, target: u, layout: d, selected: p, tab: g, inheritedAttributes: b } = this, x = getIonMode$2(this), w = {
      download: this.download,
      href: a,
      rel: c,
      target: u
    };
    return h(Host, { onClick: this.onClick, onKeyup: this.onKeyUp, id: g !== void 0 ? `tab-button-${g}` : null, class: {
      [x]: !0,
      "tab-selected": p,
      "tab-disabled": e,
      "tab-has-label": o,
      "tab-has-icon": r,
      "tab-has-label-only": o && !r,
      "tab-has-icon-only": r && !o,
      [`tab-layout-${d}`]: !0,
      "ion-activatable": !0,
      "ion-selectable": !0,
      "ion-focusable": !0
    } }, h("a", Object.assign({}, w, { class: "button-native", part: "native", role: "tab", "aria-selected": p ? "true" : null, "aria-disabled": e ? "true" : null, tabindex: e ? "-1" : void 0 }, b), h("span", { class: "button-inner" }, h("slot", null)), x === "md" && h("ion-ripple-effect", { type: "unbounded" })));
  }
  get el() {
    return this;
  }
  static get style() {
    return {
      ios: tabButtonIosCss,
      md: tabButtonMdCss
    };
  }
}, [33, "ion-tab-button", {
  disabled: [4],
  download: [1],
  href: [1],
  rel: [1],
  layout: [1025],
  selected: [1028],
  tab: [1],
  target: [1]
}, [[8, "ionTabBarChanged", "onTabBarChanged"]]]);
function defineCustomElement$1$5() {
  if (typeof customElements > "u")
    return;
  ["ion-tab-button", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-tab-button":
        customElements.get(e) || customElements.define(e, TabButton);
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$6 = defineCustomElement$1$5;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const tabBarIosCss = ":host{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-right:var(--ion-safe-area-right);padding-bottom:var(--ion-safe-area-bottom, 0);padding-left:var(--ion-safe-area-left);border-top:var(--border);background:var(--background);color:var(--color);text-align:center;contain:strict;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:10;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host(.ion-color) ::slotted(ion-tab-button){--background-focused:var(--ion-color-shade);--color-selected:var(--ion-color-contrast)}:host(.ion-color) ::slotted(.tab-selected){color:var(--ion-color-contrast)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){color:rgba(var(--ion-color-contrast-rgb), 0.7)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){background:var(--ion-color-base)}:host(.ion-color) ::slotted(ion-tab-button.ion-focused),:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:var(--background-focused)}:host(.tab-bar-translucent) ::slotted(ion-tab-button){background:transparent}:host([slot=top]){padding-top:var(--ion-safe-area-top, 0);padding-bottom:0;border-top:0;border-bottom:var(--border)}:host(.tab-bar-hidden){display:none !important}:host{--background:var(--ion-tab-bar-background, var(--ion-color-step-50, #f7f7f7));--background-focused:var(--ion-tab-bar-background-focused, #e0e0e0);--border:0.55px solid var(--ion-tab-bar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.2))));--color:var(--ion-tab-bar-color, var(--ion-color-step-600, #666666));--color-selected:var(--ion-tab-bar-color-selected, var(--ion-color-primary, #3880ff));height:50px}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.tab-bar-translucent){--background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8);-webkit-backdrop-filter:saturate(210%) blur(20px);backdrop-filter:saturate(210%) blur(20px)}:host(.ion-color.tab-bar-translucent){background:rgba(var(--ion-color-base-rgb), 0.8)}:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.6)}}", tabBarMdCss = ":host{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-right:var(--ion-safe-area-right);padding-bottom:var(--ion-safe-area-bottom, 0);padding-left:var(--ion-safe-area-left);border-top:var(--border);background:var(--background);color:var(--color);text-align:center;contain:strict;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:10;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host(.ion-color) ::slotted(ion-tab-button){--background-focused:var(--ion-color-shade);--color-selected:var(--ion-color-contrast)}:host(.ion-color) ::slotted(.tab-selected){color:var(--ion-color-contrast)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){color:rgba(var(--ion-color-contrast-rgb), 0.7)}:host(.ion-color),:host(.ion-color) ::slotted(ion-tab-button){background:var(--ion-color-base)}:host(.ion-color) ::slotted(ion-tab-button.ion-focused),:host(.tab-bar-translucent) ::slotted(ion-tab-button.ion-focused){background:var(--background-focused)}:host(.tab-bar-translucent) ::slotted(ion-tab-button){background:transparent}:host([slot=top]){padding-top:var(--ion-safe-area-top, 0);padding-bottom:0;border-top:0;border-bottom:var(--border)}:host(.tab-bar-hidden){display:none !important}:host{--background:var(--ion-tab-bar-background, var(--ion-background-color, #fff));--background-focused:var(--ion-tab-bar-background-focused, #e0e0e0);--border:1px solid var(--ion-tab-bar-border-color, var(--ion-border-color, var(--ion-color-step-150, rgba(0, 0, 0, 0.07))));--color:var(--ion-tab-bar-color, var(--ion-color-step-650, #595959));--color-selected:var(--ion-tab-bar-color-selected, var(--ion-color-primary, #3880ff));height:56px}", TabBar = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.ionTabBarChanged = createEvent(this, "ionTabBarChanged", 7), this.ionTabBarLoaded = createEvent(this, "ionTabBarLoaded", 7), this.keyboardCtrl = null, this.keyboardVisible = !1, this.color = void 0, this.selectedTab = void 0, this.translucent = !1;
  }
  selectedTabChanged() {
    this.selectedTab !== void 0 && this.ionTabBarChanged.emit({
      tab: this.selectedTab
    });
  }
  componentWillLoad() {
    this.selectedTabChanged();
  }
  async connectedCallback() {
    this.keyboardCtrl = await createKeyboardController(async (e, r) => {
      e === !1 && r !== void 0 && await r, this.keyboardVisible = e;
    });
  }
  disconnectedCallback() {
    this.keyboardCtrl && this.keyboardCtrl.destroy();
  }
  componentDidLoad() {
    this.ionTabBarLoaded.emit();
  }
  render() {
    const { color: e, translucent: r, keyboardVisible: o } = this, a = getIonMode$2(this), c = o && this.el.getAttribute("slot") !== "top";
    return h(Host, { role: "tablist", "aria-hidden": c ? "true" : null, class: createColorClasses$1(e, {
      [a]: !0,
      "tab-bar-translucent": r,
      "tab-bar-hidden": c
    }) }, h("slot", null));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      selectedTab: ["selectedTabChanged"]
    };
  }
  static get style() {
    return {
      ios: tabBarIosCss,
      md: tabBarMdCss
    };
  }
}, [33, "ion-tab-bar", {
  color: [513],
  selectedTab: [1, "selected-tab"],
  translucent: [4],
  keyboardVisible: [32]
}, void 0, {
  selectedTab: ["selectedTabChanged"]
}]);
function defineCustomElement$1$4() {
  if (typeof customElements > "u")
    return;
  ["ion-tab-bar"].forEach((e) => {
    switch (e) {
      case "ion-tab-bar":
        customElements.get(e) || customElements.define(e, TabBar);
        break;
    }
  });
}
const defineCustomElement$5 = defineCustomElement$1$4;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const appCss = "html.plt-mobile ion-app{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}html.plt-mobile ion-app [contenteditable]{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}ion-app.force-statusbar-padding{--ion-safe-area-top:20px}", App = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost();
  }
  componentDidLoad() {
    rIC(async () => {
      const e = isPlatform(window, "hybrid");
      if (config$1.getBoolean("_testing") || import("./index9-4ed9368b.js").then((o) => o.startTapClick(config$1)), config$1.getBoolean("statusTap", e) && import("./status-tap-d40565fa.js").then((o) => o.startStatusTap()), config$1.getBoolean("inputShims", needInputShims())) {
        const o = isPlatform(window, "ios") ? "ios" : "android";
        import("./input-shims-f446e377.js").then((a) => a.startInputShims(config$1, o));
      }
      const r = await Promise.resolve().then(() => hardwareBackButton);
      config$1.getBoolean("hardwareBackButton", e) ? r.startHardwareBackButton() : r.blockHardwareBackButton(), typeof window < "u" && Promise.resolve().then(() => keyboard2).then((o) => o.startKeyboardAssist(window)), import("./focus-visible-7660c2cd.js").then((o) => this.focusVisible = o.startFocusVisible());
    });
  }
  /**
   * @internal
   * Used to set focus on an element that uses `ion-focusable`.
   * Do not use this if focusing the element as a result of a keyboard
   * event as the focus utility should handle this for us. This method
   * should be used when we want to programmatically focus an element as
   * a result of another user action. (Ex: We focus the first element
   * inside of a popover when the user presents it, but the popover is not always
   * presented as a result of keyboard action.)
   */
  async setFocus(e) {
    this.focusVisible && this.focusVisible.setFocus(e);
  }
  render() {
    const e = getIonMode$2(this);
    return h(Host, { class: {
      [e]: !0,
      "ion-page": !0,
      "force-statusbar-padding": config$1.getBoolean("_forceStatusbarPadding")
    } });
  }
  get el() {
    return this;
  }
  static get style() {
    return appCss;
  }
}, [0, "ion-app", {
  setFocus: [64]
}]), needInputShims = () => !!(isPlatform(window, "ios") && isPlatform(window, "mobile") || isPlatform(window, "android") && isPlatform(window, "mobileweb")), rIC = (t) => {
  "requestIdleCallback" in window ? window.requestIdleCallback(t) : setTimeout(t, 32);
};
function defineCustomElement$1$3() {
  if (typeof customElements > "u")
    return;
  ["ion-app"].forEach((e) => {
    switch (e) {
      case "ion-app":
        customElements.get(e) || customElements.define(e, App);
        break;
    }
  });
}
const defineCustomElement$4 = defineCustomElement$1$3;
let CACHED_MAP;
const getIconMap = () => {
  if (typeof window > "u")
    return /* @__PURE__ */ new Map();
  if (!CACHED_MAP) {
    const t = window;
    t.Ionicons = t.Ionicons || {}, CACHED_MAP = t.Ionicons.map = t.Ionicons.map || /* @__PURE__ */ new Map();
  }
  return CACHED_MAP;
}, getUrl = (t) => {
  let e = getSrc(t.src);
  return e || (e = getName(t.name, t.icon, t.mode, t.ios, t.md), e ? getNamedUrl(e, t) : t.icon && (e = getSrc(t.icon), e || (e = getSrc(t.icon[t.mode]), e)) ? e : null);
}, getNamedUrl = (t, e) => {
  const r = getIconMap().get(t);
  if (r)
    return r;
  try {
    return getAssetPath(`svg/${t}.svg`);
  } catch {
    console.warn(`[Ionicons Warning]: Could not load icon with name "${t}". Ensure that the icon is registered using addIcons or that the icon SVG data is passed directly to the icon component.`, e);
  }
}, getName = (t, e, r, o, a) => (r = (r && toLower(r)) === "ios" ? "ios" : "md", o && r === "ios" ? t = toLower(o) : a && r === "md" ? t = toLower(a) : (!t && e && !isSrc(e) && (t = e), isStr(t) && (t = toLower(t))), !isStr(t) || t.trim() === "" || t.replace(/[a-z]|-|\d/gi, "") !== "" ? null : t), getSrc = (t) => isStr(t) && (t = t.trim(), isSrc(t)) ? t : null, isSrc = (t) => t.length > 0 && /(\/|\.)/.test(t), isStr = (t) => typeof t == "string", toLower = (t) => t.toLowerCase(), inheritAttributes = (t, e = []) => {
  const r = {};
  return e.forEach((o) => {
    t.hasAttribute(o) && (t.getAttribute(o) !== null && (r[o] = t.getAttribute(o)), t.removeAttribute(o));
  }), r;
}, isRTL = (t) => t && t.dir !== "" ? t.dir.toLowerCase() === "rtl" : (document == null ? void 0 : document.dir.toLowerCase()) === "rtl", validateContent = (t) => {
  const e = document.createElement("div");
  e.innerHTML = t;
  for (let o = e.childNodes.length - 1; o >= 0; o--)
    e.childNodes[o].nodeName.toLowerCase() !== "svg" && e.removeChild(e.childNodes[o]);
  const r = e.firstElementChild;
  if (r && r.nodeName.toLowerCase() === "svg") {
    const o = r.getAttribute("class") || "";
    if (r.setAttribute("class", (o + " s-ion-icon").trim()), isValid(r))
      return e.innerHTML;
  }
  return "";
}, isValid = (t) => {
  if (t.nodeType === 1) {
    if (t.nodeName.toLowerCase() === "script")
      return !1;
    for (let e = 0; e < t.attributes.length; e++) {
      const r = t.attributes[e].name;
      if (isStr(r) && r.toLowerCase().indexOf("on") === 0)
        return !1;
    }
    for (let e = 0; e < t.childNodes.length; e++)
      if (!isValid(t.childNodes[e]))
        return !1;
  }
  return !0;
}, isSvgDataUrl = (t) => t.startsWith("data:image/svg+xml"), isEncodedDataUrl = (t) => t.indexOf(";utf8,") !== -1, ioniconContent = /* @__PURE__ */ new Map(), requests = /* @__PURE__ */ new Map();
let parser;
const getSvgContent = (t, e) => {
  let r = requests.get(t);
  if (!r)
    if (typeof fetch < "u" && typeof document < "u")
      if (isSvgDataUrl(t) && isEncodedDataUrl(t)) {
        parser || (parser = new DOMParser());
        const a = parser.parseFromString(t, "text/html").querySelector("svg");
        return a && ioniconContent.set(t, a.outerHTML), Promise.resolve();
      } else
        r = fetch(t).then((o) => {
          if (o.ok)
            return o.text().then((a) => {
              a && e !== !1 && (a = validateContent(a)), ioniconContent.set(t, a || "");
            });
          ioniconContent.set(t, "");
        }), requests.set(t, r);
    else
      return ioniconContent.set(t, ""), Promise.resolve();
  return r;
}, iconCss = ":host{display:inline-block;width:1em;height:1em;contain:strict;fill:currentColor;-webkit-box-sizing:content-box !important;box-sizing:content-box !important}:host .ionicon{stroke:currentColor}.ionicon-fill-none{fill:none}.ionicon-stroke-width{stroke-width:32px;stroke-width:var(--ionicon-stroke-width, 32px)}.icon-inner,.ionicon,svg{display:block;height:100%;width:100%}@supports (background: -webkit-named-image(i)){:host(.icon-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}@supports not selector(:dir(rtl)) and selector(:host-context([dir='rtl'])){:host(.icon-rtl) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}:host(.flip-rtl):host-context([dir='rtl']) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}@supports selector(:dir(rtl)){:host(.flip-rtl:dir(rtl)) .icon-inner{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(.flip-rtl:dir(ltr)) .icon-inner{-webkit-transform:scaleX(1);transform:scaleX(1)}}:host(.icon-small){font-size:1.125rem !important}:host(.icon-large){font-size:2rem !important}:host(.ion-color){color:var(--ion-color-base) !important}:host(.ion-color-primary){--ion-color-base:var(--ion-color-primary, #3880ff)}:host(.ion-color-secondary){--ion-color-base:var(--ion-color-secondary, #0cd1e8)}:host(.ion-color-tertiary){--ion-color-base:var(--ion-color-tertiary, #f4a942)}:host(.ion-color-success){--ion-color-base:var(--ion-color-success, #10dc60)}:host(.ion-color-warning){--ion-color-base:var(--ion-color-warning, #ffce00)}:host(.ion-color-danger){--ion-color-base:var(--ion-color-danger, #f14141)}:host(.ion-color-light){--ion-color-base:var(--ion-color-light, #f4f5f8)}:host(.ion-color-medium){--ion-color-base:var(--ion-color-medium, #989aa2)}:host(.ion-color-dark){--ion-color-base:var(--ion-color-dark, #222428)}", Icon = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.iconName = null, this.inheritedAttributes = {}, this.didLoadIcon = !1, this.svgContent = void 0, this.isVisible = !1, this.mode = getIonMode(), this.color = void 0, this.ios = void 0, this.md = void 0, this.flipRtl = void 0, this.name = void 0, this.src = void 0, this.icon = void 0, this.size = void 0, this.lazy = !1, this.sanitize = !0;
  }
  componentWillLoad() {
    this.inheritedAttributes = inheritAttributes(this.el, ["aria-label"]);
  }
  connectedCallback() {
    this.waitUntilVisible(this.el, "50px", () => {
      this.isVisible = !0, this.loadIcon();
    });
  }
  componentDidLoad() {
    this.didLoadIcon || this.loadIcon();
  }
  disconnectedCallback() {
    this.io && (this.io.disconnect(), this.io = void 0);
  }
  waitUntilVisible(e, r, o) {
    if (this.lazy && typeof window < "u" && window.IntersectionObserver) {
      const a = this.io = new window.IntersectionObserver((c) => {
        c[0].isIntersecting && (a.disconnect(), this.io = void 0, o());
      }, { rootMargin: r });
      a.observe(e);
    } else
      o();
  }
  loadIcon() {
    if (this.isVisible) {
      const e = getUrl(this);
      e && (ioniconContent.has(e) ? this.svgContent = ioniconContent.get(e) : getSvgContent(e, this.sanitize).then(() => this.svgContent = ioniconContent.get(e)), this.didLoadIcon = !0);
    }
    this.iconName = getName(this.name, this.icon, this.mode, this.ios, this.md);
  }
  render() {
    const { flipRtl: e, iconName: r, inheritedAttributes: o, el: a } = this, c = this.mode || "md", u = r ? (r.includes("arrow") || r.includes("chevron")) && e !== !1 : !1, d = e || u;
    return h(Host, Object.assign({ role: "img", class: Object.assign(Object.assign({ [c]: !0 }, createColorClasses(this.color)), { [`icon-${this.size}`]: !!this.size, "flip-rtl": d, "icon-rtl": d && isRTL(a) }) }, o), this.svgContent ? h("div", { class: "icon-inner", innerHTML: this.svgContent }) : h("div", { class: "icon-inner" }));
  }
  static get assetsDirs() {
    return ["svg"];
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      name: ["loadIcon"],
      src: ["loadIcon"],
      icon: ["loadIcon"],
      ios: ["loadIcon"],
      md: ["loadIcon"]
    };
  }
  static get style() {
    return iconCss;
  }
}, [1, "ion-icon", {
  mode: [1025],
  color: [1],
  ios: [1],
  md: [1],
  flipRtl: [4, "flip-rtl"],
  name: [513],
  src: [1],
  icon: [8],
  size: [1],
  lazy: [4],
  sanitize: [4],
  svgContent: [32],
  isVisible: [32]
}]), getIonMode = () => typeof document < "u" && document.documentElement.getAttribute("mode") || "md", createColorClasses = (t) => t ? {
  "ion-color": !0,
  [`ion-color-${t}`]: !0
} : null;
function defineCustomElement$1$2() {
  if (typeof customElements > "u")
    return;
  ["ion-icon"].forEach((e) => {
    switch (e) {
      case "ion-icon":
        customElements.get(e) || customElements.define(e, Icon);
        break;
    }
  });
}
const defineCustomElement$3 = defineCustomElement$1$2;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
function getAnimationPosition(t, e, r, o) {
  let a;
  if (r === "md" ? a = t === "top" ? 8 : -8 : a = t === "top" ? 10 : -10, e && win) {
    warnIfAnchorIsHidden(e, o);
    const c = e.getBoundingClientRect();
    return t === "top" ? a += c.bottom : t === "bottom" && (a -= win.innerHeight - c.top), {
      top: `${a}px`,
      bottom: `${a}px`
    };
  } else
    return {
      top: `calc(${a}px + var(--ion-safe-area-top, 0px))`,
      bottom: `calc(${a}px - var(--ion-safe-area-bottom, 0px))`
    };
}
function warnIfAnchorIsHidden(t, e) {
  t.offsetParent === null && printIonWarning("The positionAnchor element for ion-toast was found in the DOM, but appears to be hidden. This may lead to unexpected positioning of the toast.", e);
}
const getOffsetForMiddlePosition = (t, e) => Math.floor(t / 2 - e / 2), iosEnterAnimation$1 = (t, e) => {
  const r = createAnimation(), o = createAnimation(), { position: a, top: c, bottom: u } = e, p = getElementRoot(t).querySelector(".toast-wrapper");
  switch (o.addElement(p), a) {
    case "top":
      o.fromTo("transform", "translateY(-100%)", `translateY(${c})`);
      break;
    case "middle":
      const g = getOffsetForMiddlePosition(t.clientHeight, p.clientHeight);
      p.style.top = `${g}px`, o.fromTo("opacity", 0.01, 1);
      break;
    default:
      o.fromTo("transform", "translateY(100%)", `translateY(${u})`);
      break;
  }
  return r.easing("cubic-bezier(.155,1.105,.295,1.12)").duration(400).addAnimation(o);
}, iosLeaveAnimation$1 = (t, e) => {
  const r = createAnimation(), o = createAnimation(), { position: a, top: c, bottom: u } = e, p = getElementRoot(t).querySelector(".toast-wrapper");
  switch (o.addElement(p), a) {
    case "top":
      o.fromTo("transform", `translateY(${c})`, "translateY(-100%)");
      break;
    case "middle":
      o.fromTo("opacity", 0.99, 0);
      break;
    default:
      o.fromTo("transform", `translateY(${u})`, "translateY(100%)");
      break;
  }
  return r.easing("cubic-bezier(.36,.66,.04,1)").duration(300).addAnimation(o);
}, mdEnterAnimation$1 = (t, e) => {
  const r = createAnimation(), o = createAnimation(), { position: a, top: c, bottom: u } = e, p = getElementRoot(t).querySelector(".toast-wrapper");
  switch (o.addElement(p), a) {
    case "top":
      p.style.setProperty("transform", `translateY(${c})`), o.fromTo("opacity", 0.01, 1);
      break;
    case "middle":
      const g = getOffsetForMiddlePosition(t.clientHeight, p.clientHeight);
      p.style.top = `${g}px`, o.fromTo("opacity", 0.01, 1);
      break;
    default:
      p.style.setProperty("transform", `translateY(${u})`), o.fromTo("opacity", 0.01, 1);
      break;
  }
  return r.easing("cubic-bezier(.36,.66,.04,1)").duration(400).addAnimation(o);
}, mdLeaveAnimation$1 = (t) => {
  const e = createAnimation(), r = createAnimation(), a = getElementRoot(t).querySelector(".toast-wrapper");
  return r.addElement(a).fromTo("opacity", 0.99, 0), e.easing("cubic-bezier(.36,.66,.04,1)").duration(300).addAnimation(r);
}, createSwipeToDismissGesture = (t, e, r) => {
  const o = getElementRoot(t).querySelector(".toast-wrapper"), a = t.clientHeight, c = o.getBoundingClientRect();
  let u = 0;
  const d = 0.5, p = t.position === "middle" ? 0.5 : 0, g = t.position === "top" ? -1 : 1, b = getOffsetForMiddlePosition(a, c.height), x = [
    { offset: 0, transform: `translateY(-${b + c.height}px)` },
    { offset: 0.5, transform: "translateY(0px)" },
    { offset: 1, transform: `translateY(${b + c.height}px)` }
  ], w = createAnimation("toast-swipe-to-dismiss-animation").addElement(o).duration(100);
  switch (t.position) {
    case "middle":
      u = a + c.height, w.keyframes(x), w.progressStart(!0, 0.5);
      break;
    case "top":
      u = c.bottom, w.keyframes([
        { offset: 0, transform: `translateY(${e.top})` },
        { offset: 1, transform: "translateY(-100%)" }
      ]), w.progressStart(!0, 0);
      break;
    case "bottom":
    default:
      u = a - c.top, w.keyframes([
        { offset: 0, transform: `translateY(${e.bottom})` },
        { offset: 1, transform: "translateY(100%)" }
      ]), w.progressStart(!0, 0);
      break;
  }
  const y = (C) => C * g / u, T = createGesture({
    el: o,
    gestureName: "toast-swipe-to-dismiss",
    gesturePriority: OVERLAY_GESTURE_PRIORITY,
    /**
     * Toast only supports vertical swipes.
     * This needs to be updated if we later
     * support horizontal swipes.
     */
    direction: "y",
    onMove: (C) => {
      const $ = p + y(C.deltaY);
      w.progressStep($);
    },
    onEnd: (C) => {
      const $ = C.velocityY, D = (C.deltaY + $ * 1e3) / u * g;
      T.enable(!1);
      let L = !0, R = 1, O = 0, P = 0;
      if (t.position === "middle") {
        L = D >= d / 2 || D <= -d / 2, R = 1, O = 0;
        const W = o.getBoundingClientRect(), A = W.top - b, S = `${A}px`, F = C.deltaY <= 0 ? -1 : 1, U = (b + W.height) * F, M = L ? `${U}px` : "0px", V = [
          { offset: 0, transform: `translateY(${S})` },
          { offset: 1, transform: `translateY(${M})` }
        ];
        w.keyframes(V), P = U - A;
      } else
        L = D >= d, R = L ? 1 : 0, O = y(C.deltaY), P = (L ? 1 - O : O) * u;
      const z = Math.min(Math.abs(P) / Math.abs($), 200);
      w.onFinish(() => {
        L ? (r(), w.destroy()) : (t.position === "middle" ? w.keyframes(x).progressStart(!0, 0.5) : w.progressStart(!0, 0), T.enable(!0));
      }, { oneTimeCallback: !0 }).progressEnd(R, O, z);
    }
  });
  return T;
}, toastIosCss = ":host{--border-width:0;--border-style:none;--border-color:initial;--box-shadow:none;--min-width:auto;--width:auto;--min-height:auto;--height:auto;--max-height:auto;--white-space:normal;top:0;display:block;position:absolute;width:100%;height:100%;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);contain:strict;z-index:1001;pointer-events:none}@supports (inset-inline-start: 0){:host{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host{left:0}:host-context([dir=rtl]){left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(:dir(rtl)){left:unset;right:unset;right:0}}}:host(.overlay-hidden){display:none}:host(.ion-color){--button-color:inherit;color:var(--ion-color-contrast)}:host(.ion-color) .toast-button-cancel{color:inherit}:host(.ion-color) .toast-wrapper{background:var(--ion-color-base)}.toast-wrapper{border-radius:var(--border-radius);width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow)}@supports (inset-inline-start: 0){.toast-wrapper{inset-inline-start:var(--start);inset-inline-end:var(--end)}}@supports not (inset-inline-start: 0){.toast-wrapper{left:var(--start);right:var(--end)}:host-context([dir=rtl]) .toast-wrapper{left:unset;right:unset;left:var(--end);right:var(--start)}[dir=rtl] .toast-wrapper{left:unset;right:unset;left:var(--end);right:var(--start)}@supports selector(:dir(rtl)){.toast-wrapper:dir(rtl){left:unset;right:unset;left:var(--end);right:var(--start)}}}.toast-wrapper.toast-top{-webkit-transform:translate3d(0,  -100%,  0);transform:translate3d(0,  -100%,  0);top:0}.toast-wrapper.toast-bottom{-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);bottom:0}.toast-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;pointer-events:auto;height:inherit;min-height:inherit;max-height:inherit;contain:content}.toast-layout-stacked .toast-container{-ms-flex-wrap:wrap;flex-wrap:wrap}.toast-layout-baseline .toast-content{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center}.toast-icon{-webkit-margin-start:16px;margin-inline-start:16px}.toast-content{min-width:0}.toast-message{-ms-flex:1;flex:1;white-space:var(--white-space)}.toast-button-group{display:-ms-flexbox;display:flex}.toast-layout-stacked .toast-button-group{-ms-flex-pack:end;justify-content:end;width:100%}.toast-button{border:0;outline:none;color:var(--button-color);z-index:0}.toast-icon,.toast-button-icon{font-size:1.4em}.toast-button-inner{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}@media (any-hover: hover){.toast-button:hover{cursor:pointer}}:host{--background:var(--ion-color-step-50, #f2f2f2);--border-radius:14px;--button-color:var(--ion-color-primary, #3880ff);--color:var(--ion-color-step-850, #262626);--max-width:700px;--max-height:478px;--start:10px;--end:10px;font-size:clamp(14px, 0.875rem, 43.4px)}.toast-wrapper{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:auto;margin-bottom:auto;display:block;position:absolute;z-index:10}@supports ((-webkit-backdrop-filter: blur(0)) or (backdrop-filter: blur(0))){:host(.toast-translucent) .toast-wrapper{background:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.8);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px)}:host(.ion-color.toast-translucent) .toast-wrapper{background:rgba(var(--ion-color-base-rgb), 0.8)}}.toast-wrapper.toast-middle{opacity:0.01}.toast-content{-webkit-padding-start:15px;padding-inline-start:15px;-webkit-padding-end:15px;padding-inline-end:15px;padding-top:15px;padding-bottom:15px}.toast-header{margin-bottom:2px;font-weight:500}.toast-button{-webkit-padding-start:15px;padding-inline-start:15px;-webkit-padding-end:15px;padding-inline-end:15px;padding-top:10px;padding-bottom:10px;min-height:44px;-webkit-transition:background-color, opacity 100ms linear;transition:background-color, opacity 100ms linear;border:0;background-color:transparent;font-family:var(--ion-font-family);font-size:clamp(17px, 1.0625rem, 21.998px);font-weight:500;overflow:hidden}.toast-button.ion-activated{opacity:0.4}@media (any-hover: hover){.toast-button:hover{opacity:0.6}}", toastMdCss = ":host{--border-width:0;--border-style:none;--border-color:initial;--box-shadow:none;--min-width:auto;--width:auto;--min-height:auto;--height:auto;--max-height:auto;--white-space:normal;top:0;display:block;position:absolute;width:100%;height:100%;outline:none;color:var(--color);font-family:var(--ion-font-family, inherit);contain:strict;z-index:1001;pointer-events:none}@supports (inset-inline-start: 0){:host{inset-inline-start:0}}@supports not (inset-inline-start: 0){:host{left:0}:host-context([dir=rtl]){left:unset;right:unset;right:0}@supports selector(:dir(rtl)){:host(:dir(rtl)){left:unset;right:unset;right:0}}}:host(.overlay-hidden){display:none}:host(.ion-color){--button-color:inherit;color:var(--ion-color-contrast)}:host(.ion-color) .toast-button-cancel{color:inherit}:host(.ion-color) .toast-wrapper{background:var(--ion-color-base)}.toast-wrapper{border-radius:var(--border-radius);width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow)}@supports (inset-inline-start: 0){.toast-wrapper{inset-inline-start:var(--start);inset-inline-end:var(--end)}}@supports not (inset-inline-start: 0){.toast-wrapper{left:var(--start);right:var(--end)}:host-context([dir=rtl]) .toast-wrapper{left:unset;right:unset;left:var(--end);right:var(--start)}[dir=rtl] .toast-wrapper{left:unset;right:unset;left:var(--end);right:var(--start)}@supports selector(:dir(rtl)){.toast-wrapper:dir(rtl){left:unset;right:unset;left:var(--end);right:var(--start)}}}.toast-wrapper.toast-top{-webkit-transform:translate3d(0,  -100%,  0);transform:translate3d(0,  -100%,  0);top:0}.toast-wrapper.toast-bottom{-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0);bottom:0}.toast-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;pointer-events:auto;height:inherit;min-height:inherit;max-height:inherit;contain:content}.toast-layout-stacked .toast-container{-ms-flex-wrap:wrap;flex-wrap:wrap}.toast-layout-baseline .toast-content{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center}.toast-icon{-webkit-margin-start:16px;margin-inline-start:16px}.toast-content{min-width:0}.toast-message{-ms-flex:1;flex:1;white-space:var(--white-space)}.toast-button-group{display:-ms-flexbox;display:flex}.toast-layout-stacked .toast-button-group{-ms-flex-pack:end;justify-content:end;width:100%}.toast-button{border:0;outline:none;color:var(--button-color);z-index:0}.toast-icon,.toast-button-icon{font-size:1.4em}.toast-button-inner{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}@media (any-hover: hover){.toast-button:hover{cursor:pointer}}:host{--background:var(--ion-color-step-800, #333333);--border-radius:4px;--box-shadow:0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);--button-color:var(--ion-color-primary, #3880ff);--color:var(--ion-color-step-50, #f2f2f2);--max-width:700px;--start:8px;--end:8px;font-size:0.875rem}.toast-wrapper{-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;margin-top:auto;margin-bottom:auto;display:block;position:absolute;opacity:0.01;z-index:10}.toast-content{-webkit-padding-start:16px;padding-inline-start:16px;-webkit-padding-end:16px;padding-inline-end:16px;padding-top:14px;padding-bottom:14px}.toast-header{margin-bottom:2px;font-weight:500;line-height:1.25rem}.toast-message{line-height:1.25rem}.toast-layout-baseline .toast-button-group-start{-webkit-margin-start:8px;margin-inline-start:8px}.toast-layout-stacked .toast-button-group-start{-webkit-margin-end:8px;margin-inline-end:8px;margin-top:8px}.toast-layout-baseline .toast-button-group-end{-webkit-margin-end:8px;margin-inline-end:8px}.toast-layout-stacked .toast-button-group-end{-webkit-margin-end:8px;margin-inline-end:8px;margin-bottom:8px}.toast-button{-webkit-padding-start:15px;padding-inline-start:15px;-webkit-padding-end:15px;padding-inline-end:15px;padding-top:10px;padding-bottom:10px;position:relative;background-color:transparent;font-family:var(--ion-font-family);font-size:0.875rem;font-weight:500;letter-spacing:0.84px;text-transform:uppercase;overflow:hidden}.toast-button-cancel{color:var(--ion-color-step-100, #e6e6e6)}.toast-button-icon-only{border-radius:50%;-webkit-padding-start:9px;padding-inline-start:9px;-webkit-padding-end:9px;padding-inline-end:9px;padding-top:9px;padding-bottom:9px;width:36px;height:36px}@media (any-hover: hover){.toast-button:hover{background-color:rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.08)}.toast-button-cancel:hover{background-color:rgba(var(--ion-background-color-rgb, 255, 255, 255), 0.08)}}", Toast = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.didPresent = createEvent(this, "ionToastDidPresent", 7), this.willPresent = createEvent(this, "ionToastWillPresent", 7), this.willDismiss = createEvent(this, "ionToastWillDismiss", 7), this.didDismiss = createEvent(this, "ionToastDidDismiss", 7), this.didPresentShorthand = createEvent(this, "didPresent", 7), this.willPresentShorthand = createEvent(this, "willPresent", 7), this.willDismissShorthand = createEvent(this, "willDismiss", 7), this.didDismissShorthand = createEvent(this, "didDismiss", 7), this.delegateController = createDelegateController(this), this.lockController = createLockController(), this.triggerController = createTriggerController(), this.customHTMLEnabled = config$1.get("innerHTMLTemplatesEnabled", ENABLE_HTML_CONTENT_DEFAULT), this.presented = !1, this.dispatchCancelHandler = (e) => {
      const r = e.detail.role;
      if (isCancel$2(r)) {
        const o = this.getButtons().find((a) => a.role === "cancel");
        this.callButtonHandler(o);
      }
    }, this.createSwipeGesture = (e) => {
      (this.gesture = createSwipeToDismissGesture(this.el, e, () => {
        this.dismiss(void 0, GESTURE);
      })).enable(!0);
    }, this.destroySwipeGesture = () => {
      const { gesture: e } = this;
      e !== void 0 && (e.destroy(), this.gesture = void 0);
    }, this.prefersSwipeGesture = () => {
      const { swipeGesture: e } = this;
      return e === "vertical";
    }, this.revealContentToScreenReader = !1, this.overlayIndex = void 0, this.delegate = void 0, this.hasController = !1, this.color = void 0, this.enterAnimation = void 0, this.leaveAnimation = void 0, this.cssClass = void 0, this.duration = config$1.getNumber("toastDuration", 0), this.header = void 0, this.layout = "baseline", this.message = void 0, this.keyboardClose = !1, this.position = "bottom", this.positionAnchor = void 0, this.buttons = void 0, this.translucent = !1, this.animated = !0, this.icon = void 0, this.htmlAttributes = void 0, this.swipeGesture = void 0, this.isOpen = !1, this.trigger = void 0;
  }
  swipeGestureChanged() {
    this.destroySwipeGesture(), this.presented && this.prefersSwipeGesture() && this.createSwipeGesture(this.lastPresentedPosition);
  }
  onIsOpenChange(e, r) {
    e === !0 && r === !1 ? this.present() : e === !1 && r === !0 && this.dismiss();
  }
  triggerChanged() {
    const { trigger: e, el: r, triggerController: o } = this;
    e && o.addClickListener(r, e);
  }
  connectedCallback() {
    prepareOverlay(this.el), this.triggerChanged();
  }
  disconnectedCallback() {
    this.triggerController.removeClickListener();
  }
  componentWillLoad() {
    setOverlayId(this.el);
  }
  componentDidLoad() {
    this.isOpen === !0 && raf(() => this.present()), this.triggerChanged();
  }
  /**
   * Present the toast overlay after it has been created.
   */
  async present() {
    const e = await this.lockController.lock();
    await this.delegateController.attachViewToDom();
    const { el: r, position: o } = this, a = this.getAnchorElement(), c = getAnimationPosition(o, a, getIonMode$2(this), r);
    this.lastPresentedPosition = c, await present(this, "toastEnter", iosEnterAnimation$1, mdEnterAnimation$1, {
      position: o,
      top: c.top,
      bottom: c.bottom
    }), this.revealContentToScreenReader = !0, this.duration > 0 && (this.durationTimeout = setTimeout(() => this.dismiss(void 0, "timeout"), this.duration)), this.prefersSwipeGesture() && this.createSwipeGesture(c), e();
  }
  /**
   * Dismiss the toast overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the toast.
   * This can be useful in a button handler for determining which button was
   * clicked to dismiss the toast.
   * Some examples include: ``"cancel"`, `"destructive"`, "selected"`, and `"backdrop"`.
   */
  async dismiss(e, r) {
    var o, a;
    const c = await this.lockController.lock(), { durationTimeout: u, position: d, lastPresentedPosition: p } = this;
    u && clearTimeout(u);
    const g = await dismiss(
      this,
      e,
      r,
      "toastLeave",
      iosLeaveAnimation$1,
      mdLeaveAnimation$1,
      /**
       * Fetch the cached position that was calculated back in the present
       * animation. We always want to animate the dismiss from the same
       * position the present stopped at, so the animation looks continuous.
       */
      {
        position: d,
        top: (o = p == null ? void 0 : p.top) !== null && o !== void 0 ? o : "",
        bottom: (a = p == null ? void 0 : p.bottom) !== null && a !== void 0 ? a : ""
      }
    );
    return g && (this.delegateController.removeViewFromDom(), this.revealContentToScreenReader = !1), this.lastPresentedPosition = void 0, this.destroySwipeGesture(), c(), g;
  }
  /**
   * Returns a promise that resolves when the toast did dismiss.
   */
  onDidDismiss() {
    return eventMethod(this.el, "ionToastDidDismiss");
  }
  /**
   * Returns a promise that resolves when the toast will dismiss.
   */
  onWillDismiss() {
    return eventMethod(this.el, "ionToastWillDismiss");
  }
  getButtons() {
    return this.buttons ? this.buttons.map((r) => typeof r == "string" ? { text: r } : r) : [];
  }
  /**
   * Returns the element specified by the positionAnchor prop,
   * or undefined if prop's value is an ID string and the element
   * is not found in the DOM.
   */
  getAnchorElement() {
    const { position: e, positionAnchor: r, el: o } = this;
    if (r !== void 0) {
      if (e === "middle" && r !== void 0) {
        printIonWarning('The positionAnchor property is ignored when using position="middle".', this.el);
        return;
      }
      if (typeof r == "string") {
        const a = document.getElementById(r);
        if (a === null) {
          printIonWarning(`An anchor element with an ID of "${r}" was not found in the DOM.`, o);
          return;
        }
        return a;
      }
      if (r instanceof H)
        return r;
      printIonWarning("Invalid positionAnchor value:", r, o);
    }
  }
  async buttonClick(e) {
    const r = e.role;
    return isCancel$2(r) ? this.dismiss(void 0, r) : await this.callButtonHandler(e) ? this.dismiss(void 0, r) : Promise.resolve();
  }
  async callButtonHandler(e) {
    if (e != null && e.handler)
      try {
        if (await safeCall(e.handler) === !1)
          return !1;
      } catch (r) {
        console.error(r);
      }
    return !0;
  }
  renderButtons(e, r) {
    if (e.length === 0)
      return;
    const o = getIonMode$2(this), a = {
      "toast-button-group": !0,
      [`toast-button-group-${r}`]: !0
    };
    return h("div", { class: a }, e.map((c) => h("button", Object.assign({}, c.htmlAttributes, { type: "button", class: buttonClass(c), tabIndex: 0, onClick: () => this.buttonClick(c), part: buttonPart(c) }), h("div", { class: "toast-button-inner" }, c.icon && h("ion-icon", { "aria-hidden": "true", icon: c.icon, slot: c.text === void 0 ? "icon-only" : void 0, class: "toast-button-icon" }), c.text), o === "md" && h("ion-ripple-effect", { type: c.icon !== void 0 && c.text === void 0 ? "unbounded" : "bounded" }))));
  }
  /**
   * Render the `message` property.
   * @param key - A key to give the element a stable identity. This is used to improve compatibility with screen readers.
   * @param ariaHidden - If "true" then content will be hidden from screen readers.
   */
  renderToastMessage(e, r = null) {
    const { customHTMLEnabled: o, message: a } = this;
    return o ? h("div", { key: e, "aria-hidden": r, class: "toast-message", part: "message", innerHTML: sanitizeDOMString(a) }) : h("div", { key: e, "aria-hidden": r, class: "toast-message", part: "message" }, a);
  }
  /**
   * Render the `header` property.
   * @param key - A key to give the element a stable identity. This is used to improve compatibility with screen readers.
   * @param ariaHidden - If "true" then content will be hidden from screen readers.
   */
  renderHeader(e, r = null) {
    return h("div", { key: e, class: "toast-header", "aria-hidden": r, part: "header" }, this.header);
  }
  render() {
    const { layout: e, el: r, revealContentToScreenReader: o, header: a, message: c } = this, u = this.getButtons(), d = u.filter((x) => x.side === "start"), p = u.filter((x) => x.side !== "start"), g = getIonMode$2(this), b = {
      "toast-wrapper": !0,
      [`toast-${this.position}`]: !0,
      [`toast-layout-${e}`]: !0
    };
    return e === "stacked" && d.length > 0 && p.length > 0 && printIonWarning("This toast is using start and end buttons with the stacked toast layout. We recommend following the best practice of using either start or end buttons with the stacked toast layout.", r), h(Host, Object.assign({ tabindex: "-1" }, this.htmlAttributes, { style: {
      zIndex: `${6e4 + this.overlayIndex}`
    }, class: createColorClasses$1(this.color, Object.assign(Object.assign({ [g]: !0 }, getClassMap(this.cssClass)), { "overlay-hidden": !0, "toast-translucent": this.translucent })), onIonToastWillDismiss: this.dispatchCancelHandler }), h("div", { class: b }, h("div", { class: "toast-container", part: "container" }, this.renderButtons(d, "start"), this.icon !== void 0 && h("ion-icon", { class: "toast-icon", part: "icon", icon: this.icon, lazy: !1, "aria-hidden": "true" }), h("div", { class: "toast-content", role: "status", "aria-atomic": "true", "aria-live": "polite" }, !o && a !== void 0 && this.renderHeader("oldHeader", "true"), !o && c !== void 0 && this.renderToastMessage("oldMessage", "true"), o && a !== void 0 && this.renderHeader("header"), o && c !== void 0 && this.renderToastMessage("header")), this.renderButtons(p, "end"))));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      swipeGesture: ["swipeGestureChanged"],
      isOpen: ["onIsOpenChange"],
      trigger: ["triggerChanged"]
    };
  }
  static get style() {
    return {
      ios: toastIosCss,
      md: toastMdCss
    };
  }
}, [33, "ion-toast", {
  overlayIndex: [2, "overlay-index"],
  delegate: [16],
  hasController: [4, "has-controller"],
  color: [513],
  enterAnimation: [16],
  leaveAnimation: [16],
  cssClass: [1, "css-class"],
  duration: [2],
  header: [1],
  layout: [1],
  message: [1],
  keyboardClose: [4, "keyboard-close"],
  position: [1],
  positionAnchor: [1, "position-anchor"],
  buttons: [16],
  translucent: [4],
  animated: [4],
  icon: [1],
  htmlAttributes: [16],
  swipeGesture: [1, "swipe-gesture"],
  isOpen: [4, "is-open"],
  trigger: [1],
  revealContentToScreenReader: [32],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64]
}, void 0, {
  swipeGesture: ["swipeGestureChanged"],
  isOpen: ["onIsOpenChange"],
  trigger: ["triggerChanged"]
}]), buttonClass = (t) => Object.assign({ "toast-button": !0, "toast-button-icon-only": t.icon !== void 0 && t.text === void 0, [`toast-button-${t.role}`]: t.role !== void 0, "ion-focusable": !0, "ion-activatable": !0 }, getClassMap(t.cssClass)), buttonPart = (t) => isCancel$2(t.role) ? "button cancel" : "button";
function defineCustomElement$1$1() {
  if (typeof customElements > "u")
    return;
  ["ion-toast", "ion-icon", "ion-ripple-effect"].forEach((e) => {
    switch (e) {
      case "ion-toast":
        customElements.get(e) || customElements.define(e, Toast);
        break;
      case "ion-icon":
        customElements.get(e) || defineCustomElement$T();
        break;
      case "ion-ripple-effect":
        customElements.get(e) || defineCustomElement$Q();
        break;
    }
  });
}
const defineCustomElement$2 = defineCustomElement$1$1;
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
const KEYBOARD_DID_OPEN = "ionKeyboardDidShow", KEYBOARD_DID_CLOSE = "ionKeyboardDidHide", KEYBOARD_THRESHOLD = 150;
let previousVisualViewport = {}, currentVisualViewport = {}, keyboardOpen = !1;
const resetKeyboardAssist = () => {
  previousVisualViewport = {}, currentVisualViewport = {}, keyboardOpen = !1;
}, startKeyboardAssist = (t) => {
  if (Keyboard.getEngine())
    startNativeListeners(t);
  else {
    if (!t.visualViewport)
      return;
    currentVisualViewport = copyVisualViewport(t.visualViewport), t.visualViewport.onresize = () => {
      trackViewportChanges(t), keyboardDidOpen() || keyboardDidResize(t) ? setKeyboardOpen(t) : keyboardDidClose(t) && setKeyboardClose(t);
    };
  }
}, startNativeListeners = (t) => {
  t.addEventListener("keyboardDidShow", (e) => setKeyboardOpen(t, e)), t.addEventListener("keyboardDidHide", () => setKeyboardClose(t));
}, setKeyboardOpen = (t, e) => {
  fireKeyboardOpenEvent(t, e), keyboardOpen = !0;
}, setKeyboardClose = (t) => {
  fireKeyboardCloseEvent(t), keyboardOpen = !1;
}, keyboardDidOpen = () => {
  const t = (previousVisualViewport.height - currentVisualViewport.height) * currentVisualViewport.scale;
  return !keyboardOpen && previousVisualViewport.width === currentVisualViewport.width && t > KEYBOARD_THRESHOLD;
}, keyboardDidResize = (t) => keyboardOpen && !keyboardDidClose(t), keyboardDidClose = (t) => keyboardOpen && currentVisualViewport.height === t.innerHeight, fireKeyboardOpenEvent = (t, e) => {
  const r = e ? e.keyboardHeight : t.innerHeight - currentVisualViewport.height, o = new CustomEvent(KEYBOARD_DID_OPEN, {
    detail: { keyboardHeight: r }
  });
  t.dispatchEvent(o);
}, fireKeyboardCloseEvent = (t) => {
  const e = new CustomEvent(KEYBOARD_DID_CLOSE);
  t.dispatchEvent(e);
}, trackViewportChanges = (t) => {
  previousVisualViewport = Object.assign({}, currentVisualViewport), currentVisualViewport = copyVisualViewport(t.visualViewport);
}, copyVisualViewport = (t) => ({
  width: Math.round(t.width),
  height: Math.round(t.height),
  offsetTop: t.offsetTop,
  offsetLeft: t.offsetLeft,
  pageTop: t.pageTop,
  pageLeft: t.pageLeft,
  scale: t.scale
}), keyboard2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KEYBOARD_DID_CLOSE,
  KEYBOARD_DID_OPEN,
  copyVisualViewport,
  keyboardDidClose,
  keyboardDidOpen,
  keyboardDidResize,
  resetKeyboardAssist,
  setKeyboardClose,
  setKeyboardOpen,
  startKeyboardAssist,
  trackViewportChanges
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var Style;
(function(t) {
  t.Dark = "DARK", t.Light = "LIGHT", t.Default = "DEFAULT";
})(Style || (Style = {}));
const StatusBar = {
  getEngine() {
    const t = getCapacitor();
    if (t != null && t.isPluginAvailable("StatusBar"))
      return t.Plugins.StatusBar;
  },
  // TODO FW-4696 Remove supportDefaultStatusBarStyle in Ionic v8
  supportsDefaultStatusBarStyle() {
    const t = getCapacitor();
    return !!(t != null && t.PluginHeaders);
  },
  setStyle(t) {
    const e = this.getEngine();
    e && e.setStyle(t);
  },
  getStyle: async function() {
    const t = this.getEngine();
    if (!t)
      return Style.Default;
    const { style: e } = await t.getInfo();
    return e;
  }
}, getBackdropValueForSheet = (t, e) => {
  if (e === 1)
    return 0;
  const r = 1 / (1 - e), o = -(e * r);
  return t * r + o;
}, setCardStatusBarDark = () => {
  !win || win.innerWidth >= 768 || !StatusBar.supportsDefaultStatusBarStyle() || StatusBar.setStyle({ style: Style.Dark });
}, setCardStatusBarDefault = (t = Style.Default) => {
  !win || win.innerWidth >= 768 || !StatusBar.supportsDefaultStatusBarStyle() || StatusBar.setStyle({ style: t });
}, handleCanDismiss = async (t, e) => {
  typeof t.canDismiss != "function" || !await t.canDismiss(void 0, GESTURE) || (e.isRunning() ? e.onFinish(() => {
    t.dismiss(void 0, "handler");
  }, { oneTimeCallback: !0 }) : t.dismiss(void 0, "handler"));
}, calculateSpringStep = (t) => 255275e-8 * 2.71828 ** (-14.9619 * t) - 1.00255 * 2.71828 ** (-0.0380968 * t) + 1, SwipeToCloseDefaults = {
  MIN_PRESENTING_SCALE: 0.93
}, createSwipeToCloseGesture = (t, e, r, o) => {
  const c = t.offsetHeight;
  let u = !1, d = !1, p = null, g = null;
  const b = 0.2;
  let x = !0, w = 0;
  const y = () => p && isIonContent(p) ? p.scrollY : !0, $ = createGesture({
    el: t,
    gestureName: "modalSwipeToClose",
    gesturePriority: OVERLAY_GESTURE_PRIORITY,
    direction: "y",
    threshold: 10,
    canStart: (D) => {
      const L = D.event.target;
      return L === null || !L.closest ? !0 : (p = findClosestIonContent(L), p ? (isIonContent(p) ? g = getElementRoot(p).querySelector(".inner-scroll") : g = p, !!!p.querySelector("ion-refresher") && g.scrollTop === 0) : L.closest("ion-footer") === null);
    },
    onStart: (D) => {
      const { deltaY: L } = D;
      x = y(), d = t.canDismiss !== void 0 && t.canDismiss !== !0, L > 0 && p && disableContentScrollY(p), e.progressStart(!0, u ? 1 : 0);
    },
    onMove: (D) => {
      const { deltaY: L } = D;
      L > 0 && p && disableContentScrollY(p);
      const R = D.deltaY / c, O = R >= 0 && d, P = O ? b : 0.9999, z = O ? calculateSpringStep(R / P) : R, W = clamp(1e-4, z, P);
      e.progressStep(W), W >= 0.5 && w < 0.5 ? setCardStatusBarDefault(r) : W < 0.5 && w >= 0.5 && setCardStatusBarDark(), w = W;
    },
    onEnd: (D) => {
      const L = D.velocityY, R = D.deltaY / c, O = R >= 0 && d, P = O ? b : 0.9999, z = O ? calculateSpringStep(R / P) : R, W = clamp(1e-4, z, P), A = (D.deltaY + L * 1e3) / c, S = !O && A >= 0.5;
      let F = S ? -1e-3 : 1e-3;
      S ? (e.easing("cubic-bezier(0.32, 0.72, 0, 1)"), F += getTimeGivenProgression([0, 0], [0.32, 0.72], [0, 1], [1, 1], W)[0]) : (e.easing("cubic-bezier(1, 0, 0.68, 0.28)"), F += getTimeGivenProgression([0, 0], [1, 0], [0.68, 0.28], [1, 1], W)[0]);
      const U = computeDuration(S ? R * c : (1 - W) * c, L);
      u = S, $.enable(!1), p && resetContentScrollY(p, x), e.onFinish(() => {
        S || $.enable(!0);
      }).progressEnd(S ? 1 : 0, F, U), O && W > P / 4 ? handleCanDismiss(t, e) : S && o();
    }
  });
  return $;
}, computeDuration = (t, e) => clamp(400, t / Math.abs(e * 1.1), 500), createSheetEnterAnimation = (t) => {
  const { currentBreakpoint: e, backdropBreakpoint: r } = t, o = r === void 0 || r < e, a = o ? `calc(var(--backdrop-opacity) * ${e})` : "0", c = createAnimation("backdropAnimation").fromTo("opacity", 0, a);
  return o && c.beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), { wrapperAnimation: createAnimation("wrapperAnimation").keyframes([
    { offset: 0, opacity: 1, transform: "translateY(100%)" },
    { offset: 1, opacity: 1, transform: `translateY(${100 - e * 100}%)` }
  ]), backdropAnimation: c };
}, createSheetLeaveAnimation = (t) => {
  const { currentBreakpoint: e, backdropBreakpoint: r } = t, o = `calc(var(--backdrop-opacity) * ${getBackdropValueForSheet(e, r)})`, a = [
    { offset: 0, opacity: o },
    { offset: 1, opacity: 0 }
  ], c = [
    { offset: 0, opacity: o },
    { offset: r, opacity: 0 },
    { offset: 1, opacity: 0 }
  ], u = createAnimation("backdropAnimation").keyframes(r !== 0 ? c : a);
  return { wrapperAnimation: createAnimation("wrapperAnimation").keyframes([
    { offset: 0, opacity: 1, transform: `translateY(${100 - e * 100}%)` },
    { offset: 1, opacity: 1, transform: "translateY(100%)" }
  ]), backdropAnimation: u };
}, createEnterAnimation$1 = () => {
  const t = createAnimation().fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), e = createAnimation().fromTo("transform", "translateY(100vh)", "translateY(0vh)");
  return { backdropAnimation: t, wrapperAnimation: e };
}, iosEnterAnimation = (t, e) => {
  const { presentingEl: r, currentBreakpoint: o } = e, a = getElementRoot(t), { wrapperAnimation: c, backdropAnimation: u } = o !== void 0 ? createSheetEnterAnimation(e) : createEnterAnimation$1();
  u.addElement(a.querySelector("ion-backdrop")), c.addElement(a.querySelectorAll(".modal-wrapper, .modal-shadow")).beforeStyles({ opacity: 1 });
  const d = createAnimation("entering-base").addElement(t).easing("cubic-bezier(0.32,0.72,0,1)").duration(500).addAnimation(c);
  if (r) {
    const p = window.innerWidth < 768, g = r.tagName === "ION-MODAL" && r.presentingElement !== void 0, b = getElementRoot(r), x = createAnimation().beforeStyles({
      transform: "translateY(0)",
      "transform-origin": "top center",
      overflow: "hidden"
    }), w = document.body;
    if (p) {
      const y = CSS.supports("width", "max(0px, 1px)") ? "max(30px, var(--ion-safe-area-top))" : "30px", I = g ? "-10px" : y, E = SwipeToCloseDefaults.MIN_PRESENTING_SCALE, T = `translateY(${I}) scale(${E})`;
      x.afterStyles({
        transform: T
      }).beforeAddWrite(() => w.style.setProperty("background-color", "black")).addElement(r).keyframes([
        { offset: 0, filter: "contrast(1)", transform: "translateY(0px) scale(1)", borderRadius: "0px" },
        { offset: 1, filter: "contrast(0.85)", transform: T, borderRadius: "10px 10px 0 0" }
      ]), d.addAnimation(x);
    } else if (d.addAnimation(u), !g)
      c.fromTo("opacity", "0", "1");
    else {
      const I = `translateY(-10px) scale(${g ? SwipeToCloseDefaults.MIN_PRESENTING_SCALE : 1})`;
      x.afterStyles({
        transform: I
      }).addElement(b.querySelector(".modal-wrapper")).keyframes([
        { offset: 0, filter: "contrast(1)", transform: "translateY(0) scale(1)" },
        { offset: 1, filter: "contrast(0.85)", transform: I }
      ]);
      const E = createAnimation().afterStyles({
        transform: I
      }).addElement(b.querySelector(".modal-shadow")).keyframes([
        { offset: 0, opacity: "1", transform: "translateY(0) scale(1)" },
        { offset: 1, opacity: "0", transform: I }
      ]);
      d.addAnimation([x, E]);
    }
  } else
    d.addAnimation(u);
  return d;
}, createLeaveAnimation$1 = () => {
  const t = createAnimation().fromTo("opacity", "var(--backdrop-opacity)", 0), e = createAnimation().fromTo("transform", "translateY(0vh)", "translateY(100vh)");
  return { backdropAnimation: t, wrapperAnimation: e };
}, iosLeaveAnimation = (t, e, r = 500) => {
  const { presentingEl: o, currentBreakpoint: a } = e, c = getElementRoot(t), { wrapperAnimation: u, backdropAnimation: d } = a !== void 0 ? createSheetLeaveAnimation(e) : createLeaveAnimation$1();
  d.addElement(c.querySelector("ion-backdrop")), u.addElement(c.querySelectorAll(".modal-wrapper, .modal-shadow")).beforeStyles({ opacity: 1 });
  const p = createAnimation("leaving-base").addElement(t).easing("cubic-bezier(0.32,0.72,0,1)").duration(r).addAnimation(u);
  if (o) {
    const g = window.innerWidth < 768, b = o.tagName === "ION-MODAL" && o.presentingElement !== void 0, x = getElementRoot(o), w = createAnimation().beforeClearStyles(["transform"]).afterClearStyles(["transform"]).onFinish((I) => {
      if (I !== 1)
        return;
      o.style.setProperty("overflow", ""), Array.from(y.querySelectorAll("ion-modal:not(.overlay-hidden)")).filter((T) => T.presentingElement !== void 0).length <= 1 && y.style.setProperty("background-color", "");
    }), y = document.body;
    if (g) {
      const I = CSS.supports("width", "max(0px, 1px)") ? "max(30px, var(--ion-safe-area-top))" : "30px", E = b ? "-10px" : I, T = SwipeToCloseDefaults.MIN_PRESENTING_SCALE, C = `translateY(${E}) scale(${T})`;
      w.addElement(o).keyframes([
        { offset: 0, filter: "contrast(0.85)", transform: C, borderRadius: "10px 10px 0 0" },
        { offset: 1, filter: "contrast(1)", transform: "translateY(0px) scale(1)", borderRadius: "0px" }
      ]), p.addAnimation(w);
    } else if (p.addAnimation(d), !b)
      u.fromTo("opacity", "1", "0");
    else {
      const E = `translateY(-10px) scale(${b ? SwipeToCloseDefaults.MIN_PRESENTING_SCALE : 1})`;
      w.addElement(x.querySelector(".modal-wrapper")).afterStyles({
        transform: "translate3d(0, 0, 0)"
      }).keyframes([
        { offset: 0, filter: "contrast(0.85)", transform: E },
        { offset: 1, filter: "contrast(1)", transform: "translateY(0) scale(1)" }
      ]);
      const T = createAnimation().addElement(x.querySelector(".modal-shadow")).afterStyles({
        transform: "translateY(0) scale(1)"
      }).keyframes([
        { offset: 0, opacity: "0", transform: E },
        { offset: 1, opacity: "1", transform: "translateY(0) scale(1)" }
      ]);
      p.addAnimation([w, T]);
    }
  } else
    p.addAnimation(d);
  return p;
}, createEnterAnimation = () => {
  const t = createAnimation().fromTo("opacity", 0.01, "var(--backdrop-opacity)").beforeStyles({
    "pointer-events": "none"
  }).afterClearStyles(["pointer-events"]), e = createAnimation().keyframes([
    { offset: 0, opacity: 0.01, transform: "translateY(40px)" },
    { offset: 1, opacity: 1, transform: "translateY(0px)" }
  ]);
  return { backdropAnimation: t, wrapperAnimation: e };
}, mdEnterAnimation = (t, e) => {
  const { currentBreakpoint: r } = e, o = getElementRoot(t), { wrapperAnimation: a, backdropAnimation: c } = r !== void 0 ? createSheetEnterAnimation(e) : createEnterAnimation();
  return c.addElement(o.querySelector("ion-backdrop")), a.addElement(o.querySelector(".modal-wrapper")), createAnimation().addElement(t).easing("cubic-bezier(0.36,0.66,0.04,1)").duration(280).addAnimation([c, a]);
}, createLeaveAnimation = () => {
  const t = createAnimation().fromTo("opacity", "var(--backdrop-opacity)", 0), e = createAnimation().keyframes([
    { offset: 0, opacity: 0.99, transform: "translateY(0px)" },
    { offset: 1, opacity: 0, transform: "translateY(40px)" }
  ]);
  return { backdropAnimation: t, wrapperAnimation: e };
}, mdLeaveAnimation = (t, e) => {
  const { currentBreakpoint: r } = e, o = getElementRoot(t), { wrapperAnimation: a, backdropAnimation: c } = r !== void 0 ? createSheetLeaveAnimation(e) : createLeaveAnimation();
  return c.addElement(o.querySelector("ion-backdrop")), a.addElement(o.querySelector(".modal-wrapper")), createAnimation().easing("cubic-bezier(0.47,0,0.745,0.715)").duration(200).addAnimation([c, a]);
}, createSheetGesture = (t, e, r, o, a, c, u = [], d, p, g) => {
  const b = [
    { offset: 0, opacity: "var(--backdrop-opacity)" },
    { offset: 1, opacity: 0.01 }
  ], x = [
    { offset: 0, opacity: "var(--backdrop-opacity)" },
    { offset: 1 - a, opacity: 0 },
    { offset: 1, opacity: 0 }
  ], w = {
    WRAPPER_KEYFRAMES: [
      { offset: 0, transform: "translateY(0%)" },
      { offset: 1, transform: "translateY(100%)" }
    ],
    BACKDROP_KEYFRAMES: a !== 0 ? x : b
  }, y = t.querySelector("ion-content"), I = r.clientHeight;
  let E = o, T = 0, C = !1;
  const $ = 0.95, D = c.childAnimations.find((V) => V.id === "wrapperAnimation"), L = c.childAnimations.find((V) => V.id === "backdropAnimation"), R = u[u.length - 1], O = u[0], P = () => {
    t.style.setProperty("pointer-events", "auto"), e.style.setProperty("pointer-events", "auto"), t.classList.remove("ion-disable-focus-trap");
  }, z = () => {
    t.style.setProperty("pointer-events", "none"), e.style.setProperty("pointer-events", "none"), t.classList.add("ion-disable-focus-trap");
  };
  D && L && (D.keyframes([...w.WRAPPER_KEYFRAMES]), L.keyframes([...w.BACKDROP_KEYFRAMES]), c.progressStart(!0, 1 - E), E > a ? P() : z()), y && E !== R && (y.scrollY = !1);
  const W = (V) => {
    const G = V.event.target.closest("ion-content");
    return E = d(), !(E === 1 && G);
  }, A = () => {
    C = t.canDismiss !== void 0 && t.canDismiss !== !0 && O === 0, y && (y.scrollY = !1), raf(() => {
      t.focus();
    }), c.progressStart(!0, 1 - E);
  }, S = (V) => {
    const G = 1 - E, Q = u.length > 1 ? 1 - u[1] : void 0, fe = G + V.deltaY / I, te = Q !== void 0 && fe >= Q && C, de = te ? $ : 0.9999, me = te && Q !== void 0 ? Q + calculateSpringStep((fe - Q) / (de - Q)) : fe;
    T = clamp(1e-4, me, de), c.progressStep(T);
  }, F = (V) => {
    const G = V.velocityY, Q = (V.deltaY + G * 350) / I, fe = E - Q, te = u.reduce((de, me) => Math.abs(me - fe) < Math.abs(de - fe) ? me : de);
    U({
      breakpoint: te,
      breakpointOffset: T,
      canDismiss: C,
      /**
       * The swipe is user-driven, so we should
       * always animate when the gesture ends.
       */
      animated: !0
    });
  }, U = (V) => {
    const { breakpoint: G, canDismiss: Q, breakpointOffset: fe, animated: te } = V, de = Q && G === 0, me = de ? E : G, Me = me !== 0;
    return E = 0, D && L && (D.keyframes([
      { offset: 0, transform: `translateY(${fe * 100}%)` },
      { offset: 1, transform: `translateY(${(1 - me) * 100}%)` }
    ]), L.keyframes([
      {
        offset: 0,
        opacity: `calc(var(--backdrop-opacity) * ${getBackdropValueForSheet(1 - fe, a)})`
      },
      {
        offset: 1,
        opacity: `calc(var(--backdrop-opacity) * ${getBackdropValueForSheet(me, a)})`
      }
    ]), c.progressStep(0)), M.enable(!1), de ? handleCanDismiss(t, c) : Me || p(), new Promise((ce) => {
      c.onFinish(() => {
        Me ? D && L ? raf(() => {
          D.keyframes([...w.WRAPPER_KEYFRAMES]), L.keyframes([...w.BACKDROP_KEYFRAMES]), c.progressStart(!0, 1 - me), E = me, g(E), y && E === u[u.length - 1] && (y.scrollY = !0), E > a ? P() : z(), M.enable(!0), ce();
        }) : (M.enable(!0), ce()) : ce();
      }, { oneTimeCallback: !0 }).progressEnd(1, 0, te ? 500 : 0);
    });
  }, M = createGesture({
    el: r,
    gestureName: "modalSheet",
    gesturePriority: 40,
    direction: "y",
    threshold: 10,
    canStart: W,
    onStart: A,
    onMove: S,
    onEnd: F
  });
  return {
    gesture: M,
    moveSheetToBreakpoint: U
  };
}, modalIosCss = ':host{--width:100%;--min-width:auto;--max-width:auto;--height:100%;--min-height:auto;--max-height:auto;--overflow:hidden;--border-radius:0;--border-width:0;--border-style:none;--border-color:transparent;--background:var(--ion-background-color, #fff);--box-shadow:none;--backdrop-opacity:0;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);contain:strict}.modal-wrapper,ion-backdrop{pointer-events:auto}:host(.overlay-hidden){display:none}.modal-wrapper,.modal-shadow{border-radius:var(--border-radius);width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:var(--overflow);z-index:10}.modal-shadow{position:absolute;background:transparent}@media only screen and (min-width: 768px) and (min-height: 600px){:host{--width:600px;--height:500px;--ion-safe-area-top:0px;--ion-safe-area-bottom:0px;--ion-safe-area-right:0px;--ion-safe-area-left:0px}}@media only screen and (min-width: 768px) and (min-height: 768px){:host{--width:600px;--height:600px}}.modal-handle{left:0px;right:0px;top:5px;border-radius:8px;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;position:absolute;width:36px;height:5px;-webkit-transform:translateZ(0);transform:translateZ(0);border:0;background:var(--ion-color-step-350, #c0c0be);cursor:pointer;z-index:11}.modal-handle::before{-webkit-padding-start:4px;padding-inline-start:4px;-webkit-padding-end:4px;padding-inline-end:4px;padding-top:4px;padding-bottom:4px;position:absolute;width:36px;height:5px;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);content:""}:host(.modal-sheet){--height:calc(100% - (var(--ion-safe-area-top) + 10px))}:host(.modal-sheet) .modal-wrapper,:host(.modal-sheet) .modal-shadow{position:absolute;bottom:0}:host{--backdrop-opacity:var(--ion-backdrop-opacity, 0.4)}:host(.modal-card),:host(.modal-sheet){--border-radius:10px}@media only screen and (min-width: 768px) and (min-height: 600px){:host{--border-radius:10px}}.modal-wrapper{-webkit-transform:translate3d(0,  100%,  0);transform:translate3d(0,  100%,  0)}@media screen and (max-width: 767px){@supports (width: max(0px, 1px)){:host(.modal-card){--height:calc(100% - max(30px, var(--ion-safe-area-top)) - 10px)}}@supports not (width: max(0px, 1px)){:host(.modal-card){--height:calc(100% - 40px)}}:host(.modal-card) .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.modal-card) .modal-wrapper,:host-context([dir=rtl]).modal-card .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}@supports selector(:dir(rtl)){:host(.modal-card:dir(rtl)) .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}}:host(.modal-card){--backdrop-opacity:0;--width:100%;-ms-flex-align:end;align-items:flex-end}:host(.modal-card) .modal-shadow{display:none}:host(.modal-card) ion-backdrop{pointer-events:none}}@media screen and (min-width: 768px){:host(.modal-card){--width:calc(100% - 120px);--height:calc(100% - (120px + var(--ion-safe-area-top) + var(--ion-safe-area-bottom)));--max-width:720px;--max-height:1000px;--backdrop-opacity:0;--box-shadow:0px 0px 30px 10px rgba(0, 0, 0, 0.1);-webkit-transition:all 0.5s ease-in-out;transition:all 0.5s ease-in-out}:host(.modal-card) .modal-wrapper{-webkit-box-shadow:none;box-shadow:none}:host(.modal-card) .modal-shadow{-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow)}}:host(.modal-sheet) .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl]):host(.modal-sheet) .modal-wrapper,:host-context([dir=rtl]).modal-sheet .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}@supports selector(:dir(rtl)){:host(.modal-sheet:dir(rtl)) .modal-wrapper{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);border-bottom-right-radius:0;border-bottom-left-radius:0}}', modalMdCss = ':host{--width:100%;--min-width:auto;--max-width:auto;--height:100%;--min-height:auto;--max-height:auto;--overflow:hidden;--border-radius:0;--border-width:0;--border-style:none;--border-color:transparent;--background:var(--ion-background-color, #fff);--box-shadow:none;--backdrop-opacity:0;left:0;right:0;top:0;bottom:0;display:-ms-flexbox;display:flex;position:absolute;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;outline:none;color:var(--ion-text-color, #000);contain:strict}.modal-wrapper,ion-backdrop{pointer-events:auto}:host(.overlay-hidden){display:none}.modal-wrapper,.modal-shadow{border-radius:var(--border-radius);width:var(--width);min-width:var(--min-width);max-width:var(--max-width);height:var(--height);min-height:var(--min-height);max-height:var(--max-height);border-width:var(--border-width);border-style:var(--border-style);border-color:var(--border-color);background:var(--background);-webkit-box-shadow:var(--box-shadow);box-shadow:var(--box-shadow);overflow:var(--overflow);z-index:10}.modal-shadow{position:absolute;background:transparent}@media only screen and (min-width: 768px) and (min-height: 600px){:host{--width:600px;--height:500px;--ion-safe-area-top:0px;--ion-safe-area-bottom:0px;--ion-safe-area-right:0px;--ion-safe-area-left:0px}}@media only screen and (min-width: 768px) and (min-height: 768px){:host{--width:600px;--height:600px}}.modal-handle{left:0px;right:0px;top:5px;border-radius:8px;-webkit-margin-start:auto;margin-inline-start:auto;-webkit-margin-end:auto;margin-inline-end:auto;position:absolute;width:36px;height:5px;-webkit-transform:translateZ(0);transform:translateZ(0);border:0;background:var(--ion-color-step-350, #c0c0be);cursor:pointer;z-index:11}.modal-handle::before{-webkit-padding-start:4px;padding-inline-start:4px;-webkit-padding-end:4px;padding-inline-end:4px;padding-top:4px;padding-bottom:4px;position:absolute;width:36px;height:5px;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);content:""}:host(.modal-sheet){--height:calc(100% - (var(--ion-safe-area-top) + 10px))}:host(.modal-sheet) .modal-wrapper,:host(.modal-sheet) .modal-shadow{position:absolute;bottom:0}:host{--backdrop-opacity:var(--ion-backdrop-opacity, 0.32)}@media only screen and (min-width: 768px) and (min-height: 600px){:host{--border-radius:2px;--box-shadow:0 28px 48px rgba(0, 0, 0, 0.4)}}.modal-wrapper{-webkit-transform:translate3d(0,  40px,  0);transform:translate3d(0,  40px,  0);opacity:0.01}', Modal = /* @__PURE__ */ proxyCustomElement(class extends H {
  constructor() {
    super(), this.__registerHost(), this.__attachShadow(), this.didPresent = createEvent(this, "ionModalDidPresent", 7), this.willPresent = createEvent(this, "ionModalWillPresent", 7), this.willDismiss = createEvent(this, "ionModalWillDismiss", 7), this.didDismiss = createEvent(this, "ionModalDidDismiss", 7), this.ionBreakpointDidChange = createEvent(this, "ionBreakpointDidChange", 7), this.didPresentShorthand = createEvent(this, "didPresent", 7), this.willPresentShorthand = createEvent(this, "willPresent", 7), this.willDismissShorthand = createEvent(this, "willDismiss", 7), this.didDismissShorthand = createEvent(this, "didDismiss", 7), this.ionMount = createEvent(this, "ionMount", 7), this.lockController = createLockController(), this.triggerController = createTriggerController(), this.coreDelegate = CoreDelegate(), this.isSheetModal = !1, this.inheritedAttributes = {}, this.inline = !1, this.gestureAnimationDismissing = !1, this.onHandleClick = () => {
      const { sheetTransition: e, handleBehavior: r } = this;
      r !== "cycle" || e !== void 0 || this.moveToNextBreakpoint();
    }, this.onBackdropTap = () => {
      const { sheetTransition: e } = this;
      e === void 0 && this.dismiss(void 0, BACKDROP);
    }, this.onLifecycle = (e) => {
      const r = this.usersElement, o = LIFECYCLE_MAP[e.type];
      if (r && o) {
        const a = new CustomEvent(o, {
          bubbles: !1,
          cancelable: !1,
          detail: e.detail
        });
        r.dispatchEvent(a);
      }
    }, this.presented = !1, this.hasController = !1, this.overlayIndex = void 0, this.delegate = void 0, this.keyboardClose = !0, this.enterAnimation = void 0, this.leaveAnimation = void 0, this.breakpoints = void 0, this.initialBreakpoint = void 0, this.backdropBreakpoint = 0, this.handle = void 0, this.handleBehavior = "none", this.component = void 0, this.componentProps = void 0, this.cssClass = void 0, this.backdropDismiss = !0, this.showBackdrop = !0, this.animated = !0, this.presentingElement = void 0, this.htmlAttributes = void 0, this.isOpen = !1, this.trigger = void 0, this.keepContentsMounted = !1, this.canDismiss = !0;
  }
  onIsOpenChange(e, r) {
    e === !0 && r === !1 ? this.present() : e === !1 && r === !0 && this.dismiss();
  }
  triggerChanged() {
    const { trigger: e, el: r, triggerController: o } = this;
    e && o.addClickListener(r, e);
  }
  breakpointsChanged(e) {
    e !== void 0 && (this.sortedBreakpoints = e.sort((r, o) => r - o));
  }
  connectedCallback() {
    const { el: e } = this;
    prepareOverlay(e), this.triggerChanged();
  }
  disconnectedCallback() {
    this.triggerController.removeClickListener();
  }
  componentWillLoad() {
    const { breakpoints: e, initialBreakpoint: r, el: o } = this, a = this.isSheetModal = e !== void 0 && r !== void 0;
    this.inheritedAttributes = inheritAttributes$2(o, ["aria-label", "role"]), a && (this.currentBreakpoint = this.initialBreakpoint), e !== void 0 && r !== void 0 && !e.includes(r) && printIonWarning("Your breakpoints array must include the initialBreakpoint value."), setOverlayId(o);
  }
  componentDidLoad() {
    this.isOpen === !0 && raf(() => this.present()), this.breakpointsChanged(this.breakpoints), this.triggerChanged();
  }
  /**
   * Determines whether or not an overlay
   * is being used inline or via a controller/JS
   * and returns the correct delegate.
   * By default, subsequent calls to getDelegate
   * will use a cached version of the delegate.
   * This is useful for calling dismiss after
   * present so that the correct delegate is given.
   */
  getDelegate(e = !1) {
    if (this.workingDelegate && !e)
      return {
        delegate: this.workingDelegate,
        inline: this.inline
      };
    const r = this.el.parentNode, o = this.inline = r !== null && !this.hasController, a = this.workingDelegate = o ? this.delegate || this.coreDelegate : this.delegate;
    return { inline: o, delegate: a };
  }
  /**
   * Determines whether or not the
   * modal is allowed to dismiss based
   * on the state of the canDismiss prop.
   */
  async checkCanDismiss(e, r) {
    const { canDismiss: o } = this;
    return typeof o == "function" ? o(e, r) : o;
  }
  /**
   * Present the modal overlay after it has been created.
   */
  async present() {
    const e = await this.lockController.lock();
    if (this.presented) {
      e();
      return;
    }
    const { presentingElement: r, el: o } = this;
    this.currentBreakpoint = this.initialBreakpoint;
    const { inline: a, delegate: c } = this.getDelegate(!0);
    this.ionMount.emit(), this.usersElement = await attachComponent(c, o, this.component, ["ion-page"], this.componentProps, a), hasLazyBuild(o) ? await deepReady(this.usersElement) : this.keepContentsMounted || await waitForMount(), writeTask(() => this.el.classList.add("show-modal"));
    const u = r !== void 0;
    u && getIonMode$2(this) === "ios" && (this.statusBarStyle = await StatusBar.getStyle(), setCardStatusBarDark()), await present(this, "modalEnter", iosEnterAnimation, mdEnterAnimation, {
      presentingEl: r,
      currentBreakpoint: this.initialBreakpoint,
      backdropBreakpoint: this.backdropBreakpoint
    }), typeof window < "u" && (this.keyboardOpenCallback = () => {
      this.gesture && (this.gesture.enable(!1), raf(() => {
        this.gesture && this.gesture.enable(!0);
      }));
    }, window.addEventListener(KEYBOARD_DID_OPEN, this.keyboardOpenCallback)), this.isSheetModal ? this.initSheetGesture() : u && this.initSwipeToClose(), e();
  }
  initSwipeToClose() {
    var e;
    if (getIonMode$2(this) !== "ios")
      return;
    const { el: r } = this, o = this.leaveAnimation || config$1.get("modalLeave", iosLeaveAnimation), a = this.animation = o(r, { presentingEl: this.presentingElement });
    if (!findIonContent(r)) {
      printIonContentErrorMsg(r);
      return;
    }
    const u = (e = this.statusBarStyle) !== null && e !== void 0 ? e : Style.Default;
    this.gesture = createSwipeToCloseGesture(r, a, u, () => {
      this.gestureAnimationDismissing = !0, setCardStatusBarDefault(this.statusBarStyle), this.animation.onFinish(async () => {
        await this.dismiss(void 0, GESTURE), this.gestureAnimationDismissing = !1;
      });
    }), this.gesture.enable(!0);
  }
  initSheetGesture() {
    const { wrapperEl: e, initialBreakpoint: r, backdropBreakpoint: o } = this;
    if (!e || r === void 0)
      return;
    const a = this.enterAnimation || config$1.get("modalEnter", iosEnterAnimation), c = this.animation = a(this.el, {
      presentingEl: this.presentingElement,
      currentBreakpoint: r,
      backdropBreakpoint: o
    });
    c.progressStart(!0, 1);
    const { gesture: u, moveSheetToBreakpoint: d } = createSheetGesture(this.el, this.backdropEl, e, r, o, c, this.sortedBreakpoints, () => {
      var p;
      return (p = this.currentBreakpoint) !== null && p !== void 0 ? p : 0;
    }, () => this.sheetOnDismiss(), (p) => {
      this.currentBreakpoint !== p && (this.currentBreakpoint = p, this.ionBreakpointDidChange.emit({ breakpoint: p }));
    });
    this.gesture = u, this.moveSheetToBreakpoint = d, this.gesture.enable(!0);
  }
  sheetOnDismiss() {
    this.gestureAnimationDismissing = !0, this.animation.onFinish(async () => {
      this.currentBreakpoint = 0, this.ionBreakpointDidChange.emit({ breakpoint: this.currentBreakpoint }), await this.dismiss(void 0, GESTURE), this.gestureAnimationDismissing = !1;
    });
  }
  /**
   * Dismiss the modal overlay after it has been presented.
   *
   * @param data Any data to emit in the dismiss events.
   * @param role The role of the element that is dismissing the modal. For example, 'cancel' or 'backdrop'.
   */
  async dismiss(e, r) {
    var o;
    if (this.gestureAnimationDismissing && r !== GESTURE)
      return !1;
    const a = await this.lockController.lock();
    if (r !== "handler" && !await this.checkCanDismiss(e, r))
      return a(), !1;
    const { presentingElement: c } = this;
    c !== void 0 && getIonMode$2(this) === "ios" && setCardStatusBarDefault(this.statusBarStyle), typeof window < "u" && this.keyboardOpenCallback && (window.removeEventListener(KEYBOARD_DID_OPEN, this.keyboardOpenCallback), this.keyboardOpenCallback = void 0);
    const d = activeAnimations.get(this) || [], p = await dismiss(this, e, r, "modalLeave", iosLeaveAnimation, mdLeaveAnimation, {
      presentingEl: c,
      currentBreakpoint: (o = this.currentBreakpoint) !== null && o !== void 0 ? o : this.initialBreakpoint,
      backdropBreakpoint: this.backdropBreakpoint
    });
    if (p) {
      const { delegate: g } = this.getDelegate();
      await detachComponent(g, this.usersElement), writeTask(() => this.el.classList.remove("show-modal")), this.animation && this.animation.destroy(), this.gesture && this.gesture.destroy(), d.forEach((b) => b.destroy());
    }
    return this.currentBreakpoint = void 0, this.animation = void 0, a(), p;
  }
  /**
   * Returns a promise that resolves when the modal did dismiss.
   */
  onDidDismiss() {
    return eventMethod(this.el, "ionModalDidDismiss");
  }
  /**
   * Returns a promise that resolves when the modal will dismiss.
   */
  onWillDismiss() {
    return eventMethod(this.el, "ionModalWillDismiss");
  }
  /**
   * Move a sheet style modal to a specific breakpoint. The breakpoint value must
   * be a value defined in your `breakpoints` array.
   */
  async setCurrentBreakpoint(e) {
    if (!this.isSheetModal) {
      printIonWarning("setCurrentBreakpoint is only supported on sheet modals.");
      return;
    }
    if (!this.breakpoints.includes(e)) {
      printIonWarning(`Attempted to set invalid breakpoint value ${e}. Please double check that the breakpoint value is part of your defined breakpoints.`);
      return;
    }
    const { currentBreakpoint: r, moveSheetToBreakpoint: o, canDismiss: a, breakpoints: c, animated: u } = this;
    r !== e && o && (this.sheetTransition = o({
      breakpoint: e,
      breakpointOffset: 1 - r,
      canDismiss: a !== void 0 && a !== !0 && c[0] === 0,
      animated: u
    }), await this.sheetTransition, this.sheetTransition = void 0);
  }
  /**
   * Returns the current breakpoint of a sheet style modal
   */
  async getCurrentBreakpoint() {
    return this.currentBreakpoint;
  }
  async moveToNextBreakpoint() {
    const { breakpoints: e, currentBreakpoint: r } = this;
    if (!e || r == null)
      return !1;
    const o = e.filter((d) => d !== 0), c = (o.indexOf(r) + 1) % o.length, u = o[c];
    return await this.setCurrentBreakpoint(u), !0;
  }
  render() {
    const { handle: e, isSheetModal: r, presentingElement: o, htmlAttributes: a, handleBehavior: c, inheritedAttributes: u } = this, d = e !== !1 && r, p = getIonMode$2(this), g = o !== void 0 && p === "ios", b = c === "cycle";
    return h(Host, Object.assign({ "no-router": !0, tabindex: "-1" }, a, { style: {
      zIndex: `${2e4 + this.overlayIndex}`
    }, class: Object.assign({ [p]: !0, "modal-default": !g && !r, "modal-card": g, "modal-sheet": r, "overlay-hidden": !0 }, getClassMap(this.cssClass)), onIonBackdropTap: this.onBackdropTap, onIonModalDidPresent: this.onLifecycle, onIonModalWillPresent: this.onLifecycle, onIonModalWillDismiss: this.onLifecycle, onIonModalDidDismiss: this.onLifecycle }), h("ion-backdrop", { ref: (x) => this.backdropEl = x, visible: this.showBackdrop, tappable: this.backdropDismiss, part: "backdrop" }), p === "ios" && h("div", { class: "modal-shadow" }), h("div", Object.assign({
      /*
        role and aria-modal must be used on the
        same element. They must also be set inside the
        shadow DOM otherwise ion-button will not be highlighted
        when using VoiceOver: https://bugs.webkit.org/show_bug.cgi?id=247134
      */
      role: "dialog"
    }, u, { "aria-modal": "true", class: "modal-wrapper ion-overlay-wrapper", part: "content", ref: (x) => this.wrapperEl = x }), d && h("button", {
      class: "modal-handle",
      // Prevents the handle from receiving keyboard focus when it does not cycle
      tabIndex: b ? 0 : -1,
      "aria-label": "Activate to adjust the size of the dialog overlaying the screen",
      onClick: b ? this.onHandleClick : void 0,
      part: "handle"
    }), h("slot", null)));
  }
  get el() {
    return this;
  }
  static get watchers() {
    return {
      isOpen: ["onIsOpenChange"],
      trigger: ["triggerChanged"]
    };
  }
  static get style() {
    return {
      ios: modalIosCss,
      md: modalMdCss
    };
  }
}, [33, "ion-modal", {
  hasController: [4, "has-controller"],
  overlayIndex: [2, "overlay-index"],
  delegate: [16],
  keyboardClose: [4, "keyboard-close"],
  enterAnimation: [16],
  leaveAnimation: [16],
  breakpoints: [16],
  initialBreakpoint: [2, "initial-breakpoint"],
  backdropBreakpoint: [2, "backdrop-breakpoint"],
  handle: [4],
  handleBehavior: [1, "handle-behavior"],
  component: [1],
  componentProps: [16],
  cssClass: [1, "css-class"],
  backdropDismiss: [4, "backdrop-dismiss"],
  showBackdrop: [4, "show-backdrop"],
  animated: [4],
  presentingElement: [16],
  htmlAttributes: [16],
  isOpen: [4, "is-open"],
  trigger: [1],
  keepContentsMounted: [4, "keep-contents-mounted"],
  canDismiss: [4, "can-dismiss"],
  presented: [32],
  present: [64],
  dismiss: [64],
  onDidDismiss: [64],
  onWillDismiss: [64],
  setCurrentBreakpoint: [64],
  getCurrentBreakpoint: [64]
}, void 0, {
  isOpen: ["onIsOpenChange"],
  trigger: ["triggerChanged"]
}]), LIFECYCLE_MAP = {
  ionModalDidPresent: "ionViewDidEnter",
  ionModalWillPresent: "ionViewWillEnter",
  ionModalWillDismiss: "ionViewWillLeave",
  ionModalDidDismiss: "ionViewDidLeave"
};
function defineCustomElement$1() {
  if (typeof customElements > "u")
    return;
  ["ion-modal", "ion-backdrop"].forEach((e) => {
    switch (e) {
      case "ion-modal":
        customElements.get(e) || customElements.define(e, Modal);
        break;
      case "ion-backdrop":
        customElements.get(e) || defineCustomElement$R();
        break;
    }
  });
}
const defineCustomElement = defineCustomElement$1, UPDATE_VALUE_EVENT = "update:modelValue", MODEL_VALUE = "modelValue", ROUTER_LINK_VALUE = "routerLink", NAV_MANAGER = "navManager", ROUTER_PROP_PREFIX = "router", ARIA_PROP_PREFIX = "aria", EMPTY_PROP$1 = Symbol(), DEFAULT_EMPTY_PROP$1 = { default: EMPTY_PROP$1 }, getComponentClasses = (t) => (t == null ? void 0 : t.split(" ")) || [], getElementClasses = (t, e, r = []) => {
  var o;
  return [...Array.from(((o = t.value) === null || o === void 0 ? void 0 : o.classList) || []), ...r].filter((a, c, u) => !e.has(a) && u.indexOf(a) === c);
}, defineContainer = (t, e, r = [], o, a) => {
  e !== void 0 && e();
  const c = defineComponent((u, { attrs: d, slots: p, emit: g }) => {
    var b;
    let x = u[o];
    const w = ref(), y = new Set(getComponentClasses(d.class)), I = {
      created: (D) => {
        (Array.isArray(a) ? a : [a]).forEach((R) => {
          D.addEventListener(R.toLowerCase(), (O) => {
            x = (O == null ? void 0 : O.target)[o], g(UPDATE_VALUE_EVENT, x);
          });
        });
      }
    }, E = getCurrentInstance(), C = ((b = E == null ? void 0 : E.appContext) === null || b === void 0 ? void 0 : b.provides[NAV_MANAGER]) ? inject(NAV_MANAGER) : void 0, $ = (D) => {
      const { routerLink: L } = u;
      if (L !== EMPTY_PROP$1)
        if (C !== void 0) {
          let R = { event: D };
          for (const O in u) {
            const P = u[O];
            u.hasOwnProperty(O) && O.startsWith(ROUTER_PROP_PREFIX) && P !== EMPTY_PROP$1 && (R[O] = P);
          }
          C.navigate(R);
        } else
          console.warn("Tried to navigate, but no router was found. Make sure you have mounted Vue Router.");
    };
    return () => {
      x = u[o], getComponentClasses(d.class).forEach((P) => {
        y.add(P);
      });
      const D = u.onClick, L = (P) => {
        D !== void 0 && D(P), P.defaultPrevented || $(P);
      };
      let R = {
        ref: w,
        class: getElementClasses(w, y),
        onClick: L
      };
      for (const P in u) {
        const z = u[P];
        (u.hasOwnProperty(P) && z !== EMPTY_PROP$1 || P.startsWith(ARIA_PROP_PREFIX)) && (R[P] = z);
      }
      o && (u[MODEL_VALUE] !== EMPTY_PROP$1 ? R = Object.assign(Object.assign({}, R), { [o]: u[MODEL_VALUE] }) : x !== EMPTY_PROP$1 && (R = Object.assign(Object.assign({}, R), { [o]: x })));
      const O = h$1(t, R, p.default && p.default());
      return o === void 0 ? O : withDirectives(O, [[I]]);
    };
  });
  return typeof c != "function" && (c.name = t, c.props = {
    [ROUTER_LINK_VALUE]: DEFAULT_EMPTY_PROP$1
  }, r.forEach((u) => {
    c.props[u] = DEFAULT_EMPTY_PROP$1;
  }), o && (c.props[MODEL_VALUE] = DEFAULT_EMPTY_PROP$1, c.emits = [UPDATE_VALUE_EVENT])), c;
}, IonAvatar = /* @__PURE__ */ defineContainer("ion-avatar", defineCustomElement$S), IonButton = /* @__PURE__ */ defineContainer("ion-button", defineCustomElement$O, [
  "color",
  "buttonType",
  "disabled",
  "expand",
  "fill",
  "routerDirection",
  "routerAnimation",
  "download",
  "href",
  "rel",
  "shape",
  "size",
  "strong",
  "target",
  "type",
  "form",
  "ionFocus",
  "ionBlur"
]), IonButtons = /* @__PURE__ */ defineContainer("ion-buttons", defineCustomElement$M, [
  "collapse"
]), IonCard = /* @__PURE__ */ defineContainer("ion-card", defineCustomElement$L, [
  "color",
  "button",
  "type",
  "disabled",
  "download",
  "href",
  "rel",
  "routerDirection",
  "routerAnimation",
  "target"
]), IonCardContent = /* @__PURE__ */ defineContainer("ion-card-content", defineCustomElement$K), IonCardHeader = /* @__PURE__ */ defineContainer("ion-card-header", defineCustomElement$J, [
  "color",
  "translucent"
]), IonCardSubtitle = /* @__PURE__ */ defineContainer("ion-card-subtitle", defineCustomElement$I, [
  "color"
]), IonCardTitle = /* @__PURE__ */ defineContainer("ion-card-title", defineCustomElement$H, [
  "color"
]), IonChip = /* @__PURE__ */ defineContainer("ion-chip", defineCustomElement$F, [
  "color",
  "outline",
  "disabled"
]), IonContent = /* @__PURE__ */ defineContainer("ion-content", defineCustomElement$E, [
  "color",
  "fullscreen",
  "forceOverscroll",
  "scrollX",
  "scrollY",
  "scrollEvents",
  "ionScrollStart",
  "ionScroll",
  "ionScrollEnd"
]), IonFab = /* @__PURE__ */ defineContainer("ion-fab", defineCustomElement$z, [
  "horizontal",
  "vertical",
  "edge",
  "activated"
]), IonFabButton = /* @__PURE__ */ defineContainer("ion-fab-button", defineCustomElement$y, [
  "color",
  "activated",
  "disabled",
  "download",
  "href",
  "rel",
  "routerDirection",
  "routerAnimation",
  "target",
  "show",
  "translucent",
  "type",
  "size",
  "closeIcon",
  "ionFocus",
  "ionBlur"
]), IonFooter = /* @__PURE__ */ defineContainer("ion-footer", defineCustomElement$x, [
  "collapse",
  "translucent"
]), IonHeader = /* @__PURE__ */ defineContainer("ion-header", defineCustomElement$w, [
  "collapse",
  "translucent"
]), IonItem = /* @__PURE__ */ defineContainer("ion-item", defineCustomElement$u, [
  "color",
  "button",
  "detail",
  "detailIcon",
  "disabled",
  "download",
  "fill",
  "shape",
  "href",
  "rel",
  "lines",
  "counter",
  "routerAnimation",
  "routerDirection",
  "target",
  "type",
  "counterFormatter"
]), IonLabel = /* @__PURE__ */ defineContainer("ion-label", defineCustomElement$t, [
  "color",
  "position",
  "ionColor",
  "ionStyle"
]), IonList = /* @__PURE__ */ defineContainer("ion-list", defineCustomElement$r, [
  "lines",
  "inset"
]), IonListHeader = /* @__PURE__ */ defineContainer("ion-list-header", defineCustomElement$p, [
  "color",
  "lines"
]), IonNote = /* @__PURE__ */ defineContainer("ion-note", defineCustomElement$n, [
  "color"
]), IonRadio = /* @__PURE__ */ defineContainer("ion-radio", defineCustomElement$l, [
  "color",
  "name",
  "disabled",
  "value",
  "labelPlacement",
  "legacy",
  "justify",
  "alignment",
  "ionStyle",
  "ionFocus",
  "ionBlur"
], "value", "ion-change"), IonRadioGroup = /* @__PURE__ */ defineContainer("ion-radio-group", defineCustomElement$j, [
  "allowEmptySelection",
  "compareWith",
  "name",
  "value",
  "ionChange",
  "ionValueChange"
], "value", "ion-change"), IonSearchbar = /* @__PURE__ */ defineContainer("ion-searchbar", defineCustomElement$i, [
  "color",
  "animated",
  "autocomplete",
  "autocorrect",
  "cancelButtonIcon",
  "cancelButtonText",
  "clearIcon",
  "debounce",
  "disabled",
  "inputmode",
  "enterkeyhint",
  "name",
  "placeholder",
  "searchIcon",
  "showCancelButton",
  "showClearButton",
  "spellcheck",
  "type",
  "value",
  "ionInput",
  "ionChange",
  "ionCancel",
  "ionClear",
  "ionBlur",
  "ionFocus",
  "ionStyle"
], "value", "ion-input"), IonSegment = /* @__PURE__ */ defineContainer("ion-segment", defineCustomElement$h, [
  "color",
  "disabled",
  "scrollable",
  "swipeGesture",
  "value",
  "selectOnFocus",
  "ionChange",
  "ionSelect",
  "ionStyle"
], "value", "ion-change"), IonSegmentButton = /* @__PURE__ */ defineContainer("ion-segment-button", defineCustomElement$g, [
  "disabled",
  "layout",
  "type",
  "value"
], "value", "ion-change"), IonSelect = /* @__PURE__ */ defineContainer("ion-select", defineCustomElement$c, [
  "cancelText",
  "color",
  "compareWith",
  "disabled",
  "fill",
  "interface",
  "interfaceOptions",
  "justify",
  "label",
  "labelPlacement",
  "legacy",
  "multiple",
  "name",
  "okText",
  "placeholder",
  "selectedText",
  "toggleIcon",
  "expandedIcon",
  "shape",
  "value",
  "ionChange",
  "ionCancel",
  "ionDismiss",
  "ionFocus",
  "ionBlur",
  "ionStyle"
], "value", "ion-change"), IonSelectOption = /* @__PURE__ */ defineContainer("ion-select-option", defineCustomElement$b, [
  "disabled",
  "value"
]), IonSpinner = /* @__PURE__ */ defineContainer("ion-spinner", defineCustomElement$a, [
  "color",
  "duration",
  "name",
  "paused"
]), IonTitle = /* @__PURE__ */ defineContainer("ion-title", defineCustomElement$9, [
  "color",
  "size",
  "ionStyle"
]), IonToolbar = /* @__PURE__ */ defineContainer("ion-toolbar", defineCustomElement$8, [
  "color"
]);
var LifecycleHooks;
(function(t) {
  t.WillEnter = "onIonViewWillEnter", t.DidEnter = "onIonViewDidEnter", t.WillLeave = "onIonViewWillLeave", t.DidLeave = "onIonViewDidLeave";
})(LifecycleHooks || (LifecycleHooks = {}));
LIFECYCLE_WILL_ENTER + "", LifecycleHooks.WillEnter, LIFECYCLE_DID_ENTER + "", LifecycleHooks.DidEnter, LIFECYCLE_WILL_LEAVE + "", LifecycleHooks.WillLeave, LIFECYCLE_DID_LEAVE + "", LifecycleHooks.DidLeave;
const getConfig = () => {
  if (typeof window < "u") {
    const t = window.Ionic;
    if (t && t.config)
      return t.config;
  }
  return null;
}, injectHook = (t, e, r) => {
  if (r) {
    const o = r, a = o.proxy[t] || (o.proxy[t] = []);
    o.exposed && (o.exposed[t] = a);
    const c = (...u) => {
      if (!o.isUnmounted)
        return u ? e(...u) : e();
    };
    return a.push(c), c;
  } else
    console.warn("[@ionic/vue]: Ionic Lifecycle Hooks can only be used during execution of setup().");
}, createHook = (t) => (e, r = getCurrentInstance()) => injectHook(t, e, r);
createHook(LifecycleHooks.WillEnter);
createHook(LifecycleHooks.DidEnter);
createHook(LifecycleHooks.WillLeave);
createHook(LifecycleHooks.DidLeave);
const toKebabCase = (t) => t.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase(), getHelperFunctions = () => ({
  ael: (t, e, r, o) => t.addEventListener(toKebabCase(e), r, o),
  rel: (t, e, r, o) => t.removeEventListener(toKebabCase(e), r, o),
  ce: (t, e) => new CustomEvent(toKebabCase(t), e)
}), IonicVue = {
  async install(t, e = {}) {
    typeof document < "u" && document.documentElement.classList.add("ion-ce");
    const { ael: r, rel: o, ce: a } = getHelperFunctions();
    initialize(Object.assign(Object.assign({}, e), { _ael: r, _rel: o, _ce: a }));
  }
}, IonBackButton = /* @__PURE__ */ defineComponent((t, { attrs: e, slots: r }) => {
  defineCustomElement$7();
  const o = inject("navManager"), a = () => {
    if (o === void 0)
      return;
    const c = e["default-href"] || e.defaultHref, u = e["router-animation"] || e.routerAnimation;
    o.handleNavigateBack(c, u);
  };
  return () => h$1("ion-back-button", Object.assign({ onClick: a }, e), r.default && r.default());
});
IonBackButton.name = "IonBackButton";
const IonTabButton = /* @__PURE__ */ defineComponent({
  name: "IonTabButton",
  props: {
    _getTabState: {
      type: Function,
      default: () => ({})
    },
    disabled: Boolean,
    download: String,
    href: String,
    rel: String,
    layout: String,
    selected: Boolean,
    tab: String,
    target: String
  },
  setup(t, { slots: e }) {
    defineCustomElement$6();
    const r = inject("navManager"), o = (a) => {
      a.cancelable && a.preventDefault();
      const { tab: c, href: u, _getTabState: d } = t, p = d(), g = p.tabs[c] || {}, b = g.originalHref || u, x = g.currentHref || u;
      p.activeTab === c ? b !== x && r.resetTab(c) : r.changeTab(c, x);
    };
    return () => h$1("ion-tab-button", Object.assign({ onClick: o }, t), e.default && e.default());
  }
}), isTabButton = (t) => {
  var e;
  return ((e = t.type) === null || e === void 0 ? void 0 : e.name) === "IonTabButton";
}, getTabs = (t) => {
  let e = [];
  return t.forEach((r) => {
    if (isTabButton(r))
      e.push(r);
    else if (Array.isArray(r.children) && r.children.length > 1) {
      const o = getTabs(r.children);
      e = [...e, ...o];
    }
  }), e;
};
defineComponent({
  name: "IonTabBar",
  props: {
    /* eslint-disable @typescript-eslint/no-empty-function */
    _tabsWillChange: { type: Function, default: () => {
    } },
    _tabsDidChange: { type: Function, default: () => {
    } }
    /* eslint-enable @typescript-eslint/no-empty-function */
  },
  data() {
    return {
      tabState: {
        activeTab: void 0,
        tabs: {}
      },
      tabVnodes: []
    };
  },
  updated() {
    this.setupTabState(inject("navManager"));
  },
  methods: {
    setupTabState(t) {
      const e = this.$data.tabState, r = getCurrentInstance();
      (this.$data.tabVnodes = getTabs(r.subTree.children || [])).forEach((a) => {
        e.tabs[a.props.tab] = {
          originalHref: a.props.href,
          currentHref: a.props.href,
          ref: a
        }, a.component.props._getTabState = () => e;
      }), this.checkActiveTab(t);
    },
    checkActiveTab(t) {
      const e = t.getCurrentRouteInfo(), r = this.$data.tabVnodes, { tabs: o, activeTab: a } = this.$data.tabState, c = this.$data.tabState, d = Object.keys(o).find((x) => {
        const w = o[x].originalHref;
        return e.pathname.startsWith(w);
      });
      if (r.forEach((x) => {
        const w = o[x.props.tab];
        (!w || w.originalHref !== x.props.href) && (o[x.props.tab] = {
          originalHref: x.props.href,
          currentHref: x.props.href,
          ref: x
        });
      }), d && a) {
        const x = this.$data.tabState.tabs[a].currentHref;
        if (d !== a || x !== e.pathname) {
          const w = e.search ? `?${e.search}` : "";
          o[d] = Object.assign(Object.assign({}, o[d]), { currentHref: e.pathname + w });
        }
        e.routerAction === "pop" && d !== a && (o[a] = Object.assign(Object.assign({}, o[a]), { currentHref: o[a].originalHref }));
      }
      const p = r.find((x) => {
        var w;
        return isTabButton(x) && ((w = x.props) === null || w === void 0 ? void 0 : w.tab) === d;
      }), g = this.$refs.ionTabBar, b = d !== a;
      g && (p ? (b && this.$props._tabsWillChange(d), t.handleSetCurrentTab(d), g.selectedTab = c.activeTab = d, b && this.$props._tabsDidChange(d)) : g.selectedTab = c.activeTab = "");
    }
  },
  mounted() {
    const t = inject("navManager");
    this.setupTabState(t), t.registerHistoryChangeListener(() => this.checkActiveTab(t));
  },
  setup(t, { slots: e }) {
    return defineCustomElement$5(), () => h$1("ion-tab-bar", { ref: "ionTabBar" }, e.default && e.default());
  }
});
const userComponents = shallowRef([]), IonApp = /* @__PURE__ */ defineComponent((t, { attrs: e, slots: r }) => (defineCustomElement$4(), () => h$1("ion-app", Object.assign({}, e), [r.default && r.default(), ...userComponents.value])));
IonApp.name = "IonApp";
const addTeleportedUserComponent = (t) => {
  userComponents.value = [...userComponents.value, t];
}, removeTeleportedUserComponent = (t) => {
  userComponents.value = userComponents.value.filter((e) => e !== t);
}, VueDelegate = (t = addTeleportedUserComponent, e = removeTeleportedUserComponent) => {
  const r = /* @__PURE__ */ new WeakMap();
  return { attachViewToDom: (c, u, d = {}, p) => {
    const g = document.createElement("div");
    p && g.classList.add(...p), c.appendChild(g);
    const b = h$1(Teleport, { to: g }, h$1(u, Object.assign({}, d)));
    return r.set(g, b), t(b), Promise.resolve(g);
  }, removeViewFromDom: (c, u) => {
    const d = r.get(u);
    return d && e(d), Promise.resolve();
  } };
}, IonNav = /* @__PURE__ */ defineComponent((t) => {
  defineCustomElement$o();
  const e = shallowRef([]), a = VueDelegate((c) => e.value = [...e.value, c], (c) => e.value = e.value.filter((u) => u !== c));
  return () => h$1("ion-nav", Object.assign(Object.assign({}, t), { delegate: a }), e.value);
});
IonNav.name = "IonNav";
IonNav.props = {
  animated: {
    type: Boolean,
    default: !0
  },
  animation: {
    type: Function,
    default: void 0
  },
  root: {
    type: [Function, Object, String],
    default: void 0
  },
  rootParams: {
    type: Object,
    default: void 0
  },
  swipeGesture: {
    type: Boolean,
    default: void 0
  }
};
const IonIcon = /* @__PURE__ */ defineComponent({
  name: "IonIcon",
  props: {
    color: String,
    flipRtl: Boolean,
    icon: String,
    ios: String,
    lazy: String,
    md: String,
    mode: String,
    name: String,
    size: String,
    src: String
  },
  setup(t, { slots: e }) {
    return defineCustomElement$3(), () => {
      var r, o;
      const { icon: a, ios: c, md: u, mode: d } = t;
      let p;
      const g = getConfig(), b = d || (g == null ? void 0 : g.get("mode"));
      return c || u ? b === "ios" ? p = (r = c ?? u) !== null && r !== void 0 ? r : a : p = (o = u ?? c) !== null && o !== void 0 ? o : a : p = a, h$1("ion-icon", Object.assign(Object.assign({}, t), { icon: p }), e);
    };
  }
}), EMPTY_PROP = Symbol(), DEFAULT_EMPTY_PROP = { default: EMPTY_PROP }, defineOverlayContainer = (t, e, r = [], o, a) => {
  const d = a !== void 0 ? (() => defineComponent((p, { slots: g, emit: b }) => {
    const x = [
      { componentEv: `${t}-will-present`, frameworkEv: "willPresent" },
      { componentEv: `${t}-did-present`, frameworkEv: "didPresent" },
      { componentEv: `${t}-will-dismiss`, frameworkEv: "willDismiss" },
      { componentEv: `${t}-did-dismiss`, frameworkEv: "didDismiss" }
    ];
    e !== void 0 && e();
    const w = ref(), y = async () => {
      p.isOpen && await C(p);
    }, I = async ($, D) => {
      const L = $.props.isOpen, R = D.props.isOpen;
      L !== R && (L ? await C(p) : await T());
    }, E = async () => {
      await T();
    }, T = async () => {
      w.value && (await w.value, w.value = w.value.dismiss(), await w.value, w.value = void 0);
    }, C = async ($) => {
      var D;
      if (w.value && await w.value, !((D = w.value) === null || D === void 0) && D.present) {
        await w.value.present();
        return;
      }
      let L = {};
      for (const O in $) {
        const P = $[O];
        $.hasOwnProperty(O) && P !== EMPTY_PROP && (L[O] = P);
      }
      delete L.onWillPresent, delete L.onDidPresent, delete L.onWillDismiss, delete L.onDidDismiss;
      const R = g.default && g.default()[0];
      w.value = a.create(Object.assign(Object.assign({}, L), { component: R })), w.value = await w.value, x.forEach((O) => {
        w.value.addEventListener(O.componentEv, () => {
          b(O.frameworkEv);
        });
      }), await w.value.present();
    };
    return () => h$1("div", {
      style: { display: "none" },
      onVnodeMounted: y,
      onVnodeUpdated: I,
      onVnodeBeforeUnmount: E,
      isOpen: p.isOpen === !0
    });
  }))() : (() => defineComponent((p, { slots: g }) => {
    e !== void 0 && e();
    const b = ref(!1), x = ref();
    return onMounted(() => {
      x.value.addEventListener("ion-mount", () => b.value = !0), x.value.addEventListener("will-present", () => b.value = !0), x.value.addEventListener("did-dismiss", () => b.value = !1);
    }), () => {
      let w = {};
      for (const I in p) {
        const E = p[I];
        p.hasOwnProperty(I) && E !== EMPTY_PROP && (w[I] = E);
      }
      const y = () => o ? h$1("div", { className: "ion-delegate-host ion-page" }, g) : g;
      return h$1(
        t,
        Object.assign(Object.assign({}, w), { ref: x }),
        /**
         * When binding keepContentsMounted as an attribute
         * i.e. <ion-modal keep-contents-mounted></ion-modal>
         * the value of the prop will be the empty string which is
         * why we still call renderChildren() in that case.
         */
        b.value || w.keepContentsMounted || w.keepContentsMounted === "" ? y() : void 0
      );
    };
  }))();
  return d.name = t, d.props = {
    isOpen: DEFAULT_EMPTY_PROP
  }, r.forEach((p) => {
    d.props[p] = DEFAULT_EMPTY_PROP;
  }), a !== void 0 && (d.emits = ["willPresent", "didPresent", "willDismiss", "didDismiss"]), d;
}, IonModal = /* @__PURE__ */ defineOverlayContainer("ion-modal", defineCustomElement, ["animated", "backdropBreakpoint", "backdropDismiss", "breakpoints", "canDismiss", "enterAnimation", "handle", "handleBehavior", "htmlAttributes", "initialBreakpoint", "isOpen", "keepContentsMounted", "keyboardClose", "leaveAnimation", "mode", "presentingElement", "showBackdrop", "trigger"], !0), createController = (t, e, r = !1) => {
  const o = r ? VueDelegate() : void 0, a = e.create.bind(e);
  return e.create = (c) => (t(), a(Object.assign(Object.assign({}, c), { delegate: o }))), e;
}, toastController = /* @__PURE__ */ createController(defineCustomElement$2, toastController$1), _hoisted_1$7 = { class: "section-header" }, _hoisted_2$3 = { class: "overline" }, _hoisted_3$3 = { class: "ion-text-end" }, _hoisted_4$2 = { class: "overline" }, _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "DxpAppVersionInfo",
  setup(t) {
    const e = useUserStore(), r = appContext.config.globalProperties.$store, o = computed(() => r.getters["user/getPwaState"]), a = () => {
      r.dispatch("user/updatePwaState", { registration: o.value.registration, updateExists: !1 }), !(!o.value.registration || !o.value.registration.waiting) && o.value.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }, c = process.env.VUE_APP_VERSION_INFO ? JSON.parse(process.env.VUE_APP_VERSION_INFO) : {}, u = c.branch ? c.branch + "-" + c.revision : c.tag, d = (p) => DateTime.fromMillis(p).setZone(e.currentTimeZoneId).toLocaleString(DateTime.DATETIME_MED);
    return (p, g) => (openBlock(), createElementBlock("div", _hoisted_1$7, [
      createElementVNode("div", null, [
        createElementVNode("h1", null, toDisplayString$1(unref(translate)("App")), 1),
        createElementVNode("p", _hoisted_2$3, toDisplayString$1(unref(translate)("Version: ", { appVersion: unref(u) })), 1)
      ]),
      createElementVNode("div", _hoisted_3$3, [
        createElementVNode("p", _hoisted_4$2, toDisplayString$1(unref(translate)("Built: ", { builtDateTime: d(unref(c).builtTime) })), 1),
        o.value.updateExists ? (openBlock(), createBlock(unref(IonButton), {
          key: 0,
          onClick: g[0] || (g[0] = (b) => a()),
          fill: "outline",
          color: "dark",
          size: "small"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(unref(translate)("Update")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", !0)
      ])
    ]));
  }
}), arrowBackOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M244 400L100 256l144-144M120 256h292' class='ionicon-fill-none'/></svg>", caretDownOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z'/></svg>", caretForwardOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M190.06 414l163.12-139.78a24 24 0 000-36.44L190.06 98c-15.57-13.34-39.62-2.28-39.62 18.22v279.6c0 20.5 24.05 31.56 39.62 18.18z'/></svg>", close = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z'/></svg>", closeOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M368 368L144 144M368 144L144 368' class='ionicon-fill-none ionicon-stroke-width'/></svg>", documentOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M256 56v120a32 32 0 0032 32h120' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", helpOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M160 164s1.44-33 33.54-59.46C212.6 88.83 235.49 84.28 256 84c18.73-.23 35.47 2.94 45.48 7.82C318.59 100.2 352 120.6 352 164c0 45.67-29.18 66.37-62.35 89.18S248 298.36 248 324' stroke-linecap='round' stroke-miterlimit='10' stroke-width='40' class='ionicon-fill-none'/><circle cx='248' cy='399.99' r='32'/></svg>", openOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", returnDownBackOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M112 352l-64-64 64-64' class='ionicon-fill-none ionicon-stroke-width'/><path d='M64 288h294c58.76 0 106-49.33 106-108v-20' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", returnDownForwardOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path stroke-linecap='round' stroke-linejoin='round' d='M400 352l64-64-64-64' class='ionicon-fill-none ionicon-stroke-width'/><path d='M448 288H154c-58.76 0-106-49.33-106-108v-20' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", saveOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M380.93 57.37A32 32 0 00358.3 48H94.22A46.21 46.21 0 0048 94.22v323.56A46.21 46.21 0 0094.22 464h323.56A46.36 46.36 0 00464 417.78V153.7a32 32 0 00-9.37-22.63zM256 416a64 64 0 1164-64 63.92 63.92 0 01-64 64zm48-224H112a16 16 0 01-16-16v-64a16 16 0 0116-16h192a16 16 0 0116 16v64a16 16 0 01-16 16z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/></svg>", searchOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z' stroke-miterlimit='10' class='ionicon-fill-none ionicon-stroke-width'/><path stroke-linecap='round' stroke-miterlimit='10' d='M338.29 338.29L448 448' class='ionicon-fill-none ionicon-stroke-width'/></svg>", warningOutline = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'/></svg>";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getAugmentedNamespace(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function o() {
      return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(o) {
    var a = Object.getOwnPropertyDescriptor(t, o);
    Object.defineProperty(r, o, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[o];
      }
    });
  }), r;
}
var lib$2 = {}, types = {}, ContactMech = {}, Enumeration = {}, Geo = {}, Order = {}, Party = {}, Product$1 = {}, Status = {}, Uom = {}, Stock = {}, User = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "ContactMech", {
    enumerable: !0,
    get: function() {
      return e.ContactMech;
    }
  }), Object.defineProperty(t, "Enumeration", {
    enumerable: !0,
    get: function() {
      return r.Enumeration;
    }
  }), Object.defineProperty(t, "Geo", {
    enumerable: !0,
    get: function() {
      return o.Geo;
    }
  }), t.OPERATOR = void 0, Object.defineProperty(t, "Order", {
    enumerable: !0,
    get: function() {
      return a.Order;
    }
  }), Object.defineProperty(t, "OrderItem", {
    enumerable: !0,
    get: function() {
      return a.OrderItem;
    }
  }), Object.defineProperty(t, "OrderPart", {
    enumerable: !0,
    get: function() {
      return a.OrderPart;
    }
  }), Object.defineProperty(t, "Party", {
    enumerable: !0,
    get: function() {
      return c.Party;
    }
  }), Object.defineProperty(t, "Product", {
    enumerable: !0,
    get: function() {
      return u.Product;
    }
  }), Object.defineProperty(t, "Status", {
    enumerable: !0,
    get: function() {
      return d.Status;
    }
  }), Object.defineProperty(t, "Stock", {
    enumerable: !0,
    get: function() {
      return g.Stock;
    }
  }), Object.defineProperty(t, "Uom", {
    enumerable: !0,
    get: function() {
      return p.Uom;
    }
  }), Object.defineProperty(t, "User", {
    enumerable: !0,
    get: function() {
      return b.User;
    }
  }), t.events = void 0;
  var e = ContactMech, r = Enumeration, o = Geo, a = Order, c = Party, u = Product$1, d = Status, p = Uom, g = Stock, b = User, x = {
    UNAUTHORIZED: "unauthorized",
    QUEUE_TASK: "queueTask",
    DISMISS_LOADER: "dismissLoader"
  };
  t.events = x;
  var w;
  t.OPERATOR = w, function(y) {
    y.AND = "AND", y.BETWEEN = "between", y.CONTAINS = "contains", y.EQUALS = "equals", y.GREATER_THAN = "greaterThan", y.GREATER_THAN_EQUAL_TO = "greaterThanEqualTo", y.IN = "in", y.LESS_THAN = "lessThan", y.LESS_THAN_EQUAL_TO = "lessThanEqualTo", y.LIKE = "like", y.NOT = "not", y.NOT_EMPTY = "not-empty", y.NOT_EQUAL = "notEqual", y.NOT_LIKE = "notLike", y.OR = "OR";
  }(w || (t.OPERATOR = w = {}));
})(types);
var api = {}, axios$2 = { exports: {} }, bind$4 = function(e, r) {
  return function() {
    for (var a = new Array(arguments.length), c = 0; c < a.length; c++)
      a[c] = arguments[c];
    return e.apply(r, a);
  };
}, bind$3 = bind$4, toString = Object.prototype.toString;
function isArray$5(t) {
  return toString.call(t) === "[object Array]";
}
function isUndefined(t) {
  return typeof t > "u";
}
function isBuffer$1(t) {
  return t !== null && !isUndefined(t) && t.constructor !== null && !isUndefined(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function isArrayBuffer(t) {
  return toString.call(t) === "[object ArrayBuffer]";
}
function isFormData(t) {
  return typeof FormData < "u" && t instanceof FormData;
}
function isArrayBufferView(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && t.buffer instanceof ArrayBuffer, e;
}
function isString$4(t) {
  return typeof t == "string";
}
function isNumber$2(t) {
  return typeof t == "number";
}
function isObject$5(t) {
  return t !== null && typeof t == "object";
}
function isPlainObject$1(t) {
  if (toString.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function isDate$2(t) {
  return toString.call(t) === "[object Date]";
}
function isFile(t) {
  return toString.call(t) === "[object File]";
}
function isBlob(t) {
  return toString.call(t) === "[object Blob]";
}
function isFunction$2(t) {
  return toString.call(t) === "[object Function]";
}
function isStream(t) {
  return isObject$5(t) && isFunction$2(t.pipe);
}
function isURLSearchParams(t) {
  return typeof URLSearchParams < "u" && t instanceof URLSearchParams;
}
function trim(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), isArray$5(t))
      for (var r = 0, o = t.length; r < o; r++)
        e.call(null, t[r], r, t);
    else
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && e.call(null, t[a], a, t);
}
function merge$1() {
  var t = {};
  function e(a, c) {
    isPlainObject$1(t[c]) && isPlainObject$1(a) ? t[c] = merge$1(t[c], a) : isPlainObject$1(a) ? t[c] = merge$1({}, a) : isArray$5(a) ? t[c] = a.slice() : t[c] = a;
  }
  for (var r = 0, o = arguments.length; r < o; r++)
    forEach(arguments[r], e);
  return t;
}
function extend(t, e, r) {
  return forEach(e, function(a, c) {
    r && typeof a == "function" ? t[c] = bind$3(a, r) : t[c] = a;
  }), t;
}
function stripBOM(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
var utils$e = {
  isArray: isArray$5,
  isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData,
  isArrayBufferView,
  isString: isString$4,
  isNumber: isNumber$2,
  isObject: isObject$5,
  isPlainObject: isPlainObject$1,
  isUndefined,
  isDate: isDate$2,
  isFile,
  isBlob,
  isFunction: isFunction$2,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge: merge$1,
  extend,
  trim,
  stripBOM
}, utils$d = utils$e;
function encode$4(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function(e, r, o) {
  if (!r)
    return e;
  var a;
  if (o)
    a = o(r);
  else if (utils$d.isURLSearchParams(r))
    a = r.toString();
  else {
    var c = [];
    utils$d.forEach(r, function(p, g) {
      p === null || typeof p > "u" || (utils$d.isArray(p) ? g = g + "[]" : p = [p], utils$d.forEach(p, function(x) {
        utils$d.isDate(x) ? x = x.toISOString() : utils$d.isObject(x) && (x = JSON.stringify(x)), c.push(encode$4(g) + "=" + encode$4(x));
      }));
    }), a = c.join("&");
  }
  if (a) {
    var u = e.indexOf("#");
    u !== -1 && (e = e.slice(0, u)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}, utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function(e, r, o) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: o ? o.synchronous : !1,
    runWhen: o ? o.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
InterceptorManager$1.prototype.forEach = function(e) {
  utils$c.forEach(this.handlers, function(o) {
    o !== null && e(o);
  });
};
var InterceptorManager_1 = InterceptorManager$1, utils$b = utils$e, normalizeHeaderName$1 = function(e, r) {
  utils$b.forEach(e, function(a, c) {
    c !== r && c.toUpperCase() === r.toUpperCase() && (e[r] = a, delete e[c]);
  });
}, enhanceError$1 = function(e, r, o, a, c) {
  return e.config = r, o && (e.code = o), e.request = a, e.response = c, e.isAxiosError = !0, e.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, e;
}, createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var t = enhanceError$1;
  return createError = function(r, o, a, c, u) {
    var d = new Error(r);
    return t(d, o, a, c, u);
  }, createError;
}
var settle, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var t = requireCreateError();
  return settle = function(r, o, a) {
    var c = a.config.validateStatus;
    !a.status || !c || c(a.status) ? r(a) : o(t(
      "Request failed with status code " + a.status,
      a.config,
      null,
      a.request,
      a
    ));
  }, settle;
}
var cookies, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var t = utils$e;
  return cookies = t.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(o, a, c, u, d, p) {
          var g = [];
          g.push(o + "=" + encodeURIComponent(a)), t.isNumber(c) && g.push("expires=" + new Date(c).toGMTString()), t.isString(u) && g.push("path=" + u), t.isString(d) && g.push("domain=" + d), p === !0 && g.push("secure"), document.cookie = g.join("; ");
        },
        read: function(o) {
          var a = document.cookie.match(new RegExp("(^|;\\s*)(" + o + ")=([^;]*)"));
          return a ? decodeURIComponent(a[3]) : null;
        },
        remove: function(o) {
          this.write(o, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies;
}
var isAbsoluteURL, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), isAbsoluteURL;
}
var combineURLs, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs = function(e, r) {
    return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
  }), combineURLs;
}
var buildFullPath, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var t = requireIsAbsoluteURL(), e = requireCombineURLs();
  return buildFullPath = function(o, a) {
    return o && !t(a) ? e(o, a) : a;
  }, buildFullPath;
}
var parseHeaders, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var t = utils$e, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders = function(o) {
    var a = {}, c, u, d;
    return o && t.forEach(o.split(`
`), function(g) {
      if (d = g.indexOf(":"), c = t.trim(g.substr(0, d)).toLowerCase(), u = t.trim(g.substr(d + 1)), c) {
        if (a[c] && e.indexOf(c) >= 0)
          return;
        c === "set-cookie" ? a[c] = (a[c] ? a[c] : []).concat([u]) : a[c] = a[c] ? a[c] + ", " + u : u;
      }
    }), a;
  }, parseHeaders;
}
var isURLSameOrigin, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var t = utils$e;
  return isURLSameOrigin = t.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a"), a;
      function c(u) {
        var d = u;
        return r && (o.setAttribute("href", d), d = o.href), o.setAttribute("href", d), {
          href: o.href,
          protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
          host: o.host,
          search: o.search ? o.search.replace(/^\?/, "") : "",
          hash: o.hash ? o.hash.replace(/^#/, "") : "",
          hostname: o.hostname,
          port: o.port,
          pathname: o.pathname.charAt(0) === "/" ? o.pathname : "/" + o.pathname
        };
      }
      return a = c(window.location.href), function(d) {
        var p = t.isString(d) ? c(d) : d;
        return p.protocol === a.protocol && p.host === a.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var t = utils$e, e = requireSettle(), r = requireCookies(), o = buildURL$1, a = requireBuildFullPath(), c = requireParseHeaders(), u = requireIsURLSameOrigin(), d = requireCreateError();
  return xhr = function(g) {
    return new Promise(function(x, w) {
      var y = g.data, I = g.headers, E = g.responseType;
      t.isFormData(y) && delete I["Content-Type"];
      var T = new XMLHttpRequest();
      if (g.auth) {
        var C = g.auth.username || "", $ = g.auth.password ? unescape(encodeURIComponent(g.auth.password)) : "";
        I.Authorization = "Basic " + btoa(C + ":" + $);
      }
      var D = a(g.baseURL, g.url);
      T.open(g.method.toUpperCase(), o(D, g.params, g.paramsSerializer), !0), T.timeout = g.timeout;
      function L() {
        if (T) {
          var O = "getAllResponseHeaders" in T ? c(T.getAllResponseHeaders()) : null, P = !E || E === "text" || E === "json" ? T.responseText : T.response, z = {
            data: P,
            status: T.status,
            statusText: T.statusText,
            headers: O,
            config: g,
            request: T
          };
          e(x, w, z), T = null;
        }
      }
      if ("onloadend" in T ? T.onloadend = L : T.onreadystatechange = function() {
        !T || T.readyState !== 4 || T.status === 0 && !(T.responseURL && T.responseURL.indexOf("file:") === 0) || setTimeout(L);
      }, T.onabort = function() {
        T && (w(d("Request aborted", g, "ECONNABORTED", T)), T = null);
      }, T.onerror = function() {
        w(d("Network Error", g, null, T)), T = null;
      }, T.ontimeout = function() {
        var P = "timeout of " + g.timeout + "ms exceeded";
        g.timeoutErrorMessage && (P = g.timeoutErrorMessage), w(d(
          P,
          g,
          g.transitional && g.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          T
        )), T = null;
      }, t.isStandardBrowserEnv()) {
        var R = (g.withCredentials || u(D)) && g.xsrfCookieName ? r.read(g.xsrfCookieName) : void 0;
        R && (I[g.xsrfHeaderName] = R);
      }
      "setRequestHeader" in T && t.forEach(I, function(P, z) {
        typeof y > "u" && z.toLowerCase() === "content-type" ? delete I[z] : T.setRequestHeader(z, P);
      }), t.isUndefined(g.withCredentials) || (T.withCredentials = !!g.withCredentials), E && E !== "json" && (T.responseType = g.responseType), typeof g.onDownloadProgress == "function" && T.addEventListener("progress", g.onDownloadProgress), typeof g.onUploadProgress == "function" && T.upload && T.upload.addEventListener("progress", g.onUploadProgress), g.cancelToken && g.cancelToken.promise.then(function(P) {
        T && (T.abort(), w(P), T = null);
      }), y || (y = null), T.send(y);
    });
  }, xhr;
}
var utils$a = utils$e, normalizeHeaderName = normalizeHeaderName$1, enhanceError = enhanceError$1, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(t, e) {
  !utils$a.isUndefined(t) && utils$a.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function getDefaultAdapter() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = requireXhr()), t;
}
function stringifySafely(t, e, r) {
  if (utils$a.isString(t))
    try {
      return (e || JSON.parse)(t), utils$a.trim(t);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (r || JSON.stringify)(t);
}
var defaults$5 = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function(e, r) {
    return normalizeHeaderName(r, "Accept"), normalizeHeaderName(r, "Content-Type"), utils$a.isFormData(e) || utils$a.isArrayBuffer(e) || utils$a.isBuffer(e) || utils$a.isStream(e) || utils$a.isFile(e) || utils$a.isBlob(e) ? e : utils$a.isArrayBufferView(e) ? e.buffer : utils$a.isURLSearchParams(e) ? (setContentTypeIfUnset(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : utils$a.isObject(e) || r && r["Content-Type"] === "application/json" ? (setContentTypeIfUnset(r, "application/json"), stringifySafely(e)) : e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional, o = r && r.silentJSONParsing, a = r && r.forcedJSONParsing, c = !o && this.responseType === "json";
    if (c || a && utils$a.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (u) {
        if (c)
          throw u.name === "SyntaxError" ? enhanceError(u, this, "E_JSON_PARSE") : u;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  }
};
defaults$5.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
utils$a.forEach(["delete", "get", "head"], function(e) {
  defaults$5.headers[e] = {};
});
utils$a.forEach(["post", "put", "patch"], function(e) {
  defaults$5.headers[e] = utils$a.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$5, utils$9 = utils$e, defaults$4 = defaults_1, transformData$1 = function(e, r, o) {
  var a = this || defaults$4;
  return utils$9.forEach(o, function(u) {
    e = u.call(a, e, r);
  }), e;
}, isCancel$1, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$1 = function(e) {
    return !!(e && e.__CANCEL__);
  }), isCancel$1;
}
var utils$8 = utils$e, transformData = transformData$1, isCancel = requireIsCancel(), defaults$3 = defaults_1;
function throwIfCancellationRequested(t) {
  t.cancelToken && t.cancelToken.throwIfRequested();
}
var dispatchRequest$1 = function(e) {
  throwIfCancellationRequested(e), e.headers = e.headers || {}, e.data = transformData.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = utils$8.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), utils$8.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(a) {
      delete e.headers[a];
    }
  );
  var r = e.adapter || defaults$3.adapter;
  return r(e).then(function(a) {
    return throwIfCancellationRequested(e), a.data = transformData.call(
      e,
      a.data,
      a.headers,
      e.transformResponse
    ), a;
  }, function(a) {
    return isCancel(a) || (throwIfCancellationRequested(e), a && a.response && (a.response.data = transformData.call(
      e,
      a.response.data,
      a.response.headers,
      e.transformResponse
    ))), Promise.reject(a);
  });
}, utils$7 = utils$e, mergeConfig$2 = function(e, r) {
  r = r || {};
  var o = {}, a = ["url", "method", "data"], c = ["headers", "auth", "proxy", "params"], u = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], d = ["validateStatus"];
  function p(w, y) {
    return utils$7.isPlainObject(w) && utils$7.isPlainObject(y) ? utils$7.merge(w, y) : utils$7.isPlainObject(y) ? utils$7.merge({}, y) : utils$7.isArray(y) ? y.slice() : y;
  }
  function g(w) {
    utils$7.isUndefined(r[w]) ? utils$7.isUndefined(e[w]) || (o[w] = p(void 0, e[w])) : o[w] = p(e[w], r[w]);
  }
  utils$7.forEach(a, function(y) {
    utils$7.isUndefined(r[y]) || (o[y] = p(void 0, r[y]));
  }), utils$7.forEach(c, g), utils$7.forEach(u, function(y) {
    utils$7.isUndefined(r[y]) ? utils$7.isUndefined(e[y]) || (o[y] = p(void 0, e[y])) : o[y] = p(void 0, r[y]);
  }), utils$7.forEach(d, function(y) {
    y in r ? o[y] = p(e[y], r[y]) : y in e && (o[y] = p(void 0, e[y]));
  });
  var b = a.concat(c).concat(u).concat(d), x = Object.keys(e).concat(Object.keys(r)).filter(function(y) {
    return b.indexOf(y) === -1;
  });
  return utils$7.forEach(x, g), o;
};
const name$q = "axios", version$3 = "0.21.4", description = "Promise based HTTP client for the browser and node.js", main = "index.js", scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], author = "Matt Zabriskie", license = "MIT", bugs = {
  url: "https://github.com/axios/axios/issues"
}, homepage = "https://axios-http.com", devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, jsdelivr = "dist/axios.min.js", unpkg = "dist/axios.min.js", typings = "./index.d.ts", dependencies = {
  "follow-redirects": "^1.14.0"
}, bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], require$$0$2 = {
  name: name$q,
  version: version$3,
  description,
  main,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0$2, validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  validators$1[t] = function(o) {
    return typeof o === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var deprecatedWarnings = {}, currentVerArr = pkg.version.split(".");
function isOlderVersion(t, e) {
  for (var r = e ? e.split(".") : currentVerArr, o = t.split("."), a = 0; a < 3; a++) {
    if (r[a] > o[a])
      return !0;
    if (r[a] < o[a])
      return !1;
  }
  return !1;
}
validators$1.transitional = function(e, r, o) {
  var a = r && isOlderVersion(r);
  function c(u, d) {
    return "[Axios v" + pkg.version + "] Transitional option '" + u + "'" + d + (o ? ". " + o : "");
  }
  return function(u, d, p) {
    if (e === !1)
      throw new Error(c(d, " has been removed in " + r));
    return a && !deprecatedWarnings[d] && (deprecatedWarnings[d] = !0, console.warn(
      c(
        d,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(u, d, p) : !0;
  };
};
function assertOptions(t, e, r) {
  if (typeof t != "object")
    throw new TypeError("options must be an object");
  for (var o = Object.keys(t), a = o.length; a-- > 0; ) {
    var c = o[a], u = e[c];
    if (u) {
      var d = t[c], p = d === void 0 || u(d, c, t);
      if (p !== !0)
        throw new TypeError("option " + c + " must be " + p);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + c);
  }
}
var validator$1 = {
  isOlderVersion,
  assertOptions,
  validators: validators$1
}, utils$6 = utils$e, buildURL = buildURL$1, InterceptorManager = InterceptorManager_1, dispatchRequest = dispatchRequest$1, mergeConfig$1 = mergeConfig$2, validator = validator$1, validators = validator.validators;
function Axios$1(t) {
  this.defaults = t, this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function(e) {
  typeof e == "string" ? (e = arguments[1] || {}, e.url = arguments[0]) : e = e || {}, e = mergeConfig$1(this.defaults, e), e.method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
  var r = e.transitional;
  r !== void 0 && validator.assertOptions(r, {
    silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
    forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
    clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
  }, !1);
  var o = [], a = !0;
  this.interceptors.request.forEach(function(w) {
    typeof w.runWhen == "function" && w.runWhen(e) === !1 || (a = a && w.synchronous, o.unshift(w.fulfilled, w.rejected));
  });
  var c = [];
  this.interceptors.response.forEach(function(w) {
    c.push(w.fulfilled, w.rejected);
  });
  var u;
  if (!a) {
    var d = [dispatchRequest, void 0];
    for (Array.prototype.unshift.apply(d, o), d = d.concat(c), u = Promise.resolve(e); d.length; )
      u = u.then(d.shift(), d.shift());
    return u;
  }
  for (var p = e; o.length; ) {
    var g = o.shift(), b = o.shift();
    try {
      p = g(p);
    } catch (x) {
      b(x);
      break;
    }
  }
  try {
    u = dispatchRequest(p);
  } catch (x) {
    return Promise.reject(x);
  }
  for (; c.length; )
    u = u.then(c.shift(), c.shift());
  return u;
};
Axios$1.prototype.getUri = function(e) {
  return e = mergeConfig$1(this.defaults, e), buildURL(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
utils$6.forEach(["delete", "get", "head", "options"], function(e) {
  Axios$1.prototype[e] = function(r, o) {
    return this.request(mergeConfig$1(o || {}, {
      method: e,
      url: r,
      data: (o || {}).data
    }));
  };
});
utils$6.forEach(["post", "put", "patch"], function(e) {
  Axios$1.prototype[e] = function(r, o, a) {
    return this.request(mergeConfig$1(a || {}, {
      method: e,
      url: r,
      data: o
    }));
  };
});
var Axios_1 = Axios$1, Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function t(e) {
    this.message = e;
  }
  return t.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, t.prototype.__CANCEL__ = !0, Cancel_1 = t, Cancel_1;
}
var CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var t = requireCancel();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var o;
    this.promise = new Promise(function(u) {
      o = u;
    });
    var a = this;
    r(function(u) {
      a.reason || (a.reason = new t(u), o(a.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.source = function() {
    var o, a = new e(function(u) {
      o = u;
    });
    return {
      token: a,
      cancel: o
    };
  }, CancelToken_1 = e, CancelToken_1;
}
var spread, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread = function(e) {
    return function(o) {
      return e.apply(null, o);
    };
  }), spread;
}
var isAxiosError, hasRequiredIsAxiosError;
function requireIsAxiosError() {
  return hasRequiredIsAxiosError || (hasRequiredIsAxiosError = 1, isAxiosError = function(e) {
    return typeof e == "object" && e.isAxiosError === !0;
  }), isAxiosError;
}
var utils$5 = utils$e, bind$2 = bind$4, Axios = Axios_1, mergeConfig = mergeConfig$2, defaults$2 = defaults_1;
function createInstance(t) {
  var e = new Axios(t), r = bind$2(Axios.prototype.request, e);
  return utils$5.extend(r, Axios.prototype, e), utils$5.extend(r, e), r;
}
var axios$1 = createInstance(defaults$2);
axios$1.Axios = Axios;
axios$1.create = function(e) {
  return createInstance(mergeConfig(axios$1.defaults, e));
};
axios$1.Cancel = requireCancel();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();
axios$1.all = function(e) {
  return Promise.all(e);
};
axios$1.spread = requireSpread();
axios$1.isAxiosError = requireIsAxiosError();
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axiosExports = axios$2.exports, axios = axiosExports, ACCEPTED = 202, BAD_GATEWAY = 502, BAD_REQUEST = 400, CONFLICT = 409, CONTINUE = 100, CREATED = 201, EXPECTATION_FAILED = 417, FAILED_DEPENDENCY = 424, FORBIDDEN = 403, GATEWAY_TIMEOUT = 504, GONE = 410, HTTP_VERSION_NOT_SUPPORTED = 505, IM_A_TEAPOT = 418, INSUFFICIENT_SPACE_ON_RESOURCE = 419, INSUFFICIENT_STORAGE = 507, INTERNAL_SERVER_ERROR = 500, LENGTH_REQUIRED = 411, LOCKED = 423, METHOD_FAILURE = 420, METHOD_NOT_ALLOWED = 405, MOVED_PERMANENTLY = 301, MOVED_TEMPORARILY = 302, MULTI_STATUS = 207, MULTIPLE_CHOICES = 300, NETWORK_AUTHENTICATION_REQUIRED = 511, NO_CONTENT = 204, NON_AUTHORITATIVE_INFORMATION = 203, NOT_ACCEPTABLE = 406, NOT_FOUND = 404, NOT_IMPLEMENTED = 501, NOT_MODIFIED = 304, OK = 200, PARTIAL_CONTENT = 206, PAYMENT_REQUIRED = 402, PERMANENT_REDIRECT = 308, PRECONDITION_FAILED = 412, PRECONDITION_REQUIRED = 428, PROCESSING = 102, PROXY_AUTHENTICATION_REQUIRED = 407, REQUEST_HEADER_FIELDS_TOO_LARGE = 431, REQUEST_TIMEOUT = 408, REQUEST_TOO_LONG = 413, REQUEST_URI_TOO_LONG = 414, REQUESTED_RANGE_NOT_SATISFIABLE = 416, RESET_CONTENT = 205, SEE_OTHER = 303, SERVICE_UNAVAILABLE = 503, SWITCHING_PROTOCOLS = 101, TEMPORARY_REDIRECT = 307, TOO_MANY_REQUESTS = 429, UNAUTHORIZED = 401, UNPROCESSABLE_ENTITY = 422, UNSUPPORTED_MEDIA_TYPE = 415, USE_PROXY = 305;
const legacyCodes = {
  ACCEPTED,
  BAD_GATEWAY,
  BAD_REQUEST,
  CONFLICT,
  CONTINUE,
  CREATED,
  EXPECTATION_FAILED,
  FORBIDDEN,
  GATEWAY_TIMEOUT,
  GONE,
  HTTP_VERSION_NOT_SUPPORTED,
  IM_A_TEAPOT,
  INSUFFICIENT_SPACE_ON_RESOURCE,
  INSUFFICIENT_STORAGE,
  INTERNAL_SERVER_ERROR,
  LENGTH_REQUIRED,
  LOCKED,
  METHOD_FAILURE,
  METHOD_NOT_ALLOWED,
  MOVED_PERMANENTLY,
  MOVED_TEMPORARILY,
  MULTI_STATUS,
  MULTIPLE_CHOICES,
  NETWORK_AUTHENTICATION_REQUIRED,
  NO_CONTENT,
  NON_AUTHORITATIVE_INFORMATION,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  NOT_IMPLEMENTED,
  NOT_MODIFIED,
  OK,
  PARTIAL_CONTENT,
  PAYMENT_REQUIRED,
  PERMANENT_REDIRECT,
  PRECONDITION_FAILED,
  PRECONDITION_REQUIRED,
  PROCESSING,
  PROXY_AUTHENTICATION_REQUIRED,
  REQUEST_HEADER_FIELDS_TOO_LARGE,
  REQUEST_TIMEOUT,
  REQUEST_TOO_LONG,
  REQUEST_URI_TOO_LONG,
  REQUESTED_RANGE_NOT_SATISFIABLE,
  RESET_CONTENT,
  SEE_OTHER,
  SERVICE_UNAVAILABLE,
  SWITCHING_PROTOCOLS,
  TEMPORARY_REDIRECT,
  TOO_MANY_REQUESTS,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY,
  UNSUPPORTED_MEDIA_TYPE,
  USE_PROXY
};
var statusCodeToReasonPhrase = {
  202: "Accepted",
  502: "Bad Gateway",
  400: "Bad Request",
  409: "Conflict",
  100: "Continue",
  201: "Created",
  417: "Expectation Failed",
  424: "Failed Dependency",
  403: "Forbidden",
  504: "Gateway Timeout",
  410: "Gone",
  505: "HTTP Version Not Supported",
  418: "I'm a teapot",
  419: "Insufficient Space on Resource",
  507: "Insufficient Storage",
  500: "Internal Server Error",
  411: "Length Required",
  423: "Locked",
  420: "Method Failure",
  405: "Method Not Allowed",
  301: "Moved Permanently",
  302: "Moved Temporarily",
  207: "Multi-Status",
  300: "Multiple Choices",
  511: "Network Authentication Required",
  204: "No Content",
  203: "Non Authoritative Information",
  406: "Not Acceptable",
  404: "Not Found",
  501: "Not Implemented",
  304: "Not Modified",
  200: "OK",
  206: "Partial Content",
  402: "Payment Required",
  308: "Permanent Redirect",
  412: "Precondition Failed",
  428: "Precondition Required",
  102: "Processing",
  407: "Proxy Authentication Required",
  431: "Request Header Fields Too Large",
  408: "Request Timeout",
  413: "Request Entity Too Large",
  414: "Request-URI Too Long",
  416: "Requested Range Not Satisfiable",
  205: "Reset Content",
  303: "See Other",
  503: "Service Unavailable",
  101: "Switching Protocols",
  307: "Temporary Redirect",
  429: "Too Many Requests",
  401: "Unauthorized",
  451: "Unavailable For Legal Reasons",
  422: "Unprocessable Entity",
  415: "Unsupported Media Type",
  305: "Use Proxy",
  421: "Misdirected Request"
}, reasonPhraseToStatusCode = {
  Accepted: 202,
  "Bad Gateway": 502,
  "Bad Request": 400,
  Conflict: 409,
  Continue: 100,
  Created: 201,
  "Expectation Failed": 417,
  "Failed Dependency": 424,
  Forbidden: 403,
  "Gateway Timeout": 504,
  Gone: 410,
  "HTTP Version Not Supported": 505,
  "I'm a teapot": 418,
  "Insufficient Space on Resource": 419,
  "Insufficient Storage": 507,
  "Internal Server Error": 500,
  "Length Required": 411,
  Locked: 423,
  "Method Failure": 420,
  "Method Not Allowed": 405,
  "Moved Permanently": 301,
  "Moved Temporarily": 302,
  "Multi-Status": 207,
  "Multiple Choices": 300,
  "Network Authentication Required": 511,
  "No Content": 204,
  "Non Authoritative Information": 203,
  "Not Acceptable": 406,
  "Not Found": 404,
  "Not Implemented": 501,
  "Not Modified": 304,
  OK: 200,
  "Partial Content": 206,
  "Payment Required": 402,
  "Permanent Redirect": 308,
  "Precondition Failed": 412,
  "Precondition Required": 428,
  Processing: 102,
  "Proxy Authentication Required": 407,
  "Request Header Fields Too Large": 431,
  "Request Timeout": 408,
  "Request Entity Too Large": 413,
  "Request-URI Too Long": 414,
  "Requested Range Not Satisfiable": 416,
  "Reset Content": 205,
  "See Other": 303,
  "Service Unavailable": 503,
  "Switching Protocols": 101,
  "Temporary Redirect": 307,
  "Too Many Requests": 429,
  Unauthorized: 401,
  "Unavailable For Legal Reasons": 451,
  "Unprocessable Entity": 422,
  "Unsupported Media Type": 415,
  "Use Proxy": 305,
  "Misdirected Request": 421
};
function getReasonPhrase(t) {
  var e = statusCodeToReasonPhrase[t.toString()];
  if (!e)
    throw new Error("Status code does not exist: " + t);
  return e;
}
function getStatusCode(t) {
  var e = reasonPhraseToStatusCode[t];
  if (!e)
    throw new Error("Reason phrase does not exist: " + t);
  return e;
}
var getStatusText = getReasonPhrase, StatusCodes;
(function(t) {
  t[t.ACCEPTED = 202] = "ACCEPTED", t[t.BAD_GATEWAY = 502] = "BAD_GATEWAY", t[t.BAD_REQUEST = 400] = "BAD_REQUEST", t[t.CONFLICT = 409] = "CONFLICT", t[t.CONTINUE = 100] = "CONTINUE", t[t.CREATED = 201] = "CREATED", t[t.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", t[t.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", t[t.FORBIDDEN = 403] = "FORBIDDEN", t[t.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", t[t.GONE = 410] = "GONE", t[t.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", t[t.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", t[t.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", t[t.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", t[t.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", t[t.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", t[t.LOCKED = 423] = "LOCKED", t[t.METHOD_FAILURE = 420] = "METHOD_FAILURE", t[t.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", t[t.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", t[t.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", t[t.MULTI_STATUS = 207] = "MULTI_STATUS", t[t.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", t[t.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", t[t.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", t[t.NOT_FOUND = 404] = "NOT_FOUND", t[t.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.OK = 200] = "OK", t[t.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", t[t.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", t[t.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", t[t.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", t[t.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", t[t.PROCESSING = 102] = "PROCESSING", t[t.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", t[t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", t[t.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", t[t.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", t[t.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", t[t.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", t[t.RESET_CONTENT = 205] = "RESET_CONTENT", t[t.SEE_OTHER = 303] = "SEE_OTHER", t[t.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", t[t.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", t[t.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", t[t.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", t[t.UNAUTHORIZED = 401] = "UNAUTHORIZED", t[t.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", t[t.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", t[t.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", t[t.USE_PROXY = 305] = "USE_PROXY", t[t.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST";
})(StatusCodes || (StatusCodes = {}));
var ReasonPhrases;
(function(t) {
  t.ACCEPTED = "Accepted", t.BAD_GATEWAY = "Bad Gateway", t.BAD_REQUEST = "Bad Request", t.CONFLICT = "Conflict", t.CONTINUE = "Continue", t.CREATED = "Created", t.EXPECTATION_FAILED = "Expectation Failed", t.FAILED_DEPENDENCY = "Failed Dependency", t.FORBIDDEN = "Forbidden", t.GATEWAY_TIMEOUT = "Gateway Timeout", t.GONE = "Gone", t.HTTP_VERSION_NOT_SUPPORTED = "HTTP Version Not Supported", t.IM_A_TEAPOT = "I'm a teapot", t.INSUFFICIENT_SPACE_ON_RESOURCE = "Insufficient Space on Resource", t.INSUFFICIENT_STORAGE = "Insufficient Storage", t.INTERNAL_SERVER_ERROR = "Internal Server Error", t.LENGTH_REQUIRED = "Length Required", t.LOCKED = "Locked", t.METHOD_FAILURE = "Method Failure", t.METHOD_NOT_ALLOWED = "Method Not Allowed", t.MOVED_PERMANENTLY = "Moved Permanently", t.MOVED_TEMPORARILY = "Moved Temporarily", t.MULTI_STATUS = "Multi-Status", t.MULTIPLE_CHOICES = "Multiple Choices", t.NETWORK_AUTHENTICATION_REQUIRED = "Network Authentication Required", t.NO_CONTENT = "No Content", t.NON_AUTHORITATIVE_INFORMATION = "Non Authoritative Information", t.NOT_ACCEPTABLE = "Not Acceptable", t.NOT_FOUND = "Not Found", t.NOT_IMPLEMENTED = "Not Implemented", t.NOT_MODIFIED = "Not Modified", t.OK = "OK", t.PARTIAL_CONTENT = "Partial Content", t.PAYMENT_REQUIRED = "Payment Required", t.PERMANENT_REDIRECT = "Permanent Redirect", t.PRECONDITION_FAILED = "Precondition Failed", t.PRECONDITION_REQUIRED = "Precondition Required", t.PROCESSING = "Processing", t.PROXY_AUTHENTICATION_REQUIRED = "Proxy Authentication Required", t.REQUEST_HEADER_FIELDS_TOO_LARGE = "Request Header Fields Too Large", t.REQUEST_TIMEOUT = "Request Timeout", t.REQUEST_TOO_LONG = "Request Entity Too Large", t.REQUEST_URI_TOO_LONG = "Request-URI Too Long", t.REQUESTED_RANGE_NOT_SATISFIABLE = "Requested Range Not Satisfiable", t.RESET_CONTENT = "Reset Content", t.SEE_OTHER = "See Other", t.SERVICE_UNAVAILABLE = "Service Unavailable", t.SWITCHING_PROTOCOLS = "Switching Protocols", t.TEMPORARY_REDIRECT = "Temporary Redirect", t.TOO_MANY_REQUESTS = "Too Many Requests", t.UNAUTHORIZED = "Unauthorized", t.UNAVAILABLE_FOR_LEGAL_REASONS = "Unavailable For Legal Reasons", t.UNPROCESSABLE_ENTITY = "Unprocessable Entity", t.UNSUPPORTED_MEDIA_TYPE = "Unsupported Media Type", t.USE_PROXY = "Use Proxy", t.MISDIRECTED_REQUEST = "Misdirected Request";
})(ReasonPhrases || (ReasonPhrases = {}));
var __assign = globalThis && globalThis.__assign || function() {
  return __assign = Object.assign || function(t) {
    for (var e, r = 1, o = arguments.length; r < o; r++) {
      e = arguments[r];
      for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, __assign.apply(this, arguments);
};
const index = __assign(__assign({}, legacyCodes), {
  getStatusCode,
  getStatusText
}), es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCEPTED,
  BAD_GATEWAY,
  BAD_REQUEST,
  CONFLICT,
  CONTINUE,
  CREATED,
  EXPECTATION_FAILED,
  FAILED_DEPENDENCY,
  FORBIDDEN,
  GATEWAY_TIMEOUT,
  GONE,
  HTTP_VERSION_NOT_SUPPORTED,
  IM_A_TEAPOT,
  INSUFFICIENT_SPACE_ON_RESOURCE,
  INSUFFICIENT_STORAGE,
  INTERNAL_SERVER_ERROR,
  LENGTH_REQUIRED,
  LOCKED,
  METHOD_FAILURE,
  METHOD_NOT_ALLOWED,
  MOVED_PERMANENTLY,
  MOVED_TEMPORARILY,
  MULTIPLE_CHOICES,
  MULTI_STATUS,
  NETWORK_AUTHENTICATION_REQUIRED,
  NON_AUTHORITATIVE_INFORMATION,
  NOT_ACCEPTABLE,
  NOT_FOUND,
  NOT_IMPLEMENTED,
  NOT_MODIFIED,
  NO_CONTENT,
  OK,
  PARTIAL_CONTENT,
  PAYMENT_REQUIRED,
  PERMANENT_REDIRECT,
  PRECONDITION_FAILED,
  PRECONDITION_REQUIRED,
  PROCESSING,
  PROXY_AUTHENTICATION_REQUIRED,
  REQUESTED_RANGE_NOT_SATISFIABLE,
  REQUEST_HEADER_FIELDS_TOO_LARGE,
  REQUEST_TIMEOUT,
  REQUEST_TOO_LONG,
  REQUEST_URI_TOO_LONG,
  RESET_CONTENT,
  get ReasonPhrases() {
    return ReasonPhrases;
  },
  SEE_OTHER,
  SERVICE_UNAVAILABLE,
  SWITCHING_PROTOCOLS,
  get StatusCodes() {
    return StatusCodes;
  },
  TEMPORARY_REDIRECT,
  TOO_MANY_REQUESTS,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY,
  UNSUPPORTED_MEDIA_TYPE,
  USE_PROXY,
  default: index,
  getReasonPhrase,
  getStatusCode,
  getStatusText
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(es);
var cache$1 = { exports: {} };
(function(t, e) {
  (function(o, a) {
    t.exports = a(axios);
  })(window, function(r) {
    return (
      /******/
      function(o) {
        var a = {};
        function c(u) {
          if (a[u])
            return a[u].exports;
          var d = a[u] = {
            /******/
            i: u,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return o[u].call(d.exports, d, d.exports, c), d.l = !0, d.exports;
        }
        return c.m = o, c.c = a, c.d = function(u, d, p) {
          c.o(u, d) || Object.defineProperty(u, d, { enumerable: !0, get: p });
        }, c.r = function(u) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(u, "__esModule", { value: !0 });
        }, c.t = function(u, d) {
          if (d & 1 && (u = c(u)), d & 8 || d & 4 && typeof u == "object" && u && u.__esModule)
            return u;
          var p = /* @__PURE__ */ Object.create(null);
          if (c.r(p), Object.defineProperty(p, "default", { enumerable: !0, value: u }), d & 2 && typeof u != "string")
            for (var g in u)
              c.d(p, g, (function(b) {
                return u[b];
              }).bind(null, g));
          return p;
        }, c.n = function(u) {
          var d = u && u.__esModule ? (
            /******/
            function() {
              return u.default;
            }
          ) : (
            /******/
            function() {
              return u;
            }
          );
          return c.d(d, "a", d), d;
        }, c.o = function(u, d) {
          return Object.prototype.hasOwnProperty.call(u, d);
        }, c.p = "", c(c.s = "./src/index.js");
      }({
        /***/
        "./node_modules/cache-control-esm/index.js": (
          /*!*************************************************!*\
            !*** ./node_modules/cache-control-esm/index.js ***!
            \*************************************************/
          /*! exports provided: CacheControl, parse, format, default */
          /***/
          function(o, a, c) {
            c.r(a), c.d(a, "CacheControl", function() {
              return D;
            }), c.d(a, "parse", function() {
              return L;
            }), c.d(a, "format", function() {
              return R;
            }), c(
              /*! core-js/modules/es6.array.from */
              "./node_modules/core-js/modules/es6.array.from.js"
            ), c(
              /*! core-js/modules/es6.function.name */
              "./node_modules/core-js/modules/es6.function.name.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            ), c(
              /*! core-js/modules/web.dom.iterable */
              "./node_modules/core-js/modules/web.dom.iterable.js"
            ), c(
              /*! core-js/modules/es7.symbol.async-iterator */
              "./node_modules/core-js/modules/es7.symbol.async-iterator.js"
            ), c(
              /*! core-js/modules/es6.symbol */
              "./node_modules/core-js/modules/es6.symbol.js"
            ), c(
              /*! core-js/modules/es6.regexp.split */
              "./node_modules/core-js/modules/es6.regexp.split.js"
            ), c(
              /*! core-js/modules/es6.number.is-finite */
              "./node_modules/core-js/modules/es6.number.is-finite.js"
            );
            function u(O, P) {
              return x(O) || b(O, P) || p(O, P) || d();
            }
            function d() {
              throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function p(O, P) {
              if (O) {
                if (typeof O == "string")
                  return g(O, P);
                var z = Object.prototype.toString.call(O).slice(8, -1);
                if (z === "Object" && O.constructor && (z = O.constructor.name), z === "Map" || z === "Set")
                  return Array.from(O);
                if (z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(z))
                  return g(O, P);
              }
            }
            function g(O, P) {
              (P == null || P > O.length) && (P = O.length);
              for (var z = 0, W = new Array(P); z < P; z++)
                W[z] = O[z];
              return W;
            }
            function b(O, P) {
              if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(O)))) {
                var z = [], W = !0, A = !1, S = void 0;
                try {
                  for (var F = O[Symbol.iterator](), U; !(W = (U = F.next()).done) && (z.push(U.value), !(P && z.length === P)); W = !0)
                    ;
                } catch (M) {
                  A = !0, S = M;
                } finally {
                  try {
                    !W && F.return != null && F.return();
                  } finally {
                    if (A)
                      throw S;
                  }
                }
                return z;
              }
            }
            function x(O) {
              if (Array.isArray(O))
                return O;
            }
            function w(O, P) {
              if (!(O instanceof P))
                throw new TypeError("Cannot call a class as a function");
            }
            function y(O, P) {
              for (var z = 0; z < P.length; z++) {
                var W = P[z];
                W.enumerable = W.enumerable || !1, W.configurable = !0, "value" in W && (W.writable = !0), Object.defineProperty(O, W.key, W);
              }
            }
            function I(O, P, z) {
              return P && y(O.prototype, P), z && y(O, z), O;
            }
            var E = /([a-zA-Z][a-zA-Z_-]*)\s*(?:=(?:"([^"]*)"|([^ \t",;]*)))?/g, T = {
              maxAge: "max-age",
              sharedMaxAge: "s-maxage",
              maxStale: "max-stale",
              minFresh: "min-fresh",
              immutable: "immutable",
              mustRevalidate: "must-revalidate",
              noCache: "no-cache",
              noStore: "no-store",
              noTransform: "no-transform",
              onlyIfCached: "only-if-cached",
              private: "private",
              proxyRevalidate: "proxy-revalidate",
              public: "public"
            };
            function C(O) {
              return O === null;
            }
            function $(O) {
              if (!O)
                return null;
              var P = parseInt(O, 10);
              return !Number.isFinite(P) || P < 0 ? null : P;
            }
            var D = /* @__PURE__ */ function() {
              function O() {
                w(this, O), this.maxAge = null, this.sharedMaxAge = null, this.maxStale = null, this.maxStaleDuration = null, this.minFresh = null, this.immutable = null, this.mustRevalidate = null, this.noCache = null, this.noStore = null, this.noTransform = null, this.onlyIfCached = null, this.private = null, this.proxyRevalidate = null, this.public = null;
              }
              return I(O, [{
                key: "parse",
                value: function(z) {
                  if (!z || z.length === 0)
                    return this;
                  var W = {}, A = z.match(E) || [];
                  return Array.prototype.forEach.call(A, function(S) {
                    var F = S.split("=", 2), U = u(F, 1), M = U[0], V = null;
                    F.length > 1 && (V = F[1].trim()), W[M.toLowerCase()] = V;
                  }), this.maxAge = $(W[T.maxAge]), this.sharedMaxAge = $(W[T.sharedMaxAge]), this.maxStale = C(W[T.maxStale]), this.maxStaleDuration = $(W[T.maxStale]), this.maxStaleDuration && (this.maxStale = !0), this.minFresh = $(W[T.minFresh]), this.immutable = C(W[T.immutable]), this.mustRevalidate = C(W[T.mustRevalidate]), this.noCache = C(W[T.noCache]), this.noStore = C(W[T.noStore]), this.noTransform = C(W[T.noTransform]), this.onlyIfCached = C(W[T.onlyIfCached]), this.private = C(W[T.private]), this.proxyRevalidate = C(W[T.proxyRevalidate]), this.public = C(W[T.public]), this;
                }
              }, {
                key: "format",
                value: function() {
                  var z = [];
                  return this.maxAge && z.push("".concat(T.maxAge, "=").concat(this.maxAge)), this.sharedMaxAge && z.push("".concat(T.sharedMaxAge, "=").concat(this.sharedMaxAge)), this.maxStale && (this.maxStaleDuration ? z.push("".concat(T.maxStale, "=").concat(this.maxStaleDuration)) : z.push(T.maxStale)), this.minFresh && z.push("".concat(T.minFresh, "=").concat(this.minFresh)), this.immutable && z.push(T.immutable), this.mustRevalidate && z.push(T.mustRevalidate), this.noCache && z.push(T.noCache), this.noStore && z.push(T.noStore), this.noTransform && z.push(T.noTransform), this.onlyIfCached && z.push(T.onlyIfCached), this.private && z.push(T.private), this.proxyRevalidate && z.push(T.proxyRevalidate), this.public && z.push(T.public), z.join(", ");
                }
              }]), O;
            }();
            function L(O) {
              var P = new D();
              return P.parse(O);
            }
            function R(O) {
              return O instanceof D ? O.format() : D.prototype.format.call(O);
            }
            a.default = {
              CacheControl: D,
              parse: L,
              format: R
            };
          }
        ),
        /***/
        "./node_modules/charenc/charenc.js": (
          /*!*****************************************!*\
            !*** ./node_modules/charenc/charenc.js ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = {
              // UTF-8 encoding
              utf8: {
                // Convert a string to a byte array
                stringToBytes: function(u) {
                  return c.bin.stringToBytes(unescape(encodeURIComponent(u)));
                },
                // Convert a byte array to a string
                bytesToString: function(u) {
                  return decodeURIComponent(escape(c.bin.bytesToString(u)));
                }
              },
              // Binary encoding
              bin: {
                // Convert a string to a byte array
                stringToBytes: function(u) {
                  for (var d = [], p = 0; p < u.length; p++)
                    d.push(u.charCodeAt(p) & 255);
                  return d;
                },
                // Convert a byte array to a string
                bytesToString: function(u) {
                  for (var d = [], p = 0; p < u.length; p++)
                    d.push(String.fromCharCode(u[p]));
                  return d.join("");
                }
              }
            };
            o.exports = c;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_a-function.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_a-function.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c) {
              if (typeof c != "function")
                throw TypeError(c + " is not a function!");
              return c;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_add-to-unscopables.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("unscopables"), d = Array.prototype;
            d[u] == null && c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            )(d, u, {}), o.exports = function(p) {
              d[u][p] = !0;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_advance-string-index.js": (
          /*!***************************************************************!*\
            !*** ./node_modules/core-js/modules/_advance-string-index.js ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_string-at */
              "./node_modules/core-js/modules/_string-at.js"
            )(!0);
            o.exports = function(d, p, g) {
              return p + (g ? u(d, p).length : 1);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_an-object.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_an-object.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            );
            o.exports = function(d) {
              if (!u(d))
                throw TypeError(d + " is not an object!");
              return d;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_array-includes.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/modules/_array-includes.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), d = c(
              /*! ./_to-length */
              "./node_modules/core-js/modules/_to-length.js"
            ), p = c(
              /*! ./_to-absolute-index */
              "./node_modules/core-js/modules/_to-absolute-index.js"
            );
            o.exports = function(g) {
              return function(b, x, w) {
                var y = u(b), I = d(y.length), E = p(w, I), T;
                if (g && x != x) {
                  for (; I > E; )
                    if (T = y[E++], T != T)
                      return !0;
                } else
                  for (; I > E; E++)
                    if ((g || E in y) && y[E] === x)
                      return g || E || 0;
                return !g && -1;
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_classof.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/modules/_classof.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_cof */
              "./node_modules/core-js/modules/_cof.js"
            ), d = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("toStringTag"), p = u(function() {
              return arguments;
            }()) == "Arguments", g = function(b, x) {
              try {
                return b[x];
              } catch {
              }
            };
            o.exports = function(b) {
              var x, w, y;
              return b === void 0 ? "Undefined" : b === null ? "Null" : typeof (w = g(x = Object(b), d)) == "string" ? w : p ? u(x) : (y = u(x)) == "Object" && typeof x.callee == "function" ? "Arguments" : y;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_cof.js": (
          /*!**********************************************!*\
            !*** ./node_modules/core-js/modules/_cof.js ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = {}.toString;
            o.exports = function(u) {
              return c.call(u).slice(8, -1);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_core.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/modules/_core.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = o.exports = { version: "2.6.12" };
            typeof __e == "number" && (__e = c);
          }
        ),
        /***/
        "./node_modules/core-js/modules/_create-property.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/modules/_create-property.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ), d = c(
              /*! ./_property-desc */
              "./node_modules/core-js/modules/_property-desc.js"
            );
            o.exports = function(p, g, b) {
              g in p ? u.f(p, g, d(0, b)) : p[g] = b;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_ctx.js": (
          /*!**********************************************!*\
            !*** ./node_modules/core-js/modules/_ctx.js ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_a-function */
              "./node_modules/core-js/modules/_a-function.js"
            );
            o.exports = function(d, p, g) {
              if (u(d), p === void 0)
                return d;
              switch (g) {
                case 1:
                  return function(b) {
                    return d.call(p, b);
                  };
                case 2:
                  return function(b, x) {
                    return d.call(p, b, x);
                  };
                case 3:
                  return function(b, x, w) {
                    return d.call(p, b, x, w);
                  };
              }
              return function() {
                return d.apply(p, arguments);
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_defined.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/modules/_defined.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c) {
              if (c == null)
                throw TypeError("Can't call method on  " + c);
              return c;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_descriptors.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_descriptors.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            o.exports = !c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            )(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/_dom-create.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_dom-create.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            ), d = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ).document, p = u(d) && u(d.createElement);
            o.exports = function(g) {
              return p ? d.createElement(g) : {};
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_enum-bug-keys.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
          }
        ),
        /***/
        "./node_modules/core-js/modules/_enum-keys.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_enum-keys.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-keys */
              "./node_modules/core-js/modules/_object-keys.js"
            ), d = c(
              /*! ./_object-gops */
              "./node_modules/core-js/modules/_object-gops.js"
            ), p = c(
              /*! ./_object-pie */
              "./node_modules/core-js/modules/_object-pie.js"
            );
            o.exports = function(g) {
              var b = u(g), x = d.f;
              if (x)
                for (var w = x(g), y = p.f, I = 0, E; w.length > I; )
                  y.call(g, E = w[I++]) && b.push(E);
              return b;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_export.js": (
          /*!*************************************************!*\
            !*** ./node_modules/core-js/modules/_export.js ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), d = c(
              /*! ./_core */
              "./node_modules/core-js/modules/_core.js"
            ), p = c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            ), g = c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            ), b = c(
              /*! ./_ctx */
              "./node_modules/core-js/modules/_ctx.js"
            ), x = "prototype", w = function(y, I, E) {
              var T = y & w.F, C = y & w.G, $ = y & w.S, D = y & w.P, L = y & w.B, R = C ? u : $ ? u[I] || (u[I] = {}) : (u[I] || {})[x], O = C ? d : d[I] || (d[I] = {}), P = O[x] || (O[x] = {}), z, W, A, S;
              C && (E = I);
              for (z in E)
                W = !T && R && R[z] !== void 0, A = (W ? R : E)[z], S = L && W ? b(A, u) : D && typeof A == "function" ? b(Function.call, A) : A, R && g(R, z, A, y & w.U), O[z] != A && p(O, z, S), D && P[z] != A && (P[z] = A);
            };
            u.core = d, w.F = 1, w.G = 2, w.S = 4, w.P = 8, w.B = 16, w.W = 32, w.U = 64, w.R = 128, o.exports = w;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_fails-is-regexp.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/modules/_fails-is-regexp.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("match");
            o.exports = function(d) {
              var p = /./;
              try {
                "/./"[d](p);
              } catch {
                try {
                  return p[u] = !1, !"/./"[d](p);
                } catch {
                }
              }
              return !0;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_fails.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/modules/_fails.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c) {
              try {
                return !!c();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_fix-re-wks.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_fix-re-wks.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            c(
              /*! ./es6.regexp.exec */
              "./node_modules/core-js/modules/es6.regexp.exec.js"
            );
            var u = c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            ), d = c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            ), p = c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            ), g = c(
              /*! ./_defined */
              "./node_modules/core-js/modules/_defined.js"
            ), b = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            ), x = c(
              /*! ./_regexp-exec */
              "./node_modules/core-js/modules/_regexp-exec.js"
            ), w = b("species"), y = !p(function() {
              var E = /./;
              return E.exec = function() {
                var T = [];
                return T.groups = { a: "7" }, T;
              }, "".replace(E, "$<a>") !== "7";
            }), I = function() {
              var E = /(?:)/, T = E.exec;
              E.exec = function() {
                return T.apply(this, arguments);
              };
              var C = "ab".split(E);
              return C.length === 2 && C[0] === "a" && C[1] === "b";
            }();
            o.exports = function(E, T, C) {
              var $ = b(E), D = !p(function() {
                var W = {};
                return W[$] = function() {
                  return 7;
                }, ""[E](W) != 7;
              }), L = D ? !p(function() {
                var W = !1, A = /a/;
                return A.exec = function() {
                  return W = !0, null;
                }, E === "split" && (A.constructor = {}, A.constructor[w] = function() {
                  return A;
                }), A[$](""), !W;
              }) : void 0;
              if (!D || !L || E === "replace" && !y || E === "split" && !I) {
                var R = /./[$], O = C(
                  g,
                  $,
                  ""[E],
                  function(A, S, F, U, M) {
                    return S.exec === x ? D && !M ? { done: !0, value: R.call(S, F, U) } : { done: !0, value: A.call(F, S, U) } : { done: !1 };
                  }
                ), P = O[0], z = O[1];
                u(String.prototype, E, P), d(
                  RegExp.prototype,
                  $,
                  T == 2 ? function(W, A) {
                    return z.call(W, this, A);
                  } : function(W) {
                    return z.call(W, this);
                  }
                );
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_flags.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/modules/_flags.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            );
            o.exports = function() {
              var d = u(this), p = "";
              return d.global && (p += "g"), d.ignoreCase && (p += "i"), d.multiline && (p += "m"), d.unicode && (p += "u"), d.sticky && (p += "y"), p;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_function-to-string.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/modules/_function-to-string.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            o.exports = c(
              /*! ./_shared */
              "./node_modules/core-js/modules/_shared.js"
            )("native-function-to-string", Function.toString);
          }
        ),
        /***/
        "./node_modules/core-js/modules/_global.js": (
          /*!*************************************************!*\
            !*** ./node_modules/core-js/modules/_global.js ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = o.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
            typeof __g == "number" && (__g = c);
          }
        ),
        /***/
        "./node_modules/core-js/modules/_has.js": (
          /*!**********************************************!*\
            !*** ./node_modules/core-js/modules/_has.js ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = {}.hasOwnProperty;
            o.exports = function(u, d) {
              return c.call(u, d);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_hide.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/modules/_hide.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ), d = c(
              /*! ./_property-desc */
              "./node_modules/core-js/modules/_property-desc.js"
            );
            o.exports = c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) ? function(p, g, b) {
              return u.f(p, g, d(1, b));
            } : function(p, g, b) {
              return p[g] = b, p;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_html.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/modules/_html.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ).document;
            o.exports = u && u.documentElement;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_ie8-dom-define.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            o.exports = !c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) && !c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            )(function() {
              return Object.defineProperty(c(
                /*! ./_dom-create */
                "./node_modules/core-js/modules/_dom-create.js"
              )("div"), "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iobject.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/modules/_iobject.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_cof */
              "./node_modules/core-js/modules/_cof.js"
            );
            o.exports = Object("z").propertyIsEnumerable(0) ? Object : function(d) {
              return u(d) == "String" ? d.split("") : Object(d);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_is-array-iter.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/modules/_is-array-iter.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_iterators */
              "./node_modules/core-js/modules/_iterators.js"
            ), d = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("iterator"), p = Array.prototype;
            o.exports = function(g) {
              return g !== void 0 && (u.Array === g || p[d] === g);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_is-array.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/modules/_is-array.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_cof */
              "./node_modules/core-js/modules/_cof.js"
            );
            o.exports = Array.isArray || function(p) {
              return u(p) == "Array";
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_is-object.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_is-object.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c) {
              return typeof c == "object" ? c !== null : typeof c == "function";
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_is-regexp.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_is-regexp.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            ), d = c(
              /*! ./_cof */
              "./node_modules/core-js/modules/_cof.js"
            ), p = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("match");
            o.exports = function(g) {
              var b;
              return u(g) && ((b = g[p]) !== void 0 ? !!b : d(g) == "RegExp");
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iter-call.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_iter-call.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            );
            o.exports = function(d, p, g, b) {
              try {
                return b ? p(u(g)[0], g[1]) : p(g);
              } catch (w) {
                var x = d.return;
                throw x !== void 0 && u(x.call(d)), w;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iter-create.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_iter-create.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-create */
              "./node_modules/core-js/modules/_object-create.js"
            ), d = c(
              /*! ./_property-desc */
              "./node_modules/core-js/modules/_property-desc.js"
            ), p = c(
              /*! ./_set-to-string-tag */
              "./node_modules/core-js/modules/_set-to-string-tag.js"
            ), g = {};
            c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            )(g, c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("iterator"), function() {
              return this;
            }), o.exports = function(b, x, w) {
              b.prototype = u(g, { next: d(1, w) }), p(b, x + " Iterator");
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iter-define.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_iter-define.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_library */
              "./node_modules/core-js/modules/_library.js"
            ), d = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), p = c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            ), g = c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            ), b = c(
              /*! ./_iterators */
              "./node_modules/core-js/modules/_iterators.js"
            ), x = c(
              /*! ./_iter-create */
              "./node_modules/core-js/modules/_iter-create.js"
            ), w = c(
              /*! ./_set-to-string-tag */
              "./node_modules/core-js/modules/_set-to-string-tag.js"
            ), y = c(
              /*! ./_object-gpo */
              "./node_modules/core-js/modules/_object-gpo.js"
            ), I = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("iterator"), E = !([].keys && "next" in [].keys()), T = "@@iterator", C = "keys", $ = "values", D = function() {
              return this;
            };
            o.exports = function(L, R, O, P, z, W, A) {
              x(O, R, P);
              var S = function(ce) {
                if (!E && ce in V)
                  return V[ce];
                switch (ce) {
                  case C:
                    return function() {
                      return new O(this, ce);
                    };
                  case $:
                    return function() {
                      return new O(this, ce);
                    };
                }
                return function() {
                  return new O(this, ce);
                };
              }, F = R + " Iterator", U = z == $, M = !1, V = L.prototype, G = V[I] || V[T] || z && V[z], Q = G || S(z), fe = z ? U ? S("entries") : Q : void 0, te = R == "Array" && V.entries || G, de, me, Me;
              if (te && (Me = y(te.call(new L())), Me !== Object.prototype && Me.next && (w(Me, F, !0), !u && typeof Me[I] != "function" && g(Me, I, D))), U && G && G.name !== $ && (M = !0, Q = function() {
                return G.call(this);
              }), (!u || A) && (E || M || !V[I]) && g(V, I, Q), b[R] = Q, b[F] = D, z)
                if (de = {
                  values: U ? Q : S($),
                  keys: W ? Q : S(C),
                  entries: fe
                }, A)
                  for (me in de)
                    me in V || p(V, me, de[me]);
                else
                  d(d.P + d.F * (E || M), R, de);
              return de;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iter-detect.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_iter-detect.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("iterator"), d = !1;
            try {
              var p = [7][u]();
              p.return = function() {
                d = !0;
              }, Array.from(p, function() {
                throw 2;
              });
            } catch {
            }
            o.exports = function(g, b) {
              if (!b && !d)
                return !1;
              var x = !1;
              try {
                var w = [7], y = w[u]();
                y.next = function() {
                  return { done: x = !0 };
                }, w[u] = function() {
                  return y;
                }, g(w);
              } catch {
              }
              return x;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iter-step.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_iter-step.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c, u) {
              return { value: u, done: !!c };
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_iterators.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_iterators.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = {};
          }
        ),
        /***/
        "./node_modules/core-js/modules/_library.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/modules/_library.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = !1;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_meta.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/modules/_meta.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_uid */
              "./node_modules/core-js/modules/_uid.js"
            )("meta"), d = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            ), p = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), g = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ).f, b = 0, x = Object.isExtensible || function() {
              return !0;
            }, w = !c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            )(function() {
              return x(Object.preventExtensions({}));
            }), y = function($) {
              g($, u, { value: {
                i: "O" + ++b,
                // object ID
                w: {}
                // weak collections IDs
              } });
            }, I = function($, D) {
              if (!d($))
                return typeof $ == "symbol" ? $ : (typeof $ == "string" ? "S" : "P") + $;
              if (!p($, u)) {
                if (!x($))
                  return "F";
                if (!D)
                  return "E";
                y($);
              }
              return $[u].i;
            }, E = function($, D) {
              if (!p($, u)) {
                if (!x($))
                  return !0;
                if (!D)
                  return !1;
                y($);
              }
              return $[u].w;
            }, T = function($) {
              return w && C.NEED && x($) && !p($, u) && y($), $;
            }, C = o.exports = {
              KEY: u,
              NEED: !1,
              fastKey: I,
              getWeak: E,
              onFreeze: T
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-create.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/modules/_object-create.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), d = c(
              /*! ./_object-dps */
              "./node_modules/core-js/modules/_object-dps.js"
            ), p = c(
              /*! ./_enum-bug-keys */
              "./node_modules/core-js/modules/_enum-bug-keys.js"
            ), g = c(
              /*! ./_shared-key */
              "./node_modules/core-js/modules/_shared-key.js"
            )("IE_PROTO"), b = function() {
            }, x = "prototype", w = function() {
              var y = c(
                /*! ./_dom-create */
                "./node_modules/core-js/modules/_dom-create.js"
              )("iframe"), I = p.length, E = "<", T = ">", C;
              for (y.style.display = "none", c(
                /*! ./_html */
                "./node_modules/core-js/modules/_html.js"
              ).appendChild(y), y.src = "javascript:", C = y.contentWindow.document, C.open(), C.write(E + "script" + T + "document.F=Object" + E + "/script" + T), C.close(), w = C.F; I--; )
                delete w[x][p[I]];
              return w();
            };
            o.exports = Object.create || function(I, E) {
              var T;
              return I !== null ? (b[x] = u(I), T = new b(), b[x] = null, T[g] = I) : T = w(), E === void 0 ? T : d(T, E);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-dp.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_object-dp.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), d = c(
              /*! ./_ie8-dom-define */
              "./node_modules/core-js/modules/_ie8-dom-define.js"
            ), p = c(
              /*! ./_to-primitive */
              "./node_modules/core-js/modules/_to-primitive.js"
            ), g = Object.defineProperty;
            a.f = c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) ? Object.defineProperty : function(x, w, y) {
              if (u(x), w = p(w, !0), u(y), d)
                try {
                  return g(x, w, y);
                } catch {
                }
              if ("get" in y || "set" in y)
                throw TypeError("Accessors not supported!");
              return "value" in y && (x[w] = y.value), x;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-dps.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_object-dps.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ), d = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), p = c(
              /*! ./_object-keys */
              "./node_modules/core-js/modules/_object-keys.js"
            );
            o.exports = c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) ? Object.defineProperties : function(b, x) {
              d(b);
              for (var w = p(x), y = w.length, I = 0, E; y > I; )
                u.f(b, E = w[I++], x[E]);
              return b;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-gopd.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_object-gopd.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-pie */
              "./node_modules/core-js/modules/_object-pie.js"
            ), d = c(
              /*! ./_property-desc */
              "./node_modules/core-js/modules/_property-desc.js"
            ), p = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), g = c(
              /*! ./_to-primitive */
              "./node_modules/core-js/modules/_to-primitive.js"
            ), b = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), x = c(
              /*! ./_ie8-dom-define */
              "./node_modules/core-js/modules/_ie8-dom-define.js"
            ), w = Object.getOwnPropertyDescriptor;
            a.f = c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) ? w : function(I, E) {
              if (I = p(I), E = g(E, !0), x)
                try {
                  return w(I, E);
                } catch {
                }
              if (b(I, E))
                return d(!u.f.call(I, E), I[E]);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-gopn-ext.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/modules/_object-gopn-ext.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), d = c(
              /*! ./_object-gopn */
              "./node_modules/core-js/modules/_object-gopn.js"
            ).f, p = {}.toString, g = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], b = function(x) {
              try {
                return d(x);
              } catch {
                return g.slice();
              }
            };
            o.exports.f = function(w) {
              return g && p.call(w) == "[object Window]" ? b(w) : d(u(w));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-gopn.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_object-gopn.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-keys-internal */
              "./node_modules/core-js/modules/_object-keys-internal.js"
            ), d = c(
              /*! ./_enum-bug-keys */
              "./node_modules/core-js/modules/_enum-bug-keys.js"
            ).concat("length", "prototype");
            a.f = Object.getOwnPropertyNames || function(g) {
              return u(g, d);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-gops.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_object-gops.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            a.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-gpo.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_object-gpo.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), d = c(
              /*! ./_to-object */
              "./node_modules/core-js/modules/_to-object.js"
            ), p = c(
              /*! ./_shared-key */
              "./node_modules/core-js/modules/_shared-key.js"
            )("IE_PROTO"), g = Object.prototype;
            o.exports = Object.getPrototypeOf || function(b) {
              return b = d(b), u(b, p) ? b[p] : typeof b.constructor == "function" && b instanceof b.constructor ? b.constructor.prototype : b instanceof Object ? g : null;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-keys-internal.js": (
          /*!***************************************************************!*\
            !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), d = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), p = c(
              /*! ./_array-includes */
              "./node_modules/core-js/modules/_array-includes.js"
            )(!1), g = c(
              /*! ./_shared-key */
              "./node_modules/core-js/modules/_shared-key.js"
            )("IE_PROTO");
            o.exports = function(b, x) {
              var w = d(b), y = 0, I = [], E;
              for (E in w)
                E != g && u(w, E) && I.push(E);
              for (; x.length > y; )
                u(w, E = x[y++]) && (~p(I, E) || I.push(E));
              return I;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-keys.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_object-keys.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-keys-internal */
              "./node_modules/core-js/modules/_object-keys-internal.js"
            ), d = c(
              /*! ./_enum-bug-keys */
              "./node_modules/core-js/modules/_enum-bug-keys.js"
            );
            o.exports = Object.keys || function(g) {
              return u(g, d);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_object-pie.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_object-pie.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            a.f = {}.propertyIsEnumerable;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_own-keys.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/modules/_own-keys.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-gopn */
              "./node_modules/core-js/modules/_object-gopn.js"
            ), d = c(
              /*! ./_object-gops */
              "./node_modules/core-js/modules/_object-gops.js"
            ), p = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), g = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ).Reflect;
            o.exports = g && g.ownKeys || function(x) {
              var w = u.f(p(x)), y = d.f;
              return y ? w.concat(y(x)) : w;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_property-desc.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/modules/_property-desc.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = function(c, u) {
              return {
                enumerable: !(c & 1),
                configurable: !(c & 2),
                writable: !(c & 4),
                value: u
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_redefine.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/modules/_redefine.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), d = c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            ), p = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), g = c(
              /*! ./_uid */
              "./node_modules/core-js/modules/_uid.js"
            )("src"), b = c(
              /*! ./_function-to-string */
              "./node_modules/core-js/modules/_function-to-string.js"
            ), x = "toString", w = ("" + b).split(x);
            c(
              /*! ./_core */
              "./node_modules/core-js/modules/_core.js"
            ).inspectSource = function(y) {
              return b.call(y);
            }, (o.exports = function(y, I, E, T) {
              var C = typeof E == "function";
              C && (p(E, "name") || d(E, "name", I)), y[I] !== E && (C && (p(E, g) || d(E, g, y[I] ? "" + y[I] : w.join(String(I)))), y === u ? y[I] = E : T ? y[I] ? y[I] = E : d(y, I, E) : (delete y[I], d(y, I, E)));
            })(Function.prototype, x, function() {
              return typeof this == "function" && this[g] || b.call(this);
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/_regexp-exec-abstract.js": (
          /*!***************************************************************!*\
            !*** ./node_modules/core-js/modules/_regexp-exec-abstract.js ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_classof */
              "./node_modules/core-js/modules/_classof.js"
            ), d = RegExp.prototype.exec;
            o.exports = function(p, g) {
              var b = p.exec;
              if (typeof b == "function") {
                var x = b.call(p, g);
                if (typeof x != "object")
                  throw new TypeError("RegExp exec method returned something other than an Object or null");
                return x;
              }
              if (u(p) !== "RegExp")
                throw new TypeError("RegExp#exec called on incompatible receiver");
              return d.call(p, g);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_regexp-exec.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/modules/_regexp-exec.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_flags */
              "./node_modules/core-js/modules/_flags.js"
            ), d = RegExp.prototype.exec, p = String.prototype.replace, g = d, b = "lastIndex", x = function() {
              var I = /a/, E = /b*/g;
              return d.call(I, "a"), d.call(E, "a"), I[b] !== 0 || E[b] !== 0;
            }(), w = /()??/.exec("")[1] !== void 0, y = x || w;
            y && (g = function(E) {
              var T = this, C, $, D, L;
              return w && ($ = new RegExp("^" + T.source + "$(?!\\s)", u.call(T))), x && (C = T[b]), D = d.call(T, E), x && D && (T[b] = T.global ? D.index + D[0].length : C), w && D && D.length > 1 && p.call(D[0], $, function() {
                for (L = 1; L < arguments.length - 2; L++)
                  arguments[L] === void 0 && (D[L] = void 0);
              }), D;
            }), o.exports = g;
          }
        ),
        /***/
        "./node_modules/core-js/modules/_set-to-string-tag.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ).f, d = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), p = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("toStringTag");
            o.exports = function(g, b, x) {
              g && !d(g = x ? g : g.prototype, p) && u(g, p, { configurable: !0, value: b });
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_shared-key.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_shared-key.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_shared */
              "./node_modules/core-js/modules/_shared.js"
            )("keys"), d = c(
              /*! ./_uid */
              "./node_modules/core-js/modules/_uid.js"
            );
            o.exports = function(p) {
              return u[p] || (u[p] = d(p));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_shared.js": (
          /*!*************************************************!*\
            !*** ./node_modules/core-js/modules/_shared.js ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_core */
              "./node_modules/core-js/modules/_core.js"
            ), d = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), p = "__core-js_shared__", g = d[p] || (d[p] = {});
            (o.exports = function(b, x) {
              return g[b] || (g[b] = x !== void 0 ? x : {});
            })("versions", []).push({
              version: u.version,
              mode: c(
                /*! ./_library */
                "./node_modules/core-js/modules/_library.js"
              ) ? "pure" : "global",
              copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/_species-constructor.js": (
          /*!**************************************************************!*\
            !*** ./node_modules/core-js/modules/_species-constructor.js ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), d = c(
              /*! ./_a-function */
              "./node_modules/core-js/modules/_a-function.js"
            ), p = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("species");
            o.exports = function(g, b) {
              var x = u(g).constructor, w;
              return x === void 0 || (w = u(x)[p]) == null ? b : d(w);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_string-at.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_string-at.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_to-integer */
              "./node_modules/core-js/modules/_to-integer.js"
            ), d = c(
              /*! ./_defined */
              "./node_modules/core-js/modules/_defined.js"
            );
            o.exports = function(p) {
              return function(g, b) {
                var x = String(d(g)), w = u(b), y = x.length, I, E;
                return w < 0 || w >= y ? p ? "" : void 0 : (I = x.charCodeAt(w), I < 55296 || I > 56319 || w + 1 === y || (E = x.charCodeAt(w + 1)) < 56320 || E > 57343 ? p ? x.charAt(w) : I : p ? x.slice(w, w + 2) : (I - 55296 << 10) + (E - 56320) + 65536);
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_string-context.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/modules/_string-context.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-regexp */
              "./node_modules/core-js/modules/_is-regexp.js"
            ), d = c(
              /*! ./_defined */
              "./node_modules/core-js/modules/_defined.js"
            );
            o.exports = function(p, g, b) {
              if (u(g))
                throw TypeError("String#" + b + " doesn't accept regex!");
              return String(d(p));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-absolute-index.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_to-integer */
              "./node_modules/core-js/modules/_to-integer.js"
            ), d = Math.max, p = Math.min;
            o.exports = function(g, b) {
              return g = u(g), g < 0 ? d(g + b, 0) : p(g, b);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-integer.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_to-integer.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = Math.ceil, u = Math.floor;
            o.exports = function(d) {
              return isNaN(d = +d) ? 0 : (d > 0 ? u : c)(d);
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-iobject.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_to-iobject.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_iobject */
              "./node_modules/core-js/modules/_iobject.js"
            ), d = c(
              /*! ./_defined */
              "./node_modules/core-js/modules/_defined.js"
            );
            o.exports = function(p) {
              return u(d(p));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-length.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_to-length.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_to-integer */
              "./node_modules/core-js/modules/_to-integer.js"
            ), d = Math.min;
            o.exports = function(p) {
              return p > 0 ? d(u(p), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-object.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/_to-object.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_defined */
              "./node_modules/core-js/modules/_defined.js"
            );
            o.exports = function(d) {
              return Object(u(d));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_to-primitive.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/modules/_to-primitive.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            );
            o.exports = function(d, p) {
              if (!u(d))
                return d;
              var g, b;
              if (p && typeof (g = d.toString) == "function" && !u(b = g.call(d)) || typeof (g = d.valueOf) == "function" && !u(b = g.call(d)) || !p && typeof (g = d.toString) == "function" && !u(b = g.call(d)))
                return b;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_uid.js": (
          /*!**********************************************!*\
            !*** ./node_modules/core-js/modules/_uid.js ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            var c = 0, u = Math.random();
            o.exports = function(d) {
              return "Symbol(".concat(d === void 0 ? "" : d, ")_", (++c + u).toString(36));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_wks-define.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/modules/_wks-define.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), d = c(
              /*! ./_core */
              "./node_modules/core-js/modules/_core.js"
            ), p = c(
              /*! ./_library */
              "./node_modules/core-js/modules/_library.js"
            ), g = c(
              /*! ./_wks-ext */
              "./node_modules/core-js/modules/_wks-ext.js"
            ), b = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ).f;
            o.exports = function(x) {
              var w = d.Symbol || (d.Symbol = p ? {} : u.Symbol || {});
              x.charAt(0) != "_" && !(x in w) && b(w, x, { value: g.f(x) });
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/_wks-ext.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/modules/_wks-ext.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            a.f = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            );
          }
        ),
        /***/
        "./node_modules/core-js/modules/_wks.js": (
          /*!**********************************************!*\
            !*** ./node_modules/core-js/modules/_wks.js ***!
            \**********************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_shared */
              "./node_modules/core-js/modules/_shared.js"
            )("wks"), d = c(
              /*! ./_uid */
              "./node_modules/core-js/modules/_uid.js"
            ), p = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ).Symbol, g = typeof p == "function", b = o.exports = function(x) {
              return u[x] || (u[x] = g && p[x] || (g ? p : d)("Symbol." + x));
            };
            b.store = u;
          }
        ),
        /***/
        "./node_modules/core-js/modules/core.get-iterator-method.js": (
          /*!******************************************************************!*\
            !*** ./node_modules/core-js/modules/core.get-iterator-method.js ***!
            \******************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_classof */
              "./node_modules/core-js/modules/_classof.js"
            ), d = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("iterator"), p = c(
              /*! ./_iterators */
              "./node_modules/core-js/modules/_iterators.js"
            );
            o.exports = c(
              /*! ./_core */
              "./node_modules/core-js/modules/_core.js"
            ).getIteratorMethod = function(g) {
              if (g != null)
                return g[d] || g["@@iterator"] || p[u(g)];
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.array.from.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/modules/es6.array.from.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_ctx */
              "./node_modules/core-js/modules/_ctx.js"
            ), d = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), p = c(
              /*! ./_to-object */
              "./node_modules/core-js/modules/_to-object.js"
            ), g = c(
              /*! ./_iter-call */
              "./node_modules/core-js/modules/_iter-call.js"
            ), b = c(
              /*! ./_is-array-iter */
              "./node_modules/core-js/modules/_is-array-iter.js"
            ), x = c(
              /*! ./_to-length */
              "./node_modules/core-js/modules/_to-length.js"
            ), w = c(
              /*! ./_create-property */
              "./node_modules/core-js/modules/_create-property.js"
            ), y = c(
              /*! ./core.get-iterator-method */
              "./node_modules/core-js/modules/core.get-iterator-method.js"
            );
            d(d.S + d.F * !c(
              /*! ./_iter-detect */
              "./node_modules/core-js/modules/_iter-detect.js"
            )(function(I) {
              Array.from(I);
            }), "Array", {
              // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
              from: function(E) {
                var T = p(E), C = typeof this == "function" ? this : Array, $ = arguments.length, D = $ > 1 ? arguments[1] : void 0, L = D !== void 0, R = 0, O = y(T), P, z, W, A;
                if (L && (D = u(D, $ > 2 ? arguments[2] : void 0, 2)), O != null && !(C == Array && b(O)))
                  for (A = O.call(T), z = new C(); !(W = A.next()).done; R++)
                    w(z, R, L ? g(A, D, [W.value, R], !0) : W.value);
                else
                  for (P = x(T.length), z = new C(P); P > R; R++)
                    w(z, R, L ? D(T[R], R) : T[R]);
                return z.length = R, z;
              }
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.array.iterator.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_add-to-unscopables */
              "./node_modules/core-js/modules/_add-to-unscopables.js"
            ), d = c(
              /*! ./_iter-step */
              "./node_modules/core-js/modules/_iter-step.js"
            ), p = c(
              /*! ./_iterators */
              "./node_modules/core-js/modules/_iterators.js"
            ), g = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            );
            o.exports = c(
              /*! ./_iter-define */
              "./node_modules/core-js/modules/_iter-define.js"
            )(Array, "Array", function(b, x) {
              this._t = g(b), this._i = 0, this._k = x;
            }, function() {
              var b = this._t, x = this._k, w = this._i++;
              return !b || w >= b.length ? (this._t = void 0, d(1)) : x == "keys" ? d(0, w) : x == "values" ? d(0, b[w]) : d(0, [w, b[w]]);
            }, "values"), p.Arguments = p.Array, u("keys"), u("values"), u("entries");
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.function.name.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/modules/es6.function.name.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ).f, d = Function.prototype, p = /^\s*function ([^ (]*)/, g = "name";
            g in d || c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ) && u(d, g, {
              configurable: !0,
              get: function() {
                try {
                  return ("" + this).match(p)[1];
                } catch {
                  return "";
                }
              }
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.number.is-finite.js": (
          /*!**************************************************************!*\
            !*** ./node_modules/core-js/modules/es6.number.is-finite.js ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), d = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ).isFinite;
            u(u.S, "Number", {
              isFinite: function(g) {
                return typeof g == "number" && d(g);
              }
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.object.to-string.js": (
          /*!**************************************************************!*\
            !*** ./node_modules/core-js/modules/es6.object.to-string.js ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_classof */
              "./node_modules/core-js/modules/_classof.js"
            ), d = {};
            d[c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            )("toStringTag")] = "z", d + "" != "[object z]" && c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            )(Object.prototype, "toString", function() {
              return "[object " + u(this) + "]";
            }, !0);
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.regexp.exec.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/modules/es6.regexp.exec.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_regexp-exec */
              "./node_modules/core-js/modules/_regexp-exec.js"
            );
            c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            )({
              target: "RegExp",
              proto: !0,
              forced: u !== /./.exec
            }, {
              exec: u
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.regexp.split.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/modules/es6.regexp.split.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_is-regexp */
              "./node_modules/core-js/modules/_is-regexp.js"
            ), d = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), p = c(
              /*! ./_species-constructor */
              "./node_modules/core-js/modules/_species-constructor.js"
            ), g = c(
              /*! ./_advance-string-index */
              "./node_modules/core-js/modules/_advance-string-index.js"
            ), b = c(
              /*! ./_to-length */
              "./node_modules/core-js/modules/_to-length.js"
            ), x = c(
              /*! ./_regexp-exec-abstract */
              "./node_modules/core-js/modules/_regexp-exec-abstract.js"
            ), w = c(
              /*! ./_regexp-exec */
              "./node_modules/core-js/modules/_regexp-exec.js"
            ), y = c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            ), I = Math.min, E = [].push, T = "split", C = "length", $ = "lastIndex", D = 4294967295, L = !y(function() {
            });
            c(
              /*! ./_fix-re-wks */
              "./node_modules/core-js/modules/_fix-re-wks.js"
            )("split", 2, function(R, O, P, z) {
              var W;
              return "abbc"[T](/(b)*/)[1] == "c" || "test"[T](/(?:)/, -1)[C] != 4 || "ab"[T](/(?:ab)*/)[C] != 2 || "."[T](/(.?)(.?)/)[C] != 4 || "."[T](/()()/)[C] > 1 || ""[T](/.?/)[C] ? W = function(A, S) {
                var F = String(this);
                if (A === void 0 && S === 0)
                  return [];
                if (!u(A))
                  return P.call(F, A, S);
                for (var U = [], M = (A.ignoreCase ? "i" : "") + (A.multiline ? "m" : "") + (A.unicode ? "u" : "") + (A.sticky ? "y" : ""), V = 0, G = S === void 0 ? D : S >>> 0, Q = new RegExp(A.source, M + "g"), fe, te, de; (fe = w.call(Q, F)) && (te = Q[$], !(te > V && (U.push(F.slice(V, fe.index)), fe[C] > 1 && fe.index < F[C] && E.apply(U, fe.slice(1)), de = fe[0][C], V = te, U[C] >= G))); )
                  Q[$] === fe.index && Q[$]++;
                return V === F[C] ? (de || !Q.test("")) && U.push("") : U.push(F.slice(V)), U[C] > G ? U.slice(0, G) : U;
              } : "0"[T](void 0, 0)[C] ? W = function(A, S) {
                return A === void 0 && S === 0 ? [] : P.call(this, A, S);
              } : W = P, [
                // `String.prototype.split` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.split
                function(S, F) {
                  var U = R(this), M = S == null ? void 0 : S[O];
                  return M !== void 0 ? M.call(S, U, F) : W.call(String(U), S, F);
                },
                // `RegExp.prototype[@@split]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
                //
                // NOTE: This cannot be properly polyfilled in engines that don't support
                // the 'y' flag.
                function(A, S) {
                  var F = z(W, A, this, S, W !== P);
                  if (F.done)
                    return F.value;
                  var U = d(A), M = String(this), V = p(U, RegExp), G = U.unicode, Q = (U.ignoreCase ? "i" : "") + (U.multiline ? "m" : "") + (U.unicode ? "u" : "") + (L ? "y" : "g"), fe = new V(L ? U : "^(?:" + U.source + ")", Q), te = S === void 0 ? D : S >>> 0;
                  if (te === 0)
                    return [];
                  if (M.length === 0)
                    return x(fe, M) === null ? [M] : [];
                  for (var de = 0, me = 0, Me = []; me < M.length; ) {
                    fe.lastIndex = L ? me : 0;
                    var ce = x(fe, L ? M : M.slice(me)), oe;
                    if (ce === null || (oe = I(b(fe.lastIndex + (L ? 0 : me)), M.length)) === de)
                      me = g(M, me, G);
                    else {
                      if (Me.push(M.slice(de, me)), Me.length === te)
                        return Me;
                      for (var be = 1; be <= ce.length - 1; be++)
                        if (Me.push(ce[be]), Me.length === te)
                          return Me;
                      me = de = oe;
                    }
                  }
                  return Me.push(M.slice(de)), Me;
                }
              ];
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.string.includes.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/modules/es6.string.includes.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), d = c(
              /*! ./_string-context */
              "./node_modules/core-js/modules/_string-context.js"
            ), p = "includes";
            u(u.P + u.F * c(
              /*! ./_fails-is-regexp */
              "./node_modules/core-js/modules/_fails-is-regexp.js"
            )(p), "String", {
              includes: function(b) {
                return !!~d(this, b, p).indexOf(b, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es6.symbol.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/modules/es6.symbol.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), d = c(
              /*! ./_has */
              "./node_modules/core-js/modules/_has.js"
            ), p = c(
              /*! ./_descriptors */
              "./node_modules/core-js/modules/_descriptors.js"
            ), g = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), b = c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            ), x = c(
              /*! ./_meta */
              "./node_modules/core-js/modules/_meta.js"
            ).KEY, w = c(
              /*! ./_fails */
              "./node_modules/core-js/modules/_fails.js"
            ), y = c(
              /*! ./_shared */
              "./node_modules/core-js/modules/_shared.js"
            ), I = c(
              /*! ./_set-to-string-tag */
              "./node_modules/core-js/modules/_set-to-string-tag.js"
            ), E = c(
              /*! ./_uid */
              "./node_modules/core-js/modules/_uid.js"
            ), T = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            ), C = c(
              /*! ./_wks-ext */
              "./node_modules/core-js/modules/_wks-ext.js"
            ), $ = c(
              /*! ./_wks-define */
              "./node_modules/core-js/modules/_wks-define.js"
            ), D = c(
              /*! ./_enum-keys */
              "./node_modules/core-js/modules/_enum-keys.js"
            ), L = c(
              /*! ./_is-array */
              "./node_modules/core-js/modules/_is-array.js"
            ), R = c(
              /*! ./_an-object */
              "./node_modules/core-js/modules/_an-object.js"
            ), O = c(
              /*! ./_is-object */
              "./node_modules/core-js/modules/_is-object.js"
            ), P = c(
              /*! ./_to-object */
              "./node_modules/core-js/modules/_to-object.js"
            ), z = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), W = c(
              /*! ./_to-primitive */
              "./node_modules/core-js/modules/_to-primitive.js"
            ), A = c(
              /*! ./_property-desc */
              "./node_modules/core-js/modules/_property-desc.js"
            ), S = c(
              /*! ./_object-create */
              "./node_modules/core-js/modules/_object-create.js"
            ), F = c(
              /*! ./_object-gopn-ext */
              "./node_modules/core-js/modules/_object-gopn-ext.js"
            ), U = c(
              /*! ./_object-gopd */
              "./node_modules/core-js/modules/_object-gopd.js"
            ), M = c(
              /*! ./_object-gops */
              "./node_modules/core-js/modules/_object-gops.js"
            ), V = c(
              /*! ./_object-dp */
              "./node_modules/core-js/modules/_object-dp.js"
            ), G = c(
              /*! ./_object-keys */
              "./node_modules/core-js/modules/_object-keys.js"
            ), Q = U.f, fe = V.f, te = F.f, de = u.Symbol, me = u.JSON, Me = me && me.stringify, ce = "prototype", oe = T("_hidden"), be = T("toPrimitive"), Te = {}.propertyIsEnumerable, Ae = y("symbol-registry"), je = y("symbols"), Xe = y("op-symbols"), He = Object[ce], Ke = typeof de == "function" && !!M.f, ot = u.QObject, K = !ot || !ot[ce] || !ot[ce].findChild, q = p && w(function() {
              return S(fe({}, "a", {
                get: function() {
                  return fe(this, "a", { value: 7 }).a;
                }
              })).a != 7;
            }) ? function($e, Ee, Ie) {
              var ze = Q(He, Ee);
              ze && delete He[Ee], fe($e, Ee, Ie), ze && $e !== He && fe(He, Ee, ze);
            } : fe, se = function($e) {
              var Ee = je[$e] = S(de[ce]);
              return Ee._k = $e, Ee;
            }, Ce = Ke && typeof de.iterator == "symbol" ? function($e) {
              return typeof $e == "symbol";
            } : function($e) {
              return $e instanceof de;
            }, Le = function(Ee, Ie, ze) {
              return Ee === He && Le(Xe, Ie, ze), R(Ee), Ie = W(Ie, !0), R(ze), d(je, Ie) ? (ze.enumerable ? (d(Ee, oe) && Ee[oe][Ie] && (Ee[oe][Ie] = !1), ze = S(ze, { enumerable: A(0, !1) })) : (d(Ee, oe) || fe(Ee, oe, A(1, {})), Ee[oe][Ie] = !0), q(Ee, Ie, ze)) : fe(Ee, Ie, ze);
            }, qe = function(Ee, Ie) {
              R(Ee);
              for (var ze = D(Ie = z(Ie)), ct = 0, st = ze.length, ht; st > ct; )
                Le(Ee, ht = ze[ct++], Ie[ht]);
              return Ee;
            }, Ct = function(Ee, Ie) {
              return Ie === void 0 ? S(Ee) : qe(S(Ee), Ie);
            }, ke = function(Ee) {
              var Ie = Te.call(this, Ee = W(Ee, !0));
              return this === He && d(je, Ee) && !d(Xe, Ee) ? !1 : Ie || !d(this, Ee) || !d(je, Ee) || d(this, oe) && this[oe][Ee] ? Ie : !0;
            }, xe = function(Ee, Ie) {
              if (Ee = z(Ee), Ie = W(Ie, !0), !(Ee === He && d(je, Ie) && !d(Xe, Ie))) {
                var ze = Q(Ee, Ie);
                return ze && d(je, Ie) && !(d(Ee, oe) && Ee[oe][Ie]) && (ze.enumerable = !0), ze;
              }
            }, Ne = function(Ee) {
              for (var Ie = te(z(Ee)), ze = [], ct = 0, st; Ie.length > ct; )
                !d(je, st = Ie[ct++]) && st != oe && st != x && ze.push(st);
              return ze;
            }, Se = function(Ee) {
              for (var Ie = Ee === He, ze = te(Ie ? Xe : z(Ee)), ct = [], st = 0, ht; ze.length > st; )
                d(je, ht = ze[st++]) && (!Ie || d(He, ht)) && ct.push(je[ht]);
              return ct;
            };
            Ke || (de = function() {
              if (this instanceof de)
                throw TypeError("Symbol is not a constructor!");
              var Ee = E(arguments.length > 0 ? arguments[0] : void 0), Ie = function(ze) {
                this === He && Ie.call(Xe, ze), d(this, oe) && d(this[oe], Ee) && (this[oe][Ee] = !1), q(this, Ee, A(1, ze));
              };
              return p && K && q(He, Ee, { configurable: !0, set: Ie }), se(Ee);
            }, b(de[ce], "toString", function() {
              return this._k;
            }), U.f = xe, V.f = Le, c(
              /*! ./_object-gopn */
              "./node_modules/core-js/modules/_object-gopn.js"
            ).f = F.f = Ne, c(
              /*! ./_object-pie */
              "./node_modules/core-js/modules/_object-pie.js"
            ).f = ke, M.f = Se, p && !c(
              /*! ./_library */
              "./node_modules/core-js/modules/_library.js"
            ) && b(He, "propertyIsEnumerable", ke, !0), C.f = function($e) {
              return se(T($e));
            }), g(g.G + g.W + g.F * !Ke, { Symbol: de });
            for (var ie = (
              // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
              "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
            ), he = 0; ie.length > he; )
              T(ie[he++]);
            for (var Ye = G(T.store), et = 0; Ye.length > et; )
              $(Ye[et++]);
            g(g.S + g.F * !Ke, "Symbol", {
              // 19.4.2.1 Symbol.for(key)
              for: function($e) {
                return d(Ae, $e += "") ? Ae[$e] : Ae[$e] = de($e);
              },
              // 19.4.2.5 Symbol.keyFor(sym)
              keyFor: function(Ee) {
                if (!Ce(Ee))
                  throw TypeError(Ee + " is not a symbol!");
                for (var Ie in Ae)
                  if (Ae[Ie] === Ee)
                    return Ie;
              },
              useSetter: function() {
                K = !0;
              },
              useSimple: function() {
                K = !1;
              }
            }), g(g.S + g.F * !Ke, "Object", {
              // 19.1.2.2 Object.create(O [, Properties])
              create: Ct,
              // 19.1.2.4 Object.defineProperty(O, P, Attributes)
              defineProperty: Le,
              // 19.1.2.3 Object.defineProperties(O, Properties)
              defineProperties: qe,
              // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
              getOwnPropertyDescriptor: xe,
              // 19.1.2.7 Object.getOwnPropertyNames(O)
              getOwnPropertyNames: Ne,
              // 19.1.2.8 Object.getOwnPropertySymbols(O)
              getOwnPropertySymbols: Se
            });
            var bt = w(function() {
              M.f(1);
            });
            g(g.S + g.F * bt, "Object", {
              getOwnPropertySymbols: function(Ee) {
                return M.f(P(Ee));
              }
            }), me && g(g.S + g.F * (!Ke || w(function() {
              var $e = de();
              return Me([$e]) != "[null]" || Me({ a: $e }) != "{}" || Me(Object($e)) != "{}";
            })), "JSON", {
              stringify: function(Ee) {
                for (var Ie = [Ee], ze = 1, ct, st; arguments.length > ze; )
                  Ie.push(arguments[ze++]);
                if (st = ct = Ie[1], !(!O(ct) && Ee === void 0 || Ce(Ee)))
                  return L(ct) || (ct = function(ht, Rt) {
                    if (typeof st == "function" && (Rt = st.call(this, ht, Rt)), !Ce(Rt))
                      return Rt;
                  }), Ie[1] = ct, Me.apply(me, Ie);
              }
            }), de[ce][be] || c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            )(de[ce], be, de[ce].valueOf), I(de, "Symbol"), I(Math, "Math", !0), I(u.JSON, "JSON", !0);
          }
        ),
        /***/
        "./node_modules/core-js/modules/es7.array.includes.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/es7.array.includes.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), d = c(
              /*! ./_array-includes */
              "./node_modules/core-js/modules/_array-includes.js"
            )(!0);
            u(u.P, "Array", {
              includes: function(g) {
                return d(this, g, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), c(
              /*! ./_add-to-unscopables */
              "./node_modules/core-js/modules/_add-to-unscopables.js"
            )("includes");
          }
        ),
        /***/
        "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js": (
          /*!*********************************************************************************!*\
            !*** ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js ***!
            \*********************************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = c(
              /*! ./_export */
              "./node_modules/core-js/modules/_export.js"
            ), d = c(
              /*! ./_own-keys */
              "./node_modules/core-js/modules/_own-keys.js"
            ), p = c(
              /*! ./_to-iobject */
              "./node_modules/core-js/modules/_to-iobject.js"
            ), g = c(
              /*! ./_object-gopd */
              "./node_modules/core-js/modules/_object-gopd.js"
            ), b = c(
              /*! ./_create-property */
              "./node_modules/core-js/modules/_create-property.js"
            );
            u(u.S, "Object", {
              getOwnPropertyDescriptors: function(w) {
                for (var y = p(w), I = g.f, E = d(y), T = {}, C = 0, $, D; E.length > C; )
                  D = I(y, $ = E[C++]), D !== void 0 && b(T, $, D);
                return T;
              }
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            c(
              /*! ./_wks-define */
              "./node_modules/core-js/modules/_wks-define.js"
            )("asyncIterator");
          }
        ),
        /***/
        "./node_modules/core-js/modules/web.dom.iterable.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/modules/web.dom.iterable.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            for (var u = c(
              /*! ./es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), d = c(
              /*! ./_object-keys */
              "./node_modules/core-js/modules/_object-keys.js"
            ), p = c(
              /*! ./_redefine */
              "./node_modules/core-js/modules/_redefine.js"
            ), g = c(
              /*! ./_global */
              "./node_modules/core-js/modules/_global.js"
            ), b = c(
              /*! ./_hide */
              "./node_modules/core-js/modules/_hide.js"
            ), x = c(
              /*! ./_iterators */
              "./node_modules/core-js/modules/_iterators.js"
            ), w = c(
              /*! ./_wks */
              "./node_modules/core-js/modules/_wks.js"
            ), y = w("iterator"), I = w("toStringTag"), E = x.Array, T = {
              CSSRuleList: !0,
              // TODO: Not spec compliant, should be false.
              CSSStyleDeclaration: !1,
              CSSValueList: !1,
              ClientRectList: !1,
              DOMRectList: !1,
              DOMStringList: !1,
              DOMTokenList: !0,
              DataTransferItemList: !1,
              FileList: !1,
              HTMLAllCollection: !1,
              HTMLCollection: !1,
              HTMLFormElement: !1,
              HTMLSelectElement: !1,
              MediaList: !0,
              // TODO: Not spec compliant, should be false.
              MimeTypeArray: !1,
              NamedNodeMap: !1,
              NodeList: !0,
              PaintRequestList: !1,
              Plugin: !1,
              PluginArray: !1,
              SVGLengthList: !1,
              SVGNumberList: !1,
              SVGPathSegList: !1,
              SVGPointList: !1,
              SVGStringList: !1,
              SVGTransformList: !1,
              SourceBufferList: !1,
              StyleSheetList: !0,
              // TODO: Not spec compliant, should be false.
              TextTrackCueList: !1,
              TextTrackList: !1,
              TouchList: !1
            }, C = d(T), $ = 0; $ < C.length; $++) {
              var D = C[$], L = T[D], R = g[D], O = R && R.prototype, P;
              if (O && (O[y] || b(O, y, E), O[I] || b(O, I, D), x[D] = E, L))
                for (P in u)
                  O[P] || p(O, P, u[P], !0);
            }
          }
        ),
        /***/
        "./node_modules/crypt/crypt.js": (
          /*!*************************************!*\
            !*** ./node_modules/crypt/crypt.js ***!
            \*************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            (function() {
              var c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u = {
                // Bit-wise rotation left
                rotl: function(d, p) {
                  return d << p | d >>> 32 - p;
                },
                // Bit-wise rotation right
                rotr: function(d, p) {
                  return d << 32 - p | d >>> p;
                },
                // Swap big-endian to little-endian and vice versa
                endian: function(d) {
                  if (d.constructor == Number)
                    return u.rotl(d, 8) & 16711935 | u.rotl(d, 24) & 4278255360;
                  for (var p = 0; p < d.length; p++)
                    d[p] = u.endian(d[p]);
                  return d;
                },
                // Generate an array of any length of random bytes
                randomBytes: function(d) {
                  for (var p = []; d > 0; d--)
                    p.push(Math.floor(Math.random() * 256));
                  return p;
                },
                // Convert a byte array to big-endian 32-bit words
                bytesToWords: function(d) {
                  for (var p = [], g = 0, b = 0; g < d.length; g++, b += 8)
                    p[b >>> 5] |= d[g] << 24 - b % 32;
                  return p;
                },
                // Convert big-endian 32-bit words to a byte array
                wordsToBytes: function(d) {
                  for (var p = [], g = 0; g < d.length * 32; g += 8)
                    p.push(d[g >>> 5] >>> 24 - g % 32 & 255);
                  return p;
                },
                // Convert a byte array to a hex string
                bytesToHex: function(d) {
                  for (var p = [], g = 0; g < d.length; g++)
                    p.push((d[g] >>> 4).toString(16)), p.push((d[g] & 15).toString(16));
                  return p.join("");
                },
                // Convert a hex string to a byte array
                hexToBytes: function(d) {
                  for (var p = [], g = 0; g < d.length; g += 2)
                    p.push(parseInt(d.substr(g, 2), 16));
                  return p;
                },
                // Convert a byte array to a base-64 string
                bytesToBase64: function(d) {
                  for (var p = [], g = 0; g < d.length; g += 3)
                    for (var b = d[g] << 16 | d[g + 1] << 8 | d[g + 2], x = 0; x < 4; x++)
                      g * 8 + x * 6 <= d.length * 8 ? p.push(c.charAt(b >>> 6 * (3 - x) & 63)) : p.push("=");
                  return p.join("");
                },
                // Convert a base-64 string to a byte array
                base64ToBytes: function(d) {
                  d = d.replace(/[^A-Z0-9+\/]/ig, "");
                  for (var p = [], g = 0, b = 0; g < d.length; b = ++g % 4)
                    b != 0 && p.push((c.indexOf(d.charAt(g - 1)) & Math.pow(2, -2 * b + 8) - 1) << b * 2 | c.indexOf(d.charAt(g)) >>> 6 - b * 2);
                  return p;
                }
              };
              o.exports = u;
            })();
          }
        ),
        /***/
        "./node_modules/is-buffer/index.js": (
          /*!*****************************************!*\
            !*** ./node_modules/is-buffer/index.js ***!
            \*****************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            /*!
             * Determine if an object is a Buffer
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
            o.exports = function(d) {
              return d != null && (c(d) || u(d) || !!d._isBuffer);
            };
            function c(d) {
              return !!d.constructor && typeof d.constructor.isBuffer == "function" && d.constructor.isBuffer(d);
            }
            function u(d) {
              return typeof d.readFloatLE == "function" && typeof d.slice == "function" && c(d.slice(0, 0));
            }
          }
        ),
        /***/
        "./node_modules/md5/md5.js": (
          /*!*********************************!*\
            !*** ./node_modules/md5/md5.js ***!
            \*********************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            (function() {
              var u = c(
                /*! crypt */
                "./node_modules/crypt/crypt.js"
              ), d = c(
                /*! charenc */
                "./node_modules/charenc/charenc.js"
              ).utf8, p = c(
                /*! is-buffer */
                "./node_modules/is-buffer/index.js"
              ), g = c(
                /*! charenc */
                "./node_modules/charenc/charenc.js"
              ).bin, b = function(x, w) {
                x.constructor == String ? w && w.encoding === "binary" ? x = g.stringToBytes(x) : x = d.stringToBytes(x) : p(x) ? x = Array.prototype.slice.call(x, 0) : !Array.isArray(x) && x.constructor !== Uint8Array && (x = x.toString());
                for (var y = u.bytesToWords(x), I = x.length * 8, E = 1732584193, T = -271733879, C = -1732584194, $ = 271733878, D = 0; D < y.length; D++)
                  y[D] = (y[D] << 8 | y[D] >>> 24) & 16711935 | (y[D] << 24 | y[D] >>> 8) & 4278255360;
                y[I >>> 5] |= 128 << I % 32, y[(I + 64 >>> 9 << 4) + 14] = I;
                for (var L = b._ff, R = b._gg, O = b._hh, P = b._ii, D = 0; D < y.length; D += 16) {
                  var z = E, W = T, A = C, S = $;
                  E = L(E, T, C, $, y[D + 0], 7, -680876936), $ = L($, E, T, C, y[D + 1], 12, -389564586), C = L(C, $, E, T, y[D + 2], 17, 606105819), T = L(T, C, $, E, y[D + 3], 22, -1044525330), E = L(E, T, C, $, y[D + 4], 7, -176418897), $ = L($, E, T, C, y[D + 5], 12, 1200080426), C = L(C, $, E, T, y[D + 6], 17, -1473231341), T = L(T, C, $, E, y[D + 7], 22, -45705983), E = L(E, T, C, $, y[D + 8], 7, 1770035416), $ = L($, E, T, C, y[D + 9], 12, -1958414417), C = L(C, $, E, T, y[D + 10], 17, -42063), T = L(T, C, $, E, y[D + 11], 22, -1990404162), E = L(E, T, C, $, y[D + 12], 7, 1804603682), $ = L($, E, T, C, y[D + 13], 12, -40341101), C = L(C, $, E, T, y[D + 14], 17, -1502002290), T = L(T, C, $, E, y[D + 15], 22, 1236535329), E = R(E, T, C, $, y[D + 1], 5, -165796510), $ = R($, E, T, C, y[D + 6], 9, -1069501632), C = R(C, $, E, T, y[D + 11], 14, 643717713), T = R(T, C, $, E, y[D + 0], 20, -373897302), E = R(E, T, C, $, y[D + 5], 5, -701558691), $ = R($, E, T, C, y[D + 10], 9, 38016083), C = R(C, $, E, T, y[D + 15], 14, -660478335), T = R(T, C, $, E, y[D + 4], 20, -405537848), E = R(E, T, C, $, y[D + 9], 5, 568446438), $ = R($, E, T, C, y[D + 14], 9, -1019803690), C = R(C, $, E, T, y[D + 3], 14, -187363961), T = R(T, C, $, E, y[D + 8], 20, 1163531501), E = R(E, T, C, $, y[D + 13], 5, -1444681467), $ = R($, E, T, C, y[D + 2], 9, -51403784), C = R(C, $, E, T, y[D + 7], 14, 1735328473), T = R(T, C, $, E, y[D + 12], 20, -1926607734), E = O(E, T, C, $, y[D + 5], 4, -378558), $ = O($, E, T, C, y[D + 8], 11, -2022574463), C = O(C, $, E, T, y[D + 11], 16, 1839030562), T = O(T, C, $, E, y[D + 14], 23, -35309556), E = O(E, T, C, $, y[D + 1], 4, -1530992060), $ = O($, E, T, C, y[D + 4], 11, 1272893353), C = O(C, $, E, T, y[D + 7], 16, -155497632), T = O(T, C, $, E, y[D + 10], 23, -1094730640), E = O(E, T, C, $, y[D + 13], 4, 681279174), $ = O($, E, T, C, y[D + 0], 11, -358537222), C = O(C, $, E, T, y[D + 3], 16, -722521979), T = O(T, C, $, E, y[D + 6], 23, 76029189), E = O(E, T, C, $, y[D + 9], 4, -640364487), $ = O($, E, T, C, y[D + 12], 11, -421815835), C = O(C, $, E, T, y[D + 15], 16, 530742520), T = O(T, C, $, E, y[D + 2], 23, -995338651), E = P(E, T, C, $, y[D + 0], 6, -198630844), $ = P($, E, T, C, y[D + 7], 10, 1126891415), C = P(C, $, E, T, y[D + 14], 15, -1416354905), T = P(T, C, $, E, y[D + 5], 21, -57434055), E = P(E, T, C, $, y[D + 12], 6, 1700485571), $ = P($, E, T, C, y[D + 3], 10, -1894986606), C = P(C, $, E, T, y[D + 10], 15, -1051523), T = P(T, C, $, E, y[D + 1], 21, -2054922799), E = P(E, T, C, $, y[D + 8], 6, 1873313359), $ = P($, E, T, C, y[D + 15], 10, -30611744), C = P(C, $, E, T, y[D + 6], 15, -1560198380), T = P(T, C, $, E, y[D + 13], 21, 1309151649), E = P(E, T, C, $, y[D + 4], 6, -145523070), $ = P($, E, T, C, y[D + 11], 10, -1120210379), C = P(C, $, E, T, y[D + 2], 15, 718787259), T = P(T, C, $, E, y[D + 9], 21, -343485551), E = E + z >>> 0, T = T + W >>> 0, C = C + A >>> 0, $ = $ + S >>> 0;
                }
                return u.endian([E, T, C, $]);
              };
              b._ff = function(x, w, y, I, E, T, C) {
                var $ = x + (w & y | ~w & I) + (E >>> 0) + C;
                return ($ << T | $ >>> 32 - T) + w;
              }, b._gg = function(x, w, y, I, E, T, C) {
                var $ = x + (w & I | y & ~I) + (E >>> 0) + C;
                return ($ << T | $ >>> 32 - T) + w;
              }, b._hh = function(x, w, y, I, E, T, C) {
                var $ = x + (w ^ y ^ I) + (E >>> 0) + C;
                return ($ << T | $ >>> 32 - T) + w;
              }, b._ii = function(x, w, y, I, E, T, C) {
                var $ = x + (y ^ (w | ~I)) + (E >>> 0) + C;
                return ($ << T | $ >>> 32 - T) + w;
              }, b._blocksize = 16, b._digestsize = 16, o.exports = function(x, w) {
                if (x == null)
                  throw new Error("Illegal argument " + x);
                var y = u.wordsToBytes(b(x, w));
                return w && w.asBytes ? y : w && w.asString ? g.bytesToString(y) : u.bytesToHex(y);
              };
            })();
          }
        ),
        /***/
        "./node_modules/regenerator-runtime/runtime.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/regenerator-runtime/runtime.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(o, a, c) {
            var u = function(d) {
              var p = Object.prototype, g = p.hasOwnProperty, b, x = typeof Symbol == "function" ? Symbol : {}, w = x.iterator || "@@iterator", y = x.asyncIterator || "@@asyncIterator", I = x.toStringTag || "@@toStringTag";
              function E(ce, oe, be) {
                return Object.defineProperty(ce, oe, {
                  value: be,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }), ce[oe];
              }
              try {
                E({}, "");
              } catch {
                E = function(oe, be, Te) {
                  return oe[be] = Te;
                };
              }
              function T(ce, oe, be, Te) {
                var Ae = oe && oe.prototype instanceof P ? oe : P, je = Object.create(Ae.prototype), Xe = new de(Te || []);
                return je._invoke = G(ce, be, Xe), je;
              }
              d.wrap = T;
              function C(ce, oe, be) {
                try {
                  return { type: "normal", arg: ce.call(oe, be) };
                } catch (Te) {
                  return { type: "throw", arg: Te };
                }
              }
              var $ = "suspendedStart", D = "suspendedYield", L = "executing", R = "completed", O = {};
              function P() {
              }
              function z() {
              }
              function W() {
              }
              var A = {};
              A[w] = function() {
                return this;
              };
              var S = Object.getPrototypeOf, F = S && S(S(me([])));
              F && F !== p && g.call(F, w) && (A = F);
              var U = W.prototype = P.prototype = Object.create(A);
              z.prototype = U.constructor = W, W.constructor = z, z.displayName = E(
                W,
                I,
                "GeneratorFunction"
              );
              function M(ce) {
                ["next", "throw", "return"].forEach(function(oe) {
                  E(ce, oe, function(be) {
                    return this._invoke(oe, be);
                  });
                });
              }
              d.isGeneratorFunction = function(ce) {
                var oe = typeof ce == "function" && ce.constructor;
                return oe ? oe === z || // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (oe.displayName || oe.name) === "GeneratorFunction" : !1;
              }, d.mark = function(ce) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(ce, W) : (ce.__proto__ = W, E(ce, I, "GeneratorFunction")), ce.prototype = Object.create(U), ce;
              }, d.awrap = function(ce) {
                return { __await: ce };
              };
              function V(ce, oe) {
                function be(je, Xe, He, Ke) {
                  var ot = C(ce[je], ce, Xe);
                  if (ot.type === "throw")
                    Ke(ot.arg);
                  else {
                    var K = ot.arg, q = K.value;
                    return q && typeof q == "object" && g.call(q, "__await") ? oe.resolve(q.__await).then(function(se) {
                      be("next", se, He, Ke);
                    }, function(se) {
                      be("throw", se, He, Ke);
                    }) : oe.resolve(q).then(function(se) {
                      K.value = se, He(K);
                    }, function(se) {
                      return be("throw", se, He, Ke);
                    });
                  }
                }
                var Te;
                function Ae(je, Xe) {
                  function He() {
                    return new oe(function(Ke, ot) {
                      be(je, Xe, Ke, ot);
                    });
                  }
                  return Te = // If enqueue has been called before, then we want to wait until
                  // all previous Promises have been resolved before calling invoke,
                  // so that results are always delivered in the correct order. If
                  // enqueue has not been called before, then it is important to
                  // call invoke immediately, without waiting on a callback to fire,
                  // so that the async generator function has the opportunity to do
                  // any necessary setup in a predictable way. This predictability
                  // is why the Promise constructor synchronously invokes its
                  // executor callback, and why async functions synchronously
                  // execute code before the first await. Since we implement simple
                  // async functions in terms of async generators, it is especially
                  // important to get this right, even though it requires care.
                  Te ? Te.then(
                    He,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    He
                  ) : He();
                }
                this._invoke = Ae;
              }
              M(V.prototype), V.prototype[y] = function() {
                return this;
              }, d.AsyncIterator = V, d.async = function(ce, oe, be, Te, Ae) {
                Ae === void 0 && (Ae = Promise);
                var je = new V(
                  T(ce, oe, be, Te),
                  Ae
                );
                return d.isGeneratorFunction(oe) ? je : je.next().then(function(Xe) {
                  return Xe.done ? Xe.value : je.next();
                });
              };
              function G(ce, oe, be) {
                var Te = $;
                return function(je, Xe) {
                  if (Te === L)
                    throw new Error("Generator is already running");
                  if (Te === R) {
                    if (je === "throw")
                      throw Xe;
                    return Me();
                  }
                  for (be.method = je, be.arg = Xe; ; ) {
                    var He = be.delegate;
                    if (He) {
                      var Ke = Q(He, be);
                      if (Ke) {
                        if (Ke === O)
                          continue;
                        return Ke;
                      }
                    }
                    if (be.method === "next")
                      be.sent = be._sent = be.arg;
                    else if (be.method === "throw") {
                      if (Te === $)
                        throw Te = R, be.arg;
                      be.dispatchException(be.arg);
                    } else
                      be.method === "return" && be.abrupt("return", be.arg);
                    Te = L;
                    var ot = C(ce, oe, be);
                    if (ot.type === "normal") {
                      if (Te = be.done ? R : D, ot.arg === O)
                        continue;
                      return {
                        value: ot.arg,
                        done: be.done
                      };
                    } else
                      ot.type === "throw" && (Te = R, be.method = "throw", be.arg = ot.arg);
                  }
                };
              }
              function Q(ce, oe) {
                var be = ce.iterator[oe.method];
                if (be === b) {
                  if (oe.delegate = null, oe.method === "throw") {
                    if (ce.iterator.return && (oe.method = "return", oe.arg = b, Q(ce, oe), oe.method === "throw"))
                      return O;
                    oe.method = "throw", oe.arg = new TypeError(
                      "The iterator does not provide a 'throw' method"
                    );
                  }
                  return O;
                }
                var Te = C(be, ce.iterator, oe.arg);
                if (Te.type === "throw")
                  return oe.method = "throw", oe.arg = Te.arg, oe.delegate = null, O;
                var Ae = Te.arg;
                if (!Ae)
                  return oe.method = "throw", oe.arg = new TypeError("iterator result is not an object"), oe.delegate = null, O;
                if (Ae.done)
                  oe[ce.resultName] = Ae.value, oe.next = ce.nextLoc, oe.method !== "return" && (oe.method = "next", oe.arg = b);
                else
                  return Ae;
                return oe.delegate = null, O;
              }
              M(U), E(U, I, "Generator"), U[w] = function() {
                return this;
              }, U.toString = function() {
                return "[object Generator]";
              };
              function fe(ce) {
                var oe = { tryLoc: ce[0] };
                1 in ce && (oe.catchLoc = ce[1]), 2 in ce && (oe.finallyLoc = ce[2], oe.afterLoc = ce[3]), this.tryEntries.push(oe);
              }
              function te(ce) {
                var oe = ce.completion || {};
                oe.type = "normal", delete oe.arg, ce.completion = oe;
              }
              function de(ce) {
                this.tryEntries = [{ tryLoc: "root" }], ce.forEach(fe, this), this.reset(!0);
              }
              d.keys = function(ce) {
                var oe = [];
                for (var be in ce)
                  oe.push(be);
                return oe.reverse(), function Te() {
                  for (; oe.length; ) {
                    var Ae = oe.pop();
                    if (Ae in ce)
                      return Te.value = Ae, Te.done = !1, Te;
                  }
                  return Te.done = !0, Te;
                };
              };
              function me(ce) {
                if (ce) {
                  var oe = ce[w];
                  if (oe)
                    return oe.call(ce);
                  if (typeof ce.next == "function")
                    return ce;
                  if (!isNaN(ce.length)) {
                    var be = -1, Te = function Ae() {
                      for (; ++be < ce.length; )
                        if (g.call(ce, be))
                          return Ae.value = ce[be], Ae.done = !1, Ae;
                      return Ae.value = b, Ae.done = !0, Ae;
                    };
                    return Te.next = Te;
                  }
                }
                return { next: Me };
              }
              d.values = me;
              function Me() {
                return { value: b, done: !0 };
              }
              return de.prototype = {
                constructor: de,
                reset: function(ce) {
                  if (this.prev = 0, this.next = 0, this.sent = this._sent = b, this.done = !1, this.delegate = null, this.method = "next", this.arg = b, this.tryEntries.forEach(te), !ce)
                    for (var oe in this)
                      oe.charAt(0) === "t" && g.call(this, oe) && !isNaN(+oe.slice(1)) && (this[oe] = b);
                },
                stop: function() {
                  this.done = !0;
                  var ce = this.tryEntries[0], oe = ce.completion;
                  if (oe.type === "throw")
                    throw oe.arg;
                  return this.rval;
                },
                dispatchException: function(ce) {
                  if (this.done)
                    throw ce;
                  var oe = this;
                  function be(Ke, ot) {
                    return je.type = "throw", je.arg = ce, oe.next = Ke, ot && (oe.method = "next", oe.arg = b), !!ot;
                  }
                  for (var Te = this.tryEntries.length - 1; Te >= 0; --Te) {
                    var Ae = this.tryEntries[Te], je = Ae.completion;
                    if (Ae.tryLoc === "root")
                      return be("end");
                    if (Ae.tryLoc <= this.prev) {
                      var Xe = g.call(Ae, "catchLoc"), He = g.call(Ae, "finallyLoc");
                      if (Xe && He) {
                        if (this.prev < Ae.catchLoc)
                          return be(Ae.catchLoc, !0);
                        if (this.prev < Ae.finallyLoc)
                          return be(Ae.finallyLoc);
                      } else if (Xe) {
                        if (this.prev < Ae.catchLoc)
                          return be(Ae.catchLoc, !0);
                      } else if (He) {
                        if (this.prev < Ae.finallyLoc)
                          return be(Ae.finallyLoc);
                      } else
                        throw new Error("try statement without catch or finally");
                    }
                  }
                },
                abrupt: function(ce, oe) {
                  for (var be = this.tryEntries.length - 1; be >= 0; --be) {
                    var Te = this.tryEntries[be];
                    if (Te.tryLoc <= this.prev && g.call(Te, "finallyLoc") && this.prev < Te.finallyLoc) {
                      var Ae = Te;
                      break;
                    }
                  }
                  Ae && (ce === "break" || ce === "continue") && Ae.tryLoc <= oe && oe <= Ae.finallyLoc && (Ae = null);
                  var je = Ae ? Ae.completion : {};
                  return je.type = ce, je.arg = oe, Ae ? (this.method = "next", this.next = Ae.finallyLoc, O) : this.complete(je);
                },
                complete: function(ce, oe) {
                  if (ce.type === "throw")
                    throw ce.arg;
                  return ce.type === "break" || ce.type === "continue" ? this.next = ce.arg : ce.type === "return" ? (this.rval = this.arg = ce.arg, this.method = "return", this.next = "end") : ce.type === "normal" && oe && (this.next = oe), O;
                },
                finish: function(ce) {
                  for (var oe = this.tryEntries.length - 1; oe >= 0; --oe) {
                    var be = this.tryEntries[oe];
                    if (be.finallyLoc === ce)
                      return this.complete(be.completion, be.afterLoc), te(be), O;
                  }
                },
                catch: function(ce) {
                  for (var oe = this.tryEntries.length - 1; oe >= 0; --oe) {
                    var be = this.tryEntries[oe];
                    if (be.tryLoc === ce) {
                      var Te = be.completion;
                      if (Te.type === "throw") {
                        var Ae = Te.arg;
                        te(be);
                      }
                      return Ae;
                    }
                  }
                  throw new Error("illegal catch attempt");
                },
                delegateYield: function(ce, oe, be) {
                  return this.delegate = {
                    iterator: me(ce),
                    resultName: oe,
                    nextLoc: be
                  }, this.method === "next" && (this.arg = b), O;
                }
              }, d;
            }(
              // If this script is executing as a CommonJS module, use module.exports
              // as the regeneratorRuntime namespace. Otherwise create a new empty
              // object. Either way, the resulting object will be used to initialize
              // the regeneratorRuntime variable at the top of this file.
              o.exports
            );
            try {
              regeneratorRuntime = u;
            } catch {
              Function("r", "regeneratorRuntime = r")(u);
            }
          }
        ),
        /***/
        "./src/api.js": (
          /*!********************!*\
            !*** ./src/api.js ***!
            \********************/
          /*! exports provided: setup, setupCache, serializeQuery, default */
          /***/
          function(o, a, c) {
            c.r(a), c.d(a, "setup", function() {
              return L;
            }), c.d(a, "setupCache", function() {
              return D;
            }), c(
              /*! core-js/modules/es7.object.get-own-property-descriptors */
              "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js"
            ), c(
              /*! core-js/modules/es6.symbol */
              "./node_modules/core-js/modules/es6.symbol.js"
            ), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            ), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            );
            var u = c(
              /*! axios */
              "axios"
            ), d = /* @__PURE__ */ c.n(u), p = c(
              /*! ./request */
              "./src/request.js"
            ), g = c(
              /*! ./cache */
              "./src/cache.js"
            );
            c.d(a, "serializeQuery", function() {
              return g.serializeQuery;
            });
            var b = c(
              /*! ./config */
              "./src/config.js"
            ), x = c(
              /*! ./utilities */
              "./src/utilities.js"
            );
            function w(R, O) {
              if (R == null)
                return {};
              var P = y(R, O), z, W;
              if (Object.getOwnPropertySymbols) {
                var A = Object.getOwnPropertySymbols(R);
                for (W = 0; W < A.length; W++)
                  z = A[W], !(O.indexOf(z) >= 0) && Object.prototype.propertyIsEnumerable.call(R, z) && (P[z] = R[z]);
              }
              return P;
            }
            function y(R, O) {
              if (R == null)
                return {};
              var P = {}, z = Object.keys(R), W, A;
              for (A = 0; A < z.length; A++)
                W = z[A], !(O.indexOf(W) >= 0) && (P[W] = R[W]);
              return P;
            }
            function I(R, O) {
              var P = Object.keys(R);
              if (Object.getOwnPropertySymbols) {
                var z = Object.getOwnPropertySymbols(R);
                O && (z = z.filter(function(W) {
                  return Object.getOwnPropertyDescriptor(R, W).enumerable;
                })), P.push.apply(P, z);
              }
              return P;
            }
            function E(R) {
              for (var O = 1; O < arguments.length; O++) {
                var P = arguments[O] != null ? arguments[O] : {};
                O % 2 ? I(Object(P), !0).forEach(function(z) {
                  T(R, z, P[z]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(P)) : I(Object(P)).forEach(function(z) {
                  Object.defineProperty(R, z, Object.getOwnPropertyDescriptor(P, z));
                });
              }
              return R;
            }
            function T(R, O, P) {
              return O in R ? Object.defineProperty(R, O, { value: P, enumerable: !0, configurable: !0, writable: !0 }) : R[O] = P, R;
            }
            function C(R, O, P, z, W, A, S) {
              try {
                var F = R[A](S), U = F.value;
              } catch (M) {
                P(M);
                return;
              }
              F.done ? O(U) : Promise.resolve(U).then(z, W);
            }
            function $(R) {
              return function() {
                var O = this, P = arguments;
                return new Promise(function(z, W) {
                  var A = R.apply(O, P);
                  function S(U) {
                    C(A, z, W, S, F, "next", U);
                  }
                  function F(U) {
                    C(A, z, W, S, F, "throw", U);
                  }
                  S(void 0);
                });
              };
            }
            function D() {
              var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              R = Object(b.makeConfig)(R);
              function O(z) {
                return P.apply(this, arguments);
              }
              function P() {
                return P = $(/* @__PURE__ */ regeneratorRuntime.mark(function z(W) {
                  var A, S, F, U, M;
                  return regeneratorRuntime.wrap(function(G) {
                    for (; ; )
                      switch (G.prev = G.next) {
                        case 0:
                          return A = Object(b.mergeRequestConfig)(R, W), G.next = 3, Object(p.default)(A, W);
                        case 3:
                          if (S = G.sent, F = S.next, Object(x.isFunction)(F)) {
                            G.next = 7;
                            break;
                          }
                          return G.abrupt("return", F);
                        case 7:
                          return G.prev = 7, G.next = 10, A.adapter(W);
                        case 10:
                          S = G.sent, G.next = 16;
                          break;
                        case 13:
                          G.prev = 13, G.t0 = G.catch(7), U = G.t0;
                        case 16:
                          if (!U) {
                            G.next = 31;
                            break;
                          }
                          if (M = Object(x.isFunction)(A.readOnError) ? A.readOnError(U, W) : A.readOnError, !M) {
                            G.next = 30;
                            break;
                          }
                          return G.prev = 19, A.acceptStale = !0, G.next = 23, Object(p.default)(A, W);
                        case 23:
                          return S = G.sent, S.next.request.stale = !0, G.abrupt("return", S.next);
                        case 28:
                          G.prev = 28, G.t1 = G.catch(19);
                        case 30:
                          throw U;
                        case 31:
                          return G.abrupt("return", F(S));
                        case 32:
                        case "end":
                          return G.stop();
                      }
                  }, z, null, [[7, 13], [19, 28]]);
                })), P.apply(this, arguments);
              }
              return {
                adapter: O,
                config: R,
                store: R.store
              };
            }
            function L() {
              var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = E(E(E({}, b.defaults.axios), R), {}, {
                cache: E(E({}, b.defaults.axios.cache), R.cache)
              }), P = D(O.cache);
              O.cache;
              var z = w(O, ["cache"]), W = d.a.create(E(E({}, z), {}, {
                adapter: P.adapter
              }));
              return W.cache = P.store, W;
            }
            a.default = {
              setup: L,
              setupCache: D,
              serializeQuery: g.serializeQuery
            };
          }
        ),
        /***/
        "./src/cache.js": (
          /*!**********************!*\
            !*** ./src/cache.js ***!
            \**********************/
          /*! exports provided: read, write, key, invalidate, serializeQuery, default */
          /***/
          function(o, a, c) {
            c.r(a), c.d(a, "read", function() {
              return I;
            }), c.d(a, "write", function() {
              return w;
            }), c.d(a, "key", function() {
              return T;
            }), c.d(a, "invalidate", function() {
              return D;
            }), c.d(a, "serializeQuery", function() {
              return L;
            }), c(
              /*! core-js/modules/es7.array.includes */
              "./node_modules/core-js/modules/es7.array.includes.js"
            ), c(
              /*! core-js/modules/es6.string.includes */
              "./node_modules/core-js/modules/es6.string.includes.js"
            ), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            ), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            var u = c(
              /*! ./utilities */
              "./src/utilities.js"
            ), d = c(
              /*! md5 */
              "./node_modules/md5/md5.js"
            ), p = /* @__PURE__ */ c.n(d), g = c(
              /*! ./serialize */
              "./src/serialize.js"
            );
            function b(R, O, P, z, W, A, S) {
              try {
                var F = R[A](S), U = F.value;
              } catch (M) {
                P(M);
                return;
              }
              F.done ? O(U) : Promise.resolve(U).then(z, W);
            }
            function x(R) {
              return function() {
                var O = this, P = arguments;
                return new Promise(function(z, W) {
                  var A = R.apply(O, P);
                  function S(U) {
                    b(A, z, W, S, F, "next", U);
                  }
                  function F(U) {
                    b(A, z, W, S, F, "throw", U);
                  }
                  S(void 0);
                });
              };
            }
            function w(R, O, P) {
              return y.apply(this, arguments);
            }
            function y() {
              return y = x(/* @__PURE__ */ regeneratorRuntime.mark(function R(O, P, z) {
                var W;
                return regeneratorRuntime.wrap(function(S) {
                  for (; ; )
                    switch (S.prev = S.next) {
                      case 0:
                        return S.prev = 0, W = {
                          expires: O.expires,
                          data: Object(g.default)(O, P, z)
                        }, S.next = 4, O.store.setItem(O.uuid, W);
                      case 4:
                        S.next = 19;
                        break;
                      case 6:
                        if (S.prev = 6, S.t0 = S.catch(0), O.debug("Could not store response", S.t0), !O.clearOnError) {
                          S.next = 18;
                          break;
                        }
                        return S.prev = 10, S.next = 13, O.store.clear();
                      case 13:
                        S.next = 18;
                        break;
                      case 15:
                        S.prev = 15, S.t1 = S.catch(10), O.debug("Could not clear store", S.t1);
                      case 18:
                        return S.abrupt("return", !1);
                      case 19:
                        return S.abrupt("return", !0);
                      case 20:
                      case "end":
                        return S.stop();
                    }
                }, R, null, [[0, 6], [10, 15]]);
              })), y.apply(this, arguments);
            }
            function I(R, O) {
              return E.apply(this, arguments);
            }
            function E() {
              return E = x(/* @__PURE__ */ regeneratorRuntime.mark(function R(O, P) {
                var z, W, A, S, F, U, M, V;
                return regeneratorRuntime.wrap(function(Q) {
                  for (; ; )
                    switch (Q.prev = Q.next) {
                      case 0:
                        return z = O.uuid, W = O.ignoreCache, Q.next = 3, O.store.getItem(z);
                      case 3:
                        if (A = Q.sent, !(W || !A || !A.data)) {
                          Q.next = 10;
                          break;
                        }
                        throw O.debug("cache-miss", P.url), S = new Error(), S.reason = "cache-miss", S.message = "Entry not found from cache", S;
                      case 10:
                        if (F = A.expires, U = A.data, M = typeof navigator < "u" && "onLine" in navigator && !navigator.onLine, !(!M && !O.acceptStale && F !== 0 && F < Date.now())) {
                          Q.next = 18;
                          break;
                        }
                        throw O.debug("cache-stale", P.url), V = new Error(), V.reason = "cache-stale", V.message = "Entry is stale", V;
                      case 18:
                        return O.debug(O.acceptStale ? "cache-hit-stale" : "cache-hit", P.url), Q.abrupt("return", U);
                      case 20:
                      case "end":
                        return Q.stop();
                    }
                }, R);
              })), E.apply(this, arguments);
            }
            function T(R) {
              if (Object(u.isFunction)(R.key))
                return R.key;
              var O;
              return Object(u.isString)(R.key) ? O = function(z) {
                var W = "".concat(z.baseURL ? z.baseURL : "").concat(z.url), A = "".concat(R.key, "/").concat(W).concat(L(z));
                return z.data ? A + p()(z.data) : A;
              } : O = function(z) {
                var W = "".concat(z.baseURL ? z.baseURL : "").concat(z.url), A = W + L(z);
                return z.data ? A + p()(z.data) : A;
              }, O;
            }
            function C(R, O) {
              return $.apply(this, arguments);
            }
            function $() {
              return $ = x(/* @__PURE__ */ regeneratorRuntime.mark(function R(O, P) {
                var z;
                return regeneratorRuntime.wrap(function(A) {
                  for (; ; )
                    switch (A.prev = A.next) {
                      case 0:
                        if (z = P.method.toLowerCase(), !O.exclude.methods.includes(z)) {
                          A.next = 4;
                          break;
                        }
                        return A.next = 4, O.store.removeItem(O.uuid);
                      case 4:
                      case "end":
                        return A.stop();
                    }
                }, R);
              })), $.apply(this, arguments);
            }
            function D() {
              var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              return Object(u.isFunction)(R.invalidate) ? R.invalidate : C;
            }
            function L(R) {
              if (!R.params)
                return "";
              if (typeof URLSearchParams > "u")
                return JSON.stringify(R.params);
              var O = R.params, P = R.params instanceof URLSearchParams;
              return P || (O = new URLSearchParams(), Object.keys(R.params).forEach(function(z) {
                return O.append(z, R.params[z]);
              })), "?".concat(O.toString());
            }
            a.default = {
              read: I,
              write: w,
              key: T,
              invalidate: D,
              serializeQuery: L
            };
          }
        ),
        /***/
        "./src/config.js": (
          /*!***********************!*\
            !*** ./src/config.js ***!
            \***********************/
          /*! exports provided: defaults, makeConfig, mergeRequestConfig, default */
          /***/
          function(o, a, c) {
            c.r(a), c.d(a, "defaults", function() {
              return E;
            }), c.d(a, "makeConfig", function() {
              return C;
            }), c.d(a, "mergeRequestConfig", function() {
              return $;
            }), c(
              /*! core-js/modules/es7.object.get-own-property-descriptors */
              "./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js"
            ), c(
              /*! core-js/modules/es6.symbol */
              "./node_modules/core-js/modules/es6.symbol.js"
            ), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            var u = c(
              /*! axios */
              "axios"
            ), d = /* @__PURE__ */ c.n(u), p = c(
              /*! ./memory */
              "./src/memory.js"
            ), g = c(
              /*! ./cache */
              "./src/cache.js"
            );
            function b(D, L) {
              var R = Object.keys(D);
              if (Object.getOwnPropertySymbols) {
                var O = Object.getOwnPropertySymbols(D);
                L && (O = O.filter(function(P) {
                  return Object.getOwnPropertyDescriptor(D, P).enumerable;
                })), R.push.apply(R, O);
              }
              return R;
            }
            function x(D) {
              for (var L = 1; L < arguments.length; L++) {
                var R = arguments[L] != null ? arguments[L] : {};
                L % 2 ? b(Object(R), !0).forEach(function(O) {
                  w(D, O, R[O]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(R)) : b(Object(R)).forEach(function(O) {
                  Object.defineProperty(D, O, Object.getOwnPropertyDescriptor(R, O));
                });
              }
              return D;
            }
            function w(D, L, R) {
              return L in D ? Object.defineProperty(D, L, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : D[L] = R, D;
            }
            var y = function() {
            }, I = function() {
              for (var L, R = arguments.length, O = new Array(R), P = 0; P < R; P++)
                O[P] = arguments[P];
              return (L = console).log.apply(L, ["[axios-cache-adapter]"].concat(O));
            }, E = {
              // Default settings when solely creating the cache adapter with setupCache.
              cache: {
                maxAge: 0,
                limit: !1,
                store: null,
                key: null,
                invalidate: null,
                exclude: {
                  paths: [],
                  query: !0,
                  filter: null,
                  methods: ["post", "patch", "put", "delete"]
                },
                adapter: d.a.defaults.adapter,
                clearOnStale: !0,
                clearOnError: !0,
                readOnError: !1,
                readHeaders: !1,
                debug: !1,
                ignoreCache: !1
              },
              // Additional defaults when creating the axios instance with the cache adapter.
              axios: {
                cache: {
                  maxAge: 15 * 60 * 1e3
                }
              }
            }, T = ["limit", "store", "adapter", "uuid", "acceptStale"], C = function() {
              var L = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, R = x(x(x({}, E.cache), L), {}, {
                exclude: x(x({}, E.cache.exclude), L.exclude)
              });
              return R.key = Object(g.key)(R), R.invalidate = Object(g.invalidate)(R), R.debug !== !1 ? R.debug = typeof R.debug == "function" ? R.debug : I : R.debug = y, R.store || (R.store = new p.default()), R.debug("Global cache config", R), R;
            }, $ = function(L, R) {
              var O = R.cache || {};
              O && T.forEach(function(z) {
                return O[z] ? delete O[z] : void 0;
              });
              var P = x(x(x({}, L), O), {}, {
                exclude: x(x({}, L.exclude), O.exclude)
              });
              return P.debug === !0 && (P.debug = I), O.key && (P.key = Object(g.key)(O)), P.uuid = P.key(R), L.debug("Request config for ".concat(R.url), P), P;
            };
            a.default = {
              defaults: E,
              makeConfig: C,
              mergeRequestConfig: $
            };
          }
        ),
        /***/
        "./src/exclude.js": (
          /*!************************!*\
            !*** ./src/exclude.js ***!
            \************************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            ), c(
              /*! core-js/modules/es7.array.includes */
              "./node_modules/core-js/modules/es7.array.includes.js"
            ), c(
              /*! core-js/modules/es6.string.includes */
              "./node_modules/core-js/modules/es6.string.includes.js"
            );
            var u = c(
              /*! ./utilities */
              "./src/utilities.js"
            );
            function d() {
              var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = arguments.length > 1 ? arguments[1] : void 0, b = p.exclude, x = b === void 0 ? {} : b, w = p.debug, y = g.method.toLowerCase();
              if (y === "head" || x.methods.includes(y))
                return w("Excluding request by HTTP method ".concat(g.url)), !0;
              if (typeof x.filter == "function" && x.filter(g))
                return w("Excluding request by filter ".concat(g.url)), !0;
              var I = /\?.*$/.test(g.url) || Object(u.isObject)(g.params) && Object.keys(g.params).length !== 0 || typeof URLSearchParams < "u" && g.params instanceof URLSearchParams;
              if (x.query && I)
                return w("Excluding request by query ".concat(g.url)), !0;
              var E = x.paths || [], T = E.some(function(C) {
                return g.url.match(C);
              });
              return T ? (w("Excluding request by url match ".concat(g.url)), !0) : !1;
            }
            a.default = d;
          }
        ),
        /***/
        "./src/index.js": (
          /*!**********************!*\
            !*** ./src/index.js ***!
            \**********************/
          /*! exports provided: setup, setupCache, serializeQuery, default */
          /***/
          function(o, a, c) {
            c.r(a);
            var u = c(
              /*! ./api */
              "./src/api.js"
            );
            c.d(a, "setup", function() {
              return u.setup;
            }), c.d(a, "setupCache", function() {
              return u.setupCache;
            }), c.d(a, "serializeQuery", function() {
              return u.serializeQuery;
            }), c.d(a, "default", function() {
              return u.default;
            });
          }
        ),
        /***/
        "./src/limit.js": (
          /*!**********************!*\
            !*** ./src/limit.js ***!
            \**********************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            function u(b, x, w, y, I, E, T) {
              try {
                var C = b[E](T), $ = C.value;
              } catch (D) {
                w(D);
                return;
              }
              C.done ? x($) : Promise.resolve($).then(y, I);
            }
            function d(b) {
              return function() {
                var x = this, w = arguments;
                return new Promise(function(y, I) {
                  var E = b.apply(x, w);
                  function T($) {
                    u(E, y, I, T, C, "next", $);
                  }
                  function C($) {
                    u(E, y, I, T, C, "throw", $);
                  }
                  T(void 0);
                });
              };
            }
            function p(b) {
              return g.apply(this, arguments);
            }
            function g() {
              return g = d(/* @__PURE__ */ regeneratorRuntime.mark(function b(x) {
                var w, y;
                return regeneratorRuntime.wrap(function(E) {
                  for (; ; )
                    switch (E.prev = E.next) {
                      case 0:
                        return E.next = 2, x.store.length();
                      case 2:
                        if (w = E.sent, !(w < x.limit)) {
                          E.next = 5;
                          break;
                        }
                        return E.abrupt("return");
                      case 5:
                        return x.debug("Current store size: ".concat(w)), E.next = 8, x.store.iterate(function(T, C) {
                          y || (y = {
                            value: T,
                            key: C
                          }), T.expires < y.value.expires && (y = {
                            value: T,
                            key: C
                          });
                        });
                      case 8:
                        if (!y) {
                          E.next = 12;
                          break;
                        }
                        return x.debug("Removing item: ".concat(y.key)), E.next = 12, x.store.removeItem(y.key);
                      case 12:
                      case "end":
                        return E.stop();
                    }
                }, b);
              })), g.apply(this, arguments);
            }
            a.default = p;
          }
        ),
        /***/
        "./src/memory.js": (
          /*!***********************!*\
            !*** ./src/memory.js ***!
            \***********************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            ), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            );
            var u = c(
              /*! ./utilities */
              "./src/utilities.js"
            );
            function d(y, I, E, T, C, $, D) {
              try {
                var L = y[$](D), R = L.value;
              } catch (O) {
                E(O);
                return;
              }
              L.done ? I(R) : Promise.resolve(R).then(T, C);
            }
            function p(y) {
              return function() {
                var I = this, E = arguments;
                return new Promise(function(T, C) {
                  var $ = y.apply(I, E);
                  function D(R) {
                    d($, T, C, D, L, "next", R);
                  }
                  function L(R) {
                    d($, T, C, D, L, "throw", R);
                  }
                  D(void 0);
                });
              };
            }
            function g(y, I) {
              if (!(y instanceof I))
                throw new TypeError("Cannot call a class as a function");
            }
            function b(y, I) {
              for (var E = 0; E < I.length; E++) {
                var T = I[E];
                T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(y, T.key, T);
              }
            }
            function x(y, I, E) {
              return I && b(y.prototype, I), E && b(y, E), y;
            }
            var w = /* @__PURE__ */ function() {
              function y() {
                g(this, y), this.store = {};
              }
              return x(y, [{
                key: "getItem",
                value: function() {
                  var I = p(/* @__PURE__ */ regeneratorRuntime.mark(function T(C) {
                    var $;
                    return regeneratorRuntime.wrap(function(L) {
                      for (; ; )
                        switch (L.prev = L.next) {
                          case 0:
                            return $ = this.store[C] || null, L.abrupt("return", JSON.parse($));
                          case 2:
                          case "end":
                            return L.stop();
                        }
                    }, T, this);
                  }));
                  function E(T) {
                    return I.apply(this, arguments);
                  }
                  return E;
                }()
              }, {
                key: "setItem",
                value: function() {
                  var I = p(/* @__PURE__ */ regeneratorRuntime.mark(function T(C, $) {
                    return regeneratorRuntime.wrap(function(L) {
                      for (; ; )
                        switch (L.prev = L.next) {
                          case 0:
                            return this.store[C] = JSON.stringify($), L.abrupt("return", $);
                          case 2:
                          case "end":
                            return L.stop();
                        }
                    }, T, this);
                  }));
                  function E(T, C) {
                    return I.apply(this, arguments);
                  }
                  return E;
                }()
              }, {
                key: "removeItem",
                value: function() {
                  var I = p(/* @__PURE__ */ regeneratorRuntime.mark(function T(C) {
                    return regeneratorRuntime.wrap(function(D) {
                      for (; ; )
                        switch (D.prev = D.next) {
                          case 0:
                            delete this.store[C];
                          case 1:
                          case "end":
                            return D.stop();
                        }
                    }, T, this);
                  }));
                  function E(T) {
                    return I.apply(this, arguments);
                  }
                  return E;
                }()
              }, {
                key: "clear",
                value: function() {
                  var I = p(/* @__PURE__ */ regeneratorRuntime.mark(function T() {
                    return regeneratorRuntime.wrap(function($) {
                      for (; ; )
                        switch ($.prev = $.next) {
                          case 0:
                            this.store = {};
                          case 1:
                          case "end":
                            return $.stop();
                        }
                    }, T, this);
                  }));
                  function E() {
                    return I.apply(this, arguments);
                  }
                  return E;
                }()
              }, {
                key: "length",
                value: function() {
                  var I = p(/* @__PURE__ */ regeneratorRuntime.mark(function T() {
                    return regeneratorRuntime.wrap(function($) {
                      for (; ; )
                        switch ($.prev = $.next) {
                          case 0:
                            return $.abrupt("return", Object.keys(this.store).length);
                          case 1:
                          case "end":
                            return $.stop();
                        }
                    }, T, this);
                  }));
                  function E() {
                    return I.apply(this, arguments);
                  }
                  return E;
                }()
              }, {
                key: "iterate",
                value: function(E) {
                  return Promise.all(Object(u.mapObject)(this.store, E));
                }
              }]), y;
            }();
            a.default = w;
          }
        ),
        /***/
        "./src/request.js": (
          /*!************************!*\
            !*** ./src/request.js ***!
            \************************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            var u = c(
              /*! ./response */
              "./src/response.js"
            ), d = c(
              /*! ./exclude */
              "./src/exclude.js"
            ), p = c(
              /*! ./cache */
              "./src/cache.js"
            );
            function g(y, I, E, T, C, $, D) {
              try {
                var L = y[$](D), R = L.value;
              } catch (O) {
                E(O);
                return;
              }
              L.done ? I(R) : Promise.resolve(R).then(T, C);
            }
            function b(y) {
              return function() {
                var I = this, E = arguments;
                return new Promise(function(T, C) {
                  var $ = y.apply(I, E);
                  function D(R) {
                    g($, T, C, D, L, "next", R);
                  }
                  function L(R) {
                    g($, T, C, D, L, "throw", R);
                  }
                  D(void 0);
                });
              };
            }
            function x(y, I) {
              return w.apply(this, arguments);
            }
            function w() {
              return w = b(/* @__PURE__ */ regeneratorRuntime.mark(function y(I, E) {
                var T, C, $;
                return regeneratorRuntime.wrap(function(L) {
                  for (; ; )
                    switch (L.prev = L.next) {
                      case 0:
                        return $ = function() {
                          return I.excludeFromCache = !0, {
                            config: I,
                            next: T
                          };
                        }, I.debug("uuid", I.uuid), T = function() {
                          for (var O = arguments.length, P = new Array(O), z = 0; z < O; z++)
                            P[z] = arguments[z];
                          return u.default.apply(void 0, [I, E].concat(P));
                        }, L.next = 5, I.invalidate(I, E);
                      case 5:
                        if (!Object(d.default)(I, E)) {
                          L.next = 7;
                          break;
                        }
                        return L.abrupt("return", $());
                      case 7:
                        return L.prev = 7, L.next = 10, Object(p.read)(I, E);
                      case 10:
                        return C = L.sent, C.config = E, C.request = {
                          fromCache: !0
                        }, L.abrupt("return", {
                          config: I,
                          next: C
                        });
                      case 16:
                        if (L.prev = 16, L.t0 = L.catch(7), !(I.clearOnStale && L.t0.reason === "cache-stale")) {
                          L.next = 21;
                          break;
                        }
                        return L.next = 21, I.store.removeItem(I.uuid);
                      case 21:
                        return L.abrupt("return", {
                          config: I,
                          next: T
                        });
                      case 22:
                      case "end":
                        return L.stop();
                    }
                }, y, null, [[7, 16]]);
              })), w.apply(this, arguments);
            }
            a.default = x;
          }
        ),
        /***/
        "./src/response.js": (
          /*!*************************!*\
            !*** ./src/response.js ***!
            \*************************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! regenerator-runtime/runtime */
              "./node_modules/regenerator-runtime/runtime.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            var u = c(
              /*! ./limit */
              "./src/limit.js"
            ), d = c(
              /*! ./cache */
              "./src/cache.js"
            ), p = c(
              /*! cache-control-esm */
              "./node_modules/cache-control-esm/index.js"
            );
            function g(y, I, E, T, C, $, D) {
              try {
                var L = y[$](D), R = L.value;
              } catch (O) {
                E(O);
                return;
              }
              L.done ? I(R) : Promise.resolve(R).then(T, C);
            }
            function b(y) {
              return function() {
                var I = this, E = arguments;
                return new Promise(function(T, C) {
                  var $ = y.apply(I, E);
                  function D(R) {
                    g($, T, C, D, L, "next", R);
                  }
                  function L(R) {
                    g($, T, C, D, L, "throw", R);
                  }
                  D(void 0);
                });
              };
            }
            function x(y, I, E) {
              return w.apply(this, arguments);
            }
            function w() {
              return w = b(/* @__PURE__ */ regeneratorRuntime.mark(function y(I, E, T) {
                var C, $, D, L, R;
                return regeneratorRuntime.wrap(function(P) {
                  for (; ; )
                    switch (P.prev = P.next) {
                      case 0:
                        if (C = T.request, $ = C === void 0 ? {} : C, D = T.headers, L = D === void 0 ? {} : D, !(["arraybuffer", "blob"].indexOf($.responseType) > -1)) {
                          P.next = 3;
                          break;
                        }
                        return P.abrupt("return", T);
                      case 3:
                        if (R = {}, I.readHeaders && (L["cache-control"] ? (R = Object(p.parse)(L["cache-control"]), (R.noCache || R.noStore) && (I.excludeFromCache = !0)) : L.expires ? I.expires = new Date(L.expires).getTime() : I.expires = (/* @__PURE__ */ new Date()).getTime()), I.excludeFromCache) {
                          P.next = 15;
                          break;
                        }
                        if (R.maxAge || R.maxAge === 0 ? I.expires = Date.now() + R.maxAge * 1e3 : I.readHeaders || (I.expires = I.maxAge === 0 ? Date.now() : Date.now() + I.maxAge), !I.limit) {
                          P.next = 11;
                          break;
                        }
                        return I.debug("Detected limit: ".concat(I.limit)), P.next = 11, Object(u.default)(I);
                      case 11:
                        return P.next = 13, Object(d.write)(I, E, T);
                      case 13:
                        P.next = 16;
                        break;
                      case 15:
                        T.request.excludedFromCache = !0;
                      case 16:
                        return P.abrupt("return", T);
                      case 17:
                      case "end":
                        return P.stop();
                    }
                }, y);
              })), w.apply(this, arguments);
            }
            a.default = x;
          }
        ),
        /***/
        "./src/serialize.js": (
          /*!**************************!*\
            !*** ./src/serialize.js ***!
            \**************************/
          /*! exports provided: default */
          /***/
          function(o, a, c) {
            c.r(a), c(
              /*! core-js/modules/es6.symbol */
              "./node_modules/core-js/modules/es6.symbol.js"
            ), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            function u(g, b) {
              if (g == null)
                return {};
              var x = d(g, b), w, y;
              if (Object.getOwnPropertySymbols) {
                var I = Object.getOwnPropertySymbols(g);
                for (y = 0; y < I.length; y++)
                  w = I[y], !(b.indexOf(w) >= 0) && Object.prototype.propertyIsEnumerable.call(g, w) && (x[w] = g[w]);
              }
              return x;
            }
            function d(g, b) {
              if (g == null)
                return {};
              var x = {}, w = Object.keys(g), y, I;
              for (I = 0; I < w.length; I++)
                y = w[I], !(b.indexOf(y) >= 0) && (x[y] = g[y]);
              return x;
            }
            function p(g, b, x) {
              if (x.data)
                try {
                  x.data = JSON.parse(x.data);
                } catch (y) {
                  g.debug("Could not parse data as JSON", y);
                }
              x.request, x.config;
              var w = u(x, ["request", "config"]);
              return w;
            }
            a.default = p;
          }
        ),
        /***/
        "./src/utilities.js": (
          /*!**************************!*\
            !*** ./src/utilities.js ***!
            \**************************/
          /*! exports provided: isObject, getTag, isFunction, isString, mapObject */
          /***/
          function(o, a, c) {
            c.r(a), c.d(a, "isObject", function() {
              return d;
            }), c.d(a, "getTag", function() {
              return p;
            }), c.d(a, "isFunction", function() {
              return g;
            }), c.d(a, "isString", function() {
              return b;
            }), c.d(a, "mapObject", function() {
              return x;
            }), c(
              /*! core-js/modules/es7.symbol.async-iterator */
              "./node_modules/core-js/modules/es7.symbol.async-iterator.js"
            ), c(
              /*! core-js/modules/es6.symbol */
              "./node_modules/core-js/modules/es6.symbol.js"
            ), c(
              /*! core-js/modules/es6.array.iterator */
              "./node_modules/core-js/modules/es6.array.iterator.js"
            ), c(
              /*! core-js/modules/es6.object.to-string */
              "./node_modules/core-js/modules/es6.object.to-string.js"
            );
            function u(w) {
              "@babel/helpers - typeof";
              return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? u = function(I) {
                return typeof I;
              } : u = function(I) {
                return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
              }, u(w);
            }
            function d(w) {
              var y = u(w);
              return w != null && (y === "object" || y === "function");
            }
            function p(w) {
              return w === null ? w === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(w);
            }
            function g(w) {
              if (!d(w))
                return !1;
              var y = p(w);
              return y === "[object Function]" || y === "[object AsyncFunction]" || y === "[object GeneratorFunction]" || y === "[object Proxy]";
            }
            function b(w) {
              var y = u(w);
              return y === "string" || y === "object" && w != null && !Array.isArray(w) && p(w) === "[object String]";
            }
            function x(w, y) {
              return d(w) ? Object.keys(w).map(function(I) {
                return y(w[I], I);
              }) : [];
            }
          }
        ),
        /***/
        axios: (
          /*!*************************************************************************************!*\
            !*** external {"umd":"axios","amd":"axios","commonjs":"axios","commonjs2":"axios"} ***!
            \*************************************************************************************/
          /*! no static exports found */
          /***/
          function(o, a) {
            o.exports = r;
          }
        )
        /******/
      })
    );
  });
})(cache$1);
var cacheExports = cache$1.exports, shams = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), o = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
    return !1;
  var a = 42;
  e[r] = a;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var c = Object.getOwnPropertySymbols(e);
  if (c.length !== 1 || c[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var u = Object.getOwnPropertyDescriptor(e, r);
    if (u.value !== a || u.enumerable !== !0)
      return !1;
  }
  return !0;
}, origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = shams, hasSymbols$1 = function() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, test = {
  foo: {}
}, $Object = Object, hasProto$1 = function() {
  return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
}, ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", slice = Array.prototype.slice, toStr$1 = Object.prototype.toString, funcType = "[object Function]", implementation$1 = function(e) {
  var r = this;
  if (typeof r != "function" || toStr$1.call(r) !== funcType)
    throw new TypeError(ERROR_MESSAGE + r);
  for (var o = slice.call(arguments, 1), a, c = function() {
    if (this instanceof a) {
      var b = r.apply(
        this,
        o.concat(slice.call(arguments))
      );
      return Object(b) === b ? b : this;
    } else
      return r.apply(
        e,
        o.concat(slice.call(arguments))
      );
  }, u = Math.max(0, r.length - o.length), d = [], p = 0; p < u; p++)
    d.push("$" + p);
  if (a = Function("binder", "return function (" + d.join(",") + "){ return binder.apply(this,arguments); }")(c), r.prototype) {
    var g = function() {
    };
    g.prototype = r.prototype, a.prototype = new g(), g.prototype = null;
  }
  return a;
}, implementation = implementation$1, functionBind = Function.prototype.bind || implementation, bind$1 = functionBind, src = bind$1.call(Function.call, Object.prototype.hasOwnProperty), undefined$1, $SyntaxError = SyntaxError, $Function = Function, $TypeError$1 = TypeError, getEvalledConstructor = function(t) {
  try {
    return $Function('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD)
  try {
    $gOPD({}, "");
  } catch {
    $gOPD = null;
  }
var throwTypeError = function() {
  throw new $TypeError$1();
}, ThrowTypeError = $gOPD ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols = hasSymbols$1(), hasProto = hasProto$1(), getProto = Object.getPrototypeOf || (hasProto ? function(t) {
  return t.__proto__;
} : null), needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto ? undefined$1 : getProto(Uint8Array), INTRINSICS = {
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$1,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
};
if (getProto)
  try {
    null.error;
  } catch (t) {
    var errorProto = getProto(getProto(t));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = getEvalledConstructor("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = getEvalledConstructor("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = getEvalledConstructor("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var o = t("%AsyncGeneratorFunction%");
    o && (r = o.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var a = t("%AsyncGenerator%");
    a && getProto && (r = getProto(a.prototype));
  }
  return INTRINSICS[e] = r, r;
}, LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind = functionBind, hasOwn$2 = src, $concat$1 = bind.call(Function.call, Array.prototype.concat), $spliceApply = bind.call(Function.apply, Array.prototype.splice), $replace$1 = bind.call(Function.call, String.prototype.replace), $strSlice = bind.call(Function.call, String.prototype.slice), $exec = bind.call(Function.call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function(e) {
  var r = $strSlice(e, 0, 1), o = $strSlice(e, -1);
  if (r === "%" && o !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  if (o === "%" && r !== "%")
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return $replace$1(e, rePropName, function(c, u, d, p) {
    a[a.length] = d ? $replace$1(p, reEscapeChar, "$1") : u || c;
  }), a;
}, getBaseIntrinsic = function(e, r) {
  var o = e, a;
  if (hasOwn$2(LEGACY_ALIASES, o) && (a = LEGACY_ALIASES[o], o = "%" + a[0] + "%"), hasOwn$2(INTRINSICS, o)) {
    var c = INTRINSICS[o];
    if (c === needsEval && (c = doEval(o)), typeof c > "u" && !r)
      throw new $TypeError$1("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: o,
      value: c
    };
  }
  throw new $SyntaxError("intrinsic " + e + " does not exist!");
}, getIntrinsic = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new $TypeError$1("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new $TypeError$1('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, e) === null)
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var o = stringToPath(e), a = o.length > 0 ? o[0] : "", c = getBaseIntrinsic("%" + a + "%", r), u = c.name, d = c.value, p = !1, g = c.alias;
  g && (a = g[0], $spliceApply(o, $concat$1([0, 1], g)));
  for (var b = 1, x = !0; b < o.length; b += 1) {
    var w = o[b], y = $strSlice(w, 0, 1), I = $strSlice(w, -1);
    if ((y === '"' || y === "'" || y === "`" || I === '"' || I === "'" || I === "`") && y !== I)
      throw new $SyntaxError("property names with quotes must have matching quotes");
    if ((w === "constructor" || !x) && (p = !0), a += "." + w, u = "%" + a + "%", hasOwn$2(INTRINSICS, u))
      d = INTRINSICS[u];
    else if (d != null) {
      if (!(w in d)) {
        if (!r)
          throw new $TypeError$1("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if ($gOPD && b + 1 >= o.length) {
        var E = $gOPD(d, w);
        x = !!E, x && "get" in E && !("originalValue" in E.get) ? d = E.get : d = d[w];
      } else
        x = hasOwn$2(d, w), d = d[w];
      x && !p && (INTRINSICS[u] = d);
    }
  }
  return d;
}, callBind$1 = { exports: {} };
(function(t) {
  var e = functionBind, r = getIntrinsic, o = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), c = r("%Reflect.apply%", !0) || e.call(a, o), u = r("%Object.getOwnPropertyDescriptor%", !0), d = r("%Object.defineProperty%", !0), p = r("%Math.max%");
  if (d)
    try {
      d({}, "a", { value: 1 });
    } catch {
      d = null;
    }
  t.exports = function(x) {
    var w = c(e, a, arguments);
    if (u && d) {
      var y = u(w, "length");
      y.configurable && d(
        w,
        "length",
        { value: 1 + p(0, x.length - (arguments.length - 1)) }
      );
    }
    return w;
  };
  var g = function() {
    return c(e, o, arguments);
  };
  d ? d(t.exports, "apply", { value: g }) : t.exports.apply = g;
})(callBind$1);
var callBindExports = callBind$1.exports, GetIntrinsic$1 = getIntrinsic, callBind = callBindExports, $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf")), callBound$1 = function(e, r) {
  var o = GetIntrinsic$1(e, !!r);
  return typeof o == "function" && $indexOf(e, ".prototype.") > -1 ? callBind(o) : o;
};
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map == "function" && Map.prototype, mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get == "function" ? mapSizeDescriptor.get : null, mapForEach = hasMap && Map.prototype.forEach, hasSet = typeof Set == "function" && Set.prototype, setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get == "function" ? setSizeDescriptor.get : null, setForEach = hasSet && Set.prototype.forEach, hasWeakMap = typeof WeakMap == "function" && WeakMap.prototype, weakMapHas = hasWeakMap ? WeakMap.prototype.has : null, hasWeakSet = typeof WeakSet == "function" && WeakSet.prototype, weakSetHas = hasWeakSet ? WeakSet.prototype.has : null, hasWeakRef = typeof WeakRef == "function" && WeakRef.prototype, weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null, booleanValueOf = Boolean.prototype.valueOf, objectToString$1 = Object.prototype.toString, functionToString = Function.prototype.toString, $match = String.prototype.match, $slice = String.prototype.slice, $replace = String.prototype.replace, $toUpperCase = String.prototype.toUpperCase, $toLowerCase = String.prototype.toLowerCase, $test = RegExp.prototype.test, $concat = Array.prototype.concat, $join = Array.prototype.join, $arrSlice = Array.prototype.slice, $floor = Math.floor, bigIntValueOf = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, gOPS = Object.getOwnPropertySymbols, symToString = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, hasShammedSymbols = typeof Symbol == "function" && typeof Symbol.iterator == "object", toStringTag = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols || "symbol") ? Symbol.toStringTag : null, isEnumerable = Object.prototype.propertyIsEnumerable, gPO = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function addNumericSeparator(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || $test.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var o = t < 0 ? -$floor(-t) : $floor(t);
    if (o !== t) {
      var a = String(o), c = $slice.call(e, a.length + 1);
      return $replace.call(a, r, "$&_") + "." + $replace.call($replace.call(c, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(e, r, "$&_");
}
var utilInspect = require$$0$1, inspectCustom = utilInspect.custom, inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null, objectInspect = function t(e, r, o, a) {
  var c = r || {};
  if (has$4(c, "quoteStyle") && c.quoteStyle !== "single" && c.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (has$4(c, "maxStringLength") && (typeof c.maxStringLength == "number" ? c.maxStringLength < 0 && c.maxStringLength !== 1 / 0 : c.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var u = has$4(c, "customInspect") ? c.customInspect : !0;
  if (typeof u != "boolean" && u !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (has$4(c, "indent") && c.indent !== null && c.indent !== "	" && !(parseInt(c.indent, 10) === c.indent && c.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (has$4(c, "numericSeparator") && typeof c.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var d = c.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return inspectString(e, c);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var p = String(e);
    return d ? addNumericSeparator(e, p) : p;
  }
  if (typeof e == "bigint") {
    var g = String(e) + "n";
    return d ? addNumericSeparator(e, g) : g;
  }
  var b = typeof c.depth > "u" ? 5 : c.depth;
  if (typeof o > "u" && (o = 0), o >= b && b > 0 && typeof e == "object")
    return isArray$4(e) ? "[Array]" : "[Object]";
  var x = getIndent(c, o);
  if (typeof a > "u")
    a = [];
  else if (indexOf(a, e) >= 0)
    return "[Circular]";
  function w(U, M, V) {
    if (M && (a = $arrSlice.call(a), a.push(M)), V) {
      var G = {
        depth: c.depth
      };
      return has$4(c, "quoteStyle") && (G.quoteStyle = c.quoteStyle), t(U, G, o + 1, a);
    }
    return t(U, c, o + 1, a);
  }
  if (typeof e == "function" && !isRegExp$3(e)) {
    var y = nameOf(e), I = arrObjKeys(e, w);
    return "[Function" + (y ? ": " + y : " (anonymous)") + "]" + (I.length > 0 ? " { " + $join.call(I, ", ") + " }" : "");
  }
  if (isSymbol(e)) {
    var E = hasShammedSymbols ? $replace.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(e);
    return typeof e == "object" && !hasShammedSymbols ? markBoxed(E) : E;
  }
  if (isElement(e)) {
    for (var T = "<" + $toLowerCase.call(String(e.nodeName)), C = e.attributes || [], $ = 0; $ < C.length; $++)
      T += " " + C[$].name + "=" + wrapQuotes(quote(C[$].value), "double", c);
    return T += ">", e.childNodes && e.childNodes.length && (T += "..."), T += "</" + $toLowerCase.call(String(e.nodeName)) + ">", T;
  }
  if (isArray$4(e)) {
    if (e.length === 0)
      return "[]";
    var D = arrObjKeys(e, w);
    return x && !singleLineValues(D) ? "[" + indentedJoin(D, x) + "]" : "[ " + $join.call(D, ", ") + " ]";
  }
  if (isError$1(e)) {
    var L = arrObjKeys(e, w);
    return !("cause" in Error.prototype) && "cause" in e && !isEnumerable.call(e, "cause") ? "{ [" + String(e) + "] " + $join.call($concat.call("[cause]: " + w(e.cause), L), ", ") + " }" : L.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + $join.call(L, ", ") + " }";
  }
  if (typeof e == "object" && u) {
    if (inspectSymbol && typeof e[inspectSymbol] == "function" && utilInspect)
      return utilInspect(e, { depth: b - o });
    if (u !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (isMap(e)) {
    var R = [];
    return mapForEach && mapForEach.call(e, function(U, M) {
      R.push(w(M, e, !0) + " => " + w(U, e));
    }), collectionOf("Map", mapSize.call(e), R, x);
  }
  if (isSet(e)) {
    var O = [];
    return setForEach && setForEach.call(e, function(U) {
      O.push(w(U, e));
    }), collectionOf("Set", setSize.call(e), O, x);
  }
  if (isWeakMap(e))
    return weakCollectionOf("WeakMap");
  if (isWeakSet(e))
    return weakCollectionOf("WeakSet");
  if (isWeakRef(e))
    return weakCollectionOf("WeakRef");
  if (isNumber$1(e))
    return markBoxed(w(Number(e)));
  if (isBigInt(e))
    return markBoxed(w(bigIntValueOf.call(e)));
  if (isBoolean$1(e))
    return markBoxed(booleanValueOf.call(e));
  if (isString$3(e))
    return markBoxed(w(String(e)));
  if (!isDate$1(e) && !isRegExp$3(e)) {
    var P = arrObjKeys(e, w), z = gPO ? gPO(e) === Object.prototype : e instanceof Object || e.constructor === Object, W = e instanceof Object ? "" : "null prototype", A = !z && toStringTag && Object(e) === e && toStringTag in e ? $slice.call(toStr(e), 8, -1) : W ? "Object" : "", S = z || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", F = S + (A || W ? "[" + $join.call($concat.call([], A || [], W || []), ": ") + "] " : "");
    return P.length === 0 ? F + "{}" : x ? F + "{" + indentedJoin(P, x) + "}" : F + "{ " + $join.call(P, ", ") + " }";
  }
  return String(e);
};
function wrapQuotes(t, e, r) {
  var o = (r.quoteStyle || e) === "double" ? '"' : "'";
  return o + t + o;
}
function quote(t) {
  return $replace.call(String(t), /"/g, "&quot;");
}
function isArray$4(t) {
  return toStr(t) === "[object Array]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isDate$1(t) {
  return toStr(t) === "[object Date]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isRegExp$3(t) {
  return toStr(t) === "[object RegExp]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isError$1(t) {
  return toStr(t) === "[object Error]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isString$3(t) {
  return toStr(t) === "[object String]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isNumber$1(t) {
  return toStr(t) === "[object Number]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isBoolean$1(t) {
  return toStr(t) === "[object Boolean]" && (!toStringTag || !(typeof t == "object" && toStringTag in t));
}
function isSymbol(t) {
  if (hasShammedSymbols)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !symToString)
    return !1;
  try {
    return symToString.call(t), !0;
  } catch {
  }
  return !1;
}
function isBigInt(t) {
  if (!t || typeof t != "object" || !bigIntValueOf)
    return !1;
  try {
    return bigIntValueOf.call(t), !0;
  } catch {
  }
  return !1;
}
var hasOwn$1 = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function has$4(t, e) {
  return hasOwn$1.call(t, e);
}
function toStr(t) {
  return objectToString$1.call(t);
}
function nameOf(t) {
  if (t.name)
    return t.name;
  var e = $match.call(functionToString.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function indexOf(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, o = t.length; r < o; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function isMap(t) {
  if (!mapSize || !t || typeof t != "object")
    return !1;
  try {
    mapSize.call(t);
    try {
      setSize.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function isWeakMap(t) {
  if (!weakMapHas || !t || typeof t != "object")
    return !1;
  try {
    weakMapHas.call(t, weakMapHas);
    try {
      weakSetHas.call(t, weakSetHas);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function isWeakRef(t) {
  if (!weakRefDeref || !t || typeof t != "object")
    return !1;
  try {
    return weakRefDeref.call(t), !0;
  } catch {
  }
  return !1;
}
function isSet(t) {
  if (!setSize || !t || typeof t != "object")
    return !1;
  try {
    setSize.call(t);
    try {
      mapSize.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function isWeakSet(t) {
  if (!weakSetHas || !t || typeof t != "object")
    return !1;
  try {
    weakSetHas.call(t, weakSetHas);
    try {
      weakMapHas.call(t, weakMapHas);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function isElement(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function inspectString(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, o = "... " + r + " more character" + (r > 1 ? "s" : "");
    return inspectString($slice.call(t, 0, e.maxStringLength), e) + o;
  }
  var a = $replace.call($replace.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(a, "single", e);
}
function lowbyte(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + $toUpperCase.call(e.toString(16));
}
function markBoxed(t) {
  return "Object(" + t + ")";
}
function weakCollectionOf(t) {
  return t + " { ? }";
}
function collectionOf(t, e, r, o) {
  var a = o ? indentedJoin(r, o) : $join.call(r, ", ");
  return t + " (" + e + ") {" + a + "}";
}
function singleLineValues(t) {
  for (var e = 0; e < t.length; e++)
    if (indexOf(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function getIndent(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = $join.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: $join.call(Array(e + 1), r)
  };
}
function indentedJoin(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + $join.call(t, "," + r) + `
` + e.prev;
}
function arrObjKeys(t, e) {
  var r = isArray$4(t), o = [];
  if (r) {
    o.length = t.length;
    for (var a = 0; a < t.length; a++)
      o[a] = has$4(t, a) ? e(t[a], t) : "";
  }
  var c = typeof gOPS == "function" ? gOPS(t) : [], u;
  if (hasShammedSymbols) {
    u = {};
    for (var d = 0; d < c.length; d++)
      u["$" + c[d]] = c[d];
  }
  for (var p in t)
    has$4(t, p) && (r && String(Number(p)) === p && p < t.length || hasShammedSymbols && u["$" + p] instanceof Symbol || ($test.call(/[^\w$]/, p) ? o.push(e(p, t) + ": " + e(t[p], t)) : o.push(p + ": " + e(t[p], t))));
  if (typeof gOPS == "function")
    for (var g = 0; g < c.length; g++)
      isEnumerable.call(t, c[g]) && o.push("[" + e(c[g]) + "]: " + e(t[c[g]], t));
  return o;
}
var GetIntrinsic = getIntrinsic, callBound = callBound$1, inspect = objectInspect, $TypeError = GetIntrinsic("%TypeError%"), $WeakMap = GetIntrinsic("%WeakMap%", !0), $Map = GetIntrinsic("%Map%", !0), $weakMapGet = callBound("WeakMap.prototype.get", !0), $weakMapSet = callBound("WeakMap.prototype.set", !0), $weakMapHas = callBound("WeakMap.prototype.has", !0), $mapGet = callBound("Map.prototype.get", !0), $mapSet = callBound("Map.prototype.set", !0), $mapHas = callBound("Map.prototype.has", !0), listGetNode = function(t, e) {
  for (var r = t, o; (o = r.next) !== null; r = o)
    if (o.key === e)
      return r.next = o.next, o.next = t.next, t.next = o, o;
}, listGet = function(t, e) {
  var r = listGetNode(t, e);
  return r && r.value;
}, listSet = function(t, e, r) {
  var o = listGetNode(t, e);
  o ? o.value = r : t.next = {
    // eslint-disable-line no-param-reassign
    key: e,
    next: t.next,
    value: r
  };
}, listHas = function(t, e) {
  return !!listGetNode(t, e);
}, sideChannel = function() {
  var e, r, o, a = {
    assert: function(c) {
      if (!a.has(c))
        throw new $TypeError("Side channel does not contain " + inspect(c));
    },
    get: function(c) {
      if ($WeakMap && c && (typeof c == "object" || typeof c == "function")) {
        if (e)
          return $weakMapGet(e, c);
      } else if ($Map) {
        if (r)
          return $mapGet(r, c);
      } else if (o)
        return listGet(o, c);
    },
    has: function(c) {
      if ($WeakMap && c && (typeof c == "object" || typeof c == "function")) {
        if (e)
          return $weakMapHas(e, c);
      } else if ($Map) {
        if (r)
          return $mapHas(r, c);
      } else if (o)
        return listHas(o, c);
      return !1;
    },
    set: function(c, u) {
      $WeakMap && c && (typeof c == "object" || typeof c == "function") ? (e || (e = new $WeakMap()), $weakMapSet(e, c, u)) : $Map ? (r || (r = new $Map()), $mapSet(r, c, u)) : (o || (o = { key: {}, next: null }), listSet(o, c, u));
    }
  };
  return a;
}, replace = String.prototype.replace, percentTwenties = /%20/g, Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, formats$3 = {
  default: Format.RFC3986,
  formatters: {
    RFC1738: function(t) {
      return replace.call(t, percentTwenties, "+");
    },
    RFC3986: function(t) {
      return String(t);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
}, formats$2 = formats$3, has$3 = Object.prototype.hasOwnProperty, isArray$3 = Array.isArray, hexTable = function() {
  for (var t = [], e = 0; e < 256; ++e)
    t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return t;
}(), compactQueue = function(e) {
  for (; e.length > 1; ) {
    var r = e.pop(), o = r.obj[r.prop];
    if (isArray$3(o)) {
      for (var a = [], c = 0; c < o.length; ++c)
        typeof o[c] < "u" && a.push(o[c]);
      r.obj[r.prop] = a;
    }
  }
}, arrayToObject = function(e, r) {
  for (var o = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < e.length; ++a)
    typeof e[a] < "u" && (o[a] = e[a]);
  return o;
}, merge = function t(e, r, o) {
  if (!r)
    return e;
  if (typeof r != "object") {
    if (isArray$3(e))
      e.push(r);
    else if (e && typeof e == "object")
      (o && (o.plainObjects || o.allowPrototypes) || !has$3.call(Object.prototype, r)) && (e[r] = !0);
    else
      return [e, r];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(r);
  var a = e;
  return isArray$3(e) && !isArray$3(r) && (a = arrayToObject(e, o)), isArray$3(e) && isArray$3(r) ? (r.forEach(function(c, u) {
    if (has$3.call(e, u)) {
      var d = e[u];
      d && typeof d == "object" && c && typeof c == "object" ? e[u] = t(d, c, o) : e.push(c);
    } else
      e[u] = c;
  }), e) : Object.keys(r).reduce(function(c, u) {
    var d = r[u];
    return has$3.call(c, u) ? c[u] = t(c[u], d, o) : c[u] = d, c;
  }, a);
}, assign$4 = function(e, r) {
  return Object.keys(r).reduce(function(o, a) {
    return o[a] = r[a], o;
  }, e);
}, decode$2 = function(t, e, r) {
  var o = t.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return o.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(o);
  } catch {
    return o;
  }
}, encode$3 = function(e, r, o, a, c) {
  if (e.length === 0)
    return e;
  var u = e;
  if (typeof e == "symbol" ? u = Symbol.prototype.toString.call(e) : typeof e != "string" && (u = String(e)), o === "iso-8859-1")
    return escape(u).replace(/%u[0-9a-f]{4}/gi, function(b) {
      return "%26%23" + parseInt(b.slice(2), 16) + "%3B";
    });
  for (var d = "", p = 0; p < u.length; ++p) {
    var g = u.charCodeAt(p);
    if (g === 45 || g === 46 || g === 95 || g === 126 || g >= 48 && g <= 57 || g >= 65 && g <= 90 || g >= 97 && g <= 122 || c === formats$2.RFC1738 && (g === 40 || g === 41)) {
      d += u.charAt(p);
      continue;
    }
    if (g < 128) {
      d = d + hexTable[g];
      continue;
    }
    if (g < 2048) {
      d = d + (hexTable[192 | g >> 6] + hexTable[128 | g & 63]);
      continue;
    }
    if (g < 55296 || g >= 57344) {
      d = d + (hexTable[224 | g >> 12] + hexTable[128 | g >> 6 & 63] + hexTable[128 | g & 63]);
      continue;
    }
    p += 1, g = 65536 + ((g & 1023) << 10 | u.charCodeAt(p) & 1023), d += hexTable[240 | g >> 18] + hexTable[128 | g >> 12 & 63] + hexTable[128 | g >> 6 & 63] + hexTable[128 | g & 63];
  }
  return d;
}, compact = function(e) {
  for (var r = [{ obj: { o: e }, prop: "o" }], o = [], a = 0; a < r.length; ++a)
    for (var c = r[a], u = c.obj[c.prop], d = Object.keys(u), p = 0; p < d.length; ++p) {
      var g = d[p], b = u[g];
      typeof b == "object" && b !== null && o.indexOf(b) === -1 && (r.push({ obj: u, prop: g }), o.push(b));
    }
  return compactQueue(r), e;
}, isRegExp$2 = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, isBuffer = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, combine = function(e, r) {
  return [].concat(e, r);
}, maybeMap = function(e, r) {
  if (isArray$3(e)) {
    for (var o = [], a = 0; a < e.length; a += 1)
      o.push(r(e[a]));
    return o;
  }
  return r(e);
}, utils$4 = {
  arrayToObject,
  assign: assign$4,
  combine,
  compact,
  decode: decode$2,
  encode: encode$3,
  isBuffer,
  isRegExp: isRegExp$2,
  maybeMap,
  merge
}, getSideChannel = sideChannel, utils$3 = utils$4, formats$1 = formats$3, has$2 = Object.prototype.hasOwnProperty, arrayPrefixGenerators = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, r) {
    return e + "[" + r + "]";
  },
  repeat: function(e) {
    return e;
  }
}, isArray$2 = Array.isArray, push = Array.prototype.push, pushToArray = function(t, e) {
  push.apply(t, isArray$2(e) ? e : [e]);
}, toISO = Date.prototype.toISOString, defaultFormat = formats$1.default, defaults$1 = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: utils$3.encode,
  encodeValuesOnly: !1,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return toISO.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, isNonNullishPrimitive = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, sentinel = {}, stringify$1 = function t(e, r, o, a, c, u, d, p, g, b, x, w, y, I, E, T) {
  for (var C = e, $ = T, D = 0, L = !1; ($ = $.get(sentinel)) !== void 0 && !L; ) {
    var R = $.get(e);
    if (D += 1, typeof R < "u") {
      if (R === D)
        throw new RangeError("Cyclic object value");
      L = !0;
    }
    typeof $.get(sentinel) > "u" && (D = 0);
  }
  if (typeof p == "function" ? C = p(r, C) : C instanceof Date ? C = x(C) : o === "comma" && isArray$2(C) && (C = utils$3.maybeMap(C, function(G) {
    return G instanceof Date ? x(G) : G;
  })), C === null) {
    if (c)
      return d && !I ? d(r, defaults$1.encoder, E, "key", w) : r;
    C = "";
  }
  if (isNonNullishPrimitive(C) || utils$3.isBuffer(C)) {
    if (d) {
      var O = I ? r : d(r, defaults$1.encoder, E, "key", w);
      return [y(O) + "=" + y(d(C, defaults$1.encoder, E, "value", w))];
    }
    return [y(r) + "=" + y(String(C))];
  }
  var P = [];
  if (typeof C > "u")
    return P;
  var z;
  if (o === "comma" && isArray$2(C))
    I && d && (C = utils$3.maybeMap(C, d)), z = [{ value: C.length > 0 ? C.join(",") || null : void 0 }];
  else if (isArray$2(p))
    z = p;
  else {
    var W = Object.keys(C);
    z = g ? W.sort(g) : W;
  }
  for (var A = a && isArray$2(C) && C.length === 1 ? r + "[]" : r, S = 0; S < z.length; ++S) {
    var F = z[S], U = typeof F == "object" && typeof F.value < "u" ? F.value : C[F];
    if (!(u && U === null)) {
      var M = isArray$2(C) ? typeof o == "function" ? o(A, F) : A : A + (b ? "." + F : "[" + F + "]");
      T.set(e, D);
      var V = getSideChannel();
      V.set(sentinel, T), pushToArray(P, t(
        U,
        M,
        o,
        a,
        c,
        u,
        o === "comma" && I && isArray$2(C) ? null : d,
        p,
        g,
        b,
        x,
        w,
        y,
        I,
        E,
        V
      ));
    }
  }
  return P;
}, normalizeStringifyOptions = function(e) {
  if (!e)
    return defaults$1;
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = e.charset || defaults$1.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var o = formats$1.default;
  if (typeof e.format < "u") {
    if (!has$2.call(formats$1.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    o = e.format;
  }
  var a = formats$1.formatters[o], c = defaults$1.filter;
  return (typeof e.filter == "function" || isArray$2(e.filter)) && (c = e.filter), {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: typeof e.allowDots > "u" ? defaults$1.allowDots : !!e.allowDots,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : defaults$1.charsetSentinel,
    delimiter: typeof e.delimiter > "u" ? defaults$1.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : defaults$1.encode,
    encoder: typeof e.encoder == "function" ? e.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter: c,
    format: o,
    formatter: a,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : defaults$1.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : defaults$1.strictNullHandling
  };
}, stringify_1 = function(t, e) {
  var r = t, o = normalizeStringifyOptions(e), a, c;
  typeof o.filter == "function" ? (c = o.filter, r = c("", r)) : isArray$2(o.filter) && (c = o.filter, a = c);
  var u = [];
  if (typeof r != "object" || r === null)
    return "";
  var d;
  e && e.arrayFormat in arrayPrefixGenerators ? d = e.arrayFormat : e && "indices" in e ? d = e.indices ? "indices" : "repeat" : d = "indices";
  var p = arrayPrefixGenerators[d];
  if (e && "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var g = p === "comma" && e && e.commaRoundTrip;
  a || (a = Object.keys(r)), o.sort && a.sort(o.sort);
  for (var b = getSideChannel(), x = 0; x < a.length; ++x) {
    var w = a[x];
    o.skipNulls && r[w] === null || pushToArray(u, stringify$1(
      r[w],
      w,
      p,
      g,
      o.strictNullHandling,
      o.skipNulls,
      o.encode ? o.encoder : null,
      o.filter,
      o.sort,
      o.allowDots,
      o.serializeDate,
      o.format,
      o.formatter,
      o.encodeValuesOnly,
      o.charset,
      b
    ));
  }
  var y = u.join(o.delimiter), I = o.addQueryPrefix === !0 ? "?" : "";
  return o.charsetSentinel && (o.charset === "iso-8859-1" ? I += "utf8=%26%2310003%3B&" : I += "utf8=%E2%9C%93&"), y.length > 0 ? I + y : "";
}, utils$2 = utils$4, has$1 = Object.prototype.hasOwnProperty, isArray$1 = Array.isArray, defaults = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: utils$2.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, interpretNumericEntities = function(t) {
  return t.replace(/&#(\d+);/g, function(e, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, parseArrayValue = function(t, e) {
  return t && typeof t == "string" && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
}, isoSentinel = "utf8=%26%2310003%3B", charsetSentinel = "utf8=%E2%9C%93", parseValues = function(e, r) {
  var o = { __proto__: null }, a = r.ignoreQueryPrefix ? e.replace(/^\?/, "") : e, c = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, u = a.split(r.delimiter, c), d = -1, p, g = r.charset;
  if (r.charsetSentinel)
    for (p = 0; p < u.length; ++p)
      u[p].indexOf("utf8=") === 0 && (u[p] === charsetSentinel ? g = "utf-8" : u[p] === isoSentinel && (g = "iso-8859-1"), d = p, p = u.length);
  for (p = 0; p < u.length; ++p)
    if (p !== d) {
      var b = u[p], x = b.indexOf("]="), w = x === -1 ? b.indexOf("=") : x + 1, y, I;
      w === -1 ? (y = r.decoder(b, defaults.decoder, g, "key"), I = r.strictNullHandling ? null : "") : (y = r.decoder(b.slice(0, w), defaults.decoder, g, "key"), I = utils$2.maybeMap(
        parseArrayValue(b.slice(w + 1), r),
        function(E) {
          return r.decoder(E, defaults.decoder, g, "value");
        }
      )), I && r.interpretNumericEntities && g === "iso-8859-1" && (I = interpretNumericEntities(I)), b.indexOf("[]=") > -1 && (I = isArray$1(I) ? [I] : I), has$1.call(o, y) ? o[y] = utils$2.combine(o[y], I) : o[y] = I;
    }
  return o;
}, parseObject = function(t, e, r, o) {
  for (var a = o ? e : parseArrayValue(e, r), c = t.length - 1; c >= 0; --c) {
    var u, d = t[c];
    if (d === "[]" && r.parseArrays)
      u = [].concat(a);
    else {
      u = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var p = d.charAt(0) === "[" && d.charAt(d.length - 1) === "]" ? d.slice(1, -1) : d, g = parseInt(p, 10);
      !r.parseArrays && p === "" ? u = { 0: a } : !isNaN(g) && d !== p && String(g) === p && g >= 0 && r.parseArrays && g <= r.arrayLimit ? (u = [], u[g] = a) : p !== "__proto__" && (u[p] = a);
    }
    a = u;
  }
  return a;
}, parseKeys = function(e, r, o, a) {
  if (e) {
    var c = o.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, u = /(\[[^[\]]*])/, d = /(\[[^[\]]*])/g, p = o.depth > 0 && u.exec(c), g = p ? c.slice(0, p.index) : c, b = [];
    if (g) {
      if (!o.plainObjects && has$1.call(Object.prototype, g) && !o.allowPrototypes)
        return;
      b.push(g);
    }
    for (var x = 0; o.depth > 0 && (p = d.exec(c)) !== null && x < o.depth; ) {
      if (x += 1, !o.plainObjects && has$1.call(Object.prototype, p[1].slice(1, -1)) && !o.allowPrototypes)
        return;
      b.push(p[1]);
    }
    return p && b.push("[" + c.slice(p.index) + "]"), parseObject(b, r, o, a);
  }
}, normalizeParseOptions = function(e) {
  if (!e)
    return defaults;
  if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof e.charset > "u" ? defaults.charset : e.charset;
  return {
    allowDots: typeof e.allowDots > "u" ? defaults.allowDots : !!e.allowDots,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : defaults.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : defaults.arrayLimit,
    charset: r,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : defaults.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : defaults.comma,
    decoder: typeof e.decoder == "function" ? e.decoder : defaults.decoder,
    delimiter: typeof e.delimiter == "string" || utils$2.isRegExp(e.delimiter) ? e.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : defaults.depth,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : defaults.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : defaults.strictNullHandling
  };
}, parse$3 = function(t, e) {
  var r = normalizeParseOptions(e);
  if (t === "" || t === null || typeof t > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var o = typeof t == "string" ? parseValues(t, r) : t, a = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, c = Object.keys(o), u = 0; u < c.length; ++u) {
    var d = c[u], p = parseKeys(d, o[d], r, typeof t == "string");
    a = utils$2.merge(a, p, r);
  }
  return r.allowSparse === !0 ? a : utils$2.compact(a);
}, stringify = stringify_1, parse$2 = parse$3, formats = formats$3, lib$1 = {
  formats,
  parse: parse$2,
  stringify
}, isMergeableObject = function(e) {
  return isNonNullObject(e) && !isSpecial(e);
};
function isNonNullObject(t) {
  return !!t && typeof t == "object";
}
function isSpecial(t) {
  var e = Object.prototype.toString.call(t);
  return e === "[object RegExp]" || e === "[object Date]" || isReactElement(t);
}
var canUseSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(t) {
  return t.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(t) {
  return Array.isArray(t) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(t, e) {
  return e.clone !== !1 && e.isMergeableObject(t) ? deepmerge(emptyTarget(t), t, e) : t;
}
function defaultArrayMerge(t, e, r) {
  return t.concat(e).map(function(o) {
    return cloneUnlessOtherwiseSpecified(o, r);
  });
}
function getMergeFunction(t, e) {
  if (!e.customMerge)
    return deepmerge;
  var r = e.customMerge(t);
  return typeof r == "function" ? r : deepmerge;
}
function getEnumerableOwnPropertySymbols(t) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function(e) {
    return Object.propertyIsEnumerable.call(t, e);
  }) : [];
}
function getKeys(t) {
  return Object.keys(t).concat(getEnumerableOwnPropertySymbols(t));
}
function propertyIsOnObject(t, e) {
  try {
    return e in t;
  } catch {
    return !1;
  }
}
function propertyIsUnsafe(t, e) {
  return propertyIsOnObject(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
}
function mergeObject(t, e, r) {
  var o = {};
  return r.isMergeableObject(t) && getKeys(t).forEach(function(a) {
    o[a] = cloneUnlessOtherwiseSpecified(t[a], r);
  }), getKeys(e).forEach(function(a) {
    propertyIsUnsafe(t, a) || (propertyIsOnObject(t, a) && r.isMergeableObject(e[a]) ? o[a] = getMergeFunction(a, r)(t[a], e[a], r) : o[a] = cloneUnlessOtherwiseSpecified(e[a], r));
  }), o;
}
function deepmerge(t, e, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || defaultArrayMerge, r.isMergeableObject = r.isMergeableObject || isMergeableObject, r.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var o = Array.isArray(e), a = Array.isArray(t), c = o === a;
  return c ? o ? r.arrayMerge(t, e, r) : mergeObject(t, e, r) : cloneUnlessOtherwiseSpecified(e, r);
}
deepmerge.all = function(e, r) {
  if (!Array.isArray(e))
    throw new Error("first argument should be an array");
  return e.reduce(function(o, a) {
    return deepmerge(o, a, r);
  }, {});
};
var deepmerge_1 = deepmerge, cjs = deepmerge_1;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "axios", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), t.default = t.client = void 0, t.getConfig = A, t.init = z, t.initialise = W, t.resetConfig = P, t.updateInstanceUrl = O, t.updateToken = R;
  var e = u(axios), r = require$$1, o = cacheExports, a = u(lib$1), c = u(cjs);
  function u(M) {
    return M && M.__esModule ? M : { default: M };
  }
  function d(M) {
    "@babel/helpers - typeof";
    return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(V) {
      return typeof V;
    } : function(V) {
      return V && typeof Symbol == "function" && V.constructor === Symbol && V !== Symbol.prototype ? "symbol" : typeof V;
    }, d(M);
  }
  function p(M, V) {
    var G = Object.keys(M);
    if (Object.getOwnPropertySymbols) {
      var Q = Object.getOwnPropertySymbols(M);
      V && (Q = Q.filter(function(fe) {
        return Object.getOwnPropertyDescriptor(M, fe).enumerable;
      })), G.push.apply(G, Q);
    }
    return G;
  }
  function g(M) {
    for (var V = 1; V < arguments.length; V++) {
      var G = arguments[V] != null ? arguments[V] : {};
      V % 2 ? p(Object(G), !0).forEach(function(Q) {
        b(M, Q, G[Q]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(G)) : p(Object(G)).forEach(function(Q) {
        Object.defineProperty(M, Q, Object.getOwnPropertyDescriptor(G, Q));
      });
    }
    return M;
  }
  function b(M, V, G) {
    return V in M ? Object.defineProperty(M, V, { value: G, enumerable: !0, configurable: !0, writable: !0 }) : M[V] = G, M;
  }
  function x() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    x = function() {
      return M;
    };
    var M = {}, V = Object.prototype, G = V.hasOwnProperty, Q = typeof Symbol == "function" ? Symbol : {}, fe = Q.iterator || "@@iterator", te = Q.asyncIterator || "@@asyncIterator", de = Q.toStringTag || "@@toStringTag";
    function me(ke, xe, Ne) {
      return Object.defineProperty(ke, xe, { value: Ne, enumerable: !0, configurable: !0, writable: !0 }), ke[xe];
    }
    try {
      me({}, "");
    } catch {
      me = function(Ne, Se, ie) {
        return Ne[Se] = ie;
      };
    }
    function Me(ke, xe, Ne, Se) {
      var ie = xe && xe.prototype instanceof be ? xe : be, he = Object.create(ie.prototype), Ye = new Le(Se || []);
      return he._invoke = function(et, bt, $e) {
        var Ee = "suspendedStart";
        return function(Ie, ze) {
          if (Ee === "executing")
            throw new Error("Generator is already running");
          if (Ee === "completed") {
            if (Ie === "throw")
              throw ze;
            return Ct();
          }
          for ($e.method = Ie, $e.arg = ze; ; ) {
            var ct = $e.delegate;
            if (ct) {
              var st = q(ct, $e);
              if (st) {
                if (st === oe)
                  continue;
                return st;
              }
            }
            if ($e.method === "next")
              $e.sent = $e._sent = $e.arg;
            else if ($e.method === "throw") {
              if (Ee === "suspendedStart")
                throw Ee = "completed", $e.arg;
              $e.dispatchException($e.arg);
            } else
              $e.method === "return" && $e.abrupt("return", $e.arg);
            Ee = "executing";
            var ht = ce(et, bt, $e);
            if (ht.type === "normal") {
              if (Ee = $e.done ? "completed" : "suspendedYield", ht.arg === oe)
                continue;
              return { value: ht.arg, done: $e.done };
            }
            ht.type === "throw" && (Ee = "completed", $e.method = "throw", $e.arg = ht.arg);
          }
        };
      }(ke, Ne, Ye), he;
    }
    function ce(ke, xe, Ne) {
      try {
        return { type: "normal", arg: ke.call(xe, Ne) };
      } catch (Se) {
        return { type: "throw", arg: Se };
      }
    }
    M.wrap = Me;
    var oe = {};
    function be() {
    }
    function Te() {
    }
    function Ae() {
    }
    var je = {};
    me(je, fe, function() {
      return this;
    });
    var Xe = Object.getPrototypeOf, He = Xe && Xe(Xe(qe([])));
    He && He !== V && G.call(He, fe) && (je = He);
    var Ke = Ae.prototype = be.prototype = Object.create(je);
    function ot(ke) {
      ["next", "throw", "return"].forEach(function(xe) {
        me(ke, xe, function(Ne) {
          return this._invoke(xe, Ne);
        });
      });
    }
    function K(ke, xe) {
      function Ne(ie, he, Ye, et) {
        var bt = ce(ke[ie], ke, he);
        if (bt.type !== "throw") {
          var $e = bt.arg, Ee = $e.value;
          return Ee && d(Ee) == "object" && G.call(Ee, "__await") ? xe.resolve(Ee.__await).then(function(Ie) {
            Ne("next", Ie, Ye, et);
          }, function(Ie) {
            Ne("throw", Ie, Ye, et);
          }) : xe.resolve(Ee).then(function(Ie) {
            $e.value = Ie, Ye($e);
          }, function(Ie) {
            return Ne("throw", Ie, Ye, et);
          });
        }
        et(bt.arg);
      }
      var Se;
      this._invoke = function(ie, he) {
        function Ye() {
          return new xe(function(et, bt) {
            Ne(ie, he, et, bt);
          });
        }
        return Se = Se ? Se.then(Ye, Ye) : Ye();
      };
    }
    function q(ke, xe) {
      var Ne = ke.iterator[xe.method];
      if (Ne === void 0) {
        if (xe.delegate = null, xe.method === "throw") {
          if (ke.iterator.return && (xe.method = "return", xe.arg = void 0, q(ke, xe), xe.method === "throw"))
            return oe;
          xe.method = "throw", xe.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return oe;
      }
      var Se = ce(Ne, ke.iterator, xe.arg);
      if (Se.type === "throw")
        return xe.method = "throw", xe.arg = Se.arg, xe.delegate = null, oe;
      var ie = Se.arg;
      return ie ? ie.done ? (xe[ke.resultName] = ie.value, xe.next = ke.nextLoc, xe.method !== "return" && (xe.method = "next", xe.arg = void 0), xe.delegate = null, oe) : ie : (xe.method = "throw", xe.arg = new TypeError("iterator result is not an object"), xe.delegate = null, oe);
    }
    function se(ke) {
      var xe = { tryLoc: ke[0] };
      1 in ke && (xe.catchLoc = ke[1]), 2 in ke && (xe.finallyLoc = ke[2], xe.afterLoc = ke[3]), this.tryEntries.push(xe);
    }
    function Ce(ke) {
      var xe = ke.completion || {};
      xe.type = "normal", delete xe.arg, ke.completion = xe;
    }
    function Le(ke) {
      this.tryEntries = [{ tryLoc: "root" }], ke.forEach(se, this), this.reset(!0);
    }
    function qe(ke) {
      if (ke) {
        var xe = ke[fe];
        if (xe)
          return xe.call(ke);
        if (typeof ke.next == "function")
          return ke;
        if (!isNaN(ke.length)) {
          var Ne = -1, Se = function ie() {
            for (; ++Ne < ke.length; )
              if (G.call(ke, Ne))
                return ie.value = ke[Ne], ie.done = !1, ie;
            return ie.value = void 0, ie.done = !0, ie;
          };
          return Se.next = Se;
        }
      }
      return { next: Ct };
    }
    function Ct() {
      return { value: void 0, done: !0 };
    }
    return Te.prototype = Ae, me(Ke, "constructor", Ae), me(Ae, "constructor", Te), Te.displayName = me(Ae, de, "GeneratorFunction"), M.isGeneratorFunction = function(ke) {
      var xe = typeof ke == "function" && ke.constructor;
      return !!xe && (xe === Te || (xe.displayName || xe.name) === "GeneratorFunction");
    }, M.mark = function(ke) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(ke, Ae) : (ke.__proto__ = Ae, me(ke, de, "GeneratorFunction")), ke.prototype = Object.create(Ke), ke;
    }, M.awrap = function(ke) {
      return { __await: ke };
    }, ot(K.prototype), me(K.prototype, te, function() {
      return this;
    }), M.AsyncIterator = K, M.async = function(ke, xe, Ne, Se, ie) {
      ie === void 0 && (ie = Promise);
      var he = new K(Me(ke, xe, Ne, Se), ie);
      return M.isGeneratorFunction(xe) ? he : he.next().then(function(Ye) {
        return Ye.done ? Ye.value : he.next();
      });
    }, ot(Ke), me(Ke, de, "Generator"), me(Ke, fe, function() {
      return this;
    }), me(Ke, "toString", function() {
      return "[object Generator]";
    }), M.keys = function(ke) {
      var xe = [];
      for (var Ne in ke)
        xe.push(Ne);
      return xe.reverse(), function Se() {
        for (; xe.length; ) {
          var ie = xe.pop();
          if (ie in ke)
            return Se.value = ie, Se.done = !1, Se;
        }
        return Se.done = !0, Se;
      };
    }, M.values = qe, Le.prototype = { constructor: Le, reset: function(xe) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(Ce), !xe)
        for (var Ne in this)
          Ne.charAt(0) === "t" && G.call(this, Ne) && !isNaN(+Ne.slice(1)) && (this[Ne] = void 0);
    }, stop: function() {
      this.done = !0;
      var xe = this.tryEntries[0].completion;
      if (xe.type === "throw")
        throw xe.arg;
      return this.rval;
    }, dispatchException: function(xe) {
      if (this.done)
        throw xe;
      var Ne = this;
      function Se($e, Ee) {
        return Ye.type = "throw", Ye.arg = xe, Ne.next = $e, Ee && (Ne.method = "next", Ne.arg = void 0), !!Ee;
      }
      for (var ie = this.tryEntries.length - 1; ie >= 0; --ie) {
        var he = this.tryEntries[ie], Ye = he.completion;
        if (he.tryLoc === "root")
          return Se("end");
        if (he.tryLoc <= this.prev) {
          var et = G.call(he, "catchLoc"), bt = G.call(he, "finallyLoc");
          if (et && bt) {
            if (this.prev < he.catchLoc)
              return Se(he.catchLoc, !0);
            if (this.prev < he.finallyLoc)
              return Se(he.finallyLoc);
          } else if (et) {
            if (this.prev < he.catchLoc)
              return Se(he.catchLoc, !0);
          } else {
            if (!bt)
              throw new Error("try statement without catch or finally");
            if (this.prev < he.finallyLoc)
              return Se(he.finallyLoc);
          }
        }
      }
    }, abrupt: function(xe, Ne) {
      for (var Se = this.tryEntries.length - 1; Se >= 0; --Se) {
        var ie = this.tryEntries[Se];
        if (ie.tryLoc <= this.prev && G.call(ie, "finallyLoc") && this.prev < ie.finallyLoc) {
          var he = ie;
          break;
        }
      }
      he && (xe === "break" || xe === "continue") && he.tryLoc <= Ne && Ne <= he.finallyLoc && (he = null);
      var Ye = he ? he.completion : {};
      return Ye.type = xe, Ye.arg = Ne, he ? (this.method = "next", this.next = he.finallyLoc, oe) : this.complete(Ye);
    }, complete: function(xe, Ne) {
      if (xe.type === "throw")
        throw xe.arg;
      return xe.type === "break" || xe.type === "continue" ? this.next = xe.arg : xe.type === "return" ? (this.rval = this.arg = xe.arg, this.method = "return", this.next = "end") : xe.type === "normal" && Ne && (this.next = Ne), oe;
    }, finish: function(xe) {
      for (var Ne = this.tryEntries.length - 1; Ne >= 0; --Ne) {
        var Se = this.tryEntries[Ne];
        if (Se.finallyLoc === xe)
          return this.complete(Se.completion, Se.afterLoc), Ce(Se), oe;
      }
    }, catch: function(xe) {
      for (var Ne = this.tryEntries.length - 1; Ne >= 0; --Ne) {
        var Se = this.tryEntries[Ne];
        if (Se.tryLoc === xe) {
          var ie = Se.completion;
          if (ie.type === "throw") {
            var he = ie.arg;
            Ce(Se);
          }
          return he;
        }
      }
      throw new Error("illegal catch attempt");
    }, delegateYield: function(xe, Ne, Se) {
      return this.delegate = { iterator: qe(xe), resultName: Ne, nextLoc: Se }, this.method === "next" && (this.arg = void 0), oe;
    } }, M;
  }
  function w(M, V, G, Q, fe, te, de) {
    try {
      var me = M[te](de), Me = me.value;
    } catch (ce) {
      G(ce);
      return;
    }
    me.done ? V(Me) : Promise.resolve(Me).then(Q, fe);
  }
  function y(M) {
    return function() {
      var V = this, G = arguments;
      return new Promise(function(Q, fe) {
        var te = M.apply(V, G);
        function de(Me) {
          w(te, Q, fe, de, me, "next", Me);
        }
        function me(Me) {
          w(te, Q, fe, de, me, "throw", Me);
        }
        de(void 0);
      });
    };
  }
  var I = /* @__PURE__ */ function() {
    var M = y(/* @__PURE__ */ x().mark(function V(G) {
      return x().wrap(function(fe) {
        for (; ; )
          switch (fe.prev = fe.next) {
            case 0:
              return D.token && (G.headers.Authorization = "Bearer " + D.token, G.headers["Content-Type"] = "application/json"), fe.abrupt("return", G);
            case 2:
            case "end":
              return fe.stop();
          }
      }, V);
    }));
    return function(G) {
      return M.apply(this, arguments);
    };
  }(), E = {}, T = function(V) {
    return D.events.responseSuccess && D.events.responseSuccess(V), V;
  }, C = function(V) {
    if (D.events.responseError && D.events.responseError(V), V.response) {
      var G = V.response.status;
      G == r.StatusCodes.UNAUTHORIZED && D.events.unauthorised && D.events.unauthorised(V);
    }
    return Promise.reject(V);
  }, $ = {
    token: "",
    instanceUrl: "",
    cacheMaxAge: 0,
    events: {
      unauthorised: void 0,
      responseSuccess: void 0,
      responseError: void 0,
      queueTask: void 0
    },
    interceptor: {
      request: I,
      response: {
        success: T,
        error: C
      }
    }
  }, D = g({}, $), L = function(V) {
    var G = Object.keys(V).reduce(function(Q, fe) {
      var te = V[fe];
      return d(te) === "object" && !Array.isArray(te) && te !== null && (te = JSON.stringify(te)), Q[fe] = te, Q;
    }, {});
    return a.default.stringify(G, {
      arrayFormat: "repeat"
    });
  };
  function R(M) {
    D.token = M;
  }
  function O(M) {
    D.instanceUrl = M;
  }
  function P() {
    D = g({}, $);
  }
  function z(M, V, G) {
    D.token = M, D.instanceUrl = V, D.cacheMaxAge = G;
  }
  function W(M) {
    E = M, D = (0, c.default)(D, M), e.default.interceptors.request.use(D.interceptor.request), e.default.interceptors.response.use(D.interceptor.response.success, D.interceptor.response.error);
  }
  function A() {
    return E;
  }
  e.default.interceptors.request.use(D.interceptor.request), e.default.interceptors.response.use(D.interceptor.response.success, D.interceptor.response.error);
  var S = (0, o.setupCache)({
    maxAge: D.cacheMaxAge * 1e3
  }), F = /* @__PURE__ */ function() {
    var M = y(/* @__PURE__ */ x().mark(function V(G) {
      var Q;
      return x().wrap(function(te) {
        for (; ; )
          switch (te.prev = te.next) {
            case 0:
              if (Q = {
                url: G.url,
                method: G.method,
                data: G.data,
                params: G.params,
                paramsSerializer: L
              }, G.responseType && (Q.responseType = G.responseType), D.instanceUrl && (Q.baseURL = D.instanceUrl.startsWith("http") ? D.instanceUrl : "https://".concat(D.instanceUrl, ".hotwax.io/api/")), G.cache && (Q.adapter = S.adapter), !G.queue) {
                te.next = 9;
                break;
              }
              Q.headers || (Q.headers = g(g({}, e.default.defaults.headers.common), Q.headers)), Q.events.queueTask && Q.events.queueTask({
                callbackEvent: G.callbackEvent,
                payload: Q
              }), te.next = 10;
              break;
            case 9:
              return te.abrupt("return", (0, e.default)(Q));
            case 10:
            case "end":
              return te.stop();
          }
      }, V);
    }));
    return function(G) {
      return M.apply(this, arguments);
    };
  }();
  t.default = F;
  var U = function(V) {
    return e.default.request(g({
      paramsSerializer: L
    }, V));
  };
  t.client = U;
})(api);
var util = {};
Object.defineProperty(util, "__esModule", {
  value: !0
});
util.getIdentification = getIdentification;
util.hasError = hasError;
util.isError = isError;
function _typeof$4(t) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof$4(t);
}
function hasError(t) {
  return _typeof$4(t.data) != "object" || !!t.data._ERROR_MESSAGE_ || !!t.data._ERROR_MESSAGE_LIST_ || !!t.data.error;
}
function isError(t) {
  return t.code === "error";
}
function getIdentification(t, e) {
  var r = "";
  if (t) {
    var o = t.find(function(c) {
      return c.startsWith(e);
    }), a = o ? o.split("/") : [];
    r = a[1] ? a[1] : "";
  }
  return r;
}
var modules = {}, order$2 = {}, nodeJsonTransform = {}, lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(t, e) {
  (function() {
    var r, o = "4.17.21", a = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", d = "Invalid `variable` option passed into `_.template`", p = "__lodash_hash_undefined__", g = 500, b = "__lodash_placeholder__", x = 1, w = 2, y = 4, I = 1, E = 2, T = 1, C = 2, $ = 4, D = 8, L = 16, R = 32, O = 64, P = 128, z = 256, W = 512, A = 30, S = "...", F = 800, U = 16, M = 1, V = 2, G = 3, Q = 1 / 0, fe = 9007199254740991, te = 17976931348623157e292, de = 0 / 0, me = 4294967295, Me = me - 1, ce = me >>> 1, oe = [
      ["ary", P],
      ["bind", T],
      ["bindKey", C],
      ["curry", D],
      ["curryRight", L],
      ["flip", W],
      ["partial", R],
      ["partialRight", O],
      ["rearg", z]
    ], be = "[object Arguments]", Te = "[object Array]", Ae = "[object AsyncFunction]", je = "[object Boolean]", Xe = "[object Date]", He = "[object DOMException]", Ke = "[object Error]", ot = "[object Function]", K = "[object GeneratorFunction]", q = "[object Map]", se = "[object Number]", Ce = "[object Null]", Le = "[object Object]", qe = "[object Promise]", Ct = "[object Proxy]", ke = "[object RegExp]", xe = "[object Set]", Ne = "[object String]", Se = "[object Symbol]", ie = "[object Undefined]", he = "[object WeakMap]", Ye = "[object WeakSet]", et = "[object ArrayBuffer]", bt = "[object DataView]", $e = "[object Float32Array]", Ee = "[object Float64Array]", Ie = "[object Int8Array]", ze = "[object Int16Array]", ct = "[object Int32Array]", st = "[object Uint8Array]", ht = "[object Uint8ClampedArray]", Rt = "[object Uint16Array]", ar = "[object Uint32Array]", To = /\b__p \+= '';/g, Io = /\b(__p \+=) '' \+/g, Oo = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ar = /&(?:amp|lt|gt|quot|#39);/g, $r = /[&<>"']/g, Ao = RegExp(Ar.source), $o = RegExp($r.source), Do = /<%-([\s\S]+?)%>/g, Lo = /<%([\s\S]+?)%>/g, Dr = /<%=([\s\S]+?)%>/g, Ro = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Po = /^\w*$/, No = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, un = /[\\^$.*+?()[\]{}|]/g, Lr = RegExp(un.source), lr = /^\s+/, Rr = /\s/, Rn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Nr = /\{\n\/\* \[wrapped with (.+)\] \*/, Mr = /,? & /, Ft = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Mo = /[()=,{}\[\]\/\s]/, Fo = /\\(\\)?/g, jo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, cr = /\w*$/, Bo = /^[-+]0x[0-9a-f]+$/i, Uo = /^0b[01]+$/i, ur = /^\[object .+?Constructor\]$/, Vo = /^0o[0-7]+$/i, zo = /^(?:0|[1-9]\d*)$/, Ho = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Hn = /($^)/, Fr = /['\n\r\u2028\u2029\\]/g, qn = "\\ud800-\\udfff", jr = "\\u0300-\\u036f", ls = "\\ufe20-\\ufe2f", cs = "\\u20d0-\\u20ff", ae = jr + ls + cs, _e = "\\u2700-\\u27bf", De = "a-z\\xdf-\\xf6\\xf8-\\xff", ft = "\\xac\\xb1\\xd7\\xf7", Et = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", jt = "\\u2000-\\u206f", mn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", us = "A-Z\\xc0-\\xd6\\xd8-\\xde", ds = "\\ufe0e\\ufe0f", fs = ft + Et + jt + mn, qo = "['’]", Nl = "[" + qn + "]", hs = "[" + fs + "]", Br = "[" + ae + "]", ps = "\\d+", Ml = "[" + _e + "]", ms = "[" + De + "]", gs = "[^" + qn + fs + ps + _e + De + us + "]", Go = "\\ud83c[\\udffb-\\udfff]", Fl = "(?:" + Br + "|" + Go + ")", bs = "[^" + qn + "]", Wo = "(?:\\ud83c[\\udde6-\\uddff]){2}", Yo = "[\\ud800-\\udbff][\\udc00-\\udfff]", Gn = "[" + us + "]", vs = "\\u200d", ys = "(?:" + ms + "|" + gs + ")", jl = "(?:" + Gn + "|" + gs + ")", xs = "(?:" + qo + "(?:d|ll|m|re|s|t|ve))?", ws = "(?:" + qo + "(?:D|LL|M|RE|S|T|VE))?", Es = Fl + "?", ks = "[" + ds + "]?", Bl = "(?:" + vs + "(?:" + [bs, Wo, Yo].join("|") + ")" + ks + Es + ")*", Ul = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Vl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", _s = ks + Es + Bl, zl = "(?:" + [Ml, Wo, Yo].join("|") + ")" + _s, Hl = "(?:" + [bs + Br + "?", Br, Wo, Yo, Nl].join("|") + ")", ql = RegExp(qo, "g"), Gl = RegExp(Br, "g"), Ko = RegExp(Go + "(?=" + Go + ")|" + Hl + _s, "g"), Wl = RegExp([
      Gn + "?" + ms + "+" + xs + "(?=" + [hs, Gn, "$"].join("|") + ")",
      jl + "+" + ws + "(?=" + [hs, Gn + ys, "$"].join("|") + ")",
      Gn + "?" + ys + "+" + xs,
      Gn + "+" + ws,
      Vl,
      Ul,
      ps,
      zl
    ].join("|"), "g"), Yl = RegExp("[" + vs + qn + ae + ds + "]"), Kl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Zl = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Xl = -1, vt = {};
    vt[$e] = vt[Ee] = vt[Ie] = vt[ze] = vt[ct] = vt[st] = vt[ht] = vt[Rt] = vt[ar] = !0, vt[be] = vt[Te] = vt[et] = vt[je] = vt[bt] = vt[Xe] = vt[Ke] = vt[ot] = vt[q] = vt[se] = vt[Le] = vt[ke] = vt[xe] = vt[Ne] = vt[he] = !1;
    var mt = {};
    mt[be] = mt[Te] = mt[et] = mt[bt] = mt[je] = mt[Xe] = mt[$e] = mt[Ee] = mt[Ie] = mt[ze] = mt[ct] = mt[q] = mt[se] = mt[Le] = mt[ke] = mt[xe] = mt[Ne] = mt[Se] = mt[st] = mt[ht] = mt[Rt] = mt[ar] = !0, mt[Ke] = mt[ot] = mt[he] = !1;
    var Ql = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Jl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ec = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, tc = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, nc = parseFloat, rc = parseInt, Cs = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, oc = typeof self == "object" && self && self.Object === Object && self, Ot = Cs || oc || Function("return this")(), Zo = e && !e.nodeType && e, Pn = Zo && !0 && t && !t.nodeType && t, Ss = Pn && Pn.exports === Zo, Xo = Ss && Cs.process, Xt = function() {
      try {
        var X = Pn && Pn.require && Pn.require("util").types;
        return X || Xo && Xo.binding && Xo.binding("util");
      } catch {
      }
    }(), Ts = Xt && Xt.isArrayBuffer, Is = Xt && Xt.isDate, Os = Xt && Xt.isMap, As = Xt && Xt.isRegExp, $s = Xt && Xt.isSet, Ds = Xt && Xt.isTypedArray;
    function Ht(X, pe, ue) {
      switch (ue.length) {
        case 0:
          return X.call(pe);
        case 1:
          return X.call(pe, ue[0]);
        case 2:
          return X.call(pe, ue[0], ue[1]);
        case 3:
          return X.call(pe, ue[0], ue[1], ue[2]);
      }
      return X.apply(pe, ue);
    }
    function lc(X, pe, ue, Pe) {
      for (var Ge = -1, at = X == null ? 0 : X.length; ++Ge < at; ) {
        var St = X[Ge];
        pe(Pe, St, ue(St), X);
      }
      return Pe;
    }
    function Qt(X, pe) {
      for (var ue = -1, Pe = X == null ? 0 : X.length; ++ue < Pe && pe(X[ue], ue, X) !== !1; )
        ;
      return X;
    }
    function cc(X, pe) {
      for (var ue = X == null ? 0 : X.length; ue-- && pe(X[ue], ue, X) !== !1; )
        ;
      return X;
    }
    function Ls(X, pe) {
      for (var ue = -1, Pe = X == null ? 0 : X.length; ++ue < Pe; )
        if (!pe(X[ue], ue, X))
          return !1;
      return !0;
    }
    function Cn(X, pe) {
      for (var ue = -1, Pe = X == null ? 0 : X.length, Ge = 0, at = []; ++ue < Pe; ) {
        var St = X[ue];
        pe(St, ue, X) && (at[Ge++] = St);
      }
      return at;
    }
    function Ur(X, pe) {
      var ue = X == null ? 0 : X.length;
      return !!ue && Wn(X, pe, 0) > -1;
    }
    function Qo(X, pe, ue) {
      for (var Pe = -1, Ge = X == null ? 0 : X.length; ++Pe < Ge; )
        if (ue(pe, X[Pe]))
          return !0;
      return !1;
    }
    function yt(X, pe) {
      for (var ue = -1, Pe = X == null ? 0 : X.length, Ge = Array(Pe); ++ue < Pe; )
        Ge[ue] = pe(X[ue], ue, X);
      return Ge;
    }
    function Sn(X, pe) {
      for (var ue = -1, Pe = pe.length, Ge = X.length; ++ue < Pe; )
        X[Ge + ue] = pe[ue];
      return X;
    }
    function Jo(X, pe, ue, Pe) {
      var Ge = -1, at = X == null ? 0 : X.length;
      for (Pe && at && (ue = X[++Ge]); ++Ge < at; )
        ue = pe(ue, X[Ge], Ge, X);
      return ue;
    }
    function uc(X, pe, ue, Pe) {
      var Ge = X == null ? 0 : X.length;
      for (Pe && Ge && (ue = X[--Ge]); Ge--; )
        ue = pe(ue, X[Ge], Ge, X);
      return ue;
    }
    function ei(X, pe) {
      for (var ue = -1, Pe = X == null ? 0 : X.length; ++ue < Pe; )
        if (pe(X[ue], ue, X))
          return !0;
      return !1;
    }
    var dc = ti("length");
    function fc(X) {
      return X.split("");
    }
    function hc(X) {
      return X.match(Ft) || [];
    }
    function Rs(X, pe, ue) {
      var Pe;
      return ue(X, function(Ge, at, St) {
        if (pe(Ge, at, St))
          return Pe = at, !1;
      }), Pe;
    }
    function Vr(X, pe, ue, Pe) {
      for (var Ge = X.length, at = ue + (Pe ? 1 : -1); Pe ? at-- : ++at < Ge; )
        if (pe(X[at], at, X))
          return at;
      return -1;
    }
    function Wn(X, pe, ue) {
      return pe === pe ? Cc(X, pe, ue) : Vr(X, Ps, ue);
    }
    function pc(X, pe, ue, Pe) {
      for (var Ge = ue - 1, at = X.length; ++Ge < at; )
        if (Pe(X[Ge], pe))
          return Ge;
      return -1;
    }
    function Ps(X) {
      return X !== X;
    }
    function Ns(X, pe) {
      var ue = X == null ? 0 : X.length;
      return ue ? oi(X, pe) / ue : de;
    }
    function ti(X) {
      return function(pe) {
        return pe == null ? r : pe[X];
      };
    }
    function ri(X) {
      return function(pe) {
        return X == null ? r : X[pe];
      };
    }
    function Ms(X, pe, ue, Pe, Ge) {
      return Ge(X, function(at, St, pt) {
        ue = Pe ? (Pe = !1, at) : pe(ue, at, St, pt);
      }), ue;
    }
    function mc(X, pe) {
      var ue = X.length;
      for (X.sort(pe); ue--; )
        X[ue] = X[ue].value;
      return X;
    }
    function oi(X, pe) {
      for (var ue, Pe = -1, Ge = X.length; ++Pe < Ge; ) {
        var at = pe(X[Pe]);
        at !== r && (ue = ue === r ? at : ue + at);
      }
      return ue;
    }
    function si(X, pe) {
      for (var ue = -1, Pe = Array(X); ++ue < X; )
        Pe[ue] = pe(ue);
      return Pe;
    }
    function gc(X, pe) {
      return yt(pe, function(ue) {
        return [ue, X[ue]];
      });
    }
    function Fs(X) {
      return X && X.slice(0, Vs(X) + 1).replace(lr, "");
    }
    function qt(X) {
      return function(pe) {
        return X(pe);
      };
    }
    function ai(X, pe) {
      return yt(pe, function(ue) {
        return X[ue];
      });
    }
    function dr(X, pe) {
      return X.has(pe);
    }
    function js(X, pe) {
      for (var ue = -1, Pe = X.length; ++ue < Pe && Wn(pe, X[ue], 0) > -1; )
        ;
      return ue;
    }
    function Bs(X, pe) {
      for (var ue = X.length; ue-- && Wn(pe, X[ue], 0) > -1; )
        ;
      return ue;
    }
    function bc(X, pe) {
      for (var ue = X.length, Pe = 0; ue--; )
        X[ue] === pe && ++Pe;
      return Pe;
    }
    var vc = ri(Ql), yc = ri(Jl);
    function xc(X) {
      return "\\" + tc[X];
    }
    function wc(X, pe) {
      return X == null ? r : X[pe];
    }
    function Yn(X) {
      return Yl.test(X);
    }
    function Ec(X) {
      return Kl.test(X);
    }
    function kc(X) {
      for (var pe, ue = []; !(pe = X.next()).done; )
        ue.push(pe.value);
      return ue;
    }
    function li(X) {
      var pe = -1, ue = Array(X.size);
      return X.forEach(function(Pe, Ge) {
        ue[++pe] = [Ge, Pe];
      }), ue;
    }
    function Us(X, pe) {
      return function(ue) {
        return X(pe(ue));
      };
    }
    function Tn(X, pe) {
      for (var ue = -1, Pe = X.length, Ge = 0, at = []; ++ue < Pe; ) {
        var St = X[ue];
        (St === pe || St === b) && (X[ue] = b, at[Ge++] = ue);
      }
      return at;
    }
    function zr(X) {
      var pe = -1, ue = Array(X.size);
      return X.forEach(function(Pe) {
        ue[++pe] = Pe;
      }), ue;
    }
    function _c(X) {
      var pe = -1, ue = Array(X.size);
      return X.forEach(function(Pe) {
        ue[++pe] = [Pe, Pe];
      }), ue;
    }
    function Cc(X, pe, ue) {
      for (var Pe = ue - 1, Ge = X.length; ++Pe < Ge; )
        if (X[Pe] === pe)
          return Pe;
      return -1;
    }
    function Tc(X, pe, ue) {
      for (var Pe = ue + 1; Pe--; )
        if (X[Pe] === pe)
          return Pe;
      return Pe;
    }
    function Kn(X) {
      return Yn(X) ? Oc(X) : dc(X);
    }
    function sn(X) {
      return Yn(X) ? Ac(X) : fc(X);
    }
    function Vs(X) {
      for (var pe = X.length; pe-- && Rr.test(X.charAt(pe)); )
        ;
      return pe;
    }
    var Ic = ri(ec);
    function Oc(X) {
      for (var pe = Ko.lastIndex = 0; Ko.test(X); )
        ++pe;
      return pe;
    }
    function Ac(X) {
      return X.match(Ko) || [];
    }
    function $c(X) {
      return X.match(Wl) || [];
    }
    var Dc = function X(pe) {
      pe = pe == null ? Ot : Zn.defaults(Ot.Object(), pe, Zn.pick(Ot, Zl));
      var ue = pe.Array, Pe = pe.Date, Ge = pe.Error, at = pe.Function, St = pe.Math, pt = pe.Object, ci = pe.RegExp, Lc = pe.String, Jt = pe.TypeError, Hr = ue.prototype, Rc = at.prototype, Xn = pt.prototype, qr = pe["__core-js_shared__"], Gr = Rc.toString, dt = Xn.hasOwnProperty, Pc = 0, zs = function() {
        var f = /[^.]+$/.exec(qr && qr.keys && qr.keys.IE_PROTO || "");
        return f ? "Symbol(src)_1." + f : "";
      }(), Wr = Xn.toString, Nc = Gr.call(pt), Mc = Ot._, Fc = ci(
        "^" + Gr.call(dt).replace(un, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Yr = Ss ? pe.Buffer : r, In = pe.Symbol, Kr = pe.Uint8Array, Hs = Yr ? Yr.allocUnsafe : r, Zr = Us(pt.getPrototypeOf, pt), qs = pt.create, Gs = Xn.propertyIsEnumerable, Xr = Hr.splice, Ws = In ? In.isConcatSpreadable : r, fr = In ? In.iterator : r, Nn = In ? In.toStringTag : r, Qr = function() {
        try {
          var f = Un(pt, "defineProperty");
          return f({}, "", {}), f;
        } catch {
        }
      }(), jc = pe.clearTimeout !== Ot.clearTimeout && pe.clearTimeout, Bc = Pe && Pe.now !== Ot.Date.now && Pe.now, Uc = pe.setTimeout !== Ot.setTimeout && pe.setTimeout, Jr = St.ceil, eo = St.floor, ui = pt.getOwnPropertySymbols, Vc = Yr ? Yr.isBuffer : r, Ys = pe.isFinite, zc = Hr.join, Hc = Us(pt.keys, pt), Tt = St.max, $t = St.min, qc = Pe.now, Gc = pe.parseInt, Ks = St.random, Wc = Hr.reverse, di = Un(pe, "DataView"), mr = Un(pe, "Map"), fi = Un(pe, "Promise"), Qn = Un(pe, "Set"), gr = Un(pe, "WeakMap"), br = Un(pt, "create"), to = gr && new gr(), Jn = {}, Yc = Vn(di), Kc = Vn(mr), Zc = Vn(fi), Xc = Vn(Qn), Qc = Vn(gr), no = In ? In.prototype : r, vr = no ? no.valueOf : r, Zs = no ? no.toString : r;
      function j(f) {
        if (wt(f) && !We(f) && !(f instanceof nt)) {
          if (f instanceof en)
            return f;
          if (dt.call(f, "__wrapped__"))
            return Xa(f);
        }
        return new en(f);
      }
      var er = function() {
        function f() {
        }
        return function(m) {
          if (!xt(m))
            return {};
          if (qs)
            return qs(m);
          f.prototype = m;
          var v = new f();
          return f.prototype = r, v;
        };
      }();
      function ro() {
      }
      function en(f, m) {
        this.__wrapped__ = f, this.__actions__ = [], this.__chain__ = !!m, this.__index__ = 0, this.__values__ = r;
      }
      j.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Do,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Lo,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Dr,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: j
        }
      }, j.prototype = ro.prototype, j.prototype.constructor = j, en.prototype = er(ro.prototype), en.prototype.constructor = en;
      function nt(f) {
        this.__wrapped__ = f, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = me, this.__views__ = [];
      }
      function Jc() {
        var f = new nt(this.__wrapped__);
        return f.__actions__ = Bt(this.__actions__), f.__dir__ = this.__dir__, f.__filtered__ = this.__filtered__, f.__iteratees__ = Bt(this.__iteratees__), f.__takeCount__ = this.__takeCount__, f.__views__ = Bt(this.__views__), f;
      }
      function eu() {
        if (this.__filtered__) {
          var f = new nt(this);
          f.__dir__ = -1, f.__filtered__ = !0;
        } else
          f = this.clone(), f.__dir__ *= -1;
        return f;
      }
      function tu() {
        var f = this.__wrapped__.value(), m = this.__dir__, v = We(f), k = m < 0, N = v ? f.length : 0, B = vd(0, N, this.__views__), Y = B.start, Z = B.end, J = Z - Y, ve = k ? Z : Y - 1, ye = this.__iteratees__, we = ye.length, Oe = 0, Fe = $t(J, this.__takeCount__);
        if (!v || !k && N == J && Fe == J)
          return xa(f, this.__actions__);
        var Ue = [];
        e:
          for (; J-- && Oe < Fe; ) {
            ve += m;
            for (var Qe = -1, Ve = f[ve]; ++Qe < we; ) {
              var tt = ye[Qe], rt = tt.iteratee, Kt = tt.type, Mt = rt(Ve);
              if (Kt == V)
                Ve = Mt;
              else if (!Mt) {
                if (Kt == M)
                  continue e;
                break e;
              }
            }
            Ue[Oe++] = Ve;
          }
        return Ue;
      }
      nt.prototype = er(ro.prototype), nt.prototype.constructor = nt;
      function Mn(f) {
        var m = -1, v = f == null ? 0 : f.length;
        for (this.clear(); ++m < v; ) {
          var k = f[m];
          this.set(k[0], k[1]);
        }
      }
      function ru() {
        this.__data__ = br ? br(null) : {}, this.size = 0;
      }
      function ou(f) {
        var m = this.has(f) && delete this.__data__[f];
        return this.size -= m ? 1 : 0, m;
      }
      function iu(f) {
        var m = this.__data__;
        if (br) {
          var v = m[f];
          return v === p ? r : v;
        }
        return dt.call(m, f) ? m[f] : r;
      }
      function su(f) {
        var m = this.__data__;
        return br ? m[f] !== r : dt.call(m, f);
      }
      function au(f, m) {
        var v = this.__data__;
        return this.size += this.has(f) ? 0 : 1, v[f] = br && m === r ? p : m, this;
      }
      Mn.prototype.clear = ru, Mn.prototype.delete = ou, Mn.prototype.get = iu, Mn.prototype.has = su, Mn.prototype.set = au;
      function gn(f) {
        var m = -1, v = f == null ? 0 : f.length;
        for (this.clear(); ++m < v; ) {
          var k = f[m];
          this.set(k[0], k[1]);
        }
      }
      function lu() {
        this.__data__ = [], this.size = 0;
      }
      function cu(f) {
        var m = this.__data__, v = oo(m, f);
        if (v < 0)
          return !1;
        var k = m.length - 1;
        return v == k ? m.pop() : Xr.call(m, v, 1), --this.size, !0;
      }
      function uu(f) {
        var m = this.__data__, v = oo(m, f);
        return v < 0 ? r : m[v][1];
      }
      function du(f) {
        return oo(this.__data__, f) > -1;
      }
      function fu(f, m) {
        var v = this.__data__, k = oo(v, f);
        return k < 0 ? (++this.size, v.push([f, m])) : v[k][1] = m, this;
      }
      gn.prototype.clear = lu, gn.prototype.delete = cu, gn.prototype.get = uu, gn.prototype.has = du, gn.prototype.set = fu;
      function bn(f) {
        var m = -1, v = f == null ? 0 : f.length;
        for (this.clear(); ++m < v; ) {
          var k = f[m];
          this.set(k[0], k[1]);
        }
      }
      function hu() {
        this.size = 0, this.__data__ = {
          hash: new Mn(),
          map: new (mr || gn)(),
          string: new Mn()
        };
      }
      function pu(f) {
        var m = bo(this, f).delete(f);
        return this.size -= m ? 1 : 0, m;
      }
      function gu(f) {
        return bo(this, f).get(f);
      }
      function bu(f) {
        return bo(this, f).has(f);
      }
      function vu(f, m) {
        var v = bo(this, f), k = v.size;
        return v.set(f, m), this.size += v.size == k ? 0 : 1, this;
      }
      bn.prototype.clear = hu, bn.prototype.delete = pu, bn.prototype.get = gu, bn.prototype.has = bu, bn.prototype.set = vu;
      function Fn(f) {
        var m = -1, v = f == null ? 0 : f.length;
        for (this.__data__ = new bn(); ++m < v; )
          this.add(f[m]);
      }
      function yu(f) {
        return this.__data__.set(f, p), this;
      }
      function xu(f) {
        return this.__data__.has(f);
      }
      Fn.prototype.add = Fn.prototype.push = yu, Fn.prototype.has = xu;
      function an(f) {
        var m = this.__data__ = new gn(f);
        this.size = m.size;
      }
      function wu() {
        this.__data__ = new gn(), this.size = 0;
      }
      function Eu(f) {
        var m = this.__data__, v = m.delete(f);
        return this.size = m.size, v;
      }
      function ku(f) {
        return this.__data__.get(f);
      }
      function _u(f) {
        return this.__data__.has(f);
      }
      function Cu(f, m) {
        var v = this.__data__;
        if (v instanceof gn) {
          var k = v.__data__;
          if (!mr || k.length < a - 1)
            return k.push([f, m]), this.size = ++v.size, this;
          v = this.__data__ = new bn(k);
        }
        return v.set(f, m), this.size = v.size, this;
      }
      an.prototype.clear = wu, an.prototype.delete = Eu, an.prototype.get = ku, an.prototype.has = _u, an.prototype.set = Cu;
      function Xs(f, m) {
        var v = We(f), k = !v && zn(f), N = !v && !k && Ln(f), B = !v && !k && !N && ir(f), Y = v || k || N || B, Z = Y ? si(f.length, Lc) : [], J = Z.length;
        for (var ve in f)
          (m || dt.call(f, ve)) && !(Y && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ve == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          N && (ve == "offset" || ve == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          B && (ve == "buffer" || ve == "byteLength" || ve == "byteOffset") || // Skip index properties.
          wn(ve, J))) && Z.push(ve);
        return Z;
      }
      function Qs(f) {
        var m = f.length;
        return m ? f[Ci(0, m - 1)] : r;
      }
      function Su(f, m) {
        return vo(Bt(f), jn(m, 0, f.length));
      }
      function Tu(f) {
        return vo(Bt(f));
      }
      function hi(f, m, v) {
        (v !== r && !ln(f[m], v) || v === r && !(m in f)) && vn(f, m, v);
      }
      function yr(f, m, v) {
        var k = f[m];
        (!(dt.call(f, m) && ln(k, v)) || v === r && !(m in f)) && vn(f, m, v);
      }
      function oo(f, m) {
        for (var v = f.length; v--; )
          if (ln(f[v][0], m))
            return v;
        return -1;
      }
      function Iu(f, m, v, k) {
        return On(f, function(N, B, Y) {
          m(k, N, v(N), Y);
        }), k;
      }
      function Js(f, m) {
        return f && hn(m, It(m), f);
      }
      function Ou(f, m) {
        return f && hn(m, Vt(m), f);
      }
      function vn(f, m, v) {
        m == "__proto__" && Qr ? Qr(f, m, {
          configurable: !0,
          enumerable: !0,
          value: v,
          writable: !0
        }) : f[m] = v;
      }
      function mi(f, m) {
        for (var v = -1, k = m.length, N = ue(k), B = f == null; ++v < k; )
          N[v] = B ? r : Qi(f, m[v]);
        return N;
      }
      function jn(f, m, v) {
        return f === f && (v !== r && (f = f <= v ? f : v), m !== r && (f = f >= m ? f : m)), f;
      }
      function tn(f, m, v, k, N, B) {
        var Y, Z = m & x, J = m & w, ve = m & y;
        if (v && (Y = N ? v(f, k, N, B) : v(f)), Y !== r)
          return Y;
        if (!xt(f))
          return f;
        var ye = We(f);
        if (ye) {
          if (Y = xd(f), !Z)
            return Bt(f, Y);
        } else {
          var we = Dt(f), Oe = we == ot || we == K;
          if (Ln(f))
            return ka(f, Z);
          if (we == Le || we == be || Oe && !N) {
            if (Y = J || Oe ? {} : Va(f), !Z)
              return J ? ld(f, Ou(Y, f)) : ad(f, Js(Y, f));
          } else {
            if (!mt[we])
              return N ? f : {};
            Y = wd(f, we, Z);
          }
        }
        B || (B = new an());
        var Fe = B.get(f);
        if (Fe)
          return Fe;
        B.set(f, Y), xl(f) ? f.forEach(function(Ve) {
          Y.add(tn(Ve, m, v, Ve, f, B));
        }) : vl(f) && f.forEach(function(Ve, tt) {
          Y.set(tt, tn(Ve, m, v, tt, f, B));
        });
        var Ue = ve ? J ? Mi : Ni : J ? Vt : It, Qe = ye ? r : Ue(f);
        return Qt(Qe || f, function(Ve, tt) {
          Qe && (tt = Ve, Ve = f[tt]), yr(Y, tt, tn(Ve, m, v, tt, f, B));
        }), Y;
      }
      function Au(f) {
        var m = It(f);
        return function(v) {
          return ea(v, f, m);
        };
      }
      function ea(f, m, v) {
        var k = v.length;
        if (f == null)
          return !k;
        for (f = pt(f); k--; ) {
          var N = v[k], B = m[N], Y = f[N];
          if (Y === r && !(N in f) || !B(Y))
            return !1;
        }
        return !0;
      }
      function ta(f, m, v) {
        if (typeof f != "function")
          throw new Jt(u);
        return Tr(function() {
          f.apply(r, v);
        }, m);
      }
      function xr(f, m, v, k) {
        var N = -1, B = Ur, Y = !0, Z = f.length, J = [], ve = m.length;
        if (!Z)
          return J;
        v && (m = yt(m, qt(v))), k ? (B = Qo, Y = !1) : m.length >= a && (B = dr, Y = !1, m = new Fn(m));
        e:
          for (; ++N < Z; ) {
            var ye = f[N], we = v == null ? ye : v(ye);
            if (ye = k || ye !== 0 ? ye : 0, Y && we === we) {
              for (var Oe = ve; Oe--; )
                if (m[Oe] === we)
                  continue e;
              J.push(ye);
            } else
              B(m, we, k) || J.push(ye);
          }
        return J;
      }
      var On = Ia(dn), na = Ia(bi, !0);
      function $u(f, m) {
        var v = !0;
        return On(f, function(k, N, B) {
          return v = !!m(k, N, B), v;
        }), v;
      }
      function io(f, m, v) {
        for (var k = -1, N = f.length; ++k < N; ) {
          var B = f[k], Y = m(B);
          if (Y != null && (Z === r ? Y === Y && !Yt(Y) : v(Y, Z)))
            var Z = Y, J = B;
        }
        return J;
      }
      function Du(f, m, v, k) {
        var N = f.length;
        for (v = Ze(v), v < 0 && (v = -v > N ? 0 : N + v), k = k === r || k > N ? N : Ze(k), k < 0 && (k += N), k = v > k ? 0 : El(k); v < k; )
          f[v++] = m;
        return f;
      }
      function ra(f, m) {
        var v = [];
        return On(f, function(k, N, B) {
          m(k, N, B) && v.push(k);
        }), v;
      }
      function At(f, m, v, k, N) {
        var B = -1, Y = f.length;
        for (v || (v = kd), N || (N = []); ++B < Y; ) {
          var Z = f[B];
          m > 0 && v(Z) ? m > 1 ? At(Z, m - 1, v, k, N) : Sn(N, Z) : k || (N[N.length] = Z);
        }
        return N;
      }
      var gi = Oa(), oa = Oa(!0);
      function dn(f, m) {
        return f && gi(f, m, It);
      }
      function bi(f, m) {
        return f && oa(f, m, It);
      }
      function so(f, m) {
        return Cn(m, function(v) {
          return En(f[v]);
        });
      }
      function Bn(f, m) {
        m = $n(m, f);
        for (var v = 0, k = m.length; f != null && v < k; )
          f = f[pn(m[v++])];
        return v && v == k ? f : r;
      }
      function ia(f, m, v) {
        var k = m(f);
        return We(f) ? k : Sn(k, v(f));
      }
      function Pt(f) {
        return f == null ? f === r ? ie : Ce : Nn && Nn in pt(f) ? bd(f) : Ad(f);
      }
      function vi(f, m) {
        return f > m;
      }
      function Lu(f, m) {
        return f != null && dt.call(f, m);
      }
      function Ru(f, m) {
        return f != null && m in pt(f);
      }
      function Pu(f, m, v) {
        return f >= $t(m, v) && f < Tt(m, v);
      }
      function yi(f, m, v) {
        for (var k = v ? Qo : Ur, N = f[0].length, B = f.length, Y = B, Z = ue(B), J = 1 / 0, ve = []; Y--; ) {
          var ye = f[Y];
          Y && m && (ye = yt(ye, qt(m))), J = $t(ye.length, J), Z[Y] = !v && (m || N >= 120 && ye.length >= 120) ? new Fn(Y && ye) : r;
        }
        ye = f[0];
        var we = -1, Oe = Z[0];
        e:
          for (; ++we < N && ve.length < J; ) {
            var Fe = ye[we], Ue = m ? m(Fe) : Fe;
            if (Fe = v || Fe !== 0 ? Fe : 0, !(Oe ? dr(Oe, Ue) : k(ve, Ue, v))) {
              for (Y = B; --Y; ) {
                var Qe = Z[Y];
                if (!(Qe ? dr(Qe, Ue) : k(f[Y], Ue, v)))
                  continue e;
              }
              Oe && Oe.push(Ue), ve.push(Fe);
            }
          }
        return ve;
      }
      function Fu(f, m, v, k) {
        return dn(f, function(N, B, Y) {
          m(k, v(N), B, Y);
        }), k;
      }
      function Er(f, m, v) {
        m = $n(m, f), f = Ga(f, m);
        var k = f == null ? f : f[pn(rn(m))];
        return k == null ? r : Ht(k, f, v);
      }
      function sa(f) {
        return wt(f) && Pt(f) == be;
      }
      function ju(f) {
        return wt(f) && Pt(f) == et;
      }
      function Bu(f) {
        return wt(f) && Pt(f) == Xe;
      }
      function kr(f, m, v, k, N) {
        return f === m ? !0 : f == null || m == null || !wt(f) && !wt(m) ? f !== f && m !== m : Uu(f, m, v, k, kr, N);
      }
      function Uu(f, m, v, k, N, B) {
        var Y = We(f), Z = We(m), J = Y ? Te : Dt(f), ve = Z ? Te : Dt(m);
        J = J == be ? Le : J, ve = ve == be ? Le : ve;
        var ye = J == Le, we = ve == Le, Oe = J == ve;
        if (Oe && Ln(f)) {
          if (!Ln(m))
            return !1;
          Y = !0, ye = !1;
        }
        if (Oe && !ye)
          return B || (B = new an()), Y || ir(f) ? ja(f, m, v, k, N, B) : md(f, m, J, v, k, N, B);
        if (!(v & I)) {
          var Fe = ye && dt.call(f, "__wrapped__"), Ue = we && dt.call(m, "__wrapped__");
          if (Fe || Ue) {
            var Qe = Fe ? f.value() : f, Ve = Ue ? m.value() : m;
            return B || (B = new an()), N(Qe, Ve, v, k, B);
          }
        }
        return Oe ? (B || (B = new an()), gd(f, m, v, k, N, B)) : !1;
      }
      function Vu(f) {
        return wt(f) && Dt(f) == q;
      }
      function wi(f, m, v, k) {
        var N = v.length, B = N, Y = !k;
        if (f == null)
          return !B;
        for (f = pt(f); N--; ) {
          var Z = v[N];
          if (Y && Z[2] ? Z[1] !== f[Z[0]] : !(Z[0] in f))
            return !1;
        }
        for (; ++N < B; ) {
          Z = v[N];
          var J = Z[0], ve = f[J], ye = Z[1];
          if (Y && Z[2]) {
            if (ve === r && !(J in f))
              return !1;
          } else {
            var we = new an();
            if (k)
              var Oe = k(ve, ye, J, f, m, we);
            if (!(Oe === r ? kr(ye, ve, I | E, k, we) : Oe))
              return !1;
          }
        }
        return !0;
      }
      function aa(f) {
        if (!xt(f) || Cd(f))
          return !1;
        var m = En(f) ? Fc : ur;
        return m.test(Vn(f));
      }
      function zu(f) {
        return wt(f) && Pt(f) == ke;
      }
      function Hu(f) {
        return wt(f) && Dt(f) == xe;
      }
      function qu(f) {
        return wt(f) && _o(f.length) && !!vt[Pt(f)];
      }
      function la(f) {
        return typeof f == "function" ? f : f == null ? zt : typeof f == "object" ? We(f) ? da(f[0], f[1]) : ua(f) : Rl(f);
      }
      function Ei(f) {
        if (!Sr(f))
          return Hc(f);
        var m = [];
        for (var v in pt(f))
          dt.call(f, v) && v != "constructor" && m.push(v);
        return m;
      }
      function Gu(f) {
        if (!xt(f))
          return Od(f);
        var m = Sr(f), v = [];
        for (var k in f)
          k == "constructor" && (m || !dt.call(f, k)) || v.push(k);
        return v;
      }
      function ki(f, m) {
        return f < m;
      }
      function ca(f, m) {
        var v = -1, k = Ut(f) ? ue(f.length) : [];
        return On(f, function(N, B, Y) {
          k[++v] = m(N, B, Y);
        }), k;
      }
      function ua(f) {
        var m = ji(f);
        return m.length == 1 && m[0][2] ? Ha(m[0][0], m[0][1]) : function(v) {
          return v === f || wi(v, f, m);
        };
      }
      function da(f, m) {
        return Ui(f) && za(m) ? Ha(pn(f), m) : function(v) {
          var k = Qi(v, f);
          return k === r && k === m ? Ji(v, f) : kr(m, k, I | E);
        };
      }
      function ao(f, m, v, k, N) {
        f !== m && gi(m, function(B, Y) {
          if (N || (N = new an()), xt(B))
            Wu(f, m, Y, v, ao, k, N);
          else {
            var Z = k ? k(zi(f, Y), B, Y + "", f, m, N) : r;
            Z === r && (Z = B), hi(f, Y, Z);
          }
        }, Vt);
      }
      function Wu(f, m, v, k, N, B, Y) {
        var Z = zi(f, v), J = zi(m, v), ve = Y.get(J);
        if (ve) {
          hi(f, v, ve);
          return;
        }
        var ye = B ? B(Z, J, v + "", f, m, Y) : r, we = ye === r;
        if (we) {
          var Oe = We(J), Fe = !Oe && Ln(J), Ue = !Oe && !Fe && ir(J);
          ye = J, Oe || Fe || Ue ? We(Z) ? ye = Z : kt(Z) ? ye = Bt(Z) : Fe ? (we = !1, ye = ka(J, !0)) : Ue ? (we = !1, ye = _a(J, !0)) : ye = [] : Ir(J) || zn(J) ? (ye = Z, zn(Z) ? ye = kl(Z) : (!xt(Z) || En(Z)) && (ye = Va(J))) : we = !1;
        }
        we && (Y.set(J, ye), N(ye, J, k, B, Y), Y.delete(J)), hi(f, v, ye);
      }
      function fa(f, m) {
        var v = f.length;
        if (v)
          return m += m < 0 ? v : 0, wn(m, v) ? f[m] : r;
      }
      function ha(f, m, v) {
        m.length ? m = yt(m, function(B) {
          return We(B) ? function(Y) {
            return Bn(Y, B.length === 1 ? B[0] : B);
          } : B;
        }) : m = [zt];
        var k = -1;
        m = yt(m, qt(Be()));
        var N = ca(f, function(B, Y, Z) {
          var J = yt(m, function(ve) {
            return ve(B);
          });
          return { criteria: J, index: ++k, value: B };
        });
        return mc(N, function(B, Y) {
          return sd(B, Y, v);
        });
      }
      function Yu(f, m) {
        return pa(f, m, function(v, k) {
          return Ji(f, k);
        });
      }
      function pa(f, m, v) {
        for (var k = -1, N = m.length, B = {}; ++k < N; ) {
          var Y = m[k], Z = Bn(f, Y);
          v(Z, Y) && _r(B, $n(Y, f), Z);
        }
        return B;
      }
      function Ku(f) {
        return function(m) {
          return Bn(m, f);
        };
      }
      function _i(f, m, v, k) {
        var N = k ? pc : Wn, B = -1, Y = m.length, Z = f;
        for (f === m && (m = Bt(m)), v && (Z = yt(f, qt(v))); ++B < Y; )
          for (var J = 0, ve = m[B], ye = v ? v(ve) : ve; (J = N(Z, ye, J, k)) > -1; )
            Z !== f && Xr.call(Z, J, 1), Xr.call(f, J, 1);
        return f;
      }
      function ma(f, m) {
        for (var v = f ? m.length : 0, k = v - 1; v--; ) {
          var N = m[v];
          if (v == k || N !== B) {
            var B = N;
            wn(N) ? Xr.call(f, N, 1) : Ii(f, N);
          }
        }
        return f;
      }
      function Ci(f, m) {
        return f + eo(Ks() * (m - f + 1));
      }
      function Zu(f, m, v, k) {
        for (var N = -1, B = Tt(Jr((m - f) / (v || 1)), 0), Y = ue(B); B--; )
          Y[k ? B : ++N] = f, f += v;
        return Y;
      }
      function Si(f, m) {
        var v = "";
        if (!f || m < 1 || m > fe)
          return v;
        do
          m % 2 && (v += f), m = eo(m / 2), m && (f += f);
        while (m);
        return v;
      }
      function Je(f, m) {
        return Hi(qa(f, m, zt), f + "");
      }
      function Xu(f) {
        return Qs(sr(f));
      }
      function Qu(f, m) {
        var v = sr(f);
        return vo(v, jn(m, 0, v.length));
      }
      function _r(f, m, v, k) {
        if (!xt(f))
          return f;
        m = $n(m, f);
        for (var N = -1, B = m.length, Y = B - 1, Z = f; Z != null && ++N < B; ) {
          var J = pn(m[N]), ve = v;
          if (J === "__proto__" || J === "constructor" || J === "prototype")
            return f;
          if (N != Y) {
            var ye = Z[J];
            ve = k ? k(ye, J, Z) : r, ve === r && (ve = xt(ye) ? ye : wn(m[N + 1]) ? [] : {});
          }
          yr(Z, J, ve), Z = Z[J];
        }
        return f;
      }
      var ga = to ? function(f, m) {
        return to.set(f, m), f;
      } : zt, Ju = Qr ? function(f, m) {
        return Qr(f, "toString", {
          configurable: !0,
          enumerable: !1,
          value: ns(m),
          writable: !0
        });
      } : zt;
      function ed(f) {
        return vo(sr(f));
      }
      function nn(f, m, v) {
        var k = -1, N = f.length;
        m < 0 && (m = -m > N ? 0 : N + m), v = v > N ? N : v, v < 0 && (v += N), N = m > v ? 0 : v - m >>> 0, m >>>= 0;
        for (var B = ue(N); ++k < N; )
          B[k] = f[k + m];
        return B;
      }
      function td(f, m) {
        var v;
        return On(f, function(k, N, B) {
          return v = m(k, N, B), !v;
        }), !!v;
      }
      function lo(f, m, v) {
        var k = 0, N = f == null ? k : f.length;
        if (typeof m == "number" && m === m && N <= ce) {
          for (; k < N; ) {
            var B = k + N >>> 1, Y = f[B];
            Y !== null && !Yt(Y) && (v ? Y <= m : Y < m) ? k = B + 1 : N = B;
          }
          return N;
        }
        return Ti(f, m, zt, v);
      }
      function Ti(f, m, v, k) {
        var N = 0, B = f == null ? 0 : f.length;
        if (B === 0)
          return 0;
        m = v(m);
        for (var Y = m !== m, Z = m === null, J = Yt(m), ve = m === r; N < B; ) {
          var ye = eo((N + B) / 2), we = v(f[ye]), Oe = we !== r, Fe = we === null, Ue = we === we, Qe = Yt(we);
          if (Y)
            var Ve = k || Ue;
          else
            ve ? Ve = Ue && (k || Oe) : Z ? Ve = Ue && Oe && (k || !Fe) : J ? Ve = Ue && Oe && !Fe && (k || !Qe) : Fe || Qe ? Ve = !1 : Ve = k ? we <= m : we < m;
          Ve ? N = ye + 1 : B = ye;
        }
        return $t(B, Me);
      }
      function ba(f, m) {
        for (var v = -1, k = f.length, N = 0, B = []; ++v < k; ) {
          var Y = f[v], Z = m ? m(Y) : Y;
          if (!v || !ln(Z, J)) {
            var J = Z;
            B[N++] = Y === 0 ? 0 : Y;
          }
        }
        return B;
      }
      function va(f) {
        return typeof f == "number" ? f : Yt(f) ? de : +f;
      }
      function Wt(f) {
        if (typeof f == "string")
          return f;
        if (We(f))
          return yt(f, Wt) + "";
        if (Yt(f))
          return Zs ? Zs.call(f) : "";
        var m = f + "";
        return m == "0" && 1 / f == -Q ? "-0" : m;
      }
      function An(f, m, v) {
        var k = -1, N = Ur, B = f.length, Y = !0, Z = [], J = Z;
        if (v)
          Y = !1, N = Qo;
        else if (B >= a) {
          var ve = m ? null : hd(f);
          if (ve)
            return zr(ve);
          Y = !1, N = dr, J = new Fn();
        } else
          J = m ? [] : Z;
        e:
          for (; ++k < B; ) {
            var ye = f[k], we = m ? m(ye) : ye;
            if (ye = v || ye !== 0 ? ye : 0, Y && we === we) {
              for (var Oe = J.length; Oe--; )
                if (J[Oe] === we)
                  continue e;
              m && J.push(we), Z.push(ye);
            } else
              N(J, we, v) || (J !== Z && J.push(we), Z.push(ye));
          }
        return Z;
      }
      function Ii(f, m) {
        return m = $n(m, f), f = Ga(f, m), f == null || delete f[pn(rn(m))];
      }
      function ya(f, m, v, k) {
        return _r(f, m, v(Bn(f, m)), k);
      }
      function co(f, m, v, k) {
        for (var N = f.length, B = k ? N : -1; (k ? B-- : ++B < N) && m(f[B], B, f); )
          ;
        return v ? nn(f, k ? 0 : B, k ? B + 1 : N) : nn(f, k ? B + 1 : 0, k ? N : B);
      }
      function xa(f, m) {
        var v = f;
        return v instanceof nt && (v = v.value()), Jo(m, function(k, N) {
          return N.func.apply(N.thisArg, Sn([k], N.args));
        }, v);
      }
      function Oi(f, m, v) {
        var k = f.length;
        if (k < 2)
          return k ? An(f[0]) : [];
        for (var N = -1, B = ue(k); ++N < k; )
          for (var Y = f[N], Z = -1; ++Z < k; )
            Z != N && (B[N] = xr(B[N] || Y, f[Z], m, v));
        return An(At(B, 1), m, v);
      }
      function wa(f, m, v) {
        for (var k = -1, N = f.length, B = m.length, Y = {}; ++k < N; ) {
          var Z = k < B ? m[k] : r;
          v(Y, f[k], Z);
        }
        return Y;
      }
      function Ai(f) {
        return kt(f) ? f : [];
      }
      function $i(f) {
        return typeof f == "function" ? f : zt;
      }
      function $n(f, m) {
        return We(f) ? f : Ui(f, m) ? [f] : Za(ut(f));
      }
      var nd = Je;
      function Dn(f, m, v) {
        var k = f.length;
        return v = v === r ? k : v, !m && v >= k ? f : nn(f, m, v);
      }
      var Ea = jc || function(f) {
        return Ot.clearTimeout(f);
      };
      function ka(f, m) {
        if (m)
          return f.slice();
        var v = f.length, k = Hs ? Hs(v) : new f.constructor(v);
        return f.copy(k), k;
      }
      function Di(f) {
        var m = new f.constructor(f.byteLength);
        return new Kr(m).set(new Kr(f)), m;
      }
      function rd(f, m) {
        var v = m ? Di(f.buffer) : f.buffer;
        return new f.constructor(v, f.byteOffset, f.byteLength);
      }
      function od(f) {
        var m = new f.constructor(f.source, cr.exec(f));
        return m.lastIndex = f.lastIndex, m;
      }
      function id(f) {
        return vr ? pt(vr.call(f)) : {};
      }
      function _a(f, m) {
        var v = m ? Di(f.buffer) : f.buffer;
        return new f.constructor(v, f.byteOffset, f.length);
      }
      function Ca(f, m) {
        if (f !== m) {
          var v = f !== r, k = f === null, N = f === f, B = Yt(f), Y = m !== r, Z = m === null, J = m === m, ve = Yt(m);
          if (!Z && !ve && !B && f > m || B && Y && J && !Z && !ve || k && Y && J || !v && J || !N)
            return 1;
          if (!k && !B && !ve && f < m || ve && v && N && !k && !B || Z && v && N || !Y && N || !J)
            return -1;
        }
        return 0;
      }
      function sd(f, m, v) {
        for (var k = -1, N = f.criteria, B = m.criteria, Y = N.length, Z = v.length; ++k < Y; ) {
          var J = Ca(N[k], B[k]);
          if (J) {
            if (k >= Z)
              return J;
            var ve = v[k];
            return J * (ve == "desc" ? -1 : 1);
          }
        }
        return f.index - m.index;
      }
      function Sa(f, m, v, k) {
        for (var N = -1, B = f.length, Y = v.length, Z = -1, J = m.length, ve = Tt(B - Y, 0), ye = ue(J + ve), we = !k; ++Z < J; )
          ye[Z] = m[Z];
        for (; ++N < Y; )
          (we || N < B) && (ye[v[N]] = f[N]);
        for (; ve--; )
          ye[Z++] = f[N++];
        return ye;
      }
      function Ta(f, m, v, k) {
        for (var N = -1, B = f.length, Y = -1, Z = v.length, J = -1, ve = m.length, ye = Tt(B - Z, 0), we = ue(ye + ve), Oe = !k; ++N < ye; )
          we[N] = f[N];
        for (var Fe = N; ++J < ve; )
          we[Fe + J] = m[J];
        for (; ++Y < Z; )
          (Oe || N < B) && (we[Fe + v[Y]] = f[N++]);
        return we;
      }
      function Bt(f, m) {
        var v = -1, k = f.length;
        for (m || (m = ue(k)); ++v < k; )
          m[v] = f[v];
        return m;
      }
      function hn(f, m, v, k) {
        var N = !v;
        v || (v = {});
        for (var B = -1, Y = m.length; ++B < Y; ) {
          var Z = m[B], J = k ? k(v[Z], f[Z], Z, v, f) : r;
          J === r && (J = f[Z]), N ? vn(v, Z, J) : yr(v, Z, J);
        }
        return v;
      }
      function ad(f, m) {
        return hn(f, Bi(f), m);
      }
      function ld(f, m) {
        return hn(f, Ba(f), m);
      }
      function uo(f, m) {
        return function(v, k) {
          var N = We(v) ? lc : Iu, B = m ? m() : {};
          return N(v, f, Be(k, 2), B);
        };
      }
      function tr(f) {
        return Je(function(m, v) {
          var k = -1, N = v.length, B = N > 1 ? v[N - 1] : r, Y = N > 2 ? v[2] : r;
          for (B = f.length > 3 && typeof B == "function" ? (N--, B) : r, Y && Nt(v[0], v[1], Y) && (B = N < 3 ? r : B, N = 1), m = pt(m); ++k < N; ) {
            var Z = v[k];
            Z && f(m, Z, k, B);
          }
          return m;
        });
      }
      function Ia(f, m) {
        return function(v, k) {
          if (v == null)
            return v;
          if (!Ut(v))
            return f(v, k);
          for (var N = v.length, B = m ? N : -1, Y = pt(v); (m ? B-- : ++B < N) && k(Y[B], B, Y) !== !1; )
            ;
          return v;
        };
      }
      function Oa(f) {
        return function(m, v, k) {
          for (var N = -1, B = pt(m), Y = k(m), Z = Y.length; Z--; ) {
            var J = Y[f ? Z : ++N];
            if (v(B[J], J, B) === !1)
              break;
          }
          return m;
        };
      }
      function cd(f, m, v) {
        var k = m & T, N = Cr(f);
        function B() {
          var Y = this && this !== Ot && this instanceof B ? N : f;
          return Y.apply(k ? v : this, arguments);
        }
        return B;
      }
      function Aa(f) {
        return function(m) {
          m = ut(m);
          var v = Yn(m) ? sn(m) : r, k = v ? v[0] : m.charAt(0), N = v ? Dn(v, 1).join("") : m.slice(1);
          return k[f]() + N;
        };
      }
      function nr(f) {
        return function(m) {
          return Jo($l(Al(m).replace(ql, "")), f, "");
        };
      }
      function Cr(f) {
        return function() {
          var m = arguments;
          switch (m.length) {
            case 0:
              return new f();
            case 1:
              return new f(m[0]);
            case 2:
              return new f(m[0], m[1]);
            case 3:
              return new f(m[0], m[1], m[2]);
            case 4:
              return new f(m[0], m[1], m[2], m[3]);
            case 5:
              return new f(m[0], m[1], m[2], m[3], m[4]);
            case 6:
              return new f(m[0], m[1], m[2], m[3], m[4], m[5]);
            case 7:
              return new f(m[0], m[1], m[2], m[3], m[4], m[5], m[6]);
          }
          var v = er(f.prototype), k = f.apply(v, m);
          return xt(k) ? k : v;
        };
      }
      function ud(f, m, v) {
        var k = Cr(f);
        function N() {
          for (var B = arguments.length, Y = ue(B), Z = B, J = rr(N); Z--; )
            Y[Z] = arguments[Z];
          var ve = B < 3 && Y[0] !== J && Y[B - 1] !== J ? [] : Tn(Y, J);
          if (B -= ve.length, B < v)
            return Pa(
              f,
              m,
              fo,
              N.placeholder,
              r,
              Y,
              ve,
              r,
              r,
              v - B
            );
          var ye = this && this !== Ot && this instanceof N ? k : f;
          return Ht(ye, this, Y);
        }
        return N;
      }
      function $a(f) {
        return function(m, v, k) {
          var N = pt(m);
          if (!Ut(m)) {
            var B = Be(v, 3);
            m = It(m), v = function(Z) {
              return B(N[Z], Z, N);
            };
          }
          var Y = f(m, v, k);
          return Y > -1 ? N[B ? m[Y] : Y] : r;
        };
      }
      function Da(f) {
        return xn(function(m) {
          var v = m.length, k = v, N = en.prototype.thru;
          for (f && m.reverse(); k--; ) {
            var B = m[k];
            if (typeof B != "function")
              throw new Jt(u);
            if (N && !Y && go(B) == "wrapper")
              var Y = new en([], !0);
          }
          for (k = Y ? k : v; ++k < v; ) {
            B = m[k];
            var Z = go(B), J = Z == "wrapper" ? Fi(B) : r;
            J && Vi(J[0]) && J[1] == (P | D | R | z) && !J[4].length && J[9] == 1 ? Y = Y[go(J[0])].apply(Y, J[3]) : Y = B.length == 1 && Vi(B) ? Y[Z]() : Y.thru(B);
          }
          return function() {
            var ve = arguments, ye = ve[0];
            if (Y && ve.length == 1 && We(ye))
              return Y.plant(ye).value();
            for (var we = 0, Oe = v ? m[we].apply(this, ve) : ye; ++we < v; )
              Oe = m[we].call(this, Oe);
            return Oe;
          };
        });
      }
      function fo(f, m, v, k, N, B, Y, Z, J, ve) {
        var ye = m & P, we = m & T, Oe = m & C, Fe = m & (D | L), Ue = m & W, Qe = Oe ? r : Cr(f);
        function Ve() {
          for (var tt = arguments.length, rt = ue(tt), Kt = tt; Kt--; )
            rt[Kt] = arguments[Kt];
          if (Fe)
            var Mt = rr(Ve), Zt = bc(rt, Mt);
          if (k && (rt = Sa(rt, k, N, Fe)), B && (rt = Ta(rt, B, Y, Fe)), tt -= Zt, Fe && tt < ve) {
            var _t = Tn(rt, Mt);
            return Pa(
              f,
              m,
              fo,
              Ve.placeholder,
              v,
              rt,
              _t,
              Z,
              J,
              ve - tt
            );
          }
          var cn = we ? v : this, _n = Oe ? cn[f] : f;
          return tt = rt.length, Z ? rt = $d(rt, Z) : Ue && tt > 1 && rt.reverse(), ye && J < tt && (rt.length = J), this && this !== Ot && this instanceof Ve && (_n = Qe || Cr(_n)), _n.apply(cn, rt);
        }
        return Ve;
      }
      function La(f, m) {
        return function(v, k) {
          return Fu(v, f, m(k), {});
        };
      }
      function ho(f, m) {
        return function(v, k) {
          var N;
          if (v === r && k === r)
            return m;
          if (v !== r && (N = v), k !== r) {
            if (N === r)
              return k;
            typeof v == "string" || typeof k == "string" ? (v = Wt(v), k = Wt(k)) : (v = va(v), k = va(k)), N = f(v, k);
          }
          return N;
        };
      }
      function Li(f) {
        return xn(function(m) {
          return m = yt(m, qt(Be())), Je(function(v) {
            var k = this;
            return f(m, function(N) {
              return Ht(N, k, v);
            });
          });
        });
      }
      function po(f, m) {
        m = m === r ? " " : Wt(m);
        var v = m.length;
        if (v < 2)
          return v ? Si(m, f) : m;
        var k = Si(m, Jr(f / Kn(m)));
        return Yn(m) ? Dn(sn(k), 0, f).join("") : k.slice(0, f);
      }
      function fd(f, m, v, k) {
        var N = m & T, B = Cr(f);
        function Y() {
          for (var Z = -1, J = arguments.length, ve = -1, ye = k.length, we = ue(ye + J), Oe = this && this !== Ot && this instanceof Y ? B : f; ++ve < ye; )
            we[ve] = k[ve];
          for (; J--; )
            we[ve++] = arguments[++Z];
          return Ht(Oe, N ? v : this, we);
        }
        return Y;
      }
      function Ra(f) {
        return function(m, v, k) {
          return k && typeof k != "number" && Nt(m, v, k) && (v = k = r), m = kn(m), v === r ? (v = m, m = 0) : v = kn(v), k = k === r ? m < v ? 1 : -1 : kn(k), Zu(m, v, k, f);
        };
      }
      function mo(f) {
        return function(m, v) {
          return typeof m == "string" && typeof v == "string" || (m = on(m), v = on(v)), f(m, v);
        };
      }
      function Pa(f, m, v, k, N, B, Y, Z, J, ve) {
        var ye = m & D, we = ye ? Y : r, Oe = ye ? r : Y, Fe = ye ? B : r, Ue = ye ? r : B;
        m |= ye ? R : O, m &= ~(ye ? O : R), m & $ || (m &= ~(T | C));
        var Qe = [
          f,
          m,
          N,
          Fe,
          we,
          Ue,
          Oe,
          Z,
          J,
          ve
        ], Ve = v.apply(r, Qe);
        return Vi(f) && Wa(Ve, Qe), Ve.placeholder = k, Ya(Ve, f, m);
      }
      function Ri(f) {
        var m = St[f];
        return function(v, k) {
          if (v = on(v), k = k == null ? 0 : $t(Ze(k), 292), k && Ys(v)) {
            var N = (ut(v) + "e").split("e"), B = m(N[0] + "e" + (+N[1] + k));
            return N = (ut(B) + "e").split("e"), +(N[0] + "e" + (+N[1] - k));
          }
          return m(v);
        };
      }
      var hd = Qn && 1 / zr(new Qn([, -0]))[1] == Q ? function(f) {
        return new Qn(f);
      } : is;
      function Na(f) {
        return function(m) {
          var v = Dt(m);
          return v == q ? li(m) : v == xe ? _c(m) : gc(m, f(m));
        };
      }
      function yn(f, m, v, k, N, B, Y, Z) {
        var J = m & C;
        if (!J && typeof f != "function")
          throw new Jt(u);
        var ve = k ? k.length : 0;
        if (ve || (m &= ~(R | O), k = N = r), Y = Y === r ? Y : Tt(Ze(Y), 0), Z = Z === r ? Z : Ze(Z), ve -= N ? N.length : 0, m & O) {
          var ye = k, we = N;
          k = N = r;
        }
        var Oe = J ? r : Fi(f), Fe = [
          f,
          m,
          v,
          k,
          N,
          ye,
          we,
          B,
          Y,
          Z
        ];
        if (Oe && Id(Fe, Oe), f = Fe[0], m = Fe[1], v = Fe[2], k = Fe[3], N = Fe[4], Z = Fe[9] = Fe[9] === r ? J ? 0 : f.length : Tt(Fe[9] - ve, 0), !Z && m & (D | L) && (m &= ~(D | L)), !m || m == T)
          var Ue = cd(f, m, v);
        else
          m == D || m == L ? Ue = ud(f, m, Z) : (m == R || m == (T | R)) && !N.length ? Ue = fd(f, m, v, k) : Ue = fo.apply(r, Fe);
        var Qe = Oe ? ga : Wa;
        return Ya(Qe(Ue, Fe), f, m);
      }
      function Ma(f, m, v, k) {
        return f === r || ln(f, Xn[v]) && !dt.call(k, v) ? m : f;
      }
      function Fa(f, m, v, k, N, B) {
        return xt(f) && xt(m) && (B.set(m, f), ao(f, m, r, Fa, B), B.delete(m)), f;
      }
      function pd(f) {
        return Ir(f) ? r : f;
      }
      function ja(f, m, v, k, N, B) {
        var Y = v & I, Z = f.length, J = m.length;
        if (Z != J && !(Y && J > Z))
          return !1;
        var ve = B.get(f), ye = B.get(m);
        if (ve && ye)
          return ve == m && ye == f;
        var we = -1, Oe = !0, Fe = v & E ? new Fn() : r;
        for (B.set(f, m), B.set(m, f); ++we < Z; ) {
          var Ue = f[we], Qe = m[we];
          if (k)
            var Ve = Y ? k(Qe, Ue, we, m, f, B) : k(Ue, Qe, we, f, m, B);
          if (Ve !== r) {
            if (Ve)
              continue;
            Oe = !1;
            break;
          }
          if (Fe) {
            if (!ei(m, function(tt, rt) {
              if (!dr(Fe, rt) && (Ue === tt || N(Ue, tt, v, k, B)))
                return Fe.push(rt);
            })) {
              Oe = !1;
              break;
            }
          } else if (!(Ue === Qe || N(Ue, Qe, v, k, B))) {
            Oe = !1;
            break;
          }
        }
        return B.delete(f), B.delete(m), Oe;
      }
      function md(f, m, v, k, N, B, Y) {
        switch (v) {
          case bt:
            if (f.byteLength != m.byteLength || f.byteOffset != m.byteOffset)
              return !1;
            f = f.buffer, m = m.buffer;
          case et:
            return !(f.byteLength != m.byteLength || !B(new Kr(f), new Kr(m)));
          case je:
          case Xe:
          case se:
            return ln(+f, +m);
          case Ke:
            return f.name == m.name && f.message == m.message;
          case ke:
          case Ne:
            return f == m + "";
          case q:
            var Z = li;
          case xe:
            var J = k & I;
            if (Z || (Z = zr), f.size != m.size && !J)
              return !1;
            var ve = Y.get(f);
            if (ve)
              return ve == m;
            k |= E, Y.set(f, m);
            var ye = ja(Z(f), Z(m), k, N, B, Y);
            return Y.delete(f), ye;
          case Se:
            if (vr)
              return vr.call(f) == vr.call(m);
        }
        return !1;
      }
      function gd(f, m, v, k, N, B) {
        var Y = v & I, Z = Ni(f), J = Z.length, ve = Ni(m), ye = ve.length;
        if (J != ye && !Y)
          return !1;
        for (var we = J; we--; ) {
          var Oe = Z[we];
          if (!(Y ? Oe in m : dt.call(m, Oe)))
            return !1;
        }
        var Fe = B.get(f), Ue = B.get(m);
        if (Fe && Ue)
          return Fe == m && Ue == f;
        var Qe = !0;
        B.set(f, m), B.set(m, f);
        for (var Ve = Y; ++we < J; ) {
          Oe = Z[we];
          var tt = f[Oe], rt = m[Oe];
          if (k)
            var Kt = Y ? k(rt, tt, Oe, m, f, B) : k(tt, rt, Oe, f, m, B);
          if (!(Kt === r ? tt === rt || N(tt, rt, v, k, B) : Kt)) {
            Qe = !1;
            break;
          }
          Ve || (Ve = Oe == "constructor");
        }
        if (Qe && !Ve) {
          var Mt = f.constructor, Zt = m.constructor;
          Mt != Zt && "constructor" in f && "constructor" in m && !(typeof Mt == "function" && Mt instanceof Mt && typeof Zt == "function" && Zt instanceof Zt) && (Qe = !1);
        }
        return B.delete(f), B.delete(m), Qe;
      }
      function xn(f) {
        return Hi(qa(f, r, tl), f + "");
      }
      function Ni(f) {
        return ia(f, It, Bi);
      }
      function Mi(f) {
        return ia(f, Vt, Ba);
      }
      var Fi = to ? function(f) {
        return to.get(f);
      } : is;
      function go(f) {
        for (var m = f.name + "", v = Jn[m], k = dt.call(Jn, m) ? v.length : 0; k--; ) {
          var N = v[k], B = N.func;
          if (B == null || B == f)
            return N.name;
        }
        return m;
      }
      function rr(f) {
        var m = dt.call(j, "placeholder") ? j : f;
        return m.placeholder;
      }
      function Be() {
        var f = j.iteratee || rs;
        return f = f === rs ? la : f, arguments.length ? f(arguments[0], arguments[1]) : f;
      }
      function bo(f, m) {
        var v = f.__data__;
        return _d(m) ? v[typeof m == "string" ? "string" : "hash"] : v.map;
      }
      function ji(f) {
        for (var m = It(f), v = m.length; v--; ) {
          var k = m[v], N = f[k];
          m[v] = [k, N, za(N)];
        }
        return m;
      }
      function Un(f, m) {
        var v = wc(f, m);
        return aa(v) ? v : r;
      }
      function bd(f) {
        var m = dt.call(f, Nn), v = f[Nn];
        try {
          f[Nn] = r;
          var k = !0;
        } catch {
        }
        var N = Wr.call(f);
        return k && (m ? f[Nn] = v : delete f[Nn]), N;
      }
      var Bi = ui ? function(f) {
        return f == null ? [] : (f = pt(f), Cn(ui(f), function(m) {
          return Gs.call(f, m);
        }));
      } : ss, Ba = ui ? function(f) {
        for (var m = []; f; )
          Sn(m, Bi(f)), f = Zr(f);
        return m;
      } : ss, Dt = Pt;
      (di && Dt(new di(new ArrayBuffer(1))) != bt || mr && Dt(new mr()) != q || fi && Dt(fi.resolve()) != qe || Qn && Dt(new Qn()) != xe || gr && Dt(new gr()) != he) && (Dt = function(f) {
        var m = Pt(f), v = m == Le ? f.constructor : r, k = v ? Vn(v) : "";
        if (k)
          switch (k) {
            case Yc:
              return bt;
            case Kc:
              return q;
            case Zc:
              return qe;
            case Xc:
              return xe;
            case Qc:
              return he;
          }
        return m;
      });
      function vd(f, m, v) {
        for (var k = -1, N = v.length; ++k < N; ) {
          var B = v[k], Y = B.size;
          switch (B.type) {
            case "drop":
              f += Y;
              break;
            case "dropRight":
              m -= Y;
              break;
            case "take":
              m = $t(m, f + Y);
              break;
            case "takeRight":
              f = Tt(f, m - Y);
              break;
          }
        }
        return { start: f, end: m };
      }
      function yd(f) {
        var m = f.match(Nr);
        return m ? m[1].split(Mr) : [];
      }
      function Ua(f, m, v) {
        m = $n(m, f);
        for (var k = -1, N = m.length, B = !1; ++k < N; ) {
          var Y = pn(m[k]);
          if (!(B = f != null && v(f, Y)))
            break;
          f = f[Y];
        }
        return B || ++k != N ? B : (N = f == null ? 0 : f.length, !!N && _o(N) && wn(Y, N) && (We(f) || zn(f)));
      }
      function xd(f) {
        var m = f.length, v = new f.constructor(m);
        return m && typeof f[0] == "string" && dt.call(f, "index") && (v.index = f.index, v.input = f.input), v;
      }
      function Va(f) {
        return typeof f.constructor == "function" && !Sr(f) ? er(Zr(f)) : {};
      }
      function wd(f, m, v) {
        var k = f.constructor;
        switch (m) {
          case et:
            return Di(f);
          case je:
          case Xe:
            return new k(+f);
          case bt:
            return rd(f, v);
          case $e:
          case Ee:
          case Ie:
          case ze:
          case ct:
          case st:
          case ht:
          case Rt:
          case ar:
            return _a(f, v);
          case q:
            return new k();
          case se:
          case Ne:
            return new k(f);
          case ke:
            return od(f);
          case xe:
            return new k();
          case Se:
            return id(f);
        }
      }
      function Ed(f, m) {
        var v = m.length;
        if (!v)
          return f;
        var k = v - 1;
        return m[k] = (v > 1 ? "& " : "") + m[k], m = m.join(v > 2 ? ", " : " "), f.replace(Rn, `{
/* [wrapped with ` + m + `] */
`);
      }
      function kd(f) {
        return We(f) || zn(f) || !!(Ws && f && f[Ws]);
      }
      function wn(f, m) {
        var v = typeof f;
        return m = m ?? fe, !!m && (v == "number" || v != "symbol" && zo.test(f)) && f > -1 && f % 1 == 0 && f < m;
      }
      function Nt(f, m, v) {
        if (!xt(v))
          return !1;
        var k = typeof m;
        return (k == "number" ? Ut(v) && wn(m, v.length) : k == "string" && m in v) ? ln(v[m], f) : !1;
      }
      function Ui(f, m) {
        if (We(f))
          return !1;
        var v = typeof f;
        return v == "number" || v == "symbol" || v == "boolean" || f == null || Yt(f) ? !0 : Po.test(f) || !Ro.test(f) || m != null && f in pt(m);
      }
      function _d(f) {
        var m = typeof f;
        return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? f !== "__proto__" : f === null;
      }
      function Vi(f) {
        var m = go(f), v = j[m];
        if (typeof v != "function" || !(m in nt.prototype))
          return !1;
        if (f === v)
          return !0;
        var k = Fi(v);
        return !!k && f === k[0];
      }
      function Cd(f) {
        return !!zs && zs in f;
      }
      var Sd = qr ? En : as;
      function Sr(f) {
        var m = f && f.constructor, v = typeof m == "function" && m.prototype || Xn;
        return f === v;
      }
      function za(f) {
        return f === f && !xt(f);
      }
      function Ha(f, m) {
        return function(v) {
          return v == null ? !1 : v[f] === m && (m !== r || f in pt(v));
        };
      }
      function Td(f) {
        var m = Eo(f, function(k) {
          return v.size === g && v.clear(), k;
        }), v = m.cache;
        return m;
      }
      function Id(f, m) {
        var v = f[1], k = m[1], N = v | k, B = N < (T | C | P), Y = k == P && v == D || k == P && v == z && f[7].length <= m[8] || k == (P | z) && m[7].length <= m[8] && v == D;
        if (!(B || Y))
          return f;
        k & T && (f[2] = m[2], N |= v & T ? 0 : $);
        var Z = m[3];
        if (Z) {
          var J = f[3];
          f[3] = J ? Sa(J, Z, m[4]) : Z, f[4] = J ? Tn(f[3], b) : m[4];
        }
        return Z = m[5], Z && (J = f[5], f[5] = J ? Ta(J, Z, m[6]) : Z, f[6] = J ? Tn(f[5], b) : m[6]), Z = m[7], Z && (f[7] = Z), k & P && (f[8] = f[8] == null ? m[8] : $t(f[8], m[8])), f[9] == null && (f[9] = m[9]), f[0] = m[0], f[1] = N, f;
      }
      function Od(f) {
        var m = [];
        if (f != null)
          for (var v in pt(f))
            m.push(v);
        return m;
      }
      function Ad(f) {
        return Wr.call(f);
      }
      function qa(f, m, v) {
        return m = Tt(m === r ? f.length - 1 : m, 0), function() {
          for (var k = arguments, N = -1, B = Tt(k.length - m, 0), Y = ue(B); ++N < B; )
            Y[N] = k[m + N];
          N = -1;
          for (var Z = ue(m + 1); ++N < m; )
            Z[N] = k[N];
          return Z[m] = v(Y), Ht(f, this, Z);
        };
      }
      function Ga(f, m) {
        return m.length < 2 ? f : Bn(f, nn(m, 0, -1));
      }
      function $d(f, m) {
        for (var v = f.length, k = $t(m.length, v), N = Bt(f); k--; ) {
          var B = m[k];
          f[k] = wn(B, v) ? N[B] : r;
        }
        return f;
      }
      function zi(f, m) {
        if (!(m === "constructor" && typeof f[m] == "function") && m != "__proto__")
          return f[m];
      }
      var Wa = Ka(ga), Tr = Uc || function(f, m) {
        return Ot.setTimeout(f, m);
      }, Hi = Ka(Ju);
      function Ya(f, m, v) {
        var k = m + "";
        return Hi(f, Ed(k, Dd(yd(k), v)));
      }
      function Ka(f) {
        var m = 0, v = 0;
        return function() {
          var k = qc(), N = U - (k - v);
          if (v = k, N > 0) {
            if (++m >= F)
              return arguments[0];
          } else
            m = 0;
          return f.apply(r, arguments);
        };
      }
      function vo(f, m) {
        var v = -1, k = f.length, N = k - 1;
        for (m = m === r ? k : m; ++v < m; ) {
          var B = Ci(v, N), Y = f[B];
          f[B] = f[v], f[v] = Y;
        }
        return f.length = m, f;
      }
      var Za = Td(function(f) {
        var m = [];
        return f.charCodeAt(0) === 46 && m.push(""), f.replace(No, function(v, k, N, B) {
          m.push(N ? B.replace(Fo, "$1") : k || v);
        }), m;
      });
      function pn(f) {
        if (typeof f == "string" || Yt(f))
          return f;
        var m = f + "";
        return m == "0" && 1 / f == -Q ? "-0" : m;
      }
      function Vn(f) {
        if (f != null) {
          try {
            return Gr.call(f);
          } catch {
          }
          try {
            return f + "";
          } catch {
          }
        }
        return "";
      }
      function Dd(f, m) {
        return Qt(oe, function(v) {
          var k = "_." + v[0];
          m & v[1] && !Ur(f, k) && f.push(k);
        }), f.sort();
      }
      function Xa(f) {
        if (f instanceof nt)
          return f.clone();
        var m = new en(f.__wrapped__, f.__chain__);
        return m.__actions__ = Bt(f.__actions__), m.__index__ = f.__index__, m.__values__ = f.__values__, m;
      }
      function Ld(f, m, v) {
        (v ? Nt(f, m, v) : m === r) ? m = 1 : m = Tt(Ze(m), 0);
        var k = f == null ? 0 : f.length;
        if (!k || m < 1)
          return [];
        for (var N = 0, B = 0, Y = ue(Jr(k / m)); N < k; )
          Y[B++] = nn(f, N, N += m);
        return Y;
      }
      function Rd(f) {
        for (var m = -1, v = f == null ? 0 : f.length, k = 0, N = []; ++m < v; ) {
          var B = f[m];
          B && (N[k++] = B);
        }
        return N;
      }
      function Pd() {
        var f = arguments.length;
        if (!f)
          return [];
        for (var m = ue(f - 1), v = arguments[0], k = f; k--; )
          m[k - 1] = arguments[k];
        return Sn(We(v) ? Bt(v) : [v], At(m, 1));
      }
      var Nd = Je(function(f, m) {
        return kt(f) ? xr(f, At(m, 1, kt, !0)) : [];
      }), Md = Je(function(f, m) {
        var v = rn(m);
        return kt(v) && (v = r), kt(f) ? xr(f, At(m, 1, kt, !0), Be(v, 2)) : [];
      }), Fd = Je(function(f, m) {
        var v = rn(m);
        return kt(v) && (v = r), kt(f) ? xr(f, At(m, 1, kt, !0), r, v) : [];
      });
      function jd(f, m, v) {
        var k = f == null ? 0 : f.length;
        return k ? (m = v || m === r ? 1 : Ze(m), nn(f, m < 0 ? 0 : m, k)) : [];
      }
      function Bd(f, m, v) {
        var k = f == null ? 0 : f.length;
        return k ? (m = v || m === r ? 1 : Ze(m), m = k - m, nn(f, 0, m < 0 ? 0 : m)) : [];
      }
      function Ud(f, m) {
        return f && f.length ? co(f, Be(m, 3), !0, !0) : [];
      }
      function Vd(f, m) {
        return f && f.length ? co(f, Be(m, 3), !0) : [];
      }
      function zd(f, m, v, k) {
        var N = f == null ? 0 : f.length;
        return N ? (v && typeof v != "number" && Nt(f, m, v) && (v = 0, k = N), Du(f, m, v, k)) : [];
      }
      function Qa(f, m, v) {
        var k = f == null ? 0 : f.length;
        if (!k)
          return -1;
        var N = v == null ? 0 : Ze(v);
        return N < 0 && (N = Tt(k + N, 0)), Vr(f, Be(m, 3), N);
      }
      function Ja(f, m, v) {
        var k = f == null ? 0 : f.length;
        if (!k)
          return -1;
        var N = k - 1;
        return v !== r && (N = Ze(v), N = v < 0 ? Tt(k + N, 0) : $t(N, k - 1)), Vr(f, Be(m, 3), N, !0);
      }
      function tl(f) {
        var m = f == null ? 0 : f.length;
        return m ? At(f, 1) : [];
      }
      function Hd(f) {
        var m = f == null ? 0 : f.length;
        return m ? At(f, Q) : [];
      }
      function qd(f, m) {
        var v = f == null ? 0 : f.length;
        return v ? (m = m === r ? 1 : Ze(m), At(f, m)) : [];
      }
      function Gd(f) {
        for (var m = -1, v = f == null ? 0 : f.length, k = {}; ++m < v; ) {
          var N = f[m];
          k[N[0]] = N[1];
        }
        return k;
      }
      function nl(f) {
        return f && f.length ? f[0] : r;
      }
      function Wd(f, m, v) {
        var k = f == null ? 0 : f.length;
        if (!k)
          return -1;
        var N = v == null ? 0 : Ze(v);
        return N < 0 && (N = Tt(k + N, 0)), Wn(f, m, N);
      }
      function Yd(f) {
        var m = f == null ? 0 : f.length;
        return m ? nn(f, 0, -1) : [];
      }
      var Kd = Je(function(f) {
        var m = yt(f, Ai);
        return m.length && m[0] === f[0] ? yi(m) : [];
      }), Zd = Je(function(f) {
        var m = rn(f), v = yt(f, Ai);
        return m === rn(v) ? m = r : v.pop(), v.length && v[0] === f[0] ? yi(v, Be(m, 2)) : [];
      }), Xd = Je(function(f) {
        var m = rn(f), v = yt(f, Ai);
        return m = typeof m == "function" ? m : r, m && v.pop(), v.length && v[0] === f[0] ? yi(v, r, m) : [];
      });
      function Qd(f, m) {
        return f == null ? "" : zc.call(f, m);
      }
      function rn(f) {
        var m = f == null ? 0 : f.length;
        return m ? f[m - 1] : r;
      }
      function Jd(f, m, v) {
        var k = f == null ? 0 : f.length;
        if (!k)
          return -1;
        var N = k;
        return v !== r && (N = Ze(v), N = N < 0 ? Tt(k + N, 0) : $t(N, k - 1)), m === m ? Tc(f, m, N) : Vr(f, Ps, N, !0);
      }
      function ef(f, m) {
        return f && f.length ? fa(f, Ze(m)) : r;
      }
      var tf = Je(rl);
      function rl(f, m) {
        return f && f.length && m && m.length ? _i(f, m) : f;
      }
      function nf(f, m, v) {
        return f && f.length && m && m.length ? _i(f, m, Be(v, 2)) : f;
      }
      function rf(f, m, v) {
        return f && f.length && m && m.length ? _i(f, m, r, v) : f;
      }
      var of = xn(function(f, m) {
        var v = f == null ? 0 : f.length, k = mi(f, m);
        return ma(f, yt(m, function(N) {
          return wn(N, v) ? +N : N;
        }).sort(Ca)), k;
      });
      function sf(f, m) {
        var v = [];
        if (!(f && f.length))
          return v;
        var k = -1, N = [], B = f.length;
        for (m = Be(m, 3); ++k < B; ) {
          var Y = f[k];
          m(Y, k, f) && (v.push(Y), N.push(k));
        }
        return ma(f, N), v;
      }
      function qi(f) {
        return f == null ? f : Wc.call(f);
      }
      function lf(f, m, v) {
        var k = f == null ? 0 : f.length;
        return k ? (v && typeof v != "number" && Nt(f, m, v) ? (m = 0, v = k) : (m = m == null ? 0 : Ze(m), v = v === r ? k : Ze(v)), nn(f, m, v)) : [];
      }
      function cf(f, m) {
        return lo(f, m);
      }
      function uf(f, m, v) {
        return Ti(f, m, Be(v, 2));
      }
      function df(f, m) {
        var v = f == null ? 0 : f.length;
        if (v) {
          var k = lo(f, m);
          if (k < v && ln(f[k], m))
            return k;
        }
        return -1;
      }
      function ff(f, m) {
        return lo(f, m, !0);
      }
      function hf(f, m, v) {
        return Ti(f, m, Be(v, 2), !0);
      }
      function pf(f, m) {
        var v = f == null ? 0 : f.length;
        if (v) {
          var k = lo(f, m, !0) - 1;
          if (ln(f[k], m))
            return k;
        }
        return -1;
      }
      function mf(f) {
        return f && f.length ? ba(f) : [];
      }
      function gf(f, m) {
        return f && f.length ? ba(f, Be(m, 2)) : [];
      }
      function bf(f) {
        var m = f == null ? 0 : f.length;
        return m ? nn(f, 1, m) : [];
      }
      function vf(f, m, v) {
        return f && f.length ? (m = v || m === r ? 1 : Ze(m), nn(f, 0, m < 0 ? 0 : m)) : [];
      }
      function yf(f, m, v) {
        var k = f == null ? 0 : f.length;
        return k ? (m = v || m === r ? 1 : Ze(m), m = k - m, nn(f, m < 0 ? 0 : m, k)) : [];
      }
      function xf(f, m) {
        return f && f.length ? co(f, Be(m, 3), !1, !0) : [];
      }
      function wf(f, m) {
        return f && f.length ? co(f, Be(m, 3)) : [];
      }
      var Ef = Je(function(f) {
        return An(At(f, 1, kt, !0));
      }), kf = Je(function(f) {
        var m = rn(f);
        return kt(m) && (m = r), An(At(f, 1, kt, !0), Be(m, 2));
      }), _f = Je(function(f) {
        var m = rn(f);
        return m = typeof m == "function" ? m : r, An(At(f, 1, kt, !0), r, m);
      });
      function Cf(f) {
        return f && f.length ? An(f) : [];
      }
      function Sf(f, m) {
        return f && f.length ? An(f, Be(m, 2)) : [];
      }
      function Tf(f, m) {
        return m = typeof m == "function" ? m : r, f && f.length ? An(f, r, m) : [];
      }
      function Gi(f) {
        if (!(f && f.length))
          return [];
        var m = 0;
        return f = Cn(f, function(v) {
          if (kt(v))
            return m = Tt(v.length, m), !0;
        }), si(m, function(v) {
          return yt(f, ti(v));
        });
      }
      function ol(f, m) {
        if (!(f && f.length))
          return [];
        var v = Gi(f);
        return m == null ? v : yt(v, function(k) {
          return Ht(m, r, k);
        });
      }
      var If = Je(function(f, m) {
        return kt(f) ? xr(f, m) : [];
      }), Of = Je(function(f) {
        return Oi(Cn(f, kt));
      }), Af = Je(function(f) {
        var m = rn(f);
        return kt(m) && (m = r), Oi(Cn(f, kt), Be(m, 2));
      }), $f = Je(function(f) {
        var m = rn(f);
        return m = typeof m == "function" ? m : r, Oi(Cn(f, kt), r, m);
      }), Df = Je(Gi);
      function Lf(f, m) {
        return wa(f || [], m || [], yr);
      }
      function Rf(f, m) {
        return wa(f || [], m || [], _r);
      }
      var Pf = Je(function(f) {
        var m = f.length, v = m > 1 ? f[m - 1] : r;
        return v = typeof v == "function" ? (f.pop(), v) : r, ol(f, v);
      });
      function il(f) {
        var m = j(f);
        return m.__chain__ = !0, m;
      }
      function Nf(f, m) {
        return m(f), f;
      }
      function yo(f, m) {
        return m(f);
      }
      var Mf = xn(function(f) {
        var m = f.length, v = m ? f[0] : 0, k = this.__wrapped__, N = function(B) {
          return mi(B, f);
        };
        return m > 1 || this.__actions__.length || !(k instanceof nt) || !wn(v) ? this.thru(N) : (k = k.slice(v, +v + (m ? 1 : 0)), k.__actions__.push({
          func: yo,
          args: [N],
          thisArg: r
        }), new en(k, this.__chain__).thru(function(B) {
          return m && !B.length && B.push(r), B;
        }));
      });
      function Ff() {
        return il(this);
      }
      function jf() {
        return new en(this.value(), this.__chain__);
      }
      function Bf() {
        this.__values__ === r && (this.__values__ = wl(this.value()));
        var f = this.__index__ >= this.__values__.length, m = f ? r : this.__values__[this.__index__++];
        return { done: f, value: m };
      }
      function Uf() {
        return this;
      }
      function Vf(f) {
        for (var m, v = this; v instanceof ro; ) {
          var k = Xa(v);
          k.__index__ = 0, k.__values__ = r, m ? N.__wrapped__ = k : m = k;
          var N = k;
          v = v.__wrapped__;
        }
        return N.__wrapped__ = f, m;
      }
      function zf() {
        var f = this.__wrapped__;
        if (f instanceof nt) {
          var m = f;
          return this.__actions__.length && (m = new nt(this)), m = m.reverse(), m.__actions__.push({
            func: yo,
            args: [qi],
            thisArg: r
          }), new en(m, this.__chain__);
        }
        return this.thru(qi);
      }
      function Hf() {
        return xa(this.__wrapped__, this.__actions__);
      }
      var qf = uo(function(f, m, v) {
        dt.call(f, v) ? ++f[v] : vn(f, v, 1);
      });
      function Gf(f, m, v) {
        var k = We(f) ? Ls : $u;
        return v && Nt(f, m, v) && (m = r), k(f, Be(m, 3));
      }
      function Wf(f, m) {
        var v = We(f) ? Cn : ra;
        return v(f, Be(m, 3));
      }
      var Yf = $a(Qa), Kf = $a(Ja);
      function Zf(f, m) {
        return At(xo(f, m), 1);
      }
      function Xf(f, m) {
        return At(xo(f, m), Q);
      }
      function Qf(f, m, v) {
        return v = v === r ? 1 : Ze(v), At(xo(f, m), v);
      }
      function sl(f, m) {
        var v = We(f) ? Qt : On;
        return v(f, Be(m, 3));
      }
      function al(f, m) {
        var v = We(f) ? cc : na;
        return v(f, Be(m, 3));
      }
      var Jf = uo(function(f, m, v) {
        dt.call(f, v) ? f[v].push(m) : vn(f, v, [m]);
      });
      function eh(f, m, v, k) {
        f = Ut(f) ? f : sr(f), v = v && !k ? Ze(v) : 0;
        var N = f.length;
        return v < 0 && (v = Tt(N + v, 0)), Co(f) ? v <= N && f.indexOf(m, v) > -1 : !!N && Wn(f, m, v) > -1;
      }
      var th = Je(function(f, m, v) {
        var k = -1, N = typeof m == "function", B = Ut(f) ? ue(f.length) : [];
        return On(f, function(Y) {
          B[++k] = N ? Ht(m, Y, v) : Er(Y, m, v);
        }), B;
      }), nh = uo(function(f, m, v) {
        vn(f, v, m);
      });
      function xo(f, m) {
        var v = We(f) ? yt : ca;
        return v(f, Be(m, 3));
      }
      function rh(f, m, v, k) {
        return f == null ? [] : (We(m) || (m = m == null ? [] : [m]), v = k ? r : v, We(v) || (v = v == null ? [] : [v]), ha(f, m, v));
      }
      var oh = uo(function(f, m, v) {
        f[v ? 0 : 1].push(m);
      }, function() {
        return [[], []];
      });
      function ih(f, m, v) {
        var k = We(f) ? Jo : Ms, N = arguments.length < 3;
        return k(f, Be(m, 4), v, N, On);
      }
      function sh(f, m, v) {
        var k = We(f) ? uc : Ms, N = arguments.length < 3;
        return k(f, Be(m, 4), v, N, na);
      }
      function ah(f, m) {
        var v = We(f) ? Cn : ra;
        return v(f, ko(Be(m, 3)));
      }
      function lh(f) {
        var m = We(f) ? Qs : Xu;
        return m(f);
      }
      function ch(f, m, v) {
        (v ? Nt(f, m, v) : m === r) ? m = 1 : m = Ze(m);
        var k = We(f) ? Su : Qu;
        return k(f, m);
      }
      function uh(f) {
        var m = We(f) ? Tu : ed;
        return m(f);
      }
      function dh(f) {
        if (f == null)
          return 0;
        if (Ut(f))
          return Co(f) ? Kn(f) : f.length;
        var m = Dt(f);
        return m == q || m == xe ? f.size : Ei(f).length;
      }
      function fh(f, m, v) {
        var k = We(f) ? ei : td;
        return v && Nt(f, m, v) && (m = r), k(f, Be(m, 3));
      }
      var hh = Je(function(f, m) {
        if (f == null)
          return [];
        var v = m.length;
        return v > 1 && Nt(f, m[0], m[1]) ? m = [] : v > 2 && Nt(m[0], m[1], m[2]) && (m = [m[0]]), ha(f, At(m, 1), []);
      }), wo = Bc || function() {
        return Ot.Date.now();
      };
      function ph(f, m) {
        if (typeof m != "function")
          throw new Jt(u);
        return f = Ze(f), function() {
          if (--f < 1)
            return m.apply(this, arguments);
        };
      }
      function cl(f, m, v) {
        return m = v ? r : m, m = f && m == null ? f.length : m, yn(f, P, r, r, r, r, m);
      }
      function ul(f, m) {
        var v;
        if (typeof m != "function")
          throw new Jt(u);
        return f = Ze(f), function() {
          return --f > 0 && (v = m.apply(this, arguments)), f <= 1 && (m = r), v;
        };
      }
      var Wi = Je(function(f, m, v) {
        var k = T;
        if (v.length) {
          var N = Tn(v, rr(Wi));
          k |= R;
        }
        return yn(f, k, m, v, N);
      }), dl = Je(function(f, m, v) {
        var k = T | C;
        if (v.length) {
          var N = Tn(v, rr(dl));
          k |= R;
        }
        return yn(m, k, f, v, N);
      });
      function fl(f, m, v) {
        m = v ? r : m;
        var k = yn(f, D, r, r, r, r, r, m);
        return k.placeholder = fl.placeholder, k;
      }
      function hl(f, m, v) {
        m = v ? r : m;
        var k = yn(f, L, r, r, r, r, r, m);
        return k.placeholder = hl.placeholder, k;
      }
      function pl(f, m, v) {
        var k, N, B, Y, Z, J, ve = 0, ye = !1, we = !1, Oe = !0;
        if (typeof f != "function")
          throw new Jt(u);
        m = on(m) || 0, xt(v) && (ye = !!v.leading, we = "maxWait" in v, B = we ? Tt(on(v.maxWait) || 0, m) : B, Oe = "trailing" in v ? !!v.trailing : Oe);
        function Fe(_t) {
          var cn = k, _n = N;
          return k = N = r, ve = _t, Y = f.apply(_n, cn), Y;
        }
        function Ue(_t) {
          return ve = _t, Z = Tr(tt, m), ye ? Fe(_t) : Y;
        }
        function Qe(_t) {
          var cn = _t - J, _n = _t - ve, Pl = m - cn;
          return we ? $t(Pl, B - _n) : Pl;
        }
        function Ve(_t) {
          var cn = _t - J, _n = _t - ve;
          return J === r || cn >= m || cn < 0 || we && _n >= B;
        }
        function tt() {
          var _t = wo();
          if (Ve(_t))
            return rt(_t);
          Z = Tr(tt, Qe(_t));
        }
        function rt(_t) {
          return Z = r, Oe && k ? Fe(_t) : (k = N = r, Y);
        }
        function Kt() {
          Z !== r && Ea(Z), ve = 0, k = J = N = Z = r;
        }
        function Mt() {
          return Z === r ? Y : rt(wo());
        }
        function Zt() {
          var _t = wo(), cn = Ve(_t);
          if (k = arguments, N = this, J = _t, cn) {
            if (Z === r)
              return Ue(J);
            if (we)
              return Ea(Z), Z = Tr(tt, m), Fe(J);
          }
          return Z === r && (Z = Tr(tt, m)), Y;
        }
        return Zt.cancel = Kt, Zt.flush = Mt, Zt;
      }
      var mh = Je(function(f, m) {
        return ta(f, 1, m);
      }), gh = Je(function(f, m, v) {
        return ta(f, on(m) || 0, v);
      });
      function bh(f) {
        return yn(f, W);
      }
      function Eo(f, m) {
        if (typeof f != "function" || m != null && typeof m != "function")
          throw new Jt(u);
        var v = function() {
          var k = arguments, N = m ? m.apply(this, k) : k[0], B = v.cache;
          if (B.has(N))
            return B.get(N);
          var Y = f.apply(this, k);
          return v.cache = B.set(N, Y) || B, Y;
        };
        return v.cache = new (Eo.Cache || bn)(), v;
      }
      Eo.Cache = bn;
      function ko(f) {
        if (typeof f != "function")
          throw new Jt(u);
        return function() {
          var m = arguments;
          switch (m.length) {
            case 0:
              return !f.call(this);
            case 1:
              return !f.call(this, m[0]);
            case 2:
              return !f.call(this, m[0], m[1]);
            case 3:
              return !f.call(this, m[0], m[1], m[2]);
          }
          return !f.apply(this, m);
        };
      }
      function vh(f) {
        return ul(2, f);
      }
      var yh = nd(function(f, m) {
        m = m.length == 1 && We(m[0]) ? yt(m[0], qt(Be())) : yt(At(m, 1), qt(Be()));
        var v = m.length;
        return Je(function(k) {
          for (var N = -1, B = $t(k.length, v); ++N < B; )
            k[N] = m[N].call(this, k[N]);
          return Ht(f, this, k);
        });
      }), Yi = Je(function(f, m) {
        var v = Tn(m, rr(Yi));
        return yn(f, R, r, m, v);
      }), ml = Je(function(f, m) {
        var v = Tn(m, rr(ml));
        return yn(f, O, r, m, v);
      }), xh = xn(function(f, m) {
        return yn(f, z, r, r, r, m);
      });
      function wh(f, m) {
        if (typeof f != "function")
          throw new Jt(u);
        return m = m === r ? m : Ze(m), Je(f, m);
      }
      function Eh(f, m) {
        if (typeof f != "function")
          throw new Jt(u);
        return m = m == null ? 0 : Tt(Ze(m), 0), Je(function(v) {
          var k = v[m], N = Dn(v, 0, m);
          return k && Sn(N, k), Ht(f, this, N);
        });
      }
      function kh(f, m, v) {
        var k = !0, N = !0;
        if (typeof f != "function")
          throw new Jt(u);
        return xt(v) && (k = "leading" in v ? !!v.leading : k, N = "trailing" in v ? !!v.trailing : N), pl(f, m, {
          leading: k,
          maxWait: m,
          trailing: N
        });
      }
      function _h(f) {
        return cl(f, 1);
      }
      function Ch(f, m) {
        return Yi($i(m), f);
      }
      function Sh() {
        if (!arguments.length)
          return [];
        var f = arguments[0];
        return We(f) ? f : [f];
      }
      function Th(f) {
        return tn(f, y);
      }
      function Ih(f, m) {
        return m = typeof m == "function" ? m : r, tn(f, y, m);
      }
      function Oh(f) {
        return tn(f, x | y);
      }
      function Ah(f, m) {
        return m = typeof m == "function" ? m : r, tn(f, x | y, m);
      }
      function $h(f, m) {
        return m == null || ea(f, m, It(m));
      }
      function ln(f, m) {
        return f === m || f !== f && m !== m;
      }
      var Dh = mo(vi), Lh = mo(function(f, m) {
        return f >= m;
      }), zn = sa(function() {
        return arguments;
      }()) ? sa : function(f) {
        return wt(f) && dt.call(f, "callee") && !Gs.call(f, "callee");
      }, We = ue.isArray, Rh = Ts ? qt(Ts) : ju;
      function Ut(f) {
        return f != null && _o(f.length) && !En(f);
      }
      function kt(f) {
        return wt(f) && Ut(f);
      }
      function Ph(f) {
        return f === !0 || f === !1 || wt(f) && Pt(f) == je;
      }
      var Ln = Vc || as, Nh = Is ? qt(Is) : Bu;
      function Mh(f) {
        return wt(f) && f.nodeType === 1 && !Ir(f);
      }
      function Fh(f) {
        if (f == null)
          return !0;
        if (Ut(f) && (We(f) || typeof f == "string" || typeof f.splice == "function" || Ln(f) || ir(f) || zn(f)))
          return !f.length;
        var m = Dt(f);
        if (m == q || m == xe)
          return !f.size;
        if (Sr(f))
          return !Ei(f).length;
        for (var v in f)
          if (dt.call(f, v))
            return !1;
        return !0;
      }
      function jh(f, m) {
        return kr(f, m);
      }
      function Bh(f, m, v) {
        v = typeof v == "function" ? v : r;
        var k = v ? v(f, m) : r;
        return k === r ? kr(f, m, r, v) : !!k;
      }
      function Ki(f) {
        if (!wt(f))
          return !1;
        var m = Pt(f);
        return m == Ke || m == He || typeof f.message == "string" && typeof f.name == "string" && !Ir(f);
      }
      function Uh(f) {
        return typeof f == "number" && Ys(f);
      }
      function En(f) {
        if (!xt(f))
          return !1;
        var m = Pt(f);
        return m == ot || m == K || m == Ae || m == Ct;
      }
      function bl(f) {
        return typeof f == "number" && f == Ze(f);
      }
      function _o(f) {
        return typeof f == "number" && f > -1 && f % 1 == 0 && f <= fe;
      }
      function xt(f) {
        var m = typeof f;
        return f != null && (m == "object" || m == "function");
      }
      function wt(f) {
        return f != null && typeof f == "object";
      }
      var vl = Os ? qt(Os) : Vu;
      function Vh(f, m) {
        return f === m || wi(f, m, ji(m));
      }
      function zh(f, m, v) {
        return v = typeof v == "function" ? v : r, wi(f, m, ji(m), v);
      }
      function Hh(f) {
        return yl(f) && f != +f;
      }
      function qh(f) {
        if (Sd(f))
          throw new Ge(c);
        return aa(f);
      }
      function Gh(f) {
        return f === null;
      }
      function Wh(f) {
        return f == null;
      }
      function yl(f) {
        return typeof f == "number" || wt(f) && Pt(f) == se;
      }
      function Ir(f) {
        if (!wt(f) || Pt(f) != Le)
          return !1;
        var m = Zr(f);
        if (m === null)
          return !0;
        var v = dt.call(m, "constructor") && m.constructor;
        return typeof v == "function" && v instanceof v && Gr.call(v) == Nc;
      }
      var Zi = As ? qt(As) : zu;
      function Yh(f) {
        return bl(f) && f >= -fe && f <= fe;
      }
      var xl = $s ? qt($s) : Hu;
      function Co(f) {
        return typeof f == "string" || !We(f) && wt(f) && Pt(f) == Ne;
      }
      function Yt(f) {
        return typeof f == "symbol" || wt(f) && Pt(f) == Se;
      }
      var ir = Ds ? qt(Ds) : qu;
      function Kh(f) {
        return f === r;
      }
      function Zh(f) {
        return wt(f) && Dt(f) == he;
      }
      function Xh(f) {
        return wt(f) && Pt(f) == Ye;
      }
      var Qh = mo(ki), Jh = mo(function(f, m) {
        return f <= m;
      });
      function wl(f) {
        if (!f)
          return [];
        if (Ut(f))
          return Co(f) ? sn(f) : Bt(f);
        if (fr && f[fr])
          return kc(f[fr]());
        var m = Dt(f), v = m == q ? li : m == xe ? zr : sr;
        return v(f);
      }
      function kn(f) {
        if (!f)
          return f === 0 ? f : 0;
        if (f = on(f), f === Q || f === -Q) {
          var m = f < 0 ? -1 : 1;
          return m * te;
        }
        return f === f ? f : 0;
      }
      function Ze(f) {
        var m = kn(f), v = m % 1;
        return m === m ? v ? m - v : m : 0;
      }
      function El(f) {
        return f ? jn(Ze(f), 0, me) : 0;
      }
      function on(f) {
        if (typeof f == "number")
          return f;
        if (Yt(f))
          return de;
        if (xt(f)) {
          var m = typeof f.valueOf == "function" ? f.valueOf() : f;
          f = xt(m) ? m + "" : m;
        }
        if (typeof f != "string")
          return f === 0 ? f : +f;
        f = Fs(f);
        var v = Uo.test(f);
        return v || Vo.test(f) ? rc(f.slice(2), v ? 2 : 8) : Bo.test(f) ? de : +f;
      }
      function kl(f) {
        return hn(f, Vt(f));
      }
      function ep(f) {
        return f ? jn(Ze(f), -fe, fe) : f === 0 ? f : 0;
      }
      function ut(f) {
        return f == null ? "" : Wt(f);
      }
      var tp = tr(function(f, m) {
        if (Sr(m) || Ut(m)) {
          hn(m, It(m), f);
          return;
        }
        for (var v in m)
          dt.call(m, v) && yr(f, v, m[v]);
      }), _l = tr(function(f, m) {
        hn(m, Vt(m), f);
      }), So = tr(function(f, m, v, k) {
        hn(m, Vt(m), f, k);
      }), np = tr(function(f, m, v, k) {
        hn(m, It(m), f, k);
      }), rp = xn(mi);
      function op(f, m) {
        var v = er(f);
        return m == null ? v : Js(v, m);
      }
      var ip = Je(function(f, m) {
        f = pt(f);
        var v = -1, k = m.length, N = k > 2 ? m[2] : r;
        for (N && Nt(m[0], m[1], N) && (k = 1); ++v < k; )
          for (var B = m[v], Y = Vt(B), Z = -1, J = Y.length; ++Z < J; ) {
            var ve = Y[Z], ye = f[ve];
            (ye === r || ln(ye, Xn[ve]) && !dt.call(f, ve)) && (f[ve] = B[ve]);
          }
        return f;
      }), sp = Je(function(f) {
        return f.push(r, Fa), Ht(Cl, r, f);
      });
      function lp(f, m) {
        return Rs(f, Be(m, 3), dn);
      }
      function cp(f, m) {
        return Rs(f, Be(m, 3), bi);
      }
      function up(f, m) {
        return f == null ? f : gi(f, Be(m, 3), Vt);
      }
      function dp(f, m) {
        return f == null ? f : oa(f, Be(m, 3), Vt);
      }
      function fp(f, m) {
        return f && dn(f, Be(m, 3));
      }
      function hp(f, m) {
        return f && bi(f, Be(m, 3));
      }
      function pp(f) {
        return f == null ? [] : so(f, It(f));
      }
      function gp(f) {
        return f == null ? [] : so(f, Vt(f));
      }
      function Qi(f, m, v) {
        var k = f == null ? r : Bn(f, m);
        return k === r ? v : k;
      }
      function bp(f, m) {
        return f != null && Ua(f, m, Lu);
      }
      function Ji(f, m) {
        return f != null && Ua(f, m, Ru);
      }
      var vp = La(function(f, m, v) {
        m != null && typeof m.toString != "function" && (m = Wr.call(m)), f[m] = v;
      }, ns(zt)), yp = La(function(f, m, v) {
        m != null && typeof m.toString != "function" && (m = Wr.call(m)), dt.call(f, m) ? f[m].push(v) : f[m] = [v];
      }, Be), xp = Je(Er);
      function It(f) {
        return Ut(f) ? Xs(f) : Ei(f);
      }
      function Vt(f) {
        return Ut(f) ? Xs(f, !0) : Gu(f);
      }
      function Ep(f, m) {
        var v = {};
        return m = Be(m, 3), dn(f, function(k, N, B) {
          vn(v, m(k, N, B), k);
        }), v;
      }
      function kp(f, m) {
        var v = {};
        return m = Be(m, 3), dn(f, function(k, N, B) {
          vn(v, N, m(k, N, B));
        }), v;
      }
      var _p = tr(function(f, m, v) {
        ao(f, m, v);
      }), Cl = tr(function(f, m, v, k) {
        ao(f, m, v, k);
      }), Cp = xn(function(f, m) {
        var v = {};
        if (f == null)
          return v;
        var k = !1;
        m = yt(m, function(B) {
          return B = $n(B, f), k || (k = B.length > 1), B;
        }), hn(f, Mi(f), v), k && (v = tn(v, x | w | y, pd));
        for (var N = m.length; N--; )
          Ii(v, m[N]);
        return v;
      });
      function Sp(f, m) {
        return Sl(f, ko(Be(m)));
      }
      var Tp = xn(function(f, m) {
        return f == null ? {} : Yu(f, m);
      });
      function Sl(f, m) {
        if (f == null)
          return {};
        var v = yt(Mi(f), function(k) {
          return [k];
        });
        return m = Be(m), pa(f, v, function(k, N) {
          return m(k, N[0]);
        });
      }
      function Ip(f, m, v) {
        m = $n(m, f);
        var k = -1, N = m.length;
        for (N || (N = 1, f = r); ++k < N; ) {
          var B = f == null ? r : f[pn(m[k])];
          B === r && (k = N, B = v), f = En(B) ? B.call(f) : B;
        }
        return f;
      }
      function Op(f, m, v) {
        return f == null ? f : _r(f, m, v);
      }
      function Ap(f, m, v, k) {
        return k = typeof k == "function" ? k : r, f == null ? f : _r(f, m, v, k);
      }
      var Tl = Na(It), Il = Na(Vt);
      function $p(f, m, v) {
        var k = We(f), N = k || Ln(f) || ir(f);
        if (m = Be(m, 4), v == null) {
          var B = f && f.constructor;
          N ? v = k ? new B() : [] : xt(f) ? v = En(B) ? er(Zr(f)) : {} : v = {};
        }
        return (N ? Qt : dn)(f, function(Y, Z, J) {
          return m(v, Y, Z, J);
        }), v;
      }
      function Dp(f, m) {
        return f == null ? !0 : Ii(f, m);
      }
      function Lp(f, m, v) {
        return f == null ? f : ya(f, m, $i(v));
      }
      function Rp(f, m, v, k) {
        return k = typeof k == "function" ? k : r, f == null ? f : ya(f, m, $i(v), k);
      }
      function sr(f) {
        return f == null ? [] : ai(f, It(f));
      }
      function Pp(f) {
        return f == null ? [] : ai(f, Vt(f));
      }
      function Np(f, m, v) {
        return v === r && (v = m, m = r), v !== r && (v = on(v), v = v === v ? v : 0), m !== r && (m = on(m), m = m === m ? m : 0), jn(on(f), m, v);
      }
      function Mp(f, m, v) {
        return m = kn(m), v === r ? (v = m, m = 0) : v = kn(v), f = on(f), Pu(f, m, v);
      }
      function Fp(f, m, v) {
        if (v && typeof v != "boolean" && Nt(f, m, v) && (m = v = r), v === r && (typeof m == "boolean" ? (v = m, m = r) : typeof f == "boolean" && (v = f, f = r)), f === r && m === r ? (f = 0, m = 1) : (f = kn(f), m === r ? (m = f, f = 0) : m = kn(m)), f > m) {
          var k = f;
          f = m, m = k;
        }
        if (v || f % 1 || m % 1) {
          var N = Ks();
          return $t(f + N * (m - f + nc("1e-" + ((N + "").length - 1))), m);
        }
        return Ci(f, m);
      }
      var jp = nr(function(f, m, v) {
        return m = m.toLowerCase(), f + (v ? Ol(m) : m);
      });
      function Ol(f) {
        return ts(ut(f).toLowerCase());
      }
      function Al(f) {
        return f = ut(f), f && f.replace(Ho, vc).replace(Gl, "");
      }
      function Bp(f, m, v) {
        f = ut(f), m = Wt(m);
        var k = f.length;
        v = v === r ? k : jn(Ze(v), 0, k);
        var N = v;
        return v -= m.length, v >= 0 && f.slice(v, N) == m;
      }
      function Up(f) {
        return f = ut(f), f && $o.test(f) ? f.replace($r, yc) : f;
      }
      function Vp(f) {
        return f = ut(f), f && Lr.test(f) ? f.replace(un, "\\$&") : f;
      }
      var zp = nr(function(f, m, v) {
        return f + (v ? "-" : "") + m.toLowerCase();
      }), Hp = nr(function(f, m, v) {
        return f + (v ? " " : "") + m.toLowerCase();
      }), qp = Aa("toLowerCase");
      function Gp(f, m, v) {
        f = ut(f), m = Ze(m);
        var k = m ? Kn(f) : 0;
        if (!m || k >= m)
          return f;
        var N = (m - k) / 2;
        return po(eo(N), v) + f + po(Jr(N), v);
      }
      function Wp(f, m, v) {
        f = ut(f), m = Ze(m);
        var k = m ? Kn(f) : 0;
        return m && k < m ? f + po(m - k, v) : f;
      }
      function Yp(f, m, v) {
        f = ut(f), m = Ze(m);
        var k = m ? Kn(f) : 0;
        return m && k < m ? po(m - k, v) + f : f;
      }
      function Kp(f, m, v) {
        return v || m == null ? m = 0 : m && (m = +m), Gc(ut(f).replace(lr, ""), m || 0);
      }
      function Zp(f, m, v) {
        return (v ? Nt(f, m, v) : m === r) ? m = 1 : m = Ze(m), Si(ut(f), m);
      }
      function Xp() {
        var f = arguments, m = ut(f[0]);
        return f.length < 3 ? m : m.replace(f[1], f[2]);
      }
      var Qp = nr(function(f, m, v) {
        return f + (v ? "_" : "") + m.toLowerCase();
      });
      function Jp(f, m, v) {
        return v && typeof v != "number" && Nt(f, m, v) && (m = v = r), v = v === r ? me : v >>> 0, v ? (f = ut(f), f && (typeof m == "string" || m != null && !Zi(m)) && (m = Wt(m), !m && Yn(f)) ? Dn(sn(f), 0, v) : f.split(m, v)) : [];
      }
      var em = nr(function(f, m, v) {
        return f + (v ? " " : "") + ts(m);
      });
      function tm(f, m, v) {
        return f = ut(f), v = v == null ? 0 : jn(Ze(v), 0, f.length), m = Wt(m), f.slice(v, v + m.length) == m;
      }
      function nm(f, m, v) {
        var k = j.templateSettings;
        v && Nt(f, m, v) && (m = r), f = ut(f), m = So({}, m, k, Ma);
        var N = So({}, m.imports, k.imports, Ma), B = It(N), Y = ai(N, B), Z, J, ve = 0, ye = m.interpolate || Hn, we = "__p += '", Oe = ci(
          (m.escape || Hn).source + "|" + ye.source + "|" + (ye === Dr ? jo : Hn).source + "|" + (m.evaluate || Hn).source + "|$",
          "g"
        ), Fe = "//# sourceURL=" + (dt.call(m, "sourceURL") ? (m.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Xl + "]") + `
`;
        f.replace(Oe, function(Ve, tt, rt, Kt, Mt, Zt) {
          return rt || (rt = Kt), we += f.slice(ve, Zt).replace(Fr, xc), tt && (Z = !0, we += `' +
__e(` + tt + `) +
'`), Mt && (J = !0, we += `';
` + Mt + `;
__p += '`), rt && (we += `' +
((__t = (` + rt + `)) == null ? '' : __t) +
'`), ve = Zt + Ve.length, Ve;
        }), we += `';
`;
        var Ue = dt.call(m, "variable") && m.variable;
        if (!Ue)
          we = `with (obj) {
` + we + `
}
`;
        else if (Mo.test(Ue))
          throw new Ge(d);
        we = (J ? we.replace(To, "") : we).replace(Io, "$1").replace(Oo, "$1;"), we = "function(" + (Ue || "obj") + `) {
` + (Ue ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Z ? ", __e = _.escape" : "") + (J ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + we + `return __p
}`;
        var Qe = Dl(function() {
          return at(B, Fe + "return " + we).apply(r, Y);
        });
        if (Qe.source = we, Ki(Qe))
          throw Qe;
        return Qe;
      }
      function rm(f) {
        return ut(f).toLowerCase();
      }
      function om(f) {
        return ut(f).toUpperCase();
      }
      function im(f, m, v) {
        if (f = ut(f), f && (v || m === r))
          return Fs(f);
        if (!f || !(m = Wt(m)))
          return f;
        var k = sn(f), N = sn(m), B = js(k, N), Y = Bs(k, N) + 1;
        return Dn(k, B, Y).join("");
      }
      function sm(f, m, v) {
        if (f = ut(f), f && (v || m === r))
          return f.slice(0, Vs(f) + 1);
        if (!f || !(m = Wt(m)))
          return f;
        var k = sn(f), N = Bs(k, sn(m)) + 1;
        return Dn(k, 0, N).join("");
      }
      function am(f, m, v) {
        if (f = ut(f), f && (v || m === r))
          return f.replace(lr, "");
        if (!f || !(m = Wt(m)))
          return f;
        var k = sn(f), N = js(k, sn(m));
        return Dn(k, N).join("");
      }
      function lm(f, m) {
        var v = A, k = S;
        if (xt(m)) {
          var N = "separator" in m ? m.separator : N;
          v = "length" in m ? Ze(m.length) : v, k = "omission" in m ? Wt(m.omission) : k;
        }
        f = ut(f);
        var B = f.length;
        if (Yn(f)) {
          var Y = sn(f);
          B = Y.length;
        }
        if (v >= B)
          return f;
        var Z = v - Kn(k);
        if (Z < 1)
          return k;
        var J = Y ? Dn(Y, 0, Z).join("") : f.slice(0, Z);
        if (N === r)
          return J + k;
        if (Y && (Z += J.length - Z), Zi(N)) {
          if (f.slice(Z).search(N)) {
            var ve, ye = J;
            for (N.global || (N = ci(N.source, ut(cr.exec(N)) + "g")), N.lastIndex = 0; ve = N.exec(ye); )
              var we = ve.index;
            J = J.slice(0, we === r ? Z : we);
          }
        } else if (f.indexOf(Wt(N), Z) != Z) {
          var Oe = J.lastIndexOf(N);
          Oe > -1 && (J = J.slice(0, Oe));
        }
        return J + k;
      }
      function cm(f) {
        return f = ut(f), f && Ao.test(f) ? f.replace(Ar, Ic) : f;
      }
      var um = nr(function(f, m, v) {
        return f + (v ? " " : "") + m.toUpperCase();
      }), ts = Aa("toUpperCase");
      function $l(f, m, v) {
        return f = ut(f), m = v ? r : m, m === r ? Ec(f) ? $c(f) : hc(f) : f.match(m) || [];
      }
      var Dl = Je(function(f, m) {
        try {
          return Ht(f, r, m);
        } catch (v) {
          return Ki(v) ? v : new Ge(v);
        }
      }), dm = xn(function(f, m) {
        return Qt(m, function(v) {
          v = pn(v), vn(f, v, Wi(f[v], f));
        }), f;
      });
      function fm(f) {
        var m = f == null ? 0 : f.length, v = Be();
        return f = m ? yt(f, function(k) {
          if (typeof k[1] != "function")
            throw new Jt(u);
          return [v(k[0]), k[1]];
        }) : [], Je(function(k) {
          for (var N = -1; ++N < m; ) {
            var B = f[N];
            if (Ht(B[0], this, k))
              return Ht(B[1], this, k);
          }
        });
      }
      function hm(f) {
        return Au(tn(f, x));
      }
      function ns(f) {
        return function() {
          return f;
        };
      }
      function mm(f, m) {
        return f == null || f !== f ? m : f;
      }
      var gm = Da(), bm = Da(!0);
      function zt(f) {
        return f;
      }
      function rs(f) {
        return la(typeof f == "function" ? f : tn(f, x));
      }
      function vm(f) {
        return ua(tn(f, x));
      }
      function ym(f, m) {
        return da(f, tn(m, x));
      }
      var xm = Je(function(f, m) {
        return function(v) {
          return Er(v, f, m);
        };
      }), wm = Je(function(f, m) {
        return function(v) {
          return Er(f, v, m);
        };
      });
      function os(f, m, v) {
        var k = It(m), N = so(m, k);
        v == null && !(xt(m) && (N.length || !k.length)) && (v = m, m = f, f = this, N = so(m, It(m)));
        var B = !(xt(v) && "chain" in v) || !!v.chain, Y = En(f);
        return Qt(N, function(Z) {
          var J = m[Z];
          f[Z] = J, Y && (f.prototype[Z] = function() {
            var ve = this.__chain__;
            if (B || ve) {
              var ye = f(this.__wrapped__), we = ye.__actions__ = Bt(this.__actions__);
              return we.push({ func: J, args: arguments, thisArg: f }), ye.__chain__ = ve, ye;
            }
            return J.apply(f, Sn([this.value()], arguments));
          });
        }), f;
      }
      function Em() {
        return Ot._ === this && (Ot._ = Mc), this;
      }
      function is() {
      }
      function km(f) {
        return f = Ze(f), Je(function(m) {
          return fa(m, f);
        });
      }
      var _m = Li(yt), Cm = Li(Ls), Sm = Li(ei);
      function Rl(f) {
        return Ui(f) ? ti(pn(f)) : Ku(f);
      }
      function Tm(f) {
        return function(m) {
          return f == null ? r : Bn(f, m);
        };
      }
      var Om = Ra(), Am = Ra(!0);
      function ss() {
        return [];
      }
      function as() {
        return !1;
      }
      function $m() {
        return {};
      }
      function Dm() {
        return "";
      }
      function Lm() {
        return !0;
      }
      function Rm(f, m) {
        if (f = Ze(f), f < 1 || f > fe)
          return [];
        var v = me, k = $t(f, me);
        m = Be(m), f -= me;
        for (var N = si(k, m); ++v < f; )
          m(v);
        return N;
      }
      function Pm(f) {
        return We(f) ? yt(f, pn) : Yt(f) ? [f] : Bt(Za(ut(f)));
      }
      function Nm(f) {
        var m = ++Pc;
        return ut(f) + m;
      }
      var Mm = ho(function(f, m) {
        return f + m;
      }, 0), Fm = Ri("ceil"), jm = ho(function(f, m) {
        return f / m;
      }, 1), Bm = Ri("floor");
      function Um(f) {
        return f && f.length ? io(f, zt, vi) : r;
      }
      function Vm(f, m) {
        return f && f.length ? io(f, Be(m, 2), vi) : r;
      }
      function zm(f) {
        return Ns(f, zt);
      }
      function Hm(f, m) {
        return Ns(f, Be(m, 2));
      }
      function qm(f) {
        return f && f.length ? io(f, zt, ki) : r;
      }
      function Gm(f, m) {
        return f && f.length ? io(f, Be(m, 2), ki) : r;
      }
      var Wm = ho(function(f, m) {
        return f * m;
      }, 1), Ym = Ri("round"), Km = ho(function(f, m) {
        return f - m;
      }, 0);
      function Zm(f) {
        return f && f.length ? oi(f, zt) : 0;
      }
      function Xm(f, m) {
        return f && f.length ? oi(f, Be(m, 2)) : 0;
      }
      return j.after = ph, j.ary = cl, j.assign = tp, j.assignIn = _l, j.assignInWith = So, j.assignWith = np, j.at = rp, j.before = ul, j.bind = Wi, j.bindAll = dm, j.bindKey = dl, j.castArray = Sh, j.chain = il, j.chunk = Ld, j.compact = Rd, j.concat = Pd, j.cond = fm, j.conforms = hm, j.constant = ns, j.countBy = qf, j.create = op, j.curry = fl, j.curryRight = hl, j.debounce = pl, j.defaults = ip, j.defaultsDeep = sp, j.defer = mh, j.delay = gh, j.difference = Nd, j.differenceBy = Md, j.differenceWith = Fd, j.drop = jd, j.dropRight = Bd, j.dropRightWhile = Ud, j.dropWhile = Vd, j.fill = zd, j.filter = Wf, j.flatMap = Zf, j.flatMapDeep = Xf, j.flatMapDepth = Qf, j.flatten = tl, j.flattenDeep = Hd, j.flattenDepth = qd, j.flip = bh, j.flow = gm, j.flowRight = bm, j.fromPairs = Gd, j.functions = pp, j.functionsIn = gp, j.groupBy = Jf, j.initial = Yd, j.intersection = Kd, j.intersectionBy = Zd, j.intersectionWith = Xd, j.invert = vp, j.invertBy = yp, j.invokeMap = th, j.iteratee = rs, j.keyBy = nh, j.keys = It, j.keysIn = Vt, j.map = xo, j.mapKeys = Ep, j.mapValues = kp, j.matches = vm, j.matchesProperty = ym, j.memoize = Eo, j.merge = _p, j.mergeWith = Cl, j.method = xm, j.methodOf = wm, j.mixin = os, j.negate = ko, j.nthArg = km, j.omit = Cp, j.omitBy = Sp, j.once = vh, j.orderBy = rh, j.over = _m, j.overArgs = yh, j.overEvery = Cm, j.overSome = Sm, j.partial = Yi, j.partialRight = ml, j.partition = oh, j.pick = Tp, j.pickBy = Sl, j.property = Rl, j.propertyOf = Tm, j.pull = tf, j.pullAll = rl, j.pullAllBy = nf, j.pullAllWith = rf, j.pullAt = of, j.range = Om, j.rangeRight = Am, j.rearg = xh, j.reject = ah, j.remove = sf, j.rest = wh, j.reverse = qi, j.sampleSize = ch, j.set = Op, j.setWith = Ap, j.shuffle = uh, j.slice = lf, j.sortBy = hh, j.sortedUniq = mf, j.sortedUniqBy = gf, j.split = Jp, j.spread = Eh, j.tail = bf, j.take = vf, j.takeRight = yf, j.takeRightWhile = xf, j.takeWhile = wf, j.tap = Nf, j.throttle = kh, j.thru = yo, j.toArray = wl, j.toPairs = Tl, j.toPairsIn = Il, j.toPath = Pm, j.toPlainObject = kl, j.transform = $p, j.unary = _h, j.union = Ef, j.unionBy = kf, j.unionWith = _f, j.uniq = Cf, j.uniqBy = Sf, j.uniqWith = Tf, j.unset = Dp, j.unzip = Gi, j.unzipWith = ol, j.update = Lp, j.updateWith = Rp, j.values = sr, j.valuesIn = Pp, j.without = If, j.words = $l, j.wrap = Ch, j.xor = Of, j.xorBy = Af, j.xorWith = $f, j.zip = Df, j.zipObject = Lf, j.zipObjectDeep = Rf, j.zipWith = Pf, j.entries = Tl, j.entriesIn = Il, j.extend = _l, j.extendWith = So, os(j, j), j.add = Mm, j.attempt = Dl, j.camelCase = jp, j.capitalize = Ol, j.ceil = Fm, j.clamp = Np, j.clone = Th, j.cloneDeep = Oh, j.cloneDeepWith = Ah, j.cloneWith = Ih, j.conformsTo = $h, j.deburr = Al, j.defaultTo = mm, j.divide = jm, j.endsWith = Bp, j.eq = ln, j.escape = Up, j.escapeRegExp = Vp, j.every = Gf, j.find = Yf, j.findIndex = Qa, j.findKey = lp, j.findLast = Kf, j.findLastIndex = Ja, j.findLastKey = cp, j.floor = Bm, j.forEach = sl, j.forEachRight = al, j.forIn = up, j.forInRight = dp, j.forOwn = fp, j.forOwnRight = hp, j.get = Qi, j.gt = Dh, j.gte = Lh, j.has = bp, j.hasIn = Ji, j.head = nl, j.identity = zt, j.includes = eh, j.indexOf = Wd, j.inRange = Mp, j.invoke = xp, j.isArguments = zn, j.isArray = We, j.isArrayBuffer = Rh, j.isArrayLike = Ut, j.isArrayLikeObject = kt, j.isBoolean = Ph, j.isBuffer = Ln, j.isDate = Nh, j.isElement = Mh, j.isEmpty = Fh, j.isEqual = jh, j.isEqualWith = Bh, j.isError = Ki, j.isFinite = Uh, j.isFunction = En, j.isInteger = bl, j.isLength = _o, j.isMap = vl, j.isMatch = Vh, j.isMatchWith = zh, j.isNaN = Hh, j.isNative = qh, j.isNil = Wh, j.isNull = Gh, j.isNumber = yl, j.isObject = xt, j.isObjectLike = wt, j.isPlainObject = Ir, j.isRegExp = Zi, j.isSafeInteger = Yh, j.isSet = xl, j.isString = Co, j.isSymbol = Yt, j.isTypedArray = ir, j.isUndefined = Kh, j.isWeakMap = Zh, j.isWeakSet = Xh, j.join = Qd, j.kebabCase = zp, j.last = rn, j.lastIndexOf = Jd, j.lowerCase = Hp, j.lowerFirst = qp, j.lt = Qh, j.lte = Jh, j.max = Um, j.maxBy = Vm, j.mean = zm, j.meanBy = Hm, j.min = qm, j.minBy = Gm, j.stubArray = ss, j.stubFalse = as, j.stubObject = $m, j.stubString = Dm, j.stubTrue = Lm, j.multiply = Wm, j.nth = ef, j.noConflict = Em, j.noop = is, j.now = wo, j.pad = Gp, j.padEnd = Wp, j.padStart = Yp, j.parseInt = Kp, j.random = Fp, j.reduce = ih, j.reduceRight = sh, j.repeat = Zp, j.replace = Xp, j.result = Ip, j.round = Ym, j.runInContext = X, j.sample = lh, j.size = dh, j.snakeCase = Qp, j.some = fh, j.sortedIndex = cf, j.sortedIndexBy = uf, j.sortedIndexOf = df, j.sortedLastIndex = ff, j.sortedLastIndexBy = hf, j.sortedLastIndexOf = pf, j.startCase = em, j.startsWith = tm, j.subtract = Km, j.sum = Zm, j.sumBy = Xm, j.template = nm, j.times = Rm, j.toFinite = kn, j.toInteger = Ze, j.toLength = El, j.toLower = rm, j.toNumber = on, j.toSafeInteger = ep, j.toString = ut, j.toUpper = om, j.trim = im, j.trimEnd = sm, j.trimStart = am, j.truncate = lm, j.unescape = cm, j.uniqueId = Nm, j.upperCase = um, j.upperFirst = ts, j.each = sl, j.eachRight = al, j.first = nl, os(j, function() {
        var f = {};
        return dn(j, function(m, v) {
          dt.call(j.prototype, v) || (f[v] = m);
        }), f;
      }(), { chain: !1 }), j.VERSION = o, Qt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(f) {
        j[f].placeholder = j;
      }), Qt(["drop", "take"], function(f, m) {
        nt.prototype[f] = function(v) {
          v = v === r ? 1 : Tt(Ze(v), 0);
          var k = this.__filtered__ && !m ? new nt(this) : this.clone();
          return k.__filtered__ ? k.__takeCount__ = $t(v, k.__takeCount__) : k.__views__.push({
            size: $t(v, me),
            type: f + (k.__dir__ < 0 ? "Right" : "")
          }), k;
        }, nt.prototype[f + "Right"] = function(v) {
          return this.reverse()[f](v).reverse();
        };
      }), Qt(["filter", "map", "takeWhile"], function(f, m) {
        var v = m + 1, k = v == M || v == G;
        nt.prototype[f] = function(N) {
          var B = this.clone();
          return B.__iteratees__.push({
            iteratee: Be(N, 3),
            type: v
          }), B.__filtered__ = B.__filtered__ || k, B;
        };
      }), Qt(["head", "last"], function(f, m) {
        var v = "take" + (m ? "Right" : "");
        nt.prototype[f] = function() {
          return this[v](1).value()[0];
        };
      }), Qt(["initial", "tail"], function(f, m) {
        var v = "drop" + (m ? "" : "Right");
        nt.prototype[f] = function() {
          return this.__filtered__ ? new nt(this) : this[v](1);
        };
      }), nt.prototype.compact = function() {
        return this.filter(zt);
      }, nt.prototype.find = function(f) {
        return this.filter(f).head();
      }, nt.prototype.findLast = function(f) {
        return this.reverse().find(f);
      }, nt.prototype.invokeMap = Je(function(f, m) {
        return typeof f == "function" ? new nt(this) : this.map(function(v) {
          return Er(v, f, m);
        });
      }), nt.prototype.reject = function(f) {
        return this.filter(ko(Be(f)));
      }, nt.prototype.slice = function(f, m) {
        f = Ze(f);
        var v = this;
        return v.__filtered__ && (f > 0 || m < 0) ? new nt(v) : (f < 0 ? v = v.takeRight(-f) : f && (v = v.drop(f)), m !== r && (m = Ze(m), v = m < 0 ? v.dropRight(-m) : v.take(m - f)), v);
      }, nt.prototype.takeRightWhile = function(f) {
        return this.reverse().takeWhile(f).reverse();
      }, nt.prototype.toArray = function() {
        return this.take(me);
      }, dn(nt.prototype, function(f, m) {
        var v = /^(?:filter|find|map|reject)|While$/.test(m), k = /^(?:head|last)$/.test(m), N = j[k ? "take" + (m == "last" ? "Right" : "") : m], B = k || /^find/.test(m);
        N && (j.prototype[m] = function() {
          var Y = this.__wrapped__, Z = k ? [1] : arguments, J = Y instanceof nt, ve = Z[0], ye = J || We(Y), we = function(tt) {
            var rt = N.apply(j, Sn([tt], Z));
            return k && Oe ? rt[0] : rt;
          };
          ye && v && typeof ve == "function" && ve.length != 1 && (J = ye = !1);
          var Oe = this.__chain__, Fe = !!this.__actions__.length, Ue = B && !Oe, Qe = J && !Fe;
          if (!B && ye) {
            Y = Qe ? Y : new nt(this);
            var Ve = f.apply(Y, Z);
            return Ve.__actions__.push({ func: yo, args: [we], thisArg: r }), new en(Ve, Oe);
          }
          return Ue && Qe ? f.apply(this, Z) : (Ve = this.thru(we), Ue ? k ? Ve.value()[0] : Ve.value() : Ve);
        });
      }), Qt(["pop", "push", "shift", "sort", "splice", "unshift"], function(f) {
        var m = Hr[f], v = /^(?:push|sort|unshift)$/.test(f) ? "tap" : "thru", k = /^(?:pop|shift)$/.test(f);
        j.prototype[f] = function() {
          var N = arguments;
          if (k && !this.__chain__) {
            var B = this.value();
            return m.apply(We(B) ? B : [], N);
          }
          return this[v](function(Y) {
            return m.apply(We(Y) ? Y : [], N);
          });
        };
      }), dn(nt.prototype, function(f, m) {
        var v = j[m];
        if (v) {
          var k = v.name + "";
          dt.call(Jn, k) || (Jn[k] = []), Jn[k].push({ name: m, func: v });
        }
      }), Jn[fo(r, C).name] = [{
        name: "wrapper",
        func: r
      }], nt.prototype.clone = Jc, nt.prototype.reverse = eu, nt.prototype.value = tu, j.prototype.at = Mf, j.prototype.chain = Ff, j.prototype.commit = jf, j.prototype.next = Bf, j.prototype.plant = Vf, j.prototype.reverse = zf, j.prototype.toJSON = j.prototype.valueOf = j.prototype.value = Hf, j.prototype.first = j.prototype.head, fr && (j.prototype[fr] = Uf), j;
    }, Zn = Dc();
    Pn ? ((Pn.exports = Zn)._ = Zn, Zo._ = Zn) : Ot._ = Zn;
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports, _ = lodashExports, DataTransform = function(data, map) {
  return {
    defaultOrNull: function(t) {
      return t && map.defaults ? map.defaults[t] : void 0;
    },
    getValue: function(t, e, r) {
      if (!(typeof t > "u")) {
        if (e == "" || e == null)
          return t;
        var o = t || data;
        return e = e || map.list, e == "" ? "" : _.get(o, e, this.defaultOrNull(r));
      }
    },
    setValue: function(t, e, r) {
      if (!(typeof t > "u") && !(e == "" || e == null) && e != "")
        for (var o = e.split("."), a = t, c = 0; c < o.length; c++) {
          if (c === o.length - 1) {
            a[o[c]] = r;
            return;
          }
          if (o[c] in a)
            a = a[o[c]];
          else
            return;
        }
    },
    getList: function() {
      return this.getValue(data, map.list);
    },
    transform: function(t) {
      var e = map.list != null, r;
      e ? r = this.getValue(data, map.list) : _.isArray(data) && !e ? r = data : _.isObject(data) && !e && (r = [data]);
      var o = [];
      if (!_.isEmpty(r)) {
        var a = e ? this.getList() : r;
        o = map.item ? _.map(a, _.bind(this.iterator, this, map.item)) : a, o = _.bind(this.operate, this, o)(t), o = this.each(o, t), o = this.removeAll(o);
      }
      return !e && _.isObject(data) && !_.isArray(data) ? o[0] : o;
    },
    transformAsync: function(t) {
      return new Promise((function(e, r) {
        try {
          e(this.transform(t));
        } catch (o) {
          r(o);
        }
      }).bind(this));
    },
    removeAll: function(t) {
      return _.isArray(map.remove) ? _.each(t, this.remove) : t;
    },
    remove: function(t) {
      return _.each(map.remove, function(e) {
        delete t[e];
      }), t;
    },
    operate: function(data, context) {
      return map.operate && _.each(map.operate, _.bind(function(method) {
        data = _.map(data, _.bind(function(item) {
          var fn;
          return typeof method.run == "string" ? fn = eval(method.run) : fn = method.run, this.setValue(item, method.on, fn(this.getValue(item, method.on), context)), item;
        }, this));
      }, this)), data;
    },
    each: function(t, e) {
      return map.each && _.each(t, function(r, o, a) {
        return map.each(r, o, a, e);
      }), t;
    },
    iterator: function(t, e) {
      var r = {};
      return typeof t == "string" ? this.getValue(e, t) : (_.each(t, _.bind(function(o, a) {
        if (typeof o == "string" && o.length > 0) {
          var c = this.getValue(e, o, a);
          c !== void 0 && (r[a] = c);
        } else if (_.isArray(o)) {
          var u = _.map(o, _.bind(function(p, g) {
            return this.iterator(g, p);
          }, this, e));
          r[a] = u;
        } else if (typeof o == "object") {
          var d = _.bind(this.iterator, this, o, e);
          r[a] = d();
        } else
          r[a] = "";
      }, this)), r);
    }
  };
};
nodeJsonTransform.DataTransform = DataTransform;
nodeJsonTransform.transform = function(t, e, r) {
  var o = new DataTransform(t, e);
  return o.transform(r);
};
nodeJsonTransform.transformAsync = function(t, e, r) {
  var o = new DataTransform(t, e);
  return o.transformAsync(r);
};
var order$1 = {};
Object.defineProperty(order$1, "__esModule", {
  value: !0
});
order$1.orderPartTransformRule = order$1.orderItemTransformRule = order$1.orderDetailTranformRule = void 0;
var _util$4 = util, orderItemTransformRule = {
  item: {
    orderId: "orderId",
    orderItemSeqId: "orderItemSeqId",
    orderPartSeqId: "shipGroupSeqId",
    productId: "productId",
    quantity: "quantity",
    unitAmount: "unitPrice",
    unitListPrice: "unitListPrice",
    product: {
      productId: "productId",
      pseudoId: "internalName",
      productTypeEnumId: "productTypeId",
      productName: "productName"
    }
  }
};
order$1.orderItemTransformRule = orderItemTransformRule;
var orderPartTransformRule = {
  item: {
    orderId: "orderId",
    orderPartSeqId: "shipGroupSeqId",
    partName: "orderName",
    // TODO: mapped orderItemStatusId with part status id as we are not maintaining status at part
    // level, for item status we will use the same field and will handle the scenario of cancelled
    // item using cancelledQuantity
    statusId: "orderItemStatusId",
    customerPartyId: "customerPartyId",
    facilityId: "facilityId",
    carrierPartyId: "carrierPartyId",
    shipmentMethodEnumId: "shipmentMethodTypeId",
    autoCancelDate: "autoCancelDate",
    customer: {
      partyId: "customerPartyId",
      person: {
        partyId: "customerPartyId",
        firstName: "customerPartyName",
        // assigning customerPartyName to firstName and then using operate on this field to get the firstName
        lastName: "customerPartyName"
        // assigning customerPartyName to lastName and then using operate on this field to get the lastName
      }
    },
    facility: {
      facilityId: "facilityId",
      facilityTypeEnumId: "facilityTypeId",
      facilityName: "facilityName"
    },
    contactMechs: [{
      orderId: "orderId",
      orderPartSeqId: "shipGroupSeqId",
      contactMechId: "",
      // TODO: check for mech id as we are not receiving it in current resp
      contactMech: {
        contactMechId: "",
        infoString: "customerEmailId"
      }
    }],
    postal: {
      postalAddress: {
        toName: "customerPartyName",
        city: "shipToCity",
        countryGeo: {
          geoName: "shipToCountry"
        },
        stateProvinceGeo: {
          geoName: "shipToState"
        }
      }
    },
    status: {
      statusId: "orderItemStatusId",
      description: "orderItemStatusDesc"
    }
  },
  // as we are receiving the full name in the customerPartyName, used operate to split it into
  // firstName and lastName
  operate: [{
    run: function t(e) {
      return e.split(" ")[0];
    },
    on: "customer.person.firstName"
  }, {
    run: function t(e) {
      return e.split(" ")[1];
    },
    on: "customer.person.lastName"
  }],
  defaults: {
    // This assign the default value (here emailId) to the specific key (here contactMechId) only
    // if the assigned property to the key does not exist and if we have declared the key mapping
    // to an empty string then this default value won't apply
    contactMechId: "emailId"
  }
};
order$1.orderPartTransformRule = orderPartTransformRule;
var orderDetailTranformRule = {
  item: {
    orderId: "orderId",
    orderName: "orderName",
    statusId: "orderStatusId",
    placedDate: "orderDate",
    currencyUomId: "currencyUomId",
    salesChannelEnumId: "salesChannelEnumId",
    salesChannel: {
      enumId: "salesChannelEnumId",
      description: "salesChannelDesc"
    },
    externalId: "orderIdentifications",
    status: {
      statusId: "orderStatusId",
      description: "orderStatusDesc"
    }
  },
  operate: [{
    run: function t(e) {
      return (0, _util$4.getIdentification)(e, "SHOPIFY_ORD_ID");
    },
    on: "externalId"
  }]
};
order$1.orderDetailTranformRule = orderDetailTranformRule;
Object.defineProperty(order$2, "__esModule", {
  value: !0
});
order$2.getOrderDetails = getOrderDetails;
order$2.updateOrderStatus = updateOrderStatus;
var _api$3 = _interopRequireDefault$3(api), _types$2 = types, _util$3 = util, _nodeJsonTransform$3 = nodeJsonTransform, _order = order$1;
function _interopRequireDefault$3(t) {
  return t && t.__esModule ? t : { default: t };
}
function _typeof$3(t) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof$3(t);
}
function _regeneratorRuntime$3() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$3 = function() {
    return t;
  };
  var t = {}, e = Object.prototype, r = e.hasOwnProperty, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function d(A, S, F) {
    return Object.defineProperty(A, S, { value: F, enumerable: !0, configurable: !0, writable: !0 }), A[S];
  }
  try {
    d({}, "");
  } catch {
    d = function(F, U, M) {
      return F[U] = M;
    };
  }
  function p(A, S, F, U) {
    var M = S && S.prototype instanceof x ? S : x, V = Object.create(M.prototype), G = new P(U || []);
    return V._invoke = function(Q, fe, te) {
      var de = "suspendedStart";
      return function(me, Me) {
        if (de === "executing")
          throw new Error("Generator is already running");
        if (de === "completed") {
          if (me === "throw")
            throw Me;
          return W();
        }
        for (te.method = me, te.arg = Me; ; ) {
          var ce = te.delegate;
          if (ce) {
            var oe = L(ce, te);
            if (oe) {
              if (oe === b)
                continue;
              return oe;
            }
          }
          if (te.method === "next")
            te.sent = te._sent = te.arg;
          else if (te.method === "throw") {
            if (de === "suspendedStart")
              throw de = "completed", te.arg;
            te.dispatchException(te.arg);
          } else
            te.method === "return" && te.abrupt("return", te.arg);
          de = "executing";
          var be = g(Q, fe, te);
          if (be.type === "normal") {
            if (de = te.done ? "completed" : "suspendedYield", be.arg === b)
              continue;
            return { value: be.arg, done: te.done };
          }
          be.type === "throw" && (de = "completed", te.method = "throw", te.arg = be.arg);
        }
      };
    }(A, F, G), V;
  }
  function g(A, S, F) {
    try {
      return { type: "normal", arg: A.call(S, F) };
    } catch (U) {
      return { type: "throw", arg: U };
    }
  }
  t.wrap = p;
  var b = {};
  function x() {
  }
  function w() {
  }
  function y() {
  }
  var I = {};
  d(I, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, T = E && E(E(z([])));
  T && T !== e && r.call(T, a) && (I = T);
  var C = y.prototype = x.prototype = Object.create(I);
  function $(A) {
    ["next", "throw", "return"].forEach(function(S) {
      d(A, S, function(F) {
        return this._invoke(S, F);
      });
    });
  }
  function D(A, S) {
    function F(M, V, G, Q) {
      var fe = g(A[M], A, V);
      if (fe.type !== "throw") {
        var te = fe.arg, de = te.value;
        return de && _typeof$3(de) == "object" && r.call(de, "__await") ? S.resolve(de.__await).then(function(me) {
          F("next", me, G, Q);
        }, function(me) {
          F("throw", me, G, Q);
        }) : S.resolve(de).then(function(me) {
          te.value = me, G(te);
        }, function(me) {
          return F("throw", me, G, Q);
        });
      }
      Q(fe.arg);
    }
    var U;
    this._invoke = function(M, V) {
      function G() {
        return new S(function(Q, fe) {
          F(M, V, Q, fe);
        });
      }
      return U = U ? U.then(G, G) : G();
    };
  }
  function L(A, S) {
    var F = A.iterator[S.method];
    if (F === void 0) {
      if (S.delegate = null, S.method === "throw") {
        if (A.iterator.return && (S.method = "return", S.arg = void 0, L(A, S), S.method === "throw"))
          return b;
        S.method = "throw", S.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return b;
    }
    var U = g(F, A.iterator, S.arg);
    if (U.type === "throw")
      return S.method = "throw", S.arg = U.arg, S.delegate = null, b;
    var M = U.arg;
    return M ? M.done ? (S[A.resultName] = M.value, S.next = A.nextLoc, S.method !== "return" && (S.method = "next", S.arg = void 0), S.delegate = null, b) : M : (S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, b);
  }
  function R(A) {
    var S = { tryLoc: A[0] };
    1 in A && (S.catchLoc = A[1]), 2 in A && (S.finallyLoc = A[2], S.afterLoc = A[3]), this.tryEntries.push(S);
  }
  function O(A) {
    var S = A.completion || {};
    S.type = "normal", delete S.arg, A.completion = S;
  }
  function P(A) {
    this.tryEntries = [{ tryLoc: "root" }], A.forEach(R, this), this.reset(!0);
  }
  function z(A) {
    if (A) {
      var S = A[a];
      if (S)
        return S.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var F = -1, U = function M() {
          for (; ++F < A.length; )
            if (r.call(A, F))
              return M.value = A[F], M.done = !1, M;
          return M.value = void 0, M.done = !0, M;
        };
        return U.next = U;
      }
    }
    return { next: W };
  }
  function W() {
    return { value: void 0, done: !0 };
  }
  return w.prototype = y, d(C, "constructor", y), d(y, "constructor", w), w.displayName = d(y, u, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var S = typeof A == "function" && A.constructor;
    return !!S && (S === w || (S.displayName || S.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, y) : (A.__proto__ = y, d(A, u, "GeneratorFunction")), A.prototype = Object.create(C), A;
  }, t.awrap = function(A) {
    return { __await: A };
  }, $(D.prototype), d(D.prototype, c, function() {
    return this;
  }), t.AsyncIterator = D, t.async = function(A, S, F, U, M) {
    M === void 0 && (M = Promise);
    var V = new D(p(A, S, F, U), M);
    return t.isGeneratorFunction(S) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, $(C), d(C, u, "Generator"), d(C, a, function() {
    return this;
  }), d(C, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var S = [];
    for (var F in A)
      S.push(F);
    return S.reverse(), function U() {
      for (; S.length; ) {
        var M = S.pop();
        if (M in A)
          return U.value = M, U.done = !1, U;
      }
      return U.done = !0, U;
    };
  }, t.values = z, P.prototype = { constructor: P, reset: function(S) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !S)
      for (var F in this)
        F.charAt(0) === "t" && r.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = void 0);
  }, stop: function() {
    this.done = !0;
    var S = this.tryEntries[0].completion;
    if (S.type === "throw")
      throw S.arg;
    return this.rval;
  }, dispatchException: function(S) {
    if (this.done)
      throw S;
    var F = this;
    function U(te, de) {
      return G.type = "throw", G.arg = S, F.next = te, de && (F.method = "next", F.arg = void 0), !!de;
    }
    for (var M = this.tryEntries.length - 1; M >= 0; --M) {
      var V = this.tryEntries[M], G = V.completion;
      if (V.tryLoc === "root")
        return U("end");
      if (V.tryLoc <= this.prev) {
        var Q = r.call(V, "catchLoc"), fe = r.call(V, "finallyLoc");
        if (Q && fe) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        } else if (Q) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
        } else {
          if (!fe)
            throw new Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(S, F) {
    for (var U = this.tryEntries.length - 1; U >= 0; --U) {
      var M = this.tryEntries[U];
      if (M.tryLoc <= this.prev && r.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
        var V = M;
        break;
      }
    }
    V && (S === "break" || S === "continue") && V.tryLoc <= F && F <= V.finallyLoc && (V = null);
    var G = V ? V.completion : {};
    return G.type = S, G.arg = F, V ? (this.method = "next", this.next = V.finallyLoc, b) : this.complete(G);
  }, complete: function(S, F) {
    if (S.type === "throw")
      throw S.arg;
    return S.type === "break" || S.type === "continue" ? this.next = S.arg : S.type === "return" ? (this.rval = this.arg = S.arg, this.method = "return", this.next = "end") : S.type === "normal" && F && (this.next = F), b;
  }, finish: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.finallyLoc === S)
        return this.complete(U.completion, U.afterLoc), O(U), b;
    }
  }, catch: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.tryLoc === S) {
        var M = U.completion;
        if (M.type === "throw") {
          var V = M.arg;
          O(U);
        }
        return V;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(S, F, U) {
    return this.delegate = { iterator: z(S), resultName: F, nextLoc: U }, this.method === "next" && (this.arg = void 0), b;
  } }, t;
}
function asyncGeneratorStep$3(t, e, r, o, a, c, u) {
  try {
    var d = t[c](u), p = d.value;
  } catch (g) {
    r(g);
    return;
  }
  d.done ? e(p) : Promise.resolve(p).then(o, a);
}
function _asyncToGenerator$3(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(o, a) {
      var c = t.apply(e, r);
      function u(p) {
        asyncGeneratorStep$3(c, o, a, u, d, "next", p);
      }
      function d(p) {
        asyncGeneratorStep$3(c, o, a, u, d, "throw", p);
      }
      u(void 0);
    });
  };
}
function getOrderDetails(t) {
  return _getOrderDetails.apply(this, arguments);
}
function _getOrderDetails() {
  return _getOrderDetails = _asyncToGenerator$3(/* @__PURE__ */ _regeneratorRuntime$3().mark(function t(e) {
    var r, o, a, c, u, d, p, g, b, x;
    return _regeneratorRuntime$3().wrap(function(y) {
      for (; ; )
        switch (y.prev = y.next) {
          case 0:
            return r = {
              json: {
                params: {
                  group: !0,
                  "group.field": "orderId",
                  "group.limit": 1e4,
                  "q.op": _types$2.OPERATOR.AND
                },
                query: "*:*",
                filter: "docType: ORDER ".concat(_types$2.OPERATOR.AND, " orderTypeId: SALES_ORDER ").concat(_types$2.OPERATOR.AND, " orderId: ").concat(e)
              }
            }, y.prev = 1, y.next = 4, (0, _api$3.default)({
              url: "solr-query",
              method: "get",
              params: r
            });
          case 4:
            if (d = y.sent, !((d == null ? void 0 : d.status) == 200 && !(0, _util$3.hasError)(d) && ((o = d.data) === null || o === void 0 || (a = o.grouped) === null || a === void 0 || (c = a.orderId) === null || c === void 0 || (u = c.groups) === null || u === void 0 ? void 0 : u.length) > 0)) {
              y.next = 14;
              break;
            }
            return p = d.data.grouped.orderId.groups[0], g = p.doclist.docs[0], b = p.doclist.docs.reduce(function(I, E) {
              var T = I.find(function(D) {
                return D.orderPartSeqId === E.shipGroupSeqId;
              }), C = (0, _nodeJsonTransform$3.transform)(E, _order.orderItemTransformRule);
              if (T)
                T.items.push(C);
              else {
                var $ = (0, _nodeJsonTransform$3.transform)(E, _order.orderPartTransformRule);
                $.items = [C], I.push($);
              }
              return I;
            }, []), x = (0, _nodeJsonTransform$3.transform)(g, _order.orderDetailTranformRule), x.parts = b, y.abrupt("return", Promise.resolve(x));
          case 14:
            return y.abrupt("return", Promise.reject({
              code: "error",
              message: "Unable to fetch order details for orderId: ".concat(e),
              serverResponse: d
            }));
          case 15:
            y.next = 20;
            break;
          case 17:
            return y.prev = 17, y.t0 = y.catch(1), y.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: y.t0
            }));
          case 20:
          case "end":
            return y.stop();
        }
    }, t, null, [[1, 17]]);
  })), _getOrderDetails.apply(this, arguments);
}
function updateOrderStatus(t) {
  return _updateOrderStatus.apply(this, arguments);
}
function _updateOrderStatus() {
  return _updateOrderStatus = _asyncToGenerator$3(/* @__PURE__ */ _regeneratorRuntime$3().mark(function t(e) {
    var r;
    return _regeneratorRuntime$3().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return a.prev = 0, a.next = 3, (0, _api$3.default)({
              url: "/service/changeOrderStatus",
              method: "post",
              data: e
            });
          case 3:
            if (r = a.sent, !((r == null ? void 0 : r.status) == 200 && !(0, _util$3.hasError)(r))) {
              a.next = 8;
              break;
            }
            return a.abrupt("return", Promise.resolve({
              code: "success",
              message: "Order status updated",
              serverResponse: r.data
            }));
          case 8:
            return a.abrupt("return", Promise.reject({
              code: "error",
              message: "Unable to update order status",
              serverResponse: r
            }));
          case 9:
            a.next = 14;
            break;
          case 11:
            return a.prev = 11, a.t0 = a.catch(0), a.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: a.t0
            }));
          case 14:
          case "end":
            return a.stop();
        }
    }, t, null, [[0, 11]]);
  })), _updateOrderStatus.apply(this, arguments);
}
var product$1 = {}, product = {};
Object.defineProperty(product, "__esModule", {
  value: !0
});
product.productTransformRule = void 0;
var productTransformRule = {
  item: {
    productId: "productId",
    pseudoId: "internalName",
    productName: "productName",
    salesIntroductionDate: "introductionDate",
    variants: "variantProductIds",
    parent: {
      productName: "parentProductName",
      id: "groupId"
    },
    images: {
      mainImageUrl: "mainImageUrl",
      additionalImageUrls: "additionalImageUrls"
    },
    features: "productFeatures",
    identifications: "goodIdentifications",
    brandName: "brandName",
    sku: "sku"
  },
  operate: [{
    run: function t(e) {
      if (e) {
        var r = e == null ? void 0 : e.reduce(function(o, a) {
          var c = a.split("/")[0], u = a.split("/")[1];
          return o[c] ? o[c].push(u) : o[c] = [u], o;
        }, {});
        return Object.keys(r).map(function(o) {
          return {
            desc: o,
            value: r[o]
          };
        });
      }
    },
    on: "features"
  }, {
    run: function t(e) {
      return e != null && e.length ? e.map(function(r) {
        var o = r.lastIndexOf("/"), a = r.slice(0, o), c = r.slice(o + 1);
        return {
          productIdTypeEnumId: a,
          idValue: c
        };
      }) : [];
    },
    on: "identifications"
  }]
};
product.productTransformRule = productTransformRule;
Object.defineProperty(product$1, "__esModule", {
  value: !0
});
product$1.fetchProducts = fetchProducts;
product$1.fetchProductsGroupedBy = fetchProductsGroupedBy;
product$1.fetchProductsGroupedByParent = fetchProductsGroupedByParent;
var _api$2 = _interopRequireDefault$2(api), _types$1 = types, _util$2 = util, _nodeJsonTransform$2 = nodeJsonTransform, _product = product;
function _interopRequireDefault$2(t) {
  return t && t.__esModule ? t : { default: t };
}
function _typeof$2(t) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof$2(t);
}
function ownKeys(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function _objectSpread(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(r), !0).forEach(function(o) {
      _defineProperty(t, o, r[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(r, o));
    });
  }
  return t;
}
function _defineProperty(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function _regeneratorRuntime$2() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$2 = function() {
    return t;
  };
  var t = {}, e = Object.prototype, r = e.hasOwnProperty, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function d(A, S, F) {
    return Object.defineProperty(A, S, { value: F, enumerable: !0, configurable: !0, writable: !0 }), A[S];
  }
  try {
    d({}, "");
  } catch {
    d = function(F, U, M) {
      return F[U] = M;
    };
  }
  function p(A, S, F, U) {
    var M = S && S.prototype instanceof x ? S : x, V = Object.create(M.prototype), G = new P(U || []);
    return V._invoke = function(Q, fe, te) {
      var de = "suspendedStart";
      return function(me, Me) {
        if (de === "executing")
          throw new Error("Generator is already running");
        if (de === "completed") {
          if (me === "throw")
            throw Me;
          return W();
        }
        for (te.method = me, te.arg = Me; ; ) {
          var ce = te.delegate;
          if (ce) {
            var oe = L(ce, te);
            if (oe) {
              if (oe === b)
                continue;
              return oe;
            }
          }
          if (te.method === "next")
            te.sent = te._sent = te.arg;
          else if (te.method === "throw") {
            if (de === "suspendedStart")
              throw de = "completed", te.arg;
            te.dispatchException(te.arg);
          } else
            te.method === "return" && te.abrupt("return", te.arg);
          de = "executing";
          var be = g(Q, fe, te);
          if (be.type === "normal") {
            if (de = te.done ? "completed" : "suspendedYield", be.arg === b)
              continue;
            return { value: be.arg, done: te.done };
          }
          be.type === "throw" && (de = "completed", te.method = "throw", te.arg = be.arg);
        }
      };
    }(A, F, G), V;
  }
  function g(A, S, F) {
    try {
      return { type: "normal", arg: A.call(S, F) };
    } catch (U) {
      return { type: "throw", arg: U };
    }
  }
  t.wrap = p;
  var b = {};
  function x() {
  }
  function w() {
  }
  function y() {
  }
  var I = {};
  d(I, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, T = E && E(E(z([])));
  T && T !== e && r.call(T, a) && (I = T);
  var C = y.prototype = x.prototype = Object.create(I);
  function $(A) {
    ["next", "throw", "return"].forEach(function(S) {
      d(A, S, function(F) {
        return this._invoke(S, F);
      });
    });
  }
  function D(A, S) {
    function F(M, V, G, Q) {
      var fe = g(A[M], A, V);
      if (fe.type !== "throw") {
        var te = fe.arg, de = te.value;
        return de && _typeof$2(de) == "object" && r.call(de, "__await") ? S.resolve(de.__await).then(function(me) {
          F("next", me, G, Q);
        }, function(me) {
          F("throw", me, G, Q);
        }) : S.resolve(de).then(function(me) {
          te.value = me, G(te);
        }, function(me) {
          return F("throw", me, G, Q);
        });
      }
      Q(fe.arg);
    }
    var U;
    this._invoke = function(M, V) {
      function G() {
        return new S(function(Q, fe) {
          F(M, V, Q, fe);
        });
      }
      return U = U ? U.then(G, G) : G();
    };
  }
  function L(A, S) {
    var F = A.iterator[S.method];
    if (F === void 0) {
      if (S.delegate = null, S.method === "throw") {
        if (A.iterator.return && (S.method = "return", S.arg = void 0, L(A, S), S.method === "throw"))
          return b;
        S.method = "throw", S.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return b;
    }
    var U = g(F, A.iterator, S.arg);
    if (U.type === "throw")
      return S.method = "throw", S.arg = U.arg, S.delegate = null, b;
    var M = U.arg;
    return M ? M.done ? (S[A.resultName] = M.value, S.next = A.nextLoc, S.method !== "return" && (S.method = "next", S.arg = void 0), S.delegate = null, b) : M : (S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, b);
  }
  function R(A) {
    var S = { tryLoc: A[0] };
    1 in A && (S.catchLoc = A[1]), 2 in A && (S.finallyLoc = A[2], S.afterLoc = A[3]), this.tryEntries.push(S);
  }
  function O(A) {
    var S = A.completion || {};
    S.type = "normal", delete S.arg, A.completion = S;
  }
  function P(A) {
    this.tryEntries = [{ tryLoc: "root" }], A.forEach(R, this), this.reset(!0);
  }
  function z(A) {
    if (A) {
      var S = A[a];
      if (S)
        return S.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var F = -1, U = function M() {
          for (; ++F < A.length; )
            if (r.call(A, F))
              return M.value = A[F], M.done = !1, M;
          return M.value = void 0, M.done = !0, M;
        };
        return U.next = U;
      }
    }
    return { next: W };
  }
  function W() {
    return { value: void 0, done: !0 };
  }
  return w.prototype = y, d(C, "constructor", y), d(y, "constructor", w), w.displayName = d(y, u, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var S = typeof A == "function" && A.constructor;
    return !!S && (S === w || (S.displayName || S.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, y) : (A.__proto__ = y, d(A, u, "GeneratorFunction")), A.prototype = Object.create(C), A;
  }, t.awrap = function(A) {
    return { __await: A };
  }, $(D.prototype), d(D.prototype, c, function() {
    return this;
  }), t.AsyncIterator = D, t.async = function(A, S, F, U, M) {
    M === void 0 && (M = Promise);
    var V = new D(p(A, S, F, U), M);
    return t.isGeneratorFunction(S) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, $(C), d(C, u, "Generator"), d(C, a, function() {
    return this;
  }), d(C, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var S = [];
    for (var F in A)
      S.push(F);
    return S.reverse(), function U() {
      for (; S.length; ) {
        var M = S.pop();
        if (M in A)
          return U.value = M, U.done = !1, U;
      }
      return U.done = !0, U;
    };
  }, t.values = z, P.prototype = { constructor: P, reset: function(S) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !S)
      for (var F in this)
        F.charAt(0) === "t" && r.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = void 0);
  }, stop: function() {
    this.done = !0;
    var S = this.tryEntries[0].completion;
    if (S.type === "throw")
      throw S.arg;
    return this.rval;
  }, dispatchException: function(S) {
    if (this.done)
      throw S;
    var F = this;
    function U(te, de) {
      return G.type = "throw", G.arg = S, F.next = te, de && (F.method = "next", F.arg = void 0), !!de;
    }
    for (var M = this.tryEntries.length - 1; M >= 0; --M) {
      var V = this.tryEntries[M], G = V.completion;
      if (V.tryLoc === "root")
        return U("end");
      if (V.tryLoc <= this.prev) {
        var Q = r.call(V, "catchLoc"), fe = r.call(V, "finallyLoc");
        if (Q && fe) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        } else if (Q) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
        } else {
          if (!fe)
            throw new Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(S, F) {
    for (var U = this.tryEntries.length - 1; U >= 0; --U) {
      var M = this.tryEntries[U];
      if (M.tryLoc <= this.prev && r.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
        var V = M;
        break;
      }
    }
    V && (S === "break" || S === "continue") && V.tryLoc <= F && F <= V.finallyLoc && (V = null);
    var G = V ? V.completion : {};
    return G.type = S, G.arg = F, V ? (this.method = "next", this.next = V.finallyLoc, b) : this.complete(G);
  }, complete: function(S, F) {
    if (S.type === "throw")
      throw S.arg;
    return S.type === "break" || S.type === "continue" ? this.next = S.arg : S.type === "return" ? (this.rval = this.arg = S.arg, this.method = "return", this.next = "end") : S.type === "normal" && F && (this.next = F), b;
  }, finish: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.finallyLoc === S)
        return this.complete(U.completion, U.afterLoc), O(U), b;
    }
  }, catch: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.tryLoc === S) {
        var M = U.completion;
        if (M.type === "throw") {
          var V = M.arg;
          O(U);
        }
        return V;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(S, F, U) {
    return this.delegate = { iterator: z(S), resultName: F, nextLoc: U }, this.method === "next" && (this.arg = void 0), b;
  } }, t;
}
function asyncGeneratorStep$2(t, e, r, o, a, c, u) {
  try {
    var d = t[c](u), p = d.value;
  } catch (g) {
    r(g);
    return;
  }
  d.done ? e(p) : Promise.resolve(p).then(o, a);
}
function _asyncToGenerator$2(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(o, a) {
      var c = t.apply(e, r);
      function u(p) {
        asyncGeneratorStep$2(c, o, a, u, d, "next", p);
      }
      function d(p) {
        asyncGeneratorStep$2(c, o, a, u, d, "throw", p);
      }
      u(void 0);
    });
  };
}
function fetchProducts(t) {
  return _fetchProducts.apply(this, arguments);
}
function _fetchProducts() {
  return _fetchProducts = _asyncToGenerator$2(/* @__PURE__ */ _regeneratorRuntime$2().mark(function t(e) {
    var r, o, a, c, u, d, p, g;
    return _regeneratorRuntime$2().wrap(function(x) {
      for (; ; )
        switch (x.prev = x.next) {
          case 0:
            return r = {
              json: {
                params: {
                  rows: e.viewSize,
                  start: e.viewIndex
                },
                query: "*:*",
                filter: "docType: PRODUCT"
              }
            }, o = e.queryFields ? e.queryFields : "productId productName internalName", e.filters && Object.keys(e.filters).map(function(w) {
              var y = e.filters[w].value;
              if (Array.isArray(y)) {
                var I = e.filters[w].op ? e.filters[w].op : _types$1.OPERATOR.OR;
                r.json.filter += " ".concat(_types$1.OPERATOR.AND, " ").concat(w, ": (").concat(y.join(" " + I + " "), ")");
              } else
                r.json.filter += " ".concat(_types$1.OPERATOR.AND, " ").concat(w, ": ").concat(y);
            }), e.queryString && (r.json.query = "(*".concat(e.queryString, "*)"), r.json.params.qf = o, r.json.params.defType = "edismax"), x.prev = 4, x.next = 7, (0, _api$2.default)({
              url: "solr-query",
              method: "get",
              params: r,
              cache: !0
            });
          case 7:
            if (u = x.sent, !(u.status == 200 && !(0, _util$2.hasError)(u) && ((a = u.data) === null || a === void 0 || (c = a.response) === null || c === void 0 ? void 0 : c.numFound) > 0)) {
              x.next = 13;
              break;
            }
            return g = (0, _nodeJsonTransform$2.transform)(u.data.response.docs, _product.productTransformRule), x.abrupt("return", {
              products: g,
              total: (d = u.data) === null || d === void 0 || (p = d.response) === null || p === void 0 ? void 0 : p.numFound
            });
          case 13:
            return x.abrupt("return", {
              products: {},
              total: 0
            });
          case 14:
            x.next = 19;
            break;
          case 16:
            return x.prev = 16, x.t0 = x.catch(4), x.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: x.t0
            }));
          case 19:
          case "end":
            return x.stop();
        }
    }, t, null, [[4, 16]]);
  })), _fetchProducts.apply(this, arguments);
}
function fetchProductsGroupedBy(t) {
  return _fetchProductsGroupedBy.apply(this, arguments);
}
function _fetchProductsGroupedBy() {
  return _fetchProductsGroupedBy = _asyncToGenerator$2(/* @__PURE__ */ _regeneratorRuntime$2().mark(function t(e) {
    var r, o, a, c, u, d, p, g, b, x;
    return _regeneratorRuntime$2().wrap(function(y) {
      for (; ; )
        switch (y.prev = y.next) {
          case 0:
            return r = {
              json: {
                params: {
                  group: !0,
                  "group.field": e.groupField,
                  "group.limit": e.groupLimit ? e.groupLimit : 1e4,
                  "group.ngroups": e.ngroups ? e.ngroups : !0,
                  rows: e.viewSize,
                  start: e.viewIndex,
                  "q.op": _types$1.OPERATOR.AND
                },
                query: "*:*",
                filter: "docType: PRODUCT"
              }
            }, o = e.queryFields ? e.queryFields : "productId productName internalName", e.filters && Object.keys(e.filters).map(function(I) {
              var E = e.filters[I].value;
              if (Array.isArray(E)) {
                var T = e.filters[I].op ? e.filters[I].op : _types$1.OPERATOR.OR;
                r.json.filter += " ".concat(_types$1.OPERATOR.AND, " ").concat(I, ": (").concat(E.join(" " + T + " "), ")");
              } else
                r.json.filter += " ".concat(_types$1.OPERATOR.AND, " ").concat(I, ": ").concat(E);
            }), e.queryString && (r.json.query = "(*".concat(e.queryString, "*)"), r.json.params.qf = o, r.json.params.defType = "edismax"), y.prev = 4, y.next = 7, (0, _api$2.default)({
              url: "solr-query",
              method: "get",
              params: r,
              cache: !0
            });
          case 7:
            if (u = y.sent, !(u.status == 200 && !(0, _util$2.hasError)(u) && ((a = u.data) === null || a === void 0 || (c = a.grouped) === null || c === void 0 ? void 0 : c.groupId.ngroups) > 0)) {
              y.next = 13;
              break;
            }
            return x = u.data.grouped.groupId.groups.map(function(I) {
              var E = (0, _nodeJsonTransform$2.transform)(I.doclist.docs, _product.productTransformRule);
              return {
                groupValue: I.groupValue,
                variants: E
              };
            }), y.abrupt("return", {
              products: x,
              matches: (d = u.data) === null || d === void 0 || (p = d.grouped) === null || p === void 0 ? void 0 : p.groupId.matches,
              ngroups: (g = u.data) === null || g === void 0 || (b = g.grouped) === null || b === void 0 ? void 0 : b.groupId.ngroups
            });
          case 13:
            return y.abrupt("return", {
              products: {},
              matches: 0,
              ngroups: 0
            });
          case 14:
            y.next = 19;
            break;
          case 16:
            return y.prev = 16, y.t0 = y.catch(4), y.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: y.t0
            }));
          case 19:
          case "end":
            return y.stop();
        }
    }, t, null, [[4, 16]]);
  })), _fetchProductsGroupedBy.apply(this, arguments);
}
function fetchProductsGroupedByParent(t) {
  return _fetchProductsGroupedByParent.apply(this, arguments);
}
function _fetchProductsGroupedByParent() {
  return _fetchProductsGroupedByParent = _asyncToGenerator$2(/* @__PURE__ */ _regeneratorRuntime$2().mark(function t(e) {
    var r;
    return _regeneratorRuntime$2().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return r = _objectSpread(_objectSpread({}, e), {}, {
              groupField: "groupId",
              groupLimit: 1e4,
              ngroups: !0
            }), a.next = 3, fetchProductsGroupedBy(r);
          case 3:
            return a.abrupt("return", a.sent);
          case 4:
          case "end":
            return a.stop();
        }
    }, t);
  })), _fetchProductsGroupedByParent.apply(this, arguments);
}
var user$1 = {}, user = {};
Object.defineProperty(user, "__esModule", {
  value: !0
});
user.userProfileTransformRule = void 0;
var userProfileTransformRule = {
  item: {
    userId: "userLoginId",
    username: "userLoginId",
    userFullName: "partyName",
    emailAddress: "email",
    partyId: "partyId",
    timeZone: "userTimeZone",
    facilities: "facilities"
  },
  operate: [{
    run: function t(e) {
      return e.map(function(r) {
        return {
          facilityId: r.facilityId,
          facilityName: r.name,
          roleTypeId: r.roleTypeId,
          roleTypeDescription: r.roleTypeDescription
        };
      });
    },
    on: "facilities"
  }]
};
user.userProfileTransformRule = userProfileTransformRule;
Object.defineProperty(user$1, "__esModule", {
  value: !0
});
user$1.getProductIdentificationPref = getProductIdentificationPref;
user$1.getProfile = getProfile;
user$1.logout = logout;
user$1.setProductIdentificationPref = setProductIdentificationPref;
var _api$1 = _interopRequireDefault$1(api), _user = user, _util$1 = util, _nodeJsonTransform$1 = nodeJsonTransform;
function _interopRequireDefault$1(t) {
  return t && t.__esModule ? t : { default: t };
}
function _typeof$1(t) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof$1(t);
}
function _regeneratorRuntime$1() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime$1 = function() {
    return t;
  };
  var t = {}, e = Object.prototype, r = e.hasOwnProperty, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function d(A, S, F) {
    return Object.defineProperty(A, S, { value: F, enumerable: !0, configurable: !0, writable: !0 }), A[S];
  }
  try {
    d({}, "");
  } catch {
    d = function(F, U, M) {
      return F[U] = M;
    };
  }
  function p(A, S, F, U) {
    var M = S && S.prototype instanceof x ? S : x, V = Object.create(M.prototype), G = new P(U || []);
    return V._invoke = function(Q, fe, te) {
      var de = "suspendedStart";
      return function(me, Me) {
        if (de === "executing")
          throw new Error("Generator is already running");
        if (de === "completed") {
          if (me === "throw")
            throw Me;
          return W();
        }
        for (te.method = me, te.arg = Me; ; ) {
          var ce = te.delegate;
          if (ce) {
            var oe = L(ce, te);
            if (oe) {
              if (oe === b)
                continue;
              return oe;
            }
          }
          if (te.method === "next")
            te.sent = te._sent = te.arg;
          else if (te.method === "throw") {
            if (de === "suspendedStart")
              throw de = "completed", te.arg;
            te.dispatchException(te.arg);
          } else
            te.method === "return" && te.abrupt("return", te.arg);
          de = "executing";
          var be = g(Q, fe, te);
          if (be.type === "normal") {
            if (de = te.done ? "completed" : "suspendedYield", be.arg === b)
              continue;
            return { value: be.arg, done: te.done };
          }
          be.type === "throw" && (de = "completed", te.method = "throw", te.arg = be.arg);
        }
      };
    }(A, F, G), V;
  }
  function g(A, S, F) {
    try {
      return { type: "normal", arg: A.call(S, F) };
    } catch (U) {
      return { type: "throw", arg: U };
    }
  }
  t.wrap = p;
  var b = {};
  function x() {
  }
  function w() {
  }
  function y() {
  }
  var I = {};
  d(I, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, T = E && E(E(z([])));
  T && T !== e && r.call(T, a) && (I = T);
  var C = y.prototype = x.prototype = Object.create(I);
  function $(A) {
    ["next", "throw", "return"].forEach(function(S) {
      d(A, S, function(F) {
        return this._invoke(S, F);
      });
    });
  }
  function D(A, S) {
    function F(M, V, G, Q) {
      var fe = g(A[M], A, V);
      if (fe.type !== "throw") {
        var te = fe.arg, de = te.value;
        return de && _typeof$1(de) == "object" && r.call(de, "__await") ? S.resolve(de.__await).then(function(me) {
          F("next", me, G, Q);
        }, function(me) {
          F("throw", me, G, Q);
        }) : S.resolve(de).then(function(me) {
          te.value = me, G(te);
        }, function(me) {
          return F("throw", me, G, Q);
        });
      }
      Q(fe.arg);
    }
    var U;
    this._invoke = function(M, V) {
      function G() {
        return new S(function(Q, fe) {
          F(M, V, Q, fe);
        });
      }
      return U = U ? U.then(G, G) : G();
    };
  }
  function L(A, S) {
    var F = A.iterator[S.method];
    if (F === void 0) {
      if (S.delegate = null, S.method === "throw") {
        if (A.iterator.return && (S.method = "return", S.arg = void 0, L(A, S), S.method === "throw"))
          return b;
        S.method = "throw", S.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return b;
    }
    var U = g(F, A.iterator, S.arg);
    if (U.type === "throw")
      return S.method = "throw", S.arg = U.arg, S.delegate = null, b;
    var M = U.arg;
    return M ? M.done ? (S[A.resultName] = M.value, S.next = A.nextLoc, S.method !== "return" && (S.method = "next", S.arg = void 0), S.delegate = null, b) : M : (S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, b);
  }
  function R(A) {
    var S = { tryLoc: A[0] };
    1 in A && (S.catchLoc = A[1]), 2 in A && (S.finallyLoc = A[2], S.afterLoc = A[3]), this.tryEntries.push(S);
  }
  function O(A) {
    var S = A.completion || {};
    S.type = "normal", delete S.arg, A.completion = S;
  }
  function P(A) {
    this.tryEntries = [{ tryLoc: "root" }], A.forEach(R, this), this.reset(!0);
  }
  function z(A) {
    if (A) {
      var S = A[a];
      if (S)
        return S.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var F = -1, U = function M() {
          for (; ++F < A.length; )
            if (r.call(A, F))
              return M.value = A[F], M.done = !1, M;
          return M.value = void 0, M.done = !0, M;
        };
        return U.next = U;
      }
    }
    return { next: W };
  }
  function W() {
    return { value: void 0, done: !0 };
  }
  return w.prototype = y, d(C, "constructor", y), d(y, "constructor", w), w.displayName = d(y, u, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var S = typeof A == "function" && A.constructor;
    return !!S && (S === w || (S.displayName || S.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, y) : (A.__proto__ = y, d(A, u, "GeneratorFunction")), A.prototype = Object.create(C), A;
  }, t.awrap = function(A) {
    return { __await: A };
  }, $(D.prototype), d(D.prototype, c, function() {
    return this;
  }), t.AsyncIterator = D, t.async = function(A, S, F, U, M) {
    M === void 0 && (M = Promise);
    var V = new D(p(A, S, F, U), M);
    return t.isGeneratorFunction(S) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, $(C), d(C, u, "Generator"), d(C, a, function() {
    return this;
  }), d(C, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var S = [];
    for (var F in A)
      S.push(F);
    return S.reverse(), function U() {
      for (; S.length; ) {
        var M = S.pop();
        if (M in A)
          return U.value = M, U.done = !1, U;
      }
      return U.done = !0, U;
    };
  }, t.values = z, P.prototype = { constructor: P, reset: function(S) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !S)
      for (var F in this)
        F.charAt(0) === "t" && r.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = void 0);
  }, stop: function() {
    this.done = !0;
    var S = this.tryEntries[0].completion;
    if (S.type === "throw")
      throw S.arg;
    return this.rval;
  }, dispatchException: function(S) {
    if (this.done)
      throw S;
    var F = this;
    function U(te, de) {
      return G.type = "throw", G.arg = S, F.next = te, de && (F.method = "next", F.arg = void 0), !!de;
    }
    for (var M = this.tryEntries.length - 1; M >= 0; --M) {
      var V = this.tryEntries[M], G = V.completion;
      if (V.tryLoc === "root")
        return U("end");
      if (V.tryLoc <= this.prev) {
        var Q = r.call(V, "catchLoc"), fe = r.call(V, "finallyLoc");
        if (Q && fe) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        } else if (Q) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
        } else {
          if (!fe)
            throw new Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(S, F) {
    for (var U = this.tryEntries.length - 1; U >= 0; --U) {
      var M = this.tryEntries[U];
      if (M.tryLoc <= this.prev && r.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
        var V = M;
        break;
      }
    }
    V && (S === "break" || S === "continue") && V.tryLoc <= F && F <= V.finallyLoc && (V = null);
    var G = V ? V.completion : {};
    return G.type = S, G.arg = F, V ? (this.method = "next", this.next = V.finallyLoc, b) : this.complete(G);
  }, complete: function(S, F) {
    if (S.type === "throw")
      throw S.arg;
    return S.type === "break" || S.type === "continue" ? this.next = S.arg : S.type === "return" ? (this.rval = this.arg = S.arg, this.method = "return", this.next = "end") : S.type === "normal" && F && (this.next = F), b;
  }, finish: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.finallyLoc === S)
        return this.complete(U.completion, U.afterLoc), O(U), b;
    }
  }, catch: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.tryLoc === S) {
        var M = U.completion;
        if (M.type === "throw") {
          var V = M.arg;
          O(U);
        }
        return V;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(S, F, U) {
    return this.delegate = { iterator: z(S), resultName: F, nextLoc: U }, this.method === "next" && (this.arg = void 0), b;
  } }, t;
}
function asyncGeneratorStep$1(t, e, r, o, a, c, u) {
  try {
    var d = t[c](u), p = d.value;
  } catch (g) {
    r(g);
    return;
  }
  d.done ? e(p) : Promise.resolve(p).then(o, a);
}
function _asyncToGenerator$1(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(o, a) {
      var c = t.apply(e, r);
      function u(p) {
        asyncGeneratorStep$1(c, o, a, u, d, "next", p);
      }
      function d(p) {
        asyncGeneratorStep$1(c, o, a, u, d, "throw", p);
      }
      u(void 0);
    });
  };
}
function getProfile() {
  return _getProfile.apply(this, arguments);
}
function _getProfile() {
  return _getProfile = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(function t() {
    var e, r;
    return _regeneratorRuntime$1().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return a.prev = 0, a.next = 3, (0, _api$1.default)({
              url: "user-profile",
              method: "get"
            });
          case 3:
            if (e = a.sent, !(e.status === 200 && !(0, _util$1.hasError)(e))) {
              a.next = 9;
              break;
            }
            return r = (0, _nodeJsonTransform$1.transform)(e.data, _user.userProfileTransformRule), a.abrupt("return", Promise.resolve(r));
          case 9:
            return a.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: "Failed to fetch user profile information"
            }));
          case 10:
            a.next = 15;
            break;
          case 12:
            return a.prev = 12, a.t0 = a.catch(0), a.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: a.t0
            }));
          case 15:
          case "end":
            return a.stop();
        }
    }, t, null, [[0, 12]]);
  })), _getProfile.apply(this, arguments);
}
function setProductIdentificationPref(t, e) {
  return _setProductIdentificationPref.apply(this, arguments);
}
function _setProductIdentificationPref() {
  return _setProductIdentificationPref = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(function t(e, r) {
    var o, a, c, u, d;
    return _regeneratorRuntime$1().wrap(function(g) {
      for (; ; )
        switch (g.prev = g.next) {
          case 0:
            return a = {
              inputFields: {
                productStoreId: e,
                settingTypeEnumId: "PRDT_IDEN_PREF"
              },
              filterByDate: "Y",
              entityName: "ProductStoreSetting",
              fieldList: ["fromDate", "productStoreId"],
              viewSize: 1
            }, g.prev = 1, g.next = 4, (0, _api$1.default)({
              url: "performFind",
              method: "get",
              params: a,
              cache: !0
            });
          case 4:
            c = g.sent, (0, _util$1.hasError)(c) || (o = c.data.docs[0].fromDate), g.next = 11;
            break;
          case 8:
            g.prev = 8, g.t0 = g.catch(1), console.error(g.t0);
          case 11:
            if (o) {
              g.next = 13;
              break;
            }
            return g.abrupt("return", Promise.reject("fromDate information is missing"));
          case 13:
            return u = {
              fromDate: o,
              productStoreId: e,
              settingTypeEnumId: "PRDT_IDEN_PREF",
              settingValue: JSON.stringify(r)
            }, g.prev = 14, g.next = 17, (0, _api$1.default)({
              url: "service/updateProductStoreSetting",
              method: "post",
              data: u
            });
          case 17:
            if (d = g.sent, (0, _util$1.hasError)(d)) {
              g.next = 22;
              break;
            }
            return g.abrupt("return", Promise.resolve(r));
          case 22:
            return g.abrupt("return", Promise.reject(d));
          case 23:
            g.next = 28;
            break;
          case 25:
            return g.prev = 25, g.t1 = g.catch(14), g.abrupt("return", Promise.reject(g.t1));
          case 28:
          case "end":
            return g.stop();
        }
    }, t, null, [[1, 8], [14, 25]]);
  })), _setProductIdentificationPref.apply(this, arguments);
}
function createProductIdentificationPref(t) {
  return _createProductIdentificationPref.apply(this, arguments);
}
function _createProductIdentificationPref() {
  return _createProductIdentificationPref = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(function t(e) {
    var r, o;
    return _regeneratorRuntime$1().wrap(function(c) {
      for (; ; )
        switch (c.prev = c.next) {
          case 0:
            return r = {
              primaryId: "productId",
              secondaryId: ""
            }, o = {
              fromDate: Date.now(),
              productStoreId: e,
              settingTypeEnumId: "PRDT_IDEN_PREF",
              settingValue: JSON.stringify(r)
            }, c.prev = 2, c.next = 5, (0, _api$1.default)({
              url: "service/createProductStoreSetting",
              method: "post",
              data: o
            });
          case 5:
            c.next = 10;
            break;
          case 7:
            c.prev = 7, c.t0 = c.catch(2), console.error(c.t0);
          case 10:
            return c.abrupt("return", r);
          case 11:
          case "end":
            return c.stop();
        }
    }, t, null, [[2, 7]]);
  })), _createProductIdentificationPref.apply(this, arguments);
}
function getProductIdentificationPref(t) {
  return _getProductIdentificationPref.apply(this, arguments);
}
function _getProductIdentificationPref() {
  return _getProductIdentificationPref = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(function t(e) {
    var r, o, a, c;
    return _regeneratorRuntime$1().wrap(function(d) {
      for (; ; )
        switch (d.prev = d.next) {
          case 0:
            return r = {
              primaryId: "productId",
              secondaryId: ""
            }, o = {
              inputFields: {
                productStoreId: e,
                settingTypeEnumId: "PRDT_IDEN_PREF"
              },
              filterByDate: "Y",
              entityName: "ProductStoreSetting",
              fieldList: ["settingValue", "fromDate"],
              viewSize: 1
            }, d.prev = 2, d.next = 5, (0, _api$1.default)({
              url: "performFind",
              method: "get",
              params: o,
              cache: !0
            });
          case 5:
            if (a = d.sent, !(!(0, _util$1.hasError)(a) && a.data.docs[0].settingValue)) {
              d.next = 12;
              break;
            }
            c = JSON.parse(a.data.docs[0].settingValue), r.primaryId = c.primaryId, r.secondaryId = c.secondaryId, d.next = 15;
            break;
          case 12:
            if (a.data.error !== "No record found") {
              d.next = 15;
              break;
            }
            return d.next = 15, createProductIdentificationPref(e);
          case 15:
            d.next = 20;
            break;
          case 17:
            d.prev = 17, d.t0 = d.catch(2), console.error(d.t0);
          case 20:
            return d.abrupt("return", r);
          case 21:
          case "end":
            return d.stop();
        }
    }, t, null, [[2, 17]]);
  })), _getProductIdentificationPref.apply(this, arguments);
}
function logout() {
  return _logout.apply(this, arguments);
}
function _logout() {
  return _logout = _asyncToGenerator$1(/* @__PURE__ */ _regeneratorRuntime$1().mark(function t() {
    var e;
    return _regeneratorRuntime$1().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return o.prev = 0, o.next = 3, (0, _api$1.default)({
              url: "logout",
              method: "get"
            });
          case 3:
            if (e = o.sent, e.status == 200) {
              o.next = 6;
              break;
            }
            throw e.data;
          case 6:
            return o.abrupt("return", Promise.resolve(e.data));
          case 9:
            return o.prev = 9, o.t0 = o.catch(0), o.abrupt("return", Promise.reject(o.t0));
          case 12:
          case "end":
            return o.stop();
        }
    }, t, null, [[0, 9]]);
  })), _logout.apply(this, arguments);
}
var stock$1 = {}, stock = {};
Object.defineProperty(stock, "__esModule", {
  value: !0
});
stock.stockTransformRule = void 0;
var stockTransformRule = {
  item: {
    productId: "productId",
    availableToPromiseTotal: "atp",
    facilityId: "facilityId"
  }
};
stock.stockTransformRule = stockTransformRule;
Object.defineProperty(stock$1, "__esModule", {
  value: !0
});
stock$1.fetchProductsStock = fetchProductsStock;
stock$1.fetchProductsStockAtFacility = fetchProductsStockAtFacility;
var _api = _interopRequireDefault(api), _util = util, _types = types, _nodeJsonTransform = nodeJsonTransform, _stock = stock;
function _interopRequireDefault(t) {
  return t && t.__esModule ? t : { default: t };
}
function _typeof(t) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof(t);
}
function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function() {
    return t;
  };
  var t = {}, e = Object.prototype, r = e.hasOwnProperty, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
  function d(A, S, F) {
    return Object.defineProperty(A, S, { value: F, enumerable: !0, configurable: !0, writable: !0 }), A[S];
  }
  try {
    d({}, "");
  } catch {
    d = function(F, U, M) {
      return F[U] = M;
    };
  }
  function p(A, S, F, U) {
    var M = S && S.prototype instanceof x ? S : x, V = Object.create(M.prototype), G = new P(U || []);
    return V._invoke = function(Q, fe, te) {
      var de = "suspendedStart";
      return function(me, Me) {
        if (de === "executing")
          throw new Error("Generator is already running");
        if (de === "completed") {
          if (me === "throw")
            throw Me;
          return W();
        }
        for (te.method = me, te.arg = Me; ; ) {
          var ce = te.delegate;
          if (ce) {
            var oe = L(ce, te);
            if (oe) {
              if (oe === b)
                continue;
              return oe;
            }
          }
          if (te.method === "next")
            te.sent = te._sent = te.arg;
          else if (te.method === "throw") {
            if (de === "suspendedStart")
              throw de = "completed", te.arg;
            te.dispatchException(te.arg);
          } else
            te.method === "return" && te.abrupt("return", te.arg);
          de = "executing";
          var be = g(Q, fe, te);
          if (be.type === "normal") {
            if (de = te.done ? "completed" : "suspendedYield", be.arg === b)
              continue;
            return { value: be.arg, done: te.done };
          }
          be.type === "throw" && (de = "completed", te.method = "throw", te.arg = be.arg);
        }
      };
    }(A, F, G), V;
  }
  function g(A, S, F) {
    try {
      return { type: "normal", arg: A.call(S, F) };
    } catch (U) {
      return { type: "throw", arg: U };
    }
  }
  t.wrap = p;
  var b = {};
  function x() {
  }
  function w() {
  }
  function y() {
  }
  var I = {};
  d(I, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, T = E && E(E(z([])));
  T && T !== e && r.call(T, a) && (I = T);
  var C = y.prototype = x.prototype = Object.create(I);
  function $(A) {
    ["next", "throw", "return"].forEach(function(S) {
      d(A, S, function(F) {
        return this._invoke(S, F);
      });
    });
  }
  function D(A, S) {
    function F(M, V, G, Q) {
      var fe = g(A[M], A, V);
      if (fe.type !== "throw") {
        var te = fe.arg, de = te.value;
        return de && _typeof(de) == "object" && r.call(de, "__await") ? S.resolve(de.__await).then(function(me) {
          F("next", me, G, Q);
        }, function(me) {
          F("throw", me, G, Q);
        }) : S.resolve(de).then(function(me) {
          te.value = me, G(te);
        }, function(me) {
          return F("throw", me, G, Q);
        });
      }
      Q(fe.arg);
    }
    var U;
    this._invoke = function(M, V) {
      function G() {
        return new S(function(Q, fe) {
          F(M, V, Q, fe);
        });
      }
      return U = U ? U.then(G, G) : G();
    };
  }
  function L(A, S) {
    var F = A.iterator[S.method];
    if (F === void 0) {
      if (S.delegate = null, S.method === "throw") {
        if (A.iterator.return && (S.method = "return", S.arg = void 0, L(A, S), S.method === "throw"))
          return b;
        S.method = "throw", S.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return b;
    }
    var U = g(F, A.iterator, S.arg);
    if (U.type === "throw")
      return S.method = "throw", S.arg = U.arg, S.delegate = null, b;
    var M = U.arg;
    return M ? M.done ? (S[A.resultName] = M.value, S.next = A.nextLoc, S.method !== "return" && (S.method = "next", S.arg = void 0), S.delegate = null, b) : M : (S.method = "throw", S.arg = new TypeError("iterator result is not an object"), S.delegate = null, b);
  }
  function R(A) {
    var S = { tryLoc: A[0] };
    1 in A && (S.catchLoc = A[1]), 2 in A && (S.finallyLoc = A[2], S.afterLoc = A[3]), this.tryEntries.push(S);
  }
  function O(A) {
    var S = A.completion || {};
    S.type = "normal", delete S.arg, A.completion = S;
  }
  function P(A) {
    this.tryEntries = [{ tryLoc: "root" }], A.forEach(R, this), this.reset(!0);
  }
  function z(A) {
    if (A) {
      var S = A[a];
      if (S)
        return S.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var F = -1, U = function M() {
          for (; ++F < A.length; )
            if (r.call(A, F))
              return M.value = A[F], M.done = !1, M;
          return M.value = void 0, M.done = !0, M;
        };
        return U.next = U;
      }
    }
    return { next: W };
  }
  function W() {
    return { value: void 0, done: !0 };
  }
  return w.prototype = y, d(C, "constructor", y), d(y, "constructor", w), w.displayName = d(y, u, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var S = typeof A == "function" && A.constructor;
    return !!S && (S === w || (S.displayName || S.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, y) : (A.__proto__ = y, d(A, u, "GeneratorFunction")), A.prototype = Object.create(C), A;
  }, t.awrap = function(A) {
    return { __await: A };
  }, $(D.prototype), d(D.prototype, c, function() {
    return this;
  }), t.AsyncIterator = D, t.async = function(A, S, F, U, M) {
    M === void 0 && (M = Promise);
    var V = new D(p(A, S, F, U), M);
    return t.isGeneratorFunction(S) ? V : V.next().then(function(G) {
      return G.done ? G.value : V.next();
    });
  }, $(C), d(C, u, "Generator"), d(C, a, function() {
    return this;
  }), d(C, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var S = [];
    for (var F in A)
      S.push(F);
    return S.reverse(), function U() {
      for (; S.length; ) {
        var M = S.pop();
        if (M in A)
          return U.value = M, U.done = !1, U;
      }
      return U.done = !0, U;
    };
  }, t.values = z, P.prototype = { constructor: P, reset: function(S) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(O), !S)
      for (var F in this)
        F.charAt(0) === "t" && r.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = void 0);
  }, stop: function() {
    this.done = !0;
    var S = this.tryEntries[0].completion;
    if (S.type === "throw")
      throw S.arg;
    return this.rval;
  }, dispatchException: function(S) {
    if (this.done)
      throw S;
    var F = this;
    function U(te, de) {
      return G.type = "throw", G.arg = S, F.next = te, de && (F.method = "next", F.arg = void 0), !!de;
    }
    for (var M = this.tryEntries.length - 1; M >= 0; --M) {
      var V = this.tryEntries[M], G = V.completion;
      if (V.tryLoc === "root")
        return U("end");
      if (V.tryLoc <= this.prev) {
        var Q = r.call(V, "catchLoc"), fe = r.call(V, "finallyLoc");
        if (Q && fe) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        } else if (Q) {
          if (this.prev < V.catchLoc)
            return U(V.catchLoc, !0);
        } else {
          if (!fe)
            throw new Error("try statement without catch or finally");
          if (this.prev < V.finallyLoc)
            return U(V.finallyLoc);
        }
      }
    }
  }, abrupt: function(S, F) {
    for (var U = this.tryEntries.length - 1; U >= 0; --U) {
      var M = this.tryEntries[U];
      if (M.tryLoc <= this.prev && r.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
        var V = M;
        break;
      }
    }
    V && (S === "break" || S === "continue") && V.tryLoc <= F && F <= V.finallyLoc && (V = null);
    var G = V ? V.completion : {};
    return G.type = S, G.arg = F, V ? (this.method = "next", this.next = V.finallyLoc, b) : this.complete(G);
  }, complete: function(S, F) {
    if (S.type === "throw")
      throw S.arg;
    return S.type === "break" || S.type === "continue" ? this.next = S.arg : S.type === "return" ? (this.rval = this.arg = S.arg, this.method = "return", this.next = "end") : S.type === "normal" && F && (this.next = F), b;
  }, finish: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.finallyLoc === S)
        return this.complete(U.completion, U.afterLoc), O(U), b;
    }
  }, catch: function(S) {
    for (var F = this.tryEntries.length - 1; F >= 0; --F) {
      var U = this.tryEntries[F];
      if (U.tryLoc === S) {
        var M = U.completion;
        if (M.type === "throw") {
          var V = M.arg;
          O(U);
        }
        return V;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(S, F, U) {
    return this.delegate = { iterator: z(S), resultName: F, nextLoc: U }, this.method === "next" && (this.arg = void 0), b;
  } }, t;
}
function asyncGeneratorStep(t, e, r, o, a, c, u) {
  try {
    var d = t[c](u), p = d.value;
  } catch (g) {
    r(g);
    return;
  }
  d.done ? e(p) : Promise.resolve(p).then(o, a);
}
function _asyncToGenerator(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(o, a) {
      var c = t.apply(e, r);
      function u(p) {
        asyncGeneratorStep(c, o, a, u, d, "next", p);
      }
      function d(p) {
        asyncGeneratorStep(c, o, a, u, d, "throw", p);
      }
      u(void 0);
    });
  };
}
function fetchProductsStockAtFacility(t, e) {
  return _fetchProductsStockAtFacility.apply(this, arguments);
}
function _fetchProductsStockAtFacility() {
  return _fetchProductsStockAtFacility = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function t(e, r) {
    var o, a, c;
    return _regeneratorRuntime().wrap(function(d) {
      for (; ; )
        switch (d.prev = d.next) {
          case 0:
            return o = {
              filters: {
                productId: e,
                productId_op: _types.OPERATOR.IN
              },
              viewSize: e.length * 10,
              // TODO: find a better way to find viewSize, currently assuming that a single product can be at most available on 10 facilities
              fieldsToSelect: ["productId", "atp", "facilityId"]
            }, r && (o.filters.facilityId = r, o.viewSize = e.length), d.prev = 2, d.next = 5, (0, _api.default)({
              url: "checkInventory",
              method: "get",
              params: o
            });
          case 5:
            if (a = d.sent, !(a.status === 200 && !(0, _util.hasError)(a) && a.data.count > 0)) {
              d.next = 11;
              break;
            }
            return c = (0, _nodeJsonTransform.transform)(a.data.docs, _stock.stockTransformRule), d.abrupt("return", Promise.resolve(c));
          case 11:
            return d.abrupt("return", Promise.reject({
              code: "error",
              message: "Unable to find the stock for products",
              serverResponse: ""
            }));
          case 12:
            d.next = 17;
            break;
          case 14:
            return d.prev = 14, d.t0 = d.catch(2), d.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: d.t0
            }));
          case 17:
          case "end":
            return d.stop();
        }
    }, t, null, [[2, 14]]);
  })), _fetchProductsStockAtFacility.apply(this, arguments);
}
function fetchProductsStock(t) {
  return _fetchProductsStock.apply(this, arguments);
}
function _fetchProductsStock() {
  return _fetchProductsStock = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function t(e) {
    var r, o, a;
    return _regeneratorRuntime().wrap(function(u) {
      for (; ; )
        switch (u.prev = u.next) {
          case 0:
            return r = {
              filters: {
                productId: e,
                productId_op: _types.OPERATOR.IN
              },
              viewSize: e.length,
              fieldsToSelect: ["productId", "atp"]
            }, u.prev = 1, u.next = 4, (0, _api.default)({
              url: "checkInventory",
              method: "get",
              params: r
            });
          case 4:
            if (o = u.sent, !(o.status === 200 && !(0, _util.hasError)(o) && o.data.count > 0)) {
              u.next = 10;
              break;
            }
            return a = (0, _nodeJsonTransform.transform)(o.data.docs, _stock.stockTransformRule), u.abrupt("return", Promise.resolve(a));
          case 10:
            return u.abrupt("return", Promise.reject({
              code: "error",
              message: "Unable to find the stock for products",
              serverResponse: ""
            }));
          case 11:
            u.next = 16;
            break;
          case 13:
            return u.prev = 13, u.t0 = u.catch(1), u.abrupt("return", Promise.reject({
              code: "error",
              message: "Something went wrong",
              serverResponse: u.t0
            }));
          case 16:
          case "end":
            return u.stop();
        }
    }, t, null, [[1, 13]]);
  })), _fetchProductsStock.apply(this, arguments);
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "fetchProducts", {
    enumerable: !0,
    get: function() {
      return r.fetchProducts;
    }
  }), Object.defineProperty(t, "fetchProductsGroupedBy", {
    enumerable: !0,
    get: function() {
      return r.fetchProductsGroupedBy;
    }
  }), Object.defineProperty(t, "fetchProductsGroupedByParent", {
    enumerable: !0,
    get: function() {
      return r.fetchProductsGroupedByParent;
    }
  }), Object.defineProperty(t, "fetchProductsStock", {
    enumerable: !0,
    get: function() {
      return a.fetchProductsStock;
    }
  }), Object.defineProperty(t, "fetchProductsStockAtFacility", {
    enumerable: !0,
    get: function() {
      return a.fetchProductsStockAtFacility;
    }
  }), Object.defineProperty(t, "getOrderDetails", {
    enumerable: !0,
    get: function() {
      return e.getOrderDetails;
    }
  }), Object.defineProperty(t, "getProductIdentificationPref", {
    enumerable: !0,
    get: function() {
      return o.getProductIdentificationPref;
    }
  }), Object.defineProperty(t, "getProfile", {
    enumerable: !0,
    get: function() {
      return o.getProfile;
    }
  }), Object.defineProperty(t, "logout", {
    enumerable: !0,
    get: function() {
      return o.logout;
    }
  }), Object.defineProperty(t, "setProductIdentificationPref", {
    enumerable: !0,
    get: function() {
      return o.setProductIdentificationPref;
    }
  }), Object.defineProperty(t, "updateOrderStatus", {
    enumerable: !0,
    get: function() {
      return e.updateOrderStatus;
    }
  });
  var e = order$2, r = product$1, o = user$1, a = stock$1;
})(modules);
(function(t) {
  function e(p) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
      return typeof g;
    } : function(g) {
      return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
    }, e(p);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "OPERATOR", {
    enumerable: !0,
    get: function() {
      return r.OPERATOR;
    }
  }), Object.defineProperty(t, "Order", {
    enumerable: !0,
    get: function() {
      return r.Order;
    }
  }), Object.defineProperty(t, "OrderItem", {
    enumerable: !0,
    get: function() {
      return r.OrderItem;
    }
  }), Object.defineProperty(t, "OrderPart", {
    enumerable: !0,
    get: function() {
      return r.OrderPart;
    }
  }), Object.defineProperty(t, "Product", {
    enumerable: !0,
    get: function() {
      return r.Product;
    }
  }), Object.defineProperty(t, "Response", {
    enumerable: !0,
    get: function() {
      return r.Response;
    }
  }), Object.defineProperty(t, "Stock", {
    enumerable: !0,
    get: function() {
      return r.Stock;
    }
  }), Object.defineProperty(t, "User", {
    enumerable: !0,
    get: function() {
      return r.User;
    }
  }), Object.defineProperty(t, "api", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "client", {
    enumerable: !0,
    get: function() {
      return o.client;
    }
  }), Object.defineProperty(t, "events", {
    enumerable: !0,
    get: function() {
      return r.events;
    }
  }), Object.defineProperty(t, "fetchProducts", {
    enumerable: !0,
    get: function() {
      return c.fetchProducts;
    }
  }), Object.defineProperty(t, "fetchProductsGroupedBy", {
    enumerable: !0,
    get: function() {
      return c.fetchProductsGroupedBy;
    }
  }), Object.defineProperty(t, "fetchProductsGroupedByParent", {
    enumerable: !0,
    get: function() {
      return c.fetchProductsGroupedByParent;
    }
  }), Object.defineProperty(t, "fetchProductsStock", {
    enumerable: !0,
    get: function() {
      return c.fetchProductsStock;
    }
  }), Object.defineProperty(t, "fetchProductsStockAtFacility", {
    enumerable: !0,
    get: function() {
      return c.fetchProductsStockAtFacility;
    }
  }), Object.defineProperty(t, "getConfig", {
    enumerable: !0,
    get: function() {
      return o.getConfig;
    }
  }), Object.defineProperty(t, "getOrderDetails", {
    enumerable: !0,
    get: function() {
      return c.getOrderDetails;
    }
  }), Object.defineProperty(t, "getProductIdentificationPref", {
    enumerable: !0,
    get: function() {
      return c.getProductIdentificationPref;
    }
  }), Object.defineProperty(t, "getProfile", {
    enumerable: !0,
    get: function() {
      return c.getProfile;
    }
  }), Object.defineProperty(t, "hasError", {
    enumerable: !0,
    get: function() {
      return a.hasError;
    }
  }), Object.defineProperty(t, "init", {
    enumerable: !0,
    get: function() {
      return o.init;
    }
  }), Object.defineProperty(t, "initialise", {
    enumerable: !0,
    get: function() {
      return o.initialise;
    }
  }), Object.defineProperty(t, "isError", {
    enumerable: !0,
    get: function() {
      return a.isError;
    }
  }), Object.defineProperty(t, "logout", {
    enumerable: !0,
    get: function() {
      return c.logout;
    }
  }), Object.defineProperty(t, "resetConfig", {
    enumerable: !0,
    get: function() {
      return o.resetConfig;
    }
  }), Object.defineProperty(t, "setProductIdentificationPref", {
    enumerable: !0,
    get: function() {
      return c.setProductIdentificationPref;
    }
  }), Object.defineProperty(t, "updateInstanceUrl", {
    enumerable: !0,
    get: function() {
      return o.updateInstanceUrl;
    }
  }), Object.defineProperty(t, "updateOrderStatus", {
    enumerable: !0,
    get: function() {
      return c.updateOrderStatus;
    }
  }), Object.defineProperty(t, "updateToken", {
    enumerable: !0,
    get: function() {
      return o.updateToken;
    }
  });
  var r = types, o = d(api), a = util, c = modules;
  function u(p) {
    if (typeof WeakMap != "function")
      return null;
    var g = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (u = function(w) {
      return w ? b : g;
    })(p);
  }
  function d(p, g) {
    if (!g && p && p.__esModule)
      return p;
    if (p === null || e(p) !== "object" && typeof p != "function")
      return { default: p };
    var b = u(g);
    if (b && b.has(p))
      return b.get(p);
    var x = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in p)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(p, y)) {
        var I = w ? Object.getOwnPropertyDescriptor(p, y) : null;
        I && (I.get || I.set) ? Object.defineProperty(x, y, I) : x[y] = p[y];
      }
    return x.default = p, b && b.set(p, x), x;
  }
})(lib$2);
var utils$1 = {};
const Aacute = "Á", aacute = "á", Abreve = "Ă", abreve = "ă", ac = "∾", acd = "∿", acE = "∾̳", Acirc = "Â", acirc = "â", acute = "´", Acy = "А", acy = "а", AElig = "Æ", aelig = "æ", af = "⁡", Afr = "𝔄", afr = "𝔞", Agrave = "À", agrave = "à", alefsym = "ℵ", aleph = "ℵ", Alpha = "Α", alpha = "α", Amacr = "Ā", amacr = "ā", amalg = "⨿", amp = "&", AMP = "&", andand = "⩕", And = "⩓", and = "∧", andd = "⩜", andslope = "⩘", andv = "⩚", ang = "∠", ange = "⦤", angle = "∠", angmsdaa = "⦨", angmsdab = "⦩", angmsdac = "⦪", angmsdad = "⦫", angmsdae = "⦬", angmsdaf = "⦭", angmsdag = "⦮", angmsdah = "⦯", angmsd = "∡", angrt = "∟", angrtvb = "⊾", angrtvbd = "⦝", angsph = "∢", angst = "Å", angzarr = "⍼", Aogon = "Ą", aogon = "ą", Aopf = "𝔸", aopf = "𝕒", apacir = "⩯", ap = "≈", apE = "⩰", ape = "≊", apid = "≋", apos = "'", ApplyFunction = "⁡", approx = "≈", approxeq = "≊", Aring = "Å", aring = "å", Ascr = "𝒜", ascr = "𝒶", Assign = "≔", ast = "*", asymp = "≈", asympeq = "≍", Atilde = "Ã", atilde = "ã", Auml = "Ä", auml = "ä", awconint = "∳", awint = "⨑", backcong = "≌", backepsilon = "϶", backprime = "‵", backsim = "∽", backsimeq = "⋍", Backslash = "∖", Barv = "⫧", barvee = "⊽", barwed = "⌅", Barwed = "⌆", barwedge = "⌅", bbrk = "⎵", bbrktbrk = "⎶", bcong = "≌", Bcy = "Б", bcy = "б", bdquo = "„", becaus = "∵", because = "∵", Because = "∵", bemptyv = "⦰", bepsi = "϶", bernou = "ℬ", Bernoullis = "ℬ", Beta = "Β", beta = "β", beth = "ℶ", between = "≬", Bfr = "𝔅", bfr = "𝔟", bigcap = "⋂", bigcirc = "◯", bigcup = "⋃", bigodot = "⨀", bigoplus = "⨁", bigotimes = "⨂", bigsqcup = "⨆", bigstar = "★", bigtriangledown = "▽", bigtriangleup = "△", biguplus = "⨄", bigvee = "⋁", bigwedge = "⋀", bkarow = "⤍", blacklozenge = "⧫", blacksquare = "▪", blacktriangle = "▴", blacktriangledown = "▾", blacktriangleleft = "◂", blacktriangleright = "▸", blank = "␣", blk12 = "▒", blk14 = "░", blk34 = "▓", block$1 = "█", bne = "=⃥", bnequiv = "≡⃥", bNot = "⫭", bnot = "⌐", Bopf = "𝔹", bopf = "𝕓", bot = "⊥", bottom = "⊥", bowtie = "⋈", boxbox = "⧉", boxdl = "┐", boxdL = "╕", boxDl = "╖", boxDL = "╗", boxdr = "┌", boxdR = "╒", boxDr = "╓", boxDR = "╔", boxh = "─", boxH = "═", boxhd = "┬", boxHd = "╤", boxhD = "╥", boxHD = "╦", boxhu = "┴", boxHu = "╧", boxhU = "╨", boxHU = "╩", boxminus = "⊟", boxplus = "⊞", boxtimes = "⊠", boxul = "┘", boxuL = "╛", boxUl = "╜", boxUL = "╝", boxur = "└", boxuR = "╘", boxUr = "╙", boxUR = "╚", boxv = "│", boxV = "║", boxvh = "┼", boxvH = "╪", boxVh = "╫", boxVH = "╬", boxvl = "┤", boxvL = "╡", boxVl = "╢", boxVL = "╣", boxvr = "├", boxvR = "╞", boxVr = "╟", boxVR = "╠", bprime = "‵", breve = "˘", Breve = "˘", brvbar = "¦", bscr = "𝒷", Bscr = "ℬ", bsemi = "⁏", bsim = "∽", bsime = "⋍", bsolb = "⧅", bsol = "\\", bsolhsub = "⟈", bull = "•", bullet = "•", bump = "≎", bumpE = "⪮", bumpe = "≏", Bumpeq = "≎", bumpeq = "≏", Cacute = "Ć", cacute = "ć", capand = "⩄", capbrcup = "⩉", capcap = "⩋", cap = "∩", Cap = "⋒", capcup = "⩇", capdot = "⩀", CapitalDifferentialD = "ⅅ", caps = "∩︀", caret = "⁁", caron = "ˇ", Cayleys = "ℭ", ccaps = "⩍", Ccaron = "Č", ccaron = "č", Ccedil = "Ç", ccedil = "ç", Ccirc = "Ĉ", ccirc = "ĉ", Cconint = "∰", ccups = "⩌", ccupssm = "⩐", Cdot = "Ċ", cdot = "ċ", cedil = "¸", Cedilla = "¸", cemptyv = "⦲", cent = "¢", centerdot = "·", CenterDot = "·", cfr = "𝔠", Cfr = "ℭ", CHcy = "Ч", chcy = "ч", check = "✓", checkmark = "✓", Chi = "Χ", chi = "χ", circ = "ˆ", circeq = "≗", circlearrowleft = "↺", circlearrowright = "↻", circledast = "⊛", circledcirc = "⊚", circleddash = "⊝", CircleDot = "⊙", circledR = "®", circledS = "Ⓢ", CircleMinus = "⊖", CirclePlus = "⊕", CircleTimes = "⊗", cir = "○", cirE = "⧃", cire = "≗", cirfnint = "⨐", cirmid = "⫯", cirscir = "⧂", ClockwiseContourIntegral = "∲", CloseCurlyDoubleQuote = "”", CloseCurlyQuote = "’", clubs = "♣", clubsuit = "♣", colon = ":", Colon = "∷", Colone = "⩴", colone = "≔", coloneq = "≔", comma = ",", commat = "@", comp = "∁", compfn = "∘", complement = "∁", complexes = "ℂ", cong = "≅", congdot = "⩭", Congruent = "≡", conint = "∮", Conint = "∯", ContourIntegral = "∮", copf = "𝕔", Copf = "ℂ", coprod = "∐", Coproduct = "∐", copy = "©", COPY = "©", copysr = "℗", CounterClockwiseContourIntegral = "∳", crarr = "↵", cross = "✗", Cross = "⨯", Cscr = "𝒞", cscr = "𝒸", csub = "⫏", csube = "⫑", csup = "⫐", csupe = "⫒", ctdot = "⋯", cudarrl = "⤸", cudarrr = "⤵", cuepr = "⋞", cuesc = "⋟", cularr = "↶", cularrp = "⤽", cupbrcap = "⩈", cupcap = "⩆", CupCap = "≍", cup = "∪", Cup = "⋓", cupcup = "⩊", cupdot = "⊍", cupor = "⩅", cups = "∪︀", curarr = "↷", curarrm = "⤼", curlyeqprec = "⋞", curlyeqsucc = "⋟", curlyvee = "⋎", curlywedge = "⋏", curren = "¤", curvearrowleft = "↶", curvearrowright = "↷", cuvee = "⋎", cuwed = "⋏", cwconint = "∲", cwint = "∱", cylcty = "⌭", dagger = "†", Dagger = "‡", daleth = "ℸ", darr = "↓", Darr = "↡", dArr = "⇓", dash = "‐", Dashv = "⫤", dashv = "⊣", dbkarow = "⤏", dblac = "˝", Dcaron = "Ď", dcaron = "ď", Dcy = "Д", dcy = "д", ddagger = "‡", ddarr = "⇊", DD = "ⅅ", dd = "ⅆ", DDotrahd = "⤑", ddotseq = "⩷", deg = "°", Del = "∇", Delta = "Δ", delta = "δ", demptyv = "⦱", dfisht = "⥿", Dfr = "𝔇", dfr = "𝔡", dHar = "⥥", dharl = "⇃", dharr = "⇂", DiacriticalAcute = "´", DiacriticalDot = "˙", DiacriticalDoubleAcute = "˝", DiacriticalGrave = "`", DiacriticalTilde = "˜", diam = "⋄", diamond = "⋄", Diamond = "⋄", diamondsuit = "♦", diams = "♦", die = "¨", DifferentialD = "ⅆ", digamma = "ϝ", disin = "⋲", div = "÷", divide = "÷", divideontimes = "⋇", divonx = "⋇", DJcy = "Ђ", djcy = "ђ", dlcorn = "⌞", dlcrop = "⌍", dollar = "$", Dopf = "𝔻", dopf = "𝕕", Dot = "¨", dot = "˙", DotDot = "⃜", doteq = "≐", doteqdot = "≑", DotEqual = "≐", dotminus = "∸", dotplus = "∔", dotsquare = "⊡", doublebarwedge = "⌆", DoubleContourIntegral = "∯", DoubleDot = "¨", DoubleDownArrow = "⇓", DoubleLeftArrow = "⇐", DoubleLeftRightArrow = "⇔", DoubleLeftTee = "⫤", DoubleLongLeftArrow = "⟸", DoubleLongLeftRightArrow = "⟺", DoubleLongRightArrow = "⟹", DoubleRightArrow = "⇒", DoubleRightTee = "⊨", DoubleUpArrow = "⇑", DoubleUpDownArrow = "⇕", DoubleVerticalBar = "∥", DownArrowBar = "⤓", downarrow = "↓", DownArrow = "↓", Downarrow = "⇓", DownArrowUpArrow = "⇵", DownBreve = "̑", downdownarrows = "⇊", downharpoonleft = "⇃", downharpoonright = "⇂", DownLeftRightVector = "⥐", DownLeftTeeVector = "⥞", DownLeftVectorBar = "⥖", DownLeftVector = "↽", DownRightTeeVector = "⥟", DownRightVectorBar = "⥗", DownRightVector = "⇁", DownTeeArrow = "↧", DownTee = "⊤", drbkarow = "⤐", drcorn = "⌟", drcrop = "⌌", Dscr = "𝒟", dscr = "𝒹", DScy = "Ѕ", dscy = "ѕ", dsol = "⧶", Dstrok = "Đ", dstrok = "đ", dtdot = "⋱", dtri = "▿", dtrif = "▾", duarr = "⇵", duhar = "⥯", dwangle = "⦦", DZcy = "Џ", dzcy = "џ", dzigrarr = "⟿", Eacute = "É", eacute = "é", easter = "⩮", Ecaron = "Ě", ecaron = "ě", Ecirc = "Ê", ecirc = "ê", ecir = "≖", ecolon = "≕", Ecy = "Э", ecy = "э", eDDot = "⩷", Edot = "Ė", edot = "ė", eDot = "≑", ee = "ⅇ", efDot = "≒", Efr = "𝔈", efr = "𝔢", eg = "⪚", Egrave = "È", egrave = "è", egs = "⪖", egsdot = "⪘", el = "⪙", Element$1 = "∈", elinters = "⏧", ell = "ℓ", els = "⪕", elsdot = "⪗", Emacr = "Ē", emacr = "ē", empty = "∅", emptyset = "∅", EmptySmallSquare = "◻", emptyv = "∅", EmptyVerySmallSquare = "▫", emsp13 = " ", emsp14 = " ", emsp = " ", ENG = "Ŋ", eng = "ŋ", ensp = " ", Eogon = "Ę", eogon = "ę", Eopf = "𝔼", eopf = "𝕖", epar = "⋕", eparsl = "⧣", eplus = "⩱", epsi = "ε", Epsilon = "Ε", epsilon = "ε", epsiv = "ϵ", eqcirc = "≖", eqcolon = "≕", eqsim = "≂", eqslantgtr = "⪖", eqslantless = "⪕", Equal = "⩵", equals = "=", EqualTilde = "≂", equest = "≟", Equilibrium = "⇌", equiv = "≡", equivDD = "⩸", eqvparsl = "⧥", erarr = "⥱", erDot = "≓", escr = "ℯ", Escr = "ℰ", esdot = "≐", Esim = "⩳", esim = "≂", Eta = "Η", eta = "η", ETH = "Ð", eth = "ð", Euml = "Ë", euml = "ë", euro = "€", excl = "!", exist = "∃", Exists = "∃", expectation = "ℰ", exponentiale = "ⅇ", ExponentialE = "ⅇ", fallingdotseq = "≒", Fcy = "Ф", fcy = "ф", female = "♀", ffilig = "ﬃ", fflig = "ﬀ", ffllig = "ﬄ", Ffr = "𝔉", ffr = "𝔣", filig = "ﬁ", FilledSmallSquare = "◼", FilledVerySmallSquare = "▪", fjlig = "fj", flat = "♭", fllig = "ﬂ", fltns = "▱", fnof = "ƒ", Fopf = "𝔽", fopf = "𝕗", forall = "∀", ForAll = "∀", fork = "⋔", forkv = "⫙", Fouriertrf = "ℱ", fpartint = "⨍", frac12 = "½", frac13 = "⅓", frac14 = "¼", frac15 = "⅕", frac16 = "⅙", frac18 = "⅛", frac23 = "⅔", frac25 = "⅖", frac34 = "¾", frac35 = "⅗", frac38 = "⅜", frac45 = "⅘", frac56 = "⅚", frac58 = "⅝", frac78 = "⅞", frasl = "⁄", frown = "⌢", fscr = "𝒻", Fscr = "ℱ", gacute = "ǵ", Gamma = "Γ", gamma = "γ", Gammad = "Ϝ", gammad = "ϝ", gap = "⪆", Gbreve = "Ğ", gbreve = "ğ", Gcedil = "Ģ", Gcirc = "Ĝ", gcirc = "ĝ", Gcy = "Г", gcy = "г", Gdot = "Ġ", gdot = "ġ", ge = "≥", gE = "≧", gEl = "⪌", gel = "⋛", geq = "≥", geqq = "≧", geqslant = "⩾", gescc = "⪩", ges = "⩾", gesdot = "⪀", gesdoto = "⪂", gesdotol = "⪄", gesl = "⋛︀", gesles = "⪔", Gfr = "𝔊", gfr = "𝔤", gg = "≫", Gg = "⋙", ggg = "⋙", gimel = "ℷ", GJcy = "Ѓ", gjcy = "ѓ", gla = "⪥", gl = "≷", glE = "⪒", glj = "⪤", gnap = "⪊", gnapprox = "⪊", gne = "⪈", gnE = "≩", gneq = "⪈", gneqq = "≩", gnsim = "⋧", Gopf = "𝔾", gopf = "𝕘", grave = "`", GreaterEqual = "≥", GreaterEqualLess = "⋛", GreaterFullEqual = "≧", GreaterGreater = "⪢", GreaterLess = "≷", GreaterSlantEqual = "⩾", GreaterTilde = "≳", Gscr = "𝒢", gscr = "ℊ", gsim = "≳", gsime = "⪎", gsiml = "⪐", gtcc = "⪧", gtcir = "⩺", gt = ">", GT = ">", Gt = "≫", gtdot = "⋗", gtlPar = "⦕", gtquest = "⩼", gtrapprox = "⪆", gtrarr = "⥸", gtrdot = "⋗", gtreqless = "⋛", gtreqqless = "⪌", gtrless = "≷", gtrsim = "≳", gvertneqq = "≩︀", gvnE = "≩︀", Hacek = "ˇ", hairsp = " ", half = "½", hamilt = "ℋ", HARDcy = "Ъ", hardcy = "ъ", harrcir = "⥈", harr = "↔", hArr = "⇔", harrw = "↭", Hat = "^", hbar = "ℏ", Hcirc = "Ĥ", hcirc = "ĥ", hearts = "♥", heartsuit = "♥", hellip = "…", hercon = "⊹", hfr = "𝔥", Hfr = "ℌ", HilbertSpace = "ℋ", hksearow = "⤥", hkswarow = "⤦", hoarr = "⇿", homtht = "∻", hookleftarrow = "↩", hookrightarrow = "↪", hopf = "𝕙", Hopf = "ℍ", horbar = "―", HorizontalLine = "─", hscr = "𝒽", Hscr = "ℋ", hslash = "ℏ", Hstrok = "Ħ", hstrok = "ħ", HumpDownHump = "≎", HumpEqual = "≏", hybull = "⁃", hyphen = "‐", Iacute = "Í", iacute = "í", ic = "⁣", Icirc = "Î", icirc = "î", Icy = "И", icy = "и", Idot = "İ", IEcy = "Е", iecy = "е", iexcl = "¡", iff = "⇔", ifr = "𝔦", Ifr = "ℑ", Igrave = "Ì", igrave = "ì", ii = "ⅈ", iiiint = "⨌", iiint = "∭", iinfin = "⧜", iiota = "℩", IJlig = "Ĳ", ijlig = "ĳ", Imacr = "Ī", imacr = "ī", image$1 = "ℑ", ImaginaryI = "ⅈ", imagline = "ℐ", imagpart = "ℑ", imath = "ı", Im = "ℑ", imof = "⊷", imped = "Ƶ", Implies = "⇒", incare = "℅", infin = "∞", infintie = "⧝", inodot = "ı", intcal = "⊺", int = "∫", Int = "∬", integers = "ℤ", Integral = "∫", intercal = "⊺", Intersection = "⋂", intlarhk = "⨗", intprod = "⨼", InvisibleComma = "⁣", InvisibleTimes = "⁢", IOcy = "Ё", iocy = "ё", Iogon = "Į", iogon = "į", Iopf = "𝕀", iopf = "𝕚", Iota = "Ι", iota = "ι", iprod = "⨼", iquest = "¿", iscr = "𝒾", Iscr = "ℐ", isin = "∈", isindot = "⋵", isinE = "⋹", isins = "⋴", isinsv = "⋳", isinv = "∈", it = "⁢", Itilde = "Ĩ", itilde = "ĩ", Iukcy = "І", iukcy = "і", Iuml = "Ï", iuml = "ï", Jcirc = "Ĵ", jcirc = "ĵ", Jcy = "Й", jcy = "й", Jfr = "𝔍", jfr = "𝔧", jmath = "ȷ", Jopf = "𝕁", jopf = "𝕛", Jscr = "𝒥", jscr = "𝒿", Jsercy = "Ј", jsercy = "ј", Jukcy = "Є", jukcy = "є", Kappa = "Κ", kappa = "κ", kappav = "ϰ", Kcedil = "Ķ", kcedil = "ķ", Kcy = "К", kcy = "к", Kfr = "𝔎", kfr = "𝔨", kgreen = "ĸ", KHcy = "Х", khcy = "х", KJcy = "Ќ", kjcy = "ќ", Kopf = "𝕂", kopf = "𝕜", Kscr = "𝒦", kscr = "𝓀", lAarr = "⇚", Lacute = "Ĺ", lacute = "ĺ", laemptyv = "⦴", lagran = "ℒ", Lambda = "Λ", lambda = "λ", lang = "⟨", Lang = "⟪", langd = "⦑", langle = "⟨", lap = "⪅", Laplacetrf = "ℒ", laquo = "«", larrb = "⇤", larrbfs = "⤟", larr = "←", Larr = "↞", lArr = "⇐", larrfs = "⤝", larrhk = "↩", larrlp = "↫", larrpl = "⤹", larrsim = "⥳", larrtl = "↢", latail = "⤙", lAtail = "⤛", lat = "⪫", late = "⪭", lates = "⪭︀", lbarr = "⤌", lBarr = "⤎", lbbrk = "❲", lbrace = "{", lbrack = "[", lbrke = "⦋", lbrksld = "⦏", lbrkslu = "⦍", Lcaron = "Ľ", lcaron = "ľ", Lcedil = "Ļ", lcedil = "ļ", lceil = "⌈", lcub = "{", Lcy = "Л", lcy = "л", ldca = "⤶", ldquo = "“", ldquor = "„", ldrdhar = "⥧", ldrushar = "⥋", ldsh = "↲", le = "≤", lE = "≦", LeftAngleBracket = "⟨", LeftArrowBar = "⇤", leftarrow = "←", LeftArrow = "←", Leftarrow = "⇐", LeftArrowRightArrow = "⇆", leftarrowtail = "↢", LeftCeiling = "⌈", LeftDoubleBracket = "⟦", LeftDownTeeVector = "⥡", LeftDownVectorBar = "⥙", LeftDownVector = "⇃", LeftFloor = "⌊", leftharpoondown = "↽", leftharpoonup = "↼", leftleftarrows = "⇇", leftrightarrow = "↔", LeftRightArrow = "↔", Leftrightarrow = "⇔", leftrightarrows = "⇆", leftrightharpoons = "⇋", leftrightsquigarrow = "↭", LeftRightVector = "⥎", LeftTeeArrow = "↤", LeftTee = "⊣", LeftTeeVector = "⥚", leftthreetimes = "⋋", LeftTriangleBar = "⧏", LeftTriangle = "⊲", LeftTriangleEqual = "⊴", LeftUpDownVector = "⥑", LeftUpTeeVector = "⥠", LeftUpVectorBar = "⥘", LeftUpVector = "↿", LeftVectorBar = "⥒", LeftVector = "↼", lEg = "⪋", leg = "⋚", leq = "≤", leqq = "≦", leqslant = "⩽", lescc = "⪨", les = "⩽", lesdot = "⩿", lesdoto = "⪁", lesdotor = "⪃", lesg = "⋚︀", lesges = "⪓", lessapprox = "⪅", lessdot = "⋖", lesseqgtr = "⋚", lesseqqgtr = "⪋", LessEqualGreater = "⋚", LessFullEqual = "≦", LessGreater = "≶", lessgtr = "≶", LessLess = "⪡", lesssim = "≲", LessSlantEqual = "⩽", LessTilde = "≲", lfisht = "⥼", lfloor = "⌊", Lfr = "𝔏", lfr = "𝔩", lg = "≶", lgE = "⪑", lHar = "⥢", lhard = "↽", lharu = "↼", lharul = "⥪", lhblk = "▄", LJcy = "Љ", ljcy = "љ", llarr = "⇇", ll = "≪", Ll = "⋘", llcorner = "⌞", Lleftarrow = "⇚", llhard = "⥫", lltri = "◺", Lmidot = "Ŀ", lmidot = "ŀ", lmoustache = "⎰", lmoust = "⎰", lnap = "⪉", lnapprox = "⪉", lne = "⪇", lnE = "≨", lneq = "⪇", lneqq = "≨", lnsim = "⋦", loang = "⟬", loarr = "⇽", lobrk = "⟦", longleftarrow = "⟵", LongLeftArrow = "⟵", Longleftarrow = "⟸", longleftrightarrow = "⟷", LongLeftRightArrow = "⟷", Longleftrightarrow = "⟺", longmapsto = "⟼", longrightarrow = "⟶", LongRightArrow = "⟶", Longrightarrow = "⟹", looparrowleft = "↫", looparrowright = "↬", lopar = "⦅", Lopf = "𝕃", lopf = "𝕝", loplus = "⨭", lotimes = "⨴", lowast = "∗", lowbar = "_", LowerLeftArrow = "↙", LowerRightArrow = "↘", loz = "◊", lozenge = "◊", lozf = "⧫", lpar = "(", lparlt = "⦓", lrarr = "⇆", lrcorner = "⌟", lrhar = "⇋", lrhard = "⥭", lrm = "‎", lrtri = "⊿", lsaquo = "‹", lscr = "𝓁", Lscr = "ℒ", lsh = "↰", Lsh = "↰", lsim = "≲", lsime = "⪍", lsimg = "⪏", lsqb = "[", lsquo = "‘", lsquor = "‚", Lstrok = "Ł", lstrok = "ł", ltcc = "⪦", ltcir = "⩹", lt = "<", LT = "<", Lt = "≪", ltdot = "⋖", lthree = "⋋", ltimes = "⋉", ltlarr = "⥶", ltquest = "⩻", ltri = "◃", ltrie = "⊴", ltrif = "◂", ltrPar = "⦖", lurdshar = "⥊", luruhar = "⥦", lvertneqq = "≨︀", lvnE = "≨︀", macr = "¯", male = "♂", malt = "✠", maltese = "✠", map$1 = "↦", mapsto = "↦", mapstodown = "↧", mapstoleft = "↤", mapstoup = "↥", marker = "▮", mcomma = "⨩", Mcy = "М", mcy = "м", mdash = "—", mDDot = "∺", measuredangle = "∡", MediumSpace = " ", Mellintrf = "ℳ", Mfr = "𝔐", mfr = "𝔪", mho = "℧", micro = "µ", midast = "*", midcir = "⫰", mid = "∣", middot = "·", minusb = "⊟", minus = "−", minusd = "∸", minusdu = "⨪", MinusPlus = "∓", mlcp = "⫛", mldr = "…", mnplus = "∓", models = "⊧", Mopf = "𝕄", mopf = "𝕞", mp = "∓", mscr = "𝓂", Mscr = "ℳ", mstpos = "∾", Mu = "Μ", mu = "μ", multimap = "⊸", mumap = "⊸", nabla = "∇", Nacute = "Ń", nacute = "ń", nang = "∠⃒", nap = "≉", napE = "⩰̸", napid = "≋̸", napos = "ŉ", napprox = "≉", natural = "♮", naturals = "ℕ", natur = "♮", nbsp = " ", nbump = "≎̸", nbumpe = "≏̸", ncap = "⩃", Ncaron = "Ň", ncaron = "ň", Ncedil = "Ņ", ncedil = "ņ", ncong = "≇", ncongdot = "⩭̸", ncup = "⩂", Ncy = "Н", ncy = "н", ndash = "–", nearhk = "⤤", nearr = "↗", neArr = "⇗", nearrow = "↗", ne = "≠", nedot = "≐̸", NegativeMediumSpace = "​", NegativeThickSpace = "​", NegativeThinSpace = "​", NegativeVeryThinSpace = "​", nequiv = "≢", nesear = "⤨", nesim = "≂̸", NestedGreaterGreater = "≫", NestedLessLess = "≪", NewLine = `
`, nexist = "∄", nexists = "∄", Nfr = "𝔑", nfr = "𝔫", ngE = "≧̸", nge = "≱", ngeq = "≱", ngeqq = "≧̸", ngeqslant = "⩾̸", nges = "⩾̸", nGg = "⋙̸", ngsim = "≵", nGt = "≫⃒", ngt = "≯", ngtr = "≯", nGtv = "≫̸", nharr = "↮", nhArr = "⇎", nhpar = "⫲", ni = "∋", nis = "⋼", nisd = "⋺", niv = "∋", NJcy = "Њ", njcy = "њ", nlarr = "↚", nlArr = "⇍", nldr = "‥", nlE = "≦̸", nle = "≰", nleftarrow = "↚", nLeftarrow = "⇍", nleftrightarrow = "↮", nLeftrightarrow = "⇎", nleq = "≰", nleqq = "≦̸", nleqslant = "⩽̸", nles = "⩽̸", nless = "≮", nLl = "⋘̸", nlsim = "≴", nLt = "≪⃒", nlt = "≮", nltri = "⋪", nltrie = "⋬", nLtv = "≪̸", nmid = "∤", NoBreak = "⁠", NonBreakingSpace = " ", nopf = "𝕟", Nopf = "ℕ", Not = "⫬", not = "¬", NotCongruent = "≢", NotCupCap = "≭", NotDoubleVerticalBar = "∦", NotElement = "∉", NotEqual = "≠", NotEqualTilde = "≂̸", NotExists = "∄", NotGreater = "≯", NotGreaterEqual = "≱", NotGreaterFullEqual = "≧̸", NotGreaterGreater = "≫̸", NotGreaterLess = "≹", NotGreaterSlantEqual = "⩾̸", NotGreaterTilde = "≵", NotHumpDownHump = "≎̸", NotHumpEqual = "≏̸", notin = "∉", notindot = "⋵̸", notinE = "⋹̸", notinva = "∉", notinvb = "⋷", notinvc = "⋶", NotLeftTriangleBar = "⧏̸", NotLeftTriangle = "⋪", NotLeftTriangleEqual = "⋬", NotLess = "≮", NotLessEqual = "≰", NotLessGreater = "≸", NotLessLess = "≪̸", NotLessSlantEqual = "⩽̸", NotLessTilde = "≴", NotNestedGreaterGreater = "⪢̸", NotNestedLessLess = "⪡̸", notni = "∌", notniva = "∌", notnivb = "⋾", notnivc = "⋽", NotPrecedes = "⊀", NotPrecedesEqual = "⪯̸", NotPrecedesSlantEqual = "⋠", NotReverseElement = "∌", NotRightTriangleBar = "⧐̸", NotRightTriangle = "⋫", NotRightTriangleEqual = "⋭", NotSquareSubset = "⊏̸", NotSquareSubsetEqual = "⋢", NotSquareSuperset = "⊐̸", NotSquareSupersetEqual = "⋣", NotSubset = "⊂⃒", NotSubsetEqual = "⊈", NotSucceeds = "⊁", NotSucceedsEqual = "⪰̸", NotSucceedsSlantEqual = "⋡", NotSucceedsTilde = "≿̸", NotSuperset = "⊃⃒", NotSupersetEqual = "⊉", NotTilde = "≁", NotTildeEqual = "≄", NotTildeFullEqual = "≇", NotTildeTilde = "≉", NotVerticalBar = "∤", nparallel = "∦", npar = "∦", nparsl = "⫽⃥", npart = "∂̸", npolint = "⨔", npr = "⊀", nprcue = "⋠", nprec = "⊀", npreceq = "⪯̸", npre = "⪯̸", nrarrc = "⤳̸", nrarr = "↛", nrArr = "⇏", nrarrw = "↝̸", nrightarrow = "↛", nRightarrow = "⇏", nrtri = "⋫", nrtrie = "⋭", nsc = "⊁", nsccue = "⋡", nsce = "⪰̸", Nscr = "𝒩", nscr = "𝓃", nshortmid = "∤", nshortparallel = "∦", nsim = "≁", nsime = "≄", nsimeq = "≄", nsmid = "∤", nspar = "∦", nsqsube = "⋢", nsqsupe = "⋣", nsub = "⊄", nsubE = "⫅̸", nsube = "⊈", nsubset = "⊂⃒", nsubseteq = "⊈", nsubseteqq = "⫅̸", nsucc = "⊁", nsucceq = "⪰̸", nsup = "⊅", nsupE = "⫆̸", nsupe = "⊉", nsupset = "⊃⃒", nsupseteq = "⊉", nsupseteqq = "⫆̸", ntgl = "≹", Ntilde = "Ñ", ntilde = "ñ", ntlg = "≸", ntriangleleft = "⋪", ntrianglelefteq = "⋬", ntriangleright = "⋫", ntrianglerighteq = "⋭", Nu = "Ν", nu = "ν", num = "#", numero = "№", numsp = " ", nvap = "≍⃒", nvdash = "⊬", nvDash = "⊭", nVdash = "⊮", nVDash = "⊯", nvge = "≥⃒", nvgt = ">⃒", nvHarr = "⤄", nvinfin = "⧞", nvlArr = "⤂", nvle = "≤⃒", nvlt = "<⃒", nvltrie = "⊴⃒", nvrArr = "⤃", nvrtrie = "⊵⃒", nvsim = "∼⃒", nwarhk = "⤣", nwarr = "↖", nwArr = "⇖", nwarrow = "↖", nwnear = "⤧", Oacute = "Ó", oacute = "ó", oast = "⊛", Ocirc = "Ô", ocirc = "ô", ocir = "⊚", Ocy = "О", ocy = "о", odash = "⊝", Odblac = "Ő", odblac = "ő", odiv = "⨸", odot = "⊙", odsold = "⦼", OElig = "Œ", oelig = "œ", ofcir = "⦿", Ofr = "𝔒", ofr = "𝔬", ogon = "˛", Ograve = "Ò", ograve = "ò", ogt = "⧁", ohbar = "⦵", ohm = "Ω", oint = "∮", olarr = "↺", olcir = "⦾", olcross = "⦻", oline = "‾", olt = "⧀", Omacr = "Ō", omacr = "ō", Omega = "Ω", omega = "ω", Omicron = "Ο", omicron = "ο", omid = "⦶", ominus = "⊖", Oopf = "𝕆", oopf = "𝕠", opar = "⦷", OpenCurlyDoubleQuote = "“", OpenCurlyQuote = "‘", operp = "⦹", oplus = "⊕", orarr = "↻", Or = "⩔", or = "∨", ord = "⩝", order = "ℴ", orderof = "ℴ", ordf = "ª", ordm = "º", origof = "⊶", oror = "⩖", orslope = "⩗", orv = "⩛", oS = "Ⓢ", Oscr = "𝒪", oscr = "ℴ", Oslash = "Ø", oslash = "ø", osol = "⊘", Otilde = "Õ", otilde = "õ", otimesas = "⨶", Otimes = "⨷", otimes = "⊗", Ouml = "Ö", ouml = "ö", ovbar = "⌽", OverBar = "‾", OverBrace = "⏞", OverBracket = "⎴", OverParenthesis = "⏜", para = "¶", parallel = "∥", par = "∥", parsim = "⫳", parsl = "⫽", part = "∂", PartialD = "∂", Pcy = "П", pcy = "п", percnt = "%", period = ".", permil = "‰", perp = "⊥", pertenk = "‱", Pfr = "𝔓", pfr = "𝔭", Phi = "Φ", phi = "φ", phiv = "ϕ", phmmat = "ℳ", phone = "☎", Pi = "Π", pi = "π", pitchfork = "⋔", piv = "ϖ", planck = "ℏ", planckh = "ℎ", plankv = "ℏ", plusacir = "⨣", plusb = "⊞", pluscir = "⨢", plus = "+", plusdo = "∔", plusdu = "⨥", pluse = "⩲", PlusMinus = "±", plusmn = "±", plussim = "⨦", plustwo = "⨧", pm = "±", Poincareplane = "ℌ", pointint = "⨕", popf = "𝕡", Popf = "ℙ", pound = "£", prap = "⪷", Pr = "⪻", pr = "≺", prcue = "≼", precapprox = "⪷", prec = "≺", preccurlyeq = "≼", Precedes = "≺", PrecedesEqual = "⪯", PrecedesSlantEqual = "≼", PrecedesTilde = "≾", preceq = "⪯", precnapprox = "⪹", precneqq = "⪵", precnsim = "⋨", pre = "⪯", prE = "⪳", precsim = "≾", prime = "′", Prime = "″", primes = "ℙ", prnap = "⪹", prnE = "⪵", prnsim = "⋨", prod = "∏", Product = "∏", profalar = "⌮", profline = "⌒", profsurf = "⌓", prop = "∝", Proportional = "∝", Proportion = "∷", propto = "∝", prsim = "≾", prurel = "⊰", Pscr = "𝒫", pscr = "𝓅", Psi = "Ψ", psi = "ψ", puncsp = " ", Qfr = "𝔔", qfr = "𝔮", qint = "⨌", qopf = "𝕢", Qopf = "ℚ", qprime = "⁗", Qscr = "𝒬", qscr = "𝓆", quaternions = "ℍ", quatint = "⨖", quest = "?", questeq = "≟", quot = '"', QUOT = '"', rAarr = "⇛", race = "∽̱", Racute = "Ŕ", racute = "ŕ", radic = "√", raemptyv = "⦳", rang = "⟩", Rang = "⟫", rangd = "⦒", range = "⦥", rangle = "⟩", raquo = "»", rarrap = "⥵", rarrb = "⇥", rarrbfs = "⤠", rarrc = "⤳", rarr = "→", Rarr = "↠", rArr = "⇒", rarrfs = "⤞", rarrhk = "↪", rarrlp = "↬", rarrpl = "⥅", rarrsim = "⥴", Rarrtl = "⤖", rarrtl = "↣", rarrw = "↝", ratail = "⤚", rAtail = "⤜", ratio = "∶", rationals = "ℚ", rbarr = "⤍", rBarr = "⤏", RBarr = "⤐", rbbrk = "❳", rbrace = "}", rbrack = "]", rbrke = "⦌", rbrksld = "⦎", rbrkslu = "⦐", Rcaron = "Ř", rcaron = "ř", Rcedil = "Ŗ", rcedil = "ŗ", rceil = "⌉", rcub = "}", Rcy = "Р", rcy = "р", rdca = "⤷", rdldhar = "⥩", rdquo = "”", rdquor = "”", rdsh = "↳", real = "ℜ", realine = "ℛ", realpart = "ℜ", reals = "ℝ", Re = "ℜ", rect = "▭", reg = "®", REG = "®", ReverseElement = "∋", ReverseEquilibrium = "⇋", ReverseUpEquilibrium = "⥯", rfisht = "⥽", rfloor = "⌋", rfr = "𝔯", Rfr = "ℜ", rHar = "⥤", rhard = "⇁", rharu = "⇀", rharul = "⥬", Rho = "Ρ", rho = "ρ", rhov = "ϱ", RightAngleBracket = "⟩", RightArrowBar = "⇥", rightarrow = "→", RightArrow = "→", Rightarrow = "⇒", RightArrowLeftArrow = "⇄", rightarrowtail = "↣", RightCeiling = "⌉", RightDoubleBracket = "⟧", RightDownTeeVector = "⥝", RightDownVectorBar = "⥕", RightDownVector = "⇂", RightFloor = "⌋", rightharpoondown = "⇁", rightharpoonup = "⇀", rightleftarrows = "⇄", rightleftharpoons = "⇌", rightrightarrows = "⇉", rightsquigarrow = "↝", RightTeeArrow = "↦", RightTee = "⊢", RightTeeVector = "⥛", rightthreetimes = "⋌", RightTriangleBar = "⧐", RightTriangle = "⊳", RightTriangleEqual = "⊵", RightUpDownVector = "⥏", RightUpTeeVector = "⥜", RightUpVectorBar = "⥔", RightUpVector = "↾", RightVectorBar = "⥓", RightVector = "⇀", ring = "˚", risingdotseq = "≓", rlarr = "⇄", rlhar = "⇌", rlm = "‏", rmoustache = "⎱", rmoust = "⎱", rnmid = "⫮", roang = "⟭", roarr = "⇾", robrk = "⟧", ropar = "⦆", ropf = "𝕣", Ropf = "ℝ", roplus = "⨮", rotimes = "⨵", RoundImplies = "⥰", rpar = ")", rpargt = "⦔", rppolint = "⨒", rrarr = "⇉", Rrightarrow = "⇛", rsaquo = "›", rscr = "𝓇", Rscr = "ℛ", rsh = "↱", Rsh = "↱", rsqb = "]", rsquo = "’", rsquor = "’", rthree = "⋌", rtimes = "⋊", rtri = "▹", rtrie = "⊵", rtrif = "▸", rtriltri = "⧎", RuleDelayed = "⧴", ruluhar = "⥨", rx = "℞", Sacute = "Ś", sacute = "ś", sbquo = "‚", scap = "⪸", Scaron = "Š", scaron = "š", Sc = "⪼", sc = "≻", sccue = "≽", sce = "⪰", scE = "⪴", Scedil = "Ş", scedil = "ş", Scirc = "Ŝ", scirc = "ŝ", scnap = "⪺", scnE = "⪶", scnsim = "⋩", scpolint = "⨓", scsim = "≿", Scy = "С", scy = "с", sdotb = "⊡", sdot = "⋅", sdote = "⩦", searhk = "⤥", searr = "↘", seArr = "⇘", searrow = "↘", sect = "§", semi = ";", seswar = "⤩", setminus = "∖", setmn = "∖", sext = "✶", Sfr = "𝔖", sfr = "𝔰", sfrown = "⌢", sharp = "♯", SHCHcy = "Щ", shchcy = "щ", SHcy = "Ш", shcy = "ш", ShortDownArrow = "↓", ShortLeftArrow = "←", shortmid = "∣", shortparallel = "∥", ShortRightArrow = "→", ShortUpArrow = "↑", shy = "­", Sigma = "Σ", sigma = "σ", sigmaf = "ς", sigmav = "ς", sim = "∼", simdot = "⩪", sime = "≃", simeq = "≃", simg = "⪞", simgE = "⪠", siml = "⪝", simlE = "⪟", simne = "≆", simplus = "⨤", simrarr = "⥲", slarr = "←", SmallCircle = "∘", smallsetminus = "∖", smashp = "⨳", smeparsl = "⧤", smid = "∣", smile = "⌣", smt = "⪪", smte = "⪬", smtes = "⪬︀", SOFTcy = "Ь", softcy = "ь", solbar = "⌿", solb = "⧄", sol = "/", Sopf = "𝕊", sopf = "𝕤", spades = "♠", spadesuit = "♠", spar = "∥", sqcap = "⊓", sqcaps = "⊓︀", sqcup = "⊔", sqcups = "⊔︀", Sqrt = "√", sqsub = "⊏", sqsube = "⊑", sqsubset = "⊏", sqsubseteq = "⊑", sqsup = "⊐", sqsupe = "⊒", sqsupset = "⊐", sqsupseteq = "⊒", square = "□", Square = "□", SquareIntersection = "⊓", SquareSubset = "⊏", SquareSubsetEqual = "⊑", SquareSuperset = "⊐", SquareSupersetEqual = "⊒", SquareUnion = "⊔", squarf = "▪", squ = "□", squf = "▪", srarr = "→", Sscr = "𝒮", sscr = "𝓈", ssetmn = "∖", ssmile = "⌣", sstarf = "⋆", Star = "⋆", star = "☆", starf = "★", straightepsilon = "ϵ", straightphi = "ϕ", strns = "¯", sub = "⊂", Sub = "⋐", subdot = "⪽", subE = "⫅", sube = "⊆", subedot = "⫃", submult = "⫁", subnE = "⫋", subne = "⊊", subplus = "⪿", subrarr = "⥹", subset = "⊂", Subset = "⋐", subseteq = "⊆", subseteqq = "⫅", SubsetEqual = "⊆", subsetneq = "⊊", subsetneqq = "⫋", subsim = "⫇", subsub = "⫕", subsup = "⫓", succapprox = "⪸", succ = "≻", succcurlyeq = "≽", Succeeds = "≻", SucceedsEqual = "⪰", SucceedsSlantEqual = "≽", SucceedsTilde = "≿", succeq = "⪰", succnapprox = "⪺", succneqq = "⪶", succnsim = "⋩", succsim = "≿", SuchThat = "∋", sum = "∑", Sum = "∑", sung = "♪", sup1 = "¹", sup2 = "²", sup3 = "³", sup = "⊃", Sup = "⋑", supdot = "⪾", supdsub = "⫘", supE = "⫆", supe = "⊇", supedot = "⫄", Superset = "⊃", SupersetEqual = "⊇", suphsol = "⟉", suphsub = "⫗", suplarr = "⥻", supmult = "⫂", supnE = "⫌", supne = "⊋", supplus = "⫀", supset = "⊃", Supset = "⋑", supseteq = "⊇", supseteqq = "⫆", supsetneq = "⊋", supsetneqq = "⫌", supsim = "⫈", supsub = "⫔", supsup = "⫖", swarhk = "⤦", swarr = "↙", swArr = "⇙", swarrow = "↙", swnwar = "⤪", szlig = "ß", Tab = "	", target = "⌖", Tau = "Τ", tau = "τ", tbrk = "⎴", Tcaron = "Ť", tcaron = "ť", Tcedil = "Ţ", tcedil = "ţ", Tcy = "Т", tcy = "т", tdot = "⃛", telrec = "⌕", Tfr = "𝔗", tfr = "𝔱", there4 = "∴", therefore = "∴", Therefore = "∴", Theta = "Θ", theta = "θ", thetasym = "ϑ", thetav = "ϑ", thickapprox = "≈", thicksim = "∼", ThickSpace = "  ", ThinSpace = " ", thinsp = " ", thkap = "≈", thksim = "∼", THORN = "Þ", thorn = "þ", tilde = "˜", Tilde = "∼", TildeEqual = "≃", TildeFullEqual = "≅", TildeTilde = "≈", timesbar = "⨱", timesb = "⊠", times = "×", timesd = "⨰", tint = "∭", toea = "⤨", topbot = "⌶", topcir = "⫱", top = "⊤", Topf = "𝕋", topf = "𝕥", topfork = "⫚", tosa = "⤩", tprime = "‴", trade = "™", TRADE = "™", triangle = "▵", triangledown = "▿", triangleleft = "◃", trianglelefteq = "⊴", triangleq = "≜", triangleright = "▹", trianglerighteq = "⊵", tridot = "◬", trie = "≜", triminus = "⨺", TripleDot = "⃛", triplus = "⨹", trisb = "⧍", tritime = "⨻", trpezium = "⏢", Tscr = "𝒯", tscr = "𝓉", TScy = "Ц", tscy = "ц", TSHcy = "Ћ", tshcy = "ћ", Tstrok = "Ŧ", tstrok = "ŧ", twixt = "≬", twoheadleftarrow = "↞", twoheadrightarrow = "↠", Uacute = "Ú", uacute = "ú", uarr = "↑", Uarr = "↟", uArr = "⇑", Uarrocir = "⥉", Ubrcy = "Ў", ubrcy = "ў", Ubreve = "Ŭ", ubreve = "ŭ", Ucirc = "Û", ucirc = "û", Ucy = "У", ucy = "у", udarr = "⇅", Udblac = "Ű", udblac = "ű", udhar = "⥮", ufisht = "⥾", Ufr = "𝔘", ufr = "𝔲", Ugrave = "Ù", ugrave = "ù", uHar = "⥣", uharl = "↿", uharr = "↾", uhblk = "▀", ulcorn = "⌜", ulcorner = "⌜", ulcrop = "⌏", ultri = "◸", Umacr = "Ū", umacr = "ū", uml = "¨", UnderBar = "_", UnderBrace = "⏟", UnderBracket = "⎵", UnderParenthesis = "⏝", Union = "⋃", UnionPlus = "⊎", Uogon = "Ų", uogon = "ų", Uopf = "𝕌", uopf = "𝕦", UpArrowBar = "⤒", uparrow = "↑", UpArrow = "↑", Uparrow = "⇑", UpArrowDownArrow = "⇅", updownarrow = "↕", UpDownArrow = "↕", Updownarrow = "⇕", UpEquilibrium = "⥮", upharpoonleft = "↿", upharpoonright = "↾", uplus = "⊎", UpperLeftArrow = "↖", UpperRightArrow = "↗", upsi = "υ", Upsi = "ϒ", upsih = "ϒ", Upsilon = "Υ", upsilon = "υ", UpTeeArrow = "↥", UpTee = "⊥", upuparrows = "⇈", urcorn = "⌝", urcorner = "⌝", urcrop = "⌎", Uring = "Ů", uring = "ů", urtri = "◹", Uscr = "𝒰", uscr = "𝓊", utdot = "⋰", Utilde = "Ũ", utilde = "ũ", utri = "▵", utrif = "▴", uuarr = "⇈", Uuml = "Ü", uuml = "ü", uwangle = "⦧", vangrt = "⦜", varepsilon = "ϵ", varkappa = "ϰ", varnothing = "∅", varphi = "ϕ", varpi = "ϖ", varpropto = "∝", varr = "↕", vArr = "⇕", varrho = "ϱ", varsigma = "ς", varsubsetneq = "⊊︀", varsubsetneqq = "⫋︀", varsupsetneq = "⊋︀", varsupsetneqq = "⫌︀", vartheta = "ϑ", vartriangleleft = "⊲", vartriangleright = "⊳", vBar = "⫨", Vbar = "⫫", vBarv = "⫩", Vcy = "В", vcy = "в", vdash = "⊢", vDash = "⊨", Vdash = "⊩", VDash = "⊫", Vdashl = "⫦", veebar = "⊻", vee = "∨", Vee = "⋁", veeeq = "≚", vellip = "⋮", verbar = "|", Verbar = "‖", vert = "|", Vert = "‖", VerticalBar = "∣", VerticalLine = "|", VerticalSeparator = "❘", VerticalTilde = "≀", VeryThinSpace = " ", Vfr = "𝔙", vfr = "𝔳", vltri = "⊲", vnsub = "⊂⃒", vnsup = "⊃⃒", Vopf = "𝕍", vopf = "𝕧", vprop = "∝", vrtri = "⊳", Vscr = "𝒱", vscr = "𝓋", vsubnE = "⫋︀", vsubne = "⊊︀", vsupnE = "⫌︀", vsupne = "⊋︀", Vvdash = "⊪", vzigzag = "⦚", Wcirc = "Ŵ", wcirc = "ŵ", wedbar = "⩟", wedge = "∧", Wedge = "⋀", wedgeq = "≙", weierp = "℘", Wfr = "𝔚", wfr = "𝔴", Wopf = "𝕎", wopf = "𝕨", wp = "℘", wr = "≀", wreath = "≀", Wscr = "𝒲", wscr = "𝓌", xcap = "⋂", xcirc = "◯", xcup = "⋃", xdtri = "▽", Xfr = "𝔛", xfr = "𝔵", xharr = "⟷", xhArr = "⟺", Xi = "Ξ", xi = "ξ", xlarr = "⟵", xlArr = "⟸", xmap = "⟼", xnis = "⋻", xodot = "⨀", Xopf = "𝕏", xopf = "𝕩", xoplus = "⨁", xotime = "⨂", xrarr = "⟶", xrArr = "⟹", Xscr = "𝒳", xscr = "𝓍", xsqcup = "⨆", xuplus = "⨄", xutri = "△", xvee = "⋁", xwedge = "⋀", Yacute = "Ý", yacute = "ý", YAcy = "Я", yacy = "я", Ycirc = "Ŷ", ycirc = "ŷ", Ycy = "Ы", ycy = "ы", yen = "¥", Yfr = "𝔜", yfr = "𝔶", YIcy = "Ї", yicy = "ї", Yopf = "𝕐", yopf = "𝕪", Yscr = "𝒴", yscr = "𝓎", YUcy = "Ю", yucy = "ю", yuml = "ÿ", Yuml = "Ÿ", Zacute = "Ź", zacute = "ź", Zcaron = "Ž", zcaron = "ž", Zcy = "З", zcy = "з", Zdot = "Ż", zdot = "ż", zeetrf = "ℨ", ZeroWidthSpace = "​", Zeta = "Ζ", zeta = "ζ", zfr = "𝔷", Zfr = "ℨ", ZHcy = "Ж", zhcy = "ж", zigrarr = "⇝", zopf = "𝕫", Zopf = "ℤ", Zscr = "𝒵", zscr = "𝓏", zwj = "‍", zwnj = "‌", require$$0 = {
  Aacute,
  aacute,
  Abreve,
  abreve,
  ac,
  acd,
  acE,
  Acirc,
  acirc,
  acute,
  Acy,
  acy,
  AElig,
  aelig,
  af,
  Afr,
  afr,
  Agrave,
  agrave,
  alefsym,
  aleph,
  Alpha,
  alpha,
  Amacr,
  amacr,
  amalg,
  amp,
  AMP,
  andand,
  And,
  and,
  andd,
  andslope,
  andv,
  ang,
  ange,
  angle,
  angmsdaa,
  angmsdab,
  angmsdac,
  angmsdad,
  angmsdae,
  angmsdaf,
  angmsdag,
  angmsdah,
  angmsd,
  angrt,
  angrtvb,
  angrtvbd,
  angsph,
  angst,
  angzarr,
  Aogon,
  aogon,
  Aopf,
  aopf,
  apacir,
  ap,
  apE,
  ape,
  apid,
  apos,
  ApplyFunction,
  approx,
  approxeq,
  Aring,
  aring,
  Ascr,
  ascr,
  Assign,
  ast,
  asymp,
  asympeq,
  Atilde,
  atilde,
  Auml,
  auml,
  awconint,
  awint,
  backcong,
  backepsilon,
  backprime,
  backsim,
  backsimeq,
  Backslash,
  Barv,
  barvee,
  barwed,
  Barwed,
  barwedge,
  bbrk,
  bbrktbrk,
  bcong,
  Bcy,
  bcy,
  bdquo,
  becaus,
  because,
  Because,
  bemptyv,
  bepsi,
  bernou,
  Bernoullis,
  Beta,
  beta,
  beth,
  between,
  Bfr,
  bfr,
  bigcap,
  bigcirc,
  bigcup,
  bigodot,
  bigoplus,
  bigotimes,
  bigsqcup,
  bigstar,
  bigtriangledown,
  bigtriangleup,
  biguplus,
  bigvee,
  bigwedge,
  bkarow,
  blacklozenge,
  blacksquare,
  blacktriangle,
  blacktriangledown,
  blacktriangleleft,
  blacktriangleright,
  blank,
  blk12,
  blk14,
  blk34,
  block: block$1,
  bne,
  bnequiv,
  bNot,
  bnot,
  Bopf,
  bopf,
  bot,
  bottom,
  bowtie,
  boxbox,
  boxdl,
  boxdL,
  boxDl,
  boxDL,
  boxdr,
  boxdR,
  boxDr,
  boxDR,
  boxh,
  boxH,
  boxhd,
  boxHd,
  boxhD,
  boxHD,
  boxhu,
  boxHu,
  boxhU,
  boxHU,
  boxminus,
  boxplus,
  boxtimes,
  boxul,
  boxuL,
  boxUl,
  boxUL,
  boxur,
  boxuR,
  boxUr,
  boxUR,
  boxv,
  boxV,
  boxvh,
  boxvH,
  boxVh,
  boxVH,
  boxvl,
  boxvL,
  boxVl,
  boxVL,
  boxvr,
  boxvR,
  boxVr,
  boxVR,
  bprime,
  breve,
  Breve,
  brvbar,
  bscr,
  Bscr,
  bsemi,
  bsim,
  bsime,
  bsolb,
  bsol,
  bsolhsub,
  bull,
  bullet,
  bump,
  bumpE,
  bumpe,
  Bumpeq,
  bumpeq,
  Cacute,
  cacute,
  capand,
  capbrcup,
  capcap,
  cap,
  Cap,
  capcup,
  capdot,
  CapitalDifferentialD,
  caps,
  caret,
  caron,
  Cayleys,
  ccaps,
  Ccaron,
  ccaron,
  Ccedil,
  ccedil,
  Ccirc,
  ccirc,
  Cconint,
  ccups,
  ccupssm,
  Cdot,
  cdot,
  cedil,
  Cedilla,
  cemptyv,
  cent,
  centerdot,
  CenterDot,
  cfr,
  Cfr,
  CHcy,
  chcy,
  check,
  checkmark,
  Chi,
  chi,
  circ,
  circeq,
  circlearrowleft,
  circlearrowright,
  circledast,
  circledcirc,
  circleddash,
  CircleDot,
  circledR,
  circledS,
  CircleMinus,
  CirclePlus,
  CircleTimes,
  cir,
  cirE,
  cire,
  cirfnint,
  cirmid,
  cirscir,
  ClockwiseContourIntegral,
  CloseCurlyDoubleQuote,
  CloseCurlyQuote,
  clubs,
  clubsuit,
  colon,
  Colon,
  Colone,
  colone,
  coloneq,
  comma,
  commat,
  comp,
  compfn,
  complement,
  complexes,
  cong,
  congdot,
  Congruent,
  conint,
  Conint,
  ContourIntegral,
  copf,
  Copf,
  coprod,
  Coproduct,
  copy,
  COPY,
  copysr,
  CounterClockwiseContourIntegral,
  crarr,
  cross,
  Cross,
  Cscr,
  cscr,
  csub,
  csube,
  csup,
  csupe,
  ctdot,
  cudarrl,
  cudarrr,
  cuepr,
  cuesc,
  cularr,
  cularrp,
  cupbrcap,
  cupcap,
  CupCap,
  cup,
  Cup,
  cupcup,
  cupdot,
  cupor,
  cups,
  curarr,
  curarrm,
  curlyeqprec,
  curlyeqsucc,
  curlyvee,
  curlywedge,
  curren,
  curvearrowleft,
  curvearrowright,
  cuvee,
  cuwed,
  cwconint,
  cwint,
  cylcty,
  dagger,
  Dagger,
  daleth,
  darr,
  Darr,
  dArr,
  dash,
  Dashv,
  dashv,
  dbkarow,
  dblac,
  Dcaron,
  dcaron,
  Dcy,
  dcy,
  ddagger,
  ddarr,
  DD,
  dd,
  DDotrahd,
  ddotseq,
  deg,
  Del,
  Delta,
  delta,
  demptyv,
  dfisht,
  Dfr,
  dfr,
  dHar,
  dharl,
  dharr,
  DiacriticalAcute,
  DiacriticalDot,
  DiacriticalDoubleAcute,
  DiacriticalGrave,
  DiacriticalTilde,
  diam,
  diamond,
  Diamond,
  diamondsuit,
  diams,
  die,
  DifferentialD,
  digamma,
  disin,
  div,
  divide,
  divideontimes,
  divonx,
  DJcy,
  djcy,
  dlcorn,
  dlcrop,
  dollar,
  Dopf,
  dopf,
  Dot,
  dot,
  DotDot,
  doteq,
  doteqdot,
  DotEqual,
  dotminus,
  dotplus,
  dotsquare,
  doublebarwedge,
  DoubleContourIntegral,
  DoubleDot,
  DoubleDownArrow,
  DoubleLeftArrow,
  DoubleLeftRightArrow,
  DoubleLeftTee,
  DoubleLongLeftArrow,
  DoubleLongLeftRightArrow,
  DoubleLongRightArrow,
  DoubleRightArrow,
  DoubleRightTee,
  DoubleUpArrow,
  DoubleUpDownArrow,
  DoubleVerticalBar,
  DownArrowBar,
  downarrow,
  DownArrow,
  Downarrow,
  DownArrowUpArrow,
  DownBreve,
  downdownarrows,
  downharpoonleft,
  downharpoonright,
  DownLeftRightVector,
  DownLeftTeeVector,
  DownLeftVectorBar,
  DownLeftVector,
  DownRightTeeVector,
  DownRightVectorBar,
  DownRightVector,
  DownTeeArrow,
  DownTee,
  drbkarow,
  drcorn,
  drcrop,
  Dscr,
  dscr,
  DScy,
  dscy,
  dsol,
  Dstrok,
  dstrok,
  dtdot,
  dtri,
  dtrif,
  duarr,
  duhar,
  dwangle,
  DZcy,
  dzcy,
  dzigrarr,
  Eacute,
  eacute,
  easter,
  Ecaron,
  ecaron,
  Ecirc,
  ecirc,
  ecir,
  ecolon,
  Ecy,
  ecy,
  eDDot,
  Edot,
  edot,
  eDot,
  ee,
  efDot,
  Efr,
  efr,
  eg,
  Egrave,
  egrave,
  egs,
  egsdot,
  el,
  Element: Element$1,
  elinters,
  ell,
  els,
  elsdot,
  Emacr,
  emacr,
  empty,
  emptyset,
  EmptySmallSquare,
  emptyv,
  EmptyVerySmallSquare,
  emsp13,
  emsp14,
  emsp,
  ENG,
  eng,
  ensp,
  Eogon,
  eogon,
  Eopf,
  eopf,
  epar,
  eparsl,
  eplus,
  epsi,
  Epsilon,
  epsilon,
  epsiv,
  eqcirc,
  eqcolon,
  eqsim,
  eqslantgtr,
  eqslantless,
  Equal,
  equals,
  EqualTilde,
  equest,
  Equilibrium,
  equiv,
  equivDD,
  eqvparsl,
  erarr,
  erDot,
  escr,
  Escr,
  esdot,
  Esim,
  esim,
  Eta,
  eta,
  ETH,
  eth,
  Euml,
  euml,
  euro,
  excl,
  exist,
  Exists,
  expectation,
  exponentiale,
  ExponentialE,
  fallingdotseq,
  Fcy,
  fcy,
  female,
  ffilig,
  fflig,
  ffllig,
  Ffr,
  ffr,
  filig,
  FilledSmallSquare,
  FilledVerySmallSquare,
  fjlig,
  flat,
  fllig,
  fltns,
  fnof,
  Fopf,
  fopf,
  forall,
  ForAll,
  fork,
  forkv,
  Fouriertrf,
  fpartint,
  frac12,
  frac13,
  frac14,
  frac15,
  frac16,
  frac18,
  frac23,
  frac25,
  frac34,
  frac35,
  frac38,
  frac45,
  frac56,
  frac58,
  frac78,
  frasl,
  frown,
  fscr,
  Fscr,
  gacute,
  Gamma,
  gamma,
  Gammad,
  gammad,
  gap,
  Gbreve,
  gbreve,
  Gcedil,
  Gcirc,
  gcirc,
  Gcy,
  gcy,
  Gdot,
  gdot,
  ge,
  gE,
  gEl,
  gel,
  geq,
  geqq,
  geqslant,
  gescc,
  ges,
  gesdot,
  gesdoto,
  gesdotol,
  gesl,
  gesles,
  Gfr,
  gfr,
  gg,
  Gg,
  ggg,
  gimel,
  GJcy,
  gjcy,
  gla,
  gl,
  glE,
  glj,
  gnap,
  gnapprox,
  gne,
  gnE,
  gneq,
  gneqq,
  gnsim,
  Gopf,
  gopf,
  grave,
  GreaterEqual,
  GreaterEqualLess,
  GreaterFullEqual,
  GreaterGreater,
  GreaterLess,
  GreaterSlantEqual,
  GreaterTilde,
  Gscr,
  gscr,
  gsim,
  gsime,
  gsiml,
  gtcc,
  gtcir,
  gt,
  GT,
  Gt,
  gtdot,
  gtlPar,
  gtquest,
  gtrapprox,
  gtrarr,
  gtrdot,
  gtreqless,
  gtreqqless,
  gtrless,
  gtrsim,
  gvertneqq,
  gvnE,
  Hacek,
  hairsp,
  half,
  hamilt,
  HARDcy,
  hardcy,
  harrcir,
  harr,
  hArr,
  harrw,
  Hat,
  hbar,
  Hcirc,
  hcirc,
  hearts,
  heartsuit,
  hellip,
  hercon,
  hfr,
  Hfr,
  HilbertSpace,
  hksearow,
  hkswarow,
  hoarr,
  homtht,
  hookleftarrow,
  hookrightarrow,
  hopf,
  Hopf,
  horbar,
  HorizontalLine,
  hscr,
  Hscr,
  hslash,
  Hstrok,
  hstrok,
  HumpDownHump,
  HumpEqual,
  hybull,
  hyphen,
  Iacute,
  iacute,
  ic,
  Icirc,
  icirc,
  Icy,
  icy,
  Idot,
  IEcy,
  iecy,
  iexcl,
  iff,
  ifr,
  Ifr,
  Igrave,
  igrave,
  ii,
  iiiint,
  iiint,
  iinfin,
  iiota,
  IJlig,
  ijlig,
  Imacr,
  imacr,
  image: image$1,
  ImaginaryI,
  imagline,
  imagpart,
  imath,
  Im,
  imof,
  imped,
  Implies,
  incare,
  in: "∈",
  infin,
  infintie,
  inodot,
  intcal,
  int,
  Int,
  integers,
  Integral,
  intercal,
  Intersection,
  intlarhk,
  intprod,
  InvisibleComma,
  InvisibleTimes,
  IOcy,
  iocy,
  Iogon,
  iogon,
  Iopf,
  iopf,
  Iota,
  iota,
  iprod,
  iquest,
  iscr,
  Iscr,
  isin,
  isindot,
  isinE,
  isins,
  isinsv,
  isinv,
  it,
  Itilde,
  itilde,
  Iukcy,
  iukcy,
  Iuml,
  iuml,
  Jcirc,
  jcirc,
  Jcy,
  jcy,
  Jfr,
  jfr,
  jmath,
  Jopf,
  jopf,
  Jscr,
  jscr,
  Jsercy,
  jsercy,
  Jukcy,
  jukcy,
  Kappa,
  kappa,
  kappav,
  Kcedil,
  kcedil,
  Kcy,
  kcy,
  Kfr,
  kfr,
  kgreen,
  KHcy,
  khcy,
  KJcy,
  kjcy,
  Kopf,
  kopf,
  Kscr,
  kscr,
  lAarr,
  Lacute,
  lacute,
  laemptyv,
  lagran,
  Lambda,
  lambda,
  lang,
  Lang,
  langd,
  langle,
  lap,
  Laplacetrf,
  laquo,
  larrb,
  larrbfs,
  larr,
  Larr,
  lArr,
  larrfs,
  larrhk,
  larrlp,
  larrpl,
  larrsim,
  larrtl,
  latail,
  lAtail,
  lat,
  late,
  lates,
  lbarr,
  lBarr,
  lbbrk,
  lbrace,
  lbrack,
  lbrke,
  lbrksld,
  lbrkslu,
  Lcaron,
  lcaron,
  Lcedil,
  lcedil,
  lceil,
  lcub,
  Lcy,
  lcy,
  ldca,
  ldquo,
  ldquor,
  ldrdhar,
  ldrushar,
  ldsh,
  le,
  lE,
  LeftAngleBracket,
  LeftArrowBar,
  leftarrow,
  LeftArrow,
  Leftarrow,
  LeftArrowRightArrow,
  leftarrowtail,
  LeftCeiling,
  LeftDoubleBracket,
  LeftDownTeeVector,
  LeftDownVectorBar,
  LeftDownVector,
  LeftFloor,
  leftharpoondown,
  leftharpoonup,
  leftleftarrows,
  leftrightarrow,
  LeftRightArrow,
  Leftrightarrow,
  leftrightarrows,
  leftrightharpoons,
  leftrightsquigarrow,
  LeftRightVector,
  LeftTeeArrow,
  LeftTee,
  LeftTeeVector,
  leftthreetimes,
  LeftTriangleBar,
  LeftTriangle,
  LeftTriangleEqual,
  LeftUpDownVector,
  LeftUpTeeVector,
  LeftUpVectorBar,
  LeftUpVector,
  LeftVectorBar,
  LeftVector,
  lEg,
  leg,
  leq,
  leqq,
  leqslant,
  lescc,
  les,
  lesdot,
  lesdoto,
  lesdotor,
  lesg,
  lesges,
  lessapprox,
  lessdot,
  lesseqgtr,
  lesseqqgtr,
  LessEqualGreater,
  LessFullEqual,
  LessGreater,
  lessgtr,
  LessLess,
  lesssim,
  LessSlantEqual,
  LessTilde,
  lfisht,
  lfloor,
  Lfr,
  lfr,
  lg,
  lgE,
  lHar,
  lhard,
  lharu,
  lharul,
  lhblk,
  LJcy,
  ljcy,
  llarr,
  ll,
  Ll,
  llcorner,
  Lleftarrow,
  llhard,
  lltri,
  Lmidot,
  lmidot,
  lmoustache,
  lmoust,
  lnap,
  lnapprox,
  lne,
  lnE,
  lneq,
  lneqq,
  lnsim,
  loang,
  loarr,
  lobrk,
  longleftarrow,
  LongLeftArrow,
  Longleftarrow,
  longleftrightarrow,
  LongLeftRightArrow,
  Longleftrightarrow,
  longmapsto,
  longrightarrow,
  LongRightArrow,
  Longrightarrow,
  looparrowleft,
  looparrowright,
  lopar,
  Lopf,
  lopf,
  loplus,
  lotimes,
  lowast,
  lowbar,
  LowerLeftArrow,
  LowerRightArrow,
  loz,
  lozenge,
  lozf,
  lpar,
  lparlt,
  lrarr,
  lrcorner,
  lrhar,
  lrhard,
  lrm,
  lrtri,
  lsaquo,
  lscr,
  Lscr,
  lsh,
  Lsh,
  lsim,
  lsime,
  lsimg,
  lsqb,
  lsquo,
  lsquor,
  Lstrok,
  lstrok,
  ltcc,
  ltcir,
  lt,
  LT,
  Lt,
  ltdot,
  lthree,
  ltimes,
  ltlarr,
  ltquest,
  ltri,
  ltrie,
  ltrif,
  ltrPar,
  lurdshar,
  luruhar,
  lvertneqq,
  lvnE,
  macr,
  male,
  malt,
  maltese,
  Map: "⤅",
  map: map$1,
  mapsto,
  mapstodown,
  mapstoleft,
  mapstoup,
  marker,
  mcomma,
  Mcy,
  mcy,
  mdash,
  mDDot,
  measuredangle,
  MediumSpace,
  Mellintrf,
  Mfr,
  mfr,
  mho,
  micro,
  midast,
  midcir,
  mid,
  middot,
  minusb,
  minus,
  minusd,
  minusdu,
  MinusPlus,
  mlcp,
  mldr,
  mnplus,
  models,
  Mopf,
  mopf,
  mp,
  mscr,
  Mscr,
  mstpos,
  Mu,
  mu,
  multimap,
  mumap,
  nabla,
  Nacute,
  nacute,
  nang,
  nap,
  napE,
  napid,
  napos,
  napprox,
  natural,
  naturals,
  natur,
  nbsp,
  nbump,
  nbumpe,
  ncap,
  Ncaron,
  ncaron,
  Ncedil,
  ncedil,
  ncong,
  ncongdot,
  ncup,
  Ncy,
  ncy,
  ndash,
  nearhk,
  nearr,
  neArr,
  nearrow,
  ne,
  nedot,
  NegativeMediumSpace,
  NegativeThickSpace,
  NegativeThinSpace,
  NegativeVeryThinSpace,
  nequiv,
  nesear,
  nesim,
  NestedGreaterGreater,
  NestedLessLess,
  NewLine,
  nexist,
  nexists,
  Nfr,
  nfr,
  ngE,
  nge,
  ngeq,
  ngeqq,
  ngeqslant,
  nges,
  nGg,
  ngsim,
  nGt,
  ngt,
  ngtr,
  nGtv,
  nharr,
  nhArr,
  nhpar,
  ni,
  nis,
  nisd,
  niv,
  NJcy,
  njcy,
  nlarr,
  nlArr,
  nldr,
  nlE,
  nle,
  nleftarrow,
  nLeftarrow,
  nleftrightarrow,
  nLeftrightarrow,
  nleq,
  nleqq,
  nleqslant,
  nles,
  nless,
  nLl,
  nlsim,
  nLt,
  nlt,
  nltri,
  nltrie,
  nLtv,
  nmid,
  NoBreak,
  NonBreakingSpace,
  nopf,
  Nopf,
  Not,
  not,
  NotCongruent,
  NotCupCap,
  NotDoubleVerticalBar,
  NotElement,
  NotEqual,
  NotEqualTilde,
  NotExists,
  NotGreater,
  NotGreaterEqual,
  NotGreaterFullEqual,
  NotGreaterGreater,
  NotGreaterLess,
  NotGreaterSlantEqual,
  NotGreaterTilde,
  NotHumpDownHump,
  NotHumpEqual,
  notin,
  notindot,
  notinE,
  notinva,
  notinvb,
  notinvc,
  NotLeftTriangleBar,
  NotLeftTriangle,
  NotLeftTriangleEqual,
  NotLess,
  NotLessEqual,
  NotLessGreater,
  NotLessLess,
  NotLessSlantEqual,
  NotLessTilde,
  NotNestedGreaterGreater,
  NotNestedLessLess,
  notni,
  notniva,
  notnivb,
  notnivc,
  NotPrecedes,
  NotPrecedesEqual,
  NotPrecedesSlantEqual,
  NotReverseElement,
  NotRightTriangleBar,
  NotRightTriangle,
  NotRightTriangleEqual,
  NotSquareSubset,
  NotSquareSubsetEqual,
  NotSquareSuperset,
  NotSquareSupersetEqual,
  NotSubset,
  NotSubsetEqual,
  NotSucceeds,
  NotSucceedsEqual,
  NotSucceedsSlantEqual,
  NotSucceedsTilde,
  NotSuperset,
  NotSupersetEqual,
  NotTilde,
  NotTildeEqual,
  NotTildeFullEqual,
  NotTildeTilde,
  NotVerticalBar,
  nparallel,
  npar,
  nparsl,
  npart,
  npolint,
  npr,
  nprcue,
  nprec,
  npreceq,
  npre,
  nrarrc,
  nrarr,
  nrArr,
  nrarrw,
  nrightarrow,
  nRightarrow,
  nrtri,
  nrtrie,
  nsc,
  nsccue,
  nsce,
  Nscr,
  nscr,
  nshortmid,
  nshortparallel,
  nsim,
  nsime,
  nsimeq,
  nsmid,
  nspar,
  nsqsube,
  nsqsupe,
  nsub,
  nsubE,
  nsube,
  nsubset,
  nsubseteq,
  nsubseteqq,
  nsucc,
  nsucceq,
  nsup,
  nsupE,
  nsupe,
  nsupset,
  nsupseteq,
  nsupseteqq,
  ntgl,
  Ntilde,
  ntilde,
  ntlg,
  ntriangleleft,
  ntrianglelefteq,
  ntriangleright,
  ntrianglerighteq,
  Nu,
  nu,
  num,
  numero,
  numsp,
  nvap,
  nvdash,
  nvDash,
  nVdash,
  nVDash,
  nvge,
  nvgt,
  nvHarr,
  nvinfin,
  nvlArr,
  nvle,
  nvlt,
  nvltrie,
  nvrArr,
  nvrtrie,
  nvsim,
  nwarhk,
  nwarr,
  nwArr,
  nwarrow,
  nwnear,
  Oacute,
  oacute,
  oast,
  Ocirc,
  ocirc,
  ocir,
  Ocy,
  ocy,
  odash,
  Odblac,
  odblac,
  odiv,
  odot,
  odsold,
  OElig,
  oelig,
  ofcir,
  Ofr,
  ofr,
  ogon,
  Ograve,
  ograve,
  ogt,
  ohbar,
  ohm,
  oint,
  olarr,
  olcir,
  olcross,
  oline,
  olt,
  Omacr,
  omacr,
  Omega,
  omega,
  Omicron,
  omicron,
  omid,
  ominus,
  Oopf,
  oopf,
  opar,
  OpenCurlyDoubleQuote,
  OpenCurlyQuote,
  operp,
  oplus,
  orarr,
  Or,
  or,
  ord,
  order,
  orderof,
  ordf,
  ordm,
  origof,
  oror,
  orslope,
  orv,
  oS,
  Oscr,
  oscr,
  Oslash,
  oslash,
  osol,
  Otilde,
  otilde,
  otimesas,
  Otimes,
  otimes,
  Ouml,
  ouml,
  ovbar,
  OverBar,
  OverBrace,
  OverBracket,
  OverParenthesis,
  para,
  parallel,
  par,
  parsim,
  parsl,
  part,
  PartialD,
  Pcy,
  pcy,
  percnt,
  period,
  permil,
  perp,
  pertenk,
  Pfr,
  pfr,
  Phi,
  phi,
  phiv,
  phmmat,
  phone,
  Pi,
  pi,
  pitchfork,
  piv,
  planck,
  planckh,
  plankv,
  plusacir,
  plusb,
  pluscir,
  plus,
  plusdo,
  plusdu,
  pluse,
  PlusMinus,
  plusmn,
  plussim,
  plustwo,
  pm,
  Poincareplane,
  pointint,
  popf,
  Popf,
  pound,
  prap,
  Pr,
  pr,
  prcue,
  precapprox,
  prec,
  preccurlyeq,
  Precedes,
  PrecedesEqual,
  PrecedesSlantEqual,
  PrecedesTilde,
  preceq,
  precnapprox,
  precneqq,
  precnsim,
  pre,
  prE,
  precsim,
  prime,
  Prime,
  primes,
  prnap,
  prnE,
  prnsim,
  prod,
  Product,
  profalar,
  profline,
  profsurf,
  prop,
  Proportional,
  Proportion,
  propto,
  prsim,
  prurel,
  Pscr,
  pscr,
  Psi,
  psi,
  puncsp,
  Qfr,
  qfr,
  qint,
  qopf,
  Qopf,
  qprime,
  Qscr,
  qscr,
  quaternions,
  quatint,
  quest,
  questeq,
  quot,
  QUOT,
  rAarr,
  race,
  Racute,
  racute,
  radic,
  raemptyv,
  rang,
  Rang,
  rangd,
  range,
  rangle,
  raquo,
  rarrap,
  rarrb,
  rarrbfs,
  rarrc,
  rarr,
  Rarr,
  rArr,
  rarrfs,
  rarrhk,
  rarrlp,
  rarrpl,
  rarrsim,
  Rarrtl,
  rarrtl,
  rarrw,
  ratail,
  rAtail,
  ratio,
  rationals,
  rbarr,
  rBarr,
  RBarr,
  rbbrk,
  rbrace,
  rbrack,
  rbrke,
  rbrksld,
  rbrkslu,
  Rcaron,
  rcaron,
  Rcedil,
  rcedil,
  rceil,
  rcub,
  Rcy,
  rcy,
  rdca,
  rdldhar,
  rdquo,
  rdquor,
  rdsh,
  real,
  realine,
  realpart,
  reals,
  Re,
  rect,
  reg,
  REG,
  ReverseElement,
  ReverseEquilibrium,
  ReverseUpEquilibrium,
  rfisht,
  rfloor,
  rfr,
  Rfr,
  rHar,
  rhard,
  rharu,
  rharul,
  Rho,
  rho,
  rhov,
  RightAngleBracket,
  RightArrowBar,
  rightarrow,
  RightArrow,
  Rightarrow,
  RightArrowLeftArrow,
  rightarrowtail,
  RightCeiling,
  RightDoubleBracket,
  RightDownTeeVector,
  RightDownVectorBar,
  RightDownVector,
  RightFloor,
  rightharpoondown,
  rightharpoonup,
  rightleftarrows,
  rightleftharpoons,
  rightrightarrows,
  rightsquigarrow,
  RightTeeArrow,
  RightTee,
  RightTeeVector,
  rightthreetimes,
  RightTriangleBar,
  RightTriangle,
  RightTriangleEqual,
  RightUpDownVector,
  RightUpTeeVector,
  RightUpVectorBar,
  RightUpVector,
  RightVectorBar,
  RightVector,
  ring,
  risingdotseq,
  rlarr,
  rlhar,
  rlm,
  rmoustache,
  rmoust,
  rnmid,
  roang,
  roarr,
  robrk,
  ropar,
  ropf,
  Ropf,
  roplus,
  rotimes,
  RoundImplies,
  rpar,
  rpargt,
  rppolint,
  rrarr,
  Rrightarrow,
  rsaquo,
  rscr,
  Rscr,
  rsh,
  Rsh,
  rsqb,
  rsquo,
  rsquor,
  rthree,
  rtimes,
  rtri,
  rtrie,
  rtrif,
  rtriltri,
  RuleDelayed,
  ruluhar,
  rx,
  Sacute,
  sacute,
  sbquo,
  scap,
  Scaron,
  scaron,
  Sc,
  sc,
  sccue,
  sce,
  scE,
  Scedil,
  scedil,
  Scirc,
  scirc,
  scnap,
  scnE,
  scnsim,
  scpolint,
  scsim,
  Scy,
  scy,
  sdotb,
  sdot,
  sdote,
  searhk,
  searr,
  seArr,
  searrow,
  sect,
  semi,
  seswar,
  setminus,
  setmn,
  sext,
  Sfr,
  sfr,
  sfrown,
  sharp,
  SHCHcy,
  shchcy,
  SHcy,
  shcy,
  ShortDownArrow,
  ShortLeftArrow,
  shortmid,
  shortparallel,
  ShortRightArrow,
  ShortUpArrow,
  shy,
  Sigma,
  sigma,
  sigmaf,
  sigmav,
  sim,
  simdot,
  sime,
  simeq,
  simg,
  simgE,
  siml,
  simlE,
  simne,
  simplus,
  simrarr,
  slarr,
  SmallCircle,
  smallsetminus,
  smashp,
  smeparsl,
  smid,
  smile,
  smt,
  smte,
  smtes,
  SOFTcy,
  softcy,
  solbar,
  solb,
  sol,
  Sopf,
  sopf,
  spades,
  spadesuit,
  spar,
  sqcap,
  sqcaps,
  sqcup,
  sqcups,
  Sqrt,
  sqsub,
  sqsube,
  sqsubset,
  sqsubseteq,
  sqsup,
  sqsupe,
  sqsupset,
  sqsupseteq,
  square,
  Square,
  SquareIntersection,
  SquareSubset,
  SquareSubsetEqual,
  SquareSuperset,
  SquareSupersetEqual,
  SquareUnion,
  squarf,
  squ,
  squf,
  srarr,
  Sscr,
  sscr,
  ssetmn,
  ssmile,
  sstarf,
  Star,
  star,
  starf,
  straightepsilon,
  straightphi,
  strns,
  sub,
  Sub,
  subdot,
  subE,
  sube,
  subedot,
  submult,
  subnE,
  subne,
  subplus,
  subrarr,
  subset,
  Subset,
  subseteq,
  subseteqq,
  SubsetEqual,
  subsetneq,
  subsetneqq,
  subsim,
  subsub,
  subsup,
  succapprox,
  succ,
  succcurlyeq,
  Succeeds,
  SucceedsEqual,
  SucceedsSlantEqual,
  SucceedsTilde,
  succeq,
  succnapprox,
  succneqq,
  succnsim,
  succsim,
  SuchThat,
  sum,
  Sum,
  sung,
  sup1,
  sup2,
  sup3,
  sup,
  Sup,
  supdot,
  supdsub,
  supE,
  supe,
  supedot,
  Superset,
  SupersetEqual,
  suphsol,
  suphsub,
  suplarr,
  supmult,
  supnE,
  supne,
  supplus,
  supset,
  Supset,
  supseteq,
  supseteqq,
  supsetneq,
  supsetneqq,
  supsim,
  supsub,
  supsup,
  swarhk,
  swarr,
  swArr,
  swarrow,
  swnwar,
  szlig,
  Tab,
  target,
  Tau,
  tau,
  tbrk,
  Tcaron,
  tcaron,
  Tcedil,
  tcedil,
  Tcy,
  tcy,
  tdot,
  telrec,
  Tfr,
  tfr,
  there4,
  therefore,
  Therefore,
  Theta,
  theta,
  thetasym,
  thetav,
  thickapprox,
  thicksim,
  ThickSpace,
  ThinSpace,
  thinsp,
  thkap,
  thksim,
  THORN,
  thorn,
  tilde,
  Tilde,
  TildeEqual,
  TildeFullEqual,
  TildeTilde,
  timesbar,
  timesb,
  times,
  timesd,
  tint,
  toea,
  topbot,
  topcir,
  top,
  Topf,
  topf,
  topfork,
  tosa,
  tprime,
  trade,
  TRADE,
  triangle,
  triangledown,
  triangleleft,
  trianglelefteq,
  triangleq,
  triangleright,
  trianglerighteq,
  tridot,
  trie,
  triminus,
  TripleDot,
  triplus,
  trisb,
  tritime,
  trpezium,
  Tscr,
  tscr,
  TScy,
  tscy,
  TSHcy,
  tshcy,
  Tstrok,
  tstrok,
  twixt,
  twoheadleftarrow,
  twoheadrightarrow,
  Uacute,
  uacute,
  uarr,
  Uarr,
  uArr,
  Uarrocir,
  Ubrcy,
  ubrcy,
  Ubreve,
  ubreve,
  Ucirc,
  ucirc,
  Ucy,
  ucy,
  udarr,
  Udblac,
  udblac,
  udhar,
  ufisht,
  Ufr,
  ufr,
  Ugrave,
  ugrave,
  uHar,
  uharl,
  uharr,
  uhblk,
  ulcorn,
  ulcorner,
  ulcrop,
  ultri,
  Umacr,
  umacr,
  uml,
  UnderBar,
  UnderBrace,
  UnderBracket,
  UnderParenthesis,
  Union,
  UnionPlus,
  Uogon,
  uogon,
  Uopf,
  uopf,
  UpArrowBar,
  uparrow,
  UpArrow,
  Uparrow,
  UpArrowDownArrow,
  updownarrow,
  UpDownArrow,
  Updownarrow,
  UpEquilibrium,
  upharpoonleft,
  upharpoonright,
  uplus,
  UpperLeftArrow,
  UpperRightArrow,
  upsi,
  Upsi,
  upsih,
  Upsilon,
  upsilon,
  UpTeeArrow,
  UpTee,
  upuparrows,
  urcorn,
  urcorner,
  urcrop,
  Uring,
  uring,
  urtri,
  Uscr,
  uscr,
  utdot,
  Utilde,
  utilde,
  utri,
  utrif,
  uuarr,
  Uuml,
  uuml,
  uwangle,
  vangrt,
  varepsilon,
  varkappa,
  varnothing,
  varphi,
  varpi,
  varpropto,
  varr,
  vArr,
  varrho,
  varsigma,
  varsubsetneq,
  varsubsetneqq,
  varsupsetneq,
  varsupsetneqq,
  vartheta,
  vartriangleleft,
  vartriangleright,
  vBar,
  Vbar,
  vBarv,
  Vcy,
  vcy,
  vdash,
  vDash,
  Vdash,
  VDash,
  Vdashl,
  veebar,
  vee,
  Vee,
  veeeq,
  vellip,
  verbar,
  Verbar,
  vert,
  Vert,
  VerticalBar,
  VerticalLine,
  VerticalSeparator,
  VerticalTilde,
  VeryThinSpace,
  Vfr,
  vfr,
  vltri,
  vnsub,
  vnsup,
  Vopf,
  vopf,
  vprop,
  vrtri,
  Vscr,
  vscr,
  vsubnE,
  vsubne,
  vsupnE,
  vsupne,
  Vvdash,
  vzigzag,
  Wcirc,
  wcirc,
  wedbar,
  wedge,
  Wedge,
  wedgeq,
  weierp,
  Wfr,
  wfr,
  Wopf,
  wopf,
  wp,
  wr,
  wreath,
  Wscr,
  wscr,
  xcap,
  xcirc,
  xcup,
  xdtri,
  Xfr,
  xfr,
  xharr,
  xhArr,
  Xi,
  xi,
  xlarr,
  xlArr,
  xmap,
  xnis,
  xodot,
  Xopf,
  xopf,
  xoplus,
  xotime,
  xrarr,
  xrArr,
  Xscr,
  xscr,
  xsqcup,
  xuplus,
  xutri,
  xvee,
  xwedge,
  Yacute,
  yacute,
  YAcy,
  yacy,
  Ycirc,
  ycirc,
  Ycy,
  ycy,
  yen,
  Yfr,
  yfr,
  YIcy,
  yicy,
  Yopf,
  yopf,
  Yscr,
  yscr,
  YUcy,
  yucy,
  yuml,
  Yuml,
  Zacute,
  zacute,
  Zcaron,
  zcaron,
  Zcy,
  zcy,
  Zdot,
  zdot,
  zeetrf,
  ZeroWidthSpace,
  Zeta,
  zeta,
  zfr,
  Zfr,
  ZHcy,
  zhcy,
  zigrarr,
  zopf,
  Zopf,
  Zscr,
  zscr,
  zwj,
  zwnj
};
var entities$1 = require$$0, regex$4 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, mdurl$1 = {}, encodeCache = {};
function getEncodeCache(t) {
  var e, r, o = encodeCache[t];
  if (o)
    return o;
  for (o = encodeCache[t] = [], e = 0; e < 128; e++)
    r = String.fromCharCode(e), /^[0-9a-z]$/i.test(r) ? o.push(r) : o.push("%" + ("0" + e.toString(16).toUpperCase()).slice(-2));
  for (e = 0; e < t.length; e++)
    o[t.charCodeAt(e)] = t[e];
  return o;
}
function encode$2(t, e, r) {
  var o, a, c, u, d, p = "";
  for (typeof e != "string" && (r = e, e = encode$2.defaultChars), typeof r > "u" && (r = !0), d = getEncodeCache(e), o = 0, a = t.length; o < a; o++) {
    if (c = t.charCodeAt(o), r && c === 37 && o + 2 < a && /^[0-9a-f]{2}$/i.test(t.slice(o + 1, o + 3))) {
      p += t.slice(o, o + 3), o += 2;
      continue;
    }
    if (c < 128) {
      p += d[c];
      continue;
    }
    if (c >= 55296 && c <= 57343) {
      if (c >= 55296 && c <= 56319 && o + 1 < a && (u = t.charCodeAt(o + 1), u >= 56320 && u <= 57343)) {
        p += encodeURIComponent(t[o] + t[o + 1]), o++;
        continue;
      }
      p += "%EF%BF%BD";
      continue;
    }
    p += encodeURIComponent(t[o]);
  }
  return p;
}
encode$2.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode$2.componentChars = "-_.!~*'()";
var encode_1 = encode$2, decodeCache = {};
function getDecodeCache(t) {
  var e, r, o = decodeCache[t];
  if (o)
    return o;
  for (o = decodeCache[t] = [], e = 0; e < 128; e++)
    r = String.fromCharCode(e), o.push(r);
  for (e = 0; e < t.length; e++)
    r = t.charCodeAt(e), o[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  return o;
}
function decode$1(t, e) {
  var r;
  return typeof e != "string" && (e = decode$1.defaultChars), r = getDecodeCache(e), t.replace(/(%[a-f0-9]{2})+/gi, function(o) {
    var a, c, u, d, p, g, b, x = "";
    for (a = 0, c = o.length; a < c; a += 3) {
      if (u = parseInt(o.slice(a + 1, a + 3), 16), u < 128) {
        x += r[u];
        continue;
      }
      if ((u & 224) === 192 && a + 3 < c && (d = parseInt(o.slice(a + 4, a + 6), 16), (d & 192) === 128)) {
        b = u << 6 & 1984 | d & 63, b < 128 ? x += "��" : x += String.fromCharCode(b), a += 3;
        continue;
      }
      if ((u & 240) === 224 && a + 6 < c && (d = parseInt(o.slice(a + 4, a + 6), 16), p = parseInt(o.slice(a + 7, a + 9), 16), (d & 192) === 128 && (p & 192) === 128)) {
        b = u << 12 & 61440 | d << 6 & 4032 | p & 63, b < 2048 || b >= 55296 && b <= 57343 ? x += "���" : x += String.fromCharCode(b), a += 6;
        continue;
      }
      if ((u & 248) === 240 && a + 9 < c && (d = parseInt(o.slice(a + 4, a + 6), 16), p = parseInt(o.slice(a + 7, a + 9), 16), g = parseInt(o.slice(a + 10, a + 12), 16), (d & 192) === 128 && (p & 192) === 128 && (g & 192) === 128)) {
        b = u << 18 & 1835008 | d << 12 & 258048 | p << 6 & 4032 | g & 63, b < 65536 || b > 1114111 ? x += "����" : (b -= 65536, x += String.fromCharCode(55296 + (b >> 10), 56320 + (b & 1023))), a += 9;
        continue;
      }
      x += "�";
    }
    return x;
  });
}
decode$1.defaultChars = ";/?:@&=+$,#";
decode$1.componentChars = "";
var decode_1 = decode$1, format$3 = function t(e) {
  var r = "";
  return r += e.protocol || "", r += e.slashes ? "//" : "", r += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? r += "[" + e.hostname + "]" : r += e.hostname || "", r += e.port ? ":" + e.port : "", r += e.pathname || "", r += e.search || "", r += e.hash || "", r;
};
function Url() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, delims = ["<", ">", '"', "`", " ", "\r", `
`, "	"], unwise = ["{", "}", "|", "\\", "^", "`"].concat(delims), autoEscape = ["'"].concat(unwise), nonHostChars = ["%", "/", "?", ";", "#"].concat(autoEscape), hostEndingChars = ["/", "?", "#"], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, hostlessProtocol = {
  javascript: !0,
  "javascript:": !0
}, slashedProtocol = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function urlParse(t, e) {
  if (t && t instanceof Url)
    return t;
  var r = new Url();
  return r.parse(t, e), r;
}
Url.prototype.parse = function(t, e) {
  var r, o, a, c, u, d = t;
  if (d = d.trim(), !e && t.split("#").length === 1) {
    var p = simplePathPattern.exec(d);
    if (p)
      return this.pathname = p[1], p[2] && (this.search = p[2]), this;
  }
  var g = protocolPattern.exec(d);
  if (g && (g = g[0], a = g.toLowerCase(), this.protocol = g, d = d.substr(g.length)), (e || g || d.match(/^\/\/[^@\/]+@[^@\/]+/)) && (u = d.substr(0, 2) === "//", u && !(g && hostlessProtocol[g]) && (d = d.substr(2), this.slashes = !0)), !hostlessProtocol[g] && (u || g && !slashedProtocol[g])) {
    var b = -1;
    for (r = 0; r < hostEndingChars.length; r++)
      c = d.indexOf(hostEndingChars[r]), c !== -1 && (b === -1 || c < b) && (b = c);
    var x, w;
    for (b === -1 ? w = d.lastIndexOf("@") : w = d.lastIndexOf("@", b), w !== -1 && (x = d.slice(0, w), d = d.slice(w + 1), this.auth = x), b = -1, r = 0; r < nonHostChars.length; r++)
      c = d.indexOf(nonHostChars[r]), c !== -1 && (b === -1 || c < b) && (b = c);
    b === -1 && (b = d.length), d[b - 1] === ":" && b--;
    var y = d.slice(0, b);
    d = d.slice(b), this.parseHost(y), this.hostname = this.hostname || "";
    var I = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!I) {
      var E = this.hostname.split(/\./);
      for (r = 0, o = E.length; r < o; r++) {
        var T = E[r];
        if (T && !T.match(hostnamePartPattern)) {
          for (var C = "", $ = 0, D = T.length; $ < D; $++)
            T.charCodeAt($) > 127 ? C += "x" : C += T[$];
          if (!C.match(hostnamePartPattern)) {
            var L = E.slice(0, r), R = E.slice(r + 1), O = T.match(hostnamePartStart);
            O && (L.push(O[1]), R.unshift(O[2])), R.length && (d = R.join(".") + d), this.hostname = L.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > hostnameMaxLen && (this.hostname = ""), I && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  var P = d.indexOf("#");
  P !== -1 && (this.hash = d.substr(P), d = d.slice(0, P));
  var z = d.indexOf("?");
  return z !== -1 && (this.search = d.substr(z), d = d.slice(0, z)), d && (this.pathname = d), slashedProtocol[a] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
Url.prototype.parseHost = function(t) {
  var e = portPattern.exec(t);
  e && (e = e[0], e !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
};
var parse$1 = urlParse;
mdurl$1.encode = encode_1;
mdurl$1.decode = decode_1;
mdurl$1.format = format$3;
mdurl$1.parse = parse$1;
var uc_micro = {}, regex$3, hasRequiredRegex$3;
function requireRegex$3() {
  return hasRequiredRegex$3 || (hasRequiredRegex$3 = 1, regex$3 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/), regex$3;
}
var regex$2, hasRequiredRegex$2;
function requireRegex$2() {
  return hasRequiredRegex$2 || (hasRequiredRegex$2 = 1, regex$2 = /[\0-\x1F\x7F-\x9F]/), regex$2;
}
var regex$1, hasRequiredRegex$1;
function requireRegex$1() {
  return hasRequiredRegex$1 || (hasRequiredRegex$1 = 1, regex$1 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), regex$1;
}
var regex, hasRequiredRegex;
function requireRegex() {
  return hasRequiredRegex || (hasRequiredRegex = 1, regex = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/), regex;
}
var hasRequiredUc_micro;
function requireUc_micro() {
  return hasRequiredUc_micro || (hasRequiredUc_micro = 1, uc_micro.Any = requireRegex$3(), uc_micro.Cc = requireRegex$2(), uc_micro.Cf = requireRegex$1(), uc_micro.P = regex$4, uc_micro.Z = requireRegex()), uc_micro;
}
(function(t) {
  function e(M) {
    return Object.prototype.toString.call(M);
  }
  function r(M) {
    return e(M) === "[object String]";
  }
  var o = Object.prototype.hasOwnProperty;
  function a(M, V) {
    return o.call(M, V);
  }
  function c(M) {
    var V = Array.prototype.slice.call(arguments, 1);
    return V.forEach(function(G) {
      if (G) {
        if (typeof G != "object")
          throw new TypeError(G + "must be object");
        Object.keys(G).forEach(function(Q) {
          M[Q] = G[Q];
        });
      }
    }), M;
  }
  function u(M, V, G) {
    return [].concat(M.slice(0, V), G, M.slice(V + 1));
  }
  function d(M) {
    return !(M >= 55296 && M <= 57343 || M >= 64976 && M <= 65007 || (M & 65535) === 65535 || (M & 65535) === 65534 || M >= 0 && M <= 8 || M === 11 || M >= 14 && M <= 31 || M >= 127 && M <= 159 || M > 1114111);
  }
  function p(M) {
    if (M > 65535) {
      M -= 65536;
      var V = 55296 + (M >> 10), G = 56320 + (M & 1023);
      return String.fromCharCode(V, G);
    }
    return String.fromCharCode(M);
  }
  var g = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g, b = /&([a-z#][a-z0-9]{1,31});/gi, x = new RegExp(g.source + "|" + b.source, "gi"), w = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i, y = entities$1;
  function I(M, V) {
    var G;
    return a(y, V) ? y[V] : V.charCodeAt(0) === 35 && w.test(V) && (G = V[1].toLowerCase() === "x" ? parseInt(V.slice(2), 16) : parseInt(V.slice(1), 10), d(G)) ? p(G) : M;
  }
  function E(M) {
    return M.indexOf("\\") < 0 ? M : M.replace(g, "$1");
  }
  function T(M) {
    return M.indexOf("\\") < 0 && M.indexOf("&") < 0 ? M : M.replace(x, function(V, G, Q) {
      return G || I(V, Q);
    });
  }
  var C = /[&<>"]/, $ = /[&<>"]/g, D = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
  };
  function L(M) {
    return D[M];
  }
  function R(M) {
    return C.test(M) ? M.replace($, L) : M;
  }
  var O = /[.?*+^$[\]\\(){}|-]/g;
  function P(M) {
    return M.replace(O, "\\$&");
  }
  function z(M) {
    switch (M) {
      case 9:
      case 32:
        return !0;
    }
    return !1;
  }
  function W(M) {
    if (M >= 8192 && M <= 8202)
      return !0;
    switch (M) {
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 32:
      case 160:
      case 5760:
      case 8239:
      case 8287:
      case 12288:
        return !0;
    }
    return !1;
  }
  var A = regex$4;
  function S(M) {
    return A.test(M);
  }
  function F(M) {
    switch (M) {
      case 33:
      case 34:
      case 35:
      case 36:
      case 37:
      case 38:
      case 39:
      case 40:
      case 41:
      case 42:
      case 43:
      case 44:
      case 45:
      case 46:
      case 47:
      case 58:
      case 59:
      case 60:
      case 61:
      case 62:
      case 63:
      case 64:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 123:
      case 124:
      case 125:
      case 126:
        return !0;
      default:
        return !1;
    }
  }
  function U(M) {
    return M = M.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (M = M.replace(/ẞ/g, "ß")), M.toLowerCase().toUpperCase();
  }
  t.lib = {}, t.lib.mdurl = mdurl$1, t.lib.ucmicro = requireUc_micro(), t.assign = c, t.isString = r, t.has = a, t.unescapeMd = E, t.unescapeAll = T, t.isValidEntityCode = d, t.fromCodePoint = p, t.escapeHtml = R, t.arrayReplaceAt = u, t.isSpace = z, t.isWhiteSpace = W, t.isMdAsciiPunct = F, t.isPunctChar = S, t.escapeRE = P, t.normalizeReference = U;
})(utils$1);
var helpers$1 = {}, parse_link_label = function t(e, r, o) {
  var a, c, u, d, p = -1, g = e.posMax, b = e.pos;
  for (e.pos = r + 1, a = 1; e.pos < g; ) {
    if (u = e.src.charCodeAt(e.pos), u === 93 && (a--, a === 0)) {
      c = !0;
      break;
    }
    if (d = e.pos, e.md.inline.skipToken(e), u === 91) {
      if (d === e.pos - 1)
        a++;
      else if (o)
        return e.pos = b, -1;
    }
  }
  return c && (p = e.pos), e.pos = b, p;
}, unescapeAll$2 = utils$1.unescapeAll, parse_link_destination = function t(e, r, o) {
  var a, c, u = r, d = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (e.charCodeAt(u) === 60) {
    for (u++; u < o; ) {
      if (a = e.charCodeAt(u), a === 10 || a === 60)
        return d;
      if (a === 62)
        return d.pos = u + 1, d.str = unescapeAll$2(e.slice(r + 1, u)), d.ok = !0, d;
      if (a === 92 && u + 1 < o) {
        u += 2;
        continue;
      }
      u++;
    }
    return d;
  }
  for (c = 0; u < o && (a = e.charCodeAt(u), !(a === 32 || a < 32 || a === 127)); ) {
    if (a === 92 && u + 1 < o) {
      if (e.charCodeAt(u + 1) === 32)
        break;
      u += 2;
      continue;
    }
    if (a === 40 && (c++, c > 32))
      return d;
    if (a === 41) {
      if (c === 0)
        break;
      c--;
    }
    u++;
  }
  return r === u || c !== 0 || (d.str = unescapeAll$2(e.slice(r, u)), d.pos = u, d.ok = !0), d;
}, unescapeAll$1 = utils$1.unescapeAll, parse_link_title = function t(e, r, o) {
  var a, c, u = 0, d = r, p = {
    ok: !1,
    pos: 0,
    lines: 0,
    str: ""
  };
  if (d >= o || (c = e.charCodeAt(d), c !== 34 && c !== 39 && c !== 40))
    return p;
  for (d++, c === 40 && (c = 41); d < o; ) {
    if (a = e.charCodeAt(d), a === c)
      return p.pos = d + 1, p.lines = u, p.str = unescapeAll$1(e.slice(r + 1, d)), p.ok = !0, p;
    if (a === 40 && c === 41)
      return p;
    a === 10 ? u++ : a === 92 && d + 1 < o && (d++, e.charCodeAt(d) === 10 && u++), d++;
  }
  return p;
};
helpers$1.parseLinkLabel = parse_link_label;
helpers$1.parseLinkDestination = parse_link_destination;
helpers$1.parseLinkTitle = parse_link_title;
var assign$3 = utils$1.assign, unescapeAll = utils$1.unescapeAll, escapeHtml$1 = utils$1.escapeHtml, default_rules = {};
default_rules.code_inline = function(t, e, r, o, a) {
  var c = t[e];
  return "<code" + a.renderAttrs(c) + ">" + escapeHtml$1(c.content) + "</code>";
};
default_rules.code_block = function(t, e, r, o, a) {
  var c = t[e];
  return "<pre" + a.renderAttrs(c) + "><code>" + escapeHtml$1(t[e].content) + `</code></pre>
`;
};
default_rules.fence = function(t, e, r, o, a) {
  var c = t[e], u = c.info ? unescapeAll(c.info).trim() : "", d = "", p = "", g, b, x, w, y;
  return u && (x = u.split(/(\s+)/g), d = x[0], p = x.slice(2).join("")), r.highlight ? g = r.highlight(c.content, d, p) || escapeHtml$1(c.content) : g = escapeHtml$1(c.content), g.indexOf("<pre") === 0 ? g + `
` : u ? (b = c.attrIndex("class"), w = c.attrs ? c.attrs.slice() : [], b < 0 ? w.push(["class", r.langPrefix + d]) : (w[b] = w[b].slice(), w[b][1] += " " + r.langPrefix + d), y = {
    attrs: w
  }, "<pre><code" + a.renderAttrs(y) + ">" + g + `</code></pre>
`) : "<pre><code" + a.renderAttrs(c) + ">" + g + `</code></pre>
`;
};
default_rules.image = function(t, e, r, o, a) {
  var c = t[e];
  return c.attrs[c.attrIndex("alt")][1] = a.renderInlineAsText(c.children, r, o), a.renderToken(t, e, r);
};
default_rules.hardbreak = function(t, e, r) {
  return r.xhtmlOut ? `<br />
` : `<br>
`;
};
default_rules.softbreak = function(t, e, r) {
  return r.breaks ? r.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
default_rules.text = function(t, e) {
  return escapeHtml$1(t[e].content);
};
default_rules.html_block = function(t, e) {
  return t[e].content;
};
default_rules.html_inline = function(t, e) {
  return t[e].content;
};
function Renderer$1() {
  this.rules = assign$3({}, default_rules);
}
Renderer$1.prototype.renderAttrs = function t(e) {
  var r, o, a;
  if (!e.attrs)
    return "";
  for (a = "", r = 0, o = e.attrs.length; r < o; r++)
    a += " " + escapeHtml$1(e.attrs[r][0]) + '="' + escapeHtml$1(e.attrs[r][1]) + '"';
  return a;
};
Renderer$1.prototype.renderToken = function t(e, r, o) {
  var a, c = "", u = !1, d = e[r];
  return d.hidden ? "" : (d.block && d.nesting !== -1 && r && e[r - 1].hidden && (c += `
`), c += (d.nesting === -1 ? "</" : "<") + d.tag, c += this.renderAttrs(d), d.nesting === 0 && o.xhtmlOut && (c += " /"), d.block && (u = !0, d.nesting === 1 && r + 1 < e.length && (a = e[r + 1], (a.type === "inline" || a.hidden || a.nesting === -1 && a.tag === d.tag) && (u = !1))), c += u ? `>
` : ">", c);
};
Renderer$1.prototype.renderInline = function(t, e, r) {
  for (var o, a = "", c = this.rules, u = 0, d = t.length; u < d; u++)
    o = t[u].type, typeof c[o] < "u" ? a += c[o](t, u, e, r, this) : a += this.renderToken(t, u, e);
  return a;
};
Renderer$1.prototype.renderInlineAsText = function(t, e, r) {
  for (var o = "", a = 0, c = t.length; a < c; a++)
    t[a].type === "text" ? o += t[a].content : t[a].type === "image" ? o += this.renderInlineAsText(t[a].children, e, r) : t[a].type === "softbreak" && (o += `
`);
  return o;
};
Renderer$1.prototype.render = function(t, e, r) {
  var o, a, c, u = "", d = this.rules;
  for (o = 0, a = t.length; o < a; o++)
    c = t[o].type, c === "inline" ? u += this.renderInline(t[o].children, e, r) : typeof d[c] < "u" ? u += d[c](t, o, e, r, this) : u += this.renderToken(t, o, e, r);
  return u;
};
var renderer = Renderer$1;
function Ruler$3() {
  this.__rules__ = [], this.__cache__ = null;
}
Ruler$3.prototype.__find__ = function(t) {
  for (var e = 0; e < this.__rules__.length; e++)
    if (this.__rules__[e].name === t)
      return e;
  return -1;
};
Ruler$3.prototype.__compile__ = function() {
  var t = this, e = [""];
  t.__rules__.forEach(function(r) {
    r.enabled && r.alt.forEach(function(o) {
      e.indexOf(o) < 0 && e.push(o);
    });
  }), t.__cache__ = {}, e.forEach(function(r) {
    t.__cache__[r] = [], t.__rules__.forEach(function(o) {
      o.enabled && (r && o.alt.indexOf(r) < 0 || t.__cache__[r].push(o.fn));
    });
  });
};
Ruler$3.prototype.at = function(t, e, r) {
  var o = this.__find__(t), a = r || {};
  if (o === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__[o].fn = e, this.__rules__[o].alt = a.alt || [], this.__cache__ = null;
};
Ruler$3.prototype.before = function(t, e, r, o) {
  var a = this.__find__(t), c = o || {};
  if (a === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(a, 0, {
    name: e,
    enabled: !0,
    fn: r,
    alt: c.alt || []
  }), this.__cache__ = null;
};
Ruler$3.prototype.after = function(t, e, r, o) {
  var a = this.__find__(t), c = o || {};
  if (a === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(a + 1, 0, {
    name: e,
    enabled: !0,
    fn: r,
    alt: c.alt || []
  }), this.__cache__ = null;
};
Ruler$3.prototype.push = function(t, e, r) {
  var o = r || {};
  this.__rules__.push({
    name: t,
    enabled: !0,
    fn: e,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Ruler$3.prototype.enable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  var r = [];
  return t.forEach(function(o) {
    var a = this.__find__(o);
    if (a < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[a].enabled = !0, r.push(o);
  }, this), this.__cache__ = null, r;
};
Ruler$3.prototype.enableOnly = function(t, e) {
  Array.isArray(t) || (t = [t]), this.__rules__.forEach(function(r) {
    r.enabled = !1;
  }), this.enable(t, e);
};
Ruler$3.prototype.disable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  var r = [];
  return t.forEach(function(o) {
    var a = this.__find__(o);
    if (a < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + o);
    }
    this.__rules__[a].enabled = !1, r.push(o);
  }, this), this.__cache__ = null, r;
};
Ruler$3.prototype.getRules = function(t) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[t] || [];
};
var ruler = Ruler$3, NEWLINES_RE = /\r\n?|\n/g, NULL_RE = /\0/g, normalize = function t(e) {
  var r;
  r = e.src.replace(NEWLINES_RE, `
`), r = r.replace(NULL_RE, "�"), e.src = r;
}, block = function t(e) {
  var r;
  e.inlineMode ? (r = new e.Token("inline", "", 0), r.content = e.src, r.map = [0, 1], r.children = [], e.tokens.push(r)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}, inline = function t(e) {
  var r = e.tokens, o, a, c;
  for (a = 0, c = r.length; a < c; a++)
    o = r[a], o.type === "inline" && e.md.inline.parse(o.content, e.md, e.env, o.children);
}, arrayReplaceAt = utils$1.arrayReplaceAt;
function isLinkOpen$1(t) {
  return /^<a[>\s]/i.test(t);
}
function isLinkClose$1(t) {
  return /^<\/a\s*>/i.test(t);
}
var linkify$1 = function t(e) {
  var r, o, a, c, u, d, p, g, b, x, w, y, I, E, T, C, $ = e.tokens, D;
  if (e.md.options.linkify) {
    for (o = 0, a = $.length; o < a; o++)
      if (!($[o].type !== "inline" || !e.md.linkify.pretest($[o].content)))
        for (c = $[o].children, I = 0, r = c.length - 1; r >= 0; r--) {
          if (d = c[r], d.type === "link_close") {
            for (r--; c[r].level !== d.level && c[r].type !== "link_open"; )
              r--;
            continue;
          }
          if (d.type === "html_inline" && (isLinkOpen$1(d.content) && I > 0 && I--, isLinkClose$1(d.content) && I++), !(I > 0) && d.type === "text" && e.md.linkify.test(d.content)) {
            for (b = d.content, D = e.md.linkify.match(b), p = [], y = d.level, w = 0, D.length > 0 && D[0].index === 0 && r > 0 && c[r - 1].type === "text_special" && (D = D.slice(1)), g = 0; g < D.length; g++)
              E = D[g].url, T = e.md.normalizeLink(E), e.md.validateLink(T) && (C = D[g].text, D[g].schema ? D[g].schema === "mailto:" && !/^mailto:/i.test(C) ? C = e.md.normalizeLinkText("mailto:" + C).replace(/^mailto:/, "") : C = e.md.normalizeLinkText(C) : C = e.md.normalizeLinkText("http://" + C).replace(/^http:\/\//, ""), x = D[g].index, x > w && (u = new e.Token("text", "", 0), u.content = b.slice(w, x), u.level = y, p.push(u)), u = new e.Token("link_open", "a", 1), u.attrs = [["href", T]], u.level = y++, u.markup = "linkify", u.info = "auto", p.push(u), u = new e.Token("text", "", 0), u.content = C, u.level = y, p.push(u), u = new e.Token("link_close", "a", -1), u.level = --y, u.markup = "linkify", u.info = "auto", p.push(u), w = D[g].lastIndex);
            w < b.length && (u = new e.Token("text", "", 0), u.content = b.slice(w), u.level = y, p.push(u)), $[o].children = c = arrayReplaceAt(c, r, p);
          }
        }
  }
}, RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i, SCOPED_ABBR_RE = /\((c|tm|r)\)/ig, SCOPED_ABBR = {
  c: "©",
  r: "®",
  tm: "™"
};
function replaceFn(t, e) {
  return SCOPED_ABBR[e.toLowerCase()];
}
function replace_scoped(t) {
  var e, r, o = 0;
  for (e = t.length - 1; e >= 0; e--)
    r = t[e], r.type === "text" && !o && (r.content = r.content.replace(SCOPED_ABBR_RE, replaceFn)), r.type === "link_open" && r.info === "auto" && o--, r.type === "link_close" && r.info === "auto" && o++;
}
function replace_rare(t) {
  var e, r, o = 0;
  for (e = t.length - 1; e >= 0; e--)
    r = t[e], r.type === "text" && !o && RARE_RE.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && o--, r.type === "link_close" && r.info === "auto" && o++;
}
var replacements = function t(e) {
  var r;
  if (e.md.options.typographer)
    for (r = e.tokens.length - 1; r >= 0; r--)
      e.tokens[r].type === "inline" && (SCOPED_ABBR_TEST_RE.test(e.tokens[r].content) && replace_scoped(e.tokens[r].children), RARE_RE.test(e.tokens[r].content) && replace_rare(e.tokens[r].children));
}, isWhiteSpace$1 = utils$1.isWhiteSpace, isPunctChar$1 = utils$1.isPunctChar, isMdAsciiPunct$1 = utils$1.isMdAsciiPunct, QUOTE_TEST_RE = /['"]/, QUOTE_RE = /['"]/g, APOSTROPHE = "’";
function replaceAt(t, e, r) {
  return t.slice(0, e) + r + t.slice(e + 1);
}
function process_inlines(t, e) {
  var r, o, a, c, u, d, p, g, b, x, w, y, I, E, T, C, $, D, L, R, O;
  for (L = [], r = 0; r < t.length; r++) {
    for (o = t[r], p = t[r].level, $ = L.length - 1; $ >= 0 && !(L[$].level <= p); $--)
      ;
    if (L.length = $ + 1, o.type === "text") {
      a = o.content, u = 0, d = a.length;
      e:
        for (; u < d && (QUOTE_RE.lastIndex = u, c = QUOTE_RE.exec(a), !!c); ) {
          if (T = C = !0, u = c.index + 1, D = c[0] === "'", b = 32, c.index - 1 >= 0)
            b = a.charCodeAt(c.index - 1);
          else
            for ($ = r - 1; $ >= 0 && !(t[$].type === "softbreak" || t[$].type === "hardbreak"); $--)
              if (t[$].content) {
                b = t[$].content.charCodeAt(t[$].content.length - 1);
                break;
              }
          if (x = 32, u < d)
            x = a.charCodeAt(u);
          else
            for ($ = r + 1; $ < t.length && !(t[$].type === "softbreak" || t[$].type === "hardbreak"); $++)
              if (t[$].content) {
                x = t[$].content.charCodeAt(0);
                break;
              }
          if (w = isMdAsciiPunct$1(b) || isPunctChar$1(String.fromCharCode(b)), y = isMdAsciiPunct$1(x) || isPunctChar$1(String.fromCharCode(x)), I = isWhiteSpace$1(b), E = isWhiteSpace$1(x), E ? T = !1 : y && (I || w || (T = !1)), I ? C = !1 : w && (E || y || (C = !1)), x === 34 && c[0] === '"' && b >= 48 && b <= 57 && (C = T = !1), T && C && (T = w, C = y), !T && !C) {
            D && (o.content = replaceAt(o.content, c.index, APOSTROPHE));
            continue;
          }
          if (C) {
            for ($ = L.length - 1; $ >= 0 && (g = L[$], !(L[$].level < p)); $--)
              if (g.single === D && L[$].level === p) {
                g = L[$], D ? (R = e.md.options.quotes[2], O = e.md.options.quotes[3]) : (R = e.md.options.quotes[0], O = e.md.options.quotes[1]), o.content = replaceAt(o.content, c.index, O), t[g.token].content = replaceAt(
                  t[g.token].content,
                  g.pos,
                  R
                ), u += O.length - 1, g.token === r && (u += R.length - 1), a = o.content, d = a.length, L.length = $;
                continue e;
              }
          }
          T ? L.push({
            token: r,
            pos: c.index,
            single: D,
            level: p
          }) : C && D && (o.content = replaceAt(o.content, c.index, APOSTROPHE));
        }
    }
  }
}
var smartquotes = function t(e) {
  var r;
  if (e.md.options.typographer)
    for (r = e.tokens.length - 1; r >= 0; r--)
      e.tokens[r].type !== "inline" || !QUOTE_TEST_RE.test(e.tokens[r].content) || process_inlines(e.tokens[r].children, e);
}, text_join = function t(e) {
  var r, o, a, c, u, d, p = e.tokens;
  for (r = 0, o = p.length; r < o; r++)
    if (p[r].type === "inline") {
      for (a = p[r].children, u = a.length, c = 0; c < u; c++)
        a[c].type === "text_special" && (a[c].type = "text");
      for (c = d = 0; c < u; c++)
        a[c].type === "text" && c + 1 < u && a[c + 1].type === "text" ? a[c + 1].content = a[c].content + a[c + 1].content : (c !== d && (a[d] = a[c]), d++);
      c !== d && (a.length = d);
    }
};
function Token$3(t, e, r) {
  this.type = t, this.tag = e, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
Token$3.prototype.attrIndex = function t(e) {
  var r, o, a;
  if (!this.attrs)
    return -1;
  for (r = this.attrs, o = 0, a = r.length; o < a; o++)
    if (r[o][0] === e)
      return o;
  return -1;
};
Token$3.prototype.attrPush = function t(e) {
  this.attrs ? this.attrs.push(e) : this.attrs = [e];
};
Token$3.prototype.attrSet = function t(e, r) {
  var o = this.attrIndex(e), a = [e, r];
  o < 0 ? this.attrPush(a) : this.attrs[o] = a;
};
Token$3.prototype.attrGet = function t(e) {
  var r = this.attrIndex(e), o = null;
  return r >= 0 && (o = this.attrs[r][1]), o;
};
Token$3.prototype.attrJoin = function t(e, r) {
  var o = this.attrIndex(e);
  o < 0 ? this.attrPush([e, r]) : this.attrs[o][1] = this.attrs[o][1] + " " + r;
};
var token = Token$3, Token$2 = token;
function StateCore(t, e, r) {
  this.src = t, this.env = r, this.tokens = [], this.inlineMode = !1, this.md = e;
}
StateCore.prototype.Token = Token$2;
var state_core = StateCore, Ruler$2 = ruler, _rules$2 = [
  ["normalize", normalize],
  ["block", block],
  ["inline", inline],
  ["linkify", linkify$1],
  ["replacements", replacements],
  ["smartquotes", smartquotes],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", text_join]
];
function Core() {
  this.ruler = new Ruler$2();
  for (var t = 0; t < _rules$2.length; t++)
    this.ruler.push(_rules$2[t][0], _rules$2[t][1]);
}
Core.prototype.process = function(t) {
  var e, r, o;
  for (o = this.ruler.getRules(""), e = 0, r = o.length; e < r; e++)
    o[e](t);
};
Core.prototype.State = state_core;
var parser_core = Core, isSpace$a = utils$1.isSpace;
function getLine(t, e) {
  var r = t.bMarks[e] + t.tShift[e], o = t.eMarks[e];
  return t.src.slice(r, o);
}
function escapedSplit(t) {
  var e = [], r = 0, o = t.length, a, c = !1, u = 0, d = "";
  for (a = t.charCodeAt(r); r < o; )
    a === 124 && (c ? (d += t.substring(u, r - 1), u = r) : (e.push(d + t.substring(u, r)), d = "", u = r + 1)), c = a === 92, r++, a = t.charCodeAt(r);
  return e.push(d + t.substring(u)), e;
}
var table = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w, y, I, E, T, C, $, D, L, R, O;
  if (r + 2 > o || (b = r + 1, e.sCount[b] < e.blkIndent) || e.sCount[b] - e.blkIndent >= 4 || (d = e.bMarks[b] + e.tShift[b], d >= e.eMarks[b]) || (R = e.src.charCodeAt(d++), R !== 124 && R !== 45 && R !== 58) || d >= e.eMarks[b] || (O = e.src.charCodeAt(d++), O !== 124 && O !== 45 && O !== 58 && !isSpace$a(O)) || R === 45 && isSpace$a(O))
    return !1;
  for (; d < e.eMarks[b]; ) {
    if (c = e.src.charCodeAt(d), c !== 124 && c !== 45 && c !== 58 && !isSpace$a(c))
      return !1;
    d++;
  }
  for (u = getLine(e, r + 1), x = u.split("|"), I = [], p = 0; p < x.length; p++) {
    if (E = x[p].trim(), !E) {
      if (p === 0 || p === x.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(E))
      return !1;
    E.charCodeAt(E.length - 1) === 58 ? I.push(E.charCodeAt(0) === 58 ? "center" : "right") : E.charCodeAt(0) === 58 ? I.push("left") : I.push("");
  }
  if (u = getLine(e, r).trim(), u.indexOf("|") === -1 || e.sCount[r] - e.blkIndent >= 4 || (x = escapedSplit(u), x.length && x[0] === "" && x.shift(), x.length && x[x.length - 1] === "" && x.pop(), w = x.length, w === 0 || w !== I.length))
    return !1;
  if (a)
    return !0;
  for ($ = e.parentType, e.parentType = "table", L = e.md.block.ruler.getRules("blockquote"), y = e.push("table_open", "table", 1), y.map = T = [r, 0], y = e.push("thead_open", "thead", 1), y.map = [r, r + 1], y = e.push("tr_open", "tr", 1), y.map = [r, r + 1], p = 0; p < x.length; p++)
    y = e.push("th_open", "th", 1), I[p] && (y.attrs = [["style", "text-align:" + I[p]]]), y = e.push("inline", "", 0), y.content = x[p].trim(), y.children = [], y = e.push("th_close", "th", -1);
  for (y = e.push("tr_close", "tr", -1), y = e.push("thead_close", "thead", -1), b = r + 2; b < o && !(e.sCount[b] < e.blkIndent); b++) {
    for (D = !1, p = 0, g = L.length; p < g; p++)
      if (L[p](e, b, o, !0)) {
        D = !0;
        break;
      }
    if (D || (u = getLine(e, b).trim(), !u) || e.sCount[b] - e.blkIndent >= 4)
      break;
    for (x = escapedSplit(u), x.length && x[0] === "" && x.shift(), x.length && x[x.length - 1] === "" && x.pop(), b === r + 2 && (y = e.push("tbody_open", "tbody", 1), y.map = C = [r + 2, 0]), y = e.push("tr_open", "tr", 1), y.map = [b, b + 1], p = 0; p < w; p++)
      y = e.push("td_open", "td", 1), I[p] && (y.attrs = [["style", "text-align:" + I[p]]]), y = e.push("inline", "", 0), y.content = x[p] ? x[p].trim() : "", y.children = [], y = e.push("td_close", "td", -1);
    y = e.push("tr_close", "tr", -1);
  }
  return C && (y = e.push("tbody_close", "tbody", -1), C[1] = b), y = e.push("table_close", "table", -1), T[1] = b, e.parentType = $, e.line = b, !0;
}, code$3 = function t(e, r, o) {
  var a, c, u;
  if (e.sCount[r] - e.blkIndent < 4)
    return !1;
  for (c = a = r + 1; a < o; ) {
    if (e.isEmpty(a)) {
      a++;
      continue;
    }
    if (e.sCount[a] - e.blkIndent >= 4) {
      a++, c = a;
      continue;
    }
    break;
  }
  return e.line = c, u = e.push("code_block", "code", 0), u.content = e.getLines(r, c, 4 + e.blkIndent, !1) + `
`, u.map = [r, e.line], !0;
}, fence = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w = !1, y = e.bMarks[r] + e.tShift[r], I = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || y + 3 > I || (c = e.src.charCodeAt(y), c !== 126 && c !== 96) || (g = y, y = e.skipChars(y, c), u = y - g, u < 3) || (x = e.src.slice(g, y), d = e.src.slice(y, I), c === 96 && d.indexOf(String.fromCharCode(c)) >= 0))
    return !1;
  if (a)
    return !0;
  for (p = r; p++, !(p >= o || (y = g = e.bMarks[p] + e.tShift[p], I = e.eMarks[p], y < I && e.sCount[p] < e.blkIndent)); )
    if (e.src.charCodeAt(y) === c && !(e.sCount[p] - e.blkIndent >= 4) && (y = e.skipChars(y, c), !(y - g < u) && (y = e.skipSpaces(y), !(y < I)))) {
      w = !0;
      break;
    }
  return u = e.sCount[r], e.line = p + (w ? 1 : 0), b = e.push("fence", "code", 0), b.info = d, b.content = e.getLines(r + 1, p, u, !0), b.markup = x, b.map = [r, e.line], !0;
}, isSpace$9 = utils$1.isSpace, blockquote = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w, y, I, E, T, C, $, D, L, R, O, P, z, W = e.lineMax, A = e.bMarks[r] + e.tShift[r], S = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || e.src.charCodeAt(A) !== 62)
    return !1;
  if (a)
    return !0;
  for (I = [], E = [], $ = [], D = [], O = e.md.block.ruler.getRules("blockquote"), C = e.parentType, e.parentType = "blockquote", w = r; w < o && (z = e.sCount[w] < e.blkIndent, A = e.bMarks[w] + e.tShift[w], S = e.eMarks[w], !(A >= S)); w++) {
    if (e.src.charCodeAt(A++) === 62 && !z) {
      for (p = e.sCount[w] + 1, e.src.charCodeAt(A) === 32 ? (A++, p++, c = !1, L = !0) : e.src.charCodeAt(A) === 9 ? (L = !0, (e.bsCount[w] + p) % 4 === 3 ? (A++, p++, c = !1) : c = !0) : L = !1, y = p, I.push(e.bMarks[w]), e.bMarks[w] = A; A < S && (u = e.src.charCodeAt(A), isSpace$9(u)); ) {
        u === 9 ? y += 4 - (y + e.bsCount[w] + (c ? 1 : 0)) % 4 : y++;
        A++;
      }
      b = A >= S, E.push(e.bsCount[w]), e.bsCount[w] = e.sCount[w] + 1 + (L ? 1 : 0), $.push(e.sCount[w]), e.sCount[w] = y - p, D.push(e.tShift[w]), e.tShift[w] = A - e.bMarks[w];
      continue;
    }
    if (b)
      break;
    for (R = !1, d = 0, g = O.length; d < g; d++)
      if (O[d](e, w, o, !0)) {
        R = !0;
        break;
      }
    if (R) {
      e.lineMax = w, e.blkIndent !== 0 && (I.push(e.bMarks[w]), E.push(e.bsCount[w]), D.push(e.tShift[w]), $.push(e.sCount[w]), e.sCount[w] -= e.blkIndent);
      break;
    }
    I.push(e.bMarks[w]), E.push(e.bsCount[w]), D.push(e.tShift[w]), $.push(e.sCount[w]), e.sCount[w] = -1;
  }
  for (T = e.blkIndent, e.blkIndent = 0, P = e.push("blockquote_open", "blockquote", 1), P.markup = ">", P.map = x = [r, 0], e.md.block.tokenize(e, r, w), P = e.push("blockquote_close", "blockquote", -1), P.markup = ">", e.lineMax = W, e.parentType = C, x[1] = e.line, d = 0; d < D.length; d++)
    e.bMarks[d + r] = I[d], e.tShift[d + r] = D[d], e.sCount[d + r] = $[d], e.bsCount[d + r] = E[d];
  return e.blkIndent = T, !0;
}, isSpace$8 = utils$1.isSpace, hr = function t(e, r, o, a) {
  var c, u, d, p, g = e.bMarks[r] + e.tShift[r], b = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || (c = e.src.charCodeAt(g++), c !== 42 && c !== 45 && c !== 95))
    return !1;
  for (u = 1; g < b; ) {
    if (d = e.src.charCodeAt(g++), d !== c && !isSpace$8(d))
      return !1;
    d === c && u++;
  }
  return u < 3 ? !1 : (a || (e.line = r + 1, p = e.push("hr", "hr", 0), p.map = [r, e.line], p.markup = Array(u + 1).join(String.fromCharCode(c))), !0);
}, isSpace$7 = utils$1.isSpace;
function skipBulletListMarker(t, e) {
  var r, o, a, c;
  return o = t.bMarks[e] + t.tShift[e], a = t.eMarks[e], r = t.src.charCodeAt(o++), r !== 42 && r !== 45 && r !== 43 || o < a && (c = t.src.charCodeAt(o), !isSpace$7(c)) ? -1 : o;
}
function skipOrderedListMarker(t, e) {
  var r, o = t.bMarks[e] + t.tShift[e], a = o, c = t.eMarks[e];
  if (a + 1 >= c || (r = t.src.charCodeAt(a++), r < 48 || r > 57))
    return -1;
  for (; ; ) {
    if (a >= c)
      return -1;
    if (r = t.src.charCodeAt(a++), r >= 48 && r <= 57) {
      if (a - o >= 10)
        return -1;
      continue;
    }
    if (r === 41 || r === 46)
      break;
    return -1;
  }
  return a < c && (r = t.src.charCodeAt(a), !isSpace$7(r)) ? -1 : a;
}
function markTightParagraphs(t, e) {
  var r, o, a = t.level + 2;
  for (r = e + 2, o = t.tokens.length - 2; r < o; r++)
    t.tokens[r].level === a && t.tokens[r].type === "paragraph_open" && (t.tokens[r + 2].hidden = !0, t.tokens[r].hidden = !0, r += 2);
}
var list = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w, y, I, E, T, C, $, D, L, R, O, P, z, W, A, S, F, U, M, V, G = r, Q = !1, fe = !0;
  if (e.sCount[G] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[G] - e.listIndent >= 4 && e.sCount[G] < e.blkIndent)
    return !1;
  if (a && e.parentType === "paragraph" && e.sCount[G] >= e.blkIndent && (Q = !0), (A = skipOrderedListMarker(e, G)) >= 0) {
    if (x = !0, F = e.bMarks[G] + e.tShift[G], C = Number(e.src.slice(F, A - 1)), Q && C !== 1)
      return !1;
  } else if ((A = skipBulletListMarker(e, G)) >= 0)
    x = !1;
  else
    return !1;
  if (Q && e.skipSpaces(A) >= e.eMarks[G])
    return !1;
  if (a)
    return !0;
  for (T = e.src.charCodeAt(A - 1), E = e.tokens.length, x ? (V = e.push("ordered_list_open", "ol", 1), C !== 1 && (V.attrs = [["start", C]])) : V = e.push("bullet_list_open", "ul", 1), V.map = I = [G, 0], V.markup = String.fromCharCode(T), S = !1, M = e.md.block.ruler.getRules("list"), R = e.parentType, e.parentType = "list"; G < o; ) {
    for (W = A, $ = e.eMarks[G], b = D = e.sCount[G] + A - (e.bMarks[G] + e.tShift[G]); W < $; ) {
      if (c = e.src.charCodeAt(W), c === 9)
        D += 4 - (D + e.bsCount[G]) % 4;
      else if (c === 32)
        D++;
      else
        break;
      W++;
    }
    if (u = W, u >= $ ? g = 1 : g = D - b, g > 4 && (g = 1), p = b + g, V = e.push("list_item_open", "li", 1), V.markup = String.fromCharCode(T), V.map = w = [G, 0], x && (V.info = e.src.slice(F, A - 1)), z = e.tight, P = e.tShift[G], O = e.sCount[G], L = e.listIndent, e.listIndent = e.blkIndent, e.blkIndent = p, e.tight = !0, e.tShift[G] = u - e.bMarks[G], e.sCount[G] = D, u >= $ && e.isEmpty(G + 1) ? e.line = Math.min(e.line + 2, o) : e.md.block.tokenize(e, G, o, !0), (!e.tight || S) && (fe = !1), S = e.line - G > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = L, e.tShift[G] = P, e.sCount[G] = O, e.tight = z, V = e.push("list_item_close", "li", -1), V.markup = String.fromCharCode(T), G = e.line, w[1] = G, G >= o || e.sCount[G] < e.blkIndent || e.sCount[G] - e.blkIndent >= 4)
      break;
    for (U = !1, d = 0, y = M.length; d < y; d++)
      if (M[d](e, G, o, !0)) {
        U = !0;
        break;
      }
    if (U)
      break;
    if (x) {
      if (A = skipOrderedListMarker(e, G), A < 0)
        break;
      F = e.bMarks[G] + e.tShift[G];
    } else if (A = skipBulletListMarker(e, G), A < 0)
      break;
    if (T !== e.src.charCodeAt(A - 1))
      break;
  }
  return x ? V = e.push("ordered_list_close", "ol", -1) : V = e.push("bullet_list_close", "ul", -1), V.markup = String.fromCharCode(T), I[1] = G, e.line = G, e.parentType = R, fe && markTightParagraphs(e, E), !0;
}, normalizeReference$2 = utils$1.normalizeReference, isSpace$6 = utils$1.isSpace, reference = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w, y, I, E, T, C, $, D, L, R = 0, O = e.bMarks[r] + e.tShift[r], P = e.eMarks[r], z = r + 1;
  if (e.sCount[r] - e.blkIndent >= 4 || e.src.charCodeAt(O) !== 91)
    return !1;
  for (; ++O < P; )
    if (e.src.charCodeAt(O) === 93 && e.src.charCodeAt(O - 1) !== 92) {
      if (O + 1 === P || e.src.charCodeAt(O + 1) !== 58)
        return !1;
      break;
    }
  for (p = e.lineMax, D = e.md.block.ruler.getRules("reference"), I = e.parentType, e.parentType = "reference"; z < p && !e.isEmpty(z); z++)
    if (!(e.sCount[z] - e.blkIndent > 3) && !(e.sCount[z] < 0)) {
      for ($ = !1, b = 0, x = D.length; b < x; b++)
        if (D[b](e, z, p, !0)) {
          $ = !0;
          break;
        }
      if ($)
        break;
    }
  for (C = e.getLines(r, z, e.blkIndent, !1).trim(), P = C.length, O = 1; O < P; O++) {
    if (c = C.charCodeAt(O), c === 91)
      return !1;
    if (c === 93) {
      y = O;
      break;
    } else
      c === 10 ? R++ : c === 92 && (O++, O < P && C.charCodeAt(O) === 10 && R++);
  }
  if (y < 0 || C.charCodeAt(y + 1) !== 58)
    return !1;
  for (O = y + 2; O < P; O++)
    if (c = C.charCodeAt(O), c === 10)
      R++;
    else if (!isSpace$6(c))
      break;
  if (E = e.md.helpers.parseLinkDestination(C, O, P), !E.ok || (g = e.md.normalizeLink(E.str), !e.md.validateLink(g)))
    return !1;
  for (O = E.pos, R += E.lines, u = O, d = R, T = O; O < P; O++)
    if (c = C.charCodeAt(O), c === 10)
      R++;
    else if (!isSpace$6(c))
      break;
  for (E = e.md.helpers.parseLinkTitle(C, O, P), O < P && T !== O && E.ok ? (L = E.str, O = E.pos, R += E.lines) : (L = "", O = u, R = d); O < P && (c = C.charCodeAt(O), !!isSpace$6(c)); )
    O++;
  if (O < P && C.charCodeAt(O) !== 10 && L)
    for (L = "", O = u, R = d; O < P && (c = C.charCodeAt(O), !!isSpace$6(c)); )
      O++;
  return O < P && C.charCodeAt(O) !== 10 || (w = normalizeReference$2(C.slice(1, y)), !w) ? !1 : (a || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[w] > "u" && (e.env.references[w] = { title: L, href: g }), e.parentType = I, e.line = r + R + 1), !0);
}, html_blocks = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], html_re = {}, attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*", unquoted = "[^\"'=<>`\\x00-\\x20]+", single_quoted = "'[^']*'", double_quoted = '"[^"]*"', attr_value = "(?:" + unquoted + "|" + single_quoted + "|" + double_quoted + ")", attribute = "(?:\\s+" + attr_name + "(?:\\s*=\\s*" + attr_value + ")?)", open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + attribute + "*\\s*\\/?>", close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->", processing = "<[?][\\s\\S]*?[?]>", declaration = "<![A-Z]+\\s+[^>]*>", cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", HTML_TAG_RE$1 = new RegExp("^(?:" + open_tag + "|" + close_tag + "|" + comment + "|" + processing + "|" + declaration + "|" + cdata + ")"), HTML_OPEN_CLOSE_TAG_RE$1 = new RegExp("^(?:" + open_tag + "|" + close_tag + ")");
html_re.HTML_TAG_RE = HTML_TAG_RE$1;
html_re.HTML_OPEN_CLOSE_TAG_RE = HTML_OPEN_CLOSE_TAG_RE$1;
var block_names = html_blocks, HTML_OPEN_CLOSE_TAG_RE = html_re.HTML_OPEN_CLOSE_TAG_RE, HTML_SEQUENCES = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + block_names.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"), /^$/, !1]
], html_block = function t(e, r, o, a) {
  var c, u, d, p, g = e.bMarks[r] + e.tShift[r], b = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(g) !== 60)
    return !1;
  for (p = e.src.slice(g, b), c = 0; c < HTML_SEQUENCES.length && !HTML_SEQUENCES[c][0].test(p); c++)
    ;
  if (c === HTML_SEQUENCES.length)
    return !1;
  if (a)
    return HTML_SEQUENCES[c][2];
  if (u = r + 1, !HTML_SEQUENCES[c][1].test(p)) {
    for (; u < o && !(e.sCount[u] < e.blkIndent); u++)
      if (g = e.bMarks[u] + e.tShift[u], b = e.eMarks[u], p = e.src.slice(g, b), HTML_SEQUENCES[c][1].test(p)) {
        p.length !== 0 && u++;
        break;
      }
  }
  return e.line = u, d = e.push("html_block", "", 0), d.map = [r, u], d.content = e.getLines(r, u, e.blkIndent, !0), !0;
}, isSpace$5 = utils$1.isSpace, heading = function t(e, r, o, a) {
  var c, u, d, p, g = e.bMarks[r] + e.tShift[r], b = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || (c = e.src.charCodeAt(g), c !== 35 || g >= b))
    return !1;
  for (u = 1, c = e.src.charCodeAt(++g); c === 35 && g < b && u <= 6; )
    u++, c = e.src.charCodeAt(++g);
  return u > 6 || g < b && !isSpace$5(c) ? !1 : (a || (b = e.skipSpacesBack(b, g), d = e.skipCharsBack(b, 35, g), d > g && isSpace$5(e.src.charCodeAt(d - 1)) && (b = d), e.line = r + 1, p = e.push("heading_open", "h" + String(u), 1), p.markup = "########".slice(0, u), p.map = [r, e.line], p = e.push("inline", "", 0), p.content = e.src.slice(g, b).trim(), p.map = [r, e.line], p.children = [], p = e.push("heading_close", "h" + String(u), -1), p.markup = "########".slice(0, u)), !0);
}, lheading = function t(e, r, o) {
  var a, c, u, d, p, g, b, x, w, y = r + 1, I, E = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[r] - e.blkIndent >= 4)
    return !1;
  for (I = e.parentType, e.parentType = "paragraph"; y < o && !e.isEmpty(y); y++)
    if (!(e.sCount[y] - e.blkIndent > 3)) {
      if (e.sCount[y] >= e.blkIndent && (g = e.bMarks[y] + e.tShift[y], b = e.eMarks[y], g < b && (w = e.src.charCodeAt(g), (w === 45 || w === 61) && (g = e.skipChars(g, w), g = e.skipSpaces(g), g >= b)))) {
        x = w === 61 ? 1 : 2;
        break;
      }
      if (!(e.sCount[y] < 0)) {
        for (c = !1, u = 0, d = E.length; u < d; u++)
          if (E[u](e, y, o, !0)) {
            c = !0;
            break;
          }
        if (c)
          break;
      }
    }
  return x ? (a = e.getLines(r, y, e.blkIndent, !1).trim(), e.line = y + 1, p = e.push("heading_open", "h" + String(x), 1), p.markup = String.fromCharCode(w), p.map = [r, e.line], p = e.push("inline", "", 0), p.content = a, p.map = [r, e.line - 1], p.children = [], p = e.push("heading_close", "h" + String(x), -1), p.markup = String.fromCharCode(w), e.parentType = I, !0) : !1;
}, paragraph = function t(e, r, o) {
  var a, c, u, d, p, g, b = r + 1, x = e.md.block.ruler.getRules("paragraph");
  for (g = e.parentType, e.parentType = "paragraph"; b < o && !e.isEmpty(b); b++)
    if (!(e.sCount[b] - e.blkIndent > 3) && !(e.sCount[b] < 0)) {
      for (c = !1, u = 0, d = x.length; u < d; u++)
        if (x[u](e, b, o, !0)) {
          c = !0;
          break;
        }
      if (c)
        break;
    }
  return a = e.getLines(r, b, e.blkIndent, !1).trim(), e.line = b, p = e.push("paragraph_open", "p", 1), p.map = [r, e.line], p = e.push("inline", "", 0), p.content = a, p.map = [r, e.line], p.children = [], p = e.push("paragraph_close", "p", -1), e.parentType = g, !0;
}, Token$1 = token, isSpace$4 = utils$1.isSpace;
function StateBlock(t, e, r, o) {
  var a, c, u, d, p, g, b, x;
  for (this.src = t, this.md = e, this.env = r, this.tokens = o, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", c = this.src, x = !1, u = d = g = b = 0, p = c.length; d < p; d++) {
    if (a = c.charCodeAt(d), !x)
      if (isSpace$4(a)) {
        g++, a === 9 ? b += 4 - b % 4 : b++;
        continue;
      } else
        x = !0;
    (a === 10 || d === p - 1) && (a !== 10 && d++, this.bMarks.push(u), this.eMarks.push(d), this.tShift.push(g), this.sCount.push(b), this.bsCount.push(0), x = !1, g = 0, b = 0, u = d + 1);
  }
  this.bMarks.push(c.length), this.eMarks.push(c.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
StateBlock.prototype.push = function(t, e, r) {
  var o = new Token$1(t, e, r);
  return o.block = !0, r < 0 && this.level--, o.level = this.level, r > 0 && this.level++, this.tokens.push(o), o;
};
StateBlock.prototype.isEmpty = function t(e) {
  return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
};
StateBlock.prototype.skipEmptyLines = function t(e) {
  for (var r = this.lineMax; e < r && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++)
    ;
  return e;
};
StateBlock.prototype.skipSpaces = function t(e) {
  for (var r, o = this.src.length; e < o && (r = this.src.charCodeAt(e), !!isSpace$4(r)); e++)
    ;
  return e;
};
StateBlock.prototype.skipSpacesBack = function t(e, r) {
  if (e <= r)
    return e;
  for (; e > r; )
    if (!isSpace$4(this.src.charCodeAt(--e)))
      return e + 1;
  return e;
};
StateBlock.prototype.skipChars = function t(e, r) {
  for (var o = this.src.length; e < o && this.src.charCodeAt(e) === r; e++)
    ;
  return e;
};
StateBlock.prototype.skipCharsBack = function t(e, r, o) {
  if (e <= o)
    return e;
  for (; e > o; )
    if (r !== this.src.charCodeAt(--e))
      return e + 1;
  return e;
};
StateBlock.prototype.getLines = function t(e, r, o, a) {
  var c, u, d, p, g, b, x, w = e;
  if (e >= r)
    return "";
  for (b = new Array(r - e), c = 0; w < r; w++, c++) {
    for (u = 0, x = p = this.bMarks[w], w + 1 < r || a ? g = this.eMarks[w] + 1 : g = this.eMarks[w]; p < g && u < o; ) {
      if (d = this.src.charCodeAt(p), isSpace$4(d))
        d === 9 ? u += 4 - (u + this.bsCount[w]) % 4 : u++;
      else if (p - x < this.tShift[w])
        u++;
      else
        break;
      p++;
    }
    u > o ? b[c] = new Array(u - o + 1).join(" ") + this.src.slice(p, g) : b[c] = this.src.slice(p, g);
  }
  return b.join("");
};
StateBlock.prototype.Token = Token$1;
var state_block = StateBlock, Ruler$1 = ruler, _rules$1 = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", table, ["paragraph", "reference"]],
  ["code", code$3],
  ["fence", fence, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", blockquote, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", hr, ["paragraph", "reference", "blockquote", "list"]],
  ["list", list, ["paragraph", "reference", "blockquote"]],
  ["reference", reference],
  ["html_block", html_block, ["paragraph", "reference", "blockquote"]],
  ["heading", heading, ["paragraph", "reference", "blockquote"]],
  ["lheading", lheading],
  ["paragraph", paragraph]
];
function ParserBlock$1() {
  this.ruler = new Ruler$1();
  for (var t = 0; t < _rules$1.length; t++)
    this.ruler.push(_rules$1[t][0], _rules$1[t][1], { alt: (_rules$1[t][2] || []).slice() });
}
ParserBlock$1.prototype.tokenize = function(t, e, r) {
  for (var o, a, c, u = this.ruler.getRules(""), d = u.length, p = e, g = !1, b = t.md.options.maxNesting; p < r && (t.line = p = t.skipEmptyLines(p), !(p >= r || t.sCount[p] < t.blkIndent)); ) {
    if (t.level >= b) {
      t.line = r;
      break;
    }
    for (c = t.line, a = 0; a < d; a++)
      if (o = u[a](t, p, r, !1), o) {
        if (c >= t.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!o)
      throw new Error("none of the block rules matched");
    t.tight = !g, t.isEmpty(t.line - 1) && (g = !0), p = t.line, p < r && t.isEmpty(p) && (g = !0, p++, t.line = p);
  }
};
ParserBlock$1.prototype.parse = function(t, e, r, o) {
  var a;
  t && (a = new this.State(t, e, r, o), this.tokenize(a, a.line, a.lineMax));
};
ParserBlock$1.prototype.State = state_block;
var parser_block = ParserBlock$1;
function isTerminatorChar(t) {
  switch (t) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
var text = function t(e, r) {
  for (var o = e.pos; o < e.posMax && !isTerminatorChar(e.src.charCodeAt(o)); )
    o++;
  return o === e.pos ? !1 : (r || (e.pending += e.src.slice(e.pos, o)), e.pos = o, !0);
}, SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, linkify = function t(e, r) {
  var o, a, c, u, d, p, g, b;
  return !e.md.options.linkify || e.linkLevel > 0 || (o = e.pos, a = e.posMax, o + 3 > a) || e.src.charCodeAt(o) !== 58 || e.src.charCodeAt(o + 1) !== 47 || e.src.charCodeAt(o + 2) !== 47 || (c = e.pending.match(SCHEME_RE), !c) || (u = c[1], d = e.md.linkify.matchAtStart(e.src.slice(o - u.length)), !d) || (p = d.url, p.length <= u.length) || (p = p.replace(/\*+$/, ""), g = e.md.normalizeLink(p), !e.md.validateLink(g)) ? !1 : (r || (e.pending = e.pending.slice(0, -u.length), b = e.push("link_open", "a", 1), b.attrs = [["href", g]], b.markup = "linkify", b.info = "auto", b = e.push("text", "", 0), b.content = e.md.normalizeLinkText(p), b = e.push("link_close", "a", -1), b.markup = "linkify", b.info = "auto"), e.pos += p.length - u.length, !0);
}, isSpace$3 = utils$1.isSpace, newline = function t(e, r) {
  var o, a, c, u = e.pos;
  if (e.src.charCodeAt(u) !== 10)
    return !1;
  if (o = e.pending.length - 1, a = e.posMax, !r)
    if (o >= 0 && e.pending.charCodeAt(o) === 32)
      if (o >= 1 && e.pending.charCodeAt(o - 1) === 32) {
        for (c = o - 1; c >= 1 && e.pending.charCodeAt(c - 1) === 32; )
          c--;
        e.pending = e.pending.slice(0, c), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (u++; u < a && isSpace$3(e.src.charCodeAt(u)); )
    u++;
  return e.pos = u, !0;
}, isSpace$2 = utils$1.isSpace, ESCAPED = [];
for (var i = 0; i < 256; i++)
  ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(t) {
  ESCAPED[t.charCodeAt(0)] = 1;
});
var _escape = function t(e, r) {
  var o, a, c, u, d, p = e.pos, g = e.posMax;
  if (e.src.charCodeAt(p) !== 92 || (p++, p >= g))
    return !1;
  if (o = e.src.charCodeAt(p), o === 10) {
    for (r || e.push("hardbreak", "br", 0), p++; p < g && (o = e.src.charCodeAt(p), !!isSpace$2(o)); )
      p++;
    return e.pos = p, !0;
  }
  return u = e.src[p], o >= 55296 && o <= 56319 && p + 1 < g && (a = e.src.charCodeAt(p + 1), a >= 56320 && a <= 57343 && (u += e.src[p + 1], p++)), c = "\\" + u, r || (d = e.push("text_special", "", 0), o < 256 && ESCAPED[o] !== 0 ? d.content = u : d.content = c, d.markup = c, d.info = "escape"), e.pos = p + 1, !0;
}, backticks = function t(e, r) {
  var o, a, c, u, d, p, g, b, x = e.pos, w = e.src.charCodeAt(x);
  if (w !== 96)
    return !1;
  for (o = x, x++, a = e.posMax; x < a && e.src.charCodeAt(x) === 96; )
    x++;
  if (c = e.src.slice(o, x), g = c.length, e.backticksScanned && (e.backticks[g] || 0) <= o)
    return r || (e.pending += c), e.pos += g, !0;
  for (p = x; (d = e.src.indexOf("`", p)) !== -1; ) {
    for (p = d + 1; p < a && e.src.charCodeAt(p) === 96; )
      p++;
    if (b = p - d, b === g)
      return r || (u = e.push("code_inline", "code", 0), u.markup = c, u.content = e.src.slice(x, d).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), e.pos = p, !0;
    e.backticks[b] = d;
  }
  return e.backticksScanned = !0, r || (e.pending += c), e.pos += g, !0;
}, strikethrough = {};
strikethrough.tokenize = function t(e, r) {
  var o, a, c, u, d, p = e.pos, g = e.src.charCodeAt(p);
  if (r || g !== 126 || (a = e.scanDelims(e.pos, !0), u = a.length, d = String.fromCharCode(g), u < 2))
    return !1;
  for (u % 2 && (c = e.push("text", "", 0), c.content = d, u--), o = 0; o < u; o += 2)
    c = e.push("text", "", 0), c.content = d + d, e.delimiters.push({
      marker: g,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: a.can_open,
      close: a.can_close
    });
  return e.pos += a.length, !0;
};
function postProcess$1(t, e) {
  var r, o, a, c, u, d = [], p = e.length;
  for (r = 0; r < p; r++)
    a = e[r], a.marker === 126 && a.end !== -1 && (c = e[a.end], u = t.tokens[a.token], u.type = "s_open", u.tag = "s", u.nesting = 1, u.markup = "~~", u.content = "", u = t.tokens[c.token], u.type = "s_close", u.tag = "s", u.nesting = -1, u.markup = "~~", u.content = "", t.tokens[c.token - 1].type === "text" && t.tokens[c.token - 1].content === "~" && d.push(c.token - 1));
  for (; d.length; ) {
    for (r = d.pop(), o = r + 1; o < t.tokens.length && t.tokens[o].type === "s_close"; )
      o++;
    o--, r !== o && (u = t.tokens[o], t.tokens[o] = t.tokens[r], t.tokens[r] = u);
  }
}
strikethrough.postProcess = function t(e) {
  var r, o = e.tokens_meta, a = e.tokens_meta.length;
  for (postProcess$1(e, e.delimiters), r = 0; r < a; r++)
    o[r] && o[r].delimiters && postProcess$1(e, o[r].delimiters);
};
var emphasis = {};
emphasis.tokenize = function t(e, r) {
  var o, a, c, u = e.pos, d = e.src.charCodeAt(u);
  if (r || d !== 95 && d !== 42)
    return !1;
  for (a = e.scanDelims(e.pos, d === 42), o = 0; o < a.length; o++)
    c = e.push("text", "", 0), c.content = String.fromCharCode(d), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: d,
      // Total length of these series of delimiters.
      //
      length: a.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: a.can_open,
      close: a.can_close
    });
  return e.pos += a.length, !0;
};
function postProcess(t, e) {
  var r, o, a, c, u, d, p = e.length;
  for (r = p - 1; r >= 0; r--)
    o = e[r], !(o.marker !== 95 && o.marker !== 42) && o.end !== -1 && (a = e[o.end], d = r > 0 && e[r - 1].end === o.end + 1 && // check that first two markers match and adjacent
    e[r - 1].marker === o.marker && e[r - 1].token === o.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[o.end + 1].token === a.token + 1, u = String.fromCharCode(o.marker), c = t.tokens[o.token], c.type = d ? "strong_open" : "em_open", c.tag = d ? "strong" : "em", c.nesting = 1, c.markup = d ? u + u : u, c.content = "", c = t.tokens[a.token], c.type = d ? "strong_close" : "em_close", c.tag = d ? "strong" : "em", c.nesting = -1, c.markup = d ? u + u : u, c.content = "", d && (t.tokens[e[r - 1].token].content = "", t.tokens[e[o.end + 1].token].content = "", r--));
}
emphasis.postProcess = function t(e) {
  var r, o = e.tokens_meta, a = e.tokens_meta.length;
  for (postProcess(e, e.delimiters), r = 0; r < a; r++)
    o[r] && o[r].delimiters && postProcess(e, o[r].delimiters);
};
var normalizeReference$1 = utils$1.normalizeReference, isSpace$1 = utils$1.isSpace, link = function t(e, r) {
  var o, a, c, u, d, p, g, b, x, w = "", y = "", I = e.pos, E = e.posMax, T = e.pos, C = !0;
  if (e.src.charCodeAt(e.pos) !== 91 || (d = e.pos + 1, u = e.md.helpers.parseLinkLabel(e, e.pos, !0), u < 0))
    return !1;
  if (p = u + 1, p < E && e.src.charCodeAt(p) === 40) {
    for (C = !1, p++; p < E && (a = e.src.charCodeAt(p), !(!isSpace$1(a) && a !== 10)); p++)
      ;
    if (p >= E)
      return !1;
    if (T = p, g = e.md.helpers.parseLinkDestination(e.src, p, e.posMax), g.ok) {
      for (w = e.md.normalizeLink(g.str), e.md.validateLink(w) ? p = g.pos : w = "", T = p; p < E && (a = e.src.charCodeAt(p), !(!isSpace$1(a) && a !== 10)); p++)
        ;
      if (g = e.md.helpers.parseLinkTitle(e.src, p, e.posMax), p < E && T !== p && g.ok)
        for (y = g.str, p = g.pos; p < E && (a = e.src.charCodeAt(p), !(!isSpace$1(a) && a !== 10)); p++)
          ;
    }
    (p >= E || e.src.charCodeAt(p) !== 41) && (C = !0), p++;
  }
  if (C) {
    if (typeof e.env.references > "u")
      return !1;
    if (p < E && e.src.charCodeAt(p) === 91 ? (T = p + 1, p = e.md.helpers.parseLinkLabel(e, p), p >= 0 ? c = e.src.slice(T, p++) : p = u + 1) : p = u + 1, c || (c = e.src.slice(d, u)), b = e.env.references[normalizeReference$1(c)], !b)
      return e.pos = I, !1;
    w = b.href, y = b.title;
  }
  return r || (e.pos = d, e.posMax = u, x = e.push("link_open", "a", 1), x.attrs = o = [["href", w]], y && o.push(["title", y]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, x = e.push("link_close", "a", -1)), e.pos = p, e.posMax = E, !0;
}, normalizeReference = utils$1.normalizeReference, isSpace = utils$1.isSpace, image = function t(e, r) {
  var o, a, c, u, d, p, g, b, x, w, y, I, E, T = "", C = e.pos, $ = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91 || (p = e.pos + 2, d = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1), d < 0))
    return !1;
  if (g = d + 1, g < $ && e.src.charCodeAt(g) === 40) {
    for (g++; g < $ && (a = e.src.charCodeAt(g), !(!isSpace(a) && a !== 10)); g++)
      ;
    if (g >= $)
      return !1;
    for (E = g, x = e.md.helpers.parseLinkDestination(e.src, g, e.posMax), x.ok && (T = e.md.normalizeLink(x.str), e.md.validateLink(T) ? g = x.pos : T = ""), E = g; g < $ && (a = e.src.charCodeAt(g), !(!isSpace(a) && a !== 10)); g++)
      ;
    if (x = e.md.helpers.parseLinkTitle(e.src, g, e.posMax), g < $ && E !== g && x.ok)
      for (w = x.str, g = x.pos; g < $ && (a = e.src.charCodeAt(g), !(!isSpace(a) && a !== 10)); g++)
        ;
    else
      w = "";
    if (g >= $ || e.src.charCodeAt(g) !== 41)
      return e.pos = C, !1;
    g++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (g < $ && e.src.charCodeAt(g) === 91 ? (E = g + 1, g = e.md.helpers.parseLinkLabel(e, g), g >= 0 ? u = e.src.slice(E, g++) : g = d + 1) : g = d + 1, u || (u = e.src.slice(p, d)), b = e.env.references[normalizeReference(u)], !b)
      return e.pos = C, !1;
    T = b.href, w = b.title;
  }
  return r || (c = e.src.slice(p, d), e.md.inline.parse(
    c,
    e.md,
    e.env,
    I = []
  ), y = e.push("image", "img", 0), y.attrs = o = [["src", T], ["alt", ""]], y.children = I, y.content = c, w && o.push(["title", w])), e.pos = g, e.posMax = $, !0;
}, EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/, autolink = function t(e, r) {
  var o, a, c, u, d, p, g = e.pos;
  if (e.src.charCodeAt(g) !== 60)
    return !1;
  for (d = e.pos, p = e.posMax; ; ) {
    if (++g >= p || (u = e.src.charCodeAt(g), u === 60))
      return !1;
    if (u === 62)
      break;
  }
  return o = e.src.slice(d + 1, g), AUTOLINK_RE.test(o) ? (a = e.md.normalizeLink(o), e.md.validateLink(a) ? (r || (c = e.push("link_open", "a", 1), c.attrs = [["href", a]], c.markup = "autolink", c.info = "auto", c = e.push("text", "", 0), c.content = e.md.normalizeLinkText(o), c = e.push("link_close", "a", -1), c.markup = "autolink", c.info = "auto"), e.pos += o.length + 2, !0) : !1) : EMAIL_RE.test(o) ? (a = e.md.normalizeLink("mailto:" + o), e.md.validateLink(a) ? (r || (c = e.push("link_open", "a", 1), c.attrs = [["href", a]], c.markup = "autolink", c.info = "auto", c = e.push("text", "", 0), c.content = e.md.normalizeLinkText(o), c = e.push("link_close", "a", -1), c.markup = "autolink", c.info = "auto"), e.pos += o.length + 2, !0) : !1) : !1;
}, HTML_TAG_RE = html_re.HTML_TAG_RE;
function isLinkOpen(t) {
  return /^<a[>\s]/i.test(t);
}
function isLinkClose(t) {
  return /^<\/a\s*>/i.test(t);
}
function isLetter(t) {
  var e = t | 32;
  return e >= 97 && e <= 122;
}
var html_inline = function t(e, r) {
  var o, a, c, u, d = e.pos;
  return !e.md.options.html || (c = e.posMax, e.src.charCodeAt(d) !== 60 || d + 2 >= c) || (o = e.src.charCodeAt(d + 1), o !== 33 && o !== 63 && o !== 47 && !isLetter(o)) || (a = e.src.slice(d).match(HTML_TAG_RE), !a) ? !1 : (r || (u = e.push("html_inline", "", 0), u.content = a[0], isLinkOpen(u.content) && e.linkLevel++, isLinkClose(u.content) && e.linkLevel--), e.pos += a[0].length, !0);
}, entities = entities$1, has = utils$1.has, isValidEntityCode = utils$1.isValidEntityCode, fromCodePoint = utils$1.fromCodePoint, DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i, entity = function t(e, r) {
  var o, a, c, u, d = e.pos, p = e.posMax;
  if (e.src.charCodeAt(d) !== 38 || d + 1 >= p)
    return !1;
  if (o = e.src.charCodeAt(d + 1), o === 35) {
    if (c = e.src.slice(d).match(DIGITAL_RE), c)
      return r || (a = c[1][0].toLowerCase() === "x" ? parseInt(c[1].slice(1), 16) : parseInt(c[1], 10), u = e.push("text_special", "", 0), u.content = isValidEntityCode(a) ? fromCodePoint(a) : fromCodePoint(65533), u.markup = c[0], u.info = "entity"), e.pos += c[0].length, !0;
  } else if (c = e.src.slice(d).match(NAMED_RE), c && has(entities, c[1]))
    return r || (u = e.push("text_special", "", 0), u.content = entities[c[1]], u.markup = c[0], u.info = "entity"), e.pos += c[0].length, !0;
  return !1;
};
function processDelimiters(t) {
  var e, r, o, a, c, u, d, p, g = {}, b = t.length;
  if (b) {
    var x = 0, w = -2, y = [];
    for (e = 0; e < b; e++)
      if (o = t[e], y.push(0), (t[x].marker !== o.marker || w !== o.token - 1) && (x = e), w = o.token, o.length = o.length || 0, !!o.close) {
        for (g.hasOwnProperty(o.marker) || (g[o.marker] = [-1, -1, -1, -1, -1, -1]), c = g[o.marker][(o.open ? 3 : 0) + o.length % 3], r = x - y[x] - 1, u = r; r > c; r -= y[r] + 1)
          if (a = t[r], a.marker === o.marker && a.open && a.end < 0 && (d = !1, (a.close || o.open) && (a.length + o.length) % 3 === 0 && (a.length % 3 !== 0 || o.length % 3 !== 0) && (d = !0), !d)) {
            p = r > 0 && !t[r - 1].open ? y[r - 1] + 1 : 0, y[e] = e - r + p, y[r] = p, o.open = !1, a.end = e, a.close = !1, u = -1, w = -2;
            break;
          }
        u !== -1 && (g[o.marker][(o.open ? 3 : 0) + (o.length || 0) % 3] = u);
      }
  }
}
var balance_pairs = function t(e) {
  var r, o = e.tokens_meta, a = e.tokens_meta.length;
  for (processDelimiters(e.delimiters), r = 0; r < a; r++)
    o[r] && o[r].delimiters && processDelimiters(o[r].delimiters);
}, fragments_join = function t(e) {
  var r, o, a = 0, c = e.tokens, u = e.tokens.length;
  for (r = o = 0; r < u; r++)
    c[r].nesting < 0 && a--, c[r].level = a, c[r].nesting > 0 && a++, c[r].type === "text" && r + 1 < u && c[r + 1].type === "text" ? c[r + 1].content = c[r].content + c[r + 1].content : (r !== o && (c[o] = c[r]), o++);
  r !== o && (c.length = o);
}, Token = token, isWhiteSpace = utils$1.isWhiteSpace, isPunctChar = utils$1.isPunctChar, isMdAsciiPunct = utils$1.isMdAsciiPunct;
function StateInline(t, e, r, o) {
  this.src = t, this.env = r, this.md = e, this.tokens = o, this.tokens_meta = Array(o.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
StateInline.prototype.pushPending = function() {
  var t = new Token("text", "", 0);
  return t.content = this.pending, t.level = this.pendingLevel, this.tokens.push(t), this.pending = "", t;
};
StateInline.prototype.push = function(t, e, r) {
  this.pending && this.pushPending();
  var o = new Token(t, e, r), a = null;
  return r < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), o.level = this.level, r > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], a = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(o), this.tokens_meta.push(a), o;
};
StateInline.prototype.scanDelims = function(t, e) {
  var r = t, o, a, c, u, d, p, g, b, x, w = !0, y = !0, I = this.posMax, E = this.src.charCodeAt(t);
  for (o = t > 0 ? this.src.charCodeAt(t - 1) : 32; r < I && this.src.charCodeAt(r) === E; )
    r++;
  return c = r - t, a = r < I ? this.src.charCodeAt(r) : 32, g = isMdAsciiPunct(o) || isPunctChar(String.fromCharCode(o)), x = isMdAsciiPunct(a) || isPunctChar(String.fromCharCode(a)), p = isWhiteSpace(o), b = isWhiteSpace(a), b ? w = !1 : x && (p || g || (w = !1)), p ? y = !1 : g && (b || x || (y = !1)), e ? (u = w, d = y) : (u = w && (!y || g), d = y && (!w || x)), {
    can_open: u,
    can_close: d,
    length: c
  };
};
StateInline.prototype.Token = Token;
var state_inline = StateInline, Ruler = ruler, _rules = [
  ["text", text],
  ["linkify", linkify],
  ["newline", newline],
  ["escape", _escape],
  ["backticks", backticks],
  ["strikethrough", strikethrough.tokenize],
  ["emphasis", emphasis.tokenize],
  ["link", link],
  ["image", image],
  ["autolink", autolink],
  ["html_inline", html_inline],
  ["entity", entity]
], _rules2 = [
  ["balance_pairs", balance_pairs],
  ["strikethrough", strikethrough.postProcess],
  ["emphasis", emphasis.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", fragments_join]
];
function ParserInline$1() {
  var t;
  for (this.ruler = new Ruler(), t = 0; t < _rules.length; t++)
    this.ruler.push(_rules[t][0], _rules[t][1]);
  for (this.ruler2 = new Ruler(), t = 0; t < _rules2.length; t++)
    this.ruler2.push(_rules2[t][0], _rules2[t][1]);
}
ParserInline$1.prototype.skipToken = function(t) {
  var e, r, o = t.pos, a = this.ruler.getRules(""), c = a.length, u = t.md.options.maxNesting, d = t.cache;
  if (typeof d[o] < "u") {
    t.pos = d[o];
    return;
  }
  if (t.level < u) {
    for (r = 0; r < c; r++)
      if (t.level++, e = a[r](t, !0), t.level--, e) {
        if (o >= t.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    t.pos = t.posMax;
  e || t.pos++, d[o] = t.pos;
};
ParserInline$1.prototype.tokenize = function(t) {
  for (var e, r, o, a = this.ruler.getRules(""), c = a.length, u = t.posMax, d = t.md.options.maxNesting; t.pos < u; ) {
    if (o = t.pos, t.level < d) {
      for (r = 0; r < c; r++)
        if (e = a[r](t, !1), e) {
          if (o >= t.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (e) {
      if (t.pos >= u)
        break;
      continue;
    }
    t.pending += t.src[t.pos++];
  }
  t.pending && t.pushPending();
};
ParserInline$1.prototype.parse = function(t, e, r, o) {
  var a, c, u, d = new this.State(t, e, r, o);
  for (this.tokenize(d), c = this.ruler2.getRules(""), u = c.length, a = 0; a < u; a++)
    c[a](d);
};
ParserInline$1.prototype.State = state_inline;
var parser_inline = ParserInline$1, re, hasRequiredRe;
function requireRe() {
  return hasRequiredRe || (hasRequiredRe = 1, re = function(t) {
    var e = {};
    t = t || {}, e.src_Any = requireRegex$3().source, e.src_Cc = requireRegex$2().source, e.src_Z = requireRegex().source, e.src_P = regex$4.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
    var r = "[><｜]";
    return e.src_pseudo_letter = "(?:(?!" + r + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + r + "|" + e.src_ZPCc + ")(?!" + (t["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + r + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (t["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + r + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
  }), re;
}
function assign$2(t) {
  var e = Array.prototype.slice.call(arguments, 1);
  return e.forEach(function(r) {
    r && Object.keys(r).forEach(function(o) {
      t[o] = r[o];
    });
  }), t;
}
function _class(t) {
  return Object.prototype.toString.call(t);
}
function isString$2(t) {
  return _class(t) === "[object String]";
}
function isObject$4(t) {
  return _class(t) === "[object Object]";
}
function isRegExp$1(t) {
  return _class(t) === "[object RegExp]";
}
function isFunction$1(t) {
  return _class(t) === "[object Function]";
}
function escapeRE(t) {
  return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
var defaultOptions = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function isOptionsObj(t) {
  return Object.keys(t || {}).reduce(function(e, r) {
    return e || defaultOptions.hasOwnProperty(r);
  }, !1);
}
var defaultSchemas = {
  "http:": {
    validate: function(t, e, r) {
      var o = t.slice(e);
      return r.re.http || (r.re.http = new RegExp(
        "^\\/\\/" + r.re.src_auth + r.re.src_host_port_strict + r.re.src_path,
        "i"
      )), r.re.http.test(o) ? o.match(r.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(t, e, r) {
      var o = t.slice(e);
      return r.re.no_http || (r.re.no_http = new RegExp(
        "^" + r.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + r.re.src_domain + ")\\.)+" + r.re.src_domain_root + ")" + r.re.src_port + r.re.src_host_terminator + r.re.src_path,
        "i"
      )), r.re.no_http.test(o) ? e >= 3 && t[e - 3] === ":" || e >= 3 && t[e - 3] === "/" ? 0 : o.match(r.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(t, e, r) {
      var o = t.slice(e);
      return r.re.mailto || (r.re.mailto = new RegExp(
        "^" + r.re.src_email_name + "@" + r.re.src_host_strict,
        "i"
      )), r.re.mailto.test(o) ? o.match(r.re.mailto)[0].length : 0;
    }
  }
}, tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function resetScanCache(t) {
  t.__index__ = -1, t.__text_cache__ = "";
}
function createValidator(t) {
  return function(e, r) {
    var o = e.slice(r);
    return t.test(o) ? o.match(t)[0].length : 0;
  };
}
function createNormalizer() {
  return function(t, e) {
    e.normalize(t);
  };
}
function compile$1(t) {
  var e = t.re = requireRe()(t.__opts__), r = t.__tlds__.slice();
  t.onCompile(), t.__tlds_replaced__ || r.push(tlds_2ch_src_re), r.push(e.src_xn), e.src_tlds = r.join("|");
  function o(d) {
    return d.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(o(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(o(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(o(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(o(e.tpl_host_fuzzy_test), "i");
  var a = [];
  t.__compiled__ = {};
  function c(d, p) {
    throw new Error('(LinkifyIt) Invalid schema "' + d + '": ' + p);
  }
  Object.keys(t.__schemas__).forEach(function(d) {
    var p = t.__schemas__[d];
    if (p !== null) {
      var g = { validate: null, link: null };
      if (t.__compiled__[d] = g, isObject$4(p)) {
        isRegExp$1(p.validate) ? g.validate = createValidator(p.validate) : isFunction$1(p.validate) ? g.validate = p.validate : c(d, p), isFunction$1(p.normalize) ? g.normalize = p.normalize : p.normalize ? c(d, p) : g.normalize = createNormalizer();
        return;
      }
      if (isString$2(p)) {
        a.push(d);
        return;
      }
      c(d, p);
    }
  }), a.forEach(function(d) {
    t.__compiled__[t.__schemas__[d]] && (t.__compiled__[d].validate = t.__compiled__[t.__schemas__[d]].validate, t.__compiled__[d].normalize = t.__compiled__[t.__schemas__[d]].normalize);
  }), t.__compiled__[""] = { validate: null, normalize: createNormalizer() };
  var u = Object.keys(t.__compiled__).filter(function(d) {
    return d.length > 0 && t.__compiled__[d];
  }).map(escapeRE).join("|");
  t.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + u + ")", "i"), t.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + u + ")", "ig"), t.re.schema_at_start = RegExp("^" + t.re.schema_search.source, "i"), t.re.pretest = RegExp(
    "(" + t.re.schema_test.source + ")|(" + t.re.host_fuzzy_test.source + ")|@",
    "i"
  ), resetScanCache(t);
}
function Match(t, e) {
  var r = t.__index__, o = t.__last_index__, a = t.__text_cache__.slice(r, o);
  this.schema = t.__schema__.toLowerCase(), this.index = r + e, this.lastIndex = o + e, this.raw = a, this.text = a, this.url = a;
}
function createMatch(t, e) {
  var r = new Match(t, e);
  return t.__compiled__[r.schema].normalize(r, t), r;
}
function LinkifyIt$1(t, e) {
  if (!(this instanceof LinkifyIt$1))
    return new LinkifyIt$1(t, e);
  e || isOptionsObj(t) && (e = t, t = {}), this.__opts__ = assign$2({}, defaultOptions, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = assign$2({}, defaultSchemas, t), this.__compiled__ = {}, this.__tlds__ = tlds_default, this.__tlds_replaced__ = !1, this.re = {}, compile$1(this);
}
LinkifyIt$1.prototype.add = function t(e, r) {
  return this.__schemas__[e] = r, compile$1(this), this;
};
LinkifyIt$1.prototype.set = function t(e) {
  return this.__opts__ = assign$2(this.__opts__, e), this;
};
LinkifyIt$1.prototype.test = function t(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return !1;
  var r, o, a, c, u, d, p, g, b;
  if (this.re.schema_test.test(e)) {
    for (p = this.re.schema_search, p.lastIndex = 0; (r = p.exec(e)) !== null; )
      if (c = this.testSchemaAt(e, r[2], p.lastIndex), c) {
        this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + c;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (g = e.search(this.re.host_fuzzy_test), g >= 0 && (this.__index__ < 0 || g < this.__index__) && (o = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (u = o.index + o[1].length, (this.__index__ < 0 || u < this.__index__) && (this.__schema__ = "", this.__index__ = u, this.__last_index__ = o.index + o[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (b = e.indexOf("@"), b >= 0 && (a = e.match(this.re.email_fuzzy)) !== null && (u = a.index + a[1].length, d = a.index + a[0].length, (this.__index__ < 0 || u < this.__index__ || u === this.__index__ && d > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = u, this.__last_index__ = d))), this.__index__ >= 0;
};
LinkifyIt$1.prototype.pretest = function t(e) {
  return this.re.pretest.test(e);
};
LinkifyIt$1.prototype.testSchemaAt = function t(e, r, o) {
  return this.__compiled__[r.toLowerCase()] ? this.__compiled__[r.toLowerCase()].validate(e, o, this) : 0;
};
LinkifyIt$1.prototype.match = function t(e) {
  var r = 0, o = [];
  this.__index__ >= 0 && this.__text_cache__ === e && (o.push(createMatch(this, r)), r = this.__last_index__);
  for (var a = r ? e.slice(r) : e; this.test(a); )
    o.push(createMatch(this, r)), a = a.slice(this.__last_index__), r += this.__last_index__;
  return o.length ? o : null;
};
LinkifyIt$1.prototype.matchAtStart = function t(e) {
  if (this.__text_cache__ = e, this.__index__ = -1, !e.length)
    return null;
  var r = this.re.schema_at_start.exec(e);
  if (!r)
    return null;
  var o = this.testSchemaAt(e, r[2], r[0].length);
  return o ? (this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + o, createMatch(this, 0)) : null;
};
LinkifyIt$1.prototype.tlds = function t(e, r) {
  return e = Array.isArray(e) ? e : [e], r ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function(o, a, c) {
    return o !== c[a - 1];
  }).reverse(), compile$1(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, compile$1(this), this);
};
LinkifyIt$1.prototype.normalize = function t(e) {
  e.schema || (e.url = "http://" + e.url), e.schema === "mailto:" && !/^mailto:/i.test(e.url) && (e.url = "mailto:" + e.url);
};
LinkifyIt$1.prototype.onCompile = function t() {
};
var linkifyIt = LinkifyIt$1;
const maxInt = 2147483647, base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", regexPunycode = /^xn--/, regexNonASCII = /[^\0-\x7F]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, errors = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode;
function error(t) {
  throw new RangeError(errors[t]);
}
function map(t, e) {
  const r = [];
  let o = t.length;
  for (; o--; )
    r[o] = e(t[o]);
  return r;
}
function mapDomain(t, e) {
  const r = t.split("@");
  let o = "";
  r.length > 1 && (o = r[0] + "@", t = r[1]), t = t.replace(regexSeparators, ".");
  const a = t.split("."), c = map(a, e).join(".");
  return o + c;
}
function ucs2decode(t) {
  const e = [];
  let r = 0;
  const o = t.length;
  for (; r < o; ) {
    const a = t.charCodeAt(r++);
    if (a >= 55296 && a <= 56319 && r < o) {
      const c = t.charCodeAt(r++);
      (c & 64512) == 56320 ? e.push(((a & 1023) << 10) + (c & 1023) + 65536) : (e.push(a), r--);
    } else
      e.push(a);
  }
  return e;
}
const ucs2encode = (t) => String.fromCodePoint(...t), basicToDigit = function(t) {
  return t >= 48 && t < 58 ? 26 + (t - 48) : t >= 65 && t < 91 ? t - 65 : t >= 97 && t < 123 ? t - 97 : base;
}, digitToBasic = function(t, e) {
  return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
}, adapt = function(t, e, r) {
  let o = 0;
  for (t = r ? floor(t / damp) : t >> 1, t += floor(t / e); t > baseMinusTMin * tMax >> 1; o += base)
    t = floor(t / baseMinusTMin);
  return floor(o + (baseMinusTMin + 1) * t / (t + skew));
}, decode = function(t) {
  const e = [], r = t.length;
  let o = 0, a = initialN, c = initialBias, u = t.lastIndexOf(delimiter);
  u < 0 && (u = 0);
  for (let d = 0; d < u; ++d)
    t.charCodeAt(d) >= 128 && error("not-basic"), e.push(t.charCodeAt(d));
  for (let d = u > 0 ? u + 1 : 0; d < r; ) {
    const p = o;
    for (let b = 1, x = base; ; x += base) {
      d >= r && error("invalid-input");
      const w = basicToDigit(t.charCodeAt(d++));
      w >= base && error("invalid-input"), w > floor((maxInt - o) / b) && error("overflow"), o += w * b;
      const y = x <= c ? tMin : x >= c + tMax ? tMax : x - c;
      if (w < y)
        break;
      const I = base - y;
      b > floor(maxInt / I) && error("overflow"), b *= I;
    }
    const g = e.length + 1;
    c = adapt(o - p, g, p == 0), floor(o / g) > maxInt - a && error("overflow"), a += floor(o / g), o %= g, e.splice(o++, 0, a);
  }
  return String.fromCodePoint(...e);
}, encode$1 = function(t) {
  const e = [];
  t = ucs2decode(t);
  const r = t.length;
  let o = initialN, a = 0, c = initialBias;
  for (const p of t)
    p < 128 && e.push(stringFromCharCode(p));
  const u = e.length;
  let d = u;
  for (u && e.push(delimiter); d < r; ) {
    let p = maxInt;
    for (const b of t)
      b >= o && b < p && (p = b);
    const g = d + 1;
    p - o > floor((maxInt - a) / g) && error("overflow"), a += (p - o) * g, o = p;
    for (const b of t)
      if (b < o && ++a > maxInt && error("overflow"), b === o) {
        let x = a;
        for (let w = base; ; w += base) {
          const y = w <= c ? tMin : w >= c + tMax ? tMax : w - c;
          if (x < y)
            break;
          const I = x - y, E = base - y;
          e.push(
            stringFromCharCode(digitToBasic(y + I % E, 0))
          ), x = floor(I / E);
        }
        e.push(stringFromCharCode(digitToBasic(x, 0))), c = adapt(a, g, d === u), a = 0, ++d;
      }
    ++a, ++o;
  }
  return e.join("");
}, toUnicode = function(t) {
  return mapDomain(t, function(e) {
    return regexPunycode.test(e) ? decode(e.slice(4).toLowerCase()) : e;
  });
}, toASCII = function(t) {
  return mapDomain(t, function(e) {
    return regexNonASCII.test(e) ? "xn--" + encode$1(e) : e;
  });
}, punycode$1 = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.1.0",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: ucs2decode,
    encode: ucs2encode
  },
  decode,
  encode: encode$1,
  toASCII,
  toUnicode
}, punycode_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode,
  default: punycode$1,
  encode: encode$1,
  toASCII,
  toUnicode,
  ucs2decode,
  ucs2encode
}, Symbol.toStringTag, { value: "Module" })), require$$8 = /* @__PURE__ */ getAugmentedNamespace(punycode_es6);
var _default = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 100
    // Internal protection, recursion limit
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, zero = {
  options: {
    html: !1,
    // Enable HTML tags in source
    xhtmlOut: !1,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, commonmark = {
  options: {
    html: !0,
    // Enable HTML tags in source
    xhtmlOut: !0,
    // Use '/' to close single tags (<br />)
    breaks: !1,
    // Convert '\n' in paragraphs into <br>
    langPrefix: "language-",
    // CSS language prefix for fenced blocks
    linkify: !1,
    // autoconvert URL-like texts to links
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    maxNesting: 20
    // Internal protection, recursion limit
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, utils = utils$1, helpers = helpers$1, Renderer = renderer, ParserCore = parser_core, ParserBlock = parser_block, ParserInline = parser_inline, LinkifyIt = linkifyIt, mdurl = mdurl$1, punycode = require$$8, config = {
  default: _default,
  zero,
  commonmark
}, BAD_PROTO_RE = /^(vbscript|javascript|file|data):/, GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function validateLink(t) {
  var e = t.trim().toLowerCase();
  return BAD_PROTO_RE.test(e) ? !!GOOD_DATA_RE.test(e) : !0;
}
var RECODE_HOSTNAME_FOR = ["http:", "https:", "mailto:"];
function normalizeLink(t) {
  var e = mdurl.parse(t, !0);
  if (e.hostname && (!e.protocol || RECODE_HOSTNAME_FOR.indexOf(e.protocol) >= 0))
    try {
      e.hostname = punycode.toASCII(e.hostname);
    } catch {
    }
  return mdurl.encode(mdurl.format(e));
}
function normalizeLinkText(t) {
  var e = mdurl.parse(t, !0);
  if (e.hostname && (!e.protocol || RECODE_HOSTNAME_FOR.indexOf(e.protocol) >= 0))
    try {
      e.hostname = punycode.toUnicode(e.hostname);
    } catch {
    }
  return mdurl.decode(mdurl.format(e), mdurl.decode.defaultChars + "%");
}
function MarkdownIt$1(t, e) {
  if (!(this instanceof MarkdownIt$1))
    return new MarkdownIt$1(t, e);
  e || utils.isString(t) || (e = t || {}, t = "default"), this.inline = new ParserInline(), this.block = new ParserBlock(), this.core = new ParserCore(), this.renderer = new Renderer(), this.linkify = new LinkifyIt(), this.validateLink = validateLink, this.normalizeLink = normalizeLink, this.normalizeLinkText = normalizeLinkText, this.utils = utils, this.helpers = utils.assign({}, helpers), this.options = {}, this.configure(t), e && this.set(e);
}
MarkdownIt$1.prototype.set = function(t) {
  return utils.assign(this.options, t), this;
};
MarkdownIt$1.prototype.configure = function(t) {
  var e = this, r;
  if (utils.isString(t) && (r = t, t = config[r], !t))
    throw new Error('Wrong `markdown-it` preset "' + r + '", check name');
  if (!t)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return t.options && e.set(t.options), t.components && Object.keys(t.components).forEach(function(o) {
    t.components[o].rules && e[o].ruler.enableOnly(t.components[o].rules), t.components[o].rules2 && e[o].ruler2.enableOnly(t.components[o].rules2);
  }), this;
};
MarkdownIt$1.prototype.enable = function(t, e) {
  var r = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(a) {
    r = r.concat(this[a].ruler.enable(t, !0));
  }, this), r = r.concat(this.inline.ruler2.enable(t, !0));
  var o = t.filter(function(a) {
    return r.indexOf(a) < 0;
  });
  if (o.length && !e)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + o);
  return this;
};
MarkdownIt$1.prototype.disable = function(t, e) {
  var r = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(a) {
    r = r.concat(this[a].ruler.disable(t, !0));
  }, this), r = r.concat(this.inline.ruler2.disable(t, !0));
  var o = t.filter(function(a) {
    return r.indexOf(a) < 0;
  });
  if (o.length && !e)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + o);
  return this;
};
MarkdownIt$1.prototype.use = function(t) {
  var e = [this].concat(Array.prototype.slice.call(arguments, 1));
  return t.apply(t, e), this;
};
MarkdownIt$1.prototype.parse = function(t, e) {
  if (typeof t != "string")
    throw new Error("Input data should be a String");
  var r = new this.core.State(t, this, e);
  return this.core.process(r), r.tokens;
};
MarkdownIt$1.prototype.render = function(t, e) {
  return e = e || {}, this.renderer.render(this.parse(t, e), this.options, e);
};
MarkdownIt$1.prototype.parseInline = function(t, e) {
  var r = new this.core.State(t, this, e);
  return r.inlineMode = !0, this.core.process(r), r.tokens;
};
MarkdownIt$1.prototype.renderInline = function(t, e) {
  return e = e || {}, this.renderer.render(this.parseInline(t, e), this.options, e);
};
var lib = MarkdownIt$1, markdownIt = lib;
const MarkdownIt = /* @__PURE__ */ getDefaultExportFromCjs(markdownIt), VueMarkdown = defineComponent({
  name: "VueMarkdown",
  props: {
    source: {
      type: String,
      required: !0
    },
    options: {
      type: Object,
      required: !1
    },
    plugins: {
      type: Array,
      required: !1
    }
  },
  setup(t) {
    const e = ref(new MarkdownIt(t.options ?? {}));
    for (const o of t.plugins ?? [])
      e.value.use(o);
    const r = computed(() => e.value.render(t.source));
    return () => h$1("div", { innerHTML: r.value });
  }
}), VueMarkdown$1 = VueMarkdown, _hoisted_1$6 = {
  key: 0,
  class: "empty-state"
}, _hoisted_2$2 = { class: "item-header" }, _hoisted_3$2 = { class: "truncate" }, _hoisted_4$1 = {
  key: 1,
  class: "empty-state"
}, _hoisted_5$1 = {
  key: 1,
  class: "empty-state"
}, _hoisted_6$1 = {
  key: 1,
  class: "empty-state"
}, _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "DxpGitBookSearch",
  setup(t) {
    const e = ref(), r = ref("search");
    let o = ref(""), a = ref([]);
    const c = ref({}), u = ref(!1), d = ref(!1), p = ref([]), g = ref(!1);
    function b() {
      e.value.$el.dismiss(null, "cancel");
    }
    function x() {
      o.value = "", a.value = [], c.value = {};
    }
    async function w() {
      u.value = !0;
      let $ = {};
      try {
        const D = await gitBookContext.askQuery({
          queryString: o.value,
          spaceId: process.env.VUE_APP_SPACE_ID,
          baseURL: process.env.VUE_APP_GITBOOK_BASE_URL,
          token: process.env.VUE_APP_GITBOOK_API_KEY
        });
        if (!lib$2.hasError(D))
          $ = D.data.answer, p.value = [], g.value = !1;
        else
          throw D.data;
      } catch (D) {
        console.error(D);
      }
      c.value = $, u.value = !1;
    }
    async function y() {
      u.value = !0;
      let $ = [];
      const D = process.env.VUE_APP_GITBOOK_BASE_URL;
      try {
        const L = await gitBookContext.searchQuery({
          queryString: o.value,
          spaceId: process.env.VUE_APP_SPACE_ID,
          baseURL: D,
          token: process.env.VUE_APP_GITBOOK_API_KEY
        });
        if (!lib$2.hasError(L))
          $ = L.data.items;
        else
          throw L.data;
      } catch (L) {
        console.error(L);
      }
      a.value = $, u.value = !1;
    }
    async function I() {
      d.value = !0;
      const $ = [];
      (await Promise.allSettled(c.value.sources.map((L) => {
        if (L.type === "page")
          return gitBookContext.getGitBookPage({
            pageId: L.page,
            spaceId: process.env.VUE_APP_SPACE_ID,
            baseURL: process.env.VUE_APP_GITBOOK_BASE_URL,
            token: process.env.VUE_APP_GITBOOK_API_KEY
          });
      }))).map((L) => {
        L.status === "fulfilled" && $.push(L.value.data);
      }), p.value = $, d.value = !1, g.value = !0;
    }
    function E($) {
      window.open(`https://docs.hotwax.co/user-guides/${$.path}`, "_blank");
    }
    function T($) {
      o.value = $, w();
    }
    function C() {
      r.value = "search", o.value = "", a.value = [], c.value = {}, u.value = !1, d.value = !1, p.value = [], g.value = !1;
    }
    return ($, D) => (openBlock(), createElementBlock(Fragment, null, [
      createVNode(unref(IonTabButton), {
        tab: "help",
        id: "gibook-search-modal"
      }, {
        default: withCtx(() => [
          createVNode(unref(IonIcon), { icon: unref(helpOutline) }, null, 8, ["icon"]),
          createVNode(unref(IonLabel), null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(unref(translate)("Help")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(unref(IonModal), {
        ref_key: "gitBookSearchModal",
        ref: e,
        trigger: "gibook-search-modal",
        onWillDismiss: D[4] || (D[4] = (L) => C())
      }, {
        default: withCtx(() => [
          createVNode(unref(IonHeader), null, {
            default: withCtx(() => [
              createVNode(unref(IonToolbar), null, {
                default: withCtx(() => [
                  createVNode(unref(IonButtons), { slot: "start" }, {
                    default: withCtx(() => [
                      createVNode(unref(IonButton), { onClick: b }, {
                        default: withCtx(() => [
                          createVNode(unref(IonIcon), {
                            icon: unref(close),
                            slot: "icon-only"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  createVNode(unref(IonTitle), null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(unref(translate)("Ask me anything?")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(unref(IonContent), null, {
            default: withCtx(() => [
              createVNode(unref(IonSearchbar), {
                placeholder: unref(translate)(r.value === "search" ? "Search..." : "Ask..."),
                value: unref(o),
                onKeyup: D[0] || (D[0] = withKeys((L) => {
                  isRef(o) ? o.value = L.target.value : o = L.target.value, r.value === "search" ? y() : w();
                }, ["enter"]))
              }, null, 8, ["placeholder", "value"]),
              createVNode(unref(IonSegment), {
                modelValue: r.value,
                "onUpdate:modelValue": D[1] || (D[1] = (L) => r.value = L),
                onIonChange: D[2] || (D[2] = (L) => x())
              }, {
                default: withCtx(() => [
                  createVNode(unref(IonSegmentButton), { value: "search" }, {
                    default: withCtx(() => [
                      createVNode(unref(IonLabel), null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(unref(translate)("Search")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  createVNode(unref(IonSegmentButton), { value: "ask" }, {
                    default: withCtx(() => [
                      createVNode(unref(IonLabel), null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(unref(translate)("Ask")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              u.value ? (openBlock(), createElementBlock("div", _hoisted_1$6, [
                createVNode(unref(IonItem), { lines: "none" }, {
                  default: withCtx(() => [
                    createVNode(unref(IonSpinner), {
                      name: "crescent",
                      slot: "start"
                    }),
                    createTextVNode(" " + toDisplayString$1(unref(translate)(r.value === "search" ? "Searching your query." : "Analyzing the question to answer your question.")), 1)
                  ]),
                  _: 1
                })
              ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                r.value === "search" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  unref(a).length ? (openBlock(!0), createElementBlock(Fragment, { key: 0 }, renderList(unref(a), (L, R) => (openBlock(), createElementBlock("div", { key: R }, [
                    createVNode(unref(IonItem), null, {
                      default: withCtx(() => [
                        createVNode(unref(IonIcon), {
                          icon: unref(documentOutline),
                          slot: "start"
                        }, null, 8, ["icon"]),
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(L.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(unref(IonButton), {
                          fill: "clear",
                          color: "medium",
                          slot: "end",
                          onClick: (O) => E(L)
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(IonIcon), {
                              icon: unref(returnDownBackOutline),
                              slot: "start"
                            }, null, 8, ["icon"]),
                            createTextVNode(" " + toDisplayString$1(unref(translate)("go to page")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    L.sections.length ? (openBlock(!0), createElementBlock(Fragment, { key: 0 }, renderList(L.sections, (O, P) => (openBlock(), createBlock(unref(IonItem), {
                      key: P,
                      class: "ion-padding-left"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(IonIcon), {
                          icon: unref(returnDownForwardOutline),
                          slot: "start"
                        }, null, 8, ["icon"]),
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createElementVNode("div", _hoisted_2$2, [
                              createVNode(unref(VueMarkdown$1), {
                                source: O.title ? O.title : L.title
                              }, null, 8, ["source"]),
                              createVNode(unref(IonButton), {
                                fill: "clear",
                                color: "medium",
                                slot: "end",
                                onClick: (z) => E(O)
                              }, {
                                default: withCtx(() => [
                                  createVNode(unref(IonIcon), {
                                    icon: unref(returnDownBackOutline),
                                    slot: "start"
                                  }, null, 8, ["icon"]),
                                  createTextVNode(" " + toDisplayString$1(unref(translate)("go to section")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            createElementVNode("p", _hoisted_3$2, [
                              createVNode(unref(VueMarkdown$1), {
                                source: O.body
                              }, null, 8, ["source"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))), 128)) : createCommentVNode("", !0)
                  ]))), 128)) : unref(o) ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
                    createVNode(unref(IonItem), { lines: "none" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(unref(translate)("No page found.")), 1)
                      ]),
                      _: 1
                    })
                  ])) : createCommentVNode("", !0)
                ], 64)) : r.value === "ask" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  c.value && Object.keys(c.value).length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createVNode(unref(IonItem), { lines: "none" }, {
                      default: withCtx(() => [
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(unref(o)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    createVNode(unref(IonItem), null, {
                      default: withCtx(() => [
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createElementVNode("p", null, [
                              createVNode(unref(VueMarkdown$1), {
                                source: c.value.text
                              }, null, 8, ["source"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    c.value.sources.length ? (openBlock(), createBlock(unref(IonItem), {
                      key: 0,
                      button: "",
                      onClick: D[3] || (D[3] = (L) => g.value ? "" : I())
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createElementVNode("p", null, toDisplayString$1(unref(translate)("Answer based on resources", { count: c.value.sources.length })), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(unref(IonIcon), {
                          icon: p.value.length ? unref(caretDownOutline) : unref(caretForwardOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })) : createCommentVNode("", !0),
                    d.value ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
                      createVNode(unref(IonItem), { lines: "none" }, {
                        default: withCtx(() => [
                          createVNode(unref(IonSpinner), {
                            name: "crescent",
                            slot: "start"
                          }),
                          createTextVNode(" " + toDisplayString$1(unref(translate)("Fetching resources...")), 1)
                        ]),
                        _: 1
                      })
                    ])) : p.value.length ? (openBlock(), createBlock(unref(IonList), { key: 2 }, {
                      default: withCtx(() => [
                        (openBlock(!0), createElementBlock(Fragment, null, renderList(p.value, (L) => (openBlock(), createBlock(unref(IonItem), {
                          key: L.title
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(IonLabel), null, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(L.title), 1)
                              ]),
                              _: 2
                            }, 1024),
                            createVNode(unref(IonButton), {
                              fill: "clear",
                              color: "medium",
                              slot: "end",
                              onClick: (R) => E(L)
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(IonIcon), {
                                  icon: unref(returnDownBackOutline),
                                  slot: "start"
                                }, null, 8, ["icon"]),
                                createTextVNode(" " + toDisplayString$1(unref(translate)("go to page")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))), 128))
                      ]),
                      _: 1
                    })) : g.value ? (openBlock(), createBlock(unref(IonItem), { key: 3 }, {
                      default: withCtx(() => [
                        createVNode(unref(IonLabel), null, {
                          default: withCtx(() => [
                            createElementVNode("p", null, toDisplayString$1(unref(translate)("No resource found.")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })) : createCommentVNode("", !0),
                    c.value.followupQuestions.length ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
                      createVNode(unref(IonItem), { lines: "none" }, {
                        default: withCtx(() => [
                          createVNode(unref(IonLabel), null, {
                            default: withCtx(() => [
                              createElementVNode("p", null, toDisplayString$1(unref(translate)("Related Queries")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (openBlock(!0), createElementBlock(Fragment, null, renderList(c.value.followupQuestions, (L, R) => (openBlock(), createBlock(unref(IonItem), {
                        lines: "none",
                        key: R,
                        onClick: (O) => T(L)
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(IonChip), null, {
                            default: withCtx(() => [
                              createVNode(unref(IonIcon), { icon: unref(searchOutline) }, null, 8, ["icon"]),
                              createVNode(unref(IonLabel), null, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString$1(L), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))), 128))
                    ], 64)) : createCommentVNode("", !0)
                  ], 64)) : unref(o) ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
                    createVNode(unref(IonItem), { lines: "none" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(unref(translate)("No answer found.")), 1)
                      ]),
                      _: 1
                    })
                  ])) : createCommentVNode("", !0)
                ], 64)) : createCommentVNode("", !0)
              ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ], 64));
  }
}), _hoisted_1$5 = ["src"], _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "DxpImage",
  props: ["src"],
  setup(t) {
    const e = t;
    let r = ref(imageContext.defaultImgUrl), o = process.env.VUE_APP_RESOURCE_URL || "";
    const a = () => {
      if (e.src)
        if (e.src.startsWith("http"))
          c(e.src).then(() => {
            r.value = e.src;
          }).catch(() => {
            console.error("Image doesn't exist");
          });
        else if (e.src.indexOf("assets/") != -1 || e.src.startsWith("/img/"))
          r.value = e.src;
        else {
          const u = o.concat(e.src);
          c(r).then(() => {
            r.value = u;
          }).catch(() => {
            console.error("Image doesn't exist");
          });
        }
    }, c = (u) => new Promise((d, p) => {
      const g = new Image();
      g.onload = () => d(!0), g.onerror = () => p(!1), g.src = u;
    });
    return onMounted(() => {
      a();
    }), onUpdated(() => {
      a();
    }), (u, d) => (openBlock(), createElementBlock("img", { src: unref(r) }, null, 8, _hoisted_1$5));
  }
}), goToOms = (t, e) => {
  const r = (e.startsWith("http") ? e.replace(/\/api\/?|\/$/, "") : `https://${e}.hotwax.io`) + `/commerce/control/main?token=${t}`;
  window.open(r, "_blank", "noopener, noreferrer");
}, getProductIdentificationValue = (t, e) => {
  var a;
  if (!Object.keys(e).length)
    return;
  let r = e[t];
  const o = (a = e.goodIdentifications) == null ? void 0 : a.find((c) => c.startsWith(t + "/"));
  return o && (r = o.split("/")[1]), r;
}, showToast$1 = async (t, e) => {
  const r = [{
    text: "Dismiss",
    role: "cancel"
  }];
  return e && r.push(...e), (await toastController.create({
    message: t,
    duration: 3e3,
    position: "bottom",
    buttons: r
  })).present();
}, getCurrentTime = (t, e = "t ZZZZ") => DateTime.now().setZone(t).toFormat(e), useUserStore = defineStore("user", {
  state: () => ({
    localeOptions: process.env.VUE_APP_LOCALES ? JSON.parse(process.env.VUE_APP_LOCALES) : { "en-US": "English" },
    locale: "en-US",
    currentTimeZoneId: "",
    timeZones: []
  }),
  getters: {
    getLocale: (t) => t.locale,
    getLocaleOptions: (t) => t.localeOptions,
    getTimeZones: (t) => t.timeZones,
    getCurrentTimeZone: (t) => t.currentTimeZoneId
  },
  actions: {
    async setLocale(t) {
      let e, r;
      e = this.locale;
      try {
        t && (r = Object.keys(this.localeOptions).find((o) => o === t), r = r || Object.keys(this.localeOptions).find((o) => o.slice(0, 2) === t.slice(0, 2)), e = r || this.locale, userContext.setUserLocale && await userContext.setUserLocale({ newLocale: e }));
      } catch (o) {
        console.error(o);
      } finally {
        i18n.global.locale.value = e, this.locale = e;
      }
    },
    async setUserTimeZone(t) {
      if (this.currentTimeZoneId !== t)
        try {
          return await userContext.setUserTimeZone({ tzId: t }), this.currentTimeZoneId = t, showToast$1(translate("Time zone updated successfully")), Promise.resolve(t);
        } catch (e) {
          return console.error("Error", e), Promise.reject("");
        }
    },
    async getAvailableTimeZones() {
      if (!this.timeZones.length)
        try {
          const t = await userContext.getAvailableTimeZones();
          this.timeZones = t.filter((e) => DateTime.local().setZone(e.id).isValid);
        } catch (t) {
          console.error("Error", t);
        }
    },
    updateTimeZone(t) {
      this.currentTimeZoneId = t;
    }
  },
  persist: !0
}), _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "DxpLanguageSwitcher",
  setup(t) {
    const e = useUserStore(), r = computed(() => e.getLocaleOptions), o = computed(() => e.getLocale), a = (c) => {
      e.setLocale(c);
    };
    return (c, u) => (openBlock(), createBlock(unref(IonCard), null, {
      default: withCtx(() => [
        createVNode(unref(IonCardHeader), null, {
          default: withCtx(() => [
            createVNode(unref(IonCardTitle), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(c.$t("Language")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(unref(IonCardContent), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(c.$t("Select your preferred language.")), 1)
          ]),
          _: 1
        }),
        createVNode(unref(IonItem), { lines: "none" }, {
          default: withCtx(() => [
            createVNode(unref(IonSelect), {
              label: c.$t("Choose language"),
              interface: "popover",
              value: o.value,
              onIonChange: u[0] || (u[0] = (d) => a(d.detail.value))
            }, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(Object.keys(r.value), (d) => (openBlock(), createBlock(unref(IonSelectOption), {
                  key: d,
                  value: d
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(r.value[d]), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["label", "value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function(t) {
  const e = [];
  let r = 0;
  for (let o = 0; o < t.length; o++) {
    let a = t.charCodeAt(o);
    a < 128 ? e[r++] = a : a < 2048 ? (e[r++] = a >> 6 | 192, e[r++] = a & 63 | 128) : (a & 64512) === 55296 && o + 1 < t.length && (t.charCodeAt(o + 1) & 64512) === 56320 ? (a = 65536 + ((a & 1023) << 10) + (t.charCodeAt(++o) & 1023), e[r++] = a >> 18 | 240, e[r++] = a >> 12 & 63 | 128, e[r++] = a >> 6 & 63 | 128, e[r++] = a & 63 | 128) : (e[r++] = a >> 12 | 224, e[r++] = a >> 6 & 63 | 128, e[r++] = a & 63 | 128);
  }
  return e;
}, byteArrayToString = function(t) {
  const e = [];
  let r = 0, o = 0;
  for (; r < t.length; ) {
    const a = t[r++];
    if (a < 128)
      e[o++] = String.fromCharCode(a);
    else if (a > 191 && a < 224) {
      const c = t[r++];
      e[o++] = String.fromCharCode((a & 31) << 6 | c & 63);
    } else if (a > 239 && a < 365) {
      const c = t[r++], u = t[r++], d = t[r++], p = ((a & 7) << 18 | (c & 63) << 12 | (u & 63) << 6 | d & 63) - 65536;
      e[o++] = String.fromCharCode(55296 + (p >> 10)), e[o++] = String.fromCharCode(56320 + (p & 1023));
    } else {
      const c = t[r++], u = t[r++];
      e[o++] = String.fromCharCode((a & 15) << 12 | (c & 63) << 6 | u & 63);
    }
  }
  return e.join("");
}, base64 = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(t, e) {
    if (!Array.isArray(t))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const r = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, o = [];
    for (let a = 0; a < t.length; a += 3) {
      const c = t[a], u = a + 1 < t.length, d = u ? t[a + 1] : 0, p = a + 2 < t.length, g = p ? t[a + 2] : 0, b = c >> 2, x = (c & 3) << 4 | d >> 4;
      let w = (d & 15) << 2 | g >> 6, y = g & 63;
      p || (y = 64, u || (w = 64)), o.push(r[b], r[x], r[w], r[y]);
    }
    return o.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(stringToByteArray$1(t), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : byteArrayToString(this.decodeStringToByteArray(t, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(t, e) {
    this.init_();
    const r = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, o = [];
    for (let a = 0; a < t.length; ) {
      const c = r[t.charAt(a++)], d = a < t.length ? r[t.charAt(a)] : 0;
      ++a;
      const g = a < t.length ? r[t.charAt(a)] : 64;
      ++a;
      const x = a < t.length ? r[t.charAt(a)] : 64;
      if (++a, c == null || d == null || g == null || x == null)
        throw new DecodeBase64StringError();
      const w = c << 2 | d >> 4;
      if (o.push(w), g !== 64) {
        const y = d << 4 & 240 | g >> 2;
        if (o.push(y), x !== 64) {
          const I = g << 6 & 192 | x;
          o.push(I);
        }
      }
    }
    return o;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let t = 0; t < this.ENCODED_VALS.length; t++)
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
    }
  }
};
class DecodeBase64StringError extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const base64Encode = function(t) {
  const e = stringToByteArray$1(t);
  return base64.encodeByteArray(e, !0);
}, base64urlEncodeWithoutPadding = function(t) {
  return base64Encode(t).replace(/\./g, "");
}, base64Decode = function(t) {
  try {
    return base64.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getGlobal() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__, getDefaultsFromEnvVariable = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const t = process.env.__FIREBASE_DEFAULTS__;
  if (t)
    return JSON.parse(t);
}, getDefaultsFromCookie = () => {
  if (typeof document > "u")
    return;
  let t;
  try {
    t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const e = t && base64Decode(t[1]);
  return e && JSON.parse(e);
}, getDefaults = () => {
  try {
    return getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
  } catch (t) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${t}`);
    return;
  }
}, getDefaultAppConfig = () => {
  var t;
  return (t = getDefaults()) === null || t === void 0 ? void 0 : t.config;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, r) => {
      this.resolve = e, this.reject = r;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (r, o) => {
      r ? this.reject(r) : this.resolve(o), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(r) : e(r, o));
    };
  }
}
function isIndexedDBAvailable() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function validateIndexedDBOpenable() {
  return new Promise((t, e) => {
    try {
      let r = !0;
      const o = "validate-browser-context-for-indexeddb-analytics-module", a = self.indexedDB.open(o);
      a.onsuccess = () => {
        a.result.close(), r || self.indexedDB.deleteDatabase(o), t(!0);
      }, a.onupgradeneeded = () => {
        r = !1;
      }, a.onerror = () => {
        var c;
        e(((c = a.error) === null || c === void 0 ? void 0 : c.message) || "");
      };
    } catch (r) {
      e(r);
    }
  });
}
function areCookiesEnabled() {
  return !(typeof navigator > "u" || !navigator.cookieEnabled);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_NAME = "FirebaseError";
class FirebaseError extends Error {
  constructor(e, r, o) {
    super(r), this.code = e, this.customData = o, this.name = ERROR_NAME, Object.setPrototypeOf(this, FirebaseError.prototype), Error.captureStackTrace && Error.captureStackTrace(this, ErrorFactory.prototype.create);
  }
}
class ErrorFactory {
  constructor(e, r, o) {
    this.service = e, this.serviceName = r, this.errors = o;
  }
  create(e, ...r) {
    const o = r[0] || {}, a = `${this.service}/${e}`, c = this.errors[e], u = c ? replaceTemplate(c, o) : "Error", d = `${this.serviceName}: ${u} (${a}).`;
    return new FirebaseError(a, d, o);
  }
}
function replaceTemplate(t, e) {
  return t.replace(PATTERN, (r, o) => {
    const a = e[o];
    return a != null ? String(a) : `<${o}?>`;
  });
}
const PATTERN = /\{\$([^}]+)}/g;
function deepEqual(t, e) {
  if (t === e)
    return !0;
  const r = Object.keys(t), o = Object.keys(e);
  for (const a of r) {
    if (!o.includes(a))
      return !1;
    const c = t[a], u = e[a];
    if (isObject$3(c) && isObject$3(u)) {
      if (!deepEqual(c, u))
        return !1;
    } else if (c !== u)
      return !1;
  }
  for (const a of o)
    if (!r.includes(a))
      return !1;
  return !0;
}
function isObject$3(t) {
  return t !== null && typeof t == "object";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(t) {
  return t && t._delegate ? t._delegate : t;
}
class Component {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, r, o) {
    this.name = e, this.instanceFactory = r, this.type = o, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME$1 = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Provider {
  constructor(e, r) {
    this.name = e, this.container = r, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const r = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(r)) {
      const o = new Deferred();
      if (this.instancesDeferred.set(r, o), this.isInitialized(r) || this.shouldAutoInitialize())
        try {
          const a = this.getOrInitializeService({
            instanceIdentifier: r
          });
          a && o.resolve(a);
        } catch {
        }
    }
    return this.instancesDeferred.get(r).promise;
  }
  getImmediate(e) {
    var r;
    const o = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier), a = (r = e == null ? void 0 : e.optional) !== null && r !== void 0 ? r : !1;
    if (this.isInitialized(o) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: o
        });
      } catch (c) {
        if (a)
          return null;
        throw c;
      }
    else {
      if (a)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (isComponentEager(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME$1 });
        } catch {
        }
      for (const [r, o] of this.instancesDeferred.entries()) {
        const a = this.normalizeInstanceIdentifier(r);
        try {
          const c = this.getOrInitializeService({
            instanceIdentifier: a
          });
          o.resolve(c);
        } catch {
        }
      }
    }
  }
  clearInstance(e = DEFAULT_ENTRY_NAME$1) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((r) => "INTERNAL" in r).map((r) => r.INTERNAL.delete()),
      ...e.filter((r) => "_delete" in r).map((r) => r._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = DEFAULT_ENTRY_NAME$1) {
    return this.instances.has(e);
  }
  getOptions(e = DEFAULT_ENTRY_NAME$1) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: r = {} } = e, o = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(o))
      throw Error(`${this.name}(${o}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const a = this.getOrInitializeService({
      instanceIdentifier: o,
      options: r
    });
    for (const [c, u] of this.instancesDeferred.entries()) {
      const d = this.normalizeInstanceIdentifier(c);
      o === d && u.resolve(a);
    }
    return a;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, r) {
    var o;
    const a = this.normalizeInstanceIdentifier(r), c = (o = this.onInitCallbacks.get(a)) !== null && o !== void 0 ? o : /* @__PURE__ */ new Set();
    c.add(e), this.onInitCallbacks.set(a, c);
    const u = this.instances.get(a);
    return u && e(u, a), () => {
      c.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, r) {
    const o = this.onInitCallbacks.get(r);
    if (o)
      for (const a of o)
        try {
          a(e, r);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: r = {} }) {
    let o = this.instances.get(e);
    if (!o && this.component && (o = this.component.instanceFactory(this.container, {
      instanceIdentifier: normalizeIdentifierForFactory(e),
      options: r
    }), this.instances.set(e, o), this.instancesOptions.set(e, r), this.invokeOnInitCallbacks(o, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, o);
      } catch {
      }
    return o || null;
  }
  normalizeInstanceIdentifier(e = DEFAULT_ENTRY_NAME$1) {
    return this.component ? this.component.multipleInstances ? e : DEFAULT_ENTRY_NAME$1 : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function normalizeIdentifierForFactory(t) {
  return t === DEFAULT_ENTRY_NAME$1 ? void 0 : t;
}
function isComponentEager(t) {
  return t.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ComponentContainer {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const r = this.getProvider(e.name);
    if (r.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    r.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const r = new Provider(e, this);
    return this.providers.set(e, r), r;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LogLevel;
(function(t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
  debug: LogLevel.DEBUG,
  verbose: LogLevel.VERBOSE,
  info: LogLevel.INFO,
  warn: LogLevel.WARN,
  error: LogLevel.ERROR,
  silent: LogLevel.SILENT
}, defaultLogLevel = LogLevel.INFO, ConsoleMethod = {
  [LogLevel.DEBUG]: "log",
  [LogLevel.VERBOSE]: "log",
  [LogLevel.INFO]: "info",
  [LogLevel.WARN]: "warn",
  [LogLevel.ERROR]: "error"
}, defaultLogHandler = (t, e, ...r) => {
  if (e < t.logLevel)
    return;
  const o = (/* @__PURE__ */ new Date()).toISOString(), a = ConsoleMethod[e];
  if (a)
    console[a](`[${o}]  ${t.name}:`, ...r);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
class Logger {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = defaultLogLevel, this._logHandler = defaultLogHandler, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in LogLevel))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? levelStringToEnum[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...e), this._logHandler(this, LogLevel.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...e), this._logHandler(this, LogLevel.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...e), this._logHandler(this, LogLevel.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...e), this._logHandler(this, LogLevel.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...e), this._logHandler(this, LogLevel.ERROR, ...e);
  }
}
const instanceOfAny$2 = (t, e) => e.some((r) => t instanceof r);
let idbProxyableTypes$2, cursorAdvanceMethods$2;
function getIdbProxyableTypes$2() {
  return idbProxyableTypes$2 || (idbProxyableTypes$2 = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods$2() {
  return cursorAdvanceMethods$2 || (cursorAdvanceMethods$2 = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const cursorRequestMap$2 = /* @__PURE__ */ new WeakMap(), transactionDoneMap$2 = /* @__PURE__ */ new WeakMap(), transactionStoreNamesMap$2 = /* @__PURE__ */ new WeakMap(), transformCache$2 = /* @__PURE__ */ new WeakMap(), reverseTransformCache$2 = /* @__PURE__ */ new WeakMap();
function promisifyRequest$2(t) {
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("success", c), t.removeEventListener("error", u);
    }, c = () => {
      r(wrap$2(t.result)), a();
    }, u = () => {
      o(t.error), a();
    };
    t.addEventListener("success", c), t.addEventListener("error", u);
  });
  return e.then((r) => {
    r instanceof IDBCursor && cursorRequestMap$2.set(r, t);
  }).catch(() => {
  }), reverseTransformCache$2.set(e, t), e;
}
function cacheDonePromiseForTransaction$2(t) {
  if (transactionDoneMap$2.has(t))
    return;
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("complete", c), t.removeEventListener("error", u), t.removeEventListener("abort", u);
    }, c = () => {
      r(), a();
    }, u = () => {
      o(t.error || new DOMException("AbortError", "AbortError")), a();
    };
    t.addEventListener("complete", c), t.addEventListener("error", u), t.addEventListener("abort", u);
  });
  transactionDoneMap$2.set(t, e);
}
let idbProxyTraps$2 = {
  get(t, e, r) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return transactionDoneMap$2.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || transactionStoreNamesMap$2.get(t);
      if (e === "store")
        return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return wrap$2(t[e]);
  },
  set(t, e, r) {
    return t[e] = r, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function replaceTraps$2(t) {
  idbProxyTraps$2 = t(idbProxyTraps$2);
}
function wrapFunction$2(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...r) {
    const o = t.call(unwrap$2(this), e, ...r);
    return transactionStoreNamesMap$2.set(o, e.sort ? e.sort() : [e]), wrap$2(o);
  } : getCursorAdvanceMethods$2().includes(t) ? function(...e) {
    return t.apply(unwrap$2(this), e), wrap$2(cursorRequestMap$2.get(this));
  } : function(...e) {
    return wrap$2(t.apply(unwrap$2(this), e));
  };
}
function transformCachableValue$2(t) {
  return typeof t == "function" ? wrapFunction$2(t) : (t instanceof IDBTransaction && cacheDonePromiseForTransaction$2(t), instanceOfAny$2(t, getIdbProxyableTypes$2()) ? new Proxy(t, idbProxyTraps$2) : t);
}
function wrap$2(t) {
  if (t instanceof IDBRequest)
    return promisifyRequest$2(t);
  if (transformCache$2.has(t))
    return transformCache$2.get(t);
  const e = transformCachableValue$2(t);
  return e !== t && (transformCache$2.set(t, e), reverseTransformCache$2.set(e, t)), e;
}
const unwrap$2 = (t) => reverseTransformCache$2.get(t);
function openDB$2(t, e, { blocked: r, upgrade: o, blocking: a, terminated: c } = {}) {
  const u = indexedDB.open(t, e), d = wrap$2(u);
  return o && u.addEventListener("upgradeneeded", (p) => {
    o(wrap$2(u.result), p.oldVersion, p.newVersion, wrap$2(u.transaction), p);
  }), r && u.addEventListener("blocked", (p) => r(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    p.oldVersion,
    p.newVersion,
    p
  )), d.then((p) => {
    c && p.addEventListener("close", () => c()), a && p.addEventListener("versionchange", (g) => a(g.oldVersion, g.newVersion, g));
  }).catch(() => {
  }), d;
}
const readMethods$2 = ["get", "getKey", "getAll", "getAllKeys", "count"], writeMethods$2 = ["put", "add", "delete", "clear"], cachedMethods$2 = /* @__PURE__ */ new Map();
function getMethod$2(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (cachedMethods$2.get(e))
    return cachedMethods$2.get(e);
  const r = e.replace(/FromIndex$/, ""), o = e !== r, a = writeMethods$2.includes(r);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(r in (o ? IDBIndex : IDBObjectStore).prototype) || !(a || readMethods$2.includes(r))
  )
    return;
  const c = async function(u, ...d) {
    const p = this.transaction(u, a ? "readwrite" : "readonly");
    let g = p.store;
    return o && (g = g.index(d.shift())), (await Promise.all([
      g[r](...d),
      a && p.done
    ]))[0];
  };
  return cachedMethods$2.set(e, c), c;
}
replaceTraps$2((t) => ({
  ...t,
  get: (e, r, o) => getMethod$2(e, r) || t.get(e, r, o),
  has: (e, r) => !!getMethod$2(e, r) || t.has(e, r)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((r) => {
      if (isVersionServiceProvider(r)) {
        const o = r.getImmediate();
        return `${o.library}/${o.version}`;
      } else
        return null;
    }).filter((r) => r).join(" ");
  }
}
function isVersionServiceProvider(t) {
  const e = t.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}
const name$o = "@firebase/app", version$1$1 = "0.9.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger("@firebase/app"), name$n = "@firebase/app-compat", name$m = "@firebase/analytics-compat", name$l = "@firebase/analytics", name$k = "@firebase/app-check-compat", name$j = "@firebase/app-check", name$i = "@firebase/auth", name$h = "@firebase/auth-compat", name$g = "@firebase/database", name$f = "@firebase/database-compat", name$e = "@firebase/functions", name$d = "@firebase/functions-compat", name$c = "@firebase/installations", name$b = "@firebase/installations-compat", name$a = "@firebase/messaging", name$9 = "@firebase/messaging-compat", name$8 = "@firebase/performance", name$7 = "@firebase/performance-compat", name$6 = "@firebase/remote-config", name$5 = "@firebase/remote-config-compat", name$4 = "@firebase/storage", name$3 = "@firebase/storage-compat", name$2$1 = "@firebase/firestore", name$1$1 = "@firebase/firestore-compat", name$p = "firebase";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = "[DEFAULT]", PLATFORM_LOG_STRING = {
  [name$o]: "fire-core",
  [name$n]: "fire-core-compat",
  [name$l]: "fire-analytics",
  [name$m]: "fire-analytics-compat",
  [name$j]: "fire-app-check",
  [name$k]: "fire-app-check-compat",
  [name$i]: "fire-auth",
  [name$h]: "fire-auth-compat",
  [name$g]: "fire-rtdb",
  [name$f]: "fire-rtdb-compat",
  [name$e]: "fire-fn",
  [name$d]: "fire-fn-compat",
  [name$c]: "fire-iid",
  [name$b]: "fire-iid-compat",
  [name$a]: "fire-fcm",
  [name$9]: "fire-fcm-compat",
  [name$8]: "fire-perf",
  [name$7]: "fire-perf-compat",
  [name$6]: "fire-rc",
  [name$5]: "fire-rc-compat",
  [name$4]: "fire-gcs",
  [name$3]: "fire-gcs-compat",
  [name$2$1]: "fire-fst",
  [name$1$1]: "fire-fst-compat",
  "fire-js": "fire-js",
  [name$p]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _apps = /* @__PURE__ */ new Map(), _components = /* @__PURE__ */ new Map();
function _addComponent(t, e) {
  try {
    t.container.addComponent(e);
  } catch (r) {
    logger.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, r);
  }
}
function _registerComponent(t) {
  const e = t.name;
  if (_components.has(e))
    return logger.debug(`There were multiple attempts to register component ${e}.`), !1;
  _components.set(e, t);
  for (const r of _apps.values())
    _addComponent(r, t);
  return !0;
}
function _getProvider(t, e) {
  const r = t.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return r && r.triggerHeartbeat(), t.container.getProvider(e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
}, ERROR_FACTORY$2 = new ErrorFactory("app", "Firebase", ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
  constructor(e, r, o) {
    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, r), this._name = r.name, this._automaticDataCollectionEnabled = r.automaticDataCollectionEnabled, this._container = o, this.container.addComponent(new Component(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw ERROR_FACTORY$2.create("app-deleted", { appName: this._name });
  }
}
function initializeApp(t, e = {}) {
  let r = t;
  typeof e != "object" && (e = { name: e });
  const o = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: !1 }, e), a = o.name;
  if (typeof a != "string" || !a)
    throw ERROR_FACTORY$2.create("bad-app-name", {
      appName: String(a)
    });
  if (r || (r = getDefaultAppConfig()), !r)
    throw ERROR_FACTORY$2.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const c = _apps.get(a);
  if (c) {
    if (deepEqual(r, c.options) && deepEqual(o, c.config))
      return c;
    throw ERROR_FACTORY$2.create("duplicate-app", { appName: a });
  }
  const u = new ComponentContainer(a);
  for (const p of _components.values())
    u.addComponent(p);
  const d = new FirebaseAppImpl(r, o, u);
  return _apps.set(a, d), d;
}
function getApp(t = DEFAULT_ENTRY_NAME) {
  const e = _apps.get(t);
  if (!e && t === DEFAULT_ENTRY_NAME && getDefaultAppConfig())
    return initializeApp();
  if (!e)
    throw ERROR_FACTORY$2.create("no-app", { appName: t });
  return e;
}
function registerVersion(t, e, r) {
  var o;
  let a = (o = PLATFORM_LOG_STRING[t]) !== null && o !== void 0 ? o : t;
  r && (a += `-${r}`);
  const c = a.match(/\s|\//), u = e.match(/\s|\//);
  if (c || u) {
    const d = [
      `Unable to register library "${a}" with version "${e}":`
    ];
    c && d.push(`library name "${a}" contains illegal characters (whitespace or "/")`), c && u && d.push("and"), u && d.push(`version name "${e}" contains illegal characters (whitespace or "/")`), logger.warn(d.join(" "));
    return;
  }
  _registerComponent(new Component(
    `${a}-version`,
    () => ({ library: a, version: e }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = "firebase-heartbeat-database", DB_VERSION = 1, STORE_NAME = "firebase-heartbeat-store";
let dbPromise$2 = null;
function getDbPromise$2() {
  return dbPromise$2 || (dbPromise$2 = openDB$2(DB_NAME, DB_VERSION, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(STORE_NAME);
      }
    }
  }).catch((t) => {
    throw ERROR_FACTORY$2.create("idb-open", {
      originalErrorMessage: t.message
    });
  })), dbPromise$2;
}
async function readHeartbeatsFromIndexedDB(t) {
  try {
    return await (await getDbPromise$2()).transaction(STORE_NAME).objectStore(STORE_NAME).get(computeKey(t));
  } catch (e) {
    if (e instanceof FirebaseError)
      logger.warn(e.message);
    else {
      const r = ERROR_FACTORY$2.create("idb-get", {
        originalErrorMessage: e == null ? void 0 : e.message
      });
      logger.warn(r.message);
    }
  }
}
async function writeHeartbeatsToIndexedDB(t, e) {
  try {
    const o = (await getDbPromise$2()).transaction(STORE_NAME, "readwrite");
    await o.objectStore(STORE_NAME).put(e, computeKey(t)), await o.done;
  } catch (r) {
    if (r instanceof FirebaseError)
      logger.warn(r.message);
    else {
      const o = ERROR_FACTORY$2.create("idb-set", {
        originalErrorMessage: r == null ? void 0 : r.message
      });
      logger.warn(o.message);
    }
  }
}
function computeKey(t) {
  return `${t.name}!${t.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024, STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1e3;
class HeartbeatServiceImpl {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const r = this.container.getProvider("app").getImmediate();
    this._storage = new HeartbeatStorageImpl(r), this._heartbeatsCachePromise = this._storage.read().then((o) => (this._heartbeatsCache = o, o));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    const r = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), o = getUTCDateString();
    if (this._heartbeatsCache === null && (this._heartbeatsCache = await this._heartbeatsCachePromise), !(this._heartbeatsCache.lastSentHeartbeatDate === o || this._heartbeatsCache.heartbeats.some((a) => a.date === o)))
      return this._heartbeatsCache.heartbeats.push({ date: o, agent: r }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((a) => {
        const c = new Date(a.date).valueOf();
        return Date.now() - c <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const e = getUTCDateString(), { heartbeatsToSend: r, unsentEntries: o } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats), a = base64urlEncodeWithoutPadding(JSON.stringify({ version: 2, heartbeats: r }));
    return this._heartbeatsCache.lastSentHeartbeatDate = e, o.length > 0 ? (this._heartbeatsCache.heartbeats = o, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), a;
  }
}
function getUTCDateString() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(t, e = MAX_HEADER_BYTES) {
  const r = [];
  let o = t.slice();
  for (const a of t) {
    const c = r.find((u) => u.agent === a.agent);
    if (c) {
      if (c.dates.push(a.date), countBytes(r) > e) {
        c.dates.pop();
        break;
      }
    } else if (r.push({
      agent: a.agent,
      dates: [a.date]
    }), countBytes(r) > e) {
      r.pop();
      break;
    }
    o = o.slice(1);
  }
  return {
    heartbeatsToSend: r,
    unsentEntries: o
  };
}
class HeartbeatStorageImpl {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return isIndexedDBAvailable() ? validateIndexedDBOpenable().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    return await this._canUseIndexedDBPromise ? await readHeartbeatsFromIndexedDB(this.app) || { heartbeats: [] } : { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    var r;
    if (await this._canUseIndexedDBPromise) {
      const a = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate: (r = e.lastSentHeartbeatDate) !== null && r !== void 0 ? r : a.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    var r;
    if (await this._canUseIndexedDBPromise) {
      const a = await this.read();
      return writeHeartbeatsToIndexedDB(this.app, {
        lastSentHeartbeatDate: (r = e.lastSentHeartbeatDate) !== null && r !== void 0 ? r : a.lastSentHeartbeatDate,
        heartbeats: [
          ...a.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function countBytes(t) {
  return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: t })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(t) {
  _registerComponent(new Component(
    "platform-logger",
    (e) => new PlatformLoggerServiceImpl(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), _registerComponent(new Component(
    "heartbeat",
    (e) => new HeartbeatServiceImpl(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), registerVersion(name$o, version$1$1, t), registerVersion(name$o, version$1$1, "esm2017"), registerVersion("fire-js", "");
}
registerCoreComponents("");
var name$2 = "firebase", version$2 = "10.3.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(name$2, version$2, "app");
const instanceOfAny$1 = (t, e) => e.some((r) => t instanceof r);
let idbProxyableTypes$1, cursorAdvanceMethods$1;
function getIdbProxyableTypes$1() {
  return idbProxyableTypes$1 || (idbProxyableTypes$1 = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods$1() {
  return cursorAdvanceMethods$1 || (cursorAdvanceMethods$1 = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const cursorRequestMap$1 = /* @__PURE__ */ new WeakMap(), transactionDoneMap$1 = /* @__PURE__ */ new WeakMap(), transactionStoreNamesMap$1 = /* @__PURE__ */ new WeakMap(), transformCache$1 = /* @__PURE__ */ new WeakMap(), reverseTransformCache$1 = /* @__PURE__ */ new WeakMap();
function promisifyRequest$1(t) {
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("success", c), t.removeEventListener("error", u);
    }, c = () => {
      r(wrap$1(t.result)), a();
    }, u = () => {
      o(t.error), a();
    };
    t.addEventListener("success", c), t.addEventListener("error", u);
  });
  return e.then((r) => {
    r instanceof IDBCursor && cursorRequestMap$1.set(r, t);
  }).catch(() => {
  }), reverseTransformCache$1.set(e, t), e;
}
function cacheDonePromiseForTransaction$1(t) {
  if (transactionDoneMap$1.has(t))
    return;
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("complete", c), t.removeEventListener("error", u), t.removeEventListener("abort", u);
    }, c = () => {
      r(), a();
    }, u = () => {
      o(t.error || new DOMException("AbortError", "AbortError")), a();
    };
    t.addEventListener("complete", c), t.addEventListener("error", u), t.addEventListener("abort", u);
  });
  transactionDoneMap$1.set(t, e);
}
let idbProxyTraps$1 = {
  get(t, e, r) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return transactionDoneMap$1.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || transactionStoreNamesMap$1.get(t);
      if (e === "store")
        return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return wrap$1(t[e]);
  },
  set(t, e, r) {
    return t[e] = r, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function replaceTraps$1(t) {
  idbProxyTraps$1 = t(idbProxyTraps$1);
}
function wrapFunction$1(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...r) {
    const o = t.call(unwrap$1(this), e, ...r);
    return transactionStoreNamesMap$1.set(o, e.sort ? e.sort() : [e]), wrap$1(o);
  } : getCursorAdvanceMethods$1().includes(t) ? function(...e) {
    return t.apply(unwrap$1(this), e), wrap$1(cursorRequestMap$1.get(this));
  } : function(...e) {
    return wrap$1(t.apply(unwrap$1(this), e));
  };
}
function transformCachableValue$1(t) {
  return typeof t == "function" ? wrapFunction$1(t) : (t instanceof IDBTransaction && cacheDonePromiseForTransaction$1(t), instanceOfAny$1(t, getIdbProxyableTypes$1()) ? new Proxy(t, idbProxyTraps$1) : t);
}
function wrap$1(t) {
  if (t instanceof IDBRequest)
    return promisifyRequest$1(t);
  if (transformCache$1.has(t))
    return transformCache$1.get(t);
  const e = transformCachableValue$1(t);
  return e !== t && (transformCache$1.set(t, e), reverseTransformCache$1.set(e, t)), e;
}
const unwrap$1 = (t) => reverseTransformCache$1.get(t);
function openDB$1(t, e, { blocked: r, upgrade: o, blocking: a, terminated: c } = {}) {
  const u = indexedDB.open(t, e), d = wrap$1(u);
  return o && u.addEventListener("upgradeneeded", (p) => {
    o(wrap$1(u.result), p.oldVersion, p.newVersion, wrap$1(u.transaction));
  }), r && u.addEventListener("blocked", () => r()), d.then((p) => {
    c && p.addEventListener("close", () => c()), a && p.addEventListener("versionchange", () => a());
  }).catch(() => {
  }), d;
}
const readMethods$1 = ["get", "getKey", "getAll", "getAllKeys", "count"], writeMethods$1 = ["put", "add", "delete", "clear"], cachedMethods$1 = /* @__PURE__ */ new Map();
function getMethod$1(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (cachedMethods$1.get(e))
    return cachedMethods$1.get(e);
  const r = e.replace(/FromIndex$/, ""), o = e !== r, a = writeMethods$1.includes(r);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(r in (o ? IDBIndex : IDBObjectStore).prototype) || !(a || readMethods$1.includes(r))
  )
    return;
  const c = async function(u, ...d) {
    const p = this.transaction(u, a ? "readwrite" : "readonly");
    let g = p.store;
    return o && (g = g.index(d.shift())), (await Promise.all([
      g[r](...d),
      a && p.done
    ]))[0];
  };
  return cachedMethods$1.set(e, c), c;
}
replaceTraps$1((t) => ({
  ...t,
  get: (e, r, o) => getMethod$1(e, r) || t.get(e, r, o),
  has: (e, r) => !!getMethod$1(e, r) || t.has(e, r)
}));
const name$1 = "@firebase/installations", version$1 = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 1e4, PACKAGE_VERSION = `w:${version$1}`, INTERNAL_AUTH_VERSION = "FIS_v2", INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1", TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1e3, SERVICE = "installations", SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "not-registered": "Firebase Installation is not registered.",
  "installation-not-found": "Firebase Installation not found.",
  "request-failed": '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  "app-offline": "Could not process request. Application offline.",
  "delete-pending-registration": "Can't delete installation while there is a pending registration request."
}, ERROR_FACTORY$1 = new ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
function isServerError(t) {
  return t instanceof FirebaseError && t.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId: t }) {
  return `${INSTALLATIONS_API_URL}/projects/${t}/installations`;
}
function extractAuthTokenInfoFromResponse(t) {
  return {
    token: t.token,
    requestStatus: 2,
    expiresIn: getExpiresInFromResponseExpiresIn(t.expiresIn),
    creationTime: Date.now()
  };
}
async function getErrorFromResponse(t, e) {
  const o = (await e.json()).error;
  return ERROR_FACTORY$1.create("request-failed", {
    requestName: t,
    serverCode: o.code,
    serverMessage: o.message,
    serverStatus: o.status
  });
}
function getHeaders$1({ apiKey: t }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": t
  });
}
function getHeadersWithAuth(t, { refreshToken: e }) {
  const r = getHeaders$1(t);
  return r.append("Authorization", getAuthorizationHeader(e)), r;
}
async function retryIfServerError(t) {
  const e = await t();
  return e.status >= 500 && e.status < 600 ? t() : e;
}
function getExpiresInFromResponseExpiresIn(t) {
  return Number(t.replace("s", "000"));
}
function getAuthorizationHeader(t) {
  return `${INTERNAL_AUTH_VERSION} ${t}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig: t, heartbeatServiceProvider: e }, { fid: r }) {
  const o = getInstallationsEndpoint(t), a = getHeaders$1(t), c = e.getImmediate({
    optional: !0
  });
  if (c) {
    const g = await c.getHeartbeatsHeader();
    g && a.append("x-firebase-client", g);
  }
  const u = {
    fid: r,
    authVersion: INTERNAL_AUTH_VERSION,
    appId: t.appId,
    sdkVersion: PACKAGE_VERSION
  }, d = {
    method: "POST",
    headers: a,
    body: JSON.stringify(u)
  }, p = await retryIfServerError(() => fetch(o, d));
  if (p.ok) {
    const g = await p.json();
    return {
      fid: g.fid || r,
      registrationStatus: 2,
      refreshToken: g.refreshToken,
      authToken: extractAuthTokenInfoFromResponse(g.authToken)
    };
  } else
    throw await getErrorFromResponse("Create Installation", p);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function sleep(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(t) {
  return btoa(String.fromCharCode(...t)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/, INVALID_FID = "";
function generateFid() {
  try {
    const t = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(t), t[0] = 112 + t[0] % 16;
    const r = encode(t);
    return VALID_FID_PATTERN.test(r) ? r : INVALID_FID;
  } catch {
    return INVALID_FID;
  }
}
function encode(t) {
  return bufferToBase64UrlSafe(t).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getKey$1(t) {
  return `${t.appName}!${t.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = /* @__PURE__ */ new Map();
function fidChanged(t, e) {
  const r = getKey$1(t);
  callFidChangeCallbacks(r, e), broadcastFidChange(r, e);
}
function callFidChangeCallbacks(t, e) {
  const r = fidChangeCallbacks.get(t);
  if (r)
    for (const o of r)
      o(e);
}
function broadcastFidChange(t, e) {
  const r = getBroadcastChannel();
  r && r.postMessage({ key: t, fid: e }), closeBroadcastChannel();
}
let broadcastChannel = null;
function getBroadcastChannel() {
  return !broadcastChannel && "BroadcastChannel" in self && (broadcastChannel = new BroadcastChannel("[Firebase] FID Change"), broadcastChannel.onmessage = (t) => {
    callFidChangeCallbacks(t.data.key, t.data.fid);
  }), broadcastChannel;
}
function closeBroadcastChannel() {
  fidChangeCallbacks.size === 0 && broadcastChannel && (broadcastChannel.close(), broadcastChannel = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME$1 = "firebase-installations-database", DATABASE_VERSION$1 = 1, OBJECT_STORE_NAME$1 = "firebase-installations-store";
let dbPromise$1 = null;
function getDbPromise$1() {
  return dbPromise$1 || (dbPromise$1 = openDB$1(DATABASE_NAME$1, DATABASE_VERSION$1, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(OBJECT_STORE_NAME$1);
      }
    }
  })), dbPromise$1;
}
async function set$1(t, e) {
  const r = getKey$1(t), a = (await getDbPromise$1()).transaction(OBJECT_STORE_NAME$1, "readwrite"), c = a.objectStore(OBJECT_STORE_NAME$1), u = await c.get(r);
  return await c.put(e, r), await a.done, (!u || u.fid !== e.fid) && fidChanged(t, e.fid), e;
}
async function remove(t) {
  const e = getKey$1(t), o = (await getDbPromise$1()).transaction(OBJECT_STORE_NAME$1, "readwrite");
  await o.objectStore(OBJECT_STORE_NAME$1).delete(e), await o.done;
}
async function update(t, e) {
  const r = getKey$1(t), a = (await getDbPromise$1()).transaction(OBJECT_STORE_NAME$1, "readwrite"), c = a.objectStore(OBJECT_STORE_NAME$1), u = await c.get(r), d = e(u);
  return d === void 0 ? await c.delete(r) : await c.put(d, r), await a.done, d && (!u || u.fid !== d.fid) && fidChanged(t, d.fid), d;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getInstallationEntry(t) {
  let e;
  const r = await update(t.appConfig, (o) => {
    const a = updateOrCreateInstallationEntry(o), c = triggerRegistrationIfNecessary(t, a);
    return e = c.registrationPromise, c.installationEntry;
  });
  return r.fid === INVALID_FID ? { installationEntry: await e } : {
    installationEntry: r,
    registrationPromise: e
  };
}
function updateOrCreateInstallationEntry(t) {
  const e = t || {
    fid: generateFid(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return clearTimedOutRequest(e);
}
function triggerRegistrationIfNecessary(t, e) {
  if (e.registrationStatus === 0) {
    if (!navigator.onLine) {
      const a = Promise.reject(ERROR_FACTORY$1.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: e,
        registrationPromise: a
      };
    }
    const r = {
      fid: e.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, o = registerInstallation(t, r);
    return { installationEntry: r, registrationPromise: o };
  } else
    return e.registrationStatus === 1 ? {
      installationEntry: e,
      registrationPromise: waitUntilFidRegistration(t)
    } : { installationEntry: e };
}
async function registerInstallation(t, e) {
  try {
    const r = await createInstallationRequest(t, e);
    return set$1(t.appConfig, r);
  } catch (r) {
    throw isServerError(r) && r.customData.serverCode === 409 ? await remove(t.appConfig) : await set$1(t.appConfig, {
      fid: e.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), r;
  }
}
async function waitUntilFidRegistration(t) {
  let e = await updateInstallationRequest(t.appConfig);
  for (; e.registrationStatus === 1; )
    await sleep(100), e = await updateInstallationRequest(t.appConfig);
  if (e.registrationStatus === 0) {
    const { installationEntry: r, registrationPromise: o } = await getInstallationEntry(t);
    return o || r;
  }
  return e;
}
function updateInstallationRequest(t) {
  return update(t, (e) => {
    if (!e)
      throw ERROR_FACTORY$1.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return clearTimedOutRequest(e);
  });
}
function clearTimedOutRequest(t) {
  return hasInstallationRequestTimedOut(t) ? {
    fid: t.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : t;
}
function hasInstallationRequestTimedOut(t) {
  return t.registrationStatus === 1 && t.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig: t, heartbeatServiceProvider: e }, r) {
  const o = getGenerateAuthTokenEndpoint(t, r), a = getHeadersWithAuth(t, r), c = e.getImmediate({
    optional: !0
  });
  if (c) {
    const g = await c.getHeartbeatsHeader();
    g && a.append("x-firebase-client", g);
  }
  const u = {
    installation: {
      sdkVersion: PACKAGE_VERSION,
      appId: t.appId
    }
  }, d = {
    method: "POST",
    headers: a,
    body: JSON.stringify(u)
  }, p = await retryIfServerError(() => fetch(o, d));
  if (p.ok) {
    const g = await p.json();
    return extractAuthTokenInfoFromResponse(g);
  } else
    throw await getErrorFromResponse("Generate Auth Token", p);
}
function getGenerateAuthTokenEndpoint(t, { fid: e }) {
  return `${getInstallationsEndpoint(t)}/${e}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function refreshAuthToken(t, e = !1) {
  let r;
  const o = await update(t.appConfig, (c) => {
    if (!isEntryRegistered(c))
      throw ERROR_FACTORY$1.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const u = c.authToken;
    if (!e && isAuthTokenValid(u))
      return c;
    if (u.requestStatus === 1)
      return r = waitUntilAuthTokenRequest(t, e), c;
    {
      if (!navigator.onLine)
        throw ERROR_FACTORY$1.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const d = makeAuthTokenRequestInProgressEntry(c);
      return r = fetchAuthTokenFromServer(t, d), d;
    }
  });
  return r ? await r : o.authToken;
}
async function waitUntilAuthTokenRequest(t, e) {
  let r = await updateAuthTokenRequest(t.appConfig);
  for (; r.authToken.requestStatus === 1; )
    await sleep(100), r = await updateAuthTokenRequest(t.appConfig);
  const o = r.authToken;
  return o.requestStatus === 0 ? refreshAuthToken(t, e) : o;
}
function updateAuthTokenRequest(t) {
  return update(t, (e) => {
    if (!isEntryRegistered(e))
      throw ERROR_FACTORY$1.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const r = e.authToken;
    return hasAuthTokenRequestTimedOut(r) ? Object.assign(Object.assign({}, e), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : e;
  });
}
async function fetchAuthTokenFromServer(t, e) {
  try {
    const r = await generateAuthTokenRequest(t, e), o = Object.assign(Object.assign({}, e), { authToken: r });
    return await set$1(t.appConfig, o), r;
  } catch (r) {
    if (isServerError(r) && (r.customData.serverCode === 401 || r.customData.serverCode === 404))
      await remove(t.appConfig);
    else {
      const o = Object.assign(Object.assign({}, e), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await set$1(t.appConfig, o);
    }
    throw r;
  }
}
function isEntryRegistered(t) {
  return t !== void 0 && t.registrationStatus === 2;
}
function isAuthTokenValid(t) {
  return t.requestStatus === 2 && !isAuthTokenExpired(t);
}
function isAuthTokenExpired(t) {
  const e = Date.now();
  return e < t.creationTime || t.creationTime + t.expiresIn < e + TOKEN_EXPIRATION_BUFFER;
}
function makeAuthTokenRequestInProgressEntry(t) {
  const e = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, t), { authToken: e });
}
function hasAuthTokenRequestTimedOut(t) {
  return t.requestStatus === 1 && t.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getId(t) {
  const e = t, { installationEntry: r, registrationPromise: o } = await getInstallationEntry(e);
  return o ? o.catch(console.error) : refreshAuthToken(e).catch(console.error), r.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getToken$2(t, e = !1) {
  const r = t;
  return await completeInstallationRegistration(r), (await refreshAuthToken(r, e)).token;
}
async function completeInstallationRegistration(t) {
  const { registrationPromise: e } = await getInstallationEntry(t);
  e && await e;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig$1(t) {
  if (!t || !t.options)
    throw getMissingValueError$1("App Configuration");
  if (!t.name)
    throw getMissingValueError$1("App Name");
  const e = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const r of e)
    if (!t.options[r])
      throw getMissingValueError$1(r);
  return {
    appName: t.name,
    projectId: t.options.projectId,
    apiKey: t.options.apiKey,
    appId: t.options.appId
  };
}
function getMissingValueError$1(t) {
  return ERROR_FACTORY$1.create("missing-app-config-values", {
    valueName: t
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = "installations", INSTALLATIONS_NAME_INTERNAL = "installations-internal", publicFactory = (t) => {
  const e = t.getProvider("app").getImmediate(), r = extractAppConfig$1(e), o = _getProvider(e, "heartbeat");
  return {
    app: e,
    appConfig: r,
    heartbeatServiceProvider: o,
    _delete: () => Promise.resolve()
  };
}, internalFactory = (t) => {
  const e = t.getProvider("app").getImmediate(), r = _getProvider(e, INSTALLATIONS_NAME).getImmediate();
  return {
    getId: () => getId(r),
    getToken: (a) => getToken$2(r, a)
  };
};
function registerInstallations() {
  _registerComponent(new Component(
    INSTALLATIONS_NAME,
    publicFactory,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), _registerComponent(new Component(
    INSTALLATIONS_NAME_INTERNAL,
    internalFactory,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
registerInstallations();
registerVersion(name$1, version$1);
registerVersion(name$1, version$1, "esm2017");
const instanceOfAny = (t, e) => e.some((r) => t instanceof r);
let idbProxyableTypes, cursorAdvanceMethods;
function getIdbProxyableTypes() {
  return idbProxyableTypes || (idbProxyableTypes = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function getCursorAdvanceMethods() {
  return cursorAdvanceMethods || (cursorAdvanceMethods = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const cursorRequestMap = /* @__PURE__ */ new WeakMap(), transactionDoneMap = /* @__PURE__ */ new WeakMap(), transactionStoreNamesMap = /* @__PURE__ */ new WeakMap(), transformCache = /* @__PURE__ */ new WeakMap(), reverseTransformCache = /* @__PURE__ */ new WeakMap();
function promisifyRequest(t) {
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("success", c), t.removeEventListener("error", u);
    }, c = () => {
      r(wrap(t.result)), a();
    }, u = () => {
      o(t.error), a();
    };
    t.addEventListener("success", c), t.addEventListener("error", u);
  });
  return e.then((r) => {
    r instanceof IDBCursor && cursorRequestMap.set(r, t);
  }).catch(() => {
  }), reverseTransformCache.set(e, t), e;
}
function cacheDonePromiseForTransaction(t) {
  if (transactionDoneMap.has(t))
    return;
  const e = new Promise((r, o) => {
    const a = () => {
      t.removeEventListener("complete", c), t.removeEventListener("error", u), t.removeEventListener("abort", u);
    }, c = () => {
      r(), a();
    }, u = () => {
      o(t.error || new DOMException("AbortError", "AbortError")), a();
    };
    t.addEventListener("complete", c), t.addEventListener("error", u), t.addEventListener("abort", u);
  });
  transactionDoneMap.set(t, e);
}
let idbProxyTraps = {
  get(t, e, r) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return transactionDoneMap.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || transactionStoreNamesMap.get(t);
      if (e === "store")
        return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
    }
    return wrap(t[e]);
  },
  set(t, e, r) {
    return t[e] = r, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function replaceTraps(t) {
  idbProxyTraps = t(idbProxyTraps);
}
function wrapFunction(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...r) {
    const o = t.call(unwrap(this), e, ...r);
    return transactionStoreNamesMap.set(o, e.sort ? e.sort() : [e]), wrap(o);
  } : getCursorAdvanceMethods().includes(t) ? function(...e) {
    return t.apply(unwrap(this), e), wrap(cursorRequestMap.get(this));
  } : function(...e) {
    return wrap(t.apply(unwrap(this), e));
  };
}
function transformCachableValue(t) {
  return typeof t == "function" ? wrapFunction(t) : (t instanceof IDBTransaction && cacheDonePromiseForTransaction(t), instanceOfAny(t, getIdbProxyableTypes()) ? new Proxy(t, idbProxyTraps) : t);
}
function wrap(t) {
  if (t instanceof IDBRequest)
    return promisifyRequest(t);
  if (transformCache.has(t))
    return transformCache.get(t);
  const e = transformCachableValue(t);
  return e !== t && (transformCache.set(t, e), reverseTransformCache.set(e, t)), e;
}
const unwrap = (t) => reverseTransformCache.get(t);
function openDB(t, e, { blocked: r, upgrade: o, blocking: a, terminated: c } = {}) {
  const u = indexedDB.open(t, e), d = wrap(u);
  return o && u.addEventListener("upgradeneeded", (p) => {
    o(wrap(u.result), p.oldVersion, p.newVersion, wrap(u.transaction));
  }), r && u.addEventListener("blocked", () => r()), d.then((p) => {
    c && p.addEventListener("close", () => c()), a && p.addEventListener("versionchange", () => a());
  }).catch(() => {
  }), d;
}
function deleteDB(t, { blocked: e } = {}) {
  const r = indexedDB.deleteDatabase(t);
  return e && r.addEventListener("blocked", () => e()), wrap(r).then(() => {
  });
}
const readMethods = ["get", "getKey", "getAll", "getAllKeys", "count"], writeMethods = ["put", "add", "delete", "clear"], cachedMethods = /* @__PURE__ */ new Map();
function getMethod(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (cachedMethods.get(e))
    return cachedMethods.get(e);
  const r = e.replace(/FromIndex$/, ""), o = e !== r, a = writeMethods.includes(r);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(r in (o ? IDBIndex : IDBObjectStore).prototype) || !(a || readMethods.includes(r))
  )
    return;
  const c = async function(u, ...d) {
    const p = this.transaction(u, a ? "readwrite" : "readonly");
    let g = p.store;
    return o && (g = g.index(d.shift())), (await Promise.all([
      g[r](...d),
      a && p.done
    ]))[0];
  };
  return cachedMethods.set(e, c), c;
}
replaceTraps((t) => ({
  ...t,
  get: (e, r, o) => getMethod(e, r) || t.get(e, r, o),
  has: (e, r) => !!getMethod(e, r) || t.has(e, r)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_SW_PATH = "/firebase-messaging-sw.js", DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope", DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4", ENDPOINT = "https://fcmregistrations.googleapis.com/v1", CONSOLE_CAMPAIGN_ID = "google.c.a.c_id", CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l", CONSOLE_CAMPAIGN_TIME = "google.c.a.ts", CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var MessageType$1;
(function(t) {
  t[t.DATA_MESSAGE = 1] = "DATA_MESSAGE", t[t.DISPLAY_NOTIFICATION = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */
var MessageType;
(function(t) {
  t.PUSH_RECEIVED = "push-received", t.NOTIFICATION_CLICKED = "notification-clicked";
})(MessageType || (MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function arrayToBase64(t) {
  const e = new Uint8Array(t);
  return btoa(String.fromCharCode(...e)).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function base64ToArray(t) {
  const e = "=".repeat((4 - t.length % 4) % 4), r = (t + e).replace(/\-/g, "+").replace(/_/g, "/"), o = atob(r), a = new Uint8Array(o.length);
  for (let c = 0; c < o.length; ++c)
    a[c] = o.charCodeAt(c);
  return a;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const OLD_DB_NAME = "fcm_token_details_db", OLD_DB_VERSION = 5, OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
async function migrateOldDatabase(t) {
  if ("databases" in indexedDB && !(await indexedDB.databases()).map((c) => c.name).includes(OLD_DB_NAME))
    return null;
  let e = null;
  return (await openDB(OLD_DB_NAME, OLD_DB_VERSION, {
    upgrade: async (o, a, c, u) => {
      var d;
      if (a < 2 || !o.objectStoreNames.contains(OLD_OBJECT_STORE_NAME))
        return;
      const p = u.objectStore(OLD_OBJECT_STORE_NAME), g = await p.index("fcmSenderId").get(t);
      if (await p.clear(), !!g) {
        if (a === 2) {
          const b = g;
          if (!b.auth || !b.p256dh || !b.endpoint)
            return;
          e = {
            token: b.fcmToken,
            createTime: (d = b.createTime) !== null && d !== void 0 ? d : Date.now(),
            subscriptionOptions: {
              auth: b.auth,
              p256dh: b.p256dh,
              endpoint: b.endpoint,
              swScope: b.swScope,
              vapidKey: typeof b.vapidKey == "string" ? b.vapidKey : arrayToBase64(b.vapidKey)
            }
          };
        } else if (a === 3) {
          const b = g;
          e = {
            token: b.fcmToken,
            createTime: b.createTime,
            subscriptionOptions: {
              auth: arrayToBase64(b.auth),
              p256dh: arrayToBase64(b.p256dh),
              endpoint: b.endpoint,
              swScope: b.swScope,
              vapidKey: arrayToBase64(b.vapidKey)
            }
          };
        } else if (a === 4) {
          const b = g;
          e = {
            token: b.fcmToken,
            createTime: b.createTime,
            subscriptionOptions: {
              auth: arrayToBase64(b.auth),
              p256dh: arrayToBase64(b.p256dh),
              endpoint: b.endpoint,
              swScope: b.swScope,
              vapidKey: arrayToBase64(b.vapidKey)
            }
          };
        }
      }
    }
  })).close(), await deleteDB(OLD_DB_NAME), await deleteDB("fcm_vapid_details_db"), await deleteDB("undefined"), checkTokenDetails(e) ? e : null;
}
function checkTokenDetails(t) {
  if (!t || !t.subscriptionOptions)
    return !1;
  const { subscriptionOptions: e } = t;
  return typeof t.createTime == "number" && t.createTime > 0 && typeof t.token == "string" && t.token.length > 0 && typeof e.auth == "string" && e.auth.length > 0 && typeof e.p256dh == "string" && e.p256dh.length > 0 && typeof e.endpoint == "string" && e.endpoint.length > 0 && typeof e.swScope == "string" && e.swScope.length > 0 && typeof e.vapidKey == "string" && e.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = "firebase-messaging-database", DATABASE_VERSION = 1, OBJECT_STORE_NAME = "firebase-messaging-store";
let dbPromise = null;
function getDbPromise() {
  return dbPromise || (dbPromise = openDB(DATABASE_NAME, DATABASE_VERSION, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(OBJECT_STORE_NAME);
      }
    }
  })), dbPromise;
}
async function dbGet(t) {
  const e = getKey(t), o = await (await getDbPromise()).transaction(OBJECT_STORE_NAME).objectStore(OBJECT_STORE_NAME).get(e);
  if (o)
    return o;
  {
    const a = await migrateOldDatabase(t.appConfig.senderId);
    if (a)
      return await dbSet(t, a), a;
  }
}
async function dbSet(t, e) {
  const r = getKey(t), a = (await getDbPromise()).transaction(OBJECT_STORE_NAME, "readwrite");
  return await a.objectStore(OBJECT_STORE_NAME).put(e, r), await a.done, e;
}
async function dbRemove(t) {
  const e = getKey(t), o = (await getDbPromise()).transaction(OBJECT_STORE_NAME, "readwrite");
  await o.objectStore(OBJECT_STORE_NAME).delete(e), await o.done;
}
function getKey({ appConfig: t }) {
  return t.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_MAP = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "only-available-in-window": "This method is available in a Window context.",
  "only-available-in-sw": "This method is available in a service worker context.",
  "permission-default": "The notification permission was not granted and dismissed instead.",
  "permission-blocked": "The notification permission was not granted and blocked instead.",
  "unsupported-browser": "This browser doesn't support the API's required to use the Firebase SDK.",
  "indexed-db-unsupported": "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
  "failed-service-worker-registration": "We are unable to register the default service worker. {$browserErrorMessage}",
  "token-subscribe-failed": "A problem occurred while subscribing the user to FCM: {$errorInfo}",
  "token-subscribe-no-token": "FCM returned no token when subscribing the user to push.",
  "token-unsubscribe-failed": "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
  "token-update-failed": "A problem occurred while updating the user from FCM: {$errorInfo}",
  "token-update-no-token": "FCM returned no token when updating the user to push.",
  "use-sw-after-get-token": "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
  "invalid-sw-registration": "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
  "invalid-bg-handler": "The input to setBackgroundMessageHandler() must be a function.",
  "invalid-vapid-key": "The public VAPID key must be a string.",
  "use-vapid-key-after-get-token": "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
}, ERROR_FACTORY = new ErrorFactory("messaging", "Messaging", ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestGetToken(t, e) {
  const r = await getHeaders(t), o = getBody(e), a = {
    method: "POST",
    headers: r,
    body: JSON.stringify(o)
  };
  let c;
  try {
    c = await (await fetch(getEndpoint(t.appConfig), a)).json();
  } catch (u) {
    throw ERROR_FACTORY.create("token-subscribe-failed", {
      errorInfo: u == null ? void 0 : u.toString()
    });
  }
  if (c.error) {
    const u = c.error.message;
    throw ERROR_FACTORY.create("token-subscribe-failed", {
      errorInfo: u
    });
  }
  if (!c.token)
    throw ERROR_FACTORY.create(
      "token-subscribe-no-token"
      /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */
    );
  return c.token;
}
async function requestUpdateToken(t, e) {
  const r = await getHeaders(t), o = getBody(e.subscriptionOptions), a = {
    method: "PATCH",
    headers: r,
    body: JSON.stringify(o)
  };
  let c;
  try {
    c = await (await fetch(`${getEndpoint(t.appConfig)}/${e.token}`, a)).json();
  } catch (u) {
    throw ERROR_FACTORY.create("token-update-failed", {
      errorInfo: u == null ? void 0 : u.toString()
    });
  }
  if (c.error) {
    const u = c.error.message;
    throw ERROR_FACTORY.create("token-update-failed", {
      errorInfo: u
    });
  }
  if (!c.token)
    throw ERROR_FACTORY.create(
      "token-update-no-token"
      /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */
    );
  return c.token;
}
async function requestDeleteToken(t, e) {
  const o = {
    method: "DELETE",
    headers: await getHeaders(t)
  };
  try {
    const c = await (await fetch(`${getEndpoint(t.appConfig)}/${e}`, o)).json();
    if (c.error) {
      const u = c.error.message;
      throw ERROR_FACTORY.create("token-unsubscribe-failed", {
        errorInfo: u
      });
    }
  } catch (a) {
    throw ERROR_FACTORY.create("token-unsubscribe-failed", {
      errorInfo: a == null ? void 0 : a.toString()
    });
  }
}
function getEndpoint({ projectId: t }) {
  return `${ENDPOINT}/projects/${t}/registrations`;
}
async function getHeaders({ appConfig: t, installations: e }) {
  const r = await e.getToken();
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": t.apiKey,
    "x-goog-firebase-installations-auth": `FIS ${r}`
  });
}
function getBody({ p256dh: t, auth: e, endpoint: r, vapidKey: o }) {
  const a = {
    web: {
      endpoint: r,
      auth: e,
      p256dh: t
    }
  };
  return o !== DEFAULT_VAPID_KEY && (a.web.applicationPubKey = o), a;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1e3;
async function getTokenInternal(t) {
  const e = await getPushSubscription(t.swRegistration, t.vapidKey), r = {
    vapidKey: t.vapidKey,
    swScope: t.swRegistration.scope,
    endpoint: e.endpoint,
    auth: arrayToBase64(e.getKey("auth")),
    p256dh: arrayToBase64(e.getKey("p256dh"))
  }, o = await dbGet(t.firebaseDependencies);
  if (o) {
    if (isTokenValid(o.subscriptionOptions, r))
      return Date.now() >= o.createTime + TOKEN_EXPIRATION_MS ? updateToken(t, {
        token: o.token,
        createTime: Date.now(),
        subscriptionOptions: r
      }) : o.token;
    try {
      await requestDeleteToken(t.firebaseDependencies, o.token);
    } catch (a) {
      console.warn(a);
    }
    return getNewToken(t.firebaseDependencies, r);
  } else
    return getNewToken(t.firebaseDependencies, r);
}
async function deleteTokenInternal(t) {
  const e = await dbGet(t.firebaseDependencies);
  e && (await requestDeleteToken(t.firebaseDependencies, e.token), await dbRemove(t.firebaseDependencies));
  const r = await t.swRegistration.pushManager.getSubscription();
  return r ? r.unsubscribe() : !0;
}
async function updateToken(t, e) {
  try {
    const r = await requestUpdateToken(t.firebaseDependencies, e), o = Object.assign(Object.assign({}, e), { token: r, createTime: Date.now() });
    return await dbSet(t.firebaseDependencies, o), r;
  } catch (r) {
    throw await deleteTokenInternal(t), r;
  }
}
async function getNewToken(t, e) {
  const o = {
    token: await requestGetToken(t, e),
    createTime: Date.now(),
    subscriptionOptions: e
  };
  return await dbSet(t, o), o.token;
}
async function getPushSubscription(t, e) {
  const r = await t.pushManager.getSubscription();
  return r || t.pushManager.subscribe({
    userVisibleOnly: !0,
    // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
    // submitted to pushManager#subscribe must be of type Uint8Array.
    applicationServerKey: base64ToArray(e)
  });
}
function isTokenValid(t, e) {
  const r = e.vapidKey === t.vapidKey, o = e.endpoint === t.endpoint, a = e.auth === t.auth, c = e.p256dh === t.p256dh;
  return r && o && a && c;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function externalizePayload(t) {
  const e = {
    from: t.from,
    // eslint-disable-next-line camelcase
    collapseKey: t.collapse_key,
    // eslint-disable-next-line camelcase
    messageId: t.fcmMessageId
  };
  return propagateNotificationPayload(e, t), propagateDataPayload(e, t), propagateFcmOptions(e, t), e;
}
function propagateNotificationPayload(t, e) {
  if (!e.notification)
    return;
  t.notification = {};
  const r = e.notification.title;
  r && (t.notification.title = r);
  const o = e.notification.body;
  o && (t.notification.body = o);
  const a = e.notification.image;
  a && (t.notification.image = a);
  const c = e.notification.icon;
  c && (t.notification.icon = c);
}
function propagateDataPayload(t, e) {
  e.data && (t.data = e.data);
}
function propagateFcmOptions(t, e) {
  var r, o, a, c, u;
  if (!e.fcmOptions && !(!((r = e.notification) === null || r === void 0) && r.click_action))
    return;
  t.fcmOptions = {};
  const d = (a = (o = e.fcmOptions) === null || o === void 0 ? void 0 : o.link) !== null && a !== void 0 ? a : (c = e.notification) === null || c === void 0 ? void 0 : c.click_action;
  d && (t.fcmOptions.link = d);
  const p = (u = e.fcmOptions) === null || u === void 0 ? void 0 : u.analytics_label;
  p && (t.fcmOptions.analyticsLabel = p);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isConsoleMessage(t) {
  return typeof t == "object" && !!t && CONSOLE_CAMPAIGN_ID in t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
_mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
_mergeStrings("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function _mergeStrings(t, e) {
  const r = [];
  for (let o = 0; o < t.length; o++)
    r.push(t.charAt(o)), o < e.length && r.push(e.charAt(o));
  return r.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(t) {
  if (!t || !t.options)
    throw getMissingValueError("App Configuration Object");
  if (!t.name)
    throw getMissingValueError("App Name");
  const e = [
    "projectId",
    "apiKey",
    "appId",
    "messagingSenderId"
  ], { options: r } = t;
  for (const o of e)
    if (!r[o])
      throw getMissingValueError(o);
  return {
    appName: t.name,
    projectId: r.projectId,
    apiKey: r.apiKey,
    appId: r.appId,
    senderId: r.messagingSenderId
  };
}
function getMissingValueError(t) {
  return ERROR_FACTORY.create("missing-app-config-values", {
    valueName: t
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MessagingService {
  constructor(e, r, o) {
    this.deliveryMetricsExportedToBigQueryEnabled = !1, this.onBackgroundMessageHandler = null, this.onMessageHandler = null, this.logEvents = [], this.isLogServiceStarted = !1;
    const a = extractAppConfig(e);
    this.firebaseDependencies = {
      app: e,
      appConfig: a,
      installations: r,
      analyticsProvider: o
    };
  }
  _delete() {
    return Promise.resolve();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function registerDefaultSw(t) {
  try {
    t.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
      scope: DEFAULT_SW_SCOPE
    }), t.swRegistration.update().catch(() => {
    });
  } catch (e) {
    throw ERROR_FACTORY.create("failed-service-worker-registration", {
      browserErrorMessage: e == null ? void 0 : e.message
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateSwReg(t, e) {
  if (!e && !t.swRegistration && await registerDefaultSw(t), !(!e && t.swRegistration)) {
    if (!(e instanceof ServiceWorkerRegistration))
      throw ERROR_FACTORY.create(
        "invalid-sw-registration"
        /* ErrorCode.INVALID_SW_REGISTRATION */
      );
    t.swRegistration = e;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateVapidKey(t, e) {
  e ? t.vapidKey = e : t.vapidKey || (t.vapidKey = DEFAULT_VAPID_KEY);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getToken$1(t, e) {
  if (!navigator)
    throw ERROR_FACTORY.create(
      "only-available-in-window"
      /* ErrorCode.AVAILABLE_IN_WINDOW */
    );
  if (Notification.permission === "default" && await Notification.requestPermission(), Notification.permission !== "granted")
    throw ERROR_FACTORY.create(
      "permission-blocked"
      /* ErrorCode.PERMISSION_BLOCKED */
    );
  return await updateVapidKey(t, e == null ? void 0 : e.vapidKey), await updateSwReg(t, e == null ? void 0 : e.serviceWorkerRegistration), getTokenInternal(t);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function logToScion(t, e, r) {
  const o = getEventType(e);
  (await t.firebaseDependencies.analyticsProvider.get()).logEvent(o, {
    /* eslint-disable camelcase */
    message_id: r[CONSOLE_CAMPAIGN_ID],
    message_name: r[CONSOLE_CAMPAIGN_NAME],
    message_time: r[CONSOLE_CAMPAIGN_TIME],
    message_device_time: Math.floor(Date.now() / 1e3)
    /* eslint-enable camelcase */
  });
}
function getEventType(t) {
  switch (t) {
    case MessageType.NOTIFICATION_CLICKED:
      return "notification_open";
    case MessageType.PUSH_RECEIVED:
      return "notification_foreground";
    default:
      throw new Error();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function messageEventListener(t, e) {
  const r = e.data;
  if (!r.isFirebaseMessaging)
    return;
  t.onMessageHandler && r.messageType === MessageType.PUSH_RECEIVED && (typeof t.onMessageHandler == "function" ? t.onMessageHandler(externalizePayload(r)) : t.onMessageHandler.next(externalizePayload(r)));
  const o = r.data;
  isConsoleMessage(o) && o[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1" && await logToScion(t, r.messageType, o);
}
const name = "@firebase/messaging", version = "0.12.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WindowMessagingFactory = (t) => {
  const e = new MessagingService(t.getProvider("app").getImmediate(), t.getProvider("installations-internal").getImmediate(), t.getProvider("analytics-internal"));
  return navigator.serviceWorker.addEventListener("message", (r) => messageEventListener(e, r)), e;
}, WindowMessagingInternalFactory = (t) => {
  const e = t.getProvider("messaging").getImmediate();
  return {
    getToken: (o) => getToken$1(e, o)
  };
};
function registerMessagingInWindow() {
  _registerComponent(new Component(
    "messaging",
    WindowMessagingFactory,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), _registerComponent(new Component(
    "messaging-internal",
    WindowMessagingInternalFactory,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), registerVersion(name, version), registerVersion(name, version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function isWindowSupported() {
  try {
    await validateIndexedDBOpenable();
  } catch {
    return !1;
  }
  return typeof window < "u" && isIndexedDBAvailable() && areCookiesEnabled() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function onMessage$1(t, e) {
  if (!navigator)
    throw ERROR_FACTORY.create(
      "only-available-in-window"
      /* ErrorCode.AVAILABLE_IN_WINDOW */
    );
  return t.onMessageHandler = e, () => {
    t.onMessageHandler = null;
  };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getMessagingInWindow(t = getApp()) {
  return isWindowSupported().then((e) => {
    if (!e)
      throw ERROR_FACTORY.create(
        "unsupported-browser"
        /* ErrorCode.UNSUPPORTED_BROWSER */
      );
  }, (e) => {
    throw ERROR_FACTORY.create(
      "indexed-db-unsupported"
      /* ErrorCode.INDEXED_DB_UNSUPPORTED */
    );
  }), _getProvider(getModularInstance(t), "messaging").getImmediate();
}
async function getToken(t, e) {
  return t = getModularInstance(t), getToken$1(t, e);
}
function onMessage(t, e) {
  return t = getModularInstance(t), onMessage$1(t, e);
}
registerMessagingInWindow();
const initialiseFirebaseApp = async (t, e, r, o) => {
  const a = t;
  if (!await isWindowSupported()) {
    console.error("Notifications not supported");
    return;
  }
  const c = initializeApp(a), u = getMessagingInWindow(c);
  if (await Notification.requestPermission() === "granted") {
    const p = await getToken(u, {
      vapidKey: e
    });
    await r(p), onMessage(u, (b) => {
      o({ notification: b, isForeground: !0 });
    });
    const g = new BroadcastChannel("FB_BG_MESSAGES");
    g.onmessage = (b) => {
      o({ notification: b.data, isForeground: !1 });
    };
  } else
    alert("You denied notifications.");
}, _hoisted_1$4 = { class: "center-div" }, _hoisted_2$1 = { key: 1 }, _hoisted_3$1 = { key: 2 }, _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "DxpLogin",
  setup(t) {
    const e = useAuthStore(), r = appContext.config.globalProperties.$router, o = appContext.config.globalProperties.$route, a = ref({
      message: "",
      responseMessage: ""
    });
    onMounted(async () => {
      if (!Object.keys(o.query).length) {
        window.location.href = loginContext.appLoginUrl;
        return;
      }
      const { token: d, oms: p, expirationTime: g, omsRedirectionUrl: b } = o.query;
      await c(d, p, g, b);
    });
    async function c(d, p, g, b = "") {
      const x = loginContext.getConfig();
      if (await loginContext.logout({ isUserUnauthorised: !0 }), await loginContext.initialise(x), +g < DateTime.now().toMillis()) {
        console.error("User token has expired, redirecting to launchpad."), a.value.message = "User token has expired, redirecting to launchpad.";
        const w = window.location.origin + "/login";
        window.location.href = `${loginContext.appLoginUrl}?isLoggedOut=true&redirectUrl=${w}`;
        return;
      }
      e.$patch({
        token: { value: d, expiration: g },
        oms: p
      }), loginContext.loader.present("Logging in");
      try {
        const w = await loginContext.login({ token: d, oms: p, omsRedirectionUrl: b }), y = useUserStore(), I = appContext.config.globalProperties.$store;
        await y.setLocale(I.getters["user/getUserProfile"].userLocale);
        const E = I.getters["user/getAllNotificationPrefs"];
        notificationContext.appFirebaseConfig && notificationContext.appFirebaseConfig.apiKey && (E != null && E.length) && await initialiseFirebaseApp(notificationContext.appFirebaseConfig, notificationContext.appFirebaseVapidKey, notificationContext.storeClientRegistrationToken, notificationContext.addNotification), w ? r.push(w) : r.push("/");
      } catch (w) {
        console.error(w), a.value.message = "Please contact the administrator.", a.value.responseMessage = w.message || "";
      } finally {
        loginContext.loader.dismiss();
      }
    }
    function u() {
      window.location.href = `${process.env.VUE_APP_LOGIN_URL}`;
    }
    return (d, p) => (openBlock(), createBlock(unref(IonContent), null, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$4, [
          a.value.message.length ? (openBlock(), createBlock(unref(IonItem), {
            key: 0,
            lines: "none"
          }, {
            default: withCtx(() => [
              createVNode(unref(IonIcon), {
                slot: "start",
                color: "warning",
                icon: unref(warningOutline)
              }, null, 8, ["icon"]),
              createElementVNode("h4", null, toDisplayString$1(d.$t("Login failed")), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          a.value.responseMessage.length ? (openBlock(), createElementBlock("p", _hoisted_2$1, toDisplayString$1(d.$t("Reason:")) + " " + toDisplayString$1(d.$t(a.value.responseMessage)), 1)) : createCommentVNode("", !0),
          a.value.message.length ? (openBlock(), createElementBlock("p", _hoisted_3$1, toDisplayString$1(d.$t(a.value.message)), 1)) : createCommentVNode("", !0),
          a.value.message.length ? (openBlock(), createBlock(unref(IonButton), {
            key: 3,
            class: "ion-margin-top",
            onClick: p[0] || (p[0] = (g) => u())
          }, {
            default: withCtx(() => [
              createVNode(unref(IonIcon), {
                slot: "start",
                icon: unref(arrowBackOutline)
              }, null, 8, ["icon"]),
              createTextVNode(" " + toDisplayString$1(d.$t("Back to Launchpad")), 1)
            ]),
            _: 1
          })) : createCommentVNode("", !0)
        ])
      ]),
      _: 1
    }));
  }
}), DxpLogin_vue_vue_type_style_index_0_lang = "", _hoisted_1$3 = { class: "overline" }, _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "DxpMenuFooterNavigation",
  setup(t) {
    const e = useAuthStore(), r = appContext.config.globalProperties.$store, o = computed(() => e.getOms), a = computed(() => ({
      userProfile: r.getters["user/getUserProfile"],
      currentEComStore: r.getters["user/getCurrentEComStore"],
      shopifyConfigs: r.getters["user/getShopifyConfigs"],
      currentShopifyConfig: r.getters["user/getCurrentShopifyConfig"]
    })), c = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return (u, d) => (openBlock(), createBlock(unref(IonFooter), null, {
      default: withCtx(() => [
        createVNode(unref(IonToolbar), null, {
          default: withCtx(() => {
            var p, g, b, x, w;
            return [
              createVNode(unref(IonItem), { lines: "none" }, {
                default: withCtx(() => {
                  var y;
                  return [
                    createVNode(unref(IonLabel), { class: "ion-text-wrap" }, {
                      default: withCtx(() => [
                        createElementVNode("p", _hoisted_1$3, toDisplayString$1(o.value), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(IonNote), {
                      color: unref(c) === ((y = a.value.userProfile) == null ? void 0 : y.userTimeZone) ? "" : "danger",
                      slot: "end"
                    }, {
                      default: withCtx(() => {
                        var I;
                        return [
                          createTextVNode(toDisplayString$1((I = a.value.userProfile) == null ? void 0 : I.userTimeZone), 1)
                        ];
                      }),
                      _: 1
                    }, 8, ["color"])
                  ];
                }),
                _: 1
              }),
              ((g = (p = a.value.userProfile) == null ? void 0 : p.stores) == null ? void 0 : g.length) > 2 ? (openBlock(), createBlock(unref(IonItem), {
                key: 0,
                lines: "none"
              }, {
                default: withCtx(() => [
                  createVNode(unref(IonSelect), {
                    interface: "popover",
                    value: a.value.currentEComStore.productStoreId,
                    onIonChange: d[0] || (d[0] = (y) => u.$emit("updateEcomStore", y))
                  }, {
                    default: withCtx(() => [
                      (openBlock(!0), createElementBlock(Fragment, null, renderList(a.value.userProfile.stores, (y) => (openBlock(), createBlock(unref(IonSelectOption), {
                        key: y.productStoreId,
                        value: y.productStoreId
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(y.storeName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })) : (openBlock(), createBlock(unref(IonItem), {
                key: 1,
                lines: "none"
              }, {
                default: withCtx(() => [
                  createVNode(unref(IonLabel), { class: "ion-text-wrap" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(a.value.currentEComStore.storeName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
              ((b = a.value.shopifyConfigs) == null ? void 0 : b.length) > 1 && ((w = (x = a.value.userProfile) == null ? void 0 : x.stores) == null ? void 0 : w.length) < 3 ? (openBlock(), createBlock(unref(IonItem), {
                key: 2,
                lines: "none"
              }, {
                default: withCtx(() => {
                  var y;
                  return [
                    createVNode(unref(IonSelect), {
                      interface: "popover",
                      value: (y = a.value.currentShopifyConfig) == null ? void 0 : y.shopifyConfigId,
                      onIonChange: d[1] || (d[1] = (I) => u.$emit("updateShopifyConfig", I))
                    }, {
                      default: withCtx(() => [
                        (openBlock(!0), createElementBlock(Fragment, null, renderList(a.value.shopifyConfigs, (I) => (openBlock(), createBlock(unref(IonSelectOption), {
                          key: I.shopifyConfigId,
                          value: I.shopifyConfigId
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(I.name ? I.name : I.shopifyConfigName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ];
                }),
                _: 1
              })) : (openBlock(), createBlock(unref(IonItem), {
                key: 3,
                lines: "none"
              }, {
                default: withCtx(() => [
                  createVNode(unref(IonLabel), { class: "ion-text-wrap" }, {
                    default: withCtx(() => [
                      createElementVNode("p", null, toDisplayString$1(a.value.currentShopifyConfig.name ? a.value.currentShopifyConfig.name : a.value.currentShopifyConfig.shopifyConfigName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            ];
          }),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "DxpOmsInstanceNavigator",
  setup(t) {
    const e = useAuthStore(), r = computed(() => e.getToken), o = computed(() => e.getOms);
    return (a, c) => (openBlock(), createBlock(unref(IonCard), null, {
      default: withCtx(() => [
        createVNode(unref(IonCardHeader), null, {
          default: withCtx(() => [
            createVNode(unref(IonCardSubtitle), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(a.$t("OMS instance")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(IonCardTitle), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(unref(e).getOms), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(unref(IonCardContent), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(a.$t("This is the name of the OMS you are connected to right now. Make sure that you are connected to the right instance before proceeding.")), 1)
          ]),
          _: 1
        }),
        createVNode(unref(IonButton), {
          onClick: c[0] || (c[0] = (u) => unref(goToOms)(r.value.value, o.value)),
          fill: "clear",
          disabled: !unref(appContext).hasPermission(unref(appContext).Actions.APP_COMMERCE_VIEW)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(a.$t("Go to OMS")) + " ", 1),
            createVNode(unref(IonIcon), {
              slot: "end",
              icon: unref(openOutline)
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }));
  }
}), _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "DxpProductIdentifier",
  setup(t) {
    const e = useProductIdentificationStore(), r = appContext.config.globalProperties.$store, o = computed(() => r.getters["user/getCurrentEComStore"]), a = computed(() => e.getProductIdentificationPref), c = e.getProductIdentificationOptions;
    onMounted(() => {
      e.getIdentificationPref(o.value.productStoreId);
    });
    function u(d, p) {
      e.setProductIdentificationPref(p, d, o.value.productStoreId);
    }
    return (d, p) => (openBlock(), createBlock(unref(IonCard), null, {
      default: withCtx(() => [
        createVNode(unref(IonCardHeader), null, {
          default: withCtx(() => [
            createVNode(unref(IonCardTitle), null, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1("Product Identifier"))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(unref(IonCardContent), null, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1("Choosing a product identifier allows you to view products with your preferred identifiers."), 1)
          ]),
          _: 1
        }),
        createVNode(unref(IonItem), {
          disabled: !unref(appContext).hasPermission(unref(appContext).Actions.APP_PRODUCT_IDENTIFIER_UPDATE)
        }, {
          default: withCtx(() => [
            createVNode(unref(IonSelect), {
              label: d.$t("Primary"),
              interface: "popover",
              placeholder: "primary identifier",
              value: a.value.primaryId,
              onIonChange: p[0] || (p[0] = (g) => u(g.detail.value, "primaryId"))
            }, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(c), (g) => (openBlock(), createBlock(unref(IonSelectOption), {
                  key: g,
                  value: g
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(g), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ]),
              _: 1
            }, 8, ["label", "value"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        createVNode(unref(IonItem), {
          lines: "none",
          disabled: !unref(appContext).hasPermission(unref(appContext).Actions.APP_PRODUCT_IDENTIFIER_UPDATE)
        }, {
          default: withCtx(() => [
            createVNode(unref(IonSelect), {
              label: d.$t("Secondary"),
              interface: "popover",
              placeholder: "secondary identifier",
              value: a.value.secondaryId,
              onIonChange: p[1] || (p[1] = (g) => u(g.detail.value, "secondaryId"))
            }, {
              default: withCtx(() => [
                (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(c), (g) => (openBlock(), createBlock(unref(IonSelectOption), {
                  key: g,
                  value: g
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(g), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128)),
                createVNode(unref(IonSelectOption), { value: "" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1("None"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label", "value"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }));
  }
}), _hoisted_1$2 = ["src"], _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "DxpShopifyImg",
  props: ["src", "size"],
  setup(t) {
    const e = t, r = ref(shopifyImgContext.defaultImgUrl), o = (u) => new Promise((d, p) => {
      const g = new Image();
      g.onload = () => d(!0), g.onerror = () => p(!1), g.src = u;
    }), a = (u, d) => d ? u.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".").replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(p) {
      return "_" + d + p;
    }) : u, c = () => {
      if (e.src) {
        const u = a(e.src, e.size);
        o(u).then(() => r.value = u);
      }
    };
    return onMounted(() => {
      c();
    }), onUpdated(() => {
      c();
    }), (u, d) => (openBlock(), createElementBlock("img", { src: r.value }, null, 8, _hoisted_1$2));
  }
}), _hoisted_1$1 = { class: "user-profile" }, _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "DxpUserProfile",
  props: {
    userProfile: {
      type: Object,
      required: !0
    },
    logoutLabel: {
      type: String,
      default: "Logout"
    },
    goToLabel: {
      type: String,
      default: "Go To Launchpad"
    }
  },
  emits: ["before-logout"],
  setup(t, { emit: e }) {
    const r = appContext.config.globalProperties.$store, o = process.env.VUE_APP_LOGIN_URL, a = () => {
      e("before-logout"), r.dispatch("user/logout").then(() => {
        const u = window.location.origin + "/login";
        window.location.href = `${o}?isLoggedOut=true&redirectUrl=${u}`;
      });
    }, c = () => {
      window.location.href = o;
    };
    return (u, d) => (openBlock(), createElementBlock("div", _hoisted_1$1, [
      createVNode(unref(IonCard), null, {
        default: withCtx(() => [
          createVNode(unref(IonItem), { lines: "full" }, {
            default: withCtx(() => {
              var p;
              return [
                (p = t.userProfile) != null && p.partyImageUrl ? (openBlock(), createBlock(unref(IonAvatar), {
                  key: 0,
                  slot: "start"
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$8), {
                      src: t.userProfile.partyImageUrl
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })) : createCommentVNode("", !0),
                createVNode(unref(IonCardHeader), { class: "ion-no-padding ion-padding-vertical" }, {
                  default: withCtx(() => [
                    createVNode(unref(IonCardSubtitle), null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(t.userProfile.userLoginId), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(unref(IonCardTitle), null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(t.userProfile.partyName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ];
            }),
            _: 1
          }),
          createVNode(unref(IonButton), {
            color: "danger",
            onClick: d[0] || (d[0] = (p) => a())
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(t.logoutLabel), 1)
            ]),
            _: 1
          }),
          createVNode(unref(IonButton), {
            fill: "outline",
            onClick: d[1] || (d[1] = (p) => c())
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(t.goToLabel) + " ", 1),
              createVNode(unref(IonIcon), {
                slot: "end",
                icon: unref(openOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]));
  }
}), DxpUserProfile_vue_vue_type_style_index_0_scoped_8b9b246e_lang = "", _export_sfc = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [o, a] of e)
    r[o] = a;
  return r;
}, DxpUserProfile = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__scopeId", "data-v-8b9b246e"]]), _hoisted_1 = { class: "overline" }, _hoisted_2 = { key: 0 }, _hoisted_3 = { class: "overline" }, _hoisted_4 = { key: 0 }, _hoisted_5 = { key: 0 }, _hoisted_6 = {
  key: 1,
  class: "empty-state"
}, _hoisted_7 = {
  key: 2,
  class: "empty-state"
}, _hoisted_8 = { key: 3 }, _hoisted_9 = { key: 0 }, _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DxpTimeZoneSwitcher",
  props: {
    showBrowserTimeZone: {
      type: Boolean,
      default: !0
    },
    showDateTime: {
      type: Boolean,
      default: !0
    },
    dateTimeFormat: {
      type: String,
      default: "t ZZZZ"
    }
  },
  emits: ["timeZoneUpdated"],
  setup(t, { emit: e }) {
    const r = t, o = appContext.config.globalProperties.$store, a = useUserStore(), c = computed(() => o.getters["user/getUserProfile"]), u = computed(() => a.getTimeZones), d = computed(() => a.getCurrentTimeZone), p = ref(!1), g = ref(), b = ref(""), x = ref([]), w = ref(""), y = ref({
      label: "",
      id: Intl.DateTimeFormat().resolvedOptions().timeZone
    }), I = () => {
      g.value.$el.dismiss(null, "cancel");
    };
    onBeforeMount(async () => {
      var R;
      p.value = !0, await a.getAvailableTimeZones(), c.value && c.value.userTimeZone && (a.currentTimeZoneId = c.value.userTimeZone, w.value = c.value.userTimeZone), r.showBrowserTimeZone && (y.value.label = (R = u.value.find((O) => O.id.toLowerCase().match(y.value.id.toLowerCase()))) == null ? void 0 : R.label), T(), p.value = !1;
    });
    async function E() {
      await a.setUserTimeZone(w.value).then((R) => {
        e("timeZoneUpdated", R);
      }).catch((R) => R), I();
    }
    function T() {
      const R = b.value.toLowerCase();
      x.value = u.value.filter((O) => O.id.toLowerCase().match(R) || O.label.toLowerCase().match(R)), r.showBrowserTimeZone && (x.value = x.value.filter((O) => !O.id.toLowerCase().match(y.value.id.toLowerCase())));
    }
    async function C(R) {
      (await R.target.getInputElement()).select();
    }
    function $(R) {
      /[`!@#$%^&*()_+\-=\\|,.<>?~]/.test(R.key) && R.preventDefault();
    }
    function D() {
      p.value = !0, T(), p.value = !1;
    }
    function L() {
      b.value = "", x.value = [];
    }
    return (R, O) => (openBlock(), createElementBlock(Fragment, null, [
      createVNode(unref(IonCard), null, {
        default: withCtx(() => [
          createVNode(unref(IonCardHeader), null, {
            default: withCtx(() => [
              createVNode(unref(IonCardTitle), null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(R.$t("Timezone")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(unref(IonCardContent), null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1(R.$t("The timezone you select is used to ensure automations you schedule are always accurate to the time you select.")), 1)
            ]),
            _: 1
          }),
          t.showBrowserTimeZone ? (openBlock(), createBlock(unref(IonItem), { key: 0 }, {
            default: withCtx(() => [
              createVNode(unref(IonLabel), null, {
                default: withCtx(() => [
                  createElementVNode("p", _hoisted_1, toDisplayString$1(R.$t("Browser TimeZone")), 1),
                  createTextVNode(" " + toDisplayString$1(y.value.id) + " ", 1),
                  t.showDateTime ? (openBlock(), createElementBlock("p", _hoisted_2, toDisplayString$1(unref(getCurrentTime)(y.value.id, t.dateTimeFormat)), 1)) : createCommentVNode("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", !0),
          createVNode(unref(IonItem), { lines: "none" }, {
            default: withCtx(() => [
              createVNode(unref(IonLabel), null, {
                default: withCtx(() => [
                  createElementVNode("p", _hoisted_3, toDisplayString$1(R.$t("Selected TimeZone")), 1),
                  createTextVNode(" " + toDisplayString$1(d.value) + " ", 1),
                  t.showDateTime ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString$1(unref(getCurrentTime)(d.value, t.dateTimeFormat)), 1)) : createCommentVNode("", !0)
                ]),
                _: 1
              }),
              createVNode(unref(IonButton), {
                id: "time-zone-modal",
                slot: "end",
                fill: "outline",
                color: "dark"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(R.$t("Change")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(unref(IonModal), {
        ref_key: "timeZoneModal",
        ref: g,
        trigger: "time-zone-modal",
        onDidPresent: O[5] || (O[5] = (P) => D()),
        onDidDismiss: O[6] || (O[6] = (P) => L())
      }, {
        default: withCtx(() => [
          createVNode(unref(IonHeader), null, {
            default: withCtx(() => [
              createVNode(unref(IonToolbar), null, {
                default: withCtx(() => [
                  createVNode(unref(IonButtons), { slot: "start" }, {
                    default: withCtx(() => [
                      createVNode(unref(IonButton), { onClick: I }, {
                        default: withCtx(() => [
                          createVNode(unref(IonIcon), { icon: unref(closeOutline) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  createVNode(unref(IonTitle), null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(R.$t("Select time zone")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              createVNode(unref(IonToolbar), null, {
                default: withCtx(() => [
                  createVNode(unref(IonSearchbar), {
                    onIonFocus: O[0] || (O[0] = (P) => C(P)),
                    placeholder: R.$t("Search time zones"),
                    modelValue: b.value,
                    "onUpdate:modelValue": O[1] || (O[1] = (P) => b.value = P),
                    onKeyup: O[2] || (O[2] = withKeys((P) => {
                      b.value = P.target.value, T();
                    }, ["enter"])),
                    onKeydown: O[3] || (O[3] = (P) => $(P))
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(unref(IonContent), { class: "ion-padding" }, {
            default: withCtx(() => [
              createElementVNode("div", null, [
                createVNode(unref(IonRadioGroup), {
                  value: "rd",
                  modelValue: w.value,
                  "onUpdate:modelValue": O[4] || (O[4] = (P) => w.value = P)
                }, {
                  default: withCtx(() => [
                    t.showBrowserTimeZone ? (openBlock(), createBlock(unref(IonList), { key: 0 }, {
                      default: withCtx(() => [
                        createVNode(unref(IonListHeader), null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(R.$t("Browser time zone")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(unref(IonItem), null, {
                          default: withCtx(() => [
                            createVNode(unref(IonRadio), {
                              "label-placement": "end",
                              justify: "start",
                              value: y.value.id
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(IonLabel), null, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString$1(y.value.label) + " (" + toDisplayString$1(y.value.id) + ") ", 1),
                                    t.showDateTime ? (openBlock(), createElementBlock("p", _hoisted_5, toDisplayString$1(unref(getCurrentTime)(y.value.id, t.dateTimeFormat)), 1)) : createCommentVNode("", !0)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })) : createCommentVNode("", !0),
                    createVNode(unref(IonList), null, {
                      default: withCtx(() => [
                        t.showBrowserTimeZone ? (openBlock(), createBlock(unref(IonListHeader), { key: 0 }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(R.$t("Select a different time zone")), 1)
                          ]),
                          _: 1
                        })) : createCommentVNode("", !0),
                        p.value ? (openBlock(), createElementBlock("div", _hoisted_6, [
                          createVNode(unref(IonItem), { lines: "none" }, {
                            default: withCtx(() => [
                              createVNode(unref(IonSpinner), {
                                color: "secondary",
                                name: "crescent",
                                slot: "start"
                              }),
                              createTextVNode(" " + toDisplayString$1(R.$t("Fetching time zones")), 1)
                            ]),
                            _: 1
                          })
                        ])) : x.value.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_7, [
                          createElementVNode("p", null, toDisplayString$1(R.$t("No time zone found")), 1)
                        ])) : (openBlock(), createElementBlock("div", _hoisted_8, [
                          (openBlock(!0), createElementBlock(Fragment, null, renderList(x.value, (P) => (openBlock(), createBlock(unref(IonItem), {
                            key: P.id
                          }, {
                            default: withCtx(() => [
                              createVNode(unref(IonRadio), {
                                "label-placement": "end",
                                justify: "start",
                                value: P.id
                              }, {
                                default: withCtx(() => [
                                  createVNode(unref(IonLabel), null, {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString$1(P.label) + " (" + toDisplayString$1(P.id) + ") ", 1),
                                      t.showDateTime ? (openBlock(), createElementBlock("p", _hoisted_9, toDisplayString$1(unref(getCurrentTime)(P.id, t.dateTimeFormat)), 1)) : createCommentVNode("", !0)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ]),
                            _: 2
                          }, 1024))), 128))
                        ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              createVNode(unref(IonFab), {
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed"
              }, {
                default: withCtx(() => [
                  createVNode(unref(IonFabButton), {
                    disabled: !d.value,
                    onClick: E
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(IonIcon), { icon: unref(saveOutline) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ], 64));
  }
});
function isObject$2(t) {
  return typeof t == "object" && t !== null;
}
function normalizeOptions(t, e) {
  return t = isObject$2(t) ? t : /* @__PURE__ */ Object.create(null), new Proxy(t, {
    get(r, o, a) {
      return o === "key" ? Reflect.get(r, o, a) : Reflect.get(r, o, a) || Reflect.get(e, o, a);
    }
  });
}
function get(t, e) {
  return e.reduce((r, o) => r == null ? void 0 : r[o], t);
}
function set(t, e, r) {
  return e.slice(0, -1).reduce((o, a) => /^(__proto__)$/.test(a) ? {} : o[a] = o[a] || {}, t)[e[e.length - 1]] = r, t;
}
function pick(t, e) {
  return e.reduce((r, o) => {
    const a = o.split(".");
    return set(r, a, get(t, a));
  }, {});
}
function hydrateStore(t, { storage: e, serializer: r, key: o, debug: a }) {
  try {
    const c = e == null ? void 0 : e.getItem(o);
    c && t.$patch(r == null ? void 0 : r.deserialize(c));
  } catch (c) {
    a && console.error(c);
  }
}
function persistState(t, { storage: e, serializer: r, key: o, paths: a, debug: c }) {
  try {
    const u = Array.isArray(a) ? pick(t, a) : t;
    e.setItem(o, r.serialize(u));
  } catch (u) {
    c && console.error(u);
  }
}
function createPersistedState(t = {}) {
  return (e) => {
    const { auto: r = !1 } = t, {
      options: { persist: o = r },
      store: a,
      pinia: c
    } = e;
    if (!o)
      return;
    if (!(a.$id in c.state.value)) {
      const d = c._s.get(a.$id.replace("__hot:", ""));
      d && Promise.resolve().then(() => d.$persist());
      return;
    }
    const u = (Array.isArray(o) ? o.map((d) => normalizeOptions(d, t)) : [normalizeOptions(o, t)]).map(
      ({
        storage: d = localStorage,
        beforeRestore: p = null,
        afterRestore: g = null,
        serializer: b = {
          serialize: JSON.stringify,
          deserialize: JSON.parse
        },
        key: x = a.$id,
        paths: w = null,
        debug: y = !1
      }) => {
        var I;
        return {
          storage: d,
          beforeRestore: p,
          afterRestore: g,
          serializer: b,
          key: ((I = t.key) != null ? I : (E) => E)(typeof x == "string" ? x : x(a.$id)),
          paths: w,
          debug: y
        };
      }
    );
    a.$persist = () => {
      u.forEach((d) => {
        persistState(a.$state, d);
      });
    }, a.$hydrate = ({ runHooks: d = !0 } = {}) => {
      u.forEach((p) => {
        const { beforeRestore: g, afterRestore: b } = p;
        d && (g == null || g(e)), hydrateStore(a, p), d && (b == null || b(e));
      });
    }, u.forEach((d) => {
      const { beforeRestore: p, afterRestore: g } = d;
      p == null || p(e), hydrateStore(a, d), g == null || g(e), a.$subscribe(
        (b, x) => {
          persistState(x, d);
        },
        {
          detached: !0
        }
      );
    });
  };
}
var src_default = createPersistedState();
/*!
  * shared v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const inBrowser = typeof window < "u";
let mark, measure;
if (process.env.NODE_ENV !== "production") {
  const t = inBrowser && window.performance;
  t && t.mark && t.measure && t.clearMarks && // @ts-ignore browser compat
  t.clearMeasures && (mark = (e) => {
    t.mark(e);
  }, measure = (e, r, o) => {
    t.measure(e, r, o), t.clearMarks(r), t.clearMarks(o);
  });
}
const RE_ARGS$1 = /\{([0-9a-zA-Z]+)\}/g;
function format$2(t, ...e) {
  return e.length === 1 && isObject$1(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(RE_ARGS$1, (r, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const makeSymbol = (t, e = !1) => e ? Symbol.for(t) : Symbol(t), generateFormatCacheKey = (t, e, r) => friendlyJSONstringify({ l: t, k: e, s: r }), friendlyJSONstringify = (t) => JSON.stringify(t).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), isNumber = (t) => typeof t == "number" && isFinite(t), isDate = (t) => toTypeString(t) === "[object Date]", isRegExp = (t) => toTypeString(t) === "[object RegExp]", isEmptyObject = (t) => isPlainObject(t) && Object.keys(t).length === 0, assign$1 = Object.assign;
let _globalThis;
const getGlobalThis = () => _globalThis || (_globalThis = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function escapeHtml(t) {
  return t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(t, e) {
  return hasOwnProperty.call(t, e);
}
const isArray = Array.isArray, isFunction = (t) => typeof t == "function", isString$1 = (t) => typeof t == "string", isBoolean = (t) => typeof t == "boolean", isObject$1 = (t) => t !== null && typeof t == "object", objectToString = Object.prototype.toString, toTypeString = (t) => objectToString.call(t), isPlainObject = (t) => {
  if (!isObject$1(t))
    return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e.constructor === Object;
}, toDisplayString = (t) => t == null ? "" : isArray(t) || isPlainObject(t) && t.toString === objectToString ? JSON.stringify(t, null, 2) : String(t);
function join$1(t, e = "") {
  return t.reduce((r, o, a) => a === 0 ? r + o : r + e + o, "");
}
const RANGE = 2;
function generateCodeFrame(t, e = 0, r = t.length) {
  const o = t.split(/\r?\n/);
  let a = 0;
  const c = [];
  for (let u = 0; u < o.length; u++)
    if (a += o[u].length + 1, a >= e) {
      for (let d = u - RANGE; d <= u + RANGE || r > a; d++) {
        if (d < 0 || d >= o.length)
          continue;
        const p = d + 1;
        c.push(`${p}${" ".repeat(3 - String(p).length)}|  ${o[d]}`);
        const g = o[d].length;
        if (d === u) {
          const b = e - (a - g) + 1, x = Math.max(1, r > a ? g - b : r - e);
          c.push("   |  " + " ".repeat(b) + "^".repeat(x));
        } else if (d > u) {
          if (r > a) {
            const b = Math.max(Math.min(r - a, g), 1);
            c.push("   |  " + "^".repeat(b));
          }
          a += g + 1;
        }
      }
      break;
    }
  return c.join(`
`);
}
function incrementer(t) {
  let e = t;
  return () => ++e;
}
function warn(t, e) {
  typeof console < "u" && (console.warn("[intlify] " + t), e && console.warn(e.stack));
}
const hasWarned = {};
function warnOnce(t) {
  hasWarned[t] || (hasWarned[t] = !0, warn(t));
}
function createEmitter() {
  const t = /* @__PURE__ */ new Map();
  return {
    events: t,
    on(r, o) {
      const a = t.get(r);
      a && a.push(o) || t.set(r, [o]);
    },
    off(r, o) {
      const a = t.get(r);
      a && a.splice(a.indexOf(o) >>> 0, 1);
    },
    emit(r, o) {
      (t.get(r) || []).slice().map((a) => a(o)), (t.get("*") || []).slice().map((a) => a(r, o));
    }
  };
}
/*!
  * message-compiler v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function createPosition(t, e, r) {
  return { line: t, column: e, offset: r };
}
function createLocation(t, e, r) {
  const o = { start: t, end: e };
  return r != null && (o.source = r), o;
}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
function format$1(t, ...e) {
  return e.length === 1 && isObject(e[0]) && (e = e[0]), (!e || !e.hasOwnProperty) && (e = {}), t.replace(RE_ARGS, (r, o) => e.hasOwnProperty(o) ? e[o] : "");
}
const assign = Object.assign, isString = (t) => typeof t == "string", isObject = (t) => t !== null && typeof t == "object";
function join(t, e = "") {
  return t.reduce((r, o, a) => a === 0 ? r + o : r + e + o, "");
}
const CompileErrorCodes = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, errorMessages$2 = {
  // tokenizer error messages
  [CompileErrorCodes.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [CompileErrorCodes.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [CompileErrorCodes.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function createCompileError(t, e, r = {}) {
  const { domain: o, messages: a, args: c } = r, u = format$1((a || errorMessages$2)[t] || "", ...c || []), d = new SyntaxError(String(u));
  return d.code = t, e && (d.location = e), d.domain = o, d;
}
function defaultOnError(t) {
  throw t;
}
const RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/, detectHtmlTag = (t) => RE_HTML_TAG.test(t), CHAR_SP = " ", CHAR_CR = "\r", CHAR_LF = `
`, CHAR_LS = String.fromCharCode(8232), CHAR_PS = String.fromCharCode(8233);
function createScanner(t) {
  const e = t;
  let r = 0, o = 1, a = 1, c = 0;
  const u = (P) => e[P] === CHAR_CR && e[P + 1] === CHAR_LF, d = (P) => e[P] === CHAR_LF, p = (P) => e[P] === CHAR_PS, g = (P) => e[P] === CHAR_LS, b = (P) => u(P) || d(P) || p(P) || g(P), x = () => r, w = () => o, y = () => a, I = () => c, E = (P) => u(P) || p(P) || g(P) ? CHAR_LF : e[P], T = () => E(r), C = () => E(r + c);
  function $() {
    return c = 0, b(r) && (o++, a = 0), u(r) && r++, r++, a++, e[r];
  }
  function D() {
    return u(r + c) && c++, c++, e[r + c];
  }
  function L() {
    r = 0, o = 1, a = 1, c = 0;
  }
  function R(P = 0) {
    c = P;
  }
  function O() {
    const P = r + c;
    for (; P !== r; )
      $();
    c = 0;
  }
  return {
    index: x,
    line: w,
    column: y,
    peekOffset: I,
    charAt: E,
    currentChar: T,
    currentPeek: C,
    next: $,
    peek: D,
    reset: L,
    resetPeek: R,
    skipToPeek: O
  };
}
const EOF = void 0, DOT = ".", LITERAL_DELIMITER = "'", ERROR_DOMAIN$3 = "tokenizer";
function createTokenizer(t, e = {}) {
  const r = e.location !== !1, o = createScanner(t), a = () => o.index(), c = () => createPosition(o.line(), o.column(), o.index()), u = c(), d = a(), p = {
    currentType: 14,
    offset: d,
    startLoc: u,
    endLoc: u,
    lastType: 14,
    lastOffset: d,
    lastStartLoc: u,
    lastEndLoc: u,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, g = () => p, { onError: b } = e;
  function x(K, q, se, ...Ce) {
    const Le = g();
    if (q.column += se, q.offset += se, b) {
      const qe = r ? createLocation(Le.startLoc, q) : null, Ct = createCompileError(K, qe, {
        domain: ERROR_DOMAIN$3,
        args: Ce
      });
      b(Ct);
    }
  }
  function w(K, q, se) {
    K.endLoc = c(), K.currentType = q;
    const Ce = { type: q };
    return r && (Ce.loc = createLocation(K.startLoc, K.endLoc)), se != null && (Ce.value = se), Ce;
  }
  const y = (K) => w(
    K,
    14
    /* TokenTypes.EOF */
  );
  function I(K, q) {
    return K.currentChar() === q ? (K.next(), q) : (x(CompileErrorCodes.EXPECTED_TOKEN, c(), 0, q), "");
  }
  function E(K) {
    let q = "";
    for (; K.currentPeek() === CHAR_SP || K.currentPeek() === CHAR_LF; )
      q += K.currentPeek(), K.peek();
    return q;
  }
  function T(K) {
    const q = E(K);
    return K.skipToPeek(), q;
  }
  function C(K) {
    if (K === EOF)
      return !1;
    const q = K.charCodeAt(0);
    return q >= 97 && q <= 122 || // a-z
    q >= 65 && q <= 90 || // A-Z
    q === 95;
  }
  function $(K) {
    if (K === EOF)
      return !1;
    const q = K.charCodeAt(0);
    return q >= 48 && q <= 57;
  }
  function D(K, q) {
    const { currentType: se } = q;
    if (se !== 2)
      return !1;
    E(K);
    const Ce = C(K.currentPeek());
    return K.resetPeek(), Ce;
  }
  function L(K, q) {
    const { currentType: se } = q;
    if (se !== 2)
      return !1;
    E(K);
    const Ce = K.currentPeek() === "-" ? K.peek() : K.currentPeek(), Le = $(Ce);
    return K.resetPeek(), Le;
  }
  function R(K, q) {
    const { currentType: se } = q;
    if (se !== 2)
      return !1;
    E(K);
    const Ce = K.currentPeek() === LITERAL_DELIMITER;
    return K.resetPeek(), Ce;
  }
  function O(K, q) {
    const { currentType: se } = q;
    if (se !== 8)
      return !1;
    E(K);
    const Ce = K.currentPeek() === ".";
    return K.resetPeek(), Ce;
  }
  function P(K, q) {
    const { currentType: se } = q;
    if (se !== 9)
      return !1;
    E(K);
    const Ce = C(K.currentPeek());
    return K.resetPeek(), Ce;
  }
  function z(K, q) {
    const { currentType: se } = q;
    if (!(se === 8 || se === 12))
      return !1;
    E(K);
    const Ce = K.currentPeek() === ":";
    return K.resetPeek(), Ce;
  }
  function W(K, q) {
    const { currentType: se } = q;
    if (se !== 10)
      return !1;
    const Ce = () => {
      const qe = K.currentPeek();
      return qe === "{" ? C(K.peek()) : qe === "@" || qe === "%" || qe === "|" || qe === ":" || qe === "." || qe === CHAR_SP || !qe ? !1 : qe === CHAR_LF ? (K.peek(), Ce()) : C(qe);
    }, Le = Ce();
    return K.resetPeek(), Le;
  }
  function A(K) {
    E(K);
    const q = K.currentPeek() === "|";
    return K.resetPeek(), q;
  }
  function S(K) {
    const q = E(K), se = K.currentPeek() === "%" && K.peek() === "{";
    return K.resetPeek(), {
      isModulo: se,
      hasSpace: q.length > 0
    };
  }
  function F(K, q = !0) {
    const se = (Le = !1, qe = "", Ct = !1) => {
      const ke = K.currentPeek();
      return ke === "{" ? qe === "%" ? !1 : Le : ke === "@" || !ke ? qe === "%" ? !0 : Le : ke === "%" ? (K.peek(), se(Le, "%", !0)) : ke === "|" ? qe === "%" || Ct ? !0 : !(qe === CHAR_SP || qe === CHAR_LF) : ke === CHAR_SP ? (K.peek(), se(!0, CHAR_SP, Ct)) : ke === CHAR_LF ? (K.peek(), se(!0, CHAR_LF, Ct)) : !0;
    }, Ce = se();
    return q && K.resetPeek(), Ce;
  }
  function U(K, q) {
    const se = K.currentChar();
    return se === EOF ? EOF : q(se) ? (K.next(), se) : null;
  }
  function M(K) {
    return U(K, (se) => {
      const Ce = se.charCodeAt(0);
      return Ce >= 97 && Ce <= 122 || // a-z
      Ce >= 65 && Ce <= 90 || // A-Z
      Ce >= 48 && Ce <= 57 || // 0-9
      Ce === 95 || // _
      Ce === 36;
    });
  }
  function V(K) {
    return U(K, (se) => {
      const Ce = se.charCodeAt(0);
      return Ce >= 48 && Ce <= 57;
    });
  }
  function G(K) {
    return U(K, (se) => {
      const Ce = se.charCodeAt(0);
      return Ce >= 48 && Ce <= 57 || // 0-9
      Ce >= 65 && Ce <= 70 || // A-F
      Ce >= 97 && Ce <= 102;
    });
  }
  function Q(K) {
    let q = "", se = "";
    for (; q = V(K); )
      se += q;
    return se;
  }
  function fe(K) {
    T(K);
    const q = K.currentChar();
    return q !== "%" && x(CompileErrorCodes.EXPECTED_TOKEN, c(), 0, q), K.next(), "%";
  }
  function te(K) {
    let q = "";
    for (; ; ) {
      const se = K.currentChar();
      if (se === "{" || se === "}" || se === "@" || se === "|" || !se)
        break;
      if (se === "%")
        if (F(K))
          q += se, K.next();
        else
          break;
      else if (se === CHAR_SP || se === CHAR_LF)
        if (F(K))
          q += se, K.next();
        else {
          if (A(K))
            break;
          q += se, K.next();
        }
      else
        q += se, K.next();
    }
    return q;
  }
  function de(K) {
    T(K);
    let q = "", se = "";
    for (; q = M(K); )
      se += q;
    return K.currentChar() === EOF && x(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, c(), 0), se;
  }
  function me(K) {
    T(K);
    let q = "";
    return K.currentChar() === "-" ? (K.next(), q += `-${Q(K)}`) : q += Q(K), K.currentChar() === EOF && x(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, c(), 0), q;
  }
  function Me(K) {
    T(K), I(K, "'");
    let q = "", se = "";
    const Ce = (qe) => qe !== LITERAL_DELIMITER && qe !== CHAR_LF;
    for (; q = U(K, Ce); )
      q === "\\" ? se += ce(K) : se += q;
    const Le = K.currentChar();
    return Le === CHAR_LF || Le === EOF ? (x(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, c(), 0), Le === CHAR_LF && (K.next(), I(K, "'")), se) : (I(K, "'"), se);
  }
  function ce(K) {
    const q = K.currentChar();
    switch (q) {
      case "\\":
      case "'":
        return K.next(), `\\${q}`;
      case "u":
        return oe(K, q, 4);
      case "U":
        return oe(K, q, 6);
      default:
        return x(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, c(), 0, q), "";
    }
  }
  function oe(K, q, se) {
    I(K, q);
    let Ce = "";
    for (let Le = 0; Le < se; Le++) {
      const qe = G(K);
      if (!qe) {
        x(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, c(), 0, `\\${q}${Ce}${K.currentChar()}`);
        break;
      }
      Ce += qe;
    }
    return `\\${q}${Ce}`;
  }
  function be(K) {
    T(K);
    let q = "", se = "";
    const Ce = (Le) => Le !== "{" && Le !== "}" && Le !== CHAR_SP && Le !== CHAR_LF;
    for (; q = U(K, Ce); )
      se += q;
    return se;
  }
  function Te(K) {
    let q = "", se = "";
    for (; q = M(K); )
      se += q;
    return se;
  }
  function Ae(K) {
    const q = (se = !1, Ce) => {
      const Le = K.currentChar();
      return Le === "{" || Le === "%" || Le === "@" || Le === "|" || Le === "(" || Le === ")" || !Le || Le === CHAR_SP ? Ce : Le === CHAR_LF || Le === DOT ? (Ce += Le, K.next(), q(se, Ce)) : (Ce += Le, K.next(), q(!0, Ce));
    };
    return q(!1, "");
  }
  function je(K) {
    T(K);
    const q = I(
      K,
      "|"
      /* TokenChars.Pipe */
    );
    return T(K), q;
  }
  function Xe(K, q) {
    let se = null;
    switch (K.currentChar()) {
      case "{":
        return q.braceNest >= 1 && x(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, c(), 0), K.next(), se = w(
          q,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), T(K), q.braceNest++, se;
      case "}":
        return q.braceNest > 0 && q.currentType === 2 && x(CompileErrorCodes.EMPTY_PLACEHOLDER, c(), 0), K.next(), se = w(
          q,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), q.braceNest--, q.braceNest > 0 && T(K), q.inLinked && q.braceNest === 0 && (q.inLinked = !1), se;
      case "@":
        return q.braceNest > 0 && x(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, c(), 0), se = He(K, q) || y(q), q.braceNest = 0, se;
      default:
        let Le = !0, qe = !0, Ct = !0;
        if (A(K))
          return q.braceNest > 0 && x(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, c(), 0), se = w(q, 1, je(K)), q.braceNest = 0, q.inLinked = !1, se;
        if (q.braceNest > 0 && (q.currentType === 5 || q.currentType === 6 || q.currentType === 7))
          return x(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, c(), 0), q.braceNest = 0, Ke(K, q);
        if (Le = D(K, q))
          return se = w(q, 5, de(K)), T(K), se;
        if (qe = L(K, q))
          return se = w(q, 6, me(K)), T(K), se;
        if (Ct = R(K, q))
          return se = w(q, 7, Me(K)), T(K), se;
        if (!Le && !qe && !Ct)
          return se = w(q, 13, be(K)), x(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, c(), 0, se.value), T(K), se;
        break;
    }
    return se;
  }
  function He(K, q) {
    const { currentType: se } = q;
    let Ce = null;
    const Le = K.currentChar();
    switch ((se === 8 || se === 9 || se === 12 || se === 10) && (Le === CHAR_LF || Le === CHAR_SP) && x(CompileErrorCodes.INVALID_LINKED_FORMAT, c(), 0), Le) {
      case "@":
        return K.next(), Ce = w(
          q,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), q.inLinked = !0, Ce;
      case ".":
        return T(K), K.next(), w(
          q,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return T(K), K.next(), w(
          q,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return A(K) ? (Ce = w(q, 1, je(K)), q.braceNest = 0, q.inLinked = !1, Ce) : O(K, q) || z(K, q) ? (T(K), He(K, q)) : P(K, q) ? (T(K), w(q, 12, Te(K))) : W(K, q) ? (T(K), Le === "{" ? Xe(K, q) || Ce : w(q, 11, Ae(K))) : (se === 8 && x(CompileErrorCodes.INVALID_LINKED_FORMAT, c(), 0), q.braceNest = 0, q.inLinked = !1, Ke(K, q));
    }
  }
  function Ke(K, q) {
    let se = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (q.braceNest > 0)
      return Xe(K, q) || y(q);
    if (q.inLinked)
      return He(K, q) || y(q);
    switch (K.currentChar()) {
      case "{":
        return Xe(K, q) || y(q);
      case "}":
        return x(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, c(), 0), K.next(), w(
          q,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return He(K, q) || y(q);
      default:
        if (A(K))
          return se = w(q, 1, je(K)), q.braceNest = 0, q.inLinked = !1, se;
        const { isModulo: Le, hasSpace: qe } = S(K);
        if (Le)
          return qe ? w(q, 0, te(K)) : w(q, 4, fe(K));
        if (F(K))
          return w(q, 0, te(K));
        break;
    }
    return se;
  }
  function ot() {
    const { currentType: K, offset: q, startLoc: se, endLoc: Ce } = p;
    return p.lastType = K, p.lastOffset = q, p.lastStartLoc = se, p.lastEndLoc = Ce, p.offset = a(), p.startLoc = c(), o.currentChar() === EOF ? w(
      p,
      14
      /* TokenTypes.EOF */
    ) : Ke(o, p);
  }
  return {
    nextToken: ot,
    currentOffset: a,
    currentPosition: c,
    context: g
  };
}
const ERROR_DOMAIN$2 = "parser", KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(t, e, r) {
  switch (t) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(e || r, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function createParser(t = {}) {
  const e = t.location !== !1, { onError: r } = t;
  function o(C, $, D, L, ...R) {
    const O = C.currentPosition();
    if (O.offset += L, O.column += L, r) {
      const P = e ? createLocation(D, O) : null, z = createCompileError($, P, {
        domain: ERROR_DOMAIN$2,
        args: R
      });
      r(z);
    }
  }
  function a(C, $, D) {
    const L = { type: C };
    return e && (L.start = $, L.end = $, L.loc = { start: D, end: D }), L;
  }
  function c(C, $, D, L) {
    L && (C.type = L), e && (C.end = $, C.loc && (C.loc.end = D));
  }
  function u(C, $) {
    const D = C.context(), L = a(3, D.offset, D.startLoc);
    return L.value = $, c(L, C.currentOffset(), C.currentPosition()), L;
  }
  function d(C, $) {
    const D = C.context(), { lastOffset: L, lastStartLoc: R } = D, O = a(5, L, R);
    return O.index = parseInt($, 10), C.nextToken(), c(O, C.currentOffset(), C.currentPosition()), O;
  }
  function p(C, $) {
    const D = C.context(), { lastOffset: L, lastStartLoc: R } = D, O = a(4, L, R);
    return O.key = $, C.nextToken(), c(O, C.currentOffset(), C.currentPosition()), O;
  }
  function g(C, $) {
    const D = C.context(), { lastOffset: L, lastStartLoc: R } = D, O = a(9, L, R);
    return O.value = $.replace(KNOWN_ESCAPES, fromEscapeSequence), C.nextToken(), c(O, C.currentOffset(), C.currentPosition()), O;
  }
  function b(C) {
    const $ = C.nextToken(), D = C.context(), { lastOffset: L, lastStartLoc: R } = D, O = a(8, L, R);
    return $.type !== 12 ? (o(C, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, D.lastStartLoc, 0), O.value = "", c(O, L, R), {
      nextConsumeToken: $,
      node: O
    }) : ($.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, D.lastStartLoc, 0, getTokenCaption($)), O.value = $.value || "", c(O, C.currentOffset(), C.currentPosition()), {
      node: O
    });
  }
  function x(C, $) {
    const D = C.context(), L = a(7, D.offset, D.startLoc);
    return L.value = $, c(L, C.currentOffset(), C.currentPosition()), L;
  }
  function w(C) {
    const $ = C.context(), D = a(6, $.offset, $.startLoc);
    let L = C.nextToken();
    if (L.type === 9) {
      const R = b(C);
      D.modifier = R.node, L = R.nextConsumeToken || C.nextToken();
    }
    switch (L.type !== 10 && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(L)), L = C.nextToken(), L.type === 2 && (L = C.nextToken()), L.type) {
      case 11:
        L.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(L)), D.key = x(C, L.value || "");
        break;
      case 5:
        L.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(L)), D.key = p(C, L.value || "");
        break;
      case 6:
        L.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(L)), D.key = d(C, L.value || "");
        break;
      case 7:
        L.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(L)), D.key = g(C, L.value || "");
        break;
      default:
        o(C, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, $.lastStartLoc, 0);
        const R = C.context(), O = a(7, R.offset, R.startLoc);
        return O.value = "", c(O, R.offset, R.startLoc), D.key = O, c(D, R.offset, R.startLoc), {
          nextConsumeToken: L,
          node: D
        };
    }
    return c(D, C.currentOffset(), C.currentPosition()), {
      node: D
    };
  }
  function y(C) {
    const $ = C.context(), D = $.currentType === 1 ? C.currentOffset() : $.offset, L = $.currentType === 1 ? $.endLoc : $.startLoc, R = a(2, D, L);
    R.items = [];
    let O = null;
    do {
      const W = O || C.nextToken();
      switch (O = null, W.type) {
        case 0:
          W.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(W)), R.items.push(u(C, W.value || ""));
          break;
        case 6:
          W.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(W)), R.items.push(d(C, W.value || ""));
          break;
        case 5:
          W.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(W)), R.items.push(p(C, W.value || ""));
          break;
        case 7:
          W.value == null && o(C, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, $.lastStartLoc, 0, getTokenCaption(W)), R.items.push(g(C, W.value || ""));
          break;
        case 8:
          const A = w(C);
          R.items.push(A.node), O = A.nextConsumeToken || null;
          break;
      }
    } while ($.currentType !== 14 && $.currentType !== 1);
    const P = $.currentType === 1 ? $.lastOffset : C.currentOffset(), z = $.currentType === 1 ? $.lastEndLoc : C.currentPosition();
    return c(R, P, z), R;
  }
  function I(C, $, D, L) {
    const R = C.context();
    let O = L.items.length === 0;
    const P = a(1, $, D);
    P.cases = [], P.cases.push(L);
    do {
      const z = y(C);
      O || (O = z.items.length === 0), P.cases.push(z);
    } while (R.currentType !== 14);
    return O && o(C, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, D, 0), c(P, C.currentOffset(), C.currentPosition()), P;
  }
  function E(C) {
    const $ = C.context(), { offset: D, startLoc: L } = $, R = y(C);
    return $.currentType === 14 ? R : I(C, D, L, R);
  }
  function T(C) {
    const $ = createTokenizer(C, assign({}, t)), D = $.context(), L = a(0, D.offset, D.startLoc);
    return e && L.loc && (L.loc.source = C), L.body = E($), t.onCacheKey && (L.cacheKey = t.onCacheKey(C)), D.currentType !== 14 && o($, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, D.lastStartLoc, 0, C[D.offset] || ""), c(L, $.currentOffset(), $.currentPosition()), L;
  }
  return { parse: T };
}
function getTokenCaption(t) {
  if (t.type === 14)
    return "EOF";
  const e = (t.value || "").replace(/\r?\n/gu, "\\n");
  return e.length > 10 ? e.slice(0, 9) + "…" : e;
}
function createTransformer(t, e = {}) {
  const r = {
    ast: t,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => r, helper: (c) => (r.helpers.add(c), c) };
}
function traverseNodes(t, e) {
  for (let r = 0; r < t.length; r++)
    traverseNode(t[r], e);
}
function traverseNode(t, e) {
  switch (t.type) {
    case 1:
      traverseNodes(t.cases, e), e.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      traverseNodes(t.items, e);
      break;
    case 6:
      traverseNode(t.key, e), e.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), e.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      e.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), e.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function transform(t, e = {}) {
  const r = createTransformer(t);
  r.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), t.body && traverseNode(t.body, r);
  const o = r.context();
  t.helpers = Array.from(o.helpers);
}
function optimize(t) {
  const e = t.body;
  return e.type === 2 ? optimizeMessageNode(e) : e.cases.forEach((r) => optimizeMessageNode(r)), t;
}
function optimizeMessageNode(t) {
  if (t.items.length === 1) {
    const e = t.items[0];
    (e.type === 3 || e.type === 9) && (t.static = e.value, delete e.value);
  } else {
    const e = [];
    for (let r = 0; r < t.items.length; r++) {
      const o = t.items[r];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      e.push(o.value);
    }
    if (e.length === t.items.length) {
      t.static = join(e);
      for (let r = 0; r < t.items.length; r++) {
        const o = t.items[r];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const ERROR_DOMAIN$1 = "minifier";
function minify(t) {
  switch (t.t = t.type, t.type) {
    case 0:
      const e = t;
      minify(e.body), e.b = e.body, delete e.body;
      break;
    case 1:
      const r = t, o = r.cases;
      for (let b = 0; b < o.length; b++)
        minify(o[b]);
      r.c = o, delete r.cases;
      break;
    case 2:
      const a = t, c = a.items;
      for (let b = 0; b < c.length; b++)
        minify(c[b]);
      a.i = c, delete a.items, a.static && (a.s = a.static, delete a.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const u = t;
      u.value && (u.v = u.value, delete u.value);
      break;
    case 6:
      const d = t;
      minify(d.key), d.k = d.key, delete d.key, d.modifier && (minify(d.modifier), d.m = d.modifier, delete d.modifier);
      break;
    case 5:
      const p = t;
      p.i = p.index, delete p.index;
      break;
    case 4:
      const g = t;
      g.k = g.key, delete g.key;
      break;
    default:
      throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: ERROR_DOMAIN$1,
        args: [t.type]
      });
  }
  delete t.type;
}
const ERROR_DOMAIN = "parser";
function createCodeGenerator(t, e) {
  const { sourceMap: r, filename: o, breakLineCode: a, needIndent: c } = e, u = e.location !== !1, d = {
    filename: o,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: c,
    indentLevel: 0
  };
  u && t.loc && (d.source = t.loc.source);
  const p = () => d;
  function g(T, C) {
    d.code += T;
  }
  function b(T, C = !0) {
    const $ = C ? a : "";
    g(c ? $ + "  ".repeat(T) : $);
  }
  function x(T = !0) {
    const C = ++d.indentLevel;
    T && b(C);
  }
  function w(T = !0) {
    const C = --d.indentLevel;
    T && b(C);
  }
  function y() {
    b(d.indentLevel);
  }
  return {
    context: p,
    push: g,
    indent: x,
    deindent: w,
    newline: y,
    helper: (T) => `_${T}`,
    needIndent: () => d.needIndent
  };
}
function generateLinkedNode(t, e) {
  const { helper: r } = t;
  t.push(`${r(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), generateNode(t, e.key), e.modifier ? (t.push(", "), generateNode(t, e.modifier), t.push(", _type")) : t.push(", undefined, _type"), t.push(")");
}
function generateMessageNode(t, e) {
  const { helper: r, needIndent: o } = t;
  t.push(`${r(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), t.indent(o());
  const a = e.items.length;
  for (let c = 0; c < a && (generateNode(t, e.items[c]), c !== a - 1); c++)
    t.push(", ");
  t.deindent(o()), t.push("])");
}
function generatePluralNode(t, e) {
  const { helper: r, needIndent: o } = t;
  if (e.cases.length > 1) {
    t.push(`${r(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), t.indent(o());
    const a = e.cases.length;
    for (let c = 0; c < a && (generateNode(t, e.cases[c]), c !== a - 1); c++)
      t.push(", ");
    t.deindent(o()), t.push("])");
  }
}
function generateResource(t, e) {
  e.body ? generateNode(t, e.body) : t.push("null");
}
function generateNode(t, e) {
  const { helper: r } = t;
  switch (e.type) {
    case 0:
      generateResource(t, e);
      break;
    case 1:
      generatePluralNode(t, e);
      break;
    case 2:
      generateMessageNode(t, e);
      break;
    case 6:
      generateLinkedNode(t, e);
      break;
    case 8:
      t.push(JSON.stringify(e.value), e);
      break;
    case 7:
      t.push(JSON.stringify(e.value), e);
      break;
    case 5:
      t.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "list"
        /* HelperNameMap.LIST */
      )}(${e.index}))`, e);
      break;
    case 4:
      t.push(`${r(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${r(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(e.key)}))`, e);
      break;
    case 9:
      t.push(JSON.stringify(e.value), e);
      break;
    case 3:
      t.push(JSON.stringify(e.value), e);
      break;
    default:
      throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: ERROR_DOMAIN,
        args: [e.type]
      });
  }
}
const generate = (t, e = {}) => {
  const r = isString(e.mode) ? e.mode : "normal", o = isString(e.filename) ? e.filename : "message.intl", a = !!e.sourceMap, c = e.breakLineCode != null ? e.breakLineCode : r === "arrow" ? ";" : `
`, u = e.needIndent ? e.needIndent : r !== "arrow", d = t.helpers || [], p = createCodeGenerator(t, {
    mode: r,
    filename: o,
    sourceMap: a,
    breakLineCode: c,
    needIndent: u
  });
  p.push(r === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), p.indent(u), d.length > 0 && (p.push(`const { ${join(d.map((x) => `${x}: _${x}`), ", ")} } = ctx`), p.newline()), p.push("return "), generateNode(p, t), p.deindent(u), p.push("}"), delete t.helpers;
  const { code: g, map: b } = p.context();
  return {
    ast: t,
    code: g,
    map: b ? b.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function baseCompile$1(t, e = {}) {
  const r = assign({}, e), o = !!r.jit, a = !!r.minify, c = r.optimize == null ? !0 : r.optimize, d = createParser(r).parse(t);
  return o ? (c && optimize(d), a && minify(d), { ast: d, code: "" }) : (transform(d, r), generate(d, r));
}
/*!
  * core-base v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function initFeatureFlags$1() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (getGlobalThis().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const pathStateMachine = [];
pathStateMachine[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
pathStateMachine[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
pathStateMachine[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
pathStateMachine[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(t) {
  return literalValueRE.test(t);
}
function stripQuotes(t) {
  const e = t.charCodeAt(0), r = t.charCodeAt(t.length - 1);
  return e === r && (e === 34 || e === 39) ? t.slice(1, -1) : t;
}
function getPathCharType(t) {
  if (t == null)
    return "o";
  switch (t.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return t;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function formatSubPath(t) {
  const e = t.trim();
  return t.charAt(0) === "0" && isNaN(parseInt(t)) ? !1 : isLiteral(e) ? stripQuotes(e) : "*" + e;
}
function parse(t) {
  const e = [];
  let r = -1, o = 0, a = 0, c, u, d, p, g, b, x;
  const w = [];
  w[
    0
    /* Actions.APPEND */
  ] = () => {
    u === void 0 ? u = d : u += d;
  }, w[
    1
    /* Actions.PUSH */
  ] = () => {
    u !== void 0 && (e.push(u), u = void 0);
  }, w[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    w[
      0
      /* Actions.APPEND */
    ](), a++;
  }, w[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, o = 4, w[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, u === void 0 || (u = formatSubPath(u), u === !1))
        return !1;
      w[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function y() {
    const I = t[r + 1];
    if (o === 5 && I === "'" || o === 6 && I === '"')
      return r++, d = "\\" + I, w[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (r++, c = t[r], !(c === "\\" && y())) {
      if (p = getPathCharType(c), x = pathStateMachine[o], g = x[p] || x.l || 8, g === 8 || (o = g[0], g[1] !== void 0 && (b = w[g[1]], b && (d = c, b() === !1))))
        return;
      if (o === 7)
        return e;
    }
}
const cache = /* @__PURE__ */ new Map();
function resolveWithKeyValue(t, e) {
  return isObject$1(t) ? t[e] : null;
}
function resolveValue(t, e) {
  if (!isObject$1(t))
    return null;
  let r = cache.get(e);
  if (r || (r = parse(e), r && cache.set(e, r)), !r)
    return null;
  const o = r.length;
  let a = t, c = 0;
  for (; c < o; ) {
    const u = a[r[c]];
    if (u === void 0)
      return null;
    a = u, c++;
  }
  return a;
}
const DEFAULT_MODIFIER = (t) => t, DEFAULT_MESSAGE = (t) => "", DEFAULT_MESSAGE_DATA_TYPE = "text", DEFAULT_NORMALIZE = (t) => t.length === 0 ? "" : join$1(t), DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(t, e) {
  return t = Math.abs(t), e === 2 ? t ? t > 1 ? 1 : 0 : 1 : t ? Math.min(t, 2) : 0;
}
function getPluralIndex(t) {
  const e = isNumber(t.pluralIndex) ? t.pluralIndex : -1;
  return t.named && (isNumber(t.named.count) || isNumber(t.named.n)) ? isNumber(t.named.count) ? t.named.count : isNumber(t.named.n) ? t.named.n : e : e;
}
function normalizeNamed(t, e) {
  e.count || (e.count = t), e.n || (e.n = t);
}
function createMessageContext(t = {}) {
  const e = t.locale, r = getPluralIndex(t), o = isObject$1(t.pluralRules) && isString$1(e) && isFunction(t.pluralRules[e]) ? t.pluralRules[e] : pluralDefault, a = isObject$1(t.pluralRules) && isString$1(e) && isFunction(t.pluralRules[e]) ? pluralDefault : void 0, c = (C) => C[o(r, C.length, a)], u = t.list || [], d = (C) => u[C], p = t.named || {};
  isNumber(t.pluralIndex) && normalizeNamed(r, p);
  const g = (C) => p[C];
  function b(C) {
    const $ = isFunction(t.messages) ? t.messages(C) : isObject$1(t.messages) ? t.messages[C] : !1;
    return $ || (t.parent ? t.parent.message(C) : DEFAULT_MESSAGE);
  }
  const x = (C) => t.modifiers ? t.modifiers[C] : DEFAULT_MODIFIER, w = isPlainObject(t.processor) && isFunction(t.processor.normalize) ? t.processor.normalize : DEFAULT_NORMALIZE, y = isPlainObject(t.processor) && isFunction(t.processor.interpolate) ? t.processor.interpolate : DEFAULT_INTERPOLATE, I = isPlainObject(t.processor) && isString$1(t.processor.type) ? t.processor.type : DEFAULT_MESSAGE_DATA_TYPE, T = {
    list: d,
    named: g,
    plural: c,
    linked: (C, ...$) => {
      const [D, L] = $;
      let R = "text", O = "";
      $.length === 1 ? isObject$1(D) ? (O = D.modifier || O, R = D.type || R) : isString$1(D) && (O = D || O) : $.length === 2 && (isString$1(D) && (O = D || O), isString$1(L) && (R = L || R));
      const P = b(C)(T), z = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        R === "vnode" && isArray(P) && O ? P[0] : P
      );
      return O ? x(O)(z, R) : z;
    },
    message: b,
    type: I,
    interpolate: y,
    normalize: w,
    values: assign$1({}, u, p)
  };
  return T;
}
let devtools = null;
function setDevToolsHook(t) {
  devtools = t;
}
function initI18nDevTools(t, e, r) {
  devtools && devtools.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: t,
    version: e,
    meta: r
  });
}
const translateDevTools = /* @__PURE__ */ createDevToolsHook(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function createDevToolsHook(t) {
  return (e) => devtools && devtools.emit(t, e);
}
const CoreWarnCodes = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, warnMessages$1 = {
  [CoreWarnCodes.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [CoreWarnCodes.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [CoreWarnCodes.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [CoreWarnCodes.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [CoreWarnCodes.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function getWarnMessage$1(t, ...e) {
  return format$2(warnMessages$1[t], ...e);
}
function fallbackWithSimple(t, e, r) {
  return [.../* @__PURE__ */ new Set([
    r,
    ...isArray(e) ? e : isObject$1(e) ? Object.keys(e) : isString$1(e) ? [e] : [r]
  ])];
}
function fallbackWithLocaleChain(t, e, r) {
  const o = isString$1(r) ? r : DEFAULT_LOCALE, a = t;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let c = a.__localeChainCache.get(o);
  if (!c) {
    c = [];
    let u = [r];
    for (; isArray(u); )
      u = appendBlockToChain(c, u, e);
    const d = isArray(e) || !isPlainObject(e) ? e : e.default ? e.default : null;
    u = isString$1(d) ? [d] : d, isArray(u) && appendBlockToChain(c, u, !1), a.__localeChainCache.set(o, c);
  }
  return c;
}
function appendBlockToChain(t, e, r) {
  let o = !0;
  for (let a = 0; a < e.length && isBoolean(o); a++) {
    const c = e[a];
    isString$1(c) && (o = appendLocaleToChain(t, e[a], r));
  }
  return o;
}
function appendLocaleToChain(t, e, r) {
  let o;
  const a = e.split("-");
  do {
    const c = a.join("-");
    o = appendItemToChain(t, c, r), a.splice(-1, 1);
  } while (a.length && o === !0);
  return o;
}
function appendItemToChain(t, e, r) {
  let o = !1;
  if (!t.includes(e) && (o = !0, e)) {
    o = e[e.length - 1] !== "!";
    const a = e.replace(/!/g, "");
    t.push(a), (isArray(r) || isPlainObject(r)) && r[a] && (o = r[a]);
  }
  return o;
}
const VERSION$1 = "9.4.1", NOT_REOSLVED = -1, DEFAULT_LOCALE = "en-US", MISSING_RESOLVE_VALUE = "", capitalize = (t) => `${t.charAt(0).toLocaleUpperCase()}${t.substr(1)}`;
function getDefaultLinkedModifiers() {
  return {
    upper: (t, e) => e === "text" && isString$1(t) ? t.toUpperCase() : e === "vnode" && isObject$1(t) && "__v_isVNode" in t ? t.children.toUpperCase() : t,
    lower: (t, e) => e === "text" && isString$1(t) ? t.toLowerCase() : e === "vnode" && isObject$1(t) && "__v_isVNode" in t ? t.children.toLowerCase() : t,
    capitalize: (t, e) => e === "text" && isString$1(t) ? capitalize(t) : e === "vnode" && isObject$1(t) && "__v_isVNode" in t ? capitalize(t.children) : t
  };
}
let _compiler;
function registerMessageCompiler(t) {
  _compiler = t;
}
let _resolver;
function registerMessageResolver(t) {
  _resolver = t;
}
let _fallbacker;
function registerLocaleFallbacker(t) {
  _fallbacker = t;
}
let _additionalMeta = null;
const setAdditionalMeta = (t) => {
  _additionalMeta = t;
}, getAdditionalMeta = () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (t) => {
  _fallbackContext = t;
}, getFallbackContext = () => _fallbackContext;
let _cid = 0;
function createCoreContext(t = {}) {
  const e = isFunction(t.onWarn) ? t.onWarn : warn, r = isString$1(t.version) ? t.version : VERSION$1, o = isString$1(t.locale) ? t.locale : DEFAULT_LOCALE, a = isArray(t.fallbackLocale) || isPlainObject(t.fallbackLocale) || isString$1(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : o, c = isPlainObject(t.messages) ? t.messages : { [o]: {} }, u = isPlainObject(t.datetimeFormats) ? t.datetimeFormats : { [o]: {} }, d = isPlainObject(t.numberFormats) ? t.numberFormats : { [o]: {} }, p = assign$1({}, t.modifiers || {}, getDefaultLinkedModifiers()), g = t.pluralRules || {}, b = isFunction(t.missing) ? t.missing : null, x = isBoolean(t.missingWarn) || isRegExp(t.missingWarn) ? t.missingWarn : !0, w = isBoolean(t.fallbackWarn) || isRegExp(t.fallbackWarn) ? t.fallbackWarn : !0, y = !!t.fallbackFormat, I = !!t.unresolving, E = isFunction(t.postTranslation) ? t.postTranslation : null, T = isPlainObject(t.processor) ? t.processor : null, C = isBoolean(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, $ = !!t.escapeParameter, D = isFunction(t.messageCompiler) ? t.messageCompiler : _compiler;
  process.env.NODE_ENV !== "production" && isFunction(t.messageCompiler) && warnOnce(getWarnMessage$1(CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const L = isFunction(t.messageResolver) ? t.messageResolver : _resolver || resolveWithKeyValue, R = isFunction(t.localeFallbacker) ? t.localeFallbacker : _fallbacker || fallbackWithSimple, O = isObject$1(t.fallbackContext) ? t.fallbackContext : void 0, P = t, z = isObject$1(P.__datetimeFormatters) ? P.__datetimeFormatters : /* @__PURE__ */ new Map(), W = isObject$1(P.__numberFormatters) ? P.__numberFormatters : /* @__PURE__ */ new Map(), A = isObject$1(P.__meta) ? P.__meta : {};
  _cid++;
  const S = {
    version: r,
    cid: _cid,
    locale: o,
    fallbackLocale: a,
    messages: c,
    modifiers: p,
    pluralRules: g,
    missing: b,
    missingWarn: x,
    fallbackWarn: w,
    fallbackFormat: y,
    unresolving: I,
    postTranslation: E,
    processor: T,
    warnHtmlMessage: C,
    escapeParameter: $,
    messageCompiler: D,
    messageResolver: L,
    localeFallbacker: R,
    fallbackContext: O,
    onWarn: e,
    __meta: A
  };
  return S.datetimeFormats = u, S.numberFormats = d, S.__datetimeFormatters = z, S.__numberFormatters = W, process.env.NODE_ENV !== "production" && (S.__v_emitter = P.__v_emitter != null ? P.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && initI18nDevTools(S, r, A), S;
}
function isTranslateFallbackWarn(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function isTranslateMissingWarn(t, e) {
  return t instanceof RegExp ? t.test(e) : t;
}
function handleMissing(t, e, r, o, a) {
  const { missing: c, onWarn: u } = t;
  if (process.env.NODE_ENV !== "production") {
    const d = t.__v_emitter;
    d && d.emit("missing", {
      locale: r,
      key: e,
      type: a,
      groupId: `${a}:${e}`
    });
  }
  if (c !== null) {
    const d = c(t, r, e, a);
    return isString$1(d) ? d : e;
  } else
    return process.env.NODE_ENV !== "production" && isTranslateMissingWarn(o, e) && u(getWarnMessage$1(CoreWarnCodes.NOT_FOUND_KEY, { key: e, locale: r })), e;
}
function updateFallbackLocale(t, e, r) {
  const o = t;
  o.__localeChainCache = /* @__PURE__ */ new Map(), t.localeFallbacker(t, r, e);
}
function format(t) {
  return (r) => formatParts(r, t);
}
function formatParts(t, e) {
  const r = e.b || e.body;
  if ((r.t || r.type) === 1) {
    const o = r, a = o.c || o.cases;
    return t.plural(a.reduce((c, u) => [
      ...c,
      formatMessageParts(t, u)
    ], []));
  } else
    return formatMessageParts(t, r);
}
function formatMessageParts(t, e) {
  const r = e.s || e.static;
  if (r)
    return t.type === "text" ? r : t.normalize([r]);
  {
    const o = (e.i || e.items).reduce((a, c) => [...a, formatMessagePart(t, c)], []);
    return t.normalize(o);
  }
}
function formatMessagePart(t, e) {
  const r = e.t || e.type;
  switch (r) {
    case 3:
      const o = e;
      return o.v || o.value;
    case 9:
      const a = e;
      return a.v || a.value;
    case 4:
      const c = e;
      return t.interpolate(t.named(c.k || c.key));
    case 5:
      const u = e;
      return t.interpolate(t.list(u.i || u.index));
    case 6:
      const d = e, p = d.m || d.modifier;
      return t.linked(formatMessagePart(t, d.k || d.key), p ? formatMessagePart(t, p) : void 0, t.type);
    case 7:
      const g = e;
      return g.v || g.value;
    case 8:
      const b = e;
      return b.v || b.value;
    default:
      throw new Error(`unhandled node type on format message part: ${r}`);
  }
}
const code$2 = CompileErrorCodes.__EXTEND_POINT__, inc$2 = incrementer(code$2), CoreErrorCodes = {
  INVALID_ARGUMENT: code$2,
  INVALID_DATE_ARGUMENT: inc$2(),
  INVALID_ISO_DATE_ARGUMENT: inc$2(),
  NOT_SUPPORT_NON_STRING_MESSAGE: inc$2(),
  __EXTEND_POINT__: inc$2()
  // 22
};
function createCoreError(t) {
  return createCompileError(t, null, process.env.NODE_ENV !== "production" ? { messages: errorMessages$1 } : void 0);
}
const errorMessages$1 = {
  [CoreErrorCodes.INVALID_ARGUMENT]: "Invalid arguments",
  [CoreErrorCodes.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message"
}, WARN_MESSAGE = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function checkHtmlMessage(t, e) {
  e && detectHtmlTag(t) && warn(format$2(WARN_MESSAGE, { source: t }));
}
const defaultOnCacheKey = (t) => t;
let compileCache = /* @__PURE__ */ Object.create(null);
const isMessageAST = (t) => isObject$1(t) && (t.t === 0 || t.type === 0) && ("b" in t || "body" in t);
function baseCompile(t, e = {}) {
  let r = !1;
  const o = e.onError || defaultOnError;
  return e.onError = (a) => {
    r = !0, o(a);
  }, { ...baseCompile$1(t, e), detectError: r };
}
const compileToFunction = (t, e) => {
  if (!isString$1(t))
    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const r = isBoolean(e.warnHtmlMessage) ? e.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && checkHtmlMessage(t, r);
    const a = (e.onCacheKey || defaultOnCacheKey)(t), c = compileCache[a];
    if (c)
      return c;
    const { code: u, detectError: d } = baseCompile(t, e), p = new Function(`return ${u}`)();
    return d ? p : compileCache[a] = p;
  }
};
function compile(t, e) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && isString$1(t)) {
    const r = isBoolean(e.warnHtmlMessage) ? e.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && checkHtmlMessage(t, r);
    const a = (e.onCacheKey || defaultOnCacheKey)(t), c = compileCache[a];
    if (c)
      return c;
    const { ast: u, detectError: d } = baseCompile(t, {
      ...e,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), p = format(u);
    return d ? p : compileCache[a] = p;
  } else {
    if (process.env.NODE_ENV !== "production" && !isMessageAST(t))
      return warn(`the message that is resolve with key '${e.key}' is not supported for jit compilation`), () => t;
    const r = t.cacheKey;
    if (r) {
      const o = compileCache[r];
      return o || (compileCache[r] = format(t));
    } else
      return format(t);
  }
}
const NOOP_MESSAGE_FUNCTION = () => "", isMessageFunction = (t) => isFunction(t);
function translate$1(t, ...e) {
  const { fallbackFormat: r, postTranslation: o, unresolving: a, messageCompiler: c, fallbackLocale: u, messages: d } = t, [p, g] = parseTranslateArgs(...e), b = isBoolean(g.missingWarn) ? g.missingWarn : t.missingWarn, x = isBoolean(g.fallbackWarn) ? g.fallbackWarn : t.fallbackWarn, w = isBoolean(g.escapeParameter) ? g.escapeParameter : t.escapeParameter, y = !!g.resolvedMessage, I = isString$1(g.default) || isBoolean(g.default) ? isBoolean(g.default) ? c ? p : () => p : g.default : r ? c ? p : () => p : "", E = r || I !== "", T = isString$1(g.locale) ? g.locale : t.locale;
  w && escapeParams(g);
  let [C, $, D] = y ? [
    p,
    T,
    d[T] || {}
  ] : resolveMessageFormat(t, p, T, u, x, b), L = C, R = p;
  if (!y && !(isString$1(L) || isMessageAST(L) || isMessageFunction(L)) && E && (L = I, R = L), !y && (!(isString$1(L) || isMessageAST(L) || isMessageFunction(L)) || !isString$1($)))
    return a ? NOT_REOSLVED : p;
  if (process.env.NODE_ENV !== "production" && isString$1(L) && t.messageCompiler == null)
    return warn(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${p}'.`), p;
  let O = !1;
  const P = () => {
    O = !0;
  }, z = isMessageFunction(L) ? L : compileMessageFormat(t, p, $, L, R, P);
  if (O)
    return L;
  const W = getMessageContextOptions(t, $, D, g), A = createMessageContext(W), S = evaluateMessage(t, z, A), F = o ? o(S, p) : S;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const U = {
      timestamp: Date.now(),
      key: isString$1(p) ? p : isMessageFunction(L) ? L.key : "",
      locale: $ || (isMessageFunction(L) ? L.locale : ""),
      format: isString$1(L) ? L : isMessageFunction(L) ? L.source : "",
      message: F
    };
    U.meta = assign$1({}, t.__meta, getAdditionalMeta() || {}), translateDevTools(U);
  }
  return F;
}
function escapeParams(t) {
  isArray(t.list) ? t.list = t.list.map((e) => isString$1(e) ? escapeHtml(e) : e) : isObject$1(t.named) && Object.keys(t.named).forEach((e) => {
    isString$1(t.named[e]) && (t.named[e] = escapeHtml(t.named[e]));
  });
}
function resolveMessageFormat(t, e, r, o, a, c) {
  const { messages: u, onWarn: d, messageResolver: p, localeFallbacker: g } = t, b = g(t, o, r);
  let x = {}, w, y = null, I = r, E = null;
  const T = "translate";
  for (let C = 0; C < b.length; C++) {
    if (w = E = b[C], process.env.NODE_ENV !== "production" && r !== w && isTranslateFallbackWarn(a, e) && d(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_TRANSLATE, {
      key: e,
      target: w
    })), process.env.NODE_ENV !== "production" && r !== w) {
      const O = t.__v_emitter;
      O && O.emit("fallback", {
        type: T,
        key: e,
        from: I,
        to: E,
        groupId: `${T}:${e}`
      });
    }
    x = u[w] || {};
    let $ = null, D, L;
    if (process.env.NODE_ENV !== "production" && inBrowser && ($ = window.performance.now(), D = "intlify-message-resolve-start", L = "intlify-message-resolve-end", mark && mark(D)), (y = p(x, e)) === null && (y = x[e]), process.env.NODE_ENV !== "production" && inBrowser) {
      const O = window.performance.now(), P = t.__v_emitter;
      P && $ && y && P.emit("message-resolve", {
        type: "message-resolve",
        key: e,
        message: y,
        time: O - $,
        groupId: `${T}:${e}`
      }), D && L && mark && measure && (mark(L), measure("intlify message resolve", D, L));
    }
    if (isString$1(y) || isMessageAST(y) || isMessageFunction(y))
      break;
    const R = handleMissing(
      t,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      e,
      w,
      c,
      T
    );
    R !== e && (y = R), I = E;
  }
  return [y, w, x];
}
function compileMessageFormat(t, e, r, o, a, c) {
  const { messageCompiler: u, warnHtmlMessage: d } = t;
  if (isMessageFunction(o)) {
    const w = o;
    return w.locale = w.locale || r, w.key = w.key || e, w;
  }
  if (u == null) {
    const w = () => o;
    return w.locale = r, w.key = e, w;
  }
  let p = null, g, b;
  process.env.NODE_ENV !== "production" && inBrowser && (p = window.performance.now(), g = "intlify-message-compilation-start", b = "intlify-message-compilation-end", mark && mark(g));
  const x = u(o, getCompileContext(t, r, a, o, d, c));
  if (process.env.NODE_ENV !== "production" && inBrowser) {
    const w = window.performance.now(), y = t.__v_emitter;
    y && p && y.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: w - p,
      groupId: `translate:${e}`
    }), g && b && mark && measure && (mark(b), measure("intlify message compilation", g, b));
  }
  return x.locale = r, x.key = e, x.source = o, x;
}
function evaluateMessage(t, e, r) {
  let o = null, a, c;
  process.env.NODE_ENV !== "production" && inBrowser && (o = window.performance.now(), a = "intlify-message-evaluation-start", c = "intlify-message-evaluation-end", mark && mark(a));
  const u = e(r);
  if (process.env.NODE_ENV !== "production" && inBrowser) {
    const d = window.performance.now(), p = t.__v_emitter;
    p && o && p.emit("message-evaluation", {
      type: "message-evaluation",
      value: u,
      time: d - o,
      groupId: `translate:${e.key}`
    }), a && c && mark && measure && (mark(c), measure("intlify message evaluation", a, c));
  }
  return u;
}
function parseTranslateArgs(...t) {
  const [e, r, o] = t, a = {};
  if (!isString$1(e) && !isNumber(e) && !isMessageFunction(e) && !isMessageAST(e))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const c = isNumber(e) ? String(e) : (isMessageFunction(e), e);
  return isNumber(r) ? a.plural = r : isString$1(r) ? a.default = r : isPlainObject(r) && !isEmptyObject(r) ? a.named = r : isArray(r) && (a.list = r), isNumber(o) ? a.plural = o : isString$1(o) ? a.default = o : isPlainObject(o) && assign$1(a, o), [c, a];
}
function getCompileContext(t, e, r, o, a, c) {
  return {
    locale: e,
    key: r,
    warnHtmlMessage: a,
    onError: (u) => {
      if (c && c(u), process.env.NODE_ENV !== "production") {
        const d = getSourceForCodeFrame(o), p = `Message compilation error: ${u.message}`, g = u.location && d && generateCodeFrame(d, u.location.start.offset, u.location.end.offset), b = t.__v_emitter;
        b && d && b.emit("compile-error", {
          message: d,
          error: u.message,
          start: u.location && u.location.start.offset,
          end: u.location && u.location.end.offset,
          groupId: `translate:${r}`
        }), console.error(g ? `${p}
${g}` : p);
      } else
        throw u;
    },
    onCacheKey: (u) => generateFormatCacheKey(e, r, u)
  };
}
function getSourceForCodeFrame(t) {
  var e;
  if (!isString$1(t)) {
    if ((e = t.loc) != null && e.source)
      return t.loc.source;
  }
}
function getMessageContextOptions(t, e, r, o) {
  const { modifiers: a, pluralRules: c, messageResolver: u, fallbackLocale: d, fallbackWarn: p, missingWarn: g, fallbackContext: b } = t, w = {
    locale: e,
    modifiers: a,
    pluralRules: c,
    messages: (y) => {
      let I = u(r, y);
      if (I == null && b) {
        const [, , E] = resolveMessageFormat(b, y, e, d, p, g);
        I = u(E, y);
      }
      if (isString$1(I) || isMessageAST(I)) {
        let E = !1;
        const C = compileMessageFormat(t, y, e, I, y, () => {
          E = !0;
        });
        return E ? NOOP_MESSAGE_FUNCTION : C;
      } else
        return isMessageFunction(I) ? I : NOOP_MESSAGE_FUNCTION;
    }
  };
  return t.processor && (w.processor = t.processor), o.list && (w.list = o.list), o.named && (w.named = o.named), isNumber(o.plural) && (w.pluralIndex = o.plural), w;
}
const intlDefined = typeof Intl < "u", Availabilities = {
  dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat < "u",
  numberFormat: intlDefined && typeof Intl.NumberFormat < "u"
};
function datetime(t, ...e) {
  const { datetimeFormats: r, unresolving: o, fallbackLocale: a, onWarn: c, localeFallbacker: u } = t, { __datetimeFormatters: d } = t;
  if (process.env.NODE_ENV !== "production" && !Availabilities.dateTimeFormat)
    return c(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_DATE)), MISSING_RESOLVE_VALUE;
  const [p, g, b, x] = parseDateTimeArgs(...e), w = isBoolean(b.missingWarn) ? b.missingWarn : t.missingWarn, y = isBoolean(b.fallbackWarn) ? b.fallbackWarn : t.fallbackWarn, I = !!b.part, E = isString$1(b.locale) ? b.locale : t.locale, T = u(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    E
  );
  if (!isString$1(p) || p === "")
    return new Intl.DateTimeFormat(E, x).format(g);
  let C = {}, $, D = null, L = E, R = null;
  const O = "datetime format";
  for (let W = 0; W < T.length; W++) {
    if ($ = R = T[W], process.env.NODE_ENV !== "production" && E !== $ && isTranslateFallbackWarn(y, p) && c(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_DATE_FORMAT, {
      key: p,
      target: $
    })), process.env.NODE_ENV !== "production" && E !== $) {
      const A = t.__v_emitter;
      A && A.emit("fallback", {
        type: O,
        key: p,
        from: L,
        to: R,
        groupId: `${O}:${p}`
      });
    }
    if (C = r[$] || {}, D = C[p], isPlainObject(D))
      break;
    handleMissing(t, p, $, w, O), L = R;
  }
  if (!isPlainObject(D) || !isString$1($))
    return o ? NOT_REOSLVED : p;
  let P = `${$}__${p}`;
  isEmptyObject(x) || (P = `${P}__${JSON.stringify(x)}`);
  let z = d.get(P);
  return z || (z = new Intl.DateTimeFormat($, assign$1({}, D, x)), d.set(P, z)), I ? z.formatToParts(g) : z.format(g);
}
const DATETIME_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function parseDateTimeArgs(...t) {
  const [e, r, o, a] = t, c = {};
  let u = {}, d;
  if (isString$1(e)) {
    const p = e.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!p)
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    const g = p[3] ? p[3].trim().startsWith("T") ? `${p[1].trim()}${p[3].trim()}` : `${p[1].trim()}T${p[3].trim()}` : p[1].trim();
    d = new Date(g);
    try {
      d.toISOString();
    } catch {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (isDate(e)) {
    if (isNaN(e.getTime()))
      throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
    d = e;
  } else if (isNumber(e))
    d = e;
  else
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  return isString$1(r) ? c.key = r : isPlainObject(r) && Object.keys(r).forEach((p) => {
    DATETIME_FORMAT_OPTIONS_KEYS.includes(p) ? u[p] = r[p] : c[p] = r[p];
  }), isString$1(o) ? c.locale = o : isPlainObject(o) && (u = o), isPlainObject(a) && (u = a), [c.key || "", d, c, u];
}
function clearDateTimeFormat(t, e, r) {
  const o = t;
  for (const a in r) {
    const c = `${e}__${a}`;
    o.__datetimeFormatters.has(c) && o.__datetimeFormatters.delete(c);
  }
}
function number(t, ...e) {
  const { numberFormats: r, unresolving: o, fallbackLocale: a, onWarn: c, localeFallbacker: u } = t, { __numberFormatters: d } = t;
  if (process.env.NODE_ENV !== "production" && !Availabilities.numberFormat)
    return c(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_NUMBER)), MISSING_RESOLVE_VALUE;
  const [p, g, b, x] = parseNumberArgs(...e), w = isBoolean(b.missingWarn) ? b.missingWarn : t.missingWarn, y = isBoolean(b.fallbackWarn) ? b.fallbackWarn : t.fallbackWarn, I = !!b.part, E = isString$1(b.locale) ? b.locale : t.locale, T = u(
    t,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    E
  );
  if (!isString$1(p) || p === "")
    return new Intl.NumberFormat(E, x).format(g);
  let C = {}, $, D = null, L = E, R = null;
  const O = "number format";
  for (let W = 0; W < T.length; W++) {
    if ($ = R = T[W], process.env.NODE_ENV !== "production" && E !== $ && isTranslateFallbackWarn(y, p) && c(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT, {
      key: p,
      target: $
    })), process.env.NODE_ENV !== "production" && E !== $) {
      const A = t.__v_emitter;
      A && A.emit("fallback", {
        type: O,
        key: p,
        from: L,
        to: R,
        groupId: `${O}:${p}`
      });
    }
    if (C = r[$] || {}, D = C[p], isPlainObject(D))
      break;
    handleMissing(t, p, $, w, O), L = R;
  }
  if (!isPlainObject(D) || !isString$1($))
    return o ? NOT_REOSLVED : p;
  let P = `${$}__${p}`;
  isEmptyObject(x) || (P = `${P}__${JSON.stringify(x)}`);
  let z = d.get(P);
  return z || (z = new Intl.NumberFormat($, assign$1({}, D, x)), d.set(P, z)), I ? z.formatToParts(g) : z.format(g);
}
const NUMBER_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function parseNumberArgs(...t) {
  const [e, r, o, a] = t, c = {};
  let u = {};
  if (!isNumber(e))
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  const d = e;
  return isString$1(r) ? c.key = r : isPlainObject(r) && Object.keys(r).forEach((p) => {
    NUMBER_FORMAT_OPTIONS_KEYS.includes(p) ? u[p] = r[p] : c[p] = r[p];
  }), isString$1(o) ? c.locale = o : isPlainObject(o) && (u = o), isPlainObject(a) && (u = a), [c.key || "", d, c, u];
}
function clearNumberFormat(t, e, r) {
  const o = t;
  for (const a in r) {
    const c = `${e}__${a}`;
    o.__numberFormatters.has(c) && o.__numberFormatters.delete(c);
  }
}
initFeatureFlags$1();
/*!
  * vue-i18n v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const VERSION = "9.4.1";
function initFeatureFlags() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (getGlobalThis().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (getGlobalThis().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (getGlobalThis().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const code$1 = CoreWarnCodes.__EXTEND_POINT__, inc$1 = incrementer(code$1), I18nWarnCodes = {
  FALLBACK_TO_ROOT: code$1,
  NOT_SUPPORTED_PRESERVE: inc$1(),
  NOT_SUPPORTED_FORMATTER: inc$1(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: inc$1(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: inc$1(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: inc$1(),
  NOT_FOUND_PARENT_SCOPE: inc$1(),
  IGNORE_OBJ_FLATTEN: inc$1(),
  NOTICE_DROP_ALLOW_COMPOSITION: inc$1()
  // 17
}, warnMessages = {
  [I18nWarnCodes.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [I18nWarnCodes.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function getWarnMessage(t, ...e) {
  return format$2(warnMessages[t], ...e);
}
const code = CoreErrorCodes.__EXTEND_POINT__, inc = incrementer(code), I18nErrorCodes = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: code,
  // legacy module errors
  INVALID_ARGUMENT: inc(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: inc(),
  NOT_INSTALLED: inc(),
  NOT_AVAILABLE_IN_LEGACY_MODE: inc(),
  // directive module errors
  REQUIRED_VALUE: inc(),
  INVALID_VALUE: inc(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: inc(),
  NOT_INSTALLED_WITH_PROVIDE: inc(),
  // unexpected error
  UNEXPECTED_ERROR: inc(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: inc(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: inc(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: inc(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: inc(),
  // for enhancement
  __EXTEND_POINT__: inc()
  // 37
};
function createI18nError(t, ...e) {
  return createCompileError(t, null, process.env.NODE_ENV !== "production" ? { messages: errorMessages, args: e } : void 0);
}
const errorMessages = {
  [I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
  [I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [I18nErrorCodes.NOT_INSTALLED]: "Need to install with `app.use` function",
  [I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
  [I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [I18nErrorCodes.REQUIRED_VALUE]: "Required in value: {0}",
  [I18nErrorCodes.INVALID_VALUE]: "Invalid value",
  [I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, TranslateVNodeSymbol = /* @__PURE__ */ makeSymbol("__translateVNode"), DatetimePartsSymbol = /* @__PURE__ */ makeSymbol("__datetimeParts"), NumberPartsSymbol = /* @__PURE__ */ makeSymbol("__numberParts"), EnableEmitter = /* @__PURE__ */ makeSymbol("__enableEmitter"), DisableEmitter = /* @__PURE__ */ makeSymbol("__disableEmitter"), SetPluralRulesSymbol = makeSymbol("__setPluralRules"), InejctWithOptionSymbol = /* @__PURE__ */ makeSymbol("__injectWithOption"), DisposeSymbol = /* @__PURE__ */ makeSymbol("__dispose");
function handleFlatJson(t) {
  if (!isObject$1(t))
    return t;
  for (const e in t)
    if (hasOwn(t, e))
      if (!e.includes("."))
        isObject$1(t[e]) && handleFlatJson(t[e]);
      else {
        const r = e.split("."), o = r.length - 1;
        let a = t, c = !1;
        for (let u = 0; u < o; u++) {
          if (r[u] in a || (a[r[u]] = {}), !isObject$1(a[r[u]])) {
            process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.IGNORE_OBJ_FLATTEN, {
              key: r[u]
            })), c = !0;
            break;
          }
          a = a[r[u]];
        }
        c || (a[r[o]] = t[e], delete t[e]), isObject$1(a[r[o]]) && handleFlatJson(a[r[o]]);
      }
  return t;
}
function getLocaleMessages(t, e) {
  const { messages: r, __i18n: o, messageResolver: a, flatJson: c } = e, u = isPlainObject(r) ? r : isArray(o) ? {} : { [t]: {} };
  if (isArray(o) && o.forEach((d) => {
    if ("locale" in d && "resource" in d) {
      const { locale: p, resource: g } = d;
      p ? (u[p] = u[p] || {}, deepCopy(g, u[p])) : deepCopy(g, u);
    } else
      isString$1(d) && deepCopy(JSON.parse(d), u);
  }), a == null && c)
    for (const d in u)
      hasOwn(u, d) && handleFlatJson(u[d]);
  return u;
}
const isNotObjectOrIsArray = (t) => !isObject$1(t) || isArray(t);
function deepCopy(t, e) {
  if (isNotObjectOrIsArray(t) || isNotObjectOrIsArray(e))
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
  for (const r in t)
    hasOwn(t, r) && (isNotObjectOrIsArray(t[r]) || isNotObjectOrIsArray(e[r]) ? e[r] = t[r] : deepCopy(t[r], e[r]));
}
function getComponentOptions(t) {
  return t.type;
}
function adjustI18nResources(t, e, r) {
  let o = isObject$1(e.messages) ? e.messages : {};
  "__i18nGlobal" in r && (o = getLocaleMessages(t.locale.value, {
    messages: o,
    __i18n: r.__i18nGlobal
  }));
  const a = Object.keys(o);
  a.length && a.forEach((c) => {
    t.mergeLocaleMessage(c, o[c]);
  });
  {
    if (isObject$1(e.datetimeFormats)) {
      const c = Object.keys(e.datetimeFormats);
      c.length && c.forEach((u) => {
        t.mergeDateTimeFormat(u, e.datetimeFormats[u]);
      });
    }
    if (isObject$1(e.numberFormats)) {
      const c = Object.keys(e.numberFormats);
      c.length && c.forEach((u) => {
        t.mergeNumberFormat(u, e.numberFormats[u]);
      });
    }
  }
}
function createTextNode(t) {
  return createVNode(Text, null, t, 0);
}
const DEVTOOLS_META = "__INTLIFY_META__";
let composerID = 0;
function defineCoreMissingHandler(t) {
  return (e, r, o, a) => t(r, o, getCurrentInstance() || void 0, a);
}
const getMetaInfo = () => {
  const t = getCurrentInstance();
  let e = null;
  return t && (e = getComponentOptions(t)[DEVTOOLS_META]) ? { [DEVTOOLS_META]: e } : null;
};
function createComposer(t = {}, e) {
  const { __root: r, __injectWithOption: o } = t, a = r === void 0;
  let c = isBoolean(t.inheritLocale) ? t.inheritLocale : !0;
  const u = ref(
    // prettier-ignore
    r && c ? r.locale.value : isString$1(t.locale) ? t.locale : DEFAULT_LOCALE
  ), d = ref(
    // prettier-ignore
    r && c ? r.fallbackLocale.value : isString$1(t.fallbackLocale) || isArray(t.fallbackLocale) || isPlainObject(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : u.value
  ), p = ref(getLocaleMessages(u.value, t)), g = ref(isPlainObject(t.datetimeFormats) ? t.datetimeFormats : { [u.value]: {} }), b = ref(isPlainObject(t.numberFormats) ? t.numberFormats : { [u.value]: {} });
  let x = r ? r.missingWarn : isBoolean(t.missingWarn) || isRegExp(t.missingWarn) ? t.missingWarn : !0, w = r ? r.fallbackWarn : isBoolean(t.fallbackWarn) || isRegExp(t.fallbackWarn) ? t.fallbackWarn : !0, y = r ? r.fallbackRoot : isBoolean(t.fallbackRoot) ? t.fallbackRoot : !0, I = !!t.fallbackFormat, E = isFunction(t.missing) ? t.missing : null, T = isFunction(t.missing) ? defineCoreMissingHandler(t.missing) : null, C = isFunction(t.postTranslation) ? t.postTranslation : null, $ = r ? r.warnHtmlMessage : isBoolean(t.warnHtmlMessage) ? t.warnHtmlMessage : !0, D = !!t.escapeParameter;
  const L = r ? r.modifiers : isPlainObject(t.modifiers) ? t.modifiers : {};
  let R = t.pluralRules || r && r.pluralRules, O;
  O = (() => {
    a && setFallbackContext(null);
    const ie = {
      version: VERSION,
      locale: u.value,
      fallbackLocale: d.value,
      messages: p.value,
      modifiers: L,
      pluralRules: R,
      missing: T === null ? void 0 : T,
      missingWarn: x,
      fallbackWarn: w,
      fallbackFormat: I,
      unresolving: !0,
      postTranslation: C === null ? void 0 : C,
      warnHtmlMessage: $,
      escapeParameter: D,
      messageResolver: t.messageResolver,
      messageCompiler: t.messageCompiler,
      __meta: { framework: "vue" }
    };
    ie.datetimeFormats = g.value, ie.numberFormats = b.value, ie.__datetimeFormatters = isPlainObject(O) ? O.__datetimeFormatters : void 0, ie.__numberFormatters = isPlainObject(O) ? O.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (ie.__v_emitter = isPlainObject(O) ? O.__v_emitter : void 0);
    const he = createCoreContext(ie);
    return a && setFallbackContext(he), he;
  })(), updateFallbackLocale(O, u.value, d.value);
  function z() {
    return [
      u.value,
      d.value,
      p.value,
      g.value,
      b.value
    ];
  }
  const W = computed({
    get: () => u.value,
    set: (ie) => {
      u.value = ie, O.locale = u.value;
    }
  }), A = computed({
    get: () => d.value,
    set: (ie) => {
      d.value = ie, O.fallbackLocale = d.value, updateFallbackLocale(O, u.value, ie);
    }
  }), S = computed(() => p.value), F = /* @__PURE__ */ computed(() => g.value), U = /* @__PURE__ */ computed(() => b.value);
  function M() {
    return isFunction(C) ? C : null;
  }
  function V(ie) {
    C = ie, O.postTranslation = ie;
  }
  function G() {
    return E;
  }
  function Q(ie) {
    ie !== null && (T = defineCoreMissingHandler(ie)), E = ie, O.missing = T;
  }
  function fe(ie, he) {
    return ie !== "translate" || !he.resolvedMessage;
  }
  const te = (ie, he, Ye, et, bt, $e) => {
    z();
    let Ee;
    try {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && setAdditionalMeta(getMetaInfo()), a || (O.fallbackContext = r ? getFallbackContext() : void 0), Ee = ie(O);
    } finally {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && setAdditionalMeta(null), a || (O.fallbackContext = void 0);
    }
    if (isNumber(Ee) && Ee === NOT_REOSLVED) {
      const [Ie, ze] = he();
      if (process.env.NODE_ENV !== "production" && r && isString$1(Ie) && fe(Ye, ze) && (y && (isTranslateFallbackWarn(w, Ie) || isTranslateMissingWarn(x, Ie)) && warn(getWarnMessage(I18nWarnCodes.FALLBACK_TO_ROOT, {
        key: Ie,
        type: Ye
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ct } = O;
        ct && y && ct.emit("fallback", {
          type: Ye,
          key: Ie,
          to: "global",
          groupId: `${Ye}:${Ie}`
        });
      }
      return r && y ? et(r) : bt(Ie);
    } else {
      if ($e(Ee))
        return Ee;
      throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
  };
  function de(...ie) {
    return te((he) => Reflect.apply(translate$1, null, [he, ...ie]), () => parseTranslateArgs(...ie), "translate", (he) => Reflect.apply(he.t, he, [...ie]), (he) => he, (he) => isString$1(he));
  }
  function me(...ie) {
    const [he, Ye, et] = ie;
    if (et && !isObject$1(et))
      throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
    return de(he, Ye, assign$1({ resolvedMessage: !0 }, et || {}));
  }
  function Me(...ie) {
    return te((he) => Reflect.apply(datetime, null, [he, ...ie]), () => parseDateTimeArgs(...ie), "datetime format", (he) => Reflect.apply(he.d, he, [...ie]), () => MISSING_RESOLVE_VALUE, (he) => isString$1(he));
  }
  function ce(...ie) {
    return te((he) => Reflect.apply(number, null, [he, ...ie]), () => parseNumberArgs(...ie), "number format", (he) => Reflect.apply(he.n, he, [...ie]), () => MISSING_RESOLVE_VALUE, (he) => isString$1(he));
  }
  function oe(ie) {
    return ie.map((he) => isString$1(he) || isNumber(he) || isBoolean(he) ? createTextNode(String(he)) : he);
  }
  const Te = {
    normalize: oe,
    interpolate: (ie) => ie,
    type: "vnode"
  };
  function Ae(...ie) {
    return te(
      (he) => {
        let Ye;
        const et = he;
        try {
          et.processor = Te, Ye = Reflect.apply(translate$1, null, [et, ...ie]);
        } finally {
          et.processor = null;
        }
        return Ye;
      },
      () => parseTranslateArgs(...ie),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (he) => he[TranslateVNodeSymbol](...ie),
      (he) => [createTextNode(he)],
      (he) => isArray(he)
    );
  }
  function je(...ie) {
    return te(
      (he) => Reflect.apply(number, null, [he, ...ie]),
      () => parseNumberArgs(...ie),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (he) => he[NumberPartsSymbol](...ie),
      () => [],
      (he) => isString$1(he) || isArray(he)
    );
  }
  function Xe(...ie) {
    return te(
      (he) => Reflect.apply(datetime, null, [he, ...ie]),
      () => parseDateTimeArgs(...ie),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (he) => he[DatetimePartsSymbol](...ie),
      () => [],
      (he) => isString$1(he) || isArray(he)
    );
  }
  function He(ie) {
    R = ie, O.pluralRules = R;
  }
  function Ke(ie, he) {
    const Ye = isString$1(he) ? he : u.value, et = q(Ye);
    return O.messageResolver(et, ie) !== null;
  }
  function ot(ie) {
    let he = null;
    const Ye = fallbackWithLocaleChain(O, d.value, u.value);
    for (let et = 0; et < Ye.length; et++) {
      const bt = p.value[Ye[et]] || {}, $e = O.messageResolver(bt, ie);
      if ($e != null) {
        he = $e;
        break;
      }
    }
    return he;
  }
  function K(ie) {
    const he = ot(ie);
    return he ?? (r ? r.tm(ie) || {} : {});
  }
  function q(ie) {
    return p.value[ie] || {};
  }
  function se(ie, he) {
    p.value[ie] = he, O.messages = p.value;
  }
  function Ce(ie, he) {
    p.value[ie] = p.value[ie] || {}, deepCopy(he, p.value[ie]), O.messages = p.value;
  }
  function Le(ie) {
    return g.value[ie] || {};
  }
  function qe(ie, he) {
    g.value[ie] = he, O.datetimeFormats = g.value, clearDateTimeFormat(O, ie, he);
  }
  function Ct(ie, he) {
    g.value[ie] = assign$1(g.value[ie] || {}, he), O.datetimeFormats = g.value, clearDateTimeFormat(O, ie, he);
  }
  function ke(ie) {
    return b.value[ie] || {};
  }
  function xe(ie, he) {
    b.value[ie] = he, O.numberFormats = b.value, clearNumberFormat(O, ie, he);
  }
  function Ne(ie, he) {
    b.value[ie] = assign$1(b.value[ie] || {}, he), O.numberFormats = b.value, clearNumberFormat(O, ie, he);
  }
  composerID++, r && inBrowser && (watch(r.locale, (ie) => {
    c && (u.value = ie, O.locale = ie, updateFallbackLocale(O, u.value, d.value));
  }), watch(r.fallbackLocale, (ie) => {
    c && (d.value = ie, O.fallbackLocale = ie, updateFallbackLocale(O, u.value, d.value));
  }));
  const Se = {
    id: composerID,
    locale: W,
    fallbackLocale: A,
    get inheritLocale() {
      return c;
    },
    set inheritLocale(ie) {
      c = ie, ie && r && (u.value = r.locale.value, d.value = r.fallbackLocale.value, updateFallbackLocale(O, u.value, d.value));
    },
    get availableLocales() {
      return Object.keys(p.value).sort();
    },
    messages: S,
    get modifiers() {
      return L;
    },
    get pluralRules() {
      return R || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return x;
    },
    set missingWarn(ie) {
      x = ie, O.missingWarn = x;
    },
    get fallbackWarn() {
      return w;
    },
    set fallbackWarn(ie) {
      w = ie, O.fallbackWarn = w;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(ie) {
      y = ie;
    },
    get fallbackFormat() {
      return I;
    },
    set fallbackFormat(ie) {
      I = ie, O.fallbackFormat = I;
    },
    get warnHtmlMessage() {
      return $;
    },
    set warnHtmlMessage(ie) {
      $ = ie, O.warnHtmlMessage = ie;
    },
    get escapeParameter() {
      return D;
    },
    set escapeParameter(ie) {
      D = ie, O.escapeParameter = ie;
    },
    t: de,
    getLocaleMessage: q,
    setLocaleMessage: se,
    mergeLocaleMessage: Ce,
    getPostTranslationHandler: M,
    setPostTranslationHandler: V,
    getMissingHandler: G,
    setMissingHandler: Q,
    [SetPluralRulesSymbol]: He
  };
  return Se.datetimeFormats = F, Se.numberFormats = U, Se.rt = me, Se.te = Ke, Se.tm = K, Se.d = Me, Se.n = ce, Se.getDateTimeFormat = Le, Se.setDateTimeFormat = qe, Se.mergeDateTimeFormat = Ct, Se.getNumberFormat = ke, Se.setNumberFormat = xe, Se.mergeNumberFormat = Ne, Se[InejctWithOptionSymbol] = o, Se[TranslateVNodeSymbol] = Ae, Se[DatetimePartsSymbol] = Xe, Se[NumberPartsSymbol] = je, process.env.NODE_ENV !== "production" && (Se[EnableEmitter] = (ie) => {
    O.__v_emitter = ie;
  }, Se[DisableEmitter] = () => {
    O.__v_emitter = void 0;
  }), Se;
}
function convertComposerOptions(t) {
  const e = isString$1(t.locale) ? t.locale : DEFAULT_LOCALE, r = isString$1(t.fallbackLocale) || isArray(t.fallbackLocale) || isPlainObject(t.fallbackLocale) || t.fallbackLocale === !1 ? t.fallbackLocale : e, o = isFunction(t.missing) ? t.missing : void 0, a = isBoolean(t.silentTranslationWarn) || isRegExp(t.silentTranslationWarn) ? !t.silentTranslationWarn : !0, c = isBoolean(t.silentFallbackWarn) || isRegExp(t.silentFallbackWarn) ? !t.silentFallbackWarn : !0, u = isBoolean(t.fallbackRoot) ? t.fallbackRoot : !0, d = !!t.formatFallbackMessages, p = isPlainObject(t.modifiers) ? t.modifiers : {}, g = t.pluralizationRules, b = isFunction(t.postTranslation) ? t.postTranslation : void 0, x = isString$1(t.warnHtmlInMessage) ? t.warnHtmlInMessage !== "off" : !0, w = !!t.escapeParameterHtml, y = isBoolean(t.sync) ? t.sync : !0;
  process.env.NODE_ENV !== "production" && t.formatter && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_FORMATTER)), process.env.NODE_ENV !== "production" && t.preserveDirectiveContent && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
  let I = t.messages;
  if (isPlainObject(t.sharedMessages)) {
    const R = t.sharedMessages;
    I = Object.keys(R).reduce((P, z) => {
      const W = P[z] || (P[z] = {});
      return assign$1(W, R[z]), P;
    }, I || {});
  }
  const { __i18n: E, __root: T, __injectWithOption: C } = t, $ = t.datetimeFormats, D = t.numberFormats, L = t.flatJson;
  return {
    locale: e,
    fallbackLocale: r,
    messages: I,
    flatJson: L,
    datetimeFormats: $,
    numberFormats: D,
    missing: o,
    missingWarn: a,
    fallbackWarn: c,
    fallbackRoot: u,
    fallbackFormat: d,
    modifiers: p,
    pluralRules: g,
    postTranslation: b,
    warnHtmlMessage: x,
    escapeParameter: w,
    messageResolver: t.messageResolver,
    inheritLocale: y,
    __i18n: E,
    __root: T,
    __injectWithOption: C
  };
}
function createVueI18n(t = {}, e) {
  {
    const r = createComposer(convertComposerOptions(t)), { __extender: o } = t, a = {
      // id
      id: r.id,
      // locale
      get locale() {
        return r.locale.value;
      },
      set locale(c) {
        r.locale.value = c;
      },
      // fallbackLocale
      get fallbackLocale() {
        return r.fallbackLocale.value;
      },
      set fallbackLocale(c) {
        r.fallbackLocale.value = c;
      },
      // messages
      get messages() {
        return r.messages.value;
      },
      // datetimeFormats
      get datetimeFormats() {
        return r.datetimeFormats.value;
      },
      // numberFormats
      get numberFormats() {
        return r.numberFormats.value;
      },
      // availableLocales
      get availableLocales() {
        return r.availableLocales;
      },
      // formatter
      get formatter() {
        return process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_FORMATTER)), {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(c) {
        process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_FORMATTER));
      },
      // missing
      get missing() {
        return r.getMissingHandler();
      },
      set missing(c) {
        r.setMissingHandler(c);
      },
      // silentTranslationWarn
      get silentTranslationWarn() {
        return isBoolean(r.missingWarn) ? !r.missingWarn : r.missingWarn;
      },
      set silentTranslationWarn(c) {
        r.missingWarn = isBoolean(c) ? !c : c;
      },
      // silentFallbackWarn
      get silentFallbackWarn() {
        return isBoolean(r.fallbackWarn) ? !r.fallbackWarn : r.fallbackWarn;
      },
      set silentFallbackWarn(c) {
        r.fallbackWarn = isBoolean(c) ? !c : c;
      },
      // modifiers
      get modifiers() {
        return r.modifiers;
      },
      // formatFallbackMessages
      get formatFallbackMessages() {
        return r.fallbackFormat;
      },
      set formatFallbackMessages(c) {
        r.fallbackFormat = c;
      },
      // postTranslation
      get postTranslation() {
        return r.getPostTranslationHandler();
      },
      set postTranslation(c) {
        r.setPostTranslationHandler(c);
      },
      // sync
      get sync() {
        return r.inheritLocale;
      },
      set sync(c) {
        r.inheritLocale = c;
      },
      // warnInHtmlMessage
      get warnHtmlInMessage() {
        return r.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(c) {
        r.warnHtmlMessage = c !== "off";
      },
      // escapeParameterHtml
      get escapeParameterHtml() {
        return r.escapeParameter;
      },
      set escapeParameterHtml(c) {
        r.escapeParameter = c;
      },
      // preserveDirectiveContent
      get preserveDirectiveContent() {
        return process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE)), !0;
      },
      set preserveDirectiveContent(c) {
        process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE));
      },
      // pluralizationRules
      get pluralizationRules() {
        return r.pluralRules || {};
      },
      // for internal
      __composer: r,
      // t
      t(...c) {
        const [u, d, p] = c, g = {};
        let b = null, x = null;
        if (!isString$1(u))
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        const w = u;
        return isString$1(d) ? g.locale = d : isArray(d) ? b = d : isPlainObject(d) && (x = d), isArray(p) ? b = p : isPlainObject(p) && (x = p), Reflect.apply(r.t, r, [
          w,
          b || x || {},
          g
        ]);
      },
      rt(...c) {
        return Reflect.apply(r.rt, r, [...c]);
      },
      // tc
      tc(...c) {
        const [u, d, p] = c, g = { plural: 1 };
        let b = null, x = null;
        if (!isString$1(u))
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        const w = u;
        return isString$1(d) ? g.locale = d : isNumber(d) ? g.plural = d : isArray(d) ? b = d : isPlainObject(d) && (x = d), isString$1(p) ? g.locale = p : isArray(p) ? b = p : isPlainObject(p) && (x = p), Reflect.apply(r.t, r, [
          w,
          b || x || {},
          g
        ]);
      },
      // te
      te(c, u) {
        return r.te(c, u);
      },
      // tm
      tm(c) {
        return r.tm(c);
      },
      // getLocaleMessage
      getLocaleMessage(c) {
        return r.getLocaleMessage(c);
      },
      // setLocaleMessage
      setLocaleMessage(c, u) {
        r.setLocaleMessage(c, u);
      },
      // mergeLocaleMessage
      mergeLocaleMessage(c, u) {
        r.mergeLocaleMessage(c, u);
      },
      // d
      d(...c) {
        return Reflect.apply(r.d, r, [...c]);
      },
      // getDateTimeFormat
      getDateTimeFormat(c) {
        return r.getDateTimeFormat(c);
      },
      // setDateTimeFormat
      setDateTimeFormat(c, u) {
        r.setDateTimeFormat(c, u);
      },
      // mergeDateTimeFormat
      mergeDateTimeFormat(c, u) {
        r.mergeDateTimeFormat(c, u);
      },
      // n
      n(...c) {
        return Reflect.apply(r.n, r, [...c]);
      },
      // getNumberFormat
      getNumberFormat(c) {
        return r.getNumberFormat(c);
      },
      // setNumberFormat
      setNumberFormat(c, u) {
        r.setNumberFormat(c, u);
      },
      // mergeNumberFormat
      mergeNumberFormat(c, u) {
        r.mergeNumberFormat(c, u);
      },
      // getChoiceIndex
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getChoiceIndex(c, u) {
        return process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX)), -1;
      }
    };
    return a.__extender = o, process.env.NODE_ENV !== "production" && (a.__enableEmitter = (c) => {
      const u = r;
      u[EnableEmitter] && u[EnableEmitter](c);
    }, a.__disableEmitter = () => {
      const c = r;
      c[DisableEmitter] && c[DisableEmitter]();
    }), a;
  }
}
const baseFormatProps = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (t) => t === "parent" || t === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function getInterpolateArg({ slots: t }, e) {
  return e.length === 1 && e[0] === "default" ? (t.default ? t.default() : []).reduce((o, a) => [
    ...o,
    // prettier-ignore
    ...a.type === Fragment ? a.children : [a]
  ], []) : e.reduce((r, o) => {
    const a = t[o];
    return a && (r[o] = a()), r;
  }, {});
}
function getFragmentableTag(t) {
  return Fragment;
}
const TranslationImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-t",
  props: assign$1({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (t) => isNumber(t) || !isNaN(t)
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const { slots: r, attrs: o } = e, a = t.i18n || useI18n({
      useScope: t.scope,
      __useComponent: !0
    });
    return () => {
      const c = Object.keys(r).filter((x) => x !== "_"), u = {};
      t.locale && (u.locale = t.locale), t.plural !== void 0 && (u.plural = isString$1(t.plural) ? +t.plural : t.plural);
      const d = getInterpolateArg(e, c), p = a[TranslateVNodeSymbol](t.keypath, d, u), g = assign$1({}, o), b = isString$1(t.tag) || isObject$1(t.tag) ? t.tag : getFragmentableTag();
      return h$1(b, g, p);
    };
  }
}), Translation = TranslationImpl;
function isVNode(t) {
  return isArray(t) && !isString$1(t[0]);
}
function renderFormatter(t, e, r, o) {
  const { slots: a, attrs: c } = e;
  return () => {
    const u = { part: !0 };
    let d = {};
    t.locale && (u.locale = t.locale), isString$1(t.format) ? u.key = t.format : isObject$1(t.format) && (isString$1(t.format.key) && (u.key = t.format.key), d = Object.keys(t.format).reduce((w, y) => r.includes(y) ? assign$1({}, w, { [y]: t.format[y] }) : w, {}));
    const p = o(t.value, u, d);
    let g = [u.key];
    isArray(p) ? g = p.map((w, y) => {
      const I = a[w.type], E = I ? I({ [w.type]: w.value, index: y, parts: p }) : [w.value];
      return isVNode(E) && (E[0].key = `${w.type}-${y}`), E;
    }) : isString$1(p) && (g = [p]);
    const b = assign$1({}, c), x = isString$1(t.tag) || isObject$1(t.tag) ? t.tag : getFragmentableTag();
    return h$1(x, b, g);
  };
}
const NumberFormatImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-n",
  props: assign$1({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const r = t.i18n || useI18n({
      useScope: "parent",
      __useComponent: !0
    });
    return renderFormatter(t, e, NUMBER_FORMAT_OPTIONS_KEYS, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[NumberPartsSymbol](...o)
    ));
  }
}), NumberFormat = NumberFormatImpl, DatetimeFormatImpl = /* @__PURE__ */ defineComponent({
  /* eslint-disable */
  name: "i18n-d",
  props: assign$1({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(t, e) {
    const r = t.i18n || useI18n({
      useScope: "parent",
      __useComponent: !0
    });
    return renderFormatter(t, e, DATETIME_FORMAT_OPTIONS_KEYS, (...o) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      r[DatetimePartsSymbol](...o)
    ));
  }
}), DatetimeFormat = DatetimeFormatImpl;
function getComposer$2(t, e) {
  const r = t;
  if (t.mode === "composition")
    return r.__getInstance(e) || t.global;
  {
    const o = r.__getInstance(e);
    return o != null ? o.__composer : t.global.__composer;
  }
}
function vTDirective(t) {
  const e = (u) => {
    const { instance: d, modifiers: p, value: g } = u;
    if (!d || !d.$)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const b = getComposer$2(t, d.$);
    process.env.NODE_ENV !== "production" && p.preserve && warn(getWarnMessage(I18nWarnCodes.NOT_SUPPORTED_PRESERVE));
    const x = parseValue(g);
    return [
      Reflect.apply(b.t, b, [...makeParams(x)]),
      b
    ];
  };
  return {
    created: (u, d) => {
      const [p, g] = e(d);
      inBrowser && t.global === g && (u.__i18nWatcher = watch(g.locale, () => {
        d.instance && d.instance.$forceUpdate();
      })), u.__composer = g, u.textContent = p;
    },
    unmounted: (u) => {
      inBrowser && u.__i18nWatcher && (u.__i18nWatcher(), u.__i18nWatcher = void 0, delete u.__i18nWatcher), u.__composer && (u.__composer = void 0, delete u.__composer);
    },
    beforeUpdate: (u, { value: d }) => {
      if (u.__composer) {
        const p = u.__composer, g = parseValue(d);
        u.textContent = Reflect.apply(p.t, p, [
          ...makeParams(g)
        ]);
      }
    },
    getSSRProps: (u) => {
      const [d] = e(u);
      return { textContent: d };
    }
  };
}
function parseValue(t) {
  if (isString$1(t))
    return { path: t };
  if (isPlainObject(t)) {
    if (!("path" in t))
      throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, "path");
    return t;
  } else
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
}
function makeParams(t) {
  const { path: e, locale: r, args: o, choice: a, plural: c } = t, u = {}, d = o || {};
  return isString$1(r) && (u.locale = r), isNumber(a) && (u.plural = a), isNumber(c) && (u.plural = c), [e, d, u];
}
function apply(t, e, ...r) {
  const o = isPlainObject(r[0]) ? r[0] : {}, a = !!o.useI18nComponentName, c = isBoolean(o.globalInstall) ? o.globalInstall : !0;
  process.env.NODE_ENV !== "production" && c && a && warn(getWarnMessage(I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: Translation.name
  })), c && ([a ? "i18n" : Translation.name, "I18nT"].forEach((u) => t.component(u, Translation)), [NumberFormat.name, "I18nN"].forEach((u) => t.component(u, NumberFormat)), [DatetimeFormat.name, "I18nD"].forEach((u) => t.component(u, DatetimeFormat))), t.directive("t", vTDirective(e));
}
const VueDevToolsLabels = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, VueDevToolsPlaceholders = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, VueDevToolsTimelineColors = {
  "vue-i18n-timeline": 16764185
}, VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let devtoolsApi;
async function enableDevTools(t, e) {
  return new Promise((r, o) => {
    try {
      setupDevtoolsPlugin({
        id: "vue-devtools-plugin-vue-i18n",
        label: VueDevToolsLabels[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [VUE_I18N_COMPONENT_TYPES],
        app: t
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (a) => {
        devtoolsApi = a, a.on.visitComponentTree(({ componentInstance: u, treeNode: d }) => {
          updateComponentTreeTags(u, d, e);
        }), a.on.inspectComponent(({ componentInstance: u, instanceData: d }) => {
          u.vnode.el && u.vnode.el.__VUE_I18N__ && d && (e.mode === "legacy" ? u.vnode.el.__VUE_I18N__ !== e.global.__composer && inspectComposer(d, u.vnode.el.__VUE_I18N__) : inspectComposer(d, u.vnode.el.__VUE_I18N__));
        }), a.addInspector({
          id: "vue-i18n-resource-inspector",
          label: VueDevToolsLabels[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: VueDevToolsPlaceholders[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), a.on.getInspectorTree((u) => {
          u.app === t && u.inspectorId === "vue-i18n-resource-inspector" && registerScope(u, e);
        });
        const c = /* @__PURE__ */ new Map();
        a.on.getInspectorState(async (u) => {
          if (u.app === t && u.inspectorId === "vue-i18n-resource-inspector")
            if (a.unhighlightElement(), inspectScope(u, e), u.nodeId === "global") {
              if (!c.has(u.app)) {
                const [d] = await a.getComponentInstances(u.app);
                c.set(u.app, d);
              }
              a.highlightElement(c.get(u.app));
            } else {
              const d = getComponentInstance(u.nodeId, e);
              d && a.highlightElement(d);
            }
        }), a.on.editInspectorState((u) => {
          u.app === t && u.inspectorId === "vue-i18n-resource-inspector" && editScope(u, e);
        }), a.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: VueDevToolsLabels[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: VueDevToolsTimelineColors[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), r(!0);
      });
    } catch (a) {
      console.error(a), o(!1);
    }
  });
}
function getI18nScopeLable(t) {
  return t.type.name || t.type.displayName || t.type.__file || "Anonymous";
}
function updateComponentTreeTags(t, e, r) {
  const o = r.mode === "composition" ? r.global : r.global.__composer;
  if (t && t.vnode.el && t.vnode.el.__VUE_I18N__ && t.vnode.el.__VUE_I18N__ !== o) {
    const a = {
      label: `i18n (${getI18nScopeLable(t)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    e.tags.push(a);
  }
}
function inspectComposer(t, e) {
  const r = VUE_I18N_COMPONENT_TYPES;
  t.state.push({
    type: r,
    key: "locale",
    editable: !0,
    value: e.locale.value
  }), t.state.push({
    type: r,
    key: "availableLocales",
    editable: !1,
    value: e.availableLocales
  }), t.state.push({
    type: r,
    key: "fallbackLocale",
    editable: !0,
    value: e.fallbackLocale.value
  }), t.state.push({
    type: r,
    key: "inheritLocale",
    editable: !0,
    value: e.inheritLocale
  }), t.state.push({
    type: r,
    key: "messages",
    editable: !1,
    value: getLocaleMessageValue(e.messages.value)
  }), t.state.push({
    type: r,
    key: "datetimeFormats",
    editable: !1,
    value: e.datetimeFormats.value
  }), t.state.push({
    type: r,
    key: "numberFormats",
    editable: !1,
    value: e.numberFormats.value
  });
}
function getLocaleMessageValue(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    const o = t[r];
    isFunction(o) && "source" in o ? e[r] = getMessageFunctionDetails(o) : isMessageAST(o) && o.loc && o.loc.source ? e[r] = o.loc.source : isObject$1(o) ? e[r] = getLocaleMessageValue(o) : e[r] = o;
  }), e;
}
const ESC = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function escape$1(t) {
  return t.replace(/[<>"&]/g, escapeChar);
}
function escapeChar(t) {
  return ESC[t] || t;
}
function getMessageFunctionDetails(t) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${t.source ? `("${escape$1(t.source)}")` : "(?)"}`
    }
  };
}
function registerScope(t, e) {
  t.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const r = e.mode === "composition" ? e.global : e.global.__composer;
  for (const [o, a] of e.__instances) {
    const c = e.mode === "composition" ? a : a.__composer;
    r !== c && t.rootNodes.push({
      id: c.id.toString(),
      label: `${getI18nScopeLable(o)} Scope`
    });
  }
}
function getComponentInstance(t, e) {
  let r = null;
  if (t !== "global") {
    for (const [o, a] of e.__instances.entries())
      if (a.id.toString() === t) {
        r = o;
        break;
      }
  }
  return r;
}
function getComposer$1(t, e) {
  if (t === "global")
    return e.mode === "composition" ? e.global : e.global.__composer;
  {
    const r = Array.from(e.__instances.values()).find((o) => o.id.toString() === t);
    return r ? e.mode === "composition" ? r : r.__composer : null;
  }
}
function inspectScope(t, e) {
  const r = getComposer$1(t.nodeId, e);
  return r && (t.state = makeScopeInspectState(r)), null;
}
function makeScopeInspectState(t) {
  const e = {}, r = "Locale related info", o = [
    {
      type: r,
      key: "locale",
      editable: !0,
      value: t.locale.value
    },
    {
      type: r,
      key: "fallbackLocale",
      editable: !0,
      value: t.fallbackLocale.value
    },
    {
      type: r,
      key: "availableLocales",
      editable: !1,
      value: t.availableLocales
    },
    {
      type: r,
      key: "inheritLocale",
      editable: !0,
      value: t.inheritLocale
    }
  ];
  e[r] = o;
  const a = "Locale messages info", c = [
    {
      type: a,
      key: "messages",
      editable: !1,
      value: getLocaleMessageValue(t.messages.value)
    }
  ];
  e[a] = c;
  {
    const u = "Datetime formats info", d = [
      {
        type: u,
        key: "datetimeFormats",
        editable: !1,
        value: t.datetimeFormats.value
      }
    ];
    e[u] = d;
    const p = "Datetime formats info", g = [
      {
        type: p,
        key: "numberFormats",
        editable: !1,
        value: t.numberFormats.value
      }
    ];
    e[p] = g;
  }
  return e;
}
function addTimelineEvent(t, e) {
  if (devtoolsApi) {
    let r;
    e && "groupId" in e && (r = e.groupId, delete e.groupId), devtoolsApi.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: t,
        groupId: r,
        time: Date.now(),
        meta: {},
        data: e || {},
        logType: t === "compile-error" ? "error" : t === "fallback" || t === "missing" ? "warning" : "default"
      }
    });
  }
}
function editScope(t, e) {
  const r = getComposer$1(t.nodeId, e);
  if (r) {
    const [o] = t.path;
    o === "locale" && isString$1(t.state.value) ? r.locale.value = t.state.value : o === "fallbackLocale" && (isString$1(t.state.value) || isArray(t.state.value) || isObject$1(t.state.value)) ? r.fallbackLocale.value = t.state.value : o === "inheritLocale" && isBoolean(t.state.value) && (r.inheritLocale = t.state.value);
  }
}
function defineMixin(t, e, r) {
  return {
    beforeCreate() {
      const o = getCurrentInstance();
      if (!o)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const a = this.$options;
      if (a.i18n) {
        const c = a.i18n;
        if (a.__i18n && (c.__i18n = a.__i18n), c.__root = e, this === this.$root)
          this.$i18n = mergeToGlobal(t, c);
        else {
          c.__injectWithOption = !0, c.__extender = r.__vueI18nExtend, this.$i18n = createVueI18n(c);
          const u = this.$i18n;
          u.__extender && (u.__disposer = u.__extender(this.$i18n));
        }
      } else if (a.__i18n)
        if (this === this.$root)
          this.$i18n = mergeToGlobal(t, a);
        else {
          this.$i18n = createVueI18n({
            __i18n: a.__i18n,
            __injectWithOption: !0,
            __extender: r.__vueI18nExtend,
            __root: e
          });
          const c = this.$i18n;
          c.__extender && (c.__disposer = c.__extender(this.$i18n));
        }
      else
        this.$i18n = t;
      a.__i18nGlobal && adjustI18nResources(e, a, a), this.$t = (...c) => this.$i18n.t(...c), this.$rt = (...c) => this.$i18n.rt(...c), this.$tc = (...c) => this.$i18n.tc(...c), this.$te = (c, u) => this.$i18n.te(c, u), this.$d = (...c) => this.$i18n.d(...c), this.$n = (...c) => this.$i18n.n(...c), this.$tm = (c) => this.$i18n.tm(c), r.__setInstance(o, this.$i18n);
    },
    mounted() {
      if (process.env.NODE_ENV !== "production" && this.$el && this.$i18n) {
        const o = this.$i18n;
        this.$el.__VUE_I18N__ = o.__composer;
        const a = this.__v_emitter = createEmitter();
        o.__enableEmitter && o.__enableEmitter(a), a.on("*", addTimelineEvent);
      }
    },
    unmounted() {
      const o = getCurrentInstance();
      if (!o)
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      const a = this.$i18n;
      process.env.NODE_ENV !== "production" && this.$el && this.$el.__VUE_I18N__ && (this.__v_emitter && (this.__v_emitter.off("*", addTimelineEvent), delete this.__v_emitter), this.$i18n && (a.__disableEmitter && a.__disableEmitter(), delete this.$el.__VUE_I18N__)), delete this.$t, delete this.$rt, delete this.$tc, delete this.$te, delete this.$d, delete this.$n, delete this.$tm, a.__disposer && (a.__disposer(), delete a.__disposer, delete a.__extender), r.__deleteInstance(o), delete this.$i18n;
    }
  };
}
function mergeToGlobal(t, e) {
  t.locale = e.locale || t.locale, t.fallbackLocale = e.fallbackLocale || t.fallbackLocale, t.missing = e.missing || t.missing, t.silentTranslationWarn = e.silentTranslationWarn || t.silentFallbackWarn, t.silentFallbackWarn = e.silentFallbackWarn || t.silentFallbackWarn, t.formatFallbackMessages = e.formatFallbackMessages || t.formatFallbackMessages, t.postTranslation = e.postTranslation || t.postTranslation, t.warnHtmlInMessage = e.warnHtmlInMessage || t.warnHtmlInMessage, t.escapeParameterHtml = e.escapeParameterHtml || t.escapeParameterHtml, t.sync = e.sync || t.sync, t.__composer[SetPluralRulesSymbol](e.pluralizationRules || t.pluralizationRules);
  const r = getLocaleMessages(t.locale, {
    messages: e.messages,
    __i18n: e.__i18n
  });
  return Object.keys(r).forEach((o) => t.mergeLocaleMessage(o, r[o])), e.datetimeFormats && Object.keys(e.datetimeFormats).forEach((o) => t.mergeDateTimeFormat(o, e.datetimeFormats[o])), e.numberFormats && Object.keys(e.numberFormats).forEach((o) => t.mergeNumberFormat(o, e.numberFormats[o])), t;
}
const I18nInjectionKey = /* @__PURE__ */ makeSymbol("global-vue-i18n");
function createI18n(t = {}, e) {
  const r = __VUE_I18N_LEGACY_API__ && isBoolean(t.legacy) ? t.legacy : __VUE_I18N_LEGACY_API__, o = isBoolean(t.globalInjection) ? t.globalInjection : !0, a = __VUE_I18N_LEGACY_API__ && r ? !!t.allowComposition : !0, c = /* @__PURE__ */ new Map(), [u, d] = createGlobal(t, r), p = /* @__PURE__ */ makeSymbol(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV !== "production" && r && a && warn(getWarnMessage(I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION));
  function g(w) {
    return c.get(w) || null;
  }
  function b(w, y) {
    c.set(w, y);
  }
  function x(w) {
    c.delete(w);
  }
  {
    const w = {
      // mode
      get mode() {
        return __VUE_I18N_LEGACY_API__ && r ? "legacy" : "composition";
      },
      // allowComposition
      get allowComposition() {
        return a;
      },
      // install plugin
      async install(y, ...I) {
        if (process.env.NODE_ENV !== "production" && (y.__VUE_I18N__ = w), y.__VUE_I18N_SYMBOL__ = p, y.provide(y.__VUE_I18N_SYMBOL__, w), isPlainObject(I[0])) {
          const C = I[0];
          w.__composerExtend = C.__composerExtend, w.__vueI18nExtend = C.__vueI18nExtend;
        }
        let E = null;
        !r && o && (E = injectGlobalFields(y, w.global)), __VUE_I18N_FULL_INSTALL__ && apply(y, w, ...I), __VUE_I18N_LEGACY_API__ && r && y.mixin(defineMixin(d, d.__composer, w));
        const T = y.unmount;
        if (y.unmount = () => {
          E && E(), w.dispose(), T();
        }, process.env.NODE_ENV !== "production") {
          if (!await enableDevTools(y, w))
            throw createI18nError(I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const $ = createEmitter();
          if (r) {
            const D = d;
            D.__enableEmitter && D.__enableEmitter($);
          } else {
            const D = d;
            D[EnableEmitter] && D[EnableEmitter]($);
          }
          $.on("*", addTimelineEvent);
        }
      },
      // global accessor
      get global() {
        return d;
      },
      dispose() {
        u.stop();
      },
      // @internal
      __instances: c,
      // @internal
      __getInstance: g,
      // @internal
      __setInstance: b,
      // @internal
      __deleteInstance: x
    };
    return w;
  }
}
function useI18n(t = {}) {
  const e = getCurrentInstance();
  if (e == null)
    throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
  if (!e.isCE && e.appContext.app != null && !e.appContext.app.__VUE_I18N_SYMBOL__)
    throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
  const r = getI18nInstance(e), o = getGlobalComposer(r), a = getComponentOptions(e), c = getScope(t, a);
  if (__VUE_I18N_LEGACY_API__ && r.mode === "legacy" && !t.__useComponent) {
    if (!r.allowComposition)
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
    return useI18nForLegacy(e, c, o, t);
  }
  if (c === "global")
    return adjustI18nResources(o, t, a), o;
  if (c === "parent") {
    let p = getComposer(r, e, t.__useComponent);
    return p == null && (process.env.NODE_ENV !== "production" && warn(getWarnMessage(I18nWarnCodes.NOT_FOUND_PARENT_SCOPE)), p = o), p;
  }
  const u = r;
  let d = u.__getInstance(e);
  if (d == null) {
    const p = assign$1({}, t);
    "__i18n" in a && (p.__i18n = a.__i18n), o && (p.__root = o), d = createComposer(p), u.__composerExtend && (d[DisposeSymbol] = u.__composerExtend(d)), setupLifeCycle(u, e, d), u.__setInstance(e, d);
  }
  return d;
}
function createGlobal(t, e, r) {
  const o = effectScope();
  {
    const a = __VUE_I18N_LEGACY_API__ && e ? o.run(() => createVueI18n(t)) : o.run(() => createComposer(t));
    if (a == null)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    return [o, a];
  }
}
function getI18nInstance(t) {
  {
    const e = inject(t.isCE ? I18nInjectionKey : t.appContext.app.__VUE_I18N_SYMBOL__);
    if (!e)
      throw createI18nError(t.isCE ? I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE : I18nErrorCodes.UNEXPECTED_ERROR);
    return e;
  }
}
function getScope(t, e) {
  return isEmptyObject(t) ? "__i18n" in e ? "local" : "global" : t.useScope ? t.useScope : "local";
}
function getGlobalComposer(t) {
  return t.mode === "composition" ? t.global : t.global.__composer;
}
function getComposer(t, e, r = !1) {
  let o = null;
  const a = e.root;
  let c = getParentComponentInstance(e, r);
  for (; c != null; ) {
    const u = t;
    if (t.mode === "composition")
      o = u.__getInstance(c);
    else if (__VUE_I18N_LEGACY_API__) {
      const d = u.__getInstance(c);
      d != null && (o = d.__composer, r && o && !o[InejctWithOptionSymbol] && (o = null));
    }
    if (o != null || a === c)
      break;
    c = c.parent;
  }
  return o;
}
function getParentComponentInstance(t, e = !1) {
  return t == null ? null : e && t.vnode.ctx || t.parent;
}
function setupLifeCycle(t, e, r) {
  let o = null;
  onMounted(() => {
    if (process.env.NODE_ENV !== "production" && e.vnode.el) {
      e.vnode.el.__VUE_I18N__ = r, o = createEmitter();
      const a = r;
      a[EnableEmitter] && a[EnableEmitter](o), o.on("*", addTimelineEvent);
    }
  }, e), onUnmounted(() => {
    const a = r;
    process.env.NODE_ENV !== "production" && e.vnode.el && e.vnode.el.__VUE_I18N__ && (o && o.off("*", addTimelineEvent), a[DisableEmitter] && a[DisableEmitter](), delete e.vnode.el.__VUE_I18N__), t.__deleteInstance(e);
    const c = a[DisposeSymbol];
    c && (c(), delete a[DisposeSymbol]);
  }, e);
}
function useI18nForLegacy(t, e, r, o = {}) {
  const a = e === "local", c = shallowRef(null);
  if (a && t.proxy && !(t.proxy.$options.i18n || t.proxy.$options.__i18n))
    throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const u = isBoolean(o.inheritLocale) ? o.inheritLocale : !isString$1(o.locale), d = ref(
    // prettier-ignore
    !a || u ? r.locale.value : isString$1(o.locale) ? o.locale : DEFAULT_LOCALE
  ), p = ref(
    // prettier-ignore
    !a || u ? r.fallbackLocale.value : isString$1(o.fallbackLocale) || isArray(o.fallbackLocale) || isPlainObject(o.fallbackLocale) || o.fallbackLocale === !1 ? o.fallbackLocale : d.value
  ), g = ref(getLocaleMessages(d.value, o)), b = ref(isPlainObject(o.datetimeFormats) ? o.datetimeFormats : { [d.value]: {} }), x = ref(isPlainObject(o.numberFormats) ? o.numberFormats : { [d.value]: {} }), w = a ? r.missingWarn : isBoolean(o.missingWarn) || isRegExp(o.missingWarn) ? o.missingWarn : !0, y = a ? r.fallbackWarn : isBoolean(o.fallbackWarn) || isRegExp(o.fallbackWarn) ? o.fallbackWarn : !0, I = a ? r.fallbackRoot : isBoolean(o.fallbackRoot) ? o.fallbackRoot : !0, E = !!o.fallbackFormat, T = isFunction(o.missing) ? o.missing : null, C = isFunction(o.postTranslation) ? o.postTranslation : null, $ = a ? r.warnHtmlMessage : isBoolean(o.warnHtmlMessage) ? o.warnHtmlMessage : !0, D = !!o.escapeParameter, L = a ? r.modifiers : isPlainObject(o.modifiers) ? o.modifiers : {}, R = o.pluralRules || a && r.pluralRules;
  function O() {
    return [
      d.value,
      p.value,
      g.value,
      b.value,
      x.value
    ];
  }
  const P = computed({
    get: () => c.value ? c.value.locale.value : d.value,
    set: (q) => {
      c.value && (c.value.locale.value = q), d.value = q;
    }
  }), z = computed({
    get: () => c.value ? c.value.fallbackLocale.value : p.value,
    set: (q) => {
      c.value && (c.value.fallbackLocale.value = q), p.value = q;
    }
  }), W = computed(() => c.value ? c.value.messages.value : g.value), A = computed(() => b.value), S = computed(() => x.value);
  function F() {
    return c.value ? c.value.getPostTranslationHandler() : C;
  }
  function U(q) {
    c.value && c.value.setPostTranslationHandler(q);
  }
  function M() {
    return c.value ? c.value.getMissingHandler() : T;
  }
  function V(q) {
    c.value && c.value.setMissingHandler(q);
  }
  function G(q) {
    return O(), q();
  }
  function Q(...q) {
    return c.value ? G(() => Reflect.apply(c.value.t, null, [...q])) : G(() => "");
  }
  function fe(...q) {
    return c.value ? Reflect.apply(c.value.rt, null, [...q]) : "";
  }
  function te(...q) {
    return c.value ? G(() => Reflect.apply(c.value.d, null, [...q])) : G(() => "");
  }
  function de(...q) {
    return c.value ? G(() => Reflect.apply(c.value.n, null, [...q])) : G(() => "");
  }
  function me(q) {
    return c.value ? c.value.tm(q) : {};
  }
  function Me(q, se) {
    return c.value ? c.value.te(q, se) : !1;
  }
  function ce(q) {
    return c.value ? c.value.getLocaleMessage(q) : {};
  }
  function oe(q, se) {
    c.value && (c.value.setLocaleMessage(q, se), g.value[q] = se);
  }
  function be(q, se) {
    c.value && c.value.mergeLocaleMessage(q, se);
  }
  function Te(q) {
    return c.value ? c.value.getDateTimeFormat(q) : {};
  }
  function Ae(q, se) {
    c.value && (c.value.setDateTimeFormat(q, se), b.value[q] = se);
  }
  function je(q, se) {
    c.value && c.value.mergeDateTimeFormat(q, se);
  }
  function Xe(q) {
    return c.value ? c.value.getNumberFormat(q) : {};
  }
  function He(q, se) {
    c.value && (c.value.setNumberFormat(q, se), x.value[q] = se);
  }
  function Ke(q, se) {
    c.value && c.value.mergeNumberFormat(q, se);
  }
  const ot = {
    get id() {
      return c.value ? c.value.id : -1;
    },
    locale: P,
    fallbackLocale: z,
    messages: W,
    datetimeFormats: A,
    numberFormats: S,
    get inheritLocale() {
      return c.value ? c.value.inheritLocale : u;
    },
    set inheritLocale(q) {
      c.value && (c.value.inheritLocale = q);
    },
    get availableLocales() {
      return c.value ? c.value.availableLocales : Object.keys(g.value);
    },
    get modifiers() {
      return c.value ? c.value.modifiers : L;
    },
    get pluralRules() {
      return c.value ? c.value.pluralRules : R;
    },
    get isGlobal() {
      return c.value ? c.value.isGlobal : !1;
    },
    get missingWarn() {
      return c.value ? c.value.missingWarn : w;
    },
    set missingWarn(q) {
      c.value && (c.value.missingWarn = q);
    },
    get fallbackWarn() {
      return c.value ? c.value.fallbackWarn : y;
    },
    set fallbackWarn(q) {
      c.value && (c.value.missingWarn = q);
    },
    get fallbackRoot() {
      return c.value ? c.value.fallbackRoot : I;
    },
    set fallbackRoot(q) {
      c.value && (c.value.fallbackRoot = q);
    },
    get fallbackFormat() {
      return c.value ? c.value.fallbackFormat : E;
    },
    set fallbackFormat(q) {
      c.value && (c.value.fallbackFormat = q);
    },
    get warnHtmlMessage() {
      return c.value ? c.value.warnHtmlMessage : $;
    },
    set warnHtmlMessage(q) {
      c.value && (c.value.warnHtmlMessage = q);
    },
    get escapeParameter() {
      return c.value ? c.value.escapeParameter : D;
    },
    set escapeParameter(q) {
      c.value && (c.value.escapeParameter = q);
    },
    t: Q,
    getPostTranslationHandler: F,
    setPostTranslationHandler: U,
    getMissingHandler: M,
    setMissingHandler: V,
    rt: fe,
    d: te,
    n: de,
    tm: me,
    te: Me,
    getLocaleMessage: ce,
    setLocaleMessage: oe,
    mergeLocaleMessage: be,
    getDateTimeFormat: Te,
    setDateTimeFormat: Ae,
    mergeDateTimeFormat: je,
    getNumberFormat: Xe,
    setNumberFormat: He,
    mergeNumberFormat: Ke
  };
  function K(q) {
    q.locale.value = d.value, q.fallbackLocale.value = p.value, Object.keys(g.value).forEach((se) => {
      q.mergeLocaleMessage(se, g.value[se]);
    }), Object.keys(b.value).forEach((se) => {
      q.mergeDateTimeFormat(se, b.value[se]);
    }), Object.keys(x.value).forEach((se) => {
      q.mergeNumberFormat(se, x.value[se]);
    }), q.escapeParameter = D, q.fallbackFormat = E, q.fallbackRoot = I, q.fallbackWarn = y, q.missingWarn = w, q.warnHtmlMessage = $;
  }
  return onBeforeMount(() => {
    if (t.proxy == null || t.proxy.$i18n == null)
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const q = c.value = t.proxy.$i18n.__composer;
    e === "global" ? (d.value = q.locale.value, p.value = q.fallbackLocale.value, g.value = q.messages.value, b.value = q.datetimeFormats.value, x.value = q.numberFormats.value) : a && K(q);
  }), ot;
}
const globalExportProps = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], globalExportMethods = ["t", "rt", "d", "n", "tm", "te"];
function injectGlobalFields(t, e) {
  const r = /* @__PURE__ */ Object.create(null);
  return globalExportProps.forEach((a) => {
    const c = Object.getOwnPropertyDescriptor(e, a);
    if (!c)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    const u = isRef(c.value) ? {
      get() {
        return c.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(d) {
        c.value.value = d;
      }
    } : {
      get() {
        return c.get && c.get();
      }
    };
    Object.defineProperty(r, a, u);
  }), t.config.globalProperties.$i18n = r, globalExportMethods.forEach((a) => {
    const c = Object.getOwnPropertyDescriptor(e, a);
    if (!c || !c.value)
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    Object.defineProperty(t.config.globalProperties, `$${a}`, c);
  }), () => {
    delete t.config.globalProperties.$i18n, globalExportMethods.forEach((a) => {
      delete t.config.globalProperties[`$${a}`];
    });
  };
}
initFeatureFlags();
__INTLIFY_JIT_COMPILATION__ ? registerMessageCompiler(compile) : registerMessageCompiler(compileToFunction);
registerMessageResolver(resolveValue);
registerLocaleFallbacker(fallbackWithLocaleChain);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const t = getGlobalThis();
  t.__INTLIFY__ = !0, setDevToolsHook(t.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
var isLocalhost = function() {
  return !!(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
  window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  ));
}, waitWindowLoad;
typeof window < "u" && (typeof Promise < "u" ? waitWindowLoad = new Promise(function(t) {
  return window.addEventListener("load", t);
}) : waitWindowLoad = { then: function(t) {
  return window.addEventListener("load", t);
} });
function register(t, e) {
  e === void 0 && (e = {});
  var r = e.registrationOptions;
  r === void 0 && (r = {}), delete e.registrationOptions;
  var o = function(a) {
    for (var c = [], u = arguments.length - 1; u-- > 0; )
      c[u] = arguments[u + 1];
    e && e[a] && e[a].apply(e, c);
  };
  "serviceWorker" in navigator && waitWindowLoad.then(function() {
    isLocalhost() ? (checkValidServiceWorker(t, o, r), navigator.serviceWorker.ready.then(function(a) {
      o("ready", a);
    }).catch(function(a) {
      return handleError(o, a);
    })) : (registerValidSW(t, o, r), navigator.serviceWorker.ready.then(function(a) {
      o("ready", a);
    }).catch(function(a) {
      return handleError(o, a);
    }));
  });
}
function handleError(t, e) {
  navigator.onLine || t("offline"), t("error", e);
}
function registerValidSW(t, e, r) {
  navigator.serviceWorker.register(t, r).then(function(o) {
    if (e("registered", o), o.waiting) {
      e("updated", o);
      return;
    }
    o.onupdatefound = function() {
      e("updatefound", o);
      var a = o.installing;
      a.onstatechange = function() {
        a.state === "installed" && (navigator.serviceWorker.controller ? e("updated", o) : e("cached", o));
      };
    };
  }).catch(function(o) {
    return handleError(e, o);
  });
}
function checkValidServiceWorker(t, e, r) {
  fetch(t).then(function(o) {
    o.status === 404 ? (e("error", new Error("Service worker not found at " + t)), unregister()) : o.headers.get("content-type").indexOf("javascript") === -1 ? (e("error", new Error(
      "Expected " + t + " to have javascript content-type, but received " + o.headers.get("content-type")
    )), unregister()) : registerValidSW(t, e, r);
  }).catch(function(o) {
    return handleError(e, o);
  });
}
function unregister() {
  "serviceWorker" in navigator && navigator.serviceWorker.ready.then(function(t) {
    t.unregister();
  }).catch(function(t) {
    return handleError(emit, t);
  });
}
process.env.NODE_ENV === "production" && register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {
    console.log(`App is being served from cache by a service worker.
For more details, visit https://goo.gl/AFskqB`);
  },
  registered(t) {
    console.log("Service worker has been registered."), setInterval(() => {
      t.update();
    }, 1e3 * 60 * 60);
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated(t) {
    console.log("New content is available; please refresh."), document.dispatchEvent(new CustomEvent("swUpdated", { detail: t }));
  },
  offline() {
    console.log("No internet connection found. App is running in offline mode.");
  },
  error(t) {
    console.error("Error during service worker registration:", t);
  }
});
const pinia = createPinia();
pinia.use(src_default);
let i18n, imageContext = {}, translate, loginContext = {}, shopifyImgContext = {}, appContext = {}, productIdentificationContext = {}, notificationContext = {}, gitBookContext = {}, userContext = {}, showToast = {}, refreshing = !1;
const updateAvailable = (t) => {
  const e = t.detail, r = !0;
  appContext.config.globalProperties.$store.dispatch("user/updatePwaState", { registration: e, updateExists: r }), showToast(translate("New version available, please update the app."));
};
document.addEventListener("swUpdated", updateAvailable, { once: !0 });
navigator.serviceWorker.addEventListener("controllerchange", () => {
  refreshing || (refreshing = !0, window.location.reload());
});
let dxpComponents = {
  install(t, e) {
    appContext = t, i18n = createI18n({
      legacy: !1,
      locale: process.env.VUE_APP_I18N_LOCALE || "en-US",
      fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-US",
      messages: e.localeMessages
    }), t.use(pinia), t.use(i18n), t.use(IonicVue, {
      mode: "md"
    }), t.component("DxpAppVersionInfo", _sfc_main$a), t.component("DxpGitBookSearch", _sfc_main$9), t.component("DxpImage", _sfc_main$8), t.component("DxpLanguageSwitcher", _sfc_main$7), t.component("DxpLogin", _sfc_main$6), t.component("DxpMenuFooterNavigation", _sfc_main$5), t.component("DxpOmsInstanceNavigator", _sfc_main$4), t.component("DxpProductIdentifier", _sfc_main$3), t.component("DxpShopifyImg", _sfc_main$2), t.component("DxpTimeZoneSwitcher", _sfc_main), t.component("DxpUserProfile", DxpUserProfile), showToast = e.showToast, loginContext.login = e.login, loginContext.logout = e.logout, loginContext.loader = e.loader, loginContext.appLoginUrl = e.appLoginUrl, imageContext.defaultImgUrl = e.defaultImgUrl, shopifyImgContext.defaultImgUrl = e.defaultImgUrl, userContext.setUserLocale = e.setUserLocale, userContext.setUserTimeZone = e.setUserTimeZone, userContext.getAvailableTimeZones = e.getAvailableTimeZones, productIdentificationContext.getProductIdentificationPref = e.getProductIdentificationPref, productIdentificationContext.setProductIdentificationPref = e.setProductIdentificationPref, notificationContext.addNotification = e.addNotification, notificationContext.appFirebaseConfig = e.appFirebaseConfig, notificationContext.appFirebaseVapidKey = e.appFirebaseVapidKey, notificationContext.storeClientRegistrationToken = e.storeClientRegistrationToken, gitBookContext.askQuery = e.askQuery, gitBookContext.getGitBookPage = e.getGitBookPage, gitBookContext.searchQuery = e.searchQuery, loginContext.getConfig = e.getConfig, loginContext.initialise = e.initialise, appContext.Actions = e.Actions, appContext.hasPermission = e.hasPermission, i18n.global.locale.value = useUserStore().getLocale, translate = i18n.global.t;
  }
};
export {
  _sfc_main$2 as A,
  _sfc_main as B,
  getProductIdentificationValue as C,
  DxpUserProfile as D,
  gitBookContext as E,
  goToOms as F,
  i18n as G,
  imageContext as H,
  initialiseFirebaseApp as I,
  loginContext as J,
  Keyboard as K,
  notificationContext as L,
  productIdentificationContext as M,
  shopifyImgContext as N,
  translate as O,
  useAuthStore as P,
  useProductIdentificationStore as Q,
  useUserStore as R,
  userContext as S,
  _sfc_main$8 as _,
  clamp as a,
  createAnimation as b,
  createGesture as c,
  doc as d,
  componentOnReady as e,
  findClosestIonContent as f,
  getIonPageElement as g,
  addEventListener$1 as h,
  isRTL$1 as i,
  removeEventListener as j,
  KeyboardResize as k,
  win as l,
  raf as m,
  now$1 as n,
  getScrollElement as o,
  pointerCoord as p,
  scrollByPoint as q,
  readTask as r,
  scrollToTop as s,
  dxpComponents as t,
  appContext as u,
  _sfc_main$6 as v,
  writeTask as w,
  _sfc_main$5 as x,
  _sfc_main$4 as y,
  _sfc_main$3 as z
};
